/* AUTO GENERATED SEE CODEGEN.YML */
/* https://graphql-code-generator.com/docs/plugins/ */
/* tslint:disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bytea: any;
  date: any;
  float8: any;
  geography: any;
  geometry: any;
  json: any;
  jsonb: any;
  smallint: any;
  time: any;
  timestamptz: any;
  uuid: any;
};

export type AddUsersToNetworkInput = {
  networkId: Scalars['Int'];
  userIds: Array<Maybe<Scalars['Int']>>;
};

export type AddUsersToNetworkOutput = {
  __typename?: 'AddUsersToNetworkOutput';
  network?: Maybe<Networks>;
  networkId: Scalars['Int'];
  userIds: Array<Maybe<Scalars['Int']>>;
};

export enum AirTrafficSimulationCommandEnum {
  Pause = 'PAUSE',
  Resume = 'RESUME',
  Stop = 'STOP'
}

export type AirTrafficSimulationCommandInput = {
  command: AirTrafficSimulationCommandEnum;
  flightPlanId: Scalars['Int'];
};

export type AirTrafficSimulationCommandOutput = {
  __typename?: 'AirTrafficSimulationCommandOutput';
  flightPlanId: Scalars['Int'];
};

export type AssignGroundAssetsToNetworkInput = {
  groundAssetIds: Array<Maybe<Scalars['Int']>>;
  networkId: Scalars['Int'];
};

export type AssignGroundAssetsToNetworkOutput = {
  __typename?: 'AssignGroundAssetsToNetworkOutput';
  groundAssetIds: Array<Maybe<Scalars['Int']>>;
  network?: Maybe<Networks>;
  networkId: Scalars['Int'];
};

export type AssignPrimaryAndBackupPilotsToVehicleInput = {
  pilotUserIds: Array<Maybe<Scalars['Int']>>;
  primaryPilotUserId: Scalars['Int'];
  vehicleId: Scalars['Int'];
};

export type AssignPrimaryAndBackupPilotsToVehicleOutput = {
  __typename?: 'AssignPrimaryAndBackupPilotsToVehicleOutput';
  assignedPilotUserIds: Array<Maybe<Scalars['Int']>>;
  primaryPilotUserId: Scalars['Int'];
  vehicleId: Scalars['Int'];
};

export type AssignVehiclesToNetworkInput = {
  networkId: Scalars['Int'];
  vehicleIds: Array<Maybe<Scalars['Int']>>;
};

export type AssignVehiclesToNetworkOutput = {
  __typename?: 'AssignVehiclesToNetworkOutput';
  network?: Maybe<Networks>;
  networkId: Scalars['Int'];
  vehicleIds: Array<Maybe<Scalars['Int']>>;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type ClaimManifestInput = {
  badgeTokenRecipientId: Scalars['Int'];
  emptyPayloadSerial: Scalars['String'];
  manifestId: Scalars['Int'];
};

export type ClaimManifestOutput = {
  __typename?: 'ClaimManifestOutput';
  claimedManifestId: Scalars['Int'];
  manifest?: Maybe<Manifests>;
};

export type CreateManifestInput = {
  badgeTokenSenderId: Scalars['Int'];
  destinationId: Scalars['Int'];
  manifestItems?: Maybe<Array<CreateManifestItemInput>>;
  manifestType?: Maybe<ManifestTypeEnum>;
  originId: Scalars['Int'];
  payloadSerial: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type CreateManifestItemInput = {
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type CreateManifestOutput = {
  __typename?: 'CreateManifestOutput';
  createdManifestId: Scalars['Int'];
  manifest?: Maybe<Manifests>;
};

export type CreateNetworkInput = {
  name: Scalars['String'];
  utmEnabled: Scalars['Boolean'];
};

export type CreateNetworkOutput = {
  __typename?: 'CreateNetworkOutput';
  id: Scalars['Int'];
  network?: Maybe<Networks>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  roleIds: Array<Maybe<Scalars['Int']>>;
};

export type CreateUserOutput = {
  __typename?: 'CreateUserOutput';
  email: Scalars['String'];
  id: Scalars['Int'];
  user?: Maybe<Users>;
};

export type DeactivateUserInput = {
  userId: Scalars['Int'];
};

export type DeactivateUserOutput = {
  __typename?: 'DeactivateUserOutput';
  user?: Maybe<Users>;
  userId: Scalars['Int'];
};

export type DeleteManifestInput = {
  manifestId: Scalars['Int'];
};

export type DeleteManifestOutput = {
  __typename?: 'DeleteManifestOutput';
  deletedManifestId: Scalars['Int'];
  manifest?: Maybe<Manifests>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export enum ManifestTypeEnum {
  Alternate = 'ALTERNATE',
  Empty = 'EMPTY',
  Flight = 'FLIGHT',
  Test = 'TEST'
}

export type MarkManifestAsDeliveredInput = {
  manifestId: Scalars['Int'];
};

export type MarkManifestAsDeliveredOutput = {
  __typename?: 'MarkManifestAsDeliveredOutput';
  deliveredManifestId: Scalars['Int'];
  manifest?: Maybe<Manifests>;
};

export type PriorityEventInput = {
  priorityEventId: Scalars['Int'];
};

export type PriorityEventOutput = {
  __typename?: 'PriorityEventOutput';
  acknowledgedPriorityEventId: Scalars['Int'];
  priorityEvent?: Maybe<Vehicle_Priority_Events>;
};

export type RemoveUserFromNetworkInput = {
  networkId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type RemoveUserFromNetworkOutput = {
  __typename?: 'RemoveUserFromNetworkOutput';
  network?: Maybe<Networks>;
  networkId: Scalars['Int'];
  user?: Maybe<Users>;
  userId: Scalars['Int'];
};

export type RequestFlightControlInput = {
  flightPlanId: Scalars['Int'];
};

export type RequestFlightControlOutput = {
  __typename?: 'RequestFlightControlOutput';
  requestId: Scalars['Int'];
};

export type ResetUserPasswordInput = {
  email: Scalars['String'];
};

export type ResetUserPasswordOutput = {
  __typename?: 'ResetUserPasswordOutput';
  message: Scalars['String'];
};

export enum ResolveFlightControlRequestAction {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export type ResolveFlightControlRequestInput = {
  action: ResolveFlightControlRequestAction;
  requestId: Scalars['Int'];
};

export type ResolveFlightControlRequestOutput = {
  __typename?: 'ResolveFlightControlRequestOutput';
  currentRpicUserId: Scalars['Int'];
  requestId: Scalars['Int'];
  status: ResolveFlightControlRequestStatus;
};

export enum ResolveFlightControlRequestStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type SampleInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  accessToken: Scalars['String'];
};

export type SimulateAirTrafficConflictInput = {
  altitudeAglMeters?: Maybe<Scalars['Float']>;
  azimuthDegrees?: Maybe<Scalars['Float']>;
  distanceMeters?: Maybe<Scalars['Float']>;
  flightPlanId: Scalars['Int'];
  headingDegrees?: Maybe<Scalars['Float']>;
  latencySeconds?: Maybe<Scalars['Float']>;
  speedMetersPerSecond?: Maybe<Scalars['Float']>;
};

export type SimulateAirTrafficConflictOutput = {
  __typename?: 'SimulateAirTrafficConflictOutput';
  flightPlanId: Scalars['Int'];
  jobId: Scalars['String'];
};

export type SimulateAirTrafficInput = {
  flightPlanId: Scalars['Int'];
  jobId: Scalars['Int'];
};

export type SimulateAirTrafficOutput = {
  __typename?: 'SimulateAirTrafficOutput';
  flightPlanId: Scalars['Int'];
};

export type SimulateMultipleJitterAirTrafficConflictsInput = {
  azimuthDegrees?: Maybe<Scalars['Float']>;
  distanceMeters?: Maybe<Scalars['Float']>;
  flightPlanId: Scalars['Int'];
  jitterDuringSimulation: Scalars['Boolean'];
  maxAltitudeMslMeters: Scalars['Float'];
  maxHeadingDegrees: Scalars['Float'];
  maxSpeedMetersPerSecond: Scalars['Float'];
  minAltitudeMslMeters: Scalars['Float'];
  minHeadingDegrees: Scalars['Float'];
  minSpeedMetersPerSecond: Scalars['Float'];
  repeatCount: Scalars['Int'];
  sameAirTrafficId: Scalars['Boolean'];
};

export type SimulateMultipleJitterAirTrafficConflictsOutput = {
  __typename?: 'SimulateMultipleJitterAirTrafficConflictsOutput';
  flightPlanId: Scalars['Int'];
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

export type TypeCertManualDataAndWeatherObservationInput = {
  flightPlanId: Scalars['Int'];
  manualInput: TypeCertManualDataInput;
  weatherObservation?: Maybe<WeatherObservationInput>;
};

export type TypeCertManualDataAndWeatherObservationOutput = {
  __typename?: 'TypeCertManualDataAndWeatherObservationOutput';
  manualInputId: Scalars['Int'];
  weatherObservationId?: Maybe<Scalars['Int']>;
};

export type TypeCertManualDataInput = {
  aircraftPilotRatio?: Maybe<Scalars['String']>;
  coaWaiver?: Maybe<Scalars['String']>;
  flightComplexity?: Maybe<Scalars['String']>;
  flightPlanId: Scalars['Int'];
  flightRiskAssessment?: Maybe<Scalars['String']>;
  flightTestWitness: Scalars['String'];
  groundControlStationPartNumber?: Maybe<Scalars['String']>;
  maintainerName?: Maybe<Scalars['String']>;
  observedTurbulence?: Maybe<Scalars['String']>;
  payloadBoxId?: Maybe<Scalars['Int']>;
  payloadWeightLbs?: Maybe<Scalars['Float']>;
  pilotInCommandName?: Maybe<Scalars['String']>;
  secondaryInCommandName?: Maybe<Scalars['String']>;
  specialTestConditions?: Maybe<Array<Maybe<Scalars['Int']>>>;
  takeoffCenterOfGravity?: Maybe<Scalars['String']>;
  testCardNumber?: Maybe<Scalars['String']>;
};

export type TypeCertManualDataOutput = {
  __typename?: 'TypeCertManualDataOutput';
  TypeCertManualInputData?: Maybe<Type_Cert_Manual_Data>;
  typeCertManualDataId: Scalars['Int'];
};

export type UnassignAllPilotsFromVehicleInput = {
  vehicleId: Scalars['Int'];
};

export type UnassignAllPilotsFromVehicleOutput = {
  __typename?: 'UnassignAllPilotsFromVehicleOutput';
  unassignedPilotUserIds: Array<Maybe<Scalars['Int']>>;
};

export type UpdateManifestInput = {
  badgeTokenSenderId: Scalars['Int'];
  destinationId: Scalars['Int'];
  manifestId: Scalars['Int'];
  manifestItems?: Maybe<Array<UpdateManifestItemInput>>;
  manifestType?: Maybe<ManifestTypeEnum>;
  originId: Scalars['Int'];
  payloadSerial: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type UpdateManifestItemInput = {
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type UpdateManifestOutput = {
  __typename?: 'UpdateManifestOutput';
  manifest?: Maybe<Manifests>;
  updatedManifestId: Scalars['Int'];
};

export type UpdateNetworkNameInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type UpdateNetworkNameOutput = {
  __typename?: 'UpdateNetworkNameOutput';
  id: Scalars['Int'];
  network?: Maybe<Networks>;
};

export type UpdateNetworkServiceDisabledInput = {
  id: Scalars['Int'];
  networkServiceDisabled: Scalars['Boolean'];
};

export type UpdateNetworkServiceDisabledOutput = {
  __typename?: 'UpdateNetworkServiceDisabledOutput';
  id: Scalars['Int'];
};

export type UpdateNetworkUtmEnabledInput = {
  enable: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type UpdateNetworkUtmEnabledOutput = {
  __typename?: 'UpdateNetworkUtmEnabledOutput';
  id: Scalars['Int'];
  network?: Maybe<Networks>;
};

export type UpdateUserInput = {
  id: Scalars['Int'];
  roleIds: Array<Maybe<Scalars['Int']>>;
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  id: Scalars['Int'];
  roleIds: Array<Maybe<Scalars['Int']>>;
  user?: Maybe<Users>;
};

export type VehicleCommandInput = {
  flightPlanId: Scalars['Int'];
};

export type VehicleCommandOutput = {
  __typename?: 'VehicleCommandOutput';
  command?: Maybe<Flight_Commands>;
  commandId: Scalars['Int'];
};

export type VehiclePilotAssignmentsInput = {
  pilotIds: Array<Maybe<Scalars['Int']>>;
  vehicleId: Scalars['Int'];
};

export type VehiclePilotAssignmentsOutput = {
  __typename?: 'VehiclePilotAssignmentsOutput';
  assignedPilotIds: Array<Maybe<Scalars['Int']>>;
  vehicle?: Maybe<Vehicle_Pilot_Assignments>;
  vehicleId: Scalars['Int'];
};

export type WeatherObservationInput = {
  dewPointDegreesCelsius?: Maybe<Scalars['Float']>;
  elevationMeters?: Maybe<Scalars['Float']>;
  flightPlanId: Scalars['Int'];
  humidity?: Maybe<Scalars['Int']>;
  latitudeDegrees?: Maybe<Scalars['Float']>;
  longitudeDegrees?: Maybe<Scalars['Float']>;
  observedSkyConditions?: Maybe<Scalars['String']>;
  observedVisibility?: Maybe<Scalars['String']>;
  precipitationRateMillimetersPerHour?: Maybe<Scalars['Float']>;
  precipitationTotalMillimeters?: Maybe<Scalars['Float']>;
  pressureMillibars?: Maybe<Scalars['Float']>;
  pwsWindGustKilometersPerHour?: Maybe<Scalars['Float']>;
  pwsWindSpeedKilometersPerHour?: Maybe<Scalars['Float']>;
  temperatureDegreesCelsius?: Maybe<Scalars['Float']>;
  windChillDegreesCelsius?: Maybe<Scalars['Float']>;
  windDirectionDegrees?: Maybe<Scalars['Float']>;
};

export type WeatherObservationOutput = {
  __typename?: 'WeatherObservationOutput';
  weatherObservation?: Maybe<Flight_Weather_Data>;
  weatherObservationId: Scalars['Int'];
};

/** columns and relationships of "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types = {
  __typename?: 'air_traffic_deconfliction_algorithm_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Aggregate = {
  __typename?: 'air_traffic_deconfliction_algorithm_types_aggregate';
  aggregate?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Aggregate_Fields>;
  nodes: Array<Air_Traffic_Deconfliction_Algorithm_Types>;
};

/** aggregate fields of "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Aggregate_Fields = {
  __typename?: 'air_traffic_deconfliction_algorithm_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Max_Fields>;
  min?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Min_Fields>;
};


/** aggregate fields of "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Max_Order_By>;
  min?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Arr_Rel_Insert_Input = {
  data: Array<Air_Traffic_Deconfliction_Algorithm_Types_Insert_Input>;
  on_conflict?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "air_traffic_deconfliction_algorithm_types". All fields are combined with a logical 'AND'. */
export type Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>>>;
  _not?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "air_traffic_deconfliction_algorithm_types" */
export enum Air_Traffic_Deconfliction_Algorithm_Types_Constraint {
  /** unique or primary key constraint */
  AirTrafficDeconflictionAlgorithmTypesPkey = 'air_traffic_deconfliction_algorithm_types_pkey'
}

export enum Air_Traffic_Deconfliction_Algorithm_Types_Enum {
  /** Legacy cloud deconfliction algorithm */
  LegacyDeconfliction = 'LEGACY_DECONFLICTION',
  /** Onboard detect and avoid deconfliction algorithm */
  OnboardDaa = 'ONBOARD_DAA'
}

/** expression to compare columns of type air_traffic_deconfliction_algorithm_types_enum. All fields are combined with logical 'AND'. */
export type Air_Traffic_Deconfliction_Algorithm_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Enum>;
  _in?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Enum>;
  _nin?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Enum>>;
};

/** input type for inserting data into table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Air_Traffic_Deconfliction_Algorithm_Types_Max_Fields = {
  __typename?: 'air_traffic_deconfliction_algorithm_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Air_Traffic_Deconfliction_Algorithm_Types_Min_Fields = {
  __typename?: 'air_traffic_deconfliction_algorithm_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Mutation_Response = {
  __typename?: 'air_traffic_deconfliction_algorithm_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Air_Traffic_Deconfliction_Algorithm_Types>;
};

/** input type for inserting object relation for remote table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Obj_Rel_Insert_Input = {
  data: Air_Traffic_Deconfliction_Algorithm_Types_Insert_Input;
  on_conflict?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_On_Conflict>;
};

/** on conflict condition type for table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_On_Conflict = {
  constraint: Air_Traffic_Deconfliction_Algorithm_Types_Constraint;
  update_columns: Array<Air_Traffic_Deconfliction_Algorithm_Types_Update_Column>;
  where?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
};

/** ordering options when selecting data from "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "air_traffic_deconfliction_algorithm_types" */
export enum Air_Traffic_Deconfliction_Algorithm_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "air_traffic_deconfliction_algorithm_types" */
export type Air_Traffic_Deconfliction_Algorithm_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "air_traffic_deconfliction_algorithm_types" */
export enum Air_Traffic_Deconfliction_Algorithm_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks = {
  __typename?: 'air_traffic_monitor_tasks';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  job_id?: Maybe<Scalars['String']>;
  source: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Aggregate = {
  __typename?: 'air_traffic_monitor_tasks_aggregate';
  aggregate?: Maybe<Air_Traffic_Monitor_Tasks_Aggregate_Fields>;
  nodes: Array<Air_Traffic_Monitor_Tasks>;
};

/** aggregate fields of "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Aggregate_Fields = {
  __typename?: 'air_traffic_monitor_tasks_aggregate_fields';
  avg?: Maybe<Air_Traffic_Monitor_Tasks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Air_Traffic_Monitor_Tasks_Max_Fields>;
  min?: Maybe<Air_Traffic_Monitor_Tasks_Min_Fields>;
  stddev?: Maybe<Air_Traffic_Monitor_Tasks_Stddev_Fields>;
  stddev_pop?: Maybe<Air_Traffic_Monitor_Tasks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Air_Traffic_Monitor_Tasks_Stddev_Samp_Fields>;
  sum?: Maybe<Air_Traffic_Monitor_Tasks_Sum_Fields>;
  var_pop?: Maybe<Air_Traffic_Monitor_Tasks_Var_Pop_Fields>;
  var_samp?: Maybe<Air_Traffic_Monitor_Tasks_Var_Samp_Fields>;
  variance?: Maybe<Air_Traffic_Monitor_Tasks_Variance_Fields>;
};


/** aggregate fields of "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Aggregate_Order_By = {
  avg?: Maybe<Air_Traffic_Monitor_Tasks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Air_Traffic_Monitor_Tasks_Max_Order_By>;
  min?: Maybe<Air_Traffic_Monitor_Tasks_Min_Order_By>;
  stddev?: Maybe<Air_Traffic_Monitor_Tasks_Stddev_Order_By>;
  stddev_pop?: Maybe<Air_Traffic_Monitor_Tasks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Air_Traffic_Monitor_Tasks_Stddev_Samp_Order_By>;
  sum?: Maybe<Air_Traffic_Monitor_Tasks_Sum_Order_By>;
  var_pop?: Maybe<Air_Traffic_Monitor_Tasks_Var_Pop_Order_By>;
  var_samp?: Maybe<Air_Traffic_Monitor_Tasks_Var_Samp_Order_By>;
  variance?: Maybe<Air_Traffic_Monitor_Tasks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Arr_Rel_Insert_Input = {
  data: Array<Air_Traffic_Monitor_Tasks_Insert_Input>;
  on_conflict?: Maybe<Air_Traffic_Monitor_Tasks_On_Conflict>;
};

/** aggregate avg on columns */
export type Air_Traffic_Monitor_Tasks_Avg_Fields = {
  __typename?: 'air_traffic_monitor_tasks_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "air_traffic_monitor_tasks". All fields are combined with a logical 'AND'. */
export type Air_Traffic_Monitor_Tasks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>>>;
  _not?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  job_id?: Maybe<String_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "air_traffic_monitor_tasks" */
export enum Air_Traffic_Monitor_Tasks_Constraint {
  /** unique or primary key constraint */
  AirTrafficMonitorTasksPkey = 'air_traffic_monitor_tasks_pkey'
}

/** input type for incrementing integer column in table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  job_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Air_Traffic_Monitor_Tasks_Max_Fields = {
  __typename?: 'air_traffic_monitor_tasks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  job_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_id?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Air_Traffic_Monitor_Tasks_Min_Fields = {
  __typename?: 'air_traffic_monitor_tasks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  job_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_id?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Mutation_Response = {
  __typename?: 'air_traffic_monitor_tasks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Air_Traffic_Monitor_Tasks>;
};

/** input type for inserting object relation for remote table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Obj_Rel_Insert_Input = {
  data: Air_Traffic_Monitor_Tasks_Insert_Input;
  on_conflict?: Maybe<Air_Traffic_Monitor_Tasks_On_Conflict>;
};

/** on conflict condition type for table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_On_Conflict = {
  constraint: Air_Traffic_Monitor_Tasks_Constraint;
  update_columns: Array<Air_Traffic_Monitor_Tasks_Update_Column>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};

/** ordering options when selecting data from "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  job_id?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "air_traffic_monitor_tasks" */
export enum Air_Traffic_Monitor_Tasks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  job_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Air_Traffic_Monitor_Tasks_Stddev_Fields = {
  __typename?: 'air_traffic_monitor_tasks_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Air_Traffic_Monitor_Tasks_Stddev_Pop_Fields = {
  __typename?: 'air_traffic_monitor_tasks_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Air_Traffic_Monitor_Tasks_Stddev_Samp_Fields = {
  __typename?: 'air_traffic_monitor_tasks_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Air_Traffic_Monitor_Tasks_Sum_Fields = {
  __typename?: 'air_traffic_monitor_tasks_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "air_traffic_monitor_tasks" */
export enum Air_Traffic_Monitor_Tasks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Source = 'source',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Air_Traffic_Monitor_Tasks_Var_Pop_Fields = {
  __typename?: 'air_traffic_monitor_tasks_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Air_Traffic_Monitor_Tasks_Var_Samp_Fields = {
  __typename?: 'air_traffic_monitor_tasks_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Air_Traffic_Monitor_Tasks_Variance_Fields = {
  __typename?: 'air_traffic_monitor_tasks_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "air_traffic_monitor_tasks" */
export type Air_Traffic_Monitor_Tasks_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "air_traffic_tracks" */
export type Air_Traffic_Tracks = {
  __typename?: 'air_traffic_tracks';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m: Scalars['float8'];
  callsign?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  groundspeed_mps: Scalars['float8'];
  heading_degs: Scalars['float8'];
  icao_address?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lat_degs: Scalars['float8'];
  location: Scalars['geometry'];
  lon_degs: Scalars['float8'];
  source?: Maybe<Scalars['String']>;
  timestamp_secs: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "air_traffic_tracks" */
export type Air_Traffic_Tracks_Aggregate = {
  __typename?: 'air_traffic_tracks_aggregate';
  aggregate?: Maybe<Air_Traffic_Tracks_Aggregate_Fields>;
  nodes: Array<Air_Traffic_Tracks>;
};

/** aggregate fields of "air_traffic_tracks" */
export type Air_Traffic_Tracks_Aggregate_Fields = {
  __typename?: 'air_traffic_tracks_aggregate_fields';
  avg?: Maybe<Air_Traffic_Tracks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Air_Traffic_Tracks_Max_Fields>;
  min?: Maybe<Air_Traffic_Tracks_Min_Fields>;
  stddev?: Maybe<Air_Traffic_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Air_Traffic_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Air_Traffic_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Air_Traffic_Tracks_Sum_Fields>;
  var_pop?: Maybe<Air_Traffic_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Air_Traffic_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Air_Traffic_Tracks_Variance_Fields>;
};


/** aggregate fields of "air_traffic_tracks" */
export type Air_Traffic_Tracks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Air_Traffic_Tracks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Aggregate_Order_By = {
  avg?: Maybe<Air_Traffic_Tracks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Air_Traffic_Tracks_Max_Order_By>;
  min?: Maybe<Air_Traffic_Tracks_Min_Order_By>;
  stddev?: Maybe<Air_Traffic_Tracks_Stddev_Order_By>;
  stddev_pop?: Maybe<Air_Traffic_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Air_Traffic_Tracks_Stddev_Samp_Order_By>;
  sum?: Maybe<Air_Traffic_Tracks_Sum_Order_By>;
  var_pop?: Maybe<Air_Traffic_Tracks_Var_Pop_Order_By>;
  var_samp?: Maybe<Air_Traffic_Tracks_Var_Samp_Order_By>;
  variance?: Maybe<Air_Traffic_Tracks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Arr_Rel_Insert_Input = {
  data: Array<Air_Traffic_Tracks_Insert_Input>;
  on_conflict?: Maybe<Air_Traffic_Tracks_On_Conflict>;
};

/** aggregate avg on columns */
export type Air_Traffic_Tracks_Avg_Fields = {
  __typename?: 'air_traffic_tracks_avg_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Avg_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "air_traffic_tracks". All fields are combined with a logical 'AND'. */
export type Air_Traffic_Tracks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Air_Traffic_Tracks_Bool_Exp>>>;
  _not?: Maybe<Air_Traffic_Tracks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Air_Traffic_Tracks_Bool_Exp>>>;
  aircraft_type?: Maybe<String_Comparison_Exp>;
  alt_m?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  groundspeed_mps?: Maybe<Float8_Comparison_Exp>;
  heading_degs?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "air_traffic_tracks" */
export enum Air_Traffic_Tracks_Constraint {
  /** unique or primary key constraint */
  AirTrafficTracksPkey = 'air_traffic_tracks_pkey'
}

/** input type for incrementing integer column in table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Inc_Input = {
  alt_m?: Maybe<Scalars['float8']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Insert_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Air_Traffic_Tracks_Max_Fields = {
  __typename?: 'air_traffic_tracks_max_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Max_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Air_Traffic_Tracks_Min_Fields = {
  __typename?: 'air_traffic_tracks_min_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Min_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Mutation_Response = {
  __typename?: 'air_traffic_tracks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Air_Traffic_Tracks>;
};

/** input type for inserting object relation for remote table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Obj_Rel_Insert_Input = {
  data: Air_Traffic_Tracks_Insert_Input;
  on_conflict?: Maybe<Air_Traffic_Tracks_On_Conflict>;
};

/** on conflict condition type for table "air_traffic_tracks" */
export type Air_Traffic_Tracks_On_Conflict = {
  constraint: Air_Traffic_Tracks_Constraint;
  update_columns: Array<Air_Traffic_Tracks_Update_Column>;
  where?: Maybe<Air_Traffic_Tracks_Bool_Exp>;
};

/** ordering options when selecting data from "air_traffic_tracks" */
export type Air_Traffic_Tracks_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "air_traffic_tracks" */
export type Air_Traffic_Tracks_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "air_traffic_tracks" */
export enum Air_Traffic_Tracks_Select_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltM = 'alt_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDegs = 'heading_degs',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Set_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Air_Traffic_Tracks_Stddev_Fields = {
  __typename?: 'air_traffic_tracks_stddev_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Stddev_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Air_Traffic_Tracks_Stddev_Pop_Fields = {
  __typename?: 'air_traffic_tracks_stddev_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Stddev_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Air_Traffic_Tracks_Stddev_Samp_Fields = {
  __typename?: 'air_traffic_tracks_stddev_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Stddev_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Air_Traffic_Tracks_Sum_Fields = {
  __typename?: 'air_traffic_tracks_sum_fields';
  alt_m?: Maybe<Scalars['float8']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Sum_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "air_traffic_tracks" */
export enum Air_Traffic_Tracks_Update_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltM = 'alt_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDegs = 'heading_degs',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Air_Traffic_Tracks_Var_Pop_Fields = {
  __typename?: 'air_traffic_tracks_var_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Var_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Air_Traffic_Tracks_Var_Samp_Fields = {
  __typename?: 'air_traffic_tracks_var_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Var_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Air_Traffic_Tracks_Variance_Fields = {
  __typename?: 'air_traffic_tracks_variance_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "air_traffic_tracks" */
export type Air_Traffic_Tracks_Variance_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "aircraft_type_designators" */
export type Aircraft_Type_Designators = {
  __typename?: 'aircraft_type_designators';
  created_at: Scalars['timestamptz'];
  /** Description short code to map to icon name */
  description_short_code?: Maybe<Scalars['String']>;
  /** Maps to air traffic aircraft_type */
  designator: Scalars['String'];
  /** Icon Name used for representing air traffic in UI */
  icon_name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "aircraft_type_designators" */
export type Aircraft_Type_Designators_Aggregate = {
  __typename?: 'aircraft_type_designators_aggregate';
  aggregate?: Maybe<Aircraft_Type_Designators_Aggregate_Fields>;
  nodes: Array<Aircraft_Type_Designators>;
};

/** aggregate fields of "aircraft_type_designators" */
export type Aircraft_Type_Designators_Aggregate_Fields = {
  __typename?: 'aircraft_type_designators_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Aircraft_Type_Designators_Max_Fields>;
  min?: Maybe<Aircraft_Type_Designators_Min_Fields>;
};


/** aggregate fields of "aircraft_type_designators" */
export type Aircraft_Type_Designators_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Aircraft_Type_Designators_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Aircraft_Type_Designators_Max_Order_By>;
  min?: Maybe<Aircraft_Type_Designators_Min_Order_By>;
};

/** input type for inserting array relation for remote table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Arr_Rel_Insert_Input = {
  data: Array<Aircraft_Type_Designators_Insert_Input>;
  on_conflict?: Maybe<Aircraft_Type_Designators_On_Conflict>;
};

/** Boolean expression to filter rows from the table "aircraft_type_designators". All fields are combined with a logical 'AND'. */
export type Aircraft_Type_Designators_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Aircraft_Type_Designators_Bool_Exp>>>;
  _not?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Aircraft_Type_Designators_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  description_short_code?: Maybe<String_Comparison_Exp>;
  designator?: Maybe<String_Comparison_Exp>;
  icon_name?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "aircraft_type_designators" */
export enum Aircraft_Type_Designators_Constraint {
  /** unique or primary key constraint */
  AircraftTypeDesignatorsPkey = 'aircraft_type_designators_pkey'
}

/** input type for inserting data into table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_short_code?: Maybe<Scalars['String']>;
  designator?: Maybe<Scalars['String']>;
  icon_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Aircraft_Type_Designators_Max_Fields = {
  __typename?: 'aircraft_type_designators_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_short_code?: Maybe<Scalars['String']>;
  designator?: Maybe<Scalars['String']>;
  icon_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  description_short_code?: Maybe<Order_By>;
  designator?: Maybe<Order_By>;
  icon_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Aircraft_Type_Designators_Min_Fields = {
  __typename?: 'aircraft_type_designators_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description_short_code?: Maybe<Scalars['String']>;
  designator?: Maybe<Scalars['String']>;
  icon_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  description_short_code?: Maybe<Order_By>;
  designator?: Maybe<Order_By>;
  icon_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Mutation_Response = {
  __typename?: 'aircraft_type_designators_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Aircraft_Type_Designators>;
};

/** input type for inserting object relation for remote table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Obj_Rel_Insert_Input = {
  data: Aircraft_Type_Designators_Insert_Input;
  on_conflict?: Maybe<Aircraft_Type_Designators_On_Conflict>;
};

/** on conflict condition type for table "aircraft_type_designators" */
export type Aircraft_Type_Designators_On_Conflict = {
  constraint: Aircraft_Type_Designators_Constraint;
  update_columns: Array<Aircraft_Type_Designators_Update_Column>;
  where?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
};

/** ordering options when selecting data from "aircraft_type_designators" */
export type Aircraft_Type_Designators_Order_By = {
  created_at?: Maybe<Order_By>;
  description_short_code?: Maybe<Order_By>;
  designator?: Maybe<Order_By>;
  icon_name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "aircraft_type_designators" */
export type Aircraft_Type_Designators_Pk_Columns_Input = {
  /** Maps to air traffic aircraft_type */
  designator: Scalars['String'];
};

/** select columns of table "aircraft_type_designators" */
export enum Aircraft_Type_Designators_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionShortCode = 'description_short_code',
  /** column name */
  Designator = 'designator',
  /** column name */
  IconName = 'icon_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "aircraft_type_designators" */
export type Aircraft_Type_Designators_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description_short_code?: Maybe<Scalars['String']>;
  designator?: Maybe<Scalars['String']>;
  icon_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "aircraft_type_designators" */
export enum Aircraft_Type_Designators_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionShortCode = 'description_short_code',
  /** column name */
  Designator = 'designator',
  /** column name */
  IconName = 'icon_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type Airspaces = {
  __typename?: 'airspaces';
  /** An array relationship */
  contingency_landing_spots: Array<Contingency_Landing_Spots>;
  /** An aggregated array relationship */
  contingency_landing_spots_aggregate: Contingency_Landing_Spots_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  flight_routes_by_dest_airspace: Array<Flight_Routes>;
  /** An aggregated array relationship */
  flight_routes_by_dest_airspace_aggregate: Flight_Routes_Aggregate;
  /** An array relationship */
  flight_routes_by_origin_airspace: Array<Flight_Routes>;
  /** An aggregated array relationship */
  flight_routes_by_origin_airspace_aggregate: Flight_Routes_Aggregate;
  /** UID of the terminal airspace. */
  id: Scalars['Int'];
  /** Coordinates denoting the perimeter within which the airspace is contained. */
  perimeter?: Maybe<Scalars['geometry']>;
  /** An array relationship */
  stations: Array<Stations>;
  /** An aggregated array relationship */
  stations_aggregate: Stations_Aggregate;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesContingency_Landing_SpotsArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesContingency_Landing_Spots_AggregateArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesFlight_Routes_By_Dest_AirspaceArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesFlight_Routes_By_Dest_Airspace_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesFlight_Routes_By_Origin_AirspaceArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesFlight_Routes_By_Origin_Airspace_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesStationsArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/**
 * Table containing the definitions for the virtual three-dimensional geometries surrounding the takeoff and landing locations.
 *
 *
 * columns and relationships of "airspaces"
 */
export type AirspacesStations_AggregateArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};

/** aggregated selection of "airspaces" */
export type Airspaces_Aggregate = {
  __typename?: 'airspaces_aggregate';
  aggregate?: Maybe<Airspaces_Aggregate_Fields>;
  nodes: Array<Airspaces>;
};

/** aggregate fields of "airspaces" */
export type Airspaces_Aggregate_Fields = {
  __typename?: 'airspaces_aggregate_fields';
  avg?: Maybe<Airspaces_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Airspaces_Max_Fields>;
  min?: Maybe<Airspaces_Min_Fields>;
  stddev?: Maybe<Airspaces_Stddev_Fields>;
  stddev_pop?: Maybe<Airspaces_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Airspaces_Stddev_Samp_Fields>;
  sum?: Maybe<Airspaces_Sum_Fields>;
  var_pop?: Maybe<Airspaces_Var_Pop_Fields>;
  var_samp?: Maybe<Airspaces_Var_Samp_Fields>;
  variance?: Maybe<Airspaces_Variance_Fields>;
};


/** aggregate fields of "airspaces" */
export type Airspaces_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Airspaces_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "airspaces" */
export type Airspaces_Aggregate_Order_By = {
  avg?: Maybe<Airspaces_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Airspaces_Max_Order_By>;
  min?: Maybe<Airspaces_Min_Order_By>;
  stddev?: Maybe<Airspaces_Stddev_Order_By>;
  stddev_pop?: Maybe<Airspaces_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Airspaces_Stddev_Samp_Order_By>;
  sum?: Maybe<Airspaces_Sum_Order_By>;
  var_pop?: Maybe<Airspaces_Var_Pop_Order_By>;
  var_samp?: Maybe<Airspaces_Var_Samp_Order_By>;
  variance?: Maybe<Airspaces_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "airspaces" */
export type Airspaces_Arr_Rel_Insert_Input = {
  data: Array<Airspaces_Insert_Input>;
  on_conflict?: Maybe<Airspaces_On_Conflict>;
};

/** aggregate avg on columns */
export type Airspaces_Avg_Fields = {
  __typename?: 'airspaces_avg_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "airspaces" */
export type Airspaces_Avg_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "airspaces". All fields are combined with a logical 'AND'. */
export type Airspaces_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Airspaces_Bool_Exp>>>;
  _not?: Maybe<Airspaces_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Airspaces_Bool_Exp>>>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_routes_by_dest_airspace?: Maybe<Flight_Routes_Bool_Exp>;
  flight_routes_by_origin_airspace?: Maybe<Flight_Routes_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  perimeter?: Maybe<Geometry_Comparison_Exp>;
  stations?: Maybe<Stations_Bool_Exp>;
  surveyed_elevation?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "airspaces" */
export enum Airspaces_Constraint {
  /** unique or primary key constraint */
  AirspacesPkey = 'airspaces_pkey'
}

/** input type for incrementing integer column in table "airspaces" */
export type Airspaces_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "airspaces" */
export type Airspaces_Insert_Input = {
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_routes_by_dest_airspace?: Maybe<Flight_Routes_Arr_Rel_Insert_Input>;
  flight_routes_by_origin_airspace?: Maybe<Flight_Routes_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  perimeter?: Maybe<Scalars['geometry']>;
  stations?: Maybe<Stations_Arr_Rel_Insert_Input>;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Airspaces_Max_Fields = {
  __typename?: 'airspaces_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "airspaces" */
export type Airspaces_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Airspaces_Min_Fields = {
  __typename?: 'airspaces_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "airspaces" */
export type Airspaces_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "airspaces" */
export type Airspaces_Mutation_Response = {
  __typename?: 'airspaces_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Airspaces>;
};

/** input type for inserting object relation for remote table "airspaces" */
export type Airspaces_Obj_Rel_Insert_Input = {
  data: Airspaces_Insert_Input;
  on_conflict?: Maybe<Airspaces_On_Conflict>;
};

/** on conflict condition type for table "airspaces" */
export type Airspaces_On_Conflict = {
  constraint: Airspaces_Constraint;
  update_columns: Array<Airspaces_Update_Column>;
  where?: Maybe<Airspaces_Bool_Exp>;
};

/** ordering options when selecting data from "airspaces" */
export type Airspaces_Order_By = {
  contingency_landing_spots_aggregate?: Maybe<Contingency_Landing_Spots_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_routes_by_dest_airspace_aggregate?: Maybe<Flight_Routes_Aggregate_Order_By>;
  flight_routes_by_origin_airspace_aggregate?: Maybe<Flight_Routes_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  perimeter?: Maybe<Order_By>;
  stations_aggregate?: Maybe<Stations_Aggregate_Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "airspaces" */
export type Airspaces_Pk_Columns_Input = {
  /** UID of the terminal airspace. */
  id: Scalars['Int'];
};

/** select columns of table "airspaces" */
export enum Airspaces_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Perimeter = 'perimeter',
  /** column name */
  SurveyedElevation = 'surveyed_elevation',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "airspaces" */
export type Airspaces_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  perimeter?: Maybe<Scalars['geometry']>;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Airspaces_Stddev_Fields = {
  __typename?: 'airspaces_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "airspaces" */
export type Airspaces_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Airspaces_Stddev_Pop_Fields = {
  __typename?: 'airspaces_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "airspaces" */
export type Airspaces_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Airspaces_Stddev_Samp_Fields = {
  __typename?: 'airspaces_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "airspaces" */
export type Airspaces_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Airspaces_Sum_Fields = {
  __typename?: 'airspaces_sum_fields';
  id?: Maybe<Scalars['Int']>;
  surveyed_elevation?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "airspaces" */
export type Airspaces_Sum_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "airspaces" */
export enum Airspaces_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Perimeter = 'perimeter',
  /** column name */
  SurveyedElevation = 'surveyed_elevation',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Airspaces_Var_Pop_Fields = {
  __typename?: 'airspaces_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "airspaces" */
export type Airspaces_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Airspaces_Var_Samp_Fields = {
  __typename?: 'airspaces_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "airspaces" */
export type Airspaces_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Airspaces_Variance_Fields = {
  __typename?: 'airspaces_variance_fields';
  id?: Maybe<Scalars['Float']>;
  surveyed_elevation?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "airspaces" */
export type Airspaces_Variance_Order_By = {
  id?: Maybe<Order_By>;
  surveyed_elevation?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/**
 * Represents the set of available commands for an aircraft
 *
 *
 * columns and relationships of "available_aircraft_command_sets"
 */
export type Available_Aircraft_Command_Sets = {
  __typename?: 'available_aircraft_command_sets';
  /** Serial number of the aircraft. */
  aircraft_serial_number: Scalars['String'];
  /** Alternate landing command */
  alternate_landing: Available_Aircraft_Command_State_Keys_Enum;
  /** Alternate landing toggle command */
  alternate_landing_toggle: Available_Aircraft_Command_State_Keys_Enum;
  /** arm */
  arm: Available_Aircraft_Command_State_Keys_Enum;
  created_at: Scalars['timestamptz'];
  /** disarm */
  disarm: Available_Aircraft_Command_State_Keys_Enum;
  /** exit_safe */
  exit_safe: Available_Aircraft_Command_State_Keys_Enum;
  /** Flight plan ID associated with the aircraft. */
  flight_plan_id?: Maybe<Scalars['Int']>;
  /** hold */
  hold: Available_Aircraft_Command_State_Keys_Enum;
  /** land */
  land: Available_Aircraft_Command_State_Keys_Enum;
  /** Precision landing command */
  precision_landing_toggle: Available_Aircraft_Command_State_Keys_Enum;
  /** resume */
  resume: Available_Aircraft_Command_State_Keys_Enum;
  /** reverse_course */
  reverse_course: Available_Aircraft_Command_State_Keys_Enum;
  /** safe_zone */
  safe_zone: Available_Aircraft_Command_State_Keys_Enum;
  /** takeoff */
  takeoff: Available_Aircraft_Command_State_Keys_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
};

/** aggregated selection of "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Aggregate = {
  __typename?: 'available_aircraft_command_sets_aggregate';
  aggregate?: Maybe<Available_Aircraft_Command_Sets_Aggregate_Fields>;
  nodes: Array<Available_Aircraft_Command_Sets>;
};

/** aggregate fields of "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Aggregate_Fields = {
  __typename?: 'available_aircraft_command_sets_aggregate_fields';
  avg?: Maybe<Available_Aircraft_Command_Sets_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Available_Aircraft_Command_Sets_Max_Fields>;
  min?: Maybe<Available_Aircraft_Command_Sets_Min_Fields>;
  stddev?: Maybe<Available_Aircraft_Command_Sets_Stddev_Fields>;
  stddev_pop?: Maybe<Available_Aircraft_Command_Sets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Available_Aircraft_Command_Sets_Stddev_Samp_Fields>;
  sum?: Maybe<Available_Aircraft_Command_Sets_Sum_Fields>;
  var_pop?: Maybe<Available_Aircraft_Command_Sets_Var_Pop_Fields>;
  var_samp?: Maybe<Available_Aircraft_Command_Sets_Var_Samp_Fields>;
  variance?: Maybe<Available_Aircraft_Command_Sets_Variance_Fields>;
};


/** aggregate fields of "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Available_Aircraft_Command_Sets_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Aggregate_Order_By = {
  avg?: Maybe<Available_Aircraft_Command_Sets_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Available_Aircraft_Command_Sets_Max_Order_By>;
  min?: Maybe<Available_Aircraft_Command_Sets_Min_Order_By>;
  stddev?: Maybe<Available_Aircraft_Command_Sets_Stddev_Order_By>;
  stddev_pop?: Maybe<Available_Aircraft_Command_Sets_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Available_Aircraft_Command_Sets_Stddev_Samp_Order_By>;
  sum?: Maybe<Available_Aircraft_Command_Sets_Sum_Order_By>;
  var_pop?: Maybe<Available_Aircraft_Command_Sets_Var_Pop_Order_By>;
  var_samp?: Maybe<Available_Aircraft_Command_Sets_Var_Samp_Order_By>;
  variance?: Maybe<Available_Aircraft_Command_Sets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Arr_Rel_Insert_Input = {
  data: Array<Available_Aircraft_Command_Sets_Insert_Input>;
  on_conflict?: Maybe<Available_Aircraft_Command_Sets_On_Conflict>;
};

/** aggregate avg on columns */
export type Available_Aircraft_Command_Sets_Avg_Fields = {
  __typename?: 'available_aircraft_command_sets_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "available_aircraft_command_sets". All fields are combined with a logical 'AND'. */
export type Available_Aircraft_Command_Sets_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Available_Aircraft_Command_Sets_Bool_Exp>>>;
  _not?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Available_Aircraft_Command_Sets_Bool_Exp>>>;
  aircraft_serial_number?: Maybe<String_Comparison_Exp>;
  alternate_landing?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  alternate_landing_toggle?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  arm?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  disarm?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  exit_safe?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  hold?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  land?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  precision_landing_toggle?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  resume?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  reverse_course?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  safe_zone?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  takeoff?: Maybe<Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
};

/** unique or primary key constraints on table "available_aircraft_command_sets" */
export enum Available_Aircraft_Command_Sets_Constraint {
  /** unique or primary key constraint */
  AvailableAircraftCommandSetsPkey = 'available_aircraft_command_sets_pkey'
}

/** input type for incrementing integer column in table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Insert_Input = {
  aircraft_serial_number?: Maybe<Scalars['String']>;
  alternate_landing?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  alternate_landing_toggle?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  arm?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  disarm?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  exit_safe?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  hold?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  land?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  precision_landing_toggle?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  resume?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  reverse_course?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  safe_zone?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  takeoff?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Available_Aircraft_Command_Sets_Max_Fields = {
  __typename?: 'available_aircraft_command_sets_max_fields';
  aircraft_serial_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Max_Order_By = {
  aircraft_serial_number?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Available_Aircraft_Command_Sets_Min_Fields = {
  __typename?: 'available_aircraft_command_sets_min_fields';
  aircraft_serial_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Min_Order_By = {
  aircraft_serial_number?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Mutation_Response = {
  __typename?: 'available_aircraft_command_sets_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Available_Aircraft_Command_Sets>;
};

/** input type for inserting object relation for remote table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Obj_Rel_Insert_Input = {
  data: Available_Aircraft_Command_Sets_Insert_Input;
  on_conflict?: Maybe<Available_Aircraft_Command_Sets_On_Conflict>;
};

/** on conflict condition type for table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_On_Conflict = {
  constraint: Available_Aircraft_Command_Sets_Constraint;
  update_columns: Array<Available_Aircraft_Command_Sets_Update_Column>;
  where?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
};

/** ordering options when selecting data from "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Order_By = {
  aircraft_serial_number?: Maybe<Order_By>;
  alternate_landing?: Maybe<Order_By>;
  alternate_landing_toggle?: Maybe<Order_By>;
  arm?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  disarm?: Maybe<Order_By>;
  exit_safe?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  hold?: Maybe<Order_By>;
  land?: Maybe<Order_By>;
  precision_landing_toggle?: Maybe<Order_By>;
  resume?: Maybe<Order_By>;
  reverse_course?: Maybe<Order_By>;
  safe_zone?: Maybe<Order_By>;
  takeoff?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
};

/** primary key columns input for table: "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Pk_Columns_Input = {
  /** Serial number of the aircraft. */
  aircraft_serial_number: Scalars['String'];
};

/** select columns of table "available_aircraft_command_sets" */
export enum Available_Aircraft_Command_Sets_Select_Column {
  /** column name */
  AircraftSerialNumber = 'aircraft_serial_number',
  /** column name */
  AlternateLanding = 'alternate_landing',
  /** column name */
  AlternateLandingToggle = 'alternate_landing_toggle',
  /** column name */
  Arm = 'arm',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disarm = 'disarm',
  /** column name */
  ExitSafe = 'exit_safe',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Hold = 'hold',
  /** column name */
  Land = 'land',
  /** column name */
  PrecisionLandingToggle = 'precision_landing_toggle',
  /** column name */
  Resume = 'resume',
  /** column name */
  ReverseCourse = 'reverse_course',
  /** column name */
  SafeZone = 'safe_zone',
  /** column name */
  Takeoff = 'takeoff',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Set_Input = {
  aircraft_serial_number?: Maybe<Scalars['String']>;
  alternate_landing?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  alternate_landing_toggle?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  arm?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  created_at?: Maybe<Scalars['timestamptz']>;
  disarm?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  exit_safe?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  hold?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  land?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  precision_landing_toggle?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  resume?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  reverse_course?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  safe_zone?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  takeoff?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Available_Aircraft_Command_Sets_Stddev_Fields = {
  __typename?: 'available_aircraft_command_sets_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Available_Aircraft_Command_Sets_Stddev_Pop_Fields = {
  __typename?: 'available_aircraft_command_sets_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Available_Aircraft_Command_Sets_Stddev_Samp_Fields = {
  __typename?: 'available_aircraft_command_sets_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Available_Aircraft_Command_Sets_Sum_Fields = {
  __typename?: 'available_aircraft_command_sets_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** update columns of table "available_aircraft_command_sets" */
export enum Available_Aircraft_Command_Sets_Update_Column {
  /** column name */
  AircraftSerialNumber = 'aircraft_serial_number',
  /** column name */
  AlternateLanding = 'alternate_landing',
  /** column name */
  AlternateLandingToggle = 'alternate_landing_toggle',
  /** column name */
  Arm = 'arm',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disarm = 'disarm',
  /** column name */
  ExitSafe = 'exit_safe',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Hold = 'hold',
  /** column name */
  Land = 'land',
  /** column name */
  PrecisionLandingToggle = 'precision_landing_toggle',
  /** column name */
  Resume = 'resume',
  /** column name */
  ReverseCourse = 'reverse_course',
  /** column name */
  SafeZone = 'safe_zone',
  /** column name */
  Takeoff = 'takeoff',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Available_Aircraft_Command_Sets_Var_Pop_Fields = {
  __typename?: 'available_aircraft_command_sets_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Available_Aircraft_Command_Sets_Var_Samp_Fields = {
  __typename?: 'available_aircraft_command_sets_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Available_Aircraft_Command_Sets_Variance_Fields = {
  __typename?: 'available_aircraft_command_sets_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "available_aircraft_command_sets" */
export type Available_Aircraft_Command_Sets_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
};

/**
 * Allowed Available Aircraft Command State Key values
 *
 *
 * columns and relationships of "available_aircraft_command_state_keys"
 */
export type Available_Aircraft_Command_State_Keys = {
  __typename?: 'available_aircraft_command_state_keys';
  /** Description of state_key */
  description: Scalars['String'];
  /** Allowed values for Available Vehicle Commands */
  state_key: Scalars['String'];
};

/** aggregated selection of "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Aggregate = {
  __typename?: 'available_aircraft_command_state_keys_aggregate';
  aggregate?: Maybe<Available_Aircraft_Command_State_Keys_Aggregate_Fields>;
  nodes: Array<Available_Aircraft_Command_State_Keys>;
};

/** aggregate fields of "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Aggregate_Fields = {
  __typename?: 'available_aircraft_command_state_keys_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Available_Aircraft_Command_State_Keys_Max_Fields>;
  min?: Maybe<Available_Aircraft_Command_State_Keys_Min_Fields>;
};


/** aggregate fields of "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Available_Aircraft_Command_State_Keys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Available_Aircraft_Command_State_Keys_Max_Order_By>;
  min?: Maybe<Available_Aircraft_Command_State_Keys_Min_Order_By>;
};

/** input type for inserting array relation for remote table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Arr_Rel_Insert_Input = {
  data: Array<Available_Aircraft_Command_State_Keys_Insert_Input>;
  on_conflict?: Maybe<Available_Aircraft_Command_State_Keys_On_Conflict>;
};

/** Boolean expression to filter rows from the table "available_aircraft_command_state_keys". All fields are combined with a logical 'AND'. */
export type Available_Aircraft_Command_State_Keys_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>>>;
  _not?: Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  state_key?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "available_aircraft_command_state_keys" */
export enum Available_Aircraft_Command_State_Keys_Constraint {
  /** unique or primary key constraint */
  AvailableAircraftCommandStateKeysPkey = 'available_aircraft_command_state_keys_pkey'
}

export enum Available_Aircraft_Command_State_Keys_Enum {
  /** Command is disabled. */
  Disabled = 'DISABLED',
  /** Command is enabled. */
  Enabled = 'ENABLED'
}

/** expression to compare columns of type available_aircraft_command_state_keys_enum. All fields are combined with logical 'AND'. */
export type Available_Aircraft_Command_State_Keys_Enum_Comparison_Exp = {
  _eq?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  _in?: Maybe<Array<Available_Aircraft_Command_State_Keys_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Available_Aircraft_Command_State_Keys_Enum>;
  _nin?: Maybe<Array<Available_Aircraft_Command_State_Keys_Enum>>;
};

/** input type for inserting data into table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  state_key?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Available_Aircraft_Command_State_Keys_Max_Fields = {
  __typename?: 'available_aircraft_command_state_keys_max_fields';
  description?: Maybe<Scalars['String']>;
  state_key?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Max_Order_By = {
  description?: Maybe<Order_By>;
  state_key?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Available_Aircraft_Command_State_Keys_Min_Fields = {
  __typename?: 'available_aircraft_command_state_keys_min_fields';
  description?: Maybe<Scalars['String']>;
  state_key?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Min_Order_By = {
  description?: Maybe<Order_By>;
  state_key?: Maybe<Order_By>;
};

/** response of any mutation on the table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Mutation_Response = {
  __typename?: 'available_aircraft_command_state_keys_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Available_Aircraft_Command_State_Keys>;
};

/** input type for inserting object relation for remote table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Obj_Rel_Insert_Input = {
  data: Available_Aircraft_Command_State_Keys_Insert_Input;
  on_conflict?: Maybe<Available_Aircraft_Command_State_Keys_On_Conflict>;
};

/** on conflict condition type for table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_On_Conflict = {
  constraint: Available_Aircraft_Command_State_Keys_Constraint;
  update_columns: Array<Available_Aircraft_Command_State_Keys_Update_Column>;
  where?: Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>;
};

/** ordering options when selecting data from "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Order_By = {
  description?: Maybe<Order_By>;
  state_key?: Maybe<Order_By>;
};

/** primary key columns input for table: "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Pk_Columns_Input = {
  /** Allowed values for Available Vehicle Commands */
  state_key: Scalars['String'];
};

/** select columns of table "available_aircraft_command_state_keys" */
export enum Available_Aircraft_Command_State_Keys_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  StateKey = 'state_key'
}

/** input type for updating data in table "available_aircraft_command_state_keys" */
export type Available_Aircraft_Command_State_Keys_Set_Input = {
  description?: Maybe<Scalars['String']>;
  state_key?: Maybe<Scalars['String']>;
};

/** update columns of table "available_aircraft_command_state_keys" */
export enum Available_Aircraft_Command_State_Keys_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  StateKey = 'state_key'
}

/** columns and relationships of "badge_tokens" */
export type Badge_Tokens = {
  __typename?: 'badge_tokens';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An array relationship */
  manifests: Array<Manifests>;
  /** An array relationship */
  manifestsByBadgeTokenSenderId: Array<Manifests>;
  /** An aggregated array relationship */
  manifestsByBadgeTokenSenderId_aggregate: Manifests_Aggregate;
  /** An aggregated array relationship */
  manifests_aggregate: Manifests_Aggregate;
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};


/** columns and relationships of "badge_tokens" */
export type Badge_TokensManifestsArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "badge_tokens" */
export type Badge_TokensManifestsByBadgeTokenSenderIdArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "badge_tokens" */
export type Badge_TokensManifestsByBadgeTokenSenderId_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "badge_tokens" */
export type Badge_TokensManifests_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};

/** aggregated selection of "badge_tokens" */
export type Badge_Tokens_Aggregate = {
  __typename?: 'badge_tokens_aggregate';
  aggregate?: Maybe<Badge_Tokens_Aggregate_Fields>;
  nodes: Array<Badge_Tokens>;
};

/** aggregate fields of "badge_tokens" */
export type Badge_Tokens_Aggregate_Fields = {
  __typename?: 'badge_tokens_aggregate_fields';
  avg?: Maybe<Badge_Tokens_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Badge_Tokens_Max_Fields>;
  min?: Maybe<Badge_Tokens_Min_Fields>;
  stddev?: Maybe<Badge_Tokens_Stddev_Fields>;
  stddev_pop?: Maybe<Badge_Tokens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Badge_Tokens_Stddev_Samp_Fields>;
  sum?: Maybe<Badge_Tokens_Sum_Fields>;
  var_pop?: Maybe<Badge_Tokens_Var_Pop_Fields>;
  var_samp?: Maybe<Badge_Tokens_Var_Samp_Fields>;
  variance?: Maybe<Badge_Tokens_Variance_Fields>;
};


/** aggregate fields of "badge_tokens" */
export type Badge_Tokens_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Badge_Tokens_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "badge_tokens" */
export type Badge_Tokens_Aggregate_Order_By = {
  avg?: Maybe<Badge_Tokens_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Badge_Tokens_Max_Order_By>;
  min?: Maybe<Badge_Tokens_Min_Order_By>;
  stddev?: Maybe<Badge_Tokens_Stddev_Order_By>;
  stddev_pop?: Maybe<Badge_Tokens_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Badge_Tokens_Stddev_Samp_Order_By>;
  sum?: Maybe<Badge_Tokens_Sum_Order_By>;
  var_pop?: Maybe<Badge_Tokens_Var_Pop_Order_By>;
  var_samp?: Maybe<Badge_Tokens_Var_Samp_Order_By>;
  variance?: Maybe<Badge_Tokens_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "badge_tokens" */
export type Badge_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Badge_Tokens_Insert_Input>;
  on_conflict?: Maybe<Badge_Tokens_On_Conflict>;
};

/** aggregate avg on columns */
export type Badge_Tokens_Avg_Fields = {
  __typename?: 'badge_tokens_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "badge_tokens" */
export type Badge_Tokens_Avg_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "badge_tokens". All fields are combined with a logical 'AND'. */
export type Badge_Tokens_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Badge_Tokens_Bool_Exp>>>;
  _not?: Maybe<Badge_Tokens_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Badge_Tokens_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifests?: Maybe<Manifests_Bool_Exp>;
  manifestsByBadgeTokenSenderId?: Maybe<Manifests_Bool_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  note?: Maybe<String_Comparison_Exp>;
  token_id?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "badge_tokens" */
export enum Badge_Tokens_Constraint {
  /** unique or primary key constraint */
  BadgeTokensNoteKey = 'badge_tokens_note_key',
  /** unique or primary key constraint */
  BadgeTokensPkey = 'badge_tokens_pkey',
  /** unique or primary key constraint */
  BadgeTokensTokenIdKey = 'badge_tokens_token_id_key'
}

/** input type for incrementing integer column in table "badge_tokens" */
export type Badge_Tokens_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "badge_tokens" */
export type Badge_Tokens_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manifests?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  manifestsByBadgeTokenSenderId?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Badge_Tokens_Max_Fields = {
  __typename?: 'badge_tokens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "badge_tokens" */
export type Badge_Tokens_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Badge_Tokens_Min_Fields = {
  __typename?: 'badge_tokens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "badge_tokens" */
export type Badge_Tokens_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "badge_tokens" */
export type Badge_Tokens_Mutation_Response = {
  __typename?: 'badge_tokens_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Badge_Tokens>;
};

/** input type for inserting object relation for remote table "badge_tokens" */
export type Badge_Tokens_Obj_Rel_Insert_Input = {
  data: Badge_Tokens_Insert_Input;
  on_conflict?: Maybe<Badge_Tokens_On_Conflict>;
};

/** on conflict condition type for table "badge_tokens" */
export type Badge_Tokens_On_Conflict = {
  constraint: Badge_Tokens_Constraint;
  update_columns: Array<Badge_Tokens_Update_Column>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};

/** ordering options when selecting data from "badge_tokens" */
export type Badge_Tokens_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifestsByBadgeTokenSenderId_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  manifests_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  note?: Maybe<Order_By>;
  token_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "badge_tokens" */
export type Badge_Tokens_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "badge_tokens" */
export enum Badge_Tokens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  Note = 'note',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "badge_tokens" */
export type Badge_Tokens_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  token_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Badge_Tokens_Stddev_Fields = {
  __typename?: 'badge_tokens_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "badge_tokens" */
export type Badge_Tokens_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Badge_Tokens_Stddev_Pop_Fields = {
  __typename?: 'badge_tokens_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "badge_tokens" */
export type Badge_Tokens_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Badge_Tokens_Stddev_Samp_Fields = {
  __typename?: 'badge_tokens_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "badge_tokens" */
export type Badge_Tokens_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Badge_Tokens_Sum_Fields = {
  __typename?: 'badge_tokens_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "badge_tokens" */
export type Badge_Tokens_Sum_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "badge_tokens" */
export enum Badge_Tokens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  Note = 'note',
  /** column name */
  TokenId = 'token_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Badge_Tokens_Var_Pop_Fields = {
  __typename?: 'badge_tokens_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "badge_tokens" */
export type Badge_Tokens_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Badge_Tokens_Var_Samp_Fields = {
  __typename?: 'badge_tokens_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "badge_tokens" */
export type Badge_Tokens_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Badge_Tokens_Variance_Fields = {
  __typename?: 'badge_tokens_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "badge_tokens" */
export type Badge_Tokens_Variance_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "batteries" */
export type Batteries = {
  __typename?: 'batteries';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  manufactured_at?: Maybe<Scalars['date']>;
  mongo_id?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  version: Scalars['Int'];
};

/** aggregated selection of "batteries" */
export type Batteries_Aggregate = {
  __typename?: 'batteries_aggregate';
  aggregate?: Maybe<Batteries_Aggregate_Fields>;
  nodes: Array<Batteries>;
};

/** aggregate fields of "batteries" */
export type Batteries_Aggregate_Fields = {
  __typename?: 'batteries_aggregate_fields';
  avg?: Maybe<Batteries_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Batteries_Max_Fields>;
  min?: Maybe<Batteries_Min_Fields>;
  stddev?: Maybe<Batteries_Stddev_Fields>;
  stddev_pop?: Maybe<Batteries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Batteries_Stddev_Samp_Fields>;
  sum?: Maybe<Batteries_Sum_Fields>;
  var_pop?: Maybe<Batteries_Var_Pop_Fields>;
  var_samp?: Maybe<Batteries_Var_Samp_Fields>;
  variance?: Maybe<Batteries_Variance_Fields>;
};


/** aggregate fields of "batteries" */
export type Batteries_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Batteries_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batteries" */
export type Batteries_Aggregate_Order_By = {
  avg?: Maybe<Batteries_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Batteries_Max_Order_By>;
  min?: Maybe<Batteries_Min_Order_By>;
  stddev?: Maybe<Batteries_Stddev_Order_By>;
  stddev_pop?: Maybe<Batteries_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Batteries_Stddev_Samp_Order_By>;
  sum?: Maybe<Batteries_Sum_Order_By>;
  var_pop?: Maybe<Batteries_Var_Pop_Order_By>;
  var_samp?: Maybe<Batteries_Var_Samp_Order_By>;
  variance?: Maybe<Batteries_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "batteries" */
export type Batteries_Arr_Rel_Insert_Input = {
  data: Array<Batteries_Insert_Input>;
  on_conflict?: Maybe<Batteries_On_Conflict>;
};

/** aggregate avg on columns */
export type Batteries_Avg_Fields = {
  __typename?: 'batteries_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batteries" */
export type Batteries_Avg_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "batteries". All fields are combined with a logical 'AND'. */
export type Batteries_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Batteries_Bool_Exp>>>;
  _not?: Maybe<Batteries_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Batteries_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Int_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manufactured_at?: Maybe<Date_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "batteries" */
export enum Batteries_Constraint {
  /** unique or primary key constraint */
  BatteriesMongoIdKey = 'batteries_mongo_id_key',
  /** unique or primary key constraint */
  BatteriesPkey = 'batteries_pkey'
}

/** input type for incrementing integer column in table "batteries" */
export type Batteries_Inc_Input = {
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "batteries" */
export type Batteries_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manufactured_at?: Maybe<Scalars['date']>;
  mongo_id?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Batteries_Max_Fields = {
  __typename?: 'batteries_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manufactured_at?: Maybe<Scalars['date']>;
  mongo_id?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "batteries" */
export type Batteries_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manufactured_at?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Batteries_Min_Fields = {
  __typename?: 'batteries_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manufactured_at?: Maybe<Scalars['date']>;
  mongo_id?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "batteries" */
export type Batteries_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manufactured_at?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "batteries" */
export type Batteries_Mutation_Response = {
  __typename?: 'batteries_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Batteries>;
};

/** input type for inserting object relation for remote table "batteries" */
export type Batteries_Obj_Rel_Insert_Input = {
  data: Batteries_Insert_Input;
  on_conflict?: Maybe<Batteries_On_Conflict>;
};

/** on conflict condition type for table "batteries" */
export type Batteries_On_Conflict = {
  constraint: Batteries_Constraint;
  update_columns: Array<Batteries_Update_Column>;
  where?: Maybe<Batteries_Bool_Exp>;
};

/** ordering options when selecting data from "batteries" */
export type Batteries_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manufactured_at?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "batteries" */
export type Batteries_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "batteries" */
export enum Batteries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManufacturedAt = 'manufactured_at',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "batteries" */
export type Batteries_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manufactured_at?: Maybe<Scalars['date']>;
  mongo_id?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Batteries_Stddev_Fields = {
  __typename?: 'batteries_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batteries" */
export type Batteries_Stddev_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Batteries_Stddev_Pop_Fields = {
  __typename?: 'batteries_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batteries" */
export type Batteries_Stddev_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Batteries_Stddev_Samp_Fields = {
  __typename?: 'batteries_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batteries" */
export type Batteries_Stddev_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Batteries_Sum_Fields = {
  __typename?: 'batteries_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "batteries" */
export type Batteries_Sum_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "batteries" */
export enum Batteries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManufacturedAt = 'manufactured_at',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Batteries_Var_Pop_Fields = {
  __typename?: 'batteries_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batteries" */
export type Batteries_Var_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Batteries_Var_Samp_Fields = {
  __typename?: 'batteries_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batteries" */
export type Batteries_Var_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Batteries_Variance_Fields = {
  __typename?: 'batteries_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batteries" */
export type Batteries_Variance_Order_By = {
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};


/** expression to compare columns of type bytea. All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: Maybe<Scalars['bytea']>;
  _gt?: Maybe<Scalars['bytea']>;
  _gte?: Maybe<Scalars['bytea']>;
  _in?: Maybe<Array<Scalars['bytea']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bytea']>;
  _lte?: Maybe<Scalars['bytea']>;
  _neq?: Maybe<Scalars['bytea']>;
  _nin?: Maybe<Array<Scalars['bytea']>>;
};

/** columns and relationships of "contingency_landing_spots" */
export type Contingency_Landing_Spots = {
  __typename?: 'contingency_landing_spots';
  /** An object relationship */
  airspace?: Maybe<Airspaces>;
  airspace_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  flightPlansByOriginContingencyLandingSpotId: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flightPlansByOriginContingencyLandingSpotId_aggregate: Flight_Plans_Aggregate;
  /** An array relationship */
  flight_plans: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  id: Scalars['Int'];
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  reserved?: Maybe<Scalars['Boolean']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  version: Scalars['Int'];
};


/** columns and relationships of "contingency_landing_spots" */
export type Contingency_Landing_SpotsFlightPlansByOriginContingencyLandingSpotIdArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** columns and relationships of "contingency_landing_spots" */
export type Contingency_Landing_SpotsFlightPlansByOriginContingencyLandingSpotId_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** columns and relationships of "contingency_landing_spots" */
export type Contingency_Landing_SpotsFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** columns and relationships of "contingency_landing_spots" */
export type Contingency_Landing_SpotsFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};

/** aggregated selection of "contingency_landing_spots" */
export type Contingency_Landing_Spots_Aggregate = {
  __typename?: 'contingency_landing_spots_aggregate';
  aggregate?: Maybe<Contingency_Landing_Spots_Aggregate_Fields>;
  nodes: Array<Contingency_Landing_Spots>;
};

/** aggregate fields of "contingency_landing_spots" */
export type Contingency_Landing_Spots_Aggregate_Fields = {
  __typename?: 'contingency_landing_spots_aggregate_fields';
  avg?: Maybe<Contingency_Landing_Spots_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Contingency_Landing_Spots_Max_Fields>;
  min?: Maybe<Contingency_Landing_Spots_Min_Fields>;
  stddev?: Maybe<Contingency_Landing_Spots_Stddev_Fields>;
  stddev_pop?: Maybe<Contingency_Landing_Spots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contingency_Landing_Spots_Stddev_Samp_Fields>;
  sum?: Maybe<Contingency_Landing_Spots_Sum_Fields>;
  var_pop?: Maybe<Contingency_Landing_Spots_Var_Pop_Fields>;
  var_samp?: Maybe<Contingency_Landing_Spots_Var_Samp_Fields>;
  variance?: Maybe<Contingency_Landing_Spots_Variance_Fields>;
};


/** aggregate fields of "contingency_landing_spots" */
export type Contingency_Landing_Spots_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Aggregate_Order_By = {
  avg?: Maybe<Contingency_Landing_Spots_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Contingency_Landing_Spots_Max_Order_By>;
  min?: Maybe<Contingency_Landing_Spots_Min_Order_By>;
  stddev?: Maybe<Contingency_Landing_Spots_Stddev_Order_By>;
  stddev_pop?: Maybe<Contingency_Landing_Spots_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Contingency_Landing_Spots_Stddev_Samp_Order_By>;
  sum?: Maybe<Contingency_Landing_Spots_Sum_Order_By>;
  var_pop?: Maybe<Contingency_Landing_Spots_Var_Pop_Order_By>;
  var_samp?: Maybe<Contingency_Landing_Spots_Var_Samp_Order_By>;
  variance?: Maybe<Contingency_Landing_Spots_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Arr_Rel_Insert_Input = {
  data: Array<Contingency_Landing_Spots_Insert_Input>;
  on_conflict?: Maybe<Contingency_Landing_Spots_On_Conflict>;
};

/** aggregate avg on columns */
export type Contingency_Landing_Spots_Avg_Fields = {
  __typename?: 'contingency_landing_spots_avg_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Avg_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "contingency_landing_spots". All fields are combined with a logical 'AND'. */
export type Contingency_Landing_Spots_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Contingency_Landing_Spots_Bool_Exp>>>;
  _not?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Contingency_Landing_Spots_Bool_Exp>>>;
  airspace?: Maybe<Airspaces_Bool_Exp>;
  airspace_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Int_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flightPlansByOriginContingencyLandingSpotId?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plans?: Maybe<Flight_Plans_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  reserved?: Maybe<Boolean_Comparison_Exp>;
  reserved_by_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "contingency_landing_spots" */
export enum Contingency_Landing_Spots_Constraint {
  /** unique or primary key constraint */
  ContingencyLandingSpotsMongoIdKey = 'contingency_landing_spots_mongo_id_key',
  /** unique or primary key constraint */
  ContingencyLandingSpotsPkey = 'contingency_landing_spots_pkey'
}

/** input type for incrementing integer column in table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Inc_Input = {
  airspace_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Insert_Input = {
  airspace?: Maybe<Airspaces_Obj_Rel_Insert_Input>;
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flightPlansByOriginContingencyLandingSpotId?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_plans?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  reserved?: Maybe<Scalars['Boolean']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Contingency_Landing_Spots_Max_Fields = {
  __typename?: 'contingency_landing_spots_max_fields';
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Max_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Contingency_Landing_Spots_Min_Fields = {
  __typename?: 'contingency_landing_spots_min_fields';
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Min_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Mutation_Response = {
  __typename?: 'contingency_landing_spots_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Contingency_Landing_Spots>;
};

/** input type for inserting object relation for remote table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Obj_Rel_Insert_Input = {
  data: Contingency_Landing_Spots_Insert_Input;
  on_conflict?: Maybe<Contingency_Landing_Spots_On_Conflict>;
};

/** on conflict condition type for table "contingency_landing_spots" */
export type Contingency_Landing_Spots_On_Conflict = {
  constraint: Contingency_Landing_Spots_Constraint;
  update_columns: Array<Contingency_Landing_Spots_Update_Column>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};

/** ordering options when selecting data from "contingency_landing_spots" */
export type Contingency_Landing_Spots_Order_By = {
  airspace?: Maybe<Airspaces_Order_By>;
  airspace_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flightPlansByOriginContingencyLandingSpotId_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_plans_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  reserved?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "contingency_landing_spots" */
export type Contingency_Landing_Spots_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "contingency_landing_spots" */
export enum Contingency_Landing_Spots_Select_Column {
  /** column name */
  AirspaceId = 'airspace_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  Reserved = 'reserved',
  /** column name */
  ReservedById = 'reserved_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Set_Input = {
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  reserved?: Maybe<Scalars['Boolean']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Contingency_Landing_Spots_Stddev_Fields = {
  __typename?: 'contingency_landing_spots_stddev_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Stddev_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Contingency_Landing_Spots_Stddev_Pop_Fields = {
  __typename?: 'contingency_landing_spots_stddev_pop_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Stddev_Pop_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Contingency_Landing_Spots_Stddev_Samp_Fields = {
  __typename?: 'contingency_landing_spots_stddev_samp_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Stddev_Samp_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Contingency_Landing_Spots_Sum_Fields = {
  __typename?: 'contingency_landing_spots_sum_fields';
  airspace_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  reserved_by_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Sum_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "contingency_landing_spots" */
export enum Contingency_Landing_Spots_Update_Column {
  /** column name */
  AirspaceId = 'airspace_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  Reserved = 'reserved',
  /** column name */
  ReservedById = 'reserved_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Contingency_Landing_Spots_Var_Pop_Fields = {
  __typename?: 'contingency_landing_spots_var_pop_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Var_Pop_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Contingency_Landing_Spots_Var_Samp_Fields = {
  __typename?: 'contingency_landing_spots_var_samp_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Var_Samp_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Contingency_Landing_Spots_Variance_Fields = {
  __typename?: 'contingency_landing_spots_variance_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  reserved_by_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "contingency_landing_spots" */
export type Contingency_Landing_Spots_Variance_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  reserved_by_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings = {
  __typename?: 'current_air_traffic_proximity_recordings';
  aircraft_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  aircraft_type_designator?: Maybe<Aircraft_Type_Designators>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Aggregate = {
  __typename?: 'current_air_traffic_proximity_recordings_aggregate';
  aggregate?: Maybe<Current_Air_Traffic_Proximity_Recordings_Aggregate_Fields>;
  nodes: Array<Current_Air_Traffic_Proximity_Recordings>;
};

/** aggregate fields of "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Aggregate_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_aggregate_fields';
  avg?: Maybe<Current_Air_Traffic_Proximity_Recordings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Current_Air_Traffic_Proximity_Recordings_Max_Fields>;
  min?: Maybe<Current_Air_Traffic_Proximity_Recordings_Min_Fields>;
  stddev?: Maybe<Current_Air_Traffic_Proximity_Recordings_Stddev_Fields>;
  stddev_pop?: Maybe<Current_Air_Traffic_Proximity_Recordings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Current_Air_Traffic_Proximity_Recordings_Stddev_Samp_Fields>;
  sum?: Maybe<Current_Air_Traffic_Proximity_Recordings_Sum_Fields>;
  var_pop?: Maybe<Current_Air_Traffic_Proximity_Recordings_Var_Pop_Fields>;
  var_samp?: Maybe<Current_Air_Traffic_Proximity_Recordings_Var_Samp_Fields>;
  variance?: Maybe<Current_Air_Traffic_Proximity_Recordings_Variance_Fields>;
};


/** aggregate fields of "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Aggregate_Order_By = {
  avg?: Maybe<Current_Air_Traffic_Proximity_Recordings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Current_Air_Traffic_Proximity_Recordings_Max_Order_By>;
  min?: Maybe<Current_Air_Traffic_Proximity_Recordings_Min_Order_By>;
  stddev?: Maybe<Current_Air_Traffic_Proximity_Recordings_Stddev_Order_By>;
  stddev_pop?: Maybe<Current_Air_Traffic_Proximity_Recordings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Current_Air_Traffic_Proximity_Recordings_Stddev_Samp_Order_By>;
  sum?: Maybe<Current_Air_Traffic_Proximity_Recordings_Sum_Order_By>;
  var_pop?: Maybe<Current_Air_Traffic_Proximity_Recordings_Var_Pop_Order_By>;
  var_samp?: Maybe<Current_Air_Traffic_Proximity_Recordings_Var_Samp_Order_By>;
  variance?: Maybe<Current_Air_Traffic_Proximity_Recordings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Arr_Rel_Insert_Input = {
  data: Array<Current_Air_Traffic_Proximity_Recordings_Insert_Input>;
};

/** aggregate avg on columns */
export type Current_Air_Traffic_Proximity_Recordings_Avg_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_avg_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Avg_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "current_air_traffic_proximity_recordings". All fields are combined with a logical 'AND'. */
export type Current_Air_Traffic_Proximity_Recordings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>>>;
  _not?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>>>;
  aircraft_type?: Maybe<String_Comparison_Exp>;
  aircraft_type_designator?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
  alt_meters?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  debug_data?: Maybe<String_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  groundspeed_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  heading_degrees?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  lat_degrees?: Maybe<Float8_Comparison_Exp>;
  lon_degrees?: Maybe<Float8_Comparison_Exp>;
  proximity_level?: Maybe<String_Comparison_Exp>;
  relative_altitude_meters?: Maybe<Float8_Comparison_Exp>;
  relative_distance_meters?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  timestamp_seconds?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
  vehicle_status_timestamp_seconds?: Maybe<Float8_Comparison_Exp>;
};

/** input type for incrementing integer column in table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Inc_Input = {
  alt_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Insert_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  aircraft_type_designator?: Maybe<Aircraft_Type_Designators_Obj_Rel_Insert_Input>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Current_Air_Traffic_Proximity_Recordings_Max_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_max_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Max_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Current_Air_Traffic_Proximity_Recordings_Min_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_min_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Min_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** response of any mutation on the table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Mutation_Response = {
  __typename?: 'current_air_traffic_proximity_recordings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Current_Air_Traffic_Proximity_Recordings>;
};

/** input type for inserting object relation for remote table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Obj_Rel_Insert_Input = {
  data: Current_Air_Traffic_Proximity_Recordings_Insert_Input;
};

/** ordering options when selecting data from "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  aircraft_type_designator?: Maybe<Aircraft_Type_Designators_Order_By>;
  alt_meters?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** select columns of table "current_air_traffic_proximity_recordings" */
export enum Current_Air_Traffic_Proximity_Recordings_Select_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugData = 'debug_data',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMetersPerSecond = 'groundspeed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegrees = 'lat_degrees',
  /** column name */
  LonDegrees = 'lon_degrees',
  /** column name */
  ProximityLevel = 'proximity_level',
  /** column name */
  RelativeAltitudeMeters = 'relative_altitude_meters',
  /** column name */
  RelativeDistanceMeters = 'relative_distance_meters',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSeconds = 'timestamp_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  VehicleStatusTimestampSeconds = 'vehicle_status_timestamp_seconds'
}

/** input type for updating data in table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Set_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Current_Air_Traffic_Proximity_Recordings_Stddev_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_stddev_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Stddev_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Current_Air_Traffic_Proximity_Recordings_Stddev_Pop_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_stddev_pop_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Stddev_Pop_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Current_Air_Traffic_Proximity_Recordings_Stddev_Samp_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_stddev_samp_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Stddev_Samp_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Current_Air_Traffic_Proximity_Recordings_Sum_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_sum_fields';
  alt_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Sum_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Current_Air_Traffic_Proximity_Recordings_Var_Pop_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_var_pop_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Var_Pop_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Current_Air_Traffic_Proximity_Recordings_Var_Samp_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_var_samp_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Var_Samp_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Current_Air_Traffic_Proximity_Recordings_Variance_Fields = {
  __typename?: 'current_air_traffic_proximity_recordings_variance_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "current_air_traffic_proximity_recordings" */
export type Current_Air_Traffic_Proximity_Recordings_Variance_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** columns and relationships of "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks = {
  __typename?: 'current_air_traffic_tracks';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  /** An object relationship */
  type_designator?: Maybe<Aircraft_Type_Designators>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Aggregate = {
  __typename?: 'current_air_traffic_tracks_aggregate';
  aggregate?: Maybe<Current_Air_Traffic_Tracks_Aggregate_Fields>;
  nodes: Array<Current_Air_Traffic_Tracks>;
};

/** aggregate fields of "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Aggregate_Fields = {
  __typename?: 'current_air_traffic_tracks_aggregate_fields';
  avg?: Maybe<Current_Air_Traffic_Tracks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Current_Air_Traffic_Tracks_Max_Fields>;
  min?: Maybe<Current_Air_Traffic_Tracks_Min_Fields>;
  stddev?: Maybe<Current_Air_Traffic_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Current_Air_Traffic_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Current_Air_Traffic_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Current_Air_Traffic_Tracks_Sum_Fields>;
  var_pop?: Maybe<Current_Air_Traffic_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Current_Air_Traffic_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Current_Air_Traffic_Tracks_Variance_Fields>;
};


/** aggregate fields of "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Current_Air_Traffic_Tracks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Aggregate_Order_By = {
  avg?: Maybe<Current_Air_Traffic_Tracks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Current_Air_Traffic_Tracks_Max_Order_By>;
  min?: Maybe<Current_Air_Traffic_Tracks_Min_Order_By>;
  stddev?: Maybe<Current_Air_Traffic_Tracks_Stddev_Order_By>;
  stddev_pop?: Maybe<Current_Air_Traffic_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Current_Air_Traffic_Tracks_Stddev_Samp_Order_By>;
  sum?: Maybe<Current_Air_Traffic_Tracks_Sum_Order_By>;
  var_pop?: Maybe<Current_Air_Traffic_Tracks_Var_Pop_Order_By>;
  var_samp?: Maybe<Current_Air_Traffic_Tracks_Var_Samp_Order_By>;
  variance?: Maybe<Current_Air_Traffic_Tracks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Arr_Rel_Insert_Input = {
  data: Array<Current_Air_Traffic_Tracks_Insert_Input>;
};

/** aggregate avg on columns */
export type Current_Air_Traffic_Tracks_Avg_Fields = {
  __typename?: 'current_air_traffic_tracks_avg_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Avg_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "current_air_traffic_tracks". All fields are combined with a logical 'AND'. */
export type Current_Air_Traffic_Tracks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Current_Air_Traffic_Tracks_Bool_Exp>>>;
  _not?: Maybe<Current_Air_Traffic_Tracks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Current_Air_Traffic_Tracks_Bool_Exp>>>;
  aircraft_type?: Maybe<String_Comparison_Exp>;
  alt_m?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  groundspeed_mps?: Maybe<Float8_Comparison_Exp>;
  heading_degs?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  type_designator?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** input type for incrementing integer column in table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Inc_Input = {
  alt_m?: Maybe<Scalars['float8']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Insert_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  type_designator?: Maybe<Aircraft_Type_Designators_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Current_Air_Traffic_Tracks_Max_Fields = {
  __typename?: 'current_air_traffic_tracks_max_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Max_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Current_Air_Traffic_Tracks_Min_Fields = {
  __typename?: 'current_air_traffic_tracks_min_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Min_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Mutation_Response = {
  __typename?: 'current_air_traffic_tracks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Current_Air_Traffic_Tracks>;
};

/** input type for inserting object relation for remote table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Obj_Rel_Insert_Input = {
  data: Current_Air_Traffic_Tracks_Insert_Input;
};

/** ordering options when selecting data from "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  type_designator?: Maybe<Aircraft_Type_Designators_Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "current_air_traffic_tracks" */
export enum Current_Air_Traffic_Tracks_Select_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltM = 'alt_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDegs = 'heading_degs',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Set_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Current_Air_Traffic_Tracks_Stddev_Fields = {
  __typename?: 'current_air_traffic_tracks_stddev_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Stddev_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Current_Air_Traffic_Tracks_Stddev_Pop_Fields = {
  __typename?: 'current_air_traffic_tracks_stddev_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Stddev_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Current_Air_Traffic_Tracks_Stddev_Samp_Fields = {
  __typename?: 'current_air_traffic_tracks_stddev_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Stddev_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Current_Air_Traffic_Tracks_Sum_Fields = {
  __typename?: 'current_air_traffic_tracks_sum_fields';
  alt_m?: Maybe<Scalars['float8']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Sum_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Current_Air_Traffic_Tracks_Var_Pop_Fields = {
  __typename?: 'current_air_traffic_tracks_var_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Var_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Current_Air_Traffic_Tracks_Var_Samp_Fields = {
  __typename?: 'current_air_traffic_tracks_var_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Var_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Current_Air_Traffic_Tracks_Variance_Fields = {
  __typename?: 'current_air_traffic_tracks_variance_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "current_air_traffic_tracks" */
export type Current_Air_Traffic_Tracks_Variance_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks = {
  __typename?: 'current_utm_air_traffic_tracks';
  aircraft_type?: Maybe<Scalars['String']>;
  aircraft_type_icon_name?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Aggregate = {
  __typename?: 'current_utm_air_traffic_tracks_aggregate';
  aggregate?: Maybe<Current_Utm_Air_Traffic_Tracks_Aggregate_Fields>;
  nodes: Array<Current_Utm_Air_Traffic_Tracks>;
};

/** aggregate fields of "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Aggregate_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_aggregate_fields';
  avg?: Maybe<Current_Utm_Air_Traffic_Tracks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Current_Utm_Air_Traffic_Tracks_Max_Fields>;
  min?: Maybe<Current_Utm_Air_Traffic_Tracks_Min_Fields>;
  stddev?: Maybe<Current_Utm_Air_Traffic_Tracks_Stddev_Fields>;
  stddev_pop?: Maybe<Current_Utm_Air_Traffic_Tracks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Current_Utm_Air_Traffic_Tracks_Stddev_Samp_Fields>;
  sum?: Maybe<Current_Utm_Air_Traffic_Tracks_Sum_Fields>;
  var_pop?: Maybe<Current_Utm_Air_Traffic_Tracks_Var_Pop_Fields>;
  var_samp?: Maybe<Current_Utm_Air_Traffic_Tracks_Var_Samp_Fields>;
  variance?: Maybe<Current_Utm_Air_Traffic_Tracks_Variance_Fields>;
};


/** aggregate fields of "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Aggregate_Order_By = {
  avg?: Maybe<Current_Utm_Air_Traffic_Tracks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Current_Utm_Air_Traffic_Tracks_Max_Order_By>;
  min?: Maybe<Current_Utm_Air_Traffic_Tracks_Min_Order_By>;
  stddev?: Maybe<Current_Utm_Air_Traffic_Tracks_Stddev_Order_By>;
  stddev_pop?: Maybe<Current_Utm_Air_Traffic_Tracks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Current_Utm_Air_Traffic_Tracks_Stddev_Samp_Order_By>;
  sum?: Maybe<Current_Utm_Air_Traffic_Tracks_Sum_Order_By>;
  var_pop?: Maybe<Current_Utm_Air_Traffic_Tracks_Var_Pop_Order_By>;
  var_samp?: Maybe<Current_Utm_Air_Traffic_Tracks_Var_Samp_Order_By>;
  variance?: Maybe<Current_Utm_Air_Traffic_Tracks_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Current_Utm_Air_Traffic_Tracks_Avg_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_avg_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Avg_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "current_utm_air_traffic_tracks". All fields are combined with a logical 'AND'. */
export type Current_Utm_Air_Traffic_Tracks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>>>;
  _not?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>>>;
  aircraft_type?: Maybe<String_Comparison_Exp>;
  aircraft_type_icon_name?: Maybe<String_Comparison_Exp>;
  alt_m?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  groundspeed_mps?: Maybe<Float8_Comparison_Exp>;
  heading_degs?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Current_Utm_Air_Traffic_Tracks_Max_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_max_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  aircraft_type_icon_name?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Max_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  aircraft_type_icon_name?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Current_Utm_Air_Traffic_Tracks_Min_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_min_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  aircraft_type_icon_name?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Min_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  aircraft_type_icon_name?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** ordering options when selecting data from "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  aircraft_type_icon_name?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** select columns of table "current_utm_air_traffic_tracks" */
export enum Current_Utm_Air_Traffic_Tracks_Select_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AircraftTypeIconName = 'aircraft_type_icon_name',
  /** column name */
  AltM = 'alt_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDegs = 'heading_degs',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Current_Utm_Air_Traffic_Tracks_Stddev_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_stddev_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Stddev_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Current_Utm_Air_Traffic_Tracks_Stddev_Pop_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_stddev_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Stddev_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Current_Utm_Air_Traffic_Tracks_Stddev_Samp_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_stddev_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Stddev_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Current_Utm_Air_Traffic_Tracks_Sum_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_sum_fields';
  alt_m?: Maybe<Scalars['float8']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Sum_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Current_Utm_Air_Traffic_Tracks_Var_Pop_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_var_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Var_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Current_Utm_Air_Traffic_Tracks_Var_Samp_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_var_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Var_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Current_Utm_Air_Traffic_Tracks_Variance_Fields = {
  __typename?: 'current_utm_air_traffic_tracks_variance_fields';
  alt_m?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "current_utm_air_traffic_tracks" */
export type Current_Utm_Air_Traffic_Tracks_Variance_Order_By = {
  alt_m?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "daa_observations" */
export type Daa_Observations = {
  __typename?: 'daa_observations';
  alert_level?: Maybe<Scalars['String']>;
  /** Altitude of the observation in meters */
  altitude_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** @Deprecated: Do not use! */
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  /** @Deprecated: Do not use! */
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan: Flight_Plans;
  flight_plan_id: Scalars['Int'];
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  /** Flag denoting if observation is in within lookahead time */
  in_lookahead: Scalars['Boolean'];
  /** 2D coordinate of the observation (lat, lon) */
  observation_coord?: Maybe<Scalars['geometry']>;
  observation_id: Scalars['String'];
  observation_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  observation_type_info?: Maybe<Aircraft_Type_Designators>;
  /** An array relationship */
  predicted_conflicts: Array<Predicted_Conflicts>;
  /** An aggregated array relationship */
  predicted_conflicts_aggregate: Predicted_Conflicts_Aggregate;
  source: Scalars['String'];
  /** @Deprecated: Time to leaving each alert band */
  time_to_violations_in?: Maybe<Scalars['jsonb']>;
  /** @Deprecated: Time to leaving each alert band */
  time_to_violations_out?: Maybe<Scalars['jsonb']>;
  timestamp_formatted: Scalars['timestamptz'];
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
  vehicle_serial_number: Scalars['String'];
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};


/** columns and relationships of "daa_observations" */
export type Daa_ObservationsPredicted_ConflictsArgs = {
  distinct_on?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Predicted_Conflicts_Order_By>>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};


/** columns and relationships of "daa_observations" */
export type Daa_ObservationsPredicted_Conflicts_AggregateArgs = {
  distinct_on?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Predicted_Conflicts_Order_By>>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};


/** columns and relationships of "daa_observations" */
export type Daa_ObservationsTime_To_Violations_InArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "daa_observations" */
export type Daa_ObservationsTime_To_Violations_OutArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "daa_observations" */
export type Daa_Observations_Aggregate = {
  __typename?: 'daa_observations_aggregate';
  aggregate?: Maybe<Daa_Observations_Aggregate_Fields>;
  nodes: Array<Daa_Observations>;
};

/** aggregate fields of "daa_observations" */
export type Daa_Observations_Aggregate_Fields = {
  __typename?: 'daa_observations_aggregate_fields';
  avg?: Maybe<Daa_Observations_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Daa_Observations_Max_Fields>;
  min?: Maybe<Daa_Observations_Min_Fields>;
  stddev?: Maybe<Daa_Observations_Stddev_Fields>;
  stddev_pop?: Maybe<Daa_Observations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daa_Observations_Stddev_Samp_Fields>;
  sum?: Maybe<Daa_Observations_Sum_Fields>;
  var_pop?: Maybe<Daa_Observations_Var_Pop_Fields>;
  var_samp?: Maybe<Daa_Observations_Var_Samp_Fields>;
  variance?: Maybe<Daa_Observations_Variance_Fields>;
};


/** aggregate fields of "daa_observations" */
export type Daa_Observations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Daa_Observations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "daa_observations" */
export type Daa_Observations_Aggregate_Order_By = {
  avg?: Maybe<Daa_Observations_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Daa_Observations_Max_Order_By>;
  min?: Maybe<Daa_Observations_Min_Order_By>;
  stddev?: Maybe<Daa_Observations_Stddev_Order_By>;
  stddev_pop?: Maybe<Daa_Observations_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Daa_Observations_Stddev_Samp_Order_By>;
  sum?: Maybe<Daa_Observations_Sum_Order_By>;
  var_pop?: Maybe<Daa_Observations_Var_Pop_Order_By>;
  var_samp?: Maybe<Daa_Observations_Var_Samp_Order_By>;
  variance?: Maybe<Daa_Observations_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Daa_Observations_Append_Input = {
  time_to_violations_in?: Maybe<Scalars['jsonb']>;
  time_to_violations_out?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "daa_observations" */
export type Daa_Observations_Arr_Rel_Insert_Input = {
  data: Array<Daa_Observations_Insert_Input>;
  on_conflict?: Maybe<Daa_Observations_On_Conflict>;
};

/** aggregate avg on columns */
export type Daa_Observations_Avg_Fields = {
  __typename?: 'daa_observations_avg_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "daa_observations" */
export type Daa_Observations_Avg_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "daa_observations". All fields are combined with a logical 'AND'. */
export type Daa_Observations_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Daa_Observations_Bool_Exp>>>;
  _not?: Maybe<Daa_Observations_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Daa_Observations_Bool_Exp>>>;
  alert_level?: Maybe<String_Comparison_Exp>;
  altitude_m?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  current_horizontal_separation_m?: Maybe<Float8_Comparison_Exp>;
  current_vertical_separation_m?: Maybe<Float8_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  groundspeed_mps?: Maybe<Float8_Comparison_Exp>;
  heading_deg?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  in_lookahead?: Maybe<Boolean_Comparison_Exp>;
  observation_coord?: Maybe<Geometry_Comparison_Exp>;
  observation_id?: Maybe<String_Comparison_Exp>;
  observation_type?: Maybe<String_Comparison_Exp>;
  observation_type_info?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
  predicted_conflicts?: Maybe<Predicted_Conflicts_Bool_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  time_to_violations_in?: Maybe<Jsonb_Comparison_Exp>;
  time_to_violations_out?: Maybe<Jsonb_Comparison_Exp>;
  timestamp_formatted?: Maybe<Timestamptz_Comparison_Exp>;
  timestamp_source_utc_secs?: Maybe<Float8_Comparison_Exp>;
  timestamp_utc_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
  vertical_velocity_mps?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "daa_observations" */
export enum Daa_Observations_Constraint {
  /** unique or primary key constraint */
  DaaObservationsPkey = 'daa_observations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Daa_Observations_Delete_At_Path_Input = {
  time_to_violations_in?: Maybe<Array<Maybe<Scalars['String']>>>;
  time_to_violations_out?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Daa_Observations_Delete_Elem_Input = {
  time_to_violations_in?: Maybe<Scalars['Int']>;
  time_to_violations_out?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Daa_Observations_Delete_Key_Input = {
  time_to_violations_in?: Maybe<Scalars['String']>;
  time_to_violations_out?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "daa_observations" */
export type Daa_Observations_Inc_Input = {
  altitude_m?: Maybe<Scalars['float8']>;
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "daa_observations" */
export type Daa_Observations_Insert_Input = {
  alert_level?: Maybe<Scalars['String']>;
  altitude_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  in_lookahead?: Maybe<Scalars['Boolean']>;
  observation_coord?: Maybe<Scalars['geometry']>;
  observation_id?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  observation_type_info?: Maybe<Aircraft_Type_Designators_Obj_Rel_Insert_Input>;
  predicted_conflicts?: Maybe<Predicted_Conflicts_Arr_Rel_Insert_Input>;
  source?: Maybe<Scalars['String']>;
  time_to_violations_in?: Maybe<Scalars['jsonb']>;
  time_to_violations_out?: Maybe<Scalars['jsonb']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Daa_Observations_Max_Fields = {
  __typename?: 'daa_observations_max_fields';
  alert_level?: Maybe<Scalars['String']>;
  altitude_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "daa_observations" */
export type Daa_Observations_Max_Order_By = {
  alert_level?: Maybe<Order_By>;
  altitude_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  observation_id?: Maybe<Order_By>;
  observation_type?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_formatted?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Daa_Observations_Min_Fields = {
  __typename?: 'daa_observations_min_fields';
  alert_level?: Maybe<Scalars['String']>;
  altitude_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  observation_id?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "daa_observations" */
export type Daa_Observations_Min_Order_By = {
  alert_level?: Maybe<Order_By>;
  altitude_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  observation_id?: Maybe<Order_By>;
  observation_type?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_formatted?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** response of any mutation on the table "daa_observations" */
export type Daa_Observations_Mutation_Response = {
  __typename?: 'daa_observations_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Daa_Observations>;
};

/** input type for inserting object relation for remote table "daa_observations" */
export type Daa_Observations_Obj_Rel_Insert_Input = {
  data: Daa_Observations_Insert_Input;
  on_conflict?: Maybe<Daa_Observations_On_Conflict>;
};

/** on conflict condition type for table "daa_observations" */
export type Daa_Observations_On_Conflict = {
  constraint: Daa_Observations_Constraint;
  update_columns: Array<Daa_Observations_Update_Column>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};

/** ordering options when selecting data from "daa_observations" */
export type Daa_Observations_Order_By = {
  alert_level?: Maybe<Order_By>;
  altitude_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  in_lookahead?: Maybe<Order_By>;
  observation_coord?: Maybe<Order_By>;
  observation_id?: Maybe<Order_By>;
  observation_type?: Maybe<Order_By>;
  observation_type_info?: Maybe<Aircraft_Type_Designators_Order_By>;
  predicted_conflicts_aggregate?: Maybe<Predicted_Conflicts_Aggregate_Order_By>;
  source?: Maybe<Order_By>;
  time_to_violations_in?: Maybe<Order_By>;
  time_to_violations_out?: Maybe<Order_By>;
  timestamp_formatted?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** primary key columns input for table: "daa_observations" */
export type Daa_Observations_Pk_Columns_Input = {
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Daa_Observations_Prepend_Input = {
  time_to_violations_in?: Maybe<Scalars['jsonb']>;
  time_to_violations_out?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "daa_observations" */
export enum Daa_Observations_Select_Column {
  /** column name */
  AlertLevel = 'alert_level',
  /** column name */
  AltitudeM = 'altitude_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentHorizontalSeparationM = 'current_horizontal_separation_m',
  /** column name */
  CurrentVerticalSeparationM = 'current_vertical_separation_m',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDeg = 'heading_deg',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  InLookahead = 'in_lookahead',
  /** column name */
  ObservationCoord = 'observation_coord',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  ObservationType = 'observation_type',
  /** column name */
  Source = 'source',
  /** column name */
  TimeToViolationsIn = 'time_to_violations_in',
  /** column name */
  TimeToViolationsOut = 'time_to_violations_out',
  /** column name */
  TimestampFormatted = 'timestamp_formatted',
  /** column name */
  TimestampSourceUtcSecs = 'timestamp_source_utc_secs',
  /** column name */
  TimestampUtcSecs = 'timestamp_utc_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  VerticalVelocityMps = 'vertical_velocity_mps'
}

/** input type for updating data in table "daa_observations" */
export type Daa_Observations_Set_Input = {
  alert_level?: Maybe<Scalars['String']>;
  altitude_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  in_lookahead?: Maybe<Scalars['Boolean']>;
  observation_coord?: Maybe<Scalars['geometry']>;
  observation_id?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  time_to_violations_in?: Maybe<Scalars['jsonb']>;
  time_to_violations_out?: Maybe<Scalars['jsonb']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Daa_Observations_Stddev_Fields = {
  __typename?: 'daa_observations_stddev_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "daa_observations" */
export type Daa_Observations_Stddev_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Daa_Observations_Stddev_Pop_Fields = {
  __typename?: 'daa_observations_stddev_pop_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "daa_observations" */
export type Daa_Observations_Stddev_Pop_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Daa_Observations_Stddev_Samp_Fields = {
  __typename?: 'daa_observations_stddev_samp_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "daa_observations" */
export type Daa_Observations_Stddev_Samp_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Daa_Observations_Sum_Fields = {
  __typename?: 'daa_observations_sum_fields';
  altitude_m?: Maybe<Scalars['float8']>;
  current_horizontal_separation_m?: Maybe<Scalars['float8']>;
  current_vertical_separation_m?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_deg?: Maybe<Scalars['float8']>;
  timestamp_source_utc_secs?: Maybe<Scalars['float8']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  vertical_velocity_mps?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "daa_observations" */
export type Daa_Observations_Sum_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** update columns of table "daa_observations" */
export enum Daa_Observations_Update_Column {
  /** column name */
  AlertLevel = 'alert_level',
  /** column name */
  AltitudeM = 'altitude_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentHorizontalSeparationM = 'current_horizontal_separation_m',
  /** column name */
  CurrentVerticalSeparationM = 'current_vertical_separation_m',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDeg = 'heading_deg',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  InLookahead = 'in_lookahead',
  /** column name */
  ObservationCoord = 'observation_coord',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  ObservationType = 'observation_type',
  /** column name */
  Source = 'source',
  /** column name */
  TimeToViolationsIn = 'time_to_violations_in',
  /** column name */
  TimeToViolationsOut = 'time_to_violations_out',
  /** column name */
  TimestampFormatted = 'timestamp_formatted',
  /** column name */
  TimestampSourceUtcSecs = 'timestamp_source_utc_secs',
  /** column name */
  TimestampUtcSecs = 'timestamp_utc_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  VerticalVelocityMps = 'vertical_velocity_mps'
}

/** aggregate var_pop on columns */
export type Daa_Observations_Var_Pop_Fields = {
  __typename?: 'daa_observations_var_pop_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "daa_observations" */
export type Daa_Observations_Var_Pop_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Daa_Observations_Var_Samp_Fields = {
  __typename?: 'daa_observations_var_samp_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "daa_observations" */
export type Daa_Observations_Var_Samp_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Daa_Observations_Variance_Fields = {
  __typename?: 'daa_observations_variance_fields';
  altitude_m?: Maybe<Scalars['Float']>;
  current_horizontal_separation_m?: Maybe<Scalars['Float']>;
  current_vertical_separation_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_deg?: Maybe<Scalars['Float']>;
  timestamp_source_utc_secs?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
  vertical_velocity_mps?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "daa_observations" */
export type Daa_Observations_Variance_Order_By = {
  altitude_m?: Maybe<Order_By>;
  current_horizontal_separation_m?: Maybe<Order_By>;
  current_vertical_separation_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_deg?: Maybe<Order_By>;
  timestamp_source_utc_secs?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  vertical_velocity_mps?: Maybe<Order_By>;
};

/** columns and relationships of "daa_statuses" */
export type Daa_Statuses = {
  __typename?: 'daa_statuses';
  /** @Deprecated: The alert bands and their corresponding dimensions */
  alert_bands?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan: Flight_Plans;
  flight_plan_id: Scalars['Int'];
  maneuver_path?: Maybe<Scalars['geometry']>;
  maneuver_type: Scalars['String'];
  timestamp_formatted: Scalars['timestamptz'];
  timestamp_utc_secs: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
  vehicle_serial_number: Scalars['String'];
  well_clear_status: Scalars['Boolean'];
};


/** columns and relationships of "daa_statuses" */
export type Daa_StatusesAlert_BandsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "daa_statuses" */
export type Daa_Statuses_Aggregate = {
  __typename?: 'daa_statuses_aggregate';
  aggregate?: Maybe<Daa_Statuses_Aggregate_Fields>;
  nodes: Array<Daa_Statuses>;
};

/** aggregate fields of "daa_statuses" */
export type Daa_Statuses_Aggregate_Fields = {
  __typename?: 'daa_statuses_aggregate_fields';
  avg?: Maybe<Daa_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Daa_Statuses_Max_Fields>;
  min?: Maybe<Daa_Statuses_Min_Fields>;
  stddev?: Maybe<Daa_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Daa_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Daa_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Daa_Statuses_Sum_Fields>;
  var_pop?: Maybe<Daa_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Daa_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Daa_Statuses_Variance_Fields>;
};


/** aggregate fields of "daa_statuses" */
export type Daa_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Daa_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "daa_statuses" */
export type Daa_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Daa_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Daa_Statuses_Max_Order_By>;
  min?: Maybe<Daa_Statuses_Min_Order_By>;
  stddev?: Maybe<Daa_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Daa_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Daa_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Daa_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Daa_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Daa_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Daa_Statuses_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Daa_Statuses_Append_Input = {
  alert_bands?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "daa_statuses" */
export type Daa_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Daa_Statuses_Insert_Input>;
  on_conflict?: Maybe<Daa_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Daa_Statuses_Avg_Fields = {
  __typename?: 'daa_statuses_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "daa_statuses" */
export type Daa_Statuses_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "daa_statuses". All fields are combined with a logical 'AND'. */
export type Daa_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Daa_Statuses_Bool_Exp>>>;
  _not?: Maybe<Daa_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Daa_Statuses_Bool_Exp>>>;
  alert_bands?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  maneuver_path?: Maybe<Geometry_Comparison_Exp>;
  maneuver_type?: Maybe<String_Comparison_Exp>;
  timestamp_formatted?: Maybe<Timestamptz_Comparison_Exp>;
  timestamp_utc_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
  well_clear_status?: Maybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "daa_statuses" */
export enum Daa_Statuses_Constraint {
  /** unique or primary key constraint */
  DaaStatusesPkey = 'daa_statuses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Daa_Statuses_Delete_At_Path_Input = {
  alert_bands?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Daa_Statuses_Delete_Elem_Input = {
  alert_bands?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Daa_Statuses_Delete_Key_Input = {
  alert_bands?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "daa_statuses" */
export type Daa_Statuses_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "daa_statuses" */
export type Daa_Statuses_Insert_Input = {
  alert_bands?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  maneuver_path?: Maybe<Scalars['geometry']>;
  maneuver_type?: Maybe<Scalars['String']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  well_clear_status?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Daa_Statuses_Max_Fields = {
  __typename?: 'daa_statuses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  maneuver_type?: Maybe<Scalars['String']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "daa_statuses" */
export type Daa_Statuses_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  maneuver_type?: Maybe<Order_By>;
  timestamp_formatted?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Daa_Statuses_Min_Fields = {
  __typename?: 'daa_statuses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  maneuver_type?: Maybe<Scalars['String']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "daa_statuses" */
export type Daa_Statuses_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  maneuver_type?: Maybe<Order_By>;
  timestamp_formatted?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** response of any mutation on the table "daa_statuses" */
export type Daa_Statuses_Mutation_Response = {
  __typename?: 'daa_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Daa_Statuses>;
};

/** input type for inserting object relation for remote table "daa_statuses" */
export type Daa_Statuses_Obj_Rel_Insert_Input = {
  data: Daa_Statuses_Insert_Input;
  on_conflict?: Maybe<Daa_Statuses_On_Conflict>;
};

/** on conflict condition type for table "daa_statuses" */
export type Daa_Statuses_On_Conflict = {
  constraint: Daa_Statuses_Constraint;
  update_columns: Array<Daa_Statuses_Update_Column>;
  where?: Maybe<Daa_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "daa_statuses" */
export type Daa_Statuses_Order_By = {
  alert_bands?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  maneuver_path?: Maybe<Order_By>;
  maneuver_type?: Maybe<Order_By>;
  timestamp_formatted?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  well_clear_status?: Maybe<Order_By>;
};

/** primary key columns input for table: "daa_statuses" */
export type Daa_Statuses_Pk_Columns_Input = {
  vehicle_serial_number: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Daa_Statuses_Prepend_Input = {
  alert_bands?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "daa_statuses" */
export enum Daa_Statuses_Select_Column {
  /** column name */
  AlertBands = 'alert_bands',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  ManeuverPath = 'maneuver_path',
  /** column name */
  ManeuverType = 'maneuver_type',
  /** column name */
  TimestampFormatted = 'timestamp_formatted',
  /** column name */
  TimestampUtcSecs = 'timestamp_utc_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  WellClearStatus = 'well_clear_status'
}

/** input type for updating data in table "daa_statuses" */
export type Daa_Statuses_Set_Input = {
  alert_bands?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  maneuver_path?: Maybe<Scalars['geometry']>;
  maneuver_type?: Maybe<Scalars['String']>;
  timestamp_formatted?: Maybe<Scalars['timestamptz']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  well_clear_status?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Daa_Statuses_Stddev_Fields = {
  __typename?: 'daa_statuses_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "daa_statuses" */
export type Daa_Statuses_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Daa_Statuses_Stddev_Pop_Fields = {
  __typename?: 'daa_statuses_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "daa_statuses" */
export type Daa_Statuses_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Daa_Statuses_Stddev_Samp_Fields = {
  __typename?: 'daa_statuses_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "daa_statuses" */
export type Daa_Statuses_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Daa_Statuses_Sum_Fields = {
  __typename?: 'daa_statuses_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_utc_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "daa_statuses" */
export type Daa_Statuses_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** update columns of table "daa_statuses" */
export enum Daa_Statuses_Update_Column {
  /** column name */
  AlertBands = 'alert_bands',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  ManeuverPath = 'maneuver_path',
  /** column name */
  ManeuverType = 'maneuver_type',
  /** column name */
  TimestampFormatted = 'timestamp_formatted',
  /** column name */
  TimestampUtcSecs = 'timestamp_utc_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  WellClearStatus = 'well_clear_status'
}

/** aggregate var_pop on columns */
export type Daa_Statuses_Var_Pop_Fields = {
  __typename?: 'daa_statuses_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "daa_statuses" */
export type Daa_Statuses_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Daa_Statuses_Var_Samp_Fields = {
  __typename?: 'daa_statuses_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "daa_statuses" */
export type Daa_Statuses_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Daa_Statuses_Variance_Fields = {
  __typename?: 'daa_statuses_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_utc_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "daa_statuses" */
export type Daa_Statuses_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_utc_secs?: Maybe<Order_By>;
};


/** expression to compare columns of type date. All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

/** columns and relationships of "env_feature_flags" */
export type Env_Feature_Flags = {
  __typename?: 'env_feature_flags';
  /** Whether the feature is enabled */
  enabled: Scalars['Boolean'];
  /** Name of the feature */
  feature_name: Scalars['String'];
  /** Hasura domain for the environment */
  hasura_domain: Scalars['String'];
  id: Scalars['Int'];
};

/** aggregated selection of "env_feature_flags" */
export type Env_Feature_Flags_Aggregate = {
  __typename?: 'env_feature_flags_aggregate';
  aggregate?: Maybe<Env_Feature_Flags_Aggregate_Fields>;
  nodes: Array<Env_Feature_Flags>;
};

/** aggregate fields of "env_feature_flags" */
export type Env_Feature_Flags_Aggregate_Fields = {
  __typename?: 'env_feature_flags_aggregate_fields';
  avg?: Maybe<Env_Feature_Flags_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Env_Feature_Flags_Max_Fields>;
  min?: Maybe<Env_Feature_Flags_Min_Fields>;
  stddev?: Maybe<Env_Feature_Flags_Stddev_Fields>;
  stddev_pop?: Maybe<Env_Feature_Flags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Env_Feature_Flags_Stddev_Samp_Fields>;
  sum?: Maybe<Env_Feature_Flags_Sum_Fields>;
  var_pop?: Maybe<Env_Feature_Flags_Var_Pop_Fields>;
  var_samp?: Maybe<Env_Feature_Flags_Var_Samp_Fields>;
  variance?: Maybe<Env_Feature_Flags_Variance_Fields>;
};


/** aggregate fields of "env_feature_flags" */
export type Env_Feature_Flags_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Env_Feature_Flags_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "env_feature_flags" */
export type Env_Feature_Flags_Aggregate_Order_By = {
  avg?: Maybe<Env_Feature_Flags_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Env_Feature_Flags_Max_Order_By>;
  min?: Maybe<Env_Feature_Flags_Min_Order_By>;
  stddev?: Maybe<Env_Feature_Flags_Stddev_Order_By>;
  stddev_pop?: Maybe<Env_Feature_Flags_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Env_Feature_Flags_Stddev_Samp_Order_By>;
  sum?: Maybe<Env_Feature_Flags_Sum_Order_By>;
  var_pop?: Maybe<Env_Feature_Flags_Var_Pop_Order_By>;
  var_samp?: Maybe<Env_Feature_Flags_Var_Samp_Order_By>;
  variance?: Maybe<Env_Feature_Flags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "env_feature_flags" */
export type Env_Feature_Flags_Arr_Rel_Insert_Input = {
  data: Array<Env_Feature_Flags_Insert_Input>;
  on_conflict?: Maybe<Env_Feature_Flags_On_Conflict>;
};

/** aggregate avg on columns */
export type Env_Feature_Flags_Avg_Fields = {
  __typename?: 'env_feature_flags_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Avg_Order_By = {
  id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "env_feature_flags". All fields are combined with a logical 'AND'. */
export type Env_Feature_Flags_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Env_Feature_Flags_Bool_Exp>>>;
  _not?: Maybe<Env_Feature_Flags_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Env_Feature_Flags_Bool_Exp>>>;
  enabled?: Maybe<Boolean_Comparison_Exp>;
  feature_name?: Maybe<String_Comparison_Exp>;
  hasura_domain?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "env_feature_flags" */
export enum Env_Feature_Flags_Constraint {
  /** unique or primary key constraint */
  EnvFeatureFlagsFeatureNameHasuraDomainUk = 'env_feature_flags_feature_name_hasura_domain_uk',
  /** unique or primary key constraint */
  EnvFeatureFlagsPkey = 'env_feature_flags_pkey'
}

/** input type for incrementing integer column in table "env_feature_flags" */
export type Env_Feature_Flags_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "env_feature_flags" */
export type Env_Feature_Flags_Insert_Input = {
  enabled?: Maybe<Scalars['Boolean']>;
  feature_name?: Maybe<Scalars['String']>;
  hasura_domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Env_Feature_Flags_Max_Fields = {
  __typename?: 'env_feature_flags_max_fields';
  feature_name?: Maybe<Scalars['String']>;
  hasura_domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Max_Order_By = {
  feature_name?: Maybe<Order_By>;
  hasura_domain?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Env_Feature_Flags_Min_Fields = {
  __typename?: 'env_feature_flags_min_fields';
  feature_name?: Maybe<Scalars['String']>;
  hasura_domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Min_Order_By = {
  feature_name?: Maybe<Order_By>;
  hasura_domain?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** response of any mutation on the table "env_feature_flags" */
export type Env_Feature_Flags_Mutation_Response = {
  __typename?: 'env_feature_flags_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Env_Feature_Flags>;
};

/** input type for inserting object relation for remote table "env_feature_flags" */
export type Env_Feature_Flags_Obj_Rel_Insert_Input = {
  data: Env_Feature_Flags_Insert_Input;
  on_conflict?: Maybe<Env_Feature_Flags_On_Conflict>;
};

/** on conflict condition type for table "env_feature_flags" */
export type Env_Feature_Flags_On_Conflict = {
  constraint: Env_Feature_Flags_Constraint;
  update_columns: Array<Env_Feature_Flags_Update_Column>;
  where?: Maybe<Env_Feature_Flags_Bool_Exp>;
};

/** ordering options when selecting data from "env_feature_flags" */
export type Env_Feature_Flags_Order_By = {
  enabled?: Maybe<Order_By>;
  feature_name?: Maybe<Order_By>;
  hasura_domain?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
};

/** primary key columns input for table: "env_feature_flags" */
export type Env_Feature_Flags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "env_feature_flags" */
export enum Env_Feature_Flags_Select_Column {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FeatureName = 'feature_name',
  /** column name */
  HasuraDomain = 'hasura_domain',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "env_feature_flags" */
export type Env_Feature_Flags_Set_Input = {
  enabled?: Maybe<Scalars['Boolean']>;
  feature_name?: Maybe<Scalars['String']>;
  hasura_domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Env_Feature_Flags_Stddev_Fields = {
  __typename?: 'env_feature_flags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Stddev_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Env_Feature_Flags_Stddev_Pop_Fields = {
  __typename?: 'env_feature_flags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Env_Feature_Flags_Stddev_Samp_Fields = {
  __typename?: 'env_feature_flags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Env_Feature_Flags_Sum_Fields = {
  __typename?: 'env_feature_flags_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Sum_Order_By = {
  id?: Maybe<Order_By>;
};

/** update columns of table "env_feature_flags" */
export enum Env_Feature_Flags_Update_Column {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FeatureName = 'feature_name',
  /** column name */
  HasuraDomain = 'hasura_domain',
  /** column name */
  Id = 'id'
}

/** aggregate var_pop on columns */
export type Env_Feature_Flags_Var_Pop_Fields = {
  __typename?: 'env_feature_flags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Env_Feature_Flags_Var_Samp_Fields = {
  __typename?: 'env_feature_flags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Env_Feature_Flags_Variance_Fields = {
  __typename?: 'env_feature_flags_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "env_feature_flags" */
export type Env_Feature_Flags_Variance_Order_By = {
  id?: Maybe<Order_By>;
};

export type Fetch_Current_Deduped_Air_Traffic_Tracks_Args = {
  maxsecondsold?: Maybe<Scalars['Int']>;
  searchpolygon?: Maybe<Scalars['String']>;
  vehicleserialnumber?: Maybe<Scalars['String']>;
};

/** columns and relationships of "file_asset_types" */
export type File_Asset_Types = {
  __typename?: 'file_asset_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "file_asset_types" */
export type File_Asset_Types_Aggregate = {
  __typename?: 'file_asset_types_aggregate';
  aggregate?: Maybe<File_Asset_Types_Aggregate_Fields>;
  nodes: Array<File_Asset_Types>;
};

/** aggregate fields of "file_asset_types" */
export type File_Asset_Types_Aggregate_Fields = {
  __typename?: 'file_asset_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<File_Asset_Types_Max_Fields>;
  min?: Maybe<File_Asset_Types_Min_Fields>;
};


/** aggregate fields of "file_asset_types" */
export type File_Asset_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<File_Asset_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "file_asset_types" */
export type File_Asset_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<File_Asset_Types_Max_Order_By>;
  min?: Maybe<File_Asset_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "file_asset_types" */
export type File_Asset_Types_Arr_Rel_Insert_Input = {
  data: Array<File_Asset_Types_Insert_Input>;
  on_conflict?: Maybe<File_Asset_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "file_asset_types". All fields are combined with a logical 'AND'. */
export type File_Asset_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<File_Asset_Types_Bool_Exp>>>;
  _not?: Maybe<File_Asset_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<File_Asset_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_asset_types" */
export enum File_Asset_Types_Constraint {
  /** unique or primary key constraint */
  FileAssetTypesPkey = 'file_asset_types_pkey'
}

export enum File_Asset_Types_Enum {
  /** ARDUPILOT_LOG */
  ArdupilotLog = 'ARDUPILOT_LOG',
  /** ARDUPILOT_LOG_ANALYSIS */
  ArdupilotLogAnalysis = 'ARDUPILOT_LOG_ANALYSIS',
  /** MAVNET_LOG */
  MavnetLog = 'MAVNET_LOG',
  /** MISC_FILE */
  MiscFile = 'MISC_FILE',
  /** T_LOG */
  TLog = 'T_LOG'
}

/** expression to compare columns of type file_asset_types_enum. All fields are combined with logical 'AND'. */
export type File_Asset_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<File_Asset_Types_Enum>;
  _in?: Maybe<Array<File_Asset_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<File_Asset_Types_Enum>;
  _nin?: Maybe<Array<File_Asset_Types_Enum>>;
};

/** input type for inserting data into table "file_asset_types" */
export type File_Asset_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type File_Asset_Types_Max_Fields = {
  __typename?: 'file_asset_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "file_asset_types" */
export type File_Asset_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type File_Asset_Types_Min_Fields = {
  __typename?: 'file_asset_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "file_asset_types" */
export type File_Asset_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "file_asset_types" */
export type File_Asset_Types_Mutation_Response = {
  __typename?: 'file_asset_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<File_Asset_Types>;
};

/** input type for inserting object relation for remote table "file_asset_types" */
export type File_Asset_Types_Obj_Rel_Insert_Input = {
  data: File_Asset_Types_Insert_Input;
  on_conflict?: Maybe<File_Asset_Types_On_Conflict>;
};

/** on conflict condition type for table "file_asset_types" */
export type File_Asset_Types_On_Conflict = {
  constraint: File_Asset_Types_Constraint;
  update_columns: Array<File_Asset_Types_Update_Column>;
  where?: Maybe<File_Asset_Types_Bool_Exp>;
};

/** ordering options when selecting data from "file_asset_types" */
export type File_Asset_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "file_asset_types" */
export type File_Asset_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "file_asset_types" */
export enum File_Asset_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "file_asset_types" */
export type File_Asset_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "file_asset_types" */
export enum File_Asset_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "file_assets" */
export type File_Assets = {
  __typename?: 'file_assets';
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  type: File_Asset_Types_Enum;
  updated_at: Scalars['timestamptz'];
  uploaded_on?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
};

/** aggregated selection of "file_assets" */
export type File_Assets_Aggregate = {
  __typename?: 'file_assets_aggregate';
  aggregate?: Maybe<File_Assets_Aggregate_Fields>;
  nodes: Array<File_Assets>;
};

/** aggregate fields of "file_assets" */
export type File_Assets_Aggregate_Fields = {
  __typename?: 'file_assets_aggregate_fields';
  avg?: Maybe<File_Assets_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<File_Assets_Max_Fields>;
  min?: Maybe<File_Assets_Min_Fields>;
  stddev?: Maybe<File_Assets_Stddev_Fields>;
  stddev_pop?: Maybe<File_Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Assets_Stddev_Samp_Fields>;
  sum?: Maybe<File_Assets_Sum_Fields>;
  var_pop?: Maybe<File_Assets_Var_Pop_Fields>;
  var_samp?: Maybe<File_Assets_Var_Samp_Fields>;
  variance?: Maybe<File_Assets_Variance_Fields>;
};


/** aggregate fields of "file_assets" */
export type File_Assets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<File_Assets_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "file_assets" */
export type File_Assets_Aggregate_Order_By = {
  avg?: Maybe<File_Assets_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<File_Assets_Max_Order_By>;
  min?: Maybe<File_Assets_Min_Order_By>;
  stddev?: Maybe<File_Assets_Stddev_Order_By>;
  stddev_pop?: Maybe<File_Assets_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<File_Assets_Stddev_Samp_Order_By>;
  sum?: Maybe<File_Assets_Sum_Order_By>;
  var_pop?: Maybe<File_Assets_Var_Pop_Order_By>;
  var_samp?: Maybe<File_Assets_Var_Samp_Order_By>;
  variance?: Maybe<File_Assets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "file_assets" */
export type File_Assets_Arr_Rel_Insert_Input = {
  data: Array<File_Assets_Insert_Input>;
  on_conflict?: Maybe<File_Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type File_Assets_Avg_Fields = {
  __typename?: 'file_assets_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "file_assets" */
export type File_Assets_Avg_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_assets". All fields are combined with a logical 'AND'. */
export type File_Assets_Bool_Exp = {
  _and?: Maybe<Array<Maybe<File_Assets_Bool_Exp>>>;
  _not?: Maybe<File_Assets_Bool_Exp>;
  _or?: Maybe<Array<Maybe<File_Assets_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Int_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  end_time?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  size?: Maybe<Int_Comparison_Exp>;
  start_time?: Maybe<Timestamptz_Comparison_Exp>;
  type?: Maybe<File_Asset_Types_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uploaded_on?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_assets" */
export enum File_Assets_Constraint {
  /** unique or primary key constraint */
  FileAssetsMongoIdKey = 'file_assets_mongo_id_key',
  /** unique or primary key constraint */
  FileAssetsPkey = 'file_assets_pkey'
}

/** input type for incrementing integer column in table "file_assets" */
export type File_Assets_Inc_Input = {
  created_by_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "file_assets" */
export type File_Assets_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<File_Asset_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_on?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type File_Assets_Max_Fields = {
  __typename?: 'file_assets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_on?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "file_assets" */
export type File_Assets_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uploaded_on?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type File_Assets_Min_Fields = {
  __typename?: 'file_assets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_on?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "file_assets" */
export type File_Assets_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uploaded_on?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "file_assets" */
export type File_Assets_Mutation_Response = {
  __typename?: 'file_assets_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<File_Assets>;
};

/** input type for inserting object relation for remote table "file_assets" */
export type File_Assets_Obj_Rel_Insert_Input = {
  data: File_Assets_Insert_Input;
  on_conflict?: Maybe<File_Assets_On_Conflict>;
};

/** on conflict condition type for table "file_assets" */
export type File_Assets_On_Conflict = {
  constraint: File_Assets_Constraint;
  update_columns: Array<File_Assets_Update_Column>;
  where?: Maybe<File_Assets_Bool_Exp>;
};

/** ordering options when selecting data from "file_assets" */
export type File_Assets_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  end_time?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  start_time?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uploaded_on?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "file_assets" */
export type File_Assets_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "file_assets" */
export enum File_Assets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedOn = 'uploaded_on',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "file_assets" */
export type File_Assets_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  end_time?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  start_time?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<File_Asset_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploaded_on?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type File_Assets_Stddev_Fields = {
  __typename?: 'file_assets_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "file_assets" */
export type File_Assets_Stddev_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type File_Assets_Stddev_Pop_Fields = {
  __typename?: 'file_assets_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "file_assets" */
export type File_Assets_Stddev_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type File_Assets_Stddev_Samp_Fields = {
  __typename?: 'file_assets_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "file_assets" */
export type File_Assets_Stddev_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type File_Assets_Sum_Fields = {
  __typename?: 'file_assets_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "file_assets" */
export type File_Assets_Sum_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "file_assets" */
export enum File_Assets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploadedOn = 'uploaded_on',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type File_Assets_Var_Pop_Fields = {
  __typename?: 'file_assets_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "file_assets" */
export type File_Assets_Var_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type File_Assets_Var_Samp_Fields = {
  __typename?: 'file_assets_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "file_assets" */
export type File_Assets_Var_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type File_Assets_Variance_Fields = {
  __typename?: 'file_assets_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "file_assets" */
export type File_Assets_Variance_Order_By = {
  created_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  size?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "flight_commands" */
export type Flight_Commands = {
  __typename?: 'flight_commands';
  accepted?: Maybe<Scalars['Boolean']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  mongo_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  status_reported?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
};

/** aggregated selection of "flight_commands" */
export type Flight_Commands_Aggregate = {
  __typename?: 'flight_commands_aggregate';
  aggregate?: Maybe<Flight_Commands_Aggregate_Fields>;
  nodes: Array<Flight_Commands>;
};

/** aggregate fields of "flight_commands" */
export type Flight_Commands_Aggregate_Fields = {
  __typename?: 'flight_commands_aggregate_fields';
  avg?: Maybe<Flight_Commands_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Commands_Max_Fields>;
  min?: Maybe<Flight_Commands_Min_Fields>;
  stddev?: Maybe<Flight_Commands_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Commands_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Commands_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Commands_Sum_Fields>;
  var_pop?: Maybe<Flight_Commands_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Commands_Var_Samp_Fields>;
  variance?: Maybe<Flight_Commands_Variance_Fields>;
};


/** aggregate fields of "flight_commands" */
export type Flight_Commands_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Commands_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_commands" */
export type Flight_Commands_Aggregate_Order_By = {
  avg?: Maybe<Flight_Commands_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Commands_Max_Order_By>;
  min?: Maybe<Flight_Commands_Min_Order_By>;
  stddev?: Maybe<Flight_Commands_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Commands_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Commands_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Commands_Sum_Order_By>;
  var_pop?: Maybe<Flight_Commands_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Commands_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Commands_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "flight_commands" */
export type Flight_Commands_Arr_Rel_Insert_Input = {
  data: Array<Flight_Commands_Insert_Input>;
  on_conflict?: Maybe<Flight_Commands_On_Conflict>;
};

/** aggregate avg on columns */
export type Flight_Commands_Avg_Fields = {
  __typename?: 'flight_commands_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_commands" */
export type Flight_Commands_Avg_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_commands". All fields are combined with a logical 'AND'. */
export type Flight_Commands_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Commands_Bool_Exp>>>;
  _not?: Maybe<Flight_Commands_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Commands_Bool_Exp>>>;
  accepted?: Maybe<Boolean_Comparison_Exp>;
  acknowledged?: Maybe<Boolean_Comparison_Exp>;
  argument?: Maybe<String_Comparison_Exp>;
  command?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  status_message?: Maybe<String_Comparison_Exp>;
  status_reported?: Maybe<Boolean_Comparison_Exp>;
  successful?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_commands" */
export enum Flight_Commands_Constraint {
  /** unique or primary key constraint */
  FlightCommandsMongoIdKey = 'flight_commands_mongo_id_key',
  /** unique or primary key constraint */
  FlightCommandsPkey = 'flight_commands_pkey'
}

/** input type for incrementing integer column in table "flight_commands" */
export type Flight_Commands_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "flight_commands" */
export type Flight_Commands_Insert_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  status_reported?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Flight_Commands_Max_Fields = {
  __typename?: 'flight_commands_max_fields';
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flight_commands" */
export type Flight_Commands_Max_Order_By = {
  argument?: Maybe<Order_By>;
  command?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  status_message?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Commands_Min_Fields = {
  __typename?: 'flight_commands_min_fields';
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flight_commands" */
export type Flight_Commands_Min_Order_By = {
  argument?: Maybe<Order_By>;
  command?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  status_message?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_commands" */
export type Flight_Commands_Mutation_Response = {
  __typename?: 'flight_commands_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Commands>;
};

/** input type for inserting object relation for remote table "flight_commands" */
export type Flight_Commands_Obj_Rel_Insert_Input = {
  data: Flight_Commands_Insert_Input;
  on_conflict?: Maybe<Flight_Commands_On_Conflict>;
};

/** on conflict condition type for table "flight_commands" */
export type Flight_Commands_On_Conflict = {
  constraint: Flight_Commands_Constraint;
  update_columns: Array<Flight_Commands_Update_Column>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};

/** ordering options when selecting data from "flight_commands" */
export type Flight_Commands_Order_By = {
  accepted?: Maybe<Order_By>;
  acknowledged?: Maybe<Order_By>;
  argument?: Maybe<Order_By>;
  command?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  status_message?: Maybe<Order_By>;
  status_reported?: Maybe<Order_By>;
  successful?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_commands" */
export type Flight_Commands_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "flight_commands" */
export enum Flight_Commands_Select_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  Acknowledged = 'acknowledged',
  /** column name */
  Argument = 'argument',
  /** column name */
  Command = 'command',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  StatusMessage = 'status_message',
  /** column name */
  StatusReported = 'status_reported',
  /** column name */
  Successful = 'successful',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "flight_commands" */
export type Flight_Commands_Set_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  status_reported?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Flight_Commands_Stddev_Fields = {
  __typename?: 'flight_commands_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_commands" */
export type Flight_Commands_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Commands_Stddev_Pop_Fields = {
  __typename?: 'flight_commands_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_commands" */
export type Flight_Commands_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Commands_Stddev_Samp_Fields = {
  __typename?: 'flight_commands_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_commands" */
export type Flight_Commands_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Commands_Sum_Fields = {
  __typename?: 'flight_commands_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flight_commands" */
export type Flight_Commands_Sum_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "flight_commands" */
export enum Flight_Commands_Update_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  Acknowledged = 'acknowledged',
  /** column name */
  Argument = 'argument',
  /** column name */
  Command = 'command',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  StatusMessage = 'status_message',
  /** column name */
  StatusReported = 'status_reported',
  /** column name */
  Successful = 'successful',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Flight_Commands_Var_Pop_Fields = {
  __typename?: 'flight_commands_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_commands" */
export type Flight_Commands_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Commands_Var_Samp_Fields = {
  __typename?: 'flight_commands_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_commands" */
export type Flight_Commands_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Commands_Variance_Fields = {
  __typename?: 'flight_commands_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_commands" */
export type Flight_Commands_Variance_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "flight_derivation_reports" */
export type Flight_Derivation_Reports = {
  __typename?: 'flight_derivation_reports';
  /** Total number of flights on the airframe at the start of the flight. */
  airframe_cycle_count_start: Scalars['Int'];
  /** Total number of flights on the airframe at the end of the flight. */
  airframe_cycle_count_stop: Scalars['Int'];
  /** The serial number of the battery used in the flight. */
  battery_serial_number?: Maybe<Scalars['String']>;
  /** The state of charge of the battery at the start of the flight. */
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  /** The state of charge of the battery at the end of the flight. */
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** The max cross track error in meters as computed from MATE telemetry. */
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  /** The mean cross track error in meters as computed from MATE telemetry. */
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  /** Whether the flight conducted was during daylight hours. */
  daytime_flight: Scalars['Boolean'];
  /** An object relationship */
  flight_plan: Flight_Plans;
  /** Flight plan ID corresponding to the derivation report */
  flight_plan_id: Scalars['Int'];
  /** Serial number of the ground asset on which the vehicle landed. */
  landing_ground_asset_serial_number?: Maybe<Scalars['String']>;
  /** Total time on the airframe in seconds at the start of the flight. */
  total_time_airframe_start_seconds: Scalars['Int'];
  /** Total time on the airframe in seconds at the end of the flight. */
  total_time_airframe_stop_seconds: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "flight_derivation_reports" */
export type Flight_Derivation_Reports_Aggregate = {
  __typename?: 'flight_derivation_reports_aggregate';
  aggregate?: Maybe<Flight_Derivation_Reports_Aggregate_Fields>;
  nodes: Array<Flight_Derivation_Reports>;
};

/** aggregate fields of "flight_derivation_reports" */
export type Flight_Derivation_Reports_Aggregate_Fields = {
  __typename?: 'flight_derivation_reports_aggregate_fields';
  avg?: Maybe<Flight_Derivation_Reports_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Derivation_Reports_Max_Fields>;
  min?: Maybe<Flight_Derivation_Reports_Min_Fields>;
  stddev?: Maybe<Flight_Derivation_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Derivation_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Derivation_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Derivation_Reports_Sum_Fields>;
  var_pop?: Maybe<Flight_Derivation_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Derivation_Reports_Var_Samp_Fields>;
  variance?: Maybe<Flight_Derivation_Reports_Variance_Fields>;
};


/** aggregate fields of "flight_derivation_reports" */
export type Flight_Derivation_Reports_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Aggregate_Order_By = {
  avg?: Maybe<Flight_Derivation_Reports_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Derivation_Reports_Max_Order_By>;
  min?: Maybe<Flight_Derivation_Reports_Min_Order_By>;
  stddev?: Maybe<Flight_Derivation_Reports_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Derivation_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Derivation_Reports_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Derivation_Reports_Sum_Order_By>;
  var_pop?: Maybe<Flight_Derivation_Reports_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Derivation_Reports_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Derivation_Reports_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Arr_Rel_Insert_Input = {
  data: Array<Flight_Derivation_Reports_Insert_Input>;
  on_conflict?: Maybe<Flight_Derivation_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Flight_Derivation_Reports_Avg_Fields = {
  __typename?: 'flight_derivation_reports_avg_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Avg_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_derivation_reports". All fields are combined with a logical 'AND'. */
export type Flight_Derivation_Reports_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Derivation_Reports_Bool_Exp>>>;
  _not?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Derivation_Reports_Bool_Exp>>>;
  airframe_cycle_count_start?: Maybe<Int_Comparison_Exp>;
  airframe_cycle_count_stop?: Maybe<Int_Comparison_Exp>;
  battery_serial_number?: Maybe<String_Comparison_Exp>;
  battery_state_of_charge_start_percentage?: Maybe<Int_Comparison_Exp>;
  battery_state_of_charge_stop_percentage?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  cross_track_error_max_meters?: Maybe<Float8_Comparison_Exp>;
  cross_track_error_mean_meters?: Maybe<Float8_Comparison_Exp>;
  daytime_flight?: Maybe<Boolean_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  landing_ground_asset_serial_number?: Maybe<String_Comparison_Exp>;
  total_time_airframe_start_seconds?: Maybe<Int_Comparison_Exp>;
  total_time_airframe_stop_seconds?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_derivation_reports" */
export enum Flight_Derivation_Reports_Constraint {
  /** unique or primary key constraint */
  FlightDerivationReportsPkey = 'flight_derivation_reports_pkey'
}

/** input type for incrementing integer column in table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Inc_Input = {
  airframe_cycle_count_start?: Maybe<Scalars['Int']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Int']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Int']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Insert_Input = {
  airframe_cycle_count_start?: Maybe<Scalars['Int']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Int']>;
  battery_serial_number?: Maybe<Scalars['String']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  daytime_flight?: Maybe<Scalars['Boolean']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  landing_ground_asset_serial_number?: Maybe<Scalars['String']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Int']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Flight_Derivation_Reports_Max_Fields = {
  __typename?: 'flight_derivation_reports_max_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Int']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Int']>;
  battery_serial_number?: Maybe<Scalars['String']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  landing_ground_asset_serial_number?: Maybe<Scalars['String']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Int']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Max_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_serial_number?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  landing_ground_asset_serial_number?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Derivation_Reports_Min_Fields = {
  __typename?: 'flight_derivation_reports_min_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Int']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Int']>;
  battery_serial_number?: Maybe<Scalars['String']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  landing_ground_asset_serial_number?: Maybe<Scalars['String']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Int']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Min_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_serial_number?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  landing_ground_asset_serial_number?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Mutation_Response = {
  __typename?: 'flight_derivation_reports_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Derivation_Reports>;
};

/** input type for inserting object relation for remote table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Obj_Rel_Insert_Input = {
  data: Flight_Derivation_Reports_Insert_Input;
  on_conflict?: Maybe<Flight_Derivation_Reports_On_Conflict>;
};

/** on conflict condition type for table "flight_derivation_reports" */
export type Flight_Derivation_Reports_On_Conflict = {
  constraint: Flight_Derivation_Reports_Constraint;
  update_columns: Array<Flight_Derivation_Reports_Update_Column>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};

/** ordering options when selecting data from "flight_derivation_reports" */
export type Flight_Derivation_Reports_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_serial_number?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  daytime_flight?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  landing_ground_asset_serial_number?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_derivation_reports" */
export type Flight_Derivation_Reports_Pk_Columns_Input = {
  /** Flight plan ID corresponding to the derivation report */
  flight_plan_id: Scalars['Int'];
};

/** select columns of table "flight_derivation_reports" */
export enum Flight_Derivation_Reports_Select_Column {
  /** column name */
  AirframeCycleCountStart = 'airframe_cycle_count_start',
  /** column name */
  AirframeCycleCountStop = 'airframe_cycle_count_stop',
  /** column name */
  BatterySerialNumber = 'battery_serial_number',
  /** column name */
  BatteryStateOfChargeStartPercentage = 'battery_state_of_charge_start_percentage',
  /** column name */
  BatteryStateOfChargeStopPercentage = 'battery_state_of_charge_stop_percentage',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrossTrackErrorMaxMeters = 'cross_track_error_max_meters',
  /** column name */
  CrossTrackErrorMeanMeters = 'cross_track_error_mean_meters',
  /** column name */
  DaytimeFlight = 'daytime_flight',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  LandingGroundAssetSerialNumber = 'landing_ground_asset_serial_number',
  /** column name */
  TotalTimeAirframeStartSeconds = 'total_time_airframe_start_seconds',
  /** column name */
  TotalTimeAirframeStopSeconds = 'total_time_airframe_stop_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Set_Input = {
  airframe_cycle_count_start?: Maybe<Scalars['Int']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Int']>;
  battery_serial_number?: Maybe<Scalars['String']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  daytime_flight?: Maybe<Scalars['Boolean']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  landing_ground_asset_serial_number?: Maybe<Scalars['String']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Int']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Flight_Derivation_Reports_Stddev_Fields = {
  __typename?: 'flight_derivation_reports_stddev_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Stddev_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Derivation_Reports_Stddev_Pop_Fields = {
  __typename?: 'flight_derivation_reports_stddev_pop_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Stddev_Pop_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Derivation_Reports_Stddev_Samp_Fields = {
  __typename?: 'flight_derivation_reports_stddev_samp_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Stddev_Samp_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Derivation_Reports_Sum_Fields = {
  __typename?: 'flight_derivation_reports_sum_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Int']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Int']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Int']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Int']>;
  cross_track_error_max_meters?: Maybe<Scalars['float8']>;
  cross_track_error_mean_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Int']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Sum_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "flight_derivation_reports" */
export enum Flight_Derivation_Reports_Update_Column {
  /** column name */
  AirframeCycleCountStart = 'airframe_cycle_count_start',
  /** column name */
  AirframeCycleCountStop = 'airframe_cycle_count_stop',
  /** column name */
  BatterySerialNumber = 'battery_serial_number',
  /** column name */
  BatteryStateOfChargeStartPercentage = 'battery_state_of_charge_start_percentage',
  /** column name */
  BatteryStateOfChargeStopPercentage = 'battery_state_of_charge_stop_percentage',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CrossTrackErrorMaxMeters = 'cross_track_error_max_meters',
  /** column name */
  CrossTrackErrorMeanMeters = 'cross_track_error_mean_meters',
  /** column name */
  DaytimeFlight = 'daytime_flight',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  LandingGroundAssetSerialNumber = 'landing_ground_asset_serial_number',
  /** column name */
  TotalTimeAirframeStartSeconds = 'total_time_airframe_start_seconds',
  /** column name */
  TotalTimeAirframeStopSeconds = 'total_time_airframe_stop_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Flight_Derivation_Reports_Var_Pop_Fields = {
  __typename?: 'flight_derivation_reports_var_pop_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Var_Pop_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Derivation_Reports_Var_Samp_Fields = {
  __typename?: 'flight_derivation_reports_var_samp_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Var_Samp_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Derivation_Reports_Variance_Fields = {
  __typename?: 'flight_derivation_reports_variance_fields';
  airframe_cycle_count_start?: Maybe<Scalars['Float']>;
  airframe_cycle_count_stop?: Maybe<Scalars['Float']>;
  battery_state_of_charge_start_percentage?: Maybe<Scalars['Float']>;
  battery_state_of_charge_stop_percentage?: Maybe<Scalars['Float']>;
  cross_track_error_max_meters?: Maybe<Scalars['Float']>;
  cross_track_error_mean_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  total_time_airframe_start_seconds?: Maybe<Scalars['Float']>;
  total_time_airframe_stop_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_derivation_reports" */
export type Flight_Derivation_Reports_Variance_Order_By = {
  airframe_cycle_count_start?: Maybe<Order_By>;
  airframe_cycle_count_stop?: Maybe<Order_By>;
  battery_state_of_charge_start_percentage?: Maybe<Order_By>;
  battery_state_of_charge_stop_percentage?: Maybe<Order_By>;
  cross_track_error_max_meters?: Maybe<Order_By>;
  cross_track_error_mean_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  total_time_airframe_start_seconds?: Maybe<Order_By>;
  total_time_airframe_stop_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View = {
  __typename?: 'flight_plan_current_rpic_view';
  /** An object relationship */
  flight_peoc_request?: Maybe<Positive_Exchange_Of_Flight_Control_Requests>;
  flight_peoc_request_id?: Maybe<Scalars['Int']>;
  flight_peoc_requested_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_peoc_requesting_pilot?: Maybe<Users>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  rpic_user?: Maybe<Users>;
  rpic_user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Aggregate = {
  __typename?: 'flight_plan_current_rpic_view_aggregate';
  aggregate?: Maybe<Flight_Plan_Current_Rpic_View_Aggregate_Fields>;
  nodes: Array<Flight_Plan_Current_Rpic_View>;
};

/** aggregate fields of "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Aggregate_Fields = {
  __typename?: 'flight_plan_current_rpic_view_aggregate_fields';
  avg?: Maybe<Flight_Plan_Current_Rpic_View_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Plan_Current_Rpic_View_Max_Fields>;
  min?: Maybe<Flight_Plan_Current_Rpic_View_Min_Fields>;
  stddev?: Maybe<Flight_Plan_Current_Rpic_View_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Plan_Current_Rpic_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Plan_Current_Rpic_View_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Plan_Current_Rpic_View_Sum_Fields>;
  var_pop?: Maybe<Flight_Plan_Current_Rpic_View_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Plan_Current_Rpic_View_Var_Samp_Fields>;
  variance?: Maybe<Flight_Plan_Current_Rpic_View_Variance_Fields>;
};


/** aggregate fields of "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Plan_Current_Rpic_View_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Aggregate_Order_By = {
  avg?: Maybe<Flight_Plan_Current_Rpic_View_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Plan_Current_Rpic_View_Max_Order_By>;
  min?: Maybe<Flight_Plan_Current_Rpic_View_Min_Order_By>;
  stddev?: Maybe<Flight_Plan_Current_Rpic_View_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Plan_Current_Rpic_View_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Plan_Current_Rpic_View_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Plan_Current_Rpic_View_Sum_Order_By>;
  var_pop?: Maybe<Flight_Plan_Current_Rpic_View_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Plan_Current_Rpic_View_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Plan_Current_Rpic_View_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Flight_Plan_Current_Rpic_View_Avg_Fields = {
  __typename?: 'flight_plan_current_rpic_view_avg_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Avg_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_plan_current_rpic_view". All fields are combined with a logical 'AND'. */
export type Flight_Plan_Current_Rpic_View_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>>>;
  _not?: Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>>>;
  flight_peoc_request?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
  flight_peoc_request_id?: Maybe<Int_Comparison_Exp>;
  flight_peoc_requested_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_peoc_requesting_pilot?: Maybe<Users_Bool_Exp>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Int_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  rpic_assigned_at?: Maybe<Timestamptz_Comparison_Exp>;
  rpic_user?: Maybe<Users_Bool_Exp>;
  rpic_user_id?: Maybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Flight_Plan_Current_Rpic_View_Max_Fields = {
  __typename?: 'flight_plan_current_rpic_view_max_fields';
  flight_peoc_request_id?: Maybe<Scalars['Int']>;
  flight_peoc_requested_at?: Maybe<Scalars['timestamptz']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  rpic_user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Max_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requested_at?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_assigned_at?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Plan_Current_Rpic_View_Min_Fields = {
  __typename?: 'flight_plan_current_rpic_view_min_fields';
  flight_peoc_request_id?: Maybe<Scalars['Int']>;
  flight_peoc_requested_at?: Maybe<Scalars['timestamptz']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  rpic_user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Min_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requested_at?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_assigned_at?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** ordering options when selecting data from "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Order_By = {
  flight_peoc_request?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Order_By>;
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requested_at?: Maybe<Order_By>;
  flight_peoc_requesting_pilot?: Maybe<Users_Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_assigned_at?: Maybe<Order_By>;
  rpic_user?: Maybe<Users_Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** select columns of table "flight_plan_current_rpic_view" */
export enum Flight_Plan_Current_Rpic_View_Select_Column {
  /** column name */
  FlightPeocRequestId = 'flight_peoc_request_id',
  /** column name */
  FlightPeocRequestedAt = 'flight_peoc_requested_at',
  /** column name */
  FlightPeocRequestingPilotUserId = 'flight_peoc_requesting_pilot_user_id',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  RpicAssignedAt = 'rpic_assigned_at',
  /** column name */
  RpicUserId = 'rpic_user_id'
}

/** aggregate stddev on columns */
export type Flight_Plan_Current_Rpic_View_Stddev_Fields = {
  __typename?: 'flight_plan_current_rpic_view_stddev_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Stddev_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Plan_Current_Rpic_View_Stddev_Pop_Fields = {
  __typename?: 'flight_plan_current_rpic_view_stddev_pop_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Stddev_Pop_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Plan_Current_Rpic_View_Stddev_Samp_Fields = {
  __typename?: 'flight_plan_current_rpic_view_stddev_samp_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Stddev_Samp_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Plan_Current_Rpic_View_Sum_Fields = {
  __typename?: 'flight_plan_current_rpic_view_sum_fields';
  flight_peoc_request_id?: Maybe<Scalars['Int']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  rpic_user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Sum_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Flight_Plan_Current_Rpic_View_Var_Pop_Fields = {
  __typename?: 'flight_plan_current_rpic_view_var_pop_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Var_Pop_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Plan_Current_Rpic_View_Var_Samp_Fields = {
  __typename?: 'flight_plan_current_rpic_view_var_samp_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Var_Samp_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Plan_Current_Rpic_View_Variance_Fields = {
  __typename?: 'flight_plan_current_rpic_view_variance_fields';
  flight_peoc_request_id?: Maybe<Scalars['Float']>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  rpic_user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_plan_current_rpic_view" */
export type Flight_Plan_Current_Rpic_View_Variance_Order_By = {
  flight_peoc_request_id?: Maybe<Order_By>;
  flight_peoc_requesting_pilot_user_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  rpic_user_id?: Maybe<Order_By>;
};

/** columns and relationships of "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments = {
  __typename?: 'flight_plan_pilot_assignments';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  flight_plan: Flight_Plans;
  /** ID of the flight plan */
  flight_plan_id: Scalars['Int'];
  /** ID for the pilot flight plan assignment record */
  id: Scalars['Int'];
  /** User ID of the pilot */
  pilot_id: Scalars['Int'];
  /** Denotes whether this pilot is the rpic for the associated flight plan and time of assignment. */
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  version: Scalars['Int'];
};

/** aggregated selection of "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Aggregate = {
  __typename?: 'flight_plan_pilot_assignments_aggregate';
  aggregate?: Maybe<Flight_Plan_Pilot_Assignments_Aggregate_Fields>;
  nodes: Array<Flight_Plan_Pilot_Assignments>;
};

/** aggregate fields of "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Aggregate_Fields = {
  __typename?: 'flight_plan_pilot_assignments_aggregate_fields';
  avg?: Maybe<Flight_Plan_Pilot_Assignments_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Plan_Pilot_Assignments_Max_Fields>;
  min?: Maybe<Flight_Plan_Pilot_Assignments_Min_Fields>;
  stddev?: Maybe<Flight_Plan_Pilot_Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Plan_Pilot_Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Plan_Pilot_Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Plan_Pilot_Assignments_Sum_Fields>;
  var_pop?: Maybe<Flight_Plan_Pilot_Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Plan_Pilot_Assignments_Var_Samp_Fields>;
  variance?: Maybe<Flight_Plan_Pilot_Assignments_Variance_Fields>;
};


/** aggregate fields of "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Aggregate_Order_By = {
  avg?: Maybe<Flight_Plan_Pilot_Assignments_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Plan_Pilot_Assignments_Max_Order_By>;
  min?: Maybe<Flight_Plan_Pilot_Assignments_Min_Order_By>;
  stddev?: Maybe<Flight_Plan_Pilot_Assignments_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Plan_Pilot_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Plan_Pilot_Assignments_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Plan_Pilot_Assignments_Sum_Order_By>;
  var_pop?: Maybe<Flight_Plan_Pilot_Assignments_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Plan_Pilot_Assignments_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Plan_Pilot_Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Arr_Rel_Insert_Input = {
  data: Array<Flight_Plan_Pilot_Assignments_Insert_Input>;
  on_conflict?: Maybe<Flight_Plan_Pilot_Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Flight_Plan_Pilot_Assignments_Avg_Fields = {
  __typename?: 'flight_plan_pilot_assignments_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_plan_pilot_assignments". All fields are combined with a logical 'AND'. */
export type Flight_Plan_Pilot_Assignments_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>>>;
  _not?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  pilot_id?: Maybe<Int_Comparison_Exp>;
  rpic_assigned_at?: Maybe<Timestamptz_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_plan_pilot_assignments" */
export enum Flight_Plan_Pilot_Assignments_Constraint {
  /** unique or primary key constraint */
  FlightPlanPilotAssignmentsIdPk = 'flight_plan_pilot_assignments_id_pk',
  /** unique or primary key constraint */
  FlightPlanPilotAssignmentsPilotIdFlightPlanIdUk = 'flight_plan_pilot_assignments_pilot_id_flight_plan_id_uk'
}

/** input type for incrementing integer column in table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Flight_Plan_Pilot_Assignments_Max_Fields = {
  __typename?: 'flight_plan_pilot_assignments_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  rpic_assigned_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Plan_Pilot_Assignments_Min_Fields = {
  __typename?: 'flight_plan_pilot_assignments_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  rpic_assigned_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Mutation_Response = {
  __typename?: 'flight_plan_pilot_assignments_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Plan_Pilot_Assignments>;
};

/** input type for inserting object relation for remote table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Obj_Rel_Insert_Input = {
  data: Flight_Plan_Pilot_Assignments_Insert_Input;
  on_conflict?: Maybe<Flight_Plan_Pilot_Assignments_On_Conflict>;
};

/** on conflict condition type for table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_On_Conflict = {
  constraint: Flight_Plan_Pilot_Assignments_Constraint;
  update_columns: Array<Flight_Plan_Pilot_Assignments_Update_Column>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};

/** ordering options when selecting data from "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Order_By = {
  created_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  rpic_assigned_at?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Pk_Columns_Input = {
  /** ID for the pilot flight plan assignment record */
  id: Scalars['Int'];
};

/** select columns of table "flight_plan_pilot_assignments" */
export enum Flight_Plan_Pilot_Assignments_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  PilotId = 'pilot_id',
  /** column name */
  RpicAssignedAt = 'rpic_assigned_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  rpic_assigned_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Flight_Plan_Pilot_Assignments_Stddev_Fields = {
  __typename?: 'flight_plan_pilot_assignments_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Plan_Pilot_Assignments_Stddev_Pop_Fields = {
  __typename?: 'flight_plan_pilot_assignments_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Plan_Pilot_Assignments_Stddev_Samp_Fields = {
  __typename?: 'flight_plan_pilot_assignments_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Plan_Pilot_Assignments_Sum_Fields = {
  __typename?: 'flight_plan_pilot_assignments_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "flight_plan_pilot_assignments" */
export enum Flight_Plan_Pilot_Assignments_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  PilotId = 'pilot_id',
  /** column name */
  RpicAssignedAt = 'rpic_assigned_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Flight_Plan_Pilot_Assignments_Var_Pop_Fields = {
  __typename?: 'flight_plan_pilot_assignments_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Plan_Pilot_Assignments_Var_Samp_Fields = {
  __typename?: 'flight_plan_pilot_assignments_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Plan_Pilot_Assignments_Variance_Fields = {
  __typename?: 'flight_plan_pilot_assignments_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_plan_pilot_assignments" */
export type Flight_Plan_Pilot_Assignments_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "flight_plan_statuses" */
export type Flight_Plan_Statuses = {
  __typename?: 'flight_plan_statuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "flight_plan_statuses" */
export type Flight_Plan_Statuses_Aggregate = {
  __typename?: 'flight_plan_statuses_aggregate';
  aggregate?: Maybe<Flight_Plan_Statuses_Aggregate_Fields>;
  nodes: Array<Flight_Plan_Statuses>;
};

/** aggregate fields of "flight_plan_statuses" */
export type Flight_Plan_Statuses_Aggregate_Fields = {
  __typename?: 'flight_plan_statuses_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Plan_Statuses_Max_Fields>;
  min?: Maybe<Flight_Plan_Statuses_Min_Fields>;
};


/** aggregate fields of "flight_plan_statuses" */
export type Flight_Plan_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Plan_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Plan_Statuses_Max_Order_By>;
  min?: Maybe<Flight_Plan_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Flight_Plan_Statuses_Insert_Input>;
  on_conflict?: Maybe<Flight_Plan_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "flight_plan_statuses". All fields are combined with a logical 'AND'. */
export type Flight_Plan_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Plan_Statuses_Bool_Exp>>>;
  _not?: Maybe<Flight_Plan_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Plan_Statuses_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_plan_statuses" */
export enum Flight_Plan_Statuses_Constraint {
  /** unique or primary key constraint */
  FlightPlanStatusesPkey = 'flight_plan_statuses_pkey'
}

export enum Flight_Plan_Statuses_Enum {
  /** ABORTED */
  Aborted = 'ABORTED',
  /** ARRIVED */
  Arrived = 'ARRIVED',
  /** CANCELED */
  Canceled = 'CANCELED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** DELAYED */
  Delayed = 'DELAYED',
  /** DEPARTED */
  Departed = 'DEPARTED',
  /** PREFLIGHT */
  Preflight = 'PREFLIGHT',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** SCHEDULED */
  Scheduled = 'SCHEDULED'
}

/** expression to compare columns of type flight_plan_statuses_enum. All fields are combined with logical 'AND'. */
export type Flight_Plan_Statuses_Enum_Comparison_Exp = {
  _eq?: Maybe<Flight_Plan_Statuses_Enum>;
  _in?: Maybe<Array<Flight_Plan_Statuses_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Flight_Plan_Statuses_Enum>;
  _nin?: Maybe<Array<Flight_Plan_Statuses_Enum>>;
};

/** input type for inserting data into table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Flight_Plan_Statuses_Max_Fields = {
  __typename?: 'flight_plan_statuses_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Plan_Statuses_Min_Fields = {
  __typename?: 'flight_plan_statuses_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Mutation_Response = {
  __typename?: 'flight_plan_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Plan_Statuses>;
};

/** input type for inserting object relation for remote table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Obj_Rel_Insert_Input = {
  data: Flight_Plan_Statuses_Insert_Input;
  on_conflict?: Maybe<Flight_Plan_Statuses_On_Conflict>;
};

/** on conflict condition type for table "flight_plan_statuses" */
export type Flight_Plan_Statuses_On_Conflict = {
  constraint: Flight_Plan_Statuses_Constraint;
  update_columns: Array<Flight_Plan_Statuses_Update_Column>;
  where?: Maybe<Flight_Plan_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "flight_plan_statuses" */
export type Flight_Plan_Statuses_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_plan_statuses" */
export type Flight_Plan_Statuses_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "flight_plan_statuses" */
export enum Flight_Plan_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flight_plan_statuses" */
export type Flight_Plan_Statuses_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "flight_plan_statuses" */
export enum Flight_Plan_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers = {
  __typename?: 'flight_plan_utm_providers';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Aggregate = {
  __typename?: 'flight_plan_utm_providers_aggregate';
  aggregate?: Maybe<Flight_Plan_Utm_Providers_Aggregate_Fields>;
  nodes: Array<Flight_Plan_Utm_Providers>;
};

/** aggregate fields of "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Aggregate_Fields = {
  __typename?: 'flight_plan_utm_providers_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Plan_Utm_Providers_Max_Fields>;
  min?: Maybe<Flight_Plan_Utm_Providers_Min_Fields>;
};


/** aggregate fields of "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Plan_Utm_Providers_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Plan_Utm_Providers_Max_Order_By>;
  min?: Maybe<Flight_Plan_Utm_Providers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Arr_Rel_Insert_Input = {
  data: Array<Flight_Plan_Utm_Providers_Insert_Input>;
  on_conflict?: Maybe<Flight_Plan_Utm_Providers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "flight_plan_utm_providers". All fields are combined with a logical 'AND'. */
export type Flight_Plan_Utm_Providers_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Plan_Utm_Providers_Bool_Exp>>>;
  _not?: Maybe<Flight_Plan_Utm_Providers_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Plan_Utm_Providers_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_plan_utm_providers" */
export enum Flight_Plan_Utm_Providers_Constraint {
  /** unique or primary key constraint */
  FlightPlanUtmProvidersPkey = 'flight_plan_utm_providers_pkey'
}

export enum Flight_Plan_Utm_Providers_Enum {
  /** Airmap */
  Airmap = 'Airmap'
}

/** expression to compare columns of type flight_plan_utm_providers_enum. All fields are combined with logical 'AND'. */
export type Flight_Plan_Utm_Providers_Enum_Comparison_Exp = {
  _eq?: Maybe<Flight_Plan_Utm_Providers_Enum>;
  _in?: Maybe<Array<Flight_Plan_Utm_Providers_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Flight_Plan_Utm_Providers_Enum>;
  _nin?: Maybe<Array<Flight_Plan_Utm_Providers_Enum>>;
};

/** input type for inserting data into table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Flight_Plan_Utm_Providers_Max_Fields = {
  __typename?: 'flight_plan_utm_providers_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Plan_Utm_Providers_Min_Fields = {
  __typename?: 'flight_plan_utm_providers_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Mutation_Response = {
  __typename?: 'flight_plan_utm_providers_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Plan_Utm_Providers>;
};

/** input type for inserting object relation for remote table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Obj_Rel_Insert_Input = {
  data: Flight_Plan_Utm_Providers_Insert_Input;
  on_conflict?: Maybe<Flight_Plan_Utm_Providers_On_Conflict>;
};

/** on conflict condition type for table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_On_Conflict = {
  constraint: Flight_Plan_Utm_Providers_Constraint;
  update_columns: Array<Flight_Plan_Utm_Providers_Update_Column>;
  where?: Maybe<Flight_Plan_Utm_Providers_Bool_Exp>;
};

/** ordering options when selecting data from "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "flight_plan_utm_providers" */
export enum Flight_Plan_Utm_Providers_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "flight_plan_utm_providers" */
export type Flight_Plan_Utm_Providers_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "flight_plan_utm_providers" */
export enum Flight_Plan_Utm_Providers_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_Plans = {
  __typename?: 'flight_plans';
  aborted?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  air_traffic_deconfliction_algorithm: Air_Traffic_Deconfliction_Algorithm_Types_Enum;
  /** An object relationship */
  air_traffic_deconfliction_algorithm_type: Air_Traffic_Deconfliction_Algorithm_Types;
  /** An array relationship */
  air_traffic_monitor_tasks: Array<Air_Traffic_Monitor_Tasks>;
  /** An aggregated array relationship */
  air_traffic_monitor_tasks_aggregate: Air_Traffic_Monitor_Tasks_Aggregate;
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
  arrived_on?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  contingencyLandingSpotByOriginContingencyLandingSpotId?: Maybe<Contingency_Landing_Spots>;
  /** An object relationship */
  contingency_landing_spot?: Maybe<Contingency_Landing_Spots>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  current_air_traffic_proximity_recordings: Array<Current_Air_Traffic_Proximity_Recordings>;
  /** An aggregated array relationship */
  current_air_traffic_proximity_recordings_aggregate: Current_Air_Traffic_Proximity_Recordings_Aggregate;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  departed_on?: Maybe<Scalars['timestamptz']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  destination_station?: Maybe<Stations>;
  /** An array relationship */
  file_assets: Array<File_Assets>;
  /** An aggregated array relationship */
  file_assets_aggregate: File_Assets_Aggregate;
  /** An array relationship */
  flight_derivation_reports: Array<Flight_Derivation_Reports>;
  /** An aggregated array relationship */
  flight_derivation_reports_aggregate: Flight_Derivation_Reports_Aggregate;
  /** An object relationship */
  flight_plan_current_rpic_view?: Maybe<Flight_Plan_Current_Rpic_View>;
  /** An array relationship */
  flight_plan_pilot_assignments: Array<Flight_Plan_Pilot_Assignments>;
  /** An aggregated array relationship */
  flight_plan_pilot_assignments_aggregate: Flight_Plan_Pilot_Assignments_Aggregate;
  /** A computed field, executes function "flight_plan_selected_by_user" */
  flight_plan_selected_by_user?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  flight_weather_data: Array<Flight_Weather_Data>;
  /** An aggregated array relationship */
  flight_weather_data_aggregate: Flight_Weather_Data_Aggregate;
  gufi?: Maybe<Scalars['String']>;
  /** An array relationship */
  historical_serialized_vehicle_statuses: Array<Historical_Serialized_Vehicle_Statuses>;
  /** An aggregated array relationship */
  historical_serialized_vehicle_statuses_aggregate: Historical_Serialized_Vehicle_Statuses_Aggregate;
  /** An array relationship */
  historical_vehicle_positions: Array<Historical_Vehicle_Positions>;
  /** An aggregated array relationship */
  historical_vehicle_positions_aggregate: Historical_Vehicle_Positions_Aggregate;
  /** UID of the flight plan. */
  id: Scalars['Int'];
  /** An array relationship */
  kafka_serialized_vehicle_statuses: Array<Kafka_Serialized_Vehicle_Statuses>;
  /** An aggregated array relationship */
  kafka_serialized_vehicle_statuses_aggregate: Kafka_Serialized_Vehicle_Statuses_Aggregate;
  /** An array relationship */
  landing_requests: Array<Landing_Requests>;
  /** An aggregated array relationship */
  landing_requests_aggregate: Landing_Requests_Aggregate;
  loaded?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  manifest?: Maybe<Manifests>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  origin_station?: Maybe<Stations>;
  origin_station_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  path?: Maybe<Paths>;
  /** An object relationship */
  path_by_dest_contingency_path?: Maybe<Paths>;
  /** An object relationship */
  path_by_origin_contingency_path?: Maybe<Paths>;
  path_id?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['String']>;
  scheduled_departure?: Maybe<Scalars['timestamptz']>;
  /** Flight status. REJECTED = Flight plan request was rejected and flight plan will not be loaded to vehicle. SCHEDULED = Flight plan request was approved and has been loaded to vehicle. DEPARTED = Take-off command has been issued and vehicle is in flight. ARRIVED = Vehicle arrived at the destination terminal airspace. COMPLETED = Vehicle landed at destination terminal airspace. CANCELED = Operator canceled the flight plan and the flight plan has been unloaded from the vehicle. ABORTED = Vehicle was not approved to land at destination terminal airspace and proceeded to alternate landing location. */
  status: Flight_Plan_Statuses_Enum;
  title?: Maybe<Scalars['String']>;
  /** An array relationship */
  type_cert_flight_analysis_data: Array<Type_Cert_Flight_Analysis_Data>;
  /** An aggregated array relationship */
  type_cert_flight_analysis_data_aggregate: Type_Cert_Flight_Analysis_Data_Aggregate;
  /** An array relationship */
  type_cert_manual_data: Array<Type_Cert_Manual_Data>;
  /** An aggregated array relationship */
  type_cert_manual_data_aggregate: Type_Cert_Manual_Data_Aggregate;
  upcoming?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  utm_provider?: Maybe<Flight_Plan_Utm_Providers_Enum>;
  utm_registration?: Maybe<Scalars['String']>;
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  /** An array relationship */
  vehicle_alerts: Array<Vehicle_Alerts>;
  /** An aggregated array relationship */
  vehicle_alerts_aggregate: Vehicle_Alerts_Aggregate;
  /** An array relationship */
  vehicle_flight_statuses: Array<Vehicle_Flight_Statuses>;
  /** An aggregated array relationship */
  vehicle_flight_statuses_aggregate: Vehicle_Flight_Statuses_Aggregate;
  vehicle_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  vehicle_priority_events: Array<Vehicle_Priority_Events>;
  /** An aggregated array relationship */
  vehicle_priority_events_aggregate: Vehicle_Priority_Events_Aggregate;
  version: Scalars['Int'];
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansAir_Traffic_Monitor_TasksArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Monitor_Tasks_Order_By>>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansAir_Traffic_Monitor_Tasks_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Monitor_Tasks_Order_By>>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansAirmap_RulesetsArgs = {
  path?: Maybe<Scalars['String']>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansCurrent_Air_Traffic_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansCurrent_Air_Traffic_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFile_AssetsArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFile_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFlight_Derivation_ReportsArgs = {
  distinct_on?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Derivation_Reports_Order_By>>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFlight_Derivation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Derivation_Reports_Order_By>>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFlight_Plan_Pilot_AssignmentsArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Pilot_Assignments_Order_By>>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFlight_Plan_Pilot_Assignments_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Pilot_Assignments_Order_By>>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFlight_Weather_DataArgs = {
  distinct_on?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Weather_Data_Order_By>>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansFlight_Weather_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Weather_Data_Order_By>>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansHistorical_Serialized_Vehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansHistorical_Serialized_Vehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansHistorical_Vehicle_PositionsArgs = {
  distinct_on?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Vehicle_Positions_Order_By>>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansHistorical_Vehicle_Positions_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Vehicle_Positions_Order_By>>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansKafka_Serialized_Vehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansKafka_Serialized_Vehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansLanding_RequestsArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansLanding_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansType_Cert_Flight_Analysis_DataArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Order_By>>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansType_Cert_Flight_Analysis_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Order_By>>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansType_Cert_Manual_DataArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Manual_Data_Order_By>>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansType_Cert_Manual_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Manual_Data_Order_By>>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansVehicle_AlertsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansVehicle_Alerts_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansVehicle_Flight_StatusesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_Statuses_Order_By>>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansVehicle_Flight_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_Statuses_Order_By>>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansVehicle_Priority_EventsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/**
 * Table containing the planned flights and their current status.
 *
 *
 * columns and relationships of "flight_plans"
 */
export type Flight_PlansVehicle_Priority_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};

/** aggregated selection of "flight_plans" */
export type Flight_Plans_Aggregate = {
  __typename?: 'flight_plans_aggregate';
  aggregate?: Maybe<Flight_Plans_Aggregate_Fields>;
  nodes: Array<Flight_Plans>;
};

/** aggregate fields of "flight_plans" */
export type Flight_Plans_Aggregate_Fields = {
  __typename?: 'flight_plans_aggregate_fields';
  avg?: Maybe<Flight_Plans_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Plans_Max_Fields>;
  min?: Maybe<Flight_Plans_Min_Fields>;
  stddev?: Maybe<Flight_Plans_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Plans_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Plans_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Plans_Sum_Fields>;
  var_pop?: Maybe<Flight_Plans_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Plans_Var_Samp_Fields>;
  variance?: Maybe<Flight_Plans_Variance_Fields>;
};


/** aggregate fields of "flight_plans" */
export type Flight_Plans_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Plans_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_plans" */
export type Flight_Plans_Aggregate_Order_By = {
  avg?: Maybe<Flight_Plans_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Plans_Max_Order_By>;
  min?: Maybe<Flight_Plans_Min_Order_By>;
  stddev?: Maybe<Flight_Plans_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Plans_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Plans_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Plans_Sum_Order_By>;
  var_pop?: Maybe<Flight_Plans_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Plans_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Plans_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Flight_Plans_Append_Input = {
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "flight_plans" */
export type Flight_Plans_Arr_Rel_Insert_Input = {
  data: Array<Flight_Plans_Insert_Input>;
  on_conflict?: Maybe<Flight_Plans_On_Conflict>;
};

/** aggregate avg on columns */
export type Flight_Plans_Avg_Fields = {
  __typename?: 'flight_plans_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_plans" */
export type Flight_Plans_Avg_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_plans". All fields are combined with a logical 'AND'. */
export type Flight_Plans_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Plans_Bool_Exp>>>;
  _not?: Maybe<Flight_Plans_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Plans_Bool_Exp>>>;
  aborted?: Maybe<Boolean_Comparison_Exp>;
  active?: Maybe<Boolean_Comparison_Exp>;
  air_traffic_deconfliction_algorithm?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Enum_Comparison_Exp>;
  air_traffic_deconfliction_algorithm_type?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
  air_traffic_monitor_tasks?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
  airmap_rulesets?: Maybe<Jsonb_Comparison_Exp>;
  arrived_on?: Maybe<Timestamptz_Comparison_Exp>;
  contingencyLandingSpotByOriginContingencyLandingSpotId?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  contingency_landing_spot?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Int_Comparison_Exp>;
  current_air_traffic_proximity_recordings?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  departed_on?: Maybe<Timestamptz_Comparison_Exp>;
  dest_contingency_landing_spot_id?: Maybe<Int_Comparison_Exp>;
  dest_contingency_path_id?: Maybe<Int_Comparison_Exp>;
  dest_station_id?: Maybe<Int_Comparison_Exp>;
  destination_station?: Maybe<Stations_Bool_Exp>;
  file_assets?: Maybe<File_Assets_Bool_Exp>;
  flight_derivation_reports?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
  flight_plan_current_rpic_view?: Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>;
  flight_plan_pilot_assignments?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
  flight_weather_data?: Maybe<Flight_Weather_Data_Bool_Exp>;
  gufi?: Maybe<String_Comparison_Exp>;
  historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
  historical_vehicle_positions?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  kafka_serialized_vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
  landing_requests?: Maybe<Landing_Requests_Bool_Exp>;
  loaded?: Maybe<Boolean_Comparison_Exp>;
  manifest?: Maybe<Manifests_Bool_Exp>;
  manifest_id?: Maybe<Int_Comparison_Exp>;
  mission_count?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  origin_contingency_landing_spot_id?: Maybe<Int_Comparison_Exp>;
  origin_contingency_path_id?: Maybe<Int_Comparison_Exp>;
  origin_station?: Maybe<Stations_Bool_Exp>;
  origin_station_id?: Maybe<Int_Comparison_Exp>;
  path?: Maybe<Paths_Bool_Exp>;
  path_by_dest_contingency_path?: Maybe<Paths_Bool_Exp>;
  path_by_origin_contingency_path?: Maybe<Paths_Bool_Exp>;
  path_id?: Maybe<Int_Comparison_Exp>;
  payload?: Maybe<String_Comparison_Exp>;
  scheduled_departure?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<Flight_Plan_Statuses_Enum_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  type_cert_flight_analysis_data?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
  type_cert_manual_data?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
  upcoming?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  utm_provider?: Maybe<Flight_Plan_Utm_Providers_Enum_Comparison_Exp>;
  utm_registration?: Maybe<String_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_alerts?: Maybe<Vehicle_Alerts_Bool_Exp>;
  vehicle_flight_statuses?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_plans" */
export enum Flight_Plans_Constraint {
  /** unique or primary key constraint */
  FlightPlansMongoIdKey = 'flight_plans_mongo_id_key',
  /** unique or primary key constraint */
  FlightPlansPkey = 'flight_plans_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Flight_Plans_Delete_At_Path_Input = {
  airmap_rulesets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Flight_Plans_Delete_Elem_Input = {
  airmap_rulesets?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Flight_Plans_Delete_Key_Input = {
  airmap_rulesets?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "flight_plans" */
export type Flight_Plans_Inc_Input = {
  created_by_id?: Maybe<Scalars['Int']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  origin_station_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "flight_plans" */
export type Flight_Plans_Insert_Input = {
  aborted?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  air_traffic_deconfliction_algorithm?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Enum>;
  air_traffic_deconfliction_algorithm_type?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Obj_Rel_Insert_Input>;
  air_traffic_monitor_tasks?: Maybe<Air_Traffic_Monitor_Tasks_Arr_Rel_Insert_Input>;
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
  arrived_on?: Maybe<Scalars['timestamptz']>;
  contingencyLandingSpotByOriginContingencyLandingSpotId?: Maybe<Contingency_Landing_Spots_Obj_Rel_Insert_Input>;
  contingency_landing_spot?: Maybe<Contingency_Landing_Spots_Obj_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  current_air_traffic_proximity_recordings?: Maybe<Current_Air_Traffic_Proximity_Recordings_Arr_Rel_Insert_Input>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  departed_on?: Maybe<Scalars['timestamptz']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  destination_station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  file_assets?: Maybe<File_Assets_Arr_Rel_Insert_Input>;
  flight_derivation_reports?: Maybe<Flight_Derivation_Reports_Arr_Rel_Insert_Input>;
  flight_plan_pilot_assignments?: Maybe<Flight_Plan_Pilot_Assignments_Arr_Rel_Insert_Input>;
  flight_weather_data?: Maybe<Flight_Weather_Data_Arr_Rel_Insert_Input>;
  gufi?: Maybe<Scalars['String']>;
  historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Arr_Rel_Insert_Input>;
  historical_vehicle_positions?: Maybe<Historical_Vehicle_Positions_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  kafka_serialized_vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Arr_Rel_Insert_Input>;
  landing_requests?: Maybe<Landing_Requests_Arr_Rel_Insert_Input>;
  loaded?: Maybe<Scalars['Boolean']>;
  manifest?: Maybe<Manifests_Obj_Rel_Insert_Input>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  origin_station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  origin_station_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Paths_Obj_Rel_Insert_Input>;
  path_by_dest_contingency_path?: Maybe<Paths_Obj_Rel_Insert_Input>;
  path_by_origin_contingency_path?: Maybe<Paths_Obj_Rel_Insert_Input>;
  path_id?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['String']>;
  scheduled_departure?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Flight_Plan_Statuses_Enum>;
  title?: Maybe<Scalars['String']>;
  type_cert_flight_analysis_data?: Maybe<Type_Cert_Flight_Analysis_Data_Arr_Rel_Insert_Input>;
  type_cert_manual_data?: Maybe<Type_Cert_Manual_Data_Arr_Rel_Insert_Input>;
  upcoming?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  utm_provider?: Maybe<Flight_Plan_Utm_Providers_Enum>;
  utm_registration?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_alerts?: Maybe<Vehicle_Alerts_Arr_Rel_Insert_Input>;
  vehicle_flight_statuses?: Maybe<Vehicle_Flight_Statuses_Arr_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Flight_Plans_Max_Fields = {
  __typename?: 'flight_plans_max_fields';
  arrived_on?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  departed_on?: Maybe<Scalars['timestamptz']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  gufi?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  origin_station_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['String']>;
  scheduled_departure?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  utm_registration?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flight_plans" */
export type Flight_Plans_Max_Order_By = {
  arrived_on?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  departed_on?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  gufi?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  payload?: Maybe<Order_By>;
  scheduled_departure?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  utm_registration?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Plans_Min_Fields = {
  __typename?: 'flight_plans_min_fields';
  arrived_on?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  departed_on?: Maybe<Scalars['timestamptz']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  gufi?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  origin_station_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['String']>;
  scheduled_departure?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  utm_registration?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flight_plans" */
export type Flight_Plans_Min_Order_By = {
  arrived_on?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  departed_on?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  gufi?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  payload?: Maybe<Order_By>;
  scheduled_departure?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  utm_registration?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_plans" */
export type Flight_Plans_Mutation_Response = {
  __typename?: 'flight_plans_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Plans>;
};

/** input type for inserting object relation for remote table "flight_plans" */
export type Flight_Plans_Obj_Rel_Insert_Input = {
  data: Flight_Plans_Insert_Input;
  on_conflict?: Maybe<Flight_Plans_On_Conflict>;
};

/** on conflict condition type for table "flight_plans" */
export type Flight_Plans_On_Conflict = {
  constraint: Flight_Plans_Constraint;
  update_columns: Array<Flight_Plans_Update_Column>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};

/** ordering options when selecting data from "flight_plans" */
export type Flight_Plans_Order_By = {
  aborted?: Maybe<Order_By>;
  active?: Maybe<Order_By>;
  air_traffic_deconfliction_algorithm?: Maybe<Order_By>;
  air_traffic_deconfliction_algorithm_type?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Order_By>;
  air_traffic_monitor_tasks_aggregate?: Maybe<Air_Traffic_Monitor_Tasks_Aggregate_Order_By>;
  airmap_rulesets?: Maybe<Order_By>;
  arrived_on?: Maybe<Order_By>;
  contingencyLandingSpotByOriginContingencyLandingSpotId?: Maybe<Contingency_Landing_Spots_Order_By>;
  contingency_landing_spot?: Maybe<Contingency_Landing_Spots_Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  current_air_traffic_proximity_recordings_aggregate?: Maybe<Current_Air_Traffic_Proximity_Recordings_Aggregate_Order_By>;
  deleted_at?: Maybe<Order_By>;
  departed_on?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  destination_station?: Maybe<Stations_Order_By>;
  file_assets_aggregate?: Maybe<File_Assets_Aggregate_Order_By>;
  flight_derivation_reports_aggregate?: Maybe<Flight_Derivation_Reports_Aggregate_Order_By>;
  flight_plan_current_rpic_view?: Maybe<Flight_Plan_Current_Rpic_View_Order_By>;
  flight_plan_pilot_assignments_aggregate?: Maybe<Flight_Plan_Pilot_Assignments_Aggregate_Order_By>;
  flight_weather_data_aggregate?: Maybe<Flight_Weather_Data_Aggregate_Order_By>;
  gufi?: Maybe<Order_By>;
  historical_serialized_vehicle_statuses_aggregate?: Maybe<Historical_Serialized_Vehicle_Statuses_Aggregate_Order_By>;
  historical_vehicle_positions_aggregate?: Maybe<Historical_Vehicle_Positions_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  kafka_serialized_vehicle_statuses_aggregate?: Maybe<Kafka_Serialized_Vehicle_Statuses_Aggregate_Order_By>;
  landing_requests_aggregate?: Maybe<Landing_Requests_Aggregate_Order_By>;
  loaded?: Maybe<Order_By>;
  manifest?: Maybe<Manifests_Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station?: Maybe<Stations_Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path?: Maybe<Paths_Order_By>;
  path_by_dest_contingency_path?: Maybe<Paths_Order_By>;
  path_by_origin_contingency_path?: Maybe<Paths_Order_By>;
  path_id?: Maybe<Order_By>;
  payload?: Maybe<Order_By>;
  scheduled_departure?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  type_cert_flight_analysis_data_aggregate?: Maybe<Type_Cert_Flight_Analysis_Data_Aggregate_Order_By>;
  type_cert_manual_data_aggregate?: Maybe<Type_Cert_Manual_Data_Aggregate_Order_By>;
  upcoming?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  utm_provider?: Maybe<Order_By>;
  utm_registration?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_alerts_aggregate?: Maybe<Vehicle_Alerts_Aggregate_Order_By>;
  vehicle_flight_statuses_aggregate?: Maybe<Vehicle_Flight_Statuses_Aggregate_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_priority_events_aggregate?: Maybe<Vehicle_Priority_Events_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_plans" */
export type Flight_Plans_Pk_Columns_Input = {
  /** UID of the flight plan. */
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Flight_Plans_Prepend_Input = {
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "flight_plans" */
export enum Flight_Plans_Select_Column {
  /** column name */
  Aborted = 'aborted',
  /** column name */
  Active = 'active',
  /** column name */
  AirTrafficDeconflictionAlgorithm = 'air_traffic_deconfliction_algorithm',
  /** column name */
  AirmapRulesets = 'airmap_rulesets',
  /** column name */
  ArrivedOn = 'arrived_on',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartedOn = 'departed_on',
  /** column name */
  DestContingencyLandingSpotId = 'dest_contingency_landing_spot_id',
  /** column name */
  DestContingencyPathId = 'dest_contingency_path_id',
  /** column name */
  DestStationId = 'dest_station_id',
  /** column name */
  Gufi = 'gufi',
  /** column name */
  Id = 'id',
  /** column name */
  Loaded = 'loaded',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  MissionCount = 'mission_count',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginContingencyLandingSpotId = 'origin_contingency_landing_spot_id',
  /** column name */
  OriginContingencyPathId = 'origin_contingency_path_id',
  /** column name */
  OriginStationId = 'origin_station_id',
  /** column name */
  PathId = 'path_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  ScheduledDeparture = 'scheduled_departure',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Upcoming = 'upcoming',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmProvider = 'utm_provider',
  /** column name */
  UtmRegistration = 'utm_registration',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "flight_plans" */
export type Flight_Plans_Set_Input = {
  aborted?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  air_traffic_deconfliction_algorithm?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Enum>;
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
  arrived_on?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  departed_on?: Maybe<Scalars['timestamptz']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  gufi?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  loaded?: Maybe<Scalars['Boolean']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  origin_station_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['String']>;
  scheduled_departure?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Flight_Plan_Statuses_Enum>;
  title?: Maybe<Scalars['String']>;
  upcoming?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  utm_provider?: Maybe<Flight_Plan_Utm_Providers_Enum>;
  utm_registration?: Maybe<Scalars['String']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Flight_Plans_Stddev_Fields = {
  __typename?: 'flight_plans_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_plans" */
export type Flight_Plans_Stddev_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Plans_Stddev_Pop_Fields = {
  __typename?: 'flight_plans_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_plans" */
export type Flight_Plans_Stddev_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Plans_Stddev_Samp_Fields = {
  __typename?: 'flight_plans_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_plans" */
export type Flight_Plans_Stddev_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Plans_Sum_Fields = {
  __typename?: 'flight_plans_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  dest_contingency_path_id?: Maybe<Scalars['Int']>;
  dest_station_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mission_count?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Int']>;
  origin_contingency_path_id?: Maybe<Scalars['Int']>;
  origin_station_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flight_plans" */
export type Flight_Plans_Sum_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "flight_plans" */
export enum Flight_Plans_Update_Column {
  /** column name */
  Aborted = 'aborted',
  /** column name */
  Active = 'active',
  /** column name */
  AirTrafficDeconflictionAlgorithm = 'air_traffic_deconfliction_algorithm',
  /** column name */
  AirmapRulesets = 'airmap_rulesets',
  /** column name */
  ArrivedOn = 'arrived_on',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DepartedOn = 'departed_on',
  /** column name */
  DestContingencyLandingSpotId = 'dest_contingency_landing_spot_id',
  /** column name */
  DestContingencyPathId = 'dest_contingency_path_id',
  /** column name */
  DestStationId = 'dest_station_id',
  /** column name */
  Gufi = 'gufi',
  /** column name */
  Id = 'id',
  /** column name */
  Loaded = 'loaded',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  MissionCount = 'mission_count',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginContingencyLandingSpotId = 'origin_contingency_landing_spot_id',
  /** column name */
  OriginContingencyPathId = 'origin_contingency_path_id',
  /** column name */
  OriginStationId = 'origin_station_id',
  /** column name */
  PathId = 'path_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  ScheduledDeparture = 'scheduled_departure',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Upcoming = 'upcoming',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmProvider = 'utm_provider',
  /** column name */
  UtmRegistration = 'utm_registration',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Flight_Plans_Var_Pop_Fields = {
  __typename?: 'flight_plans_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_plans" */
export type Flight_Plans_Var_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Plans_Var_Samp_Fields = {
  __typename?: 'flight_plans_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_plans" */
export type Flight_Plans_Var_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Plans_Variance_Fields = {
  __typename?: 'flight_plans_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  dest_contingency_path_id?: Maybe<Scalars['Float']>;
  dest_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  mission_count?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_contingency_landing_spot_id?: Maybe<Scalars['Float']>;
  origin_contingency_path_id?: Maybe<Scalars['Float']>;
  origin_station_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_plans" */
export type Flight_Plans_Variance_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_contingency_landing_spot_id?: Maybe<Order_By>;
  dest_contingency_path_id?: Maybe<Order_By>;
  dest_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mission_count?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_contingency_landing_spot_id?: Maybe<Order_By>;
  origin_contingency_path_id?: Maybe<Order_By>;
  origin_station_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/**
 * Table containing the possible pre-planned flight paths available for vehicles to fly.
 *
 *
 * columns and relationships of "flight_routes"
 */
export type Flight_Routes = {
  __typename?: 'flight_routes';
  active_utc_end?: Maybe<Scalars['time']>;
  active_utc_start?: Maybe<Scalars['time']>;
  created_at: Scalars['timestamptz'];
  created_by_id: Scalars['Int'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  dest_airspace?: Maybe<Airspaces>;
  /** UID of the destination airspace. */
  dest_airspace_id?: Maybe<Scalars['Int']>;
  /** UID of the flight route. */
  id: Scalars['Int'];
  mongo_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  network: Networks;
  /** UID of the operations network in which the flight route exists. */
  network_id: Scalars['Int'];
  /** An object relationship */
  origin_airspace?: Maybe<Airspaces>;
  /** UID of the origin airspace. */
  origin_airspace_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  path: Paths;
  path_id: Scalars['Int'];
  /** An object relationship */
  reverse_path: Paths;
  reverse_path_id: Scalars['Int'];
  safety_routes?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  version: Scalars['Int'];
};


/**
 * Table containing the possible pre-planned flight paths available for vehicles to fly.
 *
 *
 * columns and relationships of "flight_routes"
 */
export type Flight_RoutesSafety_RoutesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "flight_routes" */
export type Flight_Routes_Aggregate = {
  __typename?: 'flight_routes_aggregate';
  aggregate?: Maybe<Flight_Routes_Aggregate_Fields>;
  nodes: Array<Flight_Routes>;
};

/** aggregate fields of "flight_routes" */
export type Flight_Routes_Aggregate_Fields = {
  __typename?: 'flight_routes_aggregate_fields';
  avg?: Maybe<Flight_Routes_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Routes_Max_Fields>;
  min?: Maybe<Flight_Routes_Min_Fields>;
  stddev?: Maybe<Flight_Routes_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Routes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Routes_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Routes_Sum_Fields>;
  var_pop?: Maybe<Flight_Routes_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Routes_Var_Samp_Fields>;
  variance?: Maybe<Flight_Routes_Variance_Fields>;
};


/** aggregate fields of "flight_routes" */
export type Flight_Routes_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Routes_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_routes" */
export type Flight_Routes_Aggregate_Order_By = {
  avg?: Maybe<Flight_Routes_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Routes_Max_Order_By>;
  min?: Maybe<Flight_Routes_Min_Order_By>;
  stddev?: Maybe<Flight_Routes_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Routes_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Routes_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Routes_Sum_Order_By>;
  var_pop?: Maybe<Flight_Routes_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Routes_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Routes_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Flight_Routes_Append_Input = {
  safety_routes?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "flight_routes" */
export type Flight_Routes_Arr_Rel_Insert_Input = {
  data: Array<Flight_Routes_Insert_Input>;
  on_conflict?: Maybe<Flight_Routes_On_Conflict>;
};

/** aggregate avg on columns */
export type Flight_Routes_Avg_Fields = {
  __typename?: 'flight_routes_avg_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_routes" */
export type Flight_Routes_Avg_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_routes". All fields are combined with a logical 'AND'. */
export type Flight_Routes_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Routes_Bool_Exp>>>;
  _not?: Maybe<Flight_Routes_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Routes_Bool_Exp>>>;
  active_utc_end?: Maybe<Time_Comparison_Exp>;
  active_utc_start?: Maybe<Time_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Int_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  dest_airspace?: Maybe<Airspaces_Bool_Exp>;
  dest_airspace_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  origin_airspace?: Maybe<Airspaces_Bool_Exp>;
  origin_airspace_id?: Maybe<Int_Comparison_Exp>;
  path?: Maybe<Paths_Bool_Exp>;
  path_id?: Maybe<Int_Comparison_Exp>;
  reverse_path?: Maybe<Paths_Bool_Exp>;
  reverse_path_id?: Maybe<Int_Comparison_Exp>;
  safety_routes?: Maybe<Jsonb_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_routes" */
export enum Flight_Routes_Constraint {
  /** unique or primary key constraint */
  FlightRoutesMongoIdKey = 'flight_routes_mongo_id_key',
  /** unique or primary key constraint */
  FlightRoutesPkey = 'flight_routes_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Flight_Routes_Delete_At_Path_Input = {
  safety_routes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Flight_Routes_Delete_Elem_Input = {
  safety_routes?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Flight_Routes_Delete_Key_Input = {
  safety_routes?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "flight_routes" */
export type Flight_Routes_Inc_Input = {
  created_by_id?: Maybe<Scalars['Int']>;
  dest_airspace_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_airspace_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  reverse_path_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "flight_routes" */
export type Flight_Routes_Insert_Input = {
  active_utc_end?: Maybe<Scalars['time']>;
  active_utc_start?: Maybe<Scalars['time']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dest_airspace?: Maybe<Airspaces_Obj_Rel_Insert_Input>;
  dest_airspace_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  origin_airspace?: Maybe<Airspaces_Obj_Rel_Insert_Input>;
  origin_airspace_id?: Maybe<Scalars['Int']>;
  path?: Maybe<Paths_Obj_Rel_Insert_Input>;
  path_id?: Maybe<Scalars['Int']>;
  reverse_path?: Maybe<Paths_Obj_Rel_Insert_Input>;
  reverse_path_id?: Maybe<Scalars['Int']>;
  safety_routes?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Flight_Routes_Max_Fields = {
  __typename?: 'flight_routes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dest_airspace_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_airspace_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  reverse_path_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "flight_routes" */
export type Flight_Routes_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Routes_Min_Fields = {
  __typename?: 'flight_routes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dest_airspace_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_airspace_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  reverse_path_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "flight_routes" */
export type Flight_Routes_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_routes" */
export type Flight_Routes_Mutation_Response = {
  __typename?: 'flight_routes_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Routes>;
};

/** input type for inserting object relation for remote table "flight_routes" */
export type Flight_Routes_Obj_Rel_Insert_Input = {
  data: Flight_Routes_Insert_Input;
  on_conflict?: Maybe<Flight_Routes_On_Conflict>;
};

/** on conflict condition type for table "flight_routes" */
export type Flight_Routes_On_Conflict = {
  constraint: Flight_Routes_Constraint;
  update_columns: Array<Flight_Routes_Update_Column>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};

/** ordering options when selecting data from "flight_routes" */
export type Flight_Routes_Order_By = {
  active_utc_end?: Maybe<Order_By>;
  active_utc_start?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  dest_airspace?: Maybe<Airspaces_Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace?: Maybe<Airspaces_Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path?: Maybe<Paths_Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path?: Maybe<Paths_Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  safety_routes?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_routes" */
export type Flight_Routes_Pk_Columns_Input = {
  /** UID of the flight route. */
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Flight_Routes_Prepend_Input = {
  safety_routes?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "flight_routes" */
export enum Flight_Routes_Select_Column {
  /** column name */
  ActiveUtcEnd = 'active_utc_end',
  /** column name */
  ActiveUtcStart = 'active_utc_start',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DestAirspaceId = 'dest_airspace_id',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginAirspaceId = 'origin_airspace_id',
  /** column name */
  PathId = 'path_id',
  /** column name */
  ReversePathId = 'reverse_path_id',
  /** column name */
  SafetyRoutes = 'safety_routes',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "flight_routes" */
export type Flight_Routes_Set_Input = {
  active_utc_end?: Maybe<Scalars['time']>;
  active_utc_start?: Maybe<Scalars['time']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dest_airspace_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_airspace_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  reverse_path_id?: Maybe<Scalars['Int']>;
  safety_routes?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Flight_Routes_Stddev_Fields = {
  __typename?: 'flight_routes_stddev_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_routes" */
export type Flight_Routes_Stddev_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Routes_Stddev_Pop_Fields = {
  __typename?: 'flight_routes_stddev_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_routes" */
export type Flight_Routes_Stddev_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Routes_Stddev_Samp_Fields = {
  __typename?: 'flight_routes_stddev_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_routes" */
export type Flight_Routes_Stddev_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Routes_Sum_Fields = {
  __typename?: 'flight_routes_sum_fields';
  created_by_id?: Maybe<Scalars['Int']>;
  dest_airspace_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_airspace_id?: Maybe<Scalars['Int']>;
  path_id?: Maybe<Scalars['Int']>;
  reverse_path_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "flight_routes" */
export type Flight_Routes_Sum_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "flight_routes" */
export enum Flight_Routes_Update_Column {
  /** column name */
  ActiveUtcEnd = 'active_utc_end',
  /** column name */
  ActiveUtcStart = 'active_utc_start',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DestAirspaceId = 'dest_airspace_id',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginAirspaceId = 'origin_airspace_id',
  /** column name */
  PathId = 'path_id',
  /** column name */
  ReversePathId = 'reverse_path_id',
  /** column name */
  SafetyRoutes = 'safety_routes',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Flight_Routes_Var_Pop_Fields = {
  __typename?: 'flight_routes_var_pop_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_routes" */
export type Flight_Routes_Var_Pop_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Routes_Var_Samp_Fields = {
  __typename?: 'flight_routes_var_samp_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_routes" */
export type Flight_Routes_Var_Samp_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Routes_Variance_Fields = {
  __typename?: 'flight_routes_variance_fields';
  created_by_id?: Maybe<Scalars['Float']>;
  dest_airspace_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_airspace_id?: Maybe<Scalars['Float']>;
  path_id?: Maybe<Scalars['Float']>;
  reverse_path_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_routes" */
export type Flight_Routes_Variance_Order_By = {
  created_by_id?: Maybe<Order_By>;
  dest_airspace_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_airspace_id?: Maybe<Order_By>;
  path_id?: Maybe<Order_By>;
  reverse_path_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "flight_weather_data" */
export type Flight_Weather_Data = {
  __typename?: 'flight_weather_data';
  created_at: Scalars['timestamptz'];
  /** Dew point reading in degrees Celsius */
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  /** Elevation of the reading sensor in meters */
  elevation_meters?: Maybe<Scalars['float8']>;
  /** An object relationship */
  flight_plan: Flight_Plans;
  /** Flight plan ID corresponding to the record */
  flight_plan_id: Scalars['Int'];
  /** Relative humidity reading as a percentage */
  humidity?: Maybe<Scalars['float8']>;
  id: Scalars['Int'];
  /** Latitude of the weather sensor in degrees */
  latitude_degrees?: Maybe<Scalars['float8']>;
  /** Longitude of the weather sensor in degrees */
  longitude_degrees?: Maybe<Scalars['float8']>;
  /** Timestamp from the METAR observation. */
  metar_timestamp_utc?: Maybe<Scalars['String']>;
  /** Observation type. MANUAL or AUTO. */
  observation_type?: Maybe<Scalars['String']>;
  /** Observed sky conditions. */
  observed_sky_conditions?: Maybe<Scalars['String']>;
  /** Observed turbulence. */
  observed_turbulence?: Maybe<Scalars['String']>;
  /** Observed visibility. */
  observed_visibility?: Maybe<Scalars['String']>;
  /** User ID associated with the observer who submitted the observations */
  observer_user_id?: Maybe<Scalars['Int']>;
  /** Rate of precipitation - instantaneous precipitation rate.  How much rain would fall if the precipitation intensity did not change for one hour */
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  /** Accumulated precipitation for today from midnight to present. */
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  /** Air pressure in units of millibars. */
  pressure_millibars?: Maybe<Scalars['float8']>;
  /** Density altitude in meters computed from the measurements available from the Personal Weather Station. */
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  /** Wind Gust - sudden and temporary variations of the average Wind Speed. The report always shows the maximum wind gust speed recorded during the observation period. */
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  /** Wind Speed - The wind is treated as a vector; hence, winds must have direction and magnitude (speed). The wind information reported in the hourly current conditions corresponds to a 10-minute average called the sustained wind speed. */
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  /** Raw METAR collected for the record, if applicable */
  raw_metar?: Maybe<Scalars['String']>;
  /** Station ID from which the weather record was collected */
  station_identifier?: Maybe<Scalars['String']>;
  /** Temperature in degrees celsius */
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
  /** Timestamp of the observation in seconds relative to the unix epoch */
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  /** Wind chill temperature in degrees celsius */
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  /** Direction of the wind in degrees */
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "flight_weather_data" */
export type Flight_Weather_Data_Aggregate = {
  __typename?: 'flight_weather_data_aggregate';
  aggregate?: Maybe<Flight_Weather_Data_Aggregate_Fields>;
  nodes: Array<Flight_Weather_Data>;
};

/** aggregate fields of "flight_weather_data" */
export type Flight_Weather_Data_Aggregate_Fields = {
  __typename?: 'flight_weather_data_aggregate_fields';
  avg?: Maybe<Flight_Weather_Data_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Flight_Weather_Data_Max_Fields>;
  min?: Maybe<Flight_Weather_Data_Min_Fields>;
  stddev?: Maybe<Flight_Weather_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Flight_Weather_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Flight_Weather_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Flight_Weather_Data_Sum_Fields>;
  var_pop?: Maybe<Flight_Weather_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Flight_Weather_Data_Var_Samp_Fields>;
  variance?: Maybe<Flight_Weather_Data_Variance_Fields>;
};


/** aggregate fields of "flight_weather_data" */
export type Flight_Weather_Data_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "flight_weather_data" */
export type Flight_Weather_Data_Aggregate_Order_By = {
  avg?: Maybe<Flight_Weather_Data_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Flight_Weather_Data_Max_Order_By>;
  min?: Maybe<Flight_Weather_Data_Min_Order_By>;
  stddev?: Maybe<Flight_Weather_Data_Stddev_Order_By>;
  stddev_pop?: Maybe<Flight_Weather_Data_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Flight_Weather_Data_Stddev_Samp_Order_By>;
  sum?: Maybe<Flight_Weather_Data_Sum_Order_By>;
  var_pop?: Maybe<Flight_Weather_Data_Var_Pop_Order_By>;
  var_samp?: Maybe<Flight_Weather_Data_Var_Samp_Order_By>;
  variance?: Maybe<Flight_Weather_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "flight_weather_data" */
export type Flight_Weather_Data_Arr_Rel_Insert_Input = {
  data: Array<Flight_Weather_Data_Insert_Input>;
  on_conflict?: Maybe<Flight_Weather_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Flight_Weather_Data_Avg_Fields = {
  __typename?: 'flight_weather_data_avg_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Avg_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "flight_weather_data". All fields are combined with a logical 'AND'. */
export type Flight_Weather_Data_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Flight_Weather_Data_Bool_Exp>>>;
  _not?: Maybe<Flight_Weather_Data_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Flight_Weather_Data_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  dew_point_degrees_celsius?: Maybe<Float8_Comparison_Exp>;
  elevation_meters?: Maybe<Float8_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  humidity?: Maybe<Float8_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  latitude_degrees?: Maybe<Float8_Comparison_Exp>;
  longitude_degrees?: Maybe<Float8_Comparison_Exp>;
  metar_timestamp_utc?: Maybe<String_Comparison_Exp>;
  observation_type?: Maybe<String_Comparison_Exp>;
  observed_sky_conditions?: Maybe<String_Comparison_Exp>;
  observed_turbulence?: Maybe<String_Comparison_Exp>;
  observed_visibility?: Maybe<String_Comparison_Exp>;
  observer_user_id?: Maybe<Int_Comparison_Exp>;
  precipitation_rate_millimeters_per_hour?: Maybe<Float8_Comparison_Exp>;
  precipitation_total_millimeters?: Maybe<Float8_Comparison_Exp>;
  pressure_millibars?: Maybe<Float8_Comparison_Exp>;
  pws_computed_density_altitude_meters?: Maybe<Float8_Comparison_Exp>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Float8_Comparison_Exp>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Float8_Comparison_Exp>;
  raw_metar?: Maybe<String_Comparison_Exp>;
  station_identifier?: Maybe<String_Comparison_Exp>;
  temperature_degrees_celsius?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
  weather_station_observation_unix_epoch?: Maybe<Int_Comparison_Exp>;
  wind_chill_degrees_celsius?: Maybe<Float8_Comparison_Exp>;
  wind_direction_degrees?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "flight_weather_data" */
export enum Flight_Weather_Data_Constraint {
  /** unique or primary key constraint */
  FlightWeatherDataPkey = 'flight_weather_data_pkey'
}

/** input type for incrementing integer column in table "flight_weather_data" */
export type Flight_Weather_Data_Inc_Input = {
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  elevation_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  humidity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  latitude_degrees?: Maybe<Scalars['float8']>;
  longitude_degrees?: Maybe<Scalars['float8']>;
  observer_user_id?: Maybe<Scalars['Int']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  pressure_millibars?: Maybe<Scalars['float8']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  version?: Maybe<Scalars['Int']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "flight_weather_data" */
export type Flight_Weather_Data_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  elevation_meters?: Maybe<Scalars['float8']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  humidity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  latitude_degrees?: Maybe<Scalars['float8']>;
  longitude_degrees?: Maybe<Scalars['float8']>;
  metar_timestamp_utc?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  observed_sky_conditions?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  observed_visibility?: Maybe<Scalars['String']>;
  observer_user_id?: Maybe<Scalars['Int']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  pressure_millibars?: Maybe<Scalars['float8']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  raw_metar?: Maybe<Scalars['String']>;
  station_identifier?: Maybe<Scalars['String']>;
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Flight_Weather_Data_Max_Fields = {
  __typename?: 'flight_weather_data_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  elevation_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  humidity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  latitude_degrees?: Maybe<Scalars['float8']>;
  longitude_degrees?: Maybe<Scalars['float8']>;
  metar_timestamp_utc?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  observed_sky_conditions?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  observed_visibility?: Maybe<Scalars['String']>;
  observer_user_id?: Maybe<Scalars['Int']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  pressure_millibars?: Maybe<Scalars['float8']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  raw_metar?: Maybe<Scalars['String']>;
  station_identifier?: Maybe<Scalars['String']>;
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  metar_timestamp_utc?: Maybe<Order_By>;
  observation_type?: Maybe<Order_By>;
  observed_sky_conditions?: Maybe<Order_By>;
  observed_turbulence?: Maybe<Order_By>;
  observed_visibility?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  raw_metar?: Maybe<Order_By>;
  station_identifier?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Flight_Weather_Data_Min_Fields = {
  __typename?: 'flight_weather_data_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  elevation_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  humidity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  latitude_degrees?: Maybe<Scalars['float8']>;
  longitude_degrees?: Maybe<Scalars['float8']>;
  metar_timestamp_utc?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  observed_sky_conditions?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  observed_visibility?: Maybe<Scalars['String']>;
  observer_user_id?: Maybe<Scalars['Int']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  pressure_millibars?: Maybe<Scalars['float8']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  raw_metar?: Maybe<Scalars['String']>;
  station_identifier?: Maybe<Scalars['String']>;
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  metar_timestamp_utc?: Maybe<Order_By>;
  observation_type?: Maybe<Order_By>;
  observed_sky_conditions?: Maybe<Order_By>;
  observed_turbulence?: Maybe<Order_By>;
  observed_visibility?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  raw_metar?: Maybe<Order_By>;
  station_identifier?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** response of any mutation on the table "flight_weather_data" */
export type Flight_Weather_Data_Mutation_Response = {
  __typename?: 'flight_weather_data_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Flight_Weather_Data>;
};

/** input type for inserting object relation for remote table "flight_weather_data" */
export type Flight_Weather_Data_Obj_Rel_Insert_Input = {
  data: Flight_Weather_Data_Insert_Input;
  on_conflict?: Maybe<Flight_Weather_Data_On_Conflict>;
};

/** on conflict condition type for table "flight_weather_data" */
export type Flight_Weather_Data_On_Conflict = {
  constraint: Flight_Weather_Data_Constraint;
  update_columns: Array<Flight_Weather_Data_Update_Column>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};

/** ordering options when selecting data from "flight_weather_data" */
export type Flight_Weather_Data_Order_By = {
  created_at?: Maybe<Order_By>;
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  metar_timestamp_utc?: Maybe<Order_By>;
  observation_type?: Maybe<Order_By>;
  observed_sky_conditions?: Maybe<Order_By>;
  observed_turbulence?: Maybe<Order_By>;
  observed_visibility?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  raw_metar?: Maybe<Order_By>;
  station_identifier?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** primary key columns input for table: "flight_weather_data" */
export type Flight_Weather_Data_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "flight_weather_data" */
export enum Flight_Weather_Data_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DewPointDegreesCelsius = 'dew_point_degrees_celsius',
  /** column name */
  ElevationMeters = 'elevation_meters',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Humidity = 'humidity',
  /** column name */
  Id = 'id',
  /** column name */
  LatitudeDegrees = 'latitude_degrees',
  /** column name */
  LongitudeDegrees = 'longitude_degrees',
  /** column name */
  MetarTimestampUtc = 'metar_timestamp_utc',
  /** column name */
  ObservationType = 'observation_type',
  /** column name */
  ObservedSkyConditions = 'observed_sky_conditions',
  /** column name */
  ObservedTurbulence = 'observed_turbulence',
  /** column name */
  ObservedVisibility = 'observed_visibility',
  /** column name */
  ObserverUserId = 'observer_user_id',
  /** column name */
  PrecipitationRateMillimetersPerHour = 'precipitation_rate_millimeters_per_hour',
  /** column name */
  PrecipitationTotalMillimeters = 'precipitation_total_millimeters',
  /** column name */
  PressureMillibars = 'pressure_millibars',
  /** column name */
  PwsComputedDensityAltitudeMeters = 'pws_computed_density_altitude_meters',
  /** column name */
  PwsWindGustKilometersPerHour = 'pws_wind_gust_kilometers_per_hour',
  /** column name */
  PwsWindSpeedKilometersPerHour = 'pws_wind_speed_kilometers_per_hour',
  /** column name */
  RawMetar = 'raw_metar',
  /** column name */
  StationIdentifier = 'station_identifier',
  /** column name */
  TemperatureDegreesCelsius = 'temperature_degrees_celsius',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  WeatherStationObservationUnixEpoch = 'weather_station_observation_unix_epoch',
  /** column name */
  WindChillDegreesCelsius = 'wind_chill_degrees_celsius',
  /** column name */
  WindDirectionDegrees = 'wind_direction_degrees'
}

/** input type for updating data in table "flight_weather_data" */
export type Flight_Weather_Data_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  elevation_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  humidity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  latitude_degrees?: Maybe<Scalars['float8']>;
  longitude_degrees?: Maybe<Scalars['float8']>;
  metar_timestamp_utc?: Maybe<Scalars['String']>;
  observation_type?: Maybe<Scalars['String']>;
  observed_sky_conditions?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  observed_visibility?: Maybe<Scalars['String']>;
  observer_user_id?: Maybe<Scalars['Int']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  pressure_millibars?: Maybe<Scalars['float8']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  raw_metar?: Maybe<Scalars['String']>;
  station_identifier?: Maybe<Scalars['String']>;
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Flight_Weather_Data_Stddev_Fields = {
  __typename?: 'flight_weather_data_stddev_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Stddev_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Flight_Weather_Data_Stddev_Pop_Fields = {
  __typename?: 'flight_weather_data_stddev_pop_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Stddev_Pop_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Flight_Weather_Data_Stddev_Samp_Fields = {
  __typename?: 'flight_weather_data_stddev_samp_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Stddev_Samp_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Flight_Weather_Data_Sum_Fields = {
  __typename?: 'flight_weather_data_sum_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['float8']>;
  elevation_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  humidity?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  latitude_degrees?: Maybe<Scalars['float8']>;
  longitude_degrees?: Maybe<Scalars['float8']>;
  observer_user_id?: Maybe<Scalars['Int']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['float8']>;
  precipitation_total_millimeters?: Maybe<Scalars['float8']>;
  pressure_millibars?: Maybe<Scalars['float8']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['float8']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['float8']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['float8']>;
  temperature_degrees_celsius?: Maybe<Scalars['float8']>;
  version?: Maybe<Scalars['Int']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Int']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['float8']>;
  wind_direction_degrees?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Sum_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** update columns of table "flight_weather_data" */
export enum Flight_Weather_Data_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DewPointDegreesCelsius = 'dew_point_degrees_celsius',
  /** column name */
  ElevationMeters = 'elevation_meters',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Humidity = 'humidity',
  /** column name */
  Id = 'id',
  /** column name */
  LatitudeDegrees = 'latitude_degrees',
  /** column name */
  LongitudeDegrees = 'longitude_degrees',
  /** column name */
  MetarTimestampUtc = 'metar_timestamp_utc',
  /** column name */
  ObservationType = 'observation_type',
  /** column name */
  ObservedSkyConditions = 'observed_sky_conditions',
  /** column name */
  ObservedTurbulence = 'observed_turbulence',
  /** column name */
  ObservedVisibility = 'observed_visibility',
  /** column name */
  ObserverUserId = 'observer_user_id',
  /** column name */
  PrecipitationRateMillimetersPerHour = 'precipitation_rate_millimeters_per_hour',
  /** column name */
  PrecipitationTotalMillimeters = 'precipitation_total_millimeters',
  /** column name */
  PressureMillibars = 'pressure_millibars',
  /** column name */
  PwsComputedDensityAltitudeMeters = 'pws_computed_density_altitude_meters',
  /** column name */
  PwsWindGustKilometersPerHour = 'pws_wind_gust_kilometers_per_hour',
  /** column name */
  PwsWindSpeedKilometersPerHour = 'pws_wind_speed_kilometers_per_hour',
  /** column name */
  RawMetar = 'raw_metar',
  /** column name */
  StationIdentifier = 'station_identifier',
  /** column name */
  TemperatureDegreesCelsius = 'temperature_degrees_celsius',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  WeatherStationObservationUnixEpoch = 'weather_station_observation_unix_epoch',
  /** column name */
  WindChillDegreesCelsius = 'wind_chill_degrees_celsius',
  /** column name */
  WindDirectionDegrees = 'wind_direction_degrees'
}

/** aggregate var_pop on columns */
export type Flight_Weather_Data_Var_Pop_Fields = {
  __typename?: 'flight_weather_data_var_pop_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Var_Pop_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Flight_Weather_Data_Var_Samp_Fields = {
  __typename?: 'flight_weather_data_var_samp_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Var_Samp_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Flight_Weather_Data_Variance_Fields = {
  __typename?: 'flight_weather_data_variance_fields';
  dew_point_degrees_celsius?: Maybe<Scalars['Float']>;
  elevation_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  humidity?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  latitude_degrees?: Maybe<Scalars['Float']>;
  longitude_degrees?: Maybe<Scalars['Float']>;
  observer_user_id?: Maybe<Scalars['Float']>;
  precipitation_rate_millimeters_per_hour?: Maybe<Scalars['Float']>;
  precipitation_total_millimeters?: Maybe<Scalars['Float']>;
  pressure_millibars?: Maybe<Scalars['Float']>;
  pws_computed_density_altitude_meters?: Maybe<Scalars['Float']>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Scalars['Float']>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Scalars['Float']>;
  temperature_degrees_celsius?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  weather_station_observation_unix_epoch?: Maybe<Scalars['Float']>;
  wind_chill_degrees_celsius?: Maybe<Scalars['Float']>;
  wind_direction_degrees?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "flight_weather_data" */
export type Flight_Weather_Data_Variance_Order_By = {
  dew_point_degrees_celsius?: Maybe<Order_By>;
  elevation_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  humidity?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  latitude_degrees?: Maybe<Order_By>;
  longitude_degrees?: Maybe<Order_By>;
  observer_user_id?: Maybe<Order_By>;
  precipitation_rate_millimeters_per_hour?: Maybe<Order_By>;
  precipitation_total_millimeters?: Maybe<Order_By>;
  pressure_millibars?: Maybe<Order_By>;
  pws_computed_density_altitude_meters?: Maybe<Order_By>;
  pws_wind_gust_kilometers_per_hour?: Maybe<Order_By>;
  pws_wind_speed_kilometers_per_hour?: Maybe<Order_By>;
  temperature_degrees_celsius?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  weather_station_observation_unix_epoch?: Maybe<Order_By>;
  wind_chill_degrees_celsius?: Maybe<Order_By>;
  wind_direction_degrees?: Maybe<Order_By>;
};


/** expression to compare columns of type float8. All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};


/** Expression to compare the result of casting a column of type geography. Multiple cast targets are combined with logical 'AND'. */
export type Geography_Cast_Exp = {
  geometry?: Maybe<Geometry_Comparison_Exp>;
};

/** expression to compare columns of type geography. All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: Maybe<Geography_Cast_Exp>;
  _eq?: Maybe<Scalars['geography']>;
  _gt?: Maybe<Scalars['geography']>;
  _gte?: Maybe<Scalars['geography']>;
  _in?: Maybe<Array<Scalars['geography']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['geography']>;
  _lte?: Maybe<Scalars['geography']>;
  _neq?: Maybe<Scalars['geography']>;
  _nin?: Maybe<Array<Scalars['geography']>>;
  /** is the column within a distance from a geography value */
  _st_d_within?: Maybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: Maybe<Scalars['geography']>;
};


/** Expression to compare the result of casting a column of type geometry. Multiple cast targets are combined with logical 'AND'. */
export type Geometry_Cast_Exp = {
  geography?: Maybe<Geography_Comparison_Exp>;
};

/** expression to compare columns of type geometry. All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: Maybe<Geometry_Cast_Exp>;
  _eq?: Maybe<Scalars['geometry']>;
  _gt?: Maybe<Scalars['geometry']>;
  _gte?: Maybe<Scalars['geometry']>;
  _in?: Maybe<Array<Scalars['geometry']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['geometry']>;
  _lte?: Maybe<Scalars['geometry']>;
  _neq?: Maybe<Scalars['geometry']>;
  _nin?: Maybe<Array<Scalars['geometry']>>;
  /** does the column contain the given geometry value */
  _st_contains?: Maybe<Scalars['geometry']>;
  /** does the column crosses the given geometry value */
  _st_crosses?: Maybe<Scalars['geometry']>;
  /** is the column within a distance from a geometry value */
  _st_d_within?: Maybe<St_D_Within_Input>;
  /** is the column equal to given geometry value. Directionality is ignored */
  _st_equals?: Maybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: Maybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: Maybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: Maybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: Maybe<Scalars['geometry']>;
};

/** columns and relationships of "ground_asset_commands" */
export type Ground_Asset_Commands = {
  __typename?: 'ground_asset_commands';
  accepted?: Maybe<Scalars['Boolean']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dispatcher_id?: Maybe<Scalars['Int']>;
  dispatcher_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  ground_asset?: Maybe<Ground_Assets>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  status_reported?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "ground_asset_commands" */
export type Ground_Asset_Commands_Aggregate = {
  __typename?: 'ground_asset_commands_aggregate';
  aggregate?: Maybe<Ground_Asset_Commands_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Commands>;
};

/** aggregate fields of "ground_asset_commands" */
export type Ground_Asset_Commands_Aggregate_Fields = {
  __typename?: 'ground_asset_commands_aggregate_fields';
  avg?: Maybe<Ground_Asset_Commands_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Commands_Max_Fields>;
  min?: Maybe<Ground_Asset_Commands_Min_Fields>;
  stddev?: Maybe<Ground_Asset_Commands_Stddev_Fields>;
  stddev_pop?: Maybe<Ground_Asset_Commands_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ground_Asset_Commands_Stddev_Samp_Fields>;
  sum?: Maybe<Ground_Asset_Commands_Sum_Fields>;
  var_pop?: Maybe<Ground_Asset_Commands_Var_Pop_Fields>;
  var_samp?: Maybe<Ground_Asset_Commands_Var_Samp_Fields>;
  variance?: Maybe<Ground_Asset_Commands_Variance_Fields>;
};


/** aggregate fields of "ground_asset_commands" */
export type Ground_Asset_Commands_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_commands" */
export type Ground_Asset_Commands_Aggregate_Order_By = {
  avg?: Maybe<Ground_Asset_Commands_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Commands_Max_Order_By>;
  min?: Maybe<Ground_Asset_Commands_Min_Order_By>;
  stddev?: Maybe<Ground_Asset_Commands_Stddev_Order_By>;
  stddev_pop?: Maybe<Ground_Asset_Commands_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Ground_Asset_Commands_Stddev_Samp_Order_By>;
  sum?: Maybe<Ground_Asset_Commands_Sum_Order_By>;
  var_pop?: Maybe<Ground_Asset_Commands_Var_Pop_Order_By>;
  var_samp?: Maybe<Ground_Asset_Commands_Var_Samp_Order_By>;
  variance?: Maybe<Ground_Asset_Commands_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_commands" */
export type Ground_Asset_Commands_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Commands_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Commands_On_Conflict>;
};

/** aggregate avg on columns */
export type Ground_Asset_Commands_Avg_Fields = {
  __typename?: 'ground_asset_commands_avg_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Avg_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ground_asset_commands". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Commands_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Commands_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Commands_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Commands_Bool_Exp>>>;
  accepted?: Maybe<Boolean_Comparison_Exp>;
  acknowledged?: Maybe<Boolean_Comparison_Exp>;
  argument?: Maybe<String_Comparison_Exp>;
  command?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  dispatcher_id?: Maybe<Int_Comparison_Exp>;
  dispatcher_type?: Maybe<String_Comparison_Exp>;
  ground_asset?: Maybe<Ground_Assets_Bool_Exp>;
  ground_asset_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  status_message?: Maybe<String_Comparison_Exp>;
  status_reported?: Maybe<Boolean_Comparison_Exp>;
  successful?: Maybe<Boolean_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_commands" */
export enum Ground_Asset_Commands_Constraint {
  /** unique or primary key constraint */
  GroundAssetCommandsPkey = 'ground_asset_commands_pkey'
}

/** input type for incrementing integer column in table "ground_asset_commands" */
export type Ground_Asset_Commands_Inc_Input = {
  dispatcher_id?: Maybe<Scalars['Int']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "ground_asset_commands" */
export type Ground_Asset_Commands_Insert_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dispatcher_id?: Maybe<Scalars['Int']>;
  dispatcher_type?: Maybe<Scalars['String']>;
  ground_asset?: Maybe<Ground_Assets_Obj_Rel_Insert_Input>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  status_reported?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ground_Asset_Commands_Max_Fields = {
  __typename?: 'ground_asset_commands_max_fields';
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dispatcher_id?: Maybe<Scalars['Int']>;
  dispatcher_type?: Maybe<Scalars['String']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Max_Order_By = {
  argument?: Maybe<Order_By>;
  command?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  dispatcher_id?: Maybe<Order_By>;
  dispatcher_type?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  status_message?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Commands_Min_Fields = {
  __typename?: 'ground_asset_commands_min_fields';
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dispatcher_id?: Maybe<Scalars['Int']>;
  dispatcher_type?: Maybe<Scalars['String']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Min_Order_By = {
  argument?: Maybe<Order_By>;
  command?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  dispatcher_id?: Maybe<Order_By>;
  dispatcher_type?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  status_message?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_commands" */
export type Ground_Asset_Commands_Mutation_Response = {
  __typename?: 'ground_asset_commands_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Commands>;
};

/** input type for inserting object relation for remote table "ground_asset_commands" */
export type Ground_Asset_Commands_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Commands_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Commands_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_commands" */
export type Ground_Asset_Commands_On_Conflict = {
  constraint: Ground_Asset_Commands_Constraint;
  update_columns: Array<Ground_Asset_Commands_Update_Column>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_commands" */
export type Ground_Asset_Commands_Order_By = {
  accepted?: Maybe<Order_By>;
  acknowledged?: Maybe<Order_By>;
  argument?: Maybe<Order_By>;
  command?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  dispatcher_id?: Maybe<Order_By>;
  dispatcher_type?: Maybe<Order_By>;
  ground_asset?: Maybe<Ground_Assets_Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  status_message?: Maybe<Order_By>;
  status_reported?: Maybe<Order_By>;
  successful?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_commands" */
export type Ground_Asset_Commands_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ground_asset_commands" */
export enum Ground_Asset_Commands_Select_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  Acknowledged = 'acknowledged',
  /** column name */
  Argument = 'argument',
  /** column name */
  Command = 'command',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DispatcherId = 'dispatcher_id',
  /** column name */
  DispatcherType = 'dispatcher_type',
  /** column name */
  GroundAssetId = 'ground_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  StatusMessage = 'status_message',
  /** column name */
  StatusReported = 'status_reported',
  /** column name */
  Successful = 'successful',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "ground_asset_commands" */
export type Ground_Asset_Commands_Set_Input = {
  accepted?: Maybe<Scalars['Boolean']>;
  acknowledged?: Maybe<Scalars['Boolean']>;
  argument?: Maybe<Scalars['String']>;
  command?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  dispatcher_id?: Maybe<Scalars['Int']>;
  dispatcher_type?: Maybe<Scalars['String']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  status_message?: Maybe<Scalars['String']>;
  status_reported?: Maybe<Scalars['Boolean']>;
  successful?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ground_Asset_Commands_Stddev_Fields = {
  __typename?: 'ground_asset_commands_stddev_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Stddev_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ground_Asset_Commands_Stddev_Pop_Fields = {
  __typename?: 'ground_asset_commands_stddev_pop_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Stddev_Pop_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ground_Asset_Commands_Stddev_Samp_Fields = {
  __typename?: 'ground_asset_commands_stddev_samp_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Stddev_Samp_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Ground_Asset_Commands_Sum_Fields = {
  __typename?: 'ground_asset_commands_sum_fields';
  dispatcher_id?: Maybe<Scalars['Int']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Sum_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "ground_asset_commands" */
export enum Ground_Asset_Commands_Update_Column {
  /** column name */
  Accepted = 'accepted',
  /** column name */
  Acknowledged = 'acknowledged',
  /** column name */
  Argument = 'argument',
  /** column name */
  Command = 'command',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DispatcherId = 'dispatcher_id',
  /** column name */
  DispatcherType = 'dispatcher_type',
  /** column name */
  GroundAssetId = 'ground_asset_id',
  /** column name */
  Id = 'id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  StatusMessage = 'status_message',
  /** column name */
  StatusReported = 'status_reported',
  /** column name */
  Successful = 'successful',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Ground_Asset_Commands_Var_Pop_Fields = {
  __typename?: 'ground_asset_commands_var_pop_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Var_Pop_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ground_Asset_Commands_Var_Samp_Fields = {
  __typename?: 'ground_asset_commands_var_samp_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Var_Samp_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Ground_Asset_Commands_Variance_Fields = {
  __typename?: 'ground_asset_commands_variance_fields';
  dispatcher_id?: Maybe<Scalars['Float']>;
  ground_asset_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ground_asset_commands" */
export type Ground_Asset_Commands_Variance_Order_By = {
  dispatcher_id?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types = {
  __typename?: 'ground_asset_model_parameter_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Aggregate = {
  __typename?: 'ground_asset_model_parameter_types_aggregate';
  aggregate?: Maybe<Ground_Asset_Model_Parameter_Types_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Model_Parameter_Types>;
};

/** aggregate fields of "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Aggregate_Fields = {
  __typename?: 'ground_asset_model_parameter_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Model_Parameter_Types_Max_Fields>;
  min?: Maybe<Ground_Asset_Model_Parameter_Types_Min_Fields>;
};


/** aggregate fields of "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Model_Parameter_Types_Max_Order_By>;
  min?: Maybe<Ground_Asset_Model_Parameter_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Model_Parameter_Types_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Model_Parameter_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ground_asset_model_parameter_types". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Model_Parameter_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_model_parameter_types" */
export enum Ground_Asset_Model_Parameter_Types_Constraint {
  /** unique or primary key constraint */
  GroundAssetModelParameterTypesPkey = 'ground_asset_model_parameter_types_pkey'
}

export enum Ground_Asset_Model_Parameter_Types_Enum {
  /** Mavnet */
  Mavnet = 'Mavnet'
}

/** expression to compare columns of type ground_asset_model_parameter_types_enum. All fields are combined with logical 'AND'. */
export type Ground_Asset_Model_Parameter_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Ground_Asset_Model_Parameter_Types_Enum>;
  _in?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Ground_Asset_Model_Parameter_Types_Enum>;
  _nin?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Enum>>;
};

/** input type for inserting data into table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ground_Asset_Model_Parameter_Types_Max_Fields = {
  __typename?: 'ground_asset_model_parameter_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Model_Parameter_Types_Min_Fields = {
  __typename?: 'ground_asset_model_parameter_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Mutation_Response = {
  __typename?: 'ground_asset_model_parameter_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Model_Parameter_Types>;
};

/** input type for inserting object relation for remote table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Model_Parameter_Types_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Model_Parameter_Types_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_On_Conflict = {
  constraint: Ground_Asset_Model_Parameter_Types_Constraint;
  update_columns: Array<Ground_Asset_Model_Parameter_Types_Update_Column>;
  where?: Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ground_asset_model_parameter_types" */
export enum Ground_Asset_Model_Parameter_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ground_asset_model_parameter_types" */
export type Ground_Asset_Model_Parameter_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "ground_asset_model_parameter_types" */
export enum Ground_Asset_Model_Parameter_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters = {
  __typename?: 'ground_asset_model_parameters';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  ground_asset_model: Ground_Asset_Models;
  ground_asset_model_id: Scalars['Int'];
  id: Scalars['Int'];
  param_key: Scalars['String'];
  param_value?: Maybe<Scalars['String']>;
  type: Ground_Asset_Model_Parameter_Types_Enum;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Aggregate = {
  __typename?: 'ground_asset_model_parameters_aggregate';
  aggregate?: Maybe<Ground_Asset_Model_Parameters_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Model_Parameters>;
};

/** aggregate fields of "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Aggregate_Fields = {
  __typename?: 'ground_asset_model_parameters_aggregate_fields';
  avg?: Maybe<Ground_Asset_Model_Parameters_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Model_Parameters_Max_Fields>;
  min?: Maybe<Ground_Asset_Model_Parameters_Min_Fields>;
  stddev?: Maybe<Ground_Asset_Model_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<Ground_Asset_Model_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ground_Asset_Model_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<Ground_Asset_Model_Parameters_Sum_Fields>;
  var_pop?: Maybe<Ground_Asset_Model_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<Ground_Asset_Model_Parameters_Var_Samp_Fields>;
  variance?: Maybe<Ground_Asset_Model_Parameters_Variance_Fields>;
};


/** aggregate fields of "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Aggregate_Order_By = {
  avg?: Maybe<Ground_Asset_Model_Parameters_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Model_Parameters_Max_Order_By>;
  min?: Maybe<Ground_Asset_Model_Parameters_Min_Order_By>;
  stddev?: Maybe<Ground_Asset_Model_Parameters_Stddev_Order_By>;
  stddev_pop?: Maybe<Ground_Asset_Model_Parameters_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Ground_Asset_Model_Parameters_Stddev_Samp_Order_By>;
  sum?: Maybe<Ground_Asset_Model_Parameters_Sum_Order_By>;
  var_pop?: Maybe<Ground_Asset_Model_Parameters_Var_Pop_Order_By>;
  var_samp?: Maybe<Ground_Asset_Model_Parameters_Var_Samp_Order_By>;
  variance?: Maybe<Ground_Asset_Model_Parameters_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Model_Parameters_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Model_Parameters_On_Conflict>;
};

/** aggregate avg on columns */
export type Ground_Asset_Model_Parameters_Avg_Fields = {
  __typename?: 'ground_asset_model_parameters_avg_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Avg_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ground_asset_model_parameters". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Model_Parameters_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Model_Parameters_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Model_Parameters_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  ground_asset_model?: Maybe<Ground_Asset_Models_Bool_Exp>;
  ground_asset_model_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  param_key?: Maybe<String_Comparison_Exp>;
  param_value?: Maybe<String_Comparison_Exp>;
  type?: Maybe<Ground_Asset_Model_Parameter_Types_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_model_parameters" */
export enum Ground_Asset_Model_Parameters_Constraint {
  /** unique or primary key constraint */
  GroundAssetModelParametersGroundAssetModelIdTypeParam = 'ground_asset_model_parameters_ground_asset_model_id_type_param_',
  /** unique or primary key constraint */
  GroundAssetModelParametersPkey = 'ground_asset_model_parameters_pkey'
}

/** input type for incrementing integer column in table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Inc_Input = {
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model?: Maybe<Ground_Asset_Models_Obj_Rel_Insert_Input>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  type?: Maybe<Ground_Asset_Model_Parameter_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ground_Asset_Model_Parameters_Max_Fields = {
  __typename?: 'ground_asset_model_parameters_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  param_key?: Maybe<Order_By>;
  param_value?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Model_Parameters_Min_Fields = {
  __typename?: 'ground_asset_model_parameters_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  param_key?: Maybe<Order_By>;
  param_value?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Mutation_Response = {
  __typename?: 'ground_asset_model_parameters_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Model_Parameters>;
};

/** input type for inserting object relation for remote table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Model_Parameters_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Model_Parameters_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_On_Conflict = {
  constraint: Ground_Asset_Model_Parameters_Constraint;
  update_columns: Array<Ground_Asset_Model_Parameters_Update_Column>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_model?: Maybe<Ground_Asset_Models_Order_By>;
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  param_key?: Maybe<Order_By>;
  param_value?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ground_asset_model_parameters" */
export enum Ground_Asset_Model_Parameters_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GroundAssetModelId = 'ground_asset_model_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParamKey = 'param_key',
  /** column name */
  ParamValue = 'param_value',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  type?: Maybe<Ground_Asset_Model_Parameter_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ground_Asset_Model_Parameters_Stddev_Fields = {
  __typename?: 'ground_asset_model_parameters_stddev_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Stddev_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ground_Asset_Model_Parameters_Stddev_Pop_Fields = {
  __typename?: 'ground_asset_model_parameters_stddev_pop_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Stddev_Pop_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ground_Asset_Model_Parameters_Stddev_Samp_Fields = {
  __typename?: 'ground_asset_model_parameters_stddev_samp_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Stddev_Samp_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Ground_Asset_Model_Parameters_Sum_Fields = {
  __typename?: 'ground_asset_model_parameters_sum_fields';
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Sum_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "ground_asset_model_parameters" */
export enum Ground_Asset_Model_Parameters_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GroundAssetModelId = 'ground_asset_model_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParamKey = 'param_key',
  /** column name */
  ParamValue = 'param_value',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Ground_Asset_Model_Parameters_Var_Pop_Fields = {
  __typename?: 'ground_asset_model_parameters_var_pop_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Var_Pop_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ground_Asset_Model_Parameters_Var_Samp_Fields = {
  __typename?: 'ground_asset_model_parameters_var_samp_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Var_Samp_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Ground_Asset_Model_Parameters_Variance_Fields = {
  __typename?: 'ground_asset_model_parameters_variance_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ground_asset_model_parameters" */
export type Ground_Asset_Model_Parameters_Variance_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "ground_asset_model_types" */
export type Ground_Asset_Model_Types = {
  __typename?: 'ground_asset_model_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Aggregate = {
  __typename?: 'ground_asset_model_types_aggregate';
  aggregate?: Maybe<Ground_Asset_Model_Types_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Model_Types>;
};

/** aggregate fields of "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Aggregate_Fields = {
  __typename?: 'ground_asset_model_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Model_Types_Max_Fields>;
  min?: Maybe<Ground_Asset_Model_Types_Min_Fields>;
};


/** aggregate fields of "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Model_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Model_Types_Max_Order_By>;
  min?: Maybe<Ground_Asset_Model_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Model_Types_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Model_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ground_asset_model_types". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Model_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Model_Types_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Model_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Model_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_model_types" */
export enum Ground_Asset_Model_Types_Constraint {
  /** unique or primary key constraint */
  GroundAssetModelTypesPkey = 'ground_asset_model_types_pkey'
}

export enum Ground_Asset_Model_Types_Enum {
  /** PAD */
  Pad = 'PAD',
  /** STATION */
  Station = 'STATION'
}

/** expression to compare columns of type ground_asset_model_types_enum. All fields are combined with logical 'AND'. */
export type Ground_Asset_Model_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Ground_Asset_Model_Types_Enum>;
  _in?: Maybe<Array<Ground_Asset_Model_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Ground_Asset_Model_Types_Enum>;
  _nin?: Maybe<Array<Ground_Asset_Model_Types_Enum>>;
};

/** input type for inserting data into table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ground_Asset_Model_Types_Max_Fields = {
  __typename?: 'ground_asset_model_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Model_Types_Min_Fields = {
  __typename?: 'ground_asset_model_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Mutation_Response = {
  __typename?: 'ground_asset_model_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Model_Types>;
};

/** input type for inserting object relation for remote table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Model_Types_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Model_Types_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_On_Conflict = {
  constraint: Ground_Asset_Model_Types_Constraint;
  update_columns: Array<Ground_Asset_Model_Types_Update_Column>;
  where?: Maybe<Ground_Asset_Model_Types_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ground_asset_model_types" */
export enum Ground_Asset_Model_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ground_asset_model_types" */
export type Ground_Asset_Model_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "ground_asset_model_types" */
export enum Ground_Asset_Model_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "ground_asset_models" */
export type Ground_Asset_Models = {
  __typename?: 'ground_asset_models';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ground_asset_model_parameters: Array<Ground_Asset_Model_Parameters>;
  /** An aggregated array relationship */
  ground_asset_model_parameters_aggregate: Ground_Asset_Model_Parameters_Aggregate;
  /** An array relationship */
  ground_assets: Array<Ground_Assets>;
  /** An aggregated array relationship */
  ground_assets_aggregate: Ground_Assets_Aggregate;
  id: Scalars['Int'];
  mavnet_version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: Ground_Asset_Model_Types_Enum;
  updated_at: Scalars['timestamptz'];
  uwb_version?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};


/** columns and relationships of "ground_asset_models" */
export type Ground_Asset_ModelsGround_Asset_Model_ParametersArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameters_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};


/** columns and relationships of "ground_asset_models" */
export type Ground_Asset_ModelsGround_Asset_Model_Parameters_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameters_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};


/** columns and relationships of "ground_asset_models" */
export type Ground_Asset_ModelsGround_AssetsArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/** columns and relationships of "ground_asset_models" */
export type Ground_Asset_ModelsGround_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};

/** aggregated selection of "ground_asset_models" */
export type Ground_Asset_Models_Aggregate = {
  __typename?: 'ground_asset_models_aggregate';
  aggregate?: Maybe<Ground_Asset_Models_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Models>;
};

/** aggregate fields of "ground_asset_models" */
export type Ground_Asset_Models_Aggregate_Fields = {
  __typename?: 'ground_asset_models_aggregate_fields';
  avg?: Maybe<Ground_Asset_Models_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Models_Max_Fields>;
  min?: Maybe<Ground_Asset_Models_Min_Fields>;
  stddev?: Maybe<Ground_Asset_Models_Stddev_Fields>;
  stddev_pop?: Maybe<Ground_Asset_Models_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ground_Asset_Models_Stddev_Samp_Fields>;
  sum?: Maybe<Ground_Asset_Models_Sum_Fields>;
  var_pop?: Maybe<Ground_Asset_Models_Var_Pop_Fields>;
  var_samp?: Maybe<Ground_Asset_Models_Var_Samp_Fields>;
  variance?: Maybe<Ground_Asset_Models_Variance_Fields>;
};


/** aggregate fields of "ground_asset_models" */
export type Ground_Asset_Models_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Models_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_models" */
export type Ground_Asset_Models_Aggregate_Order_By = {
  avg?: Maybe<Ground_Asset_Models_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Models_Max_Order_By>;
  min?: Maybe<Ground_Asset_Models_Min_Order_By>;
  stddev?: Maybe<Ground_Asset_Models_Stddev_Order_By>;
  stddev_pop?: Maybe<Ground_Asset_Models_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Ground_Asset_Models_Stddev_Samp_Order_By>;
  sum?: Maybe<Ground_Asset_Models_Sum_Order_By>;
  var_pop?: Maybe<Ground_Asset_Models_Var_Pop_Order_By>;
  var_samp?: Maybe<Ground_Asset_Models_Var_Samp_Order_By>;
  variance?: Maybe<Ground_Asset_Models_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_models" */
export type Ground_Asset_Models_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Models_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Models_On_Conflict>;
};

/** aggregate avg on columns */
export type Ground_Asset_Models_Avg_Fields = {
  __typename?: 'ground_asset_models_avg_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Avg_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ground_asset_models". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Models_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Models_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Models_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Models_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  ground_asset_model_parameters?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
  ground_assets?: Maybe<Ground_Assets_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mavnet_version?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  type?: Maybe<Ground_Asset_Model_Types_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uwb_version?: Maybe<String_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_models" */
export enum Ground_Asset_Models_Constraint {
  /** unique or primary key constraint */
  GroundAssetModelsPkey = 'ground_asset_models_pkey'
}

/** input type for incrementing integer column in table "ground_asset_models" */
export type Ground_Asset_Models_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "ground_asset_models" */
export type Ground_Asset_Models_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_parameters?: Maybe<Ground_Asset_Model_Parameters_Arr_Rel_Insert_Input>;
  ground_assets?: Maybe<Ground_Assets_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  mavnet_version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Ground_Asset_Model_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ground_Asset_Models_Max_Fields = {
  __typename?: 'ground_asset_models_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mavnet_version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Models_Min_Fields = {
  __typename?: 'ground_asset_models_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mavnet_version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_models" */
export type Ground_Asset_Models_Mutation_Response = {
  __typename?: 'ground_asset_models_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Models>;
};

/** input type for inserting object relation for remote table "ground_asset_models" */
export type Ground_Asset_Models_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Models_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Models_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_models" */
export type Ground_Asset_Models_On_Conflict = {
  constraint: Ground_Asset_Models_Constraint;
  update_columns: Array<Ground_Asset_Models_Update_Column>;
  where?: Maybe<Ground_Asset_Models_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_models" */
export type Ground_Asset_Models_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_model_parameters_aggregate?: Maybe<Ground_Asset_Model_Parameters_Aggregate_Order_By>;
  ground_assets_aggregate?: Maybe<Ground_Assets_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_models" */
export type Ground_Asset_Models_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ground_asset_models" */
export enum Ground_Asset_Models_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "ground_asset_models" */
export type Ground_Asset_Models_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mavnet_version?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Ground_Asset_Model_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ground_Asset_Models_Stddev_Fields = {
  __typename?: 'ground_asset_models_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ground_Asset_Models_Stddev_Pop_Fields = {
  __typename?: 'ground_asset_models_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ground_Asset_Models_Stddev_Samp_Fields = {
  __typename?: 'ground_asset_models_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Ground_Asset_Models_Sum_Fields = {
  __typename?: 'ground_asset_models_sum_fields';
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Sum_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "ground_asset_models" */
export enum Ground_Asset_Models_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Ground_Asset_Models_Var_Pop_Fields = {
  __typename?: 'ground_asset_models_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ground_Asset_Models_Var_Samp_Fields = {
  __typename?: 'ground_asset_models_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Ground_Asset_Models_Variance_Fields = {
  __typename?: 'ground_asset_models_variance_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ground_asset_models" */
export type Ground_Asset_Models_Variance_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "ground_asset_networks" */
export type Ground_Asset_Networks = {
  __typename?: 'ground_asset_networks';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  ground_asset: Ground_Assets;
  ground_asset_id: Scalars['Int'];
  /** An object relationship */
  network: Networks;
  network_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "ground_asset_networks" */
export type Ground_Asset_Networks_Aggregate = {
  __typename?: 'ground_asset_networks_aggregate';
  aggregate?: Maybe<Ground_Asset_Networks_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Networks>;
};

/** aggregate fields of "ground_asset_networks" */
export type Ground_Asset_Networks_Aggregate_Fields = {
  __typename?: 'ground_asset_networks_aggregate_fields';
  avg?: Maybe<Ground_Asset_Networks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Networks_Max_Fields>;
  min?: Maybe<Ground_Asset_Networks_Min_Fields>;
  stddev?: Maybe<Ground_Asset_Networks_Stddev_Fields>;
  stddev_pop?: Maybe<Ground_Asset_Networks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ground_Asset_Networks_Stddev_Samp_Fields>;
  sum?: Maybe<Ground_Asset_Networks_Sum_Fields>;
  var_pop?: Maybe<Ground_Asset_Networks_Var_Pop_Fields>;
  var_samp?: Maybe<Ground_Asset_Networks_Var_Samp_Fields>;
  variance?: Maybe<Ground_Asset_Networks_Variance_Fields>;
};


/** aggregate fields of "ground_asset_networks" */
export type Ground_Asset_Networks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_networks" */
export type Ground_Asset_Networks_Aggregate_Order_By = {
  avg?: Maybe<Ground_Asset_Networks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Networks_Max_Order_By>;
  min?: Maybe<Ground_Asset_Networks_Min_Order_By>;
  stddev?: Maybe<Ground_Asset_Networks_Stddev_Order_By>;
  stddev_pop?: Maybe<Ground_Asset_Networks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Ground_Asset_Networks_Stddev_Samp_Order_By>;
  sum?: Maybe<Ground_Asset_Networks_Sum_Order_By>;
  var_pop?: Maybe<Ground_Asset_Networks_Var_Pop_Order_By>;
  var_samp?: Maybe<Ground_Asset_Networks_Var_Samp_Order_By>;
  variance?: Maybe<Ground_Asset_Networks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_networks" */
export type Ground_Asset_Networks_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Networks_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Networks_On_Conflict>;
};

/** aggregate avg on columns */
export type Ground_Asset_Networks_Avg_Fields = {
  __typename?: 'ground_asset_networks_avg_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Avg_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ground_asset_networks". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Networks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Networks_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Networks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Networks_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  ground_asset?: Maybe<Ground_Assets_Bool_Exp>;
  ground_asset_id?: Maybe<Int_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_networks" */
export enum Ground_Asset_Networks_Constraint {
  /** unique or primary key constraint */
  GroundAssetNetworksNetworkIdGroundAssetIdPk = 'ground_asset_networks_network_id_ground_asset_id_pk'
}

/** input type for incrementing integer column in table "ground_asset_networks" */
export type Ground_Asset_Networks_Inc_Input = {
  ground_asset_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "ground_asset_networks" */
export type Ground_Asset_Networks_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset?: Maybe<Ground_Assets_Obj_Rel_Insert_Input>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ground_Asset_Networks_Max_Fields = {
  __typename?: 'ground_asset_networks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Networks_Min_Fields = {
  __typename?: 'ground_asset_networks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_networks" */
export type Ground_Asset_Networks_Mutation_Response = {
  __typename?: 'ground_asset_networks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Networks>;
};

/** input type for inserting object relation for remote table "ground_asset_networks" */
export type Ground_Asset_Networks_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Networks_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Networks_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_networks" */
export type Ground_Asset_Networks_On_Conflict = {
  constraint: Ground_Asset_Networks_Constraint;
  update_columns: Array<Ground_Asset_Networks_Update_Column>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_networks" */
export type Ground_Asset_Networks_Order_By = {
  created_at?: Maybe<Order_By>;
  ground_asset?: Maybe<Ground_Assets_Order_By>;
  ground_asset_id?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_networks" */
export type Ground_Asset_Networks_Pk_Columns_Input = {
  ground_asset_id: Scalars['Int'];
  network_id: Scalars['Int'];
};

/** select columns of table "ground_asset_networks" */
export enum Ground_Asset_Networks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundAssetId = 'ground_asset_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "ground_asset_networks" */
export type Ground_Asset_Networks_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ground_Asset_Networks_Stddev_Fields = {
  __typename?: 'ground_asset_networks_stddev_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Stddev_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ground_Asset_Networks_Stddev_Pop_Fields = {
  __typename?: 'ground_asset_networks_stddev_pop_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Stddev_Pop_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ground_Asset_Networks_Stddev_Samp_Fields = {
  __typename?: 'ground_asset_networks_stddev_samp_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Stddev_Samp_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Ground_Asset_Networks_Sum_Fields = {
  __typename?: 'ground_asset_networks_sum_fields';
  ground_asset_id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Sum_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "ground_asset_networks" */
export enum Ground_Asset_Networks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundAssetId = 'ground_asset_id',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Ground_Asset_Networks_Var_Pop_Fields = {
  __typename?: 'ground_asset_networks_var_pop_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Var_Pop_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ground_Asset_Networks_Var_Samp_Fields = {
  __typename?: 'ground_asset_networks_var_samp_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Var_Samp_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Ground_Asset_Networks_Variance_Fields = {
  __typename?: 'ground_asset_networks_variance_fields';
  ground_asset_id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ground_asset_networks" */
export type Ground_Asset_Networks_Variance_Order_By = {
  ground_asset_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "ground_asset_status_values" */
export type Ground_Asset_Status_Values = {
  __typename?: 'ground_asset_status_values';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Aggregate = {
  __typename?: 'ground_asset_status_values_aggregate';
  aggregate?: Maybe<Ground_Asset_Status_Values_Aggregate_Fields>;
  nodes: Array<Ground_Asset_Status_Values>;
};

/** aggregate fields of "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Aggregate_Fields = {
  __typename?: 'ground_asset_status_values_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Asset_Status_Values_Max_Fields>;
  min?: Maybe<Ground_Asset_Status_Values_Min_Fields>;
};


/** aggregate fields of "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Asset_Status_Values_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Asset_Status_Values_Max_Order_By>;
  min?: Maybe<Ground_Asset_Status_Values_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Arr_Rel_Insert_Input = {
  data: Array<Ground_Asset_Status_Values_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Status_Values_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ground_asset_status_values". All fields are combined with a logical 'AND'. */
export type Ground_Asset_Status_Values_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Asset_Status_Values_Bool_Exp>>>;
  _not?: Maybe<Ground_Asset_Status_Values_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Asset_Status_Values_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_asset_status_values" */
export enum Ground_Asset_Status_Values_Constraint {
  /** unique or primary key constraint */
  GroundAssetStatusesPkey = 'ground_asset_statuses_pkey'
}

export enum Ground_Asset_Status_Values_Enum {
  /** Experimental */
  Experimental = 'Experimental',
  /** Production */
  Production = 'Production',
  /** Unqualified */
  Unqualified = 'Unqualified'
}

/** expression to compare columns of type ground_asset_status_values_enum. All fields are combined with logical 'AND'. */
export type Ground_Asset_Status_Values_Enum_Comparison_Exp = {
  _eq?: Maybe<Ground_Asset_Status_Values_Enum>;
  _in?: Maybe<Array<Ground_Asset_Status_Values_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Ground_Asset_Status_Values_Enum>;
  _nin?: Maybe<Array<Ground_Asset_Status_Values_Enum>>;
};

/** input type for inserting data into table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ground_Asset_Status_Values_Max_Fields = {
  __typename?: 'ground_asset_status_values_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Asset_Status_Values_Min_Fields = {
  __typename?: 'ground_asset_status_values_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Mutation_Response = {
  __typename?: 'ground_asset_status_values_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Asset_Status_Values>;
};

/** input type for inserting object relation for remote table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Obj_Rel_Insert_Input = {
  data: Ground_Asset_Status_Values_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Status_Values_On_Conflict>;
};

/** on conflict condition type for table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_On_Conflict = {
  constraint: Ground_Asset_Status_Values_Constraint;
  update_columns: Array<Ground_Asset_Status_Values_Update_Column>;
  where?: Maybe<Ground_Asset_Status_Values_Bool_Exp>;
};

/** ordering options when selecting data from "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ground_asset_status_values" */
export enum Ground_Asset_Status_Values_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ground_asset_status_values" */
export type Ground_Asset_Status_Values_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "ground_asset_status_values" */
export enum Ground_Asset_Status_Values_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "ground_assets" */
export type Ground_Assets = {
  __typename?: 'ground_assets';
  activated?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  ground_asset_commands: Array<Ground_Asset_Commands>;
  /** An aggregated array relationship */
  ground_asset_commands_aggregate: Ground_Asset_Commands_Aggregate;
  /** An object relationship */
  ground_asset_model?: Maybe<Ground_Asset_Models>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  ground_asset_networks: Array<Ground_Asset_Networks>;
  /** An aggregated array relationship */
  ground_asset_networks_aggregate: Ground_Asset_Networks_Aggregate;
  heading?: Maybe<Scalars['smallint']>;
  /** An array relationship */
  historical_serialized_ground_asset_statuses: Array<Historical_Serialized_Ground_Asset_Statuses>;
  /** An aggregated array relationship */
  historical_serialized_ground_asset_statuses_aggregate: Historical_Serialized_Ground_Asset_Statuses_Aggregate;
  id: Scalars['Int'];
  is_connected?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  kafka_serialized_ground_asset_statuses: Array<Kafka_Serialized_Ground_Asset_Statuses>;
  /** An aggregated array relationship */
  kafka_serialized_ground_asset_statuses_aggregate: Kafka_Serialized_Ground_Asset_Statuses_Aggregate;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['geometry']>;
  locking_enabled?: Maybe<Scalars['Boolean']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  status: Ground_Asset_Status_Values_Enum;
  storage_enabled?: Maybe<Scalars['Boolean']>;
  store_telemetry?: Maybe<Scalars['Boolean']>;
  tenant_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  uwb_version?: Maybe<Scalars['String']>;
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  version: Scalars['Int'];
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsGround_Asset_CommandsArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsGround_Asset_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsGround_Asset_NetworksArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsGround_Asset_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsHistorical_Serialized_Ground_Asset_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsHistorical_Serialized_Ground_Asset_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsKafka_Serialized_Ground_Asset_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** columns and relationships of "ground_assets" */
export type Ground_AssetsKafka_Serialized_Ground_Asset_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};

/** aggregated selection of "ground_assets" */
export type Ground_Assets_Aggregate = {
  __typename?: 'ground_assets_aggregate';
  aggregate?: Maybe<Ground_Assets_Aggregate_Fields>;
  nodes: Array<Ground_Assets>;
};

/** aggregate fields of "ground_assets" */
export type Ground_Assets_Aggregate_Fields = {
  __typename?: 'ground_assets_aggregate_fields';
  avg?: Maybe<Ground_Assets_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Assets_Max_Fields>;
  min?: Maybe<Ground_Assets_Min_Fields>;
  stddev?: Maybe<Ground_Assets_Stddev_Fields>;
  stddev_pop?: Maybe<Ground_Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ground_Assets_Stddev_Samp_Fields>;
  sum?: Maybe<Ground_Assets_Sum_Fields>;
  var_pop?: Maybe<Ground_Assets_Var_Pop_Fields>;
  var_samp?: Maybe<Ground_Assets_Var_Samp_Fields>;
  variance?: Maybe<Ground_Assets_Variance_Fields>;
};


/** aggregate fields of "ground_assets" */
export type Ground_Assets_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Assets_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_assets" */
export type Ground_Assets_Aggregate_Order_By = {
  avg?: Maybe<Ground_Assets_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Assets_Max_Order_By>;
  min?: Maybe<Ground_Assets_Min_Order_By>;
  stddev?: Maybe<Ground_Assets_Stddev_Order_By>;
  stddev_pop?: Maybe<Ground_Assets_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Ground_Assets_Stddev_Samp_Order_By>;
  sum?: Maybe<Ground_Assets_Sum_Order_By>;
  var_pop?: Maybe<Ground_Assets_Var_Pop_Order_By>;
  var_samp?: Maybe<Ground_Assets_Var_Samp_Order_By>;
  variance?: Maybe<Ground_Assets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ground_assets" */
export type Ground_Assets_Arr_Rel_Insert_Input = {
  data: Array<Ground_Assets_Insert_Input>;
  on_conflict?: Maybe<Ground_Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type Ground_Assets_Avg_Fields = {
  __typename?: 'ground_assets_avg_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ground_assets" */
export type Ground_Assets_Avg_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ground_assets". All fields are combined with a logical 'AND'. */
export type Ground_Assets_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Assets_Bool_Exp>>>;
  _not?: Maybe<Ground_Assets_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Assets_Bool_Exp>>>;
  activated?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  ground_asset_commands?: Maybe<Ground_Asset_Commands_Bool_Exp>;
  ground_asset_model?: Maybe<Ground_Asset_Models_Bool_Exp>;
  ground_asset_model_id?: Maybe<Int_Comparison_Exp>;
  ground_asset_networks?: Maybe<Ground_Asset_Networks_Bool_Exp>;
  heading?: Maybe<Smallint_Comparison_Exp>;
  historical_serialized_ground_asset_statuses?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_connected?: Maybe<Boolean_Comparison_Exp>;
  kafka_serialized_ground_asset_statuses?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
  landing_vehicle_id?: Maybe<Int_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  locking_enabled?: Maybe<Boolean_Comparison_Exp>;
  mavnet_version?: Maybe<String_Comparison_Exp>;
  mttr_serial_number?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  status?: Maybe<Ground_Asset_Status_Values_Enum_Comparison_Exp>;
  storage_enabled?: Maybe<Boolean_Comparison_Exp>;
  store_telemetry?: Maybe<Boolean_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uwb_version?: Maybe<String_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_assets" */
export enum Ground_Assets_Constraint {
  /** unique or primary key constraint */
  GroundAssetsPkey = 'ground_assets_pkey',
  /** unique or primary key constraint */
  GroundAssetsSerialNumberKey = 'ground_assets_serial_number_key'
}

/** input type for incrementing integer column in table "ground_assets" */
export type Ground_Assets_Inc_Input = {
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "ground_assets" */
export type Ground_Assets_Insert_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_commands?: Maybe<Ground_Asset_Commands_Arr_Rel_Insert_Input>;
  ground_asset_model?: Maybe<Ground_Asset_Models_Obj_Rel_Insert_Input>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  ground_asset_networks?: Maybe<Ground_Asset_Networks_Arr_Rel_Insert_Input>;
  heading?: Maybe<Scalars['smallint']>;
  historical_serialized_ground_asset_statuses?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  is_connected?: Maybe<Scalars['Boolean']>;
  kafka_serialized_ground_asset_statuses?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Arr_Rel_Insert_Input>;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['geometry']>;
  locking_enabled?: Maybe<Scalars['Boolean']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Ground_Asset_Status_Values_Enum>;
  storage_enabled?: Maybe<Scalars['Boolean']>;
  store_telemetry?: Maybe<Scalars['Boolean']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Ground_Assets_Max_Fields = {
  __typename?: 'ground_assets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "ground_assets" */
export type Ground_Assets_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mttr_serial_number?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Assets_Min_Fields = {
  __typename?: 'ground_assets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "ground_assets" */
export type Ground_Assets_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mttr_serial_number?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_assets" */
export type Ground_Assets_Mutation_Response = {
  __typename?: 'ground_assets_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Assets>;
};

/** input type for inserting object relation for remote table "ground_assets" */
export type Ground_Assets_Obj_Rel_Insert_Input = {
  data: Ground_Assets_Insert_Input;
  on_conflict?: Maybe<Ground_Assets_On_Conflict>;
};

/** on conflict condition type for table "ground_assets" */
export type Ground_Assets_On_Conflict = {
  constraint: Ground_Assets_Constraint;
  update_columns: Array<Ground_Assets_Update_Column>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};

/** ordering options when selecting data from "ground_assets" */
export type Ground_Assets_Order_By = {
  activated?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  ground_asset_commands_aggregate?: Maybe<Ground_Asset_Commands_Aggregate_Order_By>;
  ground_asset_model?: Maybe<Ground_Asset_Models_Order_By>;
  ground_asset_model_id?: Maybe<Order_By>;
  ground_asset_networks_aggregate?: Maybe<Ground_Asset_Networks_Aggregate_Order_By>;
  heading?: Maybe<Order_By>;
  historical_serialized_ground_asset_statuses_aggregate?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  is_connected?: Maybe<Order_By>;
  kafka_serialized_ground_asset_statuses_aggregate?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Aggregate_Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  locking_enabled?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mttr_serial_number?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  storage_enabled?: Maybe<Order_By>;
  store_telemetry?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_assets" */
export type Ground_Assets_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "ground_assets" */
export enum Ground_Assets_Select_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GroundAssetModelId = 'ground_asset_model_id',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  IsConnected = 'is_connected',
  /** column name */
  LandingVehicleId = 'landing_vehicle_id',
  /** column name */
  Location = 'location',
  /** column name */
  LockingEnabled = 'locking_enabled',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  MttrSerialNumber = 'mttr_serial_number',
  /** column name */
  Name = 'name',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Status = 'status',
  /** column name */
  StorageEnabled = 'storage_enabled',
  /** column name */
  StoreTelemetry = 'store_telemetry',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "ground_assets" */
export type Ground_Assets_Set_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  is_connected?: Maybe<Scalars['Boolean']>;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['geometry']>;
  locking_enabled?: Maybe<Scalars['Boolean']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Ground_Asset_Status_Values_Enum>;
  storage_enabled?: Maybe<Scalars['Boolean']>;
  store_telemetry?: Maybe<Scalars['Boolean']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Ground_Assets_Stddev_Fields = {
  __typename?: 'ground_assets_stddev_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ground_assets" */
export type Ground_Assets_Stddev_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ground_Assets_Stddev_Pop_Fields = {
  __typename?: 'ground_assets_stddev_pop_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ground_assets" */
export type Ground_Assets_Stddev_Pop_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ground_Assets_Stddev_Samp_Fields = {
  __typename?: 'ground_assets_stddev_samp_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ground_assets" */
export type Ground_Assets_Stddev_Samp_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Ground_Assets_Sum_Fields = {
  __typename?: 'ground_assets_sum_fields';
  ground_asset_model_id?: Maybe<Scalars['Int']>;
  heading?: Maybe<Scalars['smallint']>;
  id?: Maybe<Scalars['Int']>;
  landing_vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ground_assets" */
export type Ground_Assets_Sum_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "ground_assets" */
export enum Ground_Assets_Update_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  GroundAssetModelId = 'ground_asset_model_id',
  /** column name */
  Heading = 'heading',
  /** column name */
  Id = 'id',
  /** column name */
  IsConnected = 'is_connected',
  /** column name */
  LandingVehicleId = 'landing_vehicle_id',
  /** column name */
  Location = 'location',
  /** column name */
  LockingEnabled = 'locking_enabled',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  MttrSerialNumber = 'mttr_serial_number',
  /** column name */
  Name = 'name',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Status = 'status',
  /** column name */
  StorageEnabled = 'storage_enabled',
  /** column name */
  StoreTelemetry = 'store_telemetry',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Ground_Assets_Var_Pop_Fields = {
  __typename?: 'ground_assets_var_pop_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ground_assets" */
export type Ground_Assets_Var_Pop_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ground_Assets_Var_Samp_Fields = {
  __typename?: 'ground_assets_var_samp_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ground_assets" */
export type Ground_Assets_Var_Samp_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Ground_Assets_Variance_Fields = {
  __typename?: 'ground_assets_variance_fields';
  ground_asset_model_id?: Maybe<Scalars['Float']>;
  heading?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  landing_vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ground_assets" */
export type Ground_Assets_Variance_Order_By = {
  ground_asset_model_id?: Maybe<Order_By>;
  heading?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  landing_vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses = {
  __typename?: 'ground_control_workflow_state_processing_statuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Aggregate = {
  __typename?: 'ground_control_workflow_state_processing_statuses_aggregate';
  aggregate?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Aggregate_Fields>;
  nodes: Array<Ground_Control_Workflow_State_Processing_Statuses>;
};

/** aggregate fields of "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Aggregate_Fields = {
  __typename?: 'ground_control_workflow_state_processing_statuses_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Max_Fields>;
  min?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Min_Fields>;
};


/** aggregate fields of "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Max_Order_By>;
  min?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Ground_Control_Workflow_State_Processing_Statuses_Insert_Input>;
  on_conflict?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ground_control_workflow_state_processing_statuses". All fields are combined with a logical 'AND'. */
export type Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>>>;
  _not?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ground_control_workflow_state_processing_statuses" */
export enum Ground_Control_Workflow_State_Processing_Statuses_Constraint {
  /** unique or primary key constraint */
  GroundControlWorkflowStateProcessingStatusesPkey = 'ground_control_workflow_state_processing_statuses_pkey'
}

/** input type for inserting data into table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ground_Control_Workflow_State_Processing_Statuses_Max_Fields = {
  __typename?: 'ground_control_workflow_state_processing_statuses_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Ground_Control_Workflow_State_Processing_Statuses_Min_Fields = {
  __typename?: 'ground_control_workflow_state_processing_statuses_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Mutation_Response = {
  __typename?: 'ground_control_workflow_state_processing_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Ground_Control_Workflow_State_Processing_Statuses>;
};

/** input type for inserting object relation for remote table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Obj_Rel_Insert_Input = {
  data: Ground_Control_Workflow_State_Processing_Statuses_Insert_Input;
  on_conflict?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_On_Conflict>;
};

/** on conflict condition type for table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_On_Conflict = {
  constraint: Ground_Control_Workflow_State_Processing_Statuses_Constraint;
  update_columns: Array<Ground_Control_Workflow_State_Processing_Statuses_Update_Column>;
  where?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ground_control_workflow_state_processing_statuses" */
export enum Ground_Control_Workflow_State_Processing_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ground_control_workflow_state_processing_statuses" */
export type Ground_Control_Workflow_State_Processing_Statuses_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "ground_control_workflow_state_processing_statuses" */
export enum Ground_Control_Workflow_State_Processing_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses = {
  __typename?: 'historical_serialized_ground_asset_statuses';
  activity_state?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  ground_asset: Ground_Assets;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs: Scalars['float8'];
  location?: Maybe<Scalars['geometry']>;
  lon_degs: Scalars['float8'];
  occupied?: Maybe<Scalars['Boolean']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  protobuf_message: Scalars['bytea'];
  serial_number: Scalars['String'];
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Aggregate = {
  __typename?: 'historical_serialized_ground_asset_statuses_aggregate';
  aggregate?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Aggregate_Fields>;
  nodes: Array<Historical_Serialized_Ground_Asset_Statuses>;
};

/** aggregate fields of "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Aggregate_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_aggregate_fields';
  avg?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Max_Fields>;
  min?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Min_Fields>;
  stddev?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Sum_Fields>;
  var_pop?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Variance_Fields>;
};


/** aggregate fields of "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Max_Order_By>;
  min?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Min_Order_By>;
  stddev?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Historical_Serialized_Ground_Asset_Statuses_Insert_Input>;
  on_conflict?: Maybe<Historical_Serialized_Ground_Asset_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Avg_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_avg_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Avg_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "historical_serialized_ground_asset_statuses". All fields are combined with a logical 'AND'. */
export type Historical_Serialized_Ground_Asset_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>>>;
  _not?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>>>;
  activity_state?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  ground_asset?: Maybe<Ground_Assets_Bool_Exp>;
  ground_asset_state?: Maybe<Int_Comparison_Exp>;
  hardware_state?: Maybe<Int_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  occupied?: Maybe<Boolean_Comparison_Exp>;
  paired_vehicle_conn_state?: Maybe<Int_Comparison_Exp>;
  paired_vehicle_serial_number?: Maybe<String_Comparison_Exp>;
  protobuf_message?: Maybe<Bytea_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  timestamp_date?: Maybe<Timestamptz_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "historical_serialized_ground_asset_statuses" */
export enum Historical_Serialized_Ground_Asset_Statuses_Constraint {
  /** unique or primary key constraint */
  HistoricalSerializedGroundAssetStatusesPkey = 'historical_serialized_ground_asset_statuses_pkey'
}

/** input type for incrementing integer column in table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Inc_Input = {
  activity_state?: Maybe<Scalars['Int']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Insert_Input = {
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset?: Maybe<Ground_Assets_Obj_Rel_Insert_Input>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  occupied?: Maybe<Scalars['Boolean']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Max_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_max_fields';
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Max_Order_By = {
  activity_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  paired_vehicle_serial_number?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Min_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_min_fields';
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Min_Order_By = {
  activity_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  paired_vehicle_serial_number?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Mutation_Response = {
  __typename?: 'historical_serialized_ground_asset_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Historical_Serialized_Ground_Asset_Statuses>;
};

/** input type for inserting object relation for remote table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Obj_Rel_Insert_Input = {
  data: Historical_Serialized_Ground_Asset_Statuses_Insert_Input;
  on_conflict?: Maybe<Historical_Serialized_Ground_Asset_Statuses_On_Conflict>;
};

/** on conflict condition type for table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_On_Conflict = {
  constraint: Historical_Serialized_Ground_Asset_Statuses_Constraint;
  update_columns: Array<Historical_Serialized_Ground_Asset_Statuses_Update_Column>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Order_By = {
  activity_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  ground_asset?: Maybe<Ground_Assets_Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  occupied?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  paired_vehicle_serial_number?: Maybe<Order_By>;
  protobuf_message?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Pk_Columns_Input = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};

/** select columns of table "historical_serialized_ground_asset_statuses" */
export enum Historical_Serialized_Ground_Asset_Statuses_Select_Column {
  /** column name */
  ActivityState = 'activity_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundAssetState = 'ground_asset_state',
  /** column name */
  HardwareState = 'hardware_state',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Occupied = 'occupied',
  /** column name */
  PairedVehicleConnState = 'paired_vehicle_conn_state',
  /** column name */
  PairedVehicleSerialNumber = 'paired_vehicle_serial_number',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Set_Input = {
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  occupied?: Maybe<Scalars['Boolean']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Stddev_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_stddev_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Stddev_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Stddev_Pop_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_stddev_pop_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Stddev_Pop_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Stddev_Samp_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_stddev_samp_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Stddev_Samp_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Sum_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_sum_fields';
  activity_state?: Maybe<Scalars['Int']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Sum_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "historical_serialized_ground_asset_statuses" */
export enum Historical_Serialized_Ground_Asset_Statuses_Update_Column {
  /** column name */
  ActivityState = 'activity_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundAssetState = 'ground_asset_state',
  /** column name */
  HardwareState = 'hardware_state',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Occupied = 'occupied',
  /** column name */
  PairedVehicleConnState = 'paired_vehicle_conn_state',
  /** column name */
  PairedVehicleSerialNumber = 'paired_vehicle_serial_number',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Var_Pop_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_var_pop_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Var_Pop_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Var_Samp_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_var_samp_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Var_Samp_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Historical_Serialized_Ground_Asset_Statuses_Variance_Fields = {
  __typename?: 'historical_serialized_ground_asset_statuses_variance_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "historical_serialized_ground_asset_statuses" */
export type Historical_Serialized_Ground_Asset_Statuses_Variance_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses = {
  __typename?: 'historical_serialized_vehicle_statuses';
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  /** Estimated time enroute of vehicle in seconds. */
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs: Scalars['float8'];
  location?: Maybe<Scalars['geometry']>;
  lon_degs: Scalars['float8'];
  protobuf_message: Scalars['bytea'];
  serial_number: Scalars['String'];
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
};

/** aggregated selection of "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Aggregate = {
  __typename?: 'historical_serialized_vehicle_statuses_aggregate';
  aggregate?: Maybe<Historical_Serialized_Vehicle_Statuses_Aggregate_Fields>;
  nodes: Array<Historical_Serialized_Vehicle_Statuses>;
};

/** aggregate fields of "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Aggregate_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_aggregate_fields';
  avg?: Maybe<Historical_Serialized_Vehicle_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Historical_Serialized_Vehicle_Statuses_Max_Fields>;
  min?: Maybe<Historical_Serialized_Vehicle_Statuses_Min_Fields>;
  stddev?: Maybe<Historical_Serialized_Vehicle_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Historical_Serialized_Vehicle_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Historical_Serialized_Vehicle_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Historical_Serialized_Vehicle_Statuses_Sum_Fields>;
  var_pop?: Maybe<Historical_Serialized_Vehicle_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Historical_Serialized_Vehicle_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Historical_Serialized_Vehicle_Statuses_Variance_Fields>;
};


/** aggregate fields of "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Historical_Serialized_Vehicle_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Historical_Serialized_Vehicle_Statuses_Max_Order_By>;
  min?: Maybe<Historical_Serialized_Vehicle_Statuses_Min_Order_By>;
  stddev?: Maybe<Historical_Serialized_Vehicle_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Historical_Serialized_Vehicle_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Historical_Serialized_Vehicle_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Historical_Serialized_Vehicle_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Historical_Serialized_Vehicle_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Historical_Serialized_Vehicle_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Historical_Serialized_Vehicle_Statuses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Historical_Serialized_Vehicle_Statuses_Insert_Input>;
  on_conflict?: Maybe<Historical_Serialized_Vehicle_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Historical_Serialized_Vehicle_Statuses_Avg_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_avg_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Avg_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "historical_serialized_vehicle_statuses". All fields are combined with a logical 'AND'. */
export type Historical_Serialized_Vehicle_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>>>;
  _not?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>>>;
  accessory_state?: Maybe<Int_Comparison_Exp>;
  alt_agl_meters?: Maybe<Float8_Comparison_Exp>;
  anomaly_status?: Maybe<Int_Comparison_Exp>;
  cell_modem_rssi?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  estimated_soc?: Maybe<Float8_Comparison_Exp>;
  eta_secs?: Maybe<Float8_Comparison_Exp>;
  ete_terminal_airspace_secs?: Maybe<Float8_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  fts_state?: Maybe<Int_Comparison_Exp>;
  ground_speed_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  heading_degrees?: Maybe<Float8_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  protobuf_message?: Maybe<Bytea_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  smbt_soc?: Maybe<Float8_Comparison_Exp>;
  smbt_spn?: Maybe<String_Comparison_Exp>;
  timestamp_date?: Maybe<Timestamptz_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
};

/** unique or primary key constraints on table "historical_serialized_vehicle_statuses" */
export enum Historical_Serialized_Vehicle_Statuses_Constraint {
  /** unique or primary key constraint */
  HistoricalSerializedVehicleStatusesPkey = 'historical_serialized_vehicle_statuses_pkey'
}

/** input type for incrementing integer column in table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Inc_Input = {
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Insert_Input = {
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Historical_Serialized_Vehicle_Statuses_Max_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_max_fields';
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Max_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  smbt_spn?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Historical_Serialized_Vehicle_Statuses_Min_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_min_fields';
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Min_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  smbt_spn?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Mutation_Response = {
  __typename?: 'historical_serialized_vehicle_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Historical_Serialized_Vehicle_Statuses>;
};

/** input type for inserting object relation for remote table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Obj_Rel_Insert_Input = {
  data: Historical_Serialized_Vehicle_Statuses_Insert_Input;
  on_conflict?: Maybe<Historical_Serialized_Vehicle_Statuses_On_Conflict>;
};

/** on conflict condition type for table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_On_Conflict = {
  constraint: Historical_Serialized_Vehicle_Statuses_Constraint;
  update_columns: Array<Historical_Serialized_Vehicle_Statuses_Update_Column>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  protobuf_message?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  smbt_spn?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
};

/** primary key columns input for table: "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Pk_Columns_Input = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};

/** select columns of table "historical_serialized_vehicle_statuses" */
export enum Historical_Serialized_Vehicle_Statuses_Select_Column {
  /** column name */
  AccessoryState = 'accessory_state',
  /** column name */
  AltAglMeters = 'alt_agl_meters',
  /** column name */
  AnomalyStatus = 'anomaly_status',
  /** column name */
  CellModemRssi = 'cell_modem_rssi',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedSoc = 'estimated_soc',
  /** column name */
  EtaSecs = 'eta_secs',
  /** column name */
  EteTerminalAirspaceSecs = 'ete_terminal_airspace_secs',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FtsState = 'fts_state',
  /** column name */
  GroundSpeedMetersPerSecond = 'ground_speed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SmbtSoc = 'smbt_soc',
  /** column name */
  SmbtSpn = 'smbt_spn',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Set_Input = {
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Historical_Serialized_Vehicle_Statuses_Stddev_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_stddev_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Stddev_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Historical_Serialized_Vehicle_Statuses_Stddev_Pop_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_stddev_pop_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Stddev_Pop_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Historical_Serialized_Vehicle_Statuses_Stddev_Samp_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_stddev_samp_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Stddev_Samp_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Historical_Serialized_Vehicle_Statuses_Sum_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_sum_fields';
  accessory_state?: Maybe<Scalars['Int']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Sum_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "historical_serialized_vehicle_statuses" */
export enum Historical_Serialized_Vehicle_Statuses_Update_Column {
  /** column name */
  AccessoryState = 'accessory_state',
  /** column name */
  AltAglMeters = 'alt_agl_meters',
  /** column name */
  AnomalyStatus = 'anomaly_status',
  /** column name */
  CellModemRssi = 'cell_modem_rssi',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedSoc = 'estimated_soc',
  /** column name */
  EtaSecs = 'eta_secs',
  /** column name */
  EteTerminalAirspaceSecs = 'ete_terminal_airspace_secs',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FtsState = 'fts_state',
  /** column name */
  GroundSpeedMetersPerSecond = 'ground_speed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SmbtSoc = 'smbt_soc',
  /** column name */
  SmbtSpn = 'smbt_spn',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Historical_Serialized_Vehicle_Statuses_Var_Pop_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_var_pop_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Var_Pop_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Historical_Serialized_Vehicle_Statuses_Var_Samp_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_var_samp_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Var_Samp_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Historical_Serialized_Vehicle_Statuses_Variance_Fields = {
  __typename?: 'historical_serialized_vehicle_statuses_variance_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "historical_serialized_vehicle_statuses" */
export type Historical_Serialized_Vehicle_Statuses_Variance_Order_By = {
  accessory_state?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "historical_vehicle_positions" */
export type Historical_Vehicle_Positions = {
  __typename?: 'historical_vehicle_positions';
  /** Altitude Above Ground Level (AGL) */
  alt_agl_meters?: Maybe<Scalars['float8']>;
  /** Altitude Mean Sea Level (MSL) */
  alt_meters?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  /** Flight Plan ID (FK) */
  flight_plan_id?: Maybe<Scalars['Int']>;
  /** Latitude in degrees */
  lat_degs: Scalars['float8'];
  /** Longitude in degrees */
  lon_degs: Scalars['float8'];
  /** Vehicle Serial Number (FK) */
  serial_number: Scalars['String'];
  /** Timestamp in seconds */
  timestamp_secs: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Aggregate = {
  __typename?: 'historical_vehicle_positions_aggregate';
  aggregate?: Maybe<Historical_Vehicle_Positions_Aggregate_Fields>;
  nodes: Array<Historical_Vehicle_Positions>;
};

/** aggregate fields of "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Aggregate_Fields = {
  __typename?: 'historical_vehicle_positions_aggregate_fields';
  avg?: Maybe<Historical_Vehicle_Positions_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Historical_Vehicle_Positions_Max_Fields>;
  min?: Maybe<Historical_Vehicle_Positions_Min_Fields>;
  stddev?: Maybe<Historical_Vehicle_Positions_Stddev_Fields>;
  stddev_pop?: Maybe<Historical_Vehicle_Positions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Historical_Vehicle_Positions_Stddev_Samp_Fields>;
  sum?: Maybe<Historical_Vehicle_Positions_Sum_Fields>;
  var_pop?: Maybe<Historical_Vehicle_Positions_Var_Pop_Fields>;
  var_samp?: Maybe<Historical_Vehicle_Positions_Var_Samp_Fields>;
  variance?: Maybe<Historical_Vehicle_Positions_Variance_Fields>;
};


/** aggregate fields of "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Aggregate_Order_By = {
  avg?: Maybe<Historical_Vehicle_Positions_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Historical_Vehicle_Positions_Max_Order_By>;
  min?: Maybe<Historical_Vehicle_Positions_Min_Order_By>;
  stddev?: Maybe<Historical_Vehicle_Positions_Stddev_Order_By>;
  stddev_pop?: Maybe<Historical_Vehicle_Positions_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Historical_Vehicle_Positions_Stddev_Samp_Order_By>;
  sum?: Maybe<Historical_Vehicle_Positions_Sum_Order_By>;
  var_pop?: Maybe<Historical_Vehicle_Positions_Var_Pop_Order_By>;
  var_samp?: Maybe<Historical_Vehicle_Positions_Var_Samp_Order_By>;
  variance?: Maybe<Historical_Vehicle_Positions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Arr_Rel_Insert_Input = {
  data: Array<Historical_Vehicle_Positions_Insert_Input>;
  on_conflict?: Maybe<Historical_Vehicle_Positions_On_Conflict>;
};

/** aggregate avg on columns */
export type Historical_Vehicle_Positions_Avg_Fields = {
  __typename?: 'historical_vehicle_positions_avg_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Avg_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "historical_vehicle_positions". All fields are combined with a logical 'AND'. */
export type Historical_Vehicle_Positions_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Historical_Vehicle_Positions_Bool_Exp>>>;
  _not?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Historical_Vehicle_Positions_Bool_Exp>>>;
  alt_agl_meters?: Maybe<Float8_Comparison_Exp>;
  alt_meters?: Maybe<Float8_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "historical_vehicle_positions" */
export enum Historical_Vehicle_Positions_Constraint {
  /** unique or primary key constraint */
  HistoricalVehiclePositionsPkey = 'historical_vehicle_positions_pkey'
}

/** input type for incrementing integer column in table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Inc_Input = {
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Insert_Input = {
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Historical_Vehicle_Positions_Max_Fields = {
  __typename?: 'historical_vehicle_positions_max_fields';
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Max_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Historical_Vehicle_Positions_Min_Fields = {
  __typename?: 'historical_vehicle_positions_min_fields';
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Min_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Mutation_Response = {
  __typename?: 'historical_vehicle_positions_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Historical_Vehicle_Positions>;
};

/** input type for inserting object relation for remote table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Obj_Rel_Insert_Input = {
  data: Historical_Vehicle_Positions_Insert_Input;
  on_conflict?: Maybe<Historical_Vehicle_Positions_On_Conflict>;
};

/** on conflict condition type for table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_On_Conflict = {
  constraint: Historical_Vehicle_Positions_Constraint;
  update_columns: Array<Historical_Vehicle_Positions_Update_Column>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};

/** ordering options when selecting data from "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Pk_Columns_Input = {
  /** Vehicle Serial Number (FK) */
  serial_number: Scalars['String'];
  /** Timestamp in seconds */
  timestamp_secs: Scalars['float8'];
};

/** select columns of table "historical_vehicle_positions" */
export enum Historical_Vehicle_Positions_Select_Column {
  /** column name */
  AltAglMeters = 'alt_agl_meters',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Set_Input = {
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Historical_Vehicle_Positions_Stddev_Fields = {
  __typename?: 'historical_vehicle_positions_stddev_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Stddev_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Historical_Vehicle_Positions_Stddev_Pop_Fields = {
  __typename?: 'historical_vehicle_positions_stddev_pop_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Stddev_Pop_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Historical_Vehicle_Positions_Stddev_Samp_Fields = {
  __typename?: 'historical_vehicle_positions_stddev_samp_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Stddev_Samp_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Historical_Vehicle_Positions_Sum_Fields = {
  __typename?: 'historical_vehicle_positions_sum_fields';
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Sum_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "historical_vehicle_positions" */
export enum Historical_Vehicle_Positions_Update_Column {
  /** column name */
  AltAglMeters = 'alt_agl_meters',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Historical_Vehicle_Positions_Var_Pop_Fields = {
  __typename?: 'historical_vehicle_positions_var_pop_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Var_Pop_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Historical_Vehicle_Positions_Var_Samp_Fields = {
  __typename?: 'historical_vehicle_positions_var_samp_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Var_Samp_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Historical_Vehicle_Positions_Variance_Fields = {
  __typename?: 'historical_vehicle_positions_variance_fields';
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "historical_vehicle_positions" */
export type Historical_Vehicle_Positions_Variance_Order_By = {
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};


/** expression to compare columns of type json. All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};


/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings';
  air_traffic_record_id?: Maybe<Scalars['String']>;
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  vehicle_id: Scalars['Int'];
  vehicle_status_timestamp_ms: Scalars['float8'];
};

/** aggregated selection of "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_aggregate';
  aggregate?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate_Fields>;
  nodes: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
};

/** aggregate fields of "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_aggregate_fields';
  avg?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Max_Fields>;
  min?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Min_Fields>;
  stddev?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Fields>;
  stddev_pop?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Samp_Fields>;
  sum?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Sum_Fields>;
  var_pop?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Pop_Fields>;
  var_samp?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Samp_Fields>;
  variance?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Variance_Fields>;
};


/** aggregate fields of "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate_Order_By = {
  avg?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Max_Order_By>;
  min?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Min_Order_By>;
  stddev?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Order_By>;
  stddev_pop?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Samp_Order_By>;
  sum?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Sum_Order_By>;
  var_pop?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Pop_Order_By>;
  var_samp?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Samp_Order_By>;
  variance?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Arr_Rel_Insert_Input = {
  data: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Insert_Input>;
  on_conflict?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_On_Conflict>;
};

/** aggregate avg on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Avg_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_avg_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Avg_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kafka_air_traffic_vehicle_flight_proximity_recordings". All fields are combined with a logical 'AND'. */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>>>;
  _not?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>>>;
  air_traffic_record_id?: Maybe<String_Comparison_Exp>;
  aircraft_type?: Maybe<String_Comparison_Exp>;
  alt_m?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  debug_data?: Maybe<String_Comparison_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  groundspeed_mps?: Maybe<Float8_Comparison_Exp>;
  heading_degs?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  proximity_level?: Maybe<String_Comparison_Exp>;
  relative_altitude_m?: Maybe<Float8_Comparison_Exp>;
  relative_distance_m?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  vehicle_status_timestamp_ms?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export enum Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Constraint {
  /** unique or primary key constraint */
  KafkaAirTrafficVehicleFlightProximityRecordingsPkey = 'kafka_air_traffic_vehicle_flight_proximity_recordings_pkey'
}

/** input type for incrementing integer column in table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Inc_Input = {
  alt_m?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Insert_Input = {
  air_traffic_record_id?: Maybe<Scalars['String']>;
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Max_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_max_fields';
  air_traffic_record_id?: Maybe<Scalars['String']>;
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Max_Order_By = {
  air_traffic_record_id?: Maybe<Order_By>;
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Min_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_min_fields';
  air_traffic_record_id?: Maybe<Scalars['String']>;
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Min_Order_By = {
  air_traffic_record_id?: Maybe<Order_By>;
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** response of any mutation on the table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Mutation_Response = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
};

/** input type for inserting object relation for remote table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Obj_Rel_Insert_Input = {
  data: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Insert_Input;
  on_conflict?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_On_Conflict>;
};

/** on conflict condition type for table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_On_Conflict = {
  constraint: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Constraint;
  update_columns: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Update_Column>;
  where?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>;
};

/** ordering options when selecting data from "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Order_By = {
  air_traffic_record_id?: Maybe<Order_By>;
  aircraft_type?: Maybe<Order_By>;
  alt_m?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** primary key columns input for table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Pk_Columns_Input = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};

/** select columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export enum Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Select_Column {
  /** column name */
  AirTrafficRecordId = 'air_traffic_record_id',
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltM = 'alt_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugData = 'debug_data',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDegs = 'heading_degs',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  ProximityLevel = 'proximity_level',
  /** column name */
  RelativeAltitudeM = 'relative_altitude_m',
  /** column name */
  RelativeDistanceM = 'relative_distance_m',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  VehicleStatusTimestampMs = 'vehicle_status_timestamp_ms'
}

/** input type for updating data in table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Set_Input = {
  air_traffic_record_id?: Maybe<Scalars['String']>;
  aircraft_type?: Maybe<Scalars['String']>;
  alt_m?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_stddev_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Pop_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_stddev_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Samp_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_stddev_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Stddev_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Sum_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_sum_fields';
  alt_m?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_mps?: Maybe<Scalars['float8']>;
  heading_degs?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  relative_altitude_m?: Maybe<Scalars['float8']>;
  relative_distance_m?: Maybe<Scalars['float8']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Sum_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** update columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export enum Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Update_Column {
  /** column name */
  AirTrafficRecordId = 'air_traffic_record_id',
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltM = 'alt_m',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugData = 'debug_data',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMps = 'groundspeed_mps',
  /** column name */
  HeadingDegs = 'heading_degs',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  ProximityLevel = 'proximity_level',
  /** column name */
  RelativeAltitudeM = 'relative_altitude_m',
  /** column name */
  RelativeDistanceM = 'relative_distance_m',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  VehicleStatusTimestampMs = 'vehicle_status_timestamp_ms'
}

/** aggregate var_pop on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Pop_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_var_pop_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Pop_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Samp_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_var_samp_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Var_Samp_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Variance_Fields = {
  __typename?: 'kafka_air_traffic_vehicle_flight_proximity_recordings_variance_fields';
  alt_m?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_mps?: Maybe<Scalars['Float']>;
  heading_degs?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  relative_altitude_m?: Maybe<Scalars['Float']>;
  relative_distance_m?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_ms?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "kafka_air_traffic_vehicle_flight_proximity_recordings" */
export type Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Variance_Order_By = {
  alt_m?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_mps?: Maybe<Order_By>;
  heading_degs?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  relative_altitude_m?: Maybe<Order_By>;
  relative_distance_m?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  vehicle_status_timestamp_ms?: Maybe<Order_By>;
};

/** columns and relationships of "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters: Scalars['float8'];
  callsign?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id: Scalars['Int'];
  groundspeed_meters_per_second: Scalars['float8'];
  heading_degrees: Scalars['float8'];
  icao_address?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lat_degrees: Scalars['float8'];
  lon_degrees: Scalars['float8'];
  proximity_level: Scalars['String'];
  relative_altitude_meters: Scalars['float8'];
  relative_distance_meters: Scalars['float8'];
  source?: Maybe<Scalars['String']>;
  timestamp_seconds: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
  vehicle_serial_number: Scalars['String'];
  vehicle_status_timestamp_seconds: Scalars['float8'];
};

/** aggregated selection of "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_aggregate';
  aggregate?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate_Fields>;
  nodes: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
};

/** aggregate fields of "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_aggregate_fields';
  avg?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Max_Fields>;
  min?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Min_Fields>;
  stddev?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Fields>;
  stddev_pop?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Samp_Fields>;
  sum?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Sum_Fields>;
  var_pop?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Pop_Fields>;
  var_samp?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Samp_Fields>;
  variance?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Variance_Fields>;
};


/** aggregate fields of "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate_Order_By = {
  avg?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Max_Order_By>;
  min?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Min_Order_By>;
  stddev?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Order_By>;
  stddev_pop?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Samp_Order_By>;
  sum?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Sum_Order_By>;
  var_pop?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Pop_Order_By>;
  var_samp?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Samp_Order_By>;
  variance?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Arr_Rel_Insert_Input = {
  data: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Insert_Input>;
  on_conflict?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_On_Conflict>;
};

/** aggregate avg on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Avg_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_avg_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Avg_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kafka_cached_air_traffic_flight_proximity_recordings". All fields are combined with a logical 'AND'. */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>>>;
  _not?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>>>;
  aircraft_type?: Maybe<String_Comparison_Exp>;
  alt_meters?: Maybe<Float8_Comparison_Exp>;
  callsign?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  debug_data?: Maybe<String_Comparison_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  groundspeed_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  heading_degrees?: Maybe<Float8_Comparison_Exp>;
  icao_address?: Maybe<String_Comparison_Exp>;
  id?: Maybe<String_Comparison_Exp>;
  lat_degrees?: Maybe<Float8_Comparison_Exp>;
  lon_degrees?: Maybe<Float8_Comparison_Exp>;
  proximity_level?: Maybe<String_Comparison_Exp>;
  relative_altitude_meters?: Maybe<Float8_Comparison_Exp>;
  relative_distance_meters?: Maybe<Float8_Comparison_Exp>;
  source?: Maybe<String_Comparison_Exp>;
  timestamp_seconds?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
  vehicle_status_timestamp_seconds?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "kafka_cached_air_traffic_flight_proximity_recordings" */
export enum Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Constraint {
  /** unique or primary key constraint */
  KafkaCachedAirTrafficFlightProximityRecordingsPkey = 'kafka_cached_air_traffic_flight_proximity_recordings_pkey'
}

/** input type for incrementing integer column in table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Inc_Input = {
  alt_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Insert_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Max_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_max_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Max_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Min_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_min_fields';
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Min_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** response of any mutation on the table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Mutation_Response = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
};

/** input type for inserting object relation for remote table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Obj_Rel_Insert_Input = {
  data: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Insert_Input;
  on_conflict?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_On_Conflict>;
};

/** on conflict condition type for table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_On_Conflict = {
  constraint: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Constraint;
  update_columns: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Update_Column>;
  where?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>;
};

/** ordering options when selecting data from "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Order_By = {
  aircraft_type?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  callsign?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  debug_data?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  icao_address?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  proximity_level?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  source?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** primary key columns input for table: "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Pk_Columns_Input = {
  flight_plan_id: Scalars['Int'];
  id: Scalars['String'];
};

/** select columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export enum Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Select_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugData = 'debug_data',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMetersPerSecond = 'groundspeed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegrees = 'lat_degrees',
  /** column name */
  LonDegrees = 'lon_degrees',
  /** column name */
  ProximityLevel = 'proximity_level',
  /** column name */
  RelativeAltitudeMeters = 'relative_altitude_meters',
  /** column name */
  RelativeDistanceMeters = 'relative_distance_meters',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSeconds = 'timestamp_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  VehicleStatusTimestampSeconds = 'vehicle_status_timestamp_seconds'
}

/** input type for updating data in table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Set_Input = {
  aircraft_type?: Maybe<Scalars['String']>;
  alt_meters?: Maybe<Scalars['float8']>;
  callsign?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  debug_data?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  icao_address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  proximity_level?: Maybe<Scalars['String']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  source?: Maybe<Scalars['String']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_stddev_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Pop_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_stddev_pop_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Pop_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Samp_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_stddev_samp_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Stddev_Samp_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Sum_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_sum_fields';
  alt_meters?: Maybe<Scalars['float8']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  groundspeed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degrees?: Maybe<Scalars['float8']>;
  lon_degrees?: Maybe<Scalars['float8']>;
  relative_altitude_meters?: Maybe<Scalars['float8']>;
  relative_distance_meters?: Maybe<Scalars['float8']>;
  timestamp_seconds?: Maybe<Scalars['float8']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Sum_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** update columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export enum Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Update_Column {
  /** column name */
  AircraftType = 'aircraft_type',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  Callsign = 'callsign',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugData = 'debug_data',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  GroundspeedMetersPerSecond = 'groundspeed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  IcaoAddress = 'icao_address',
  /** column name */
  Id = 'id',
  /** column name */
  LatDegrees = 'lat_degrees',
  /** column name */
  LonDegrees = 'lon_degrees',
  /** column name */
  ProximityLevel = 'proximity_level',
  /** column name */
  RelativeAltitudeMeters = 'relative_altitude_meters',
  /** column name */
  RelativeDistanceMeters = 'relative_distance_meters',
  /** column name */
  Source = 'source',
  /** column name */
  TimestampSeconds = 'timestamp_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number',
  /** column name */
  VehicleStatusTimestampSeconds = 'vehicle_status_timestamp_seconds'
}

/** aggregate var_pop on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Pop_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_var_pop_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Pop_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Samp_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_var_samp_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Var_Samp_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Variance_Fields = {
  __typename?: 'kafka_cached_air_traffic_flight_proximity_recordings_variance_fields';
  alt_meters?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  groundspeed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degrees?: Maybe<Scalars['Float']>;
  lon_degrees?: Maybe<Scalars['Float']>;
  relative_altitude_meters?: Maybe<Scalars['Float']>;
  relative_distance_meters?: Maybe<Scalars['Float']>;
  timestamp_seconds?: Maybe<Scalars['Float']>;
  vehicle_status_timestamp_seconds?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "kafka_cached_air_traffic_flight_proximity_recordings" */
export type Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Variance_Order_By = {
  alt_meters?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  groundspeed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degrees?: Maybe<Order_By>;
  lon_degrees?: Maybe<Order_By>;
  relative_altitude_meters?: Maybe<Order_By>;
  relative_distance_meters?: Maybe<Order_By>;
  timestamp_seconds?: Maybe<Order_By>;
  vehicle_status_timestamp_seconds?: Maybe<Order_By>;
};

/** columns and relationships of "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages = {
  __typename?: 'kafka_mqtt_vehicle_status_messages';
  lat: Scalars['float8'];
  lon: Scalars['float8'];
  serial_number: Scalars['String'];
  timestamp: Scalars['float8'];
  topic: Scalars['String'];
  vehicle_status_protobuf: Scalars['bytea'];
};

/** aggregated selection of "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Aggregate = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_aggregate';
  aggregate?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Aggregate_Fields>;
  nodes: Array<Kafka_Mqtt_Vehicle_Status_Messages>;
};

/** aggregate fields of "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Aggregate_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_aggregate_fields';
  avg?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Max_Fields>;
  min?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Min_Fields>;
  stddev?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Sum_Fields>;
  var_pop?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Var_Samp_Fields>;
  variance?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Variance_Fields>;
};


/** aggregate fields of "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Aggregate_Order_By = {
  avg?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Max_Order_By>;
  min?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Min_Order_By>;
  stddev?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Order_By>;
  stddev_pop?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Samp_Order_By>;
  sum?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Sum_Order_By>;
  var_pop?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Var_Pop_Order_By>;
  var_samp?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Var_Samp_Order_By>;
  variance?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Arr_Rel_Insert_Input = {
  data: Array<Kafka_Mqtt_Vehicle_Status_Messages_Insert_Input>;
  on_conflict?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Avg_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_avg_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Avg_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kafka_mqtt_vehicle_status_messages". All fields are combined with a logical 'AND'. */
export type Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>>>;
  _not?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>>>;
  lat?: Maybe<Float8_Comparison_Exp>;
  lon?: Maybe<Float8_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  timestamp?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  vehicle_status_protobuf?: Maybe<Bytea_Comparison_Exp>;
};

/** unique or primary key constraints on table "kafka_mqtt_vehicle_status_messages" */
export enum Kafka_Mqtt_Vehicle_Status_Messages_Constraint {
  /** unique or primary key constraint */
  KafkaMqttVehicleStatusMessagesSerialNumberTimestampPk = 'kafka_mqtt_vehicle_status_messages_serial_number_timestamp_pk'
}

/** input type for incrementing integer column in table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Inc_Input = {
  lat?: Maybe<Scalars['float8']>;
  lon?: Maybe<Scalars['float8']>;
  timestamp?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Insert_Input = {
  lat?: Maybe<Scalars['float8']>;
  lon?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  vehicle_status_protobuf?: Maybe<Scalars['bytea']>;
};

/** aggregate max on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Max_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_max_fields';
  lat?: Maybe<Scalars['float8']>;
  lon?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Max_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Min_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_min_fields';
  lat?: Maybe<Scalars['float8']>;
  lon?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Min_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
};

/** response of any mutation on the table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Mutation_Response = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Kafka_Mqtt_Vehicle_Status_Messages>;
};

/** input type for inserting object relation for remote table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Obj_Rel_Insert_Input = {
  data: Kafka_Mqtt_Vehicle_Status_Messages_Insert_Input;
  on_conflict?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_On_Conflict>;
};

/** on conflict condition type for table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_On_Conflict = {
  constraint: Kafka_Mqtt_Vehicle_Status_Messages_Constraint;
  update_columns: Array<Kafka_Mqtt_Vehicle_Status_Messages_Update_Column>;
  where?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>;
};

/** ordering options when selecting data from "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  vehicle_status_protobuf?: Maybe<Order_By>;
};

/** primary key columns input for table: "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Pk_Columns_Input = {
  serial_number: Scalars['String'];
  timestamp: Scalars['float8'];
};

/** select columns of table "kafka_mqtt_vehicle_status_messages" */
export enum Kafka_Mqtt_Vehicle_Status_Messages_Select_Column {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lon = 'lon',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Topic = 'topic',
  /** column name */
  VehicleStatusProtobuf = 'vehicle_status_protobuf'
}

/** input type for updating data in table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Set_Input = {
  lat?: Maybe<Scalars['float8']>;
  lon?: Maybe<Scalars['float8']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  vehicle_status_protobuf?: Maybe<Scalars['bytea']>;
};

/** aggregate stddev on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_stddev_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Pop_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Pop_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Samp_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Stddev_Samp_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Sum_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_sum_fields';
  lat?: Maybe<Scalars['float8']>;
  lon?: Maybe<Scalars['float8']>;
  timestamp?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Sum_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** update columns of table "kafka_mqtt_vehicle_status_messages" */
export enum Kafka_Mqtt_Vehicle_Status_Messages_Update_Column {
  /** column name */
  Lat = 'lat',
  /** column name */
  Lon = 'lon',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  Topic = 'topic',
  /** column name */
  VehicleStatusProtobuf = 'vehicle_status_protobuf'
}

/** aggregate var_pop on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Var_Pop_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_var_pop_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Var_Pop_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Var_Samp_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_var_samp_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Var_Samp_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Kafka_Mqtt_Vehicle_Status_Messages_Variance_Fields = {
  __typename?: 'kafka_mqtt_vehicle_status_messages_variance_fields';
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  timestamp?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "kafka_mqtt_vehicle_status_messages" */
export type Kafka_Mqtt_Vehicle_Status_Messages_Variance_Order_By = {
  lat?: Maybe<Order_By>;
  lon?: Maybe<Order_By>;
  timestamp?: Maybe<Order_By>;
};

/** columns and relationships of "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses = {
  __typename?: 'kafka_serialized_ground_asset_statuses';
  activity_state?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  ground_asset?: Maybe<Ground_Assets>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs: Scalars['float8'];
  location?: Maybe<Scalars['geometry']>;
  lon_degs: Scalars['float8'];
  occupied?: Maybe<Scalars['Boolean']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  protobuf_message: Scalars['bytea'];
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Aggregate = {
  __typename?: 'kafka_serialized_ground_asset_statuses_aggregate';
  aggregate?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Aggregate_Fields>;
  nodes: Array<Kafka_Serialized_Ground_Asset_Statuses>;
};

/** aggregate fields of "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Aggregate_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_aggregate_fields';
  avg?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Max_Fields>;
  min?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Min_Fields>;
  stddev?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Sum_Fields>;
  var_pop?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Variance_Fields>;
};


/** aggregate fields of "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Max_Order_By>;
  min?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Min_Order_By>;
  stddev?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Kafka_Serialized_Ground_Asset_Statuses_Insert_Input>;
  on_conflict?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Avg_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_avg_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Avg_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kafka_serialized_ground_asset_statuses". All fields are combined with a logical 'AND'. */
export type Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>>>;
  _not?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>>>;
  activity_state?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  ground_asset?: Maybe<Ground_Assets_Bool_Exp>;
  ground_asset_state?: Maybe<Int_Comparison_Exp>;
  hardware_state?: Maybe<Int_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  occupied?: Maybe<Boolean_Comparison_Exp>;
  paired_vehicle_conn_state?: Maybe<Int_Comparison_Exp>;
  paired_vehicle_serial_number?: Maybe<String_Comparison_Exp>;
  protobuf_message?: Maybe<Bytea_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  timestamp_date?: Maybe<Timestamptz_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "kafka_serialized_ground_asset_statuses" */
export enum Kafka_Serialized_Ground_Asset_Statuses_Constraint {
  /** unique or primary key constraint */
  KafkaSerializedGroundAssetStatusesPkey = 'kafka_serialized_ground_asset_statuses_pkey'
}

/** input type for incrementing integer column in table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Inc_Input = {
  activity_state?: Maybe<Scalars['Int']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Insert_Input = {
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset?: Maybe<Ground_Assets_Obj_Rel_Insert_Input>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  occupied?: Maybe<Scalars['Boolean']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Max_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_max_fields';
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Max_Order_By = {
  activity_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  paired_vehicle_serial_number?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Min_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_min_fields';
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Min_Order_By = {
  activity_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  paired_vehicle_serial_number?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Mutation_Response = {
  __typename?: 'kafka_serialized_ground_asset_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Kafka_Serialized_Ground_Asset_Statuses>;
};

/** input type for inserting object relation for remote table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Obj_Rel_Insert_Input = {
  data: Kafka_Serialized_Ground_Asset_Statuses_Insert_Input;
  on_conflict?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_On_Conflict>;
};

/** on conflict condition type for table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_On_Conflict = {
  constraint: Kafka_Serialized_Ground_Asset_Statuses_Constraint;
  update_columns: Array<Kafka_Serialized_Ground_Asset_Statuses_Update_Column>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Order_By = {
  activity_state?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  ground_asset?: Maybe<Ground_Assets_Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  occupied?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  paired_vehicle_serial_number?: Maybe<Order_By>;
  protobuf_message?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Pk_Columns_Input = {
  topic: Scalars['String'];
};

/** select columns of table "kafka_serialized_ground_asset_statuses" */
export enum Kafka_Serialized_Ground_Asset_Statuses_Select_Column {
  /** column name */
  ActivityState = 'activity_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundAssetState = 'ground_asset_state',
  /** column name */
  HardwareState = 'hardware_state',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Occupied = 'occupied',
  /** column name */
  PairedVehicleConnState = 'paired_vehicle_conn_state',
  /** column name */
  PairedVehicleSerialNumber = 'paired_vehicle_serial_number',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Set_Input = {
  activity_state?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  occupied?: Maybe<Scalars['Boolean']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  paired_vehicle_serial_number?: Maybe<Scalars['String']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  serial_number?: Maybe<Scalars['String']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Stddev_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_stddev_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Stddev_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Stddev_Pop_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_stddev_pop_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Stddev_Pop_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Stddev_Samp_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_stddev_samp_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Stddev_Samp_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Sum_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_sum_fields';
  activity_state?: Maybe<Scalars['Int']>;
  ground_asset_state?: Maybe<Scalars['Int']>;
  hardware_state?: Maybe<Scalars['Int']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Sum_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "kafka_serialized_ground_asset_statuses" */
export enum Kafka_Serialized_Ground_Asset_Statuses_Update_Column {
  /** column name */
  ActivityState = 'activity_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroundAssetState = 'ground_asset_state',
  /** column name */
  HardwareState = 'hardware_state',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  Occupied = 'occupied',
  /** column name */
  PairedVehicleConnState = 'paired_vehicle_conn_state',
  /** column name */
  PairedVehicleSerialNumber = 'paired_vehicle_serial_number',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Var_Pop_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_var_pop_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Var_Pop_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Var_Samp_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_var_samp_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Var_Samp_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Kafka_Serialized_Ground_Asset_Statuses_Variance_Fields = {
  __typename?: 'kafka_serialized_ground_asset_statuses_variance_fields';
  activity_state?: Maybe<Scalars['Float']>;
  ground_asset_state?: Maybe<Scalars['Float']>;
  hardware_state?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  paired_vehicle_conn_state?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "kafka_serialized_ground_asset_statuses" */
export type Kafka_Serialized_Ground_Asset_Statuses_Variance_Order_By = {
  activity_state?: Maybe<Order_By>;
  ground_asset_state?: Maybe<Order_By>;
  hardware_state?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  paired_vehicle_conn_state?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/**
 * Table containing the vehicle telemetry data.
 *
 *
 * columns and relationships of "kafka_serialized_vehicle_statuses"
 */
export type Kafka_Serialized_Vehicle_Statuses = {
  __typename?: 'kafka_serialized_vehicle_statuses';
  /** Accessory State for BPLU */
  accessory_state?: Maybe<Scalars['Int']>;
  /** Aircraft Air Speed */
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  /** Altitude of the vehicle above ground in meters. Positive for up. */
  alt_agl_meters?: Maybe<Scalars['float8']>;
  /** Aircraft Altitude Above Mean Sea Level (MSL) */
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  /** Is Battery Locked */
  battery_locked?: Maybe<Scalars['Boolean']>;
  /** Battery Power in Watts */
  battery_power_watts?: Maybe<Scalars['float8']>;
  /** Battery Temperature in Celsius */
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  /** Battery Voltage in Volts */
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  destination_soc_required?: Maybe<Scalars['float8']>;
  /** @Deprecated, use estimated_soc_percentage */
  estimated_soc?: Maybe<Scalars['float8']>;
  /** Estimated State of Charge (SOC) Percentage */
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  /** Estimated time of arrival of vehicle at destination in seconds. */
  eta_secs?: Maybe<Scalars['float8']>;
  /** Estimated time enroute of vehicle in seconds. */
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  /** An object relationship */
  flightStatus?: Maybe<Vehicle_Flight_Statuses>;
  /** Flight Mode */
  flight_mode?: Maybe<Scalars['Int']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  /** GPS Fix Type, see: https://mavlink.io/en/messages/common.html#GPS_FIX_TYPE */
  gps_fix_type?: Maybe<Scalars['Int']>;
  /** Speed of the vehicle over ground in meters per second. */
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  /** Heading in compass units. [0, 359] 0 = north. */
  heading_degrees?: Maybe<Scalars['float8']>;
  landing_type?: Maybe<Scalars['String']>;
  /** Latitude in degrees [-180, 180]. */
  lat_degs: Scalars['float8'];
  /** Lidar Dist in Meters */
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  /** Longitude in degrees [-180, 180]. */
  lon_degs: Scalars['float8'];
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  /** Paired Ground Asset Serial Number */
  paired_ground_asset_serial_number?: Maybe<Scalars['String']>;
  /** Is Payload Locked */
  payload_locked?: Maybe<Scalars['Boolean']>;
  /** PL Retries */
  pl_retries?: Maybe<Scalars['Int']>;
  /** PL Target (Searching/Acquired) */
  pl_target_number?: Maybe<Scalars['Boolean']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  protobuf_message: Scalars['bytea'];
  /** Reported State of Charge (SOC) Percentage */
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  /** Number of Visible Satellites */
  satellites_visible?: Maybe<Scalars['Int']>;
  /** Serial number of the vehicle. */
  serial_number?: Maybe<Scalars['String']>;
  /** @Deprecated, use reported_soc_percentage */
  smbt_soc?: Maybe<Scalars['float8']>;
  /** @Deprecated, not currently tracked or used */
  smbt_spn?: Maybe<Scalars['String']>;
  /** Aircraft Throttle Percentage */
  throttle_percentage?: Maybe<Scalars['Int']>;
  /** Time and date of telemetry formatted as YYYY-MM-DD HH:MM:SS.MMS. */
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  /** Time and date of telemetry in seconds since epoch. */
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
};

/** aggregated selection of "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Aggregate = {
  __typename?: 'kafka_serialized_vehicle_statuses_aggregate';
  aggregate?: Maybe<Kafka_Serialized_Vehicle_Statuses_Aggregate_Fields>;
  nodes: Array<Kafka_Serialized_Vehicle_Statuses>;
};

/** aggregate fields of "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Aggregate_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_aggregate_fields';
  avg?: Maybe<Kafka_Serialized_Vehicle_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Kafka_Serialized_Vehicle_Statuses_Max_Fields>;
  min?: Maybe<Kafka_Serialized_Vehicle_Statuses_Min_Fields>;
  stddev?: Maybe<Kafka_Serialized_Vehicle_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Kafka_Serialized_Vehicle_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kafka_Serialized_Vehicle_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Kafka_Serialized_Vehicle_Statuses_Sum_Fields>;
  var_pop?: Maybe<Kafka_Serialized_Vehicle_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Kafka_Serialized_Vehicle_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Kafka_Serialized_Vehicle_Statuses_Variance_Fields>;
};


/** aggregate fields of "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Kafka_Serialized_Vehicle_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Kafka_Serialized_Vehicle_Statuses_Max_Order_By>;
  min?: Maybe<Kafka_Serialized_Vehicle_Statuses_Min_Order_By>;
  stddev?: Maybe<Kafka_Serialized_Vehicle_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Kafka_Serialized_Vehicle_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Kafka_Serialized_Vehicle_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Kafka_Serialized_Vehicle_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Kafka_Serialized_Vehicle_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Kafka_Serialized_Vehicle_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Kafka_Serialized_Vehicle_Statuses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Kafka_Serialized_Vehicle_Statuses_Insert_Input>;
  on_conflict?: Maybe<Kafka_Serialized_Vehicle_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Kafka_Serialized_Vehicle_Statuses_Avg_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_avg_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Avg_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kafka_serialized_vehicle_statuses". All fields are combined with a logical 'AND'. */
export type Kafka_Serialized_Vehicle_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>>>;
  _not?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>>>;
  accessory_state?: Maybe<Int_Comparison_Exp>;
  air_speed_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  alt_agl_meters?: Maybe<Float8_Comparison_Exp>;
  alt_meters?: Maybe<Float8_Comparison_Exp>;
  anomaly_status?: Maybe<Int_Comparison_Exp>;
  battery_locked?: Maybe<Boolean_Comparison_Exp>;
  battery_power_watts?: Maybe<Float8_Comparison_Exp>;
  battery_temperature_celsius?: Maybe<Float8_Comparison_Exp>;
  battery_voltage_volts?: Maybe<Float8_Comparison_Exp>;
  cell_modem_rssi?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  destination_soc_required?: Maybe<Float8_Comparison_Exp>;
  estimated_soc?: Maybe<Float8_Comparison_Exp>;
  estimated_soc_percentage?: Maybe<Int_Comparison_Exp>;
  eta_secs?: Maybe<Float8_Comparison_Exp>;
  ete_terminal_airspace_secs?: Maybe<Float8_Comparison_Exp>;
  flightStatus?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
  flight_mode?: Maybe<Int_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  fts_state?: Maybe<Int_Comparison_Exp>;
  gps_fix_type?: Maybe<Int_Comparison_Exp>;
  ground_speed_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  heading_degrees?: Maybe<Float8_Comparison_Exp>;
  landing_type?: Maybe<String_Comparison_Exp>;
  lat_degs?: Maybe<Float8_Comparison_Exp>;
  lidar_dist_meters?: Maybe<Float8_Comparison_Exp>;
  location?: Maybe<Geometry_Comparison_Exp>;
  lon_degs?: Maybe<Float8_Comparison_Exp>;
  nearest_safety_zone_flight_path_idx?: Maybe<Int_Comparison_Exp>;
  paired_ground_asset_serial_number?: Maybe<String_Comparison_Exp>;
  payload_locked?: Maybe<Boolean_Comparison_Exp>;
  pl_retries?: Maybe<Int_Comparison_Exp>;
  pl_target_number?: Maybe<Boolean_Comparison_Exp>;
  primary_gps_indicator?: Maybe<Int_Comparison_Exp>;
  protobuf_message?: Maybe<Bytea_Comparison_Exp>;
  reported_soc_percentage?: Maybe<Int_Comparison_Exp>;
  satellites_visible?: Maybe<Int_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  smbt_soc?: Maybe<Float8_Comparison_Exp>;
  smbt_spn?: Maybe<String_Comparison_Exp>;
  throttle_percentage?: Maybe<Int_Comparison_Exp>;
  timestamp_date?: Maybe<Timestamptz_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
};

/** unique or primary key constraints on table "kafka_serialized_vehicle_statuses" */
export enum Kafka_Serialized_Vehicle_Statuses_Constraint {
  /** unique or primary key constraint */
  KafkaSerializedVehicleStatusesPkey = 'kafka_serialized_vehicle_statuses_pkey'
}

/** input type for incrementing integer column in table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Inc_Input = {
  accessory_state?: Maybe<Scalars['Int']>;
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  battery_power_watts?: Maybe<Scalars['float8']>;
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  destination_soc_required?: Maybe<Scalars['float8']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_mode?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  gps_fix_type?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  pl_retries?: Maybe<Scalars['Int']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  satellites_visible?: Maybe<Scalars['Int']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  throttle_percentage?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Insert_Input = {
  accessory_state?: Maybe<Scalars['Int']>;
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  battery_locked?: Maybe<Scalars['Boolean']>;
  battery_power_watts?: Maybe<Scalars['float8']>;
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_soc_required?: Maybe<Scalars['float8']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flightStatus?: Maybe<Vehicle_Flight_Statuses_Obj_Rel_Insert_Input>;
  flight_mode?: Maybe<Scalars['Int']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  gps_fix_type?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  landing_type?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  paired_ground_asset_serial_number?: Maybe<Scalars['String']>;
  payload_locked?: Maybe<Scalars['Boolean']>;
  pl_retries?: Maybe<Scalars['Int']>;
  pl_target_number?: Maybe<Scalars['Boolean']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  satellites_visible?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  throttle_percentage?: Maybe<Scalars['Int']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Kafka_Serialized_Vehicle_Statuses_Max_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_max_fields';
  accessory_state?: Maybe<Scalars['Int']>;
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  battery_power_watts?: Maybe<Scalars['float8']>;
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_soc_required?: Maybe<Scalars['float8']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_mode?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  gps_fix_type?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  landing_type?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  paired_ground_asset_serial_number?: Maybe<Scalars['String']>;
  pl_retries?: Maybe<Scalars['Int']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  satellites_visible?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  throttle_percentage?: Maybe<Scalars['Int']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Max_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  landing_type?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  paired_ground_asset_serial_number?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  smbt_spn?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Kafka_Serialized_Vehicle_Statuses_Min_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_min_fields';
  accessory_state?: Maybe<Scalars['Int']>;
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  battery_power_watts?: Maybe<Scalars['float8']>;
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_soc_required?: Maybe<Scalars['float8']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_mode?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  gps_fix_type?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  landing_type?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  paired_ground_asset_serial_number?: Maybe<Scalars['String']>;
  pl_retries?: Maybe<Scalars['Int']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  satellites_visible?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  throttle_percentage?: Maybe<Scalars['Int']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Min_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  landing_type?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  paired_ground_asset_serial_number?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  smbt_spn?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Mutation_Response = {
  __typename?: 'kafka_serialized_vehicle_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Kafka_Serialized_Vehicle_Statuses>;
};

/** input type for inserting object relation for remote table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Obj_Rel_Insert_Input = {
  data: Kafka_Serialized_Vehicle_Statuses_Insert_Input;
  on_conflict?: Maybe<Kafka_Serialized_Vehicle_Statuses_On_Conflict>;
};

/** on conflict condition type for table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_On_Conflict = {
  constraint: Kafka_Serialized_Vehicle_Statuses_Constraint;
  update_columns: Array<Kafka_Serialized_Vehicle_Statuses_Update_Column>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_locked?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flightStatus?: Maybe<Vehicle_Flight_Statuses_Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  landing_type?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  location?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  paired_ground_asset_serial_number?: Maybe<Order_By>;
  payload_locked?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  pl_target_number?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  protobuf_message?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  smbt_spn?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_date?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
};

/** primary key columns input for table: "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Pk_Columns_Input = {
  topic: Scalars['String'];
};

/** select columns of table "kafka_serialized_vehicle_statuses" */
export enum Kafka_Serialized_Vehicle_Statuses_Select_Column {
  /** column name */
  AccessoryState = 'accessory_state',
  /** column name */
  AirSpeedMetersPerSecond = 'air_speed_meters_per_second',
  /** column name */
  AltAglMeters = 'alt_agl_meters',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  AnomalyStatus = 'anomaly_status',
  /** column name */
  BatteryLocked = 'battery_locked',
  /** column name */
  BatteryPowerWatts = 'battery_power_watts',
  /** column name */
  BatteryTemperatureCelsius = 'battery_temperature_celsius',
  /** column name */
  BatteryVoltageVolts = 'battery_voltage_volts',
  /** column name */
  CellModemRssi = 'cell_modem_rssi',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DestinationSocRequired = 'destination_soc_required',
  /** column name */
  EstimatedSoc = 'estimated_soc',
  /** column name */
  EstimatedSocPercentage = 'estimated_soc_percentage',
  /** column name */
  EtaSecs = 'eta_secs',
  /** column name */
  EteTerminalAirspaceSecs = 'ete_terminal_airspace_secs',
  /** column name */
  FlightMode = 'flight_mode',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FtsState = 'fts_state',
  /** column name */
  GpsFixType = 'gps_fix_type',
  /** column name */
  GroundSpeedMetersPerSecond = 'ground_speed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  LandingType = 'landing_type',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  LidarDistMeters = 'lidar_dist_meters',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  NearestSafetyZoneFlightPathIdx = 'nearest_safety_zone_flight_path_idx',
  /** column name */
  PairedGroundAssetSerialNumber = 'paired_ground_asset_serial_number',
  /** column name */
  PayloadLocked = 'payload_locked',
  /** column name */
  PlRetries = 'pl_retries',
  /** column name */
  PlTargetNumber = 'pl_target_number',
  /** column name */
  PrimaryGpsIndicator = 'primary_gps_indicator',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  ReportedSocPercentage = 'reported_soc_percentage',
  /** column name */
  SatellitesVisible = 'satellites_visible',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SmbtSoc = 'smbt_soc',
  /** column name */
  SmbtSpn = 'smbt_spn',
  /** column name */
  ThrottlePercentage = 'throttle_percentage',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Set_Input = {
  accessory_state?: Maybe<Scalars['Int']>;
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  battery_locked?: Maybe<Scalars['Boolean']>;
  battery_power_watts?: Maybe<Scalars['float8']>;
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  destination_soc_required?: Maybe<Scalars['float8']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_mode?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  gps_fix_type?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  landing_type?: Maybe<Scalars['String']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  location?: Maybe<Scalars['geometry']>;
  lon_degs?: Maybe<Scalars['float8']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  paired_ground_asset_serial_number?: Maybe<Scalars['String']>;
  payload_locked?: Maybe<Scalars['Boolean']>;
  pl_retries?: Maybe<Scalars['Int']>;
  pl_target_number?: Maybe<Scalars['Boolean']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  protobuf_message?: Maybe<Scalars['bytea']>;
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  satellites_visible?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  smbt_spn?: Maybe<Scalars['String']>;
  throttle_percentage?: Maybe<Scalars['Int']>;
  timestamp_date?: Maybe<Scalars['timestamptz']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Kafka_Serialized_Vehicle_Statuses_Stddev_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_stddev_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Stddev_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Kafka_Serialized_Vehicle_Statuses_Stddev_Pop_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_stddev_pop_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Stddev_Pop_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Kafka_Serialized_Vehicle_Statuses_Stddev_Samp_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_stddev_samp_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Stddev_Samp_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Kafka_Serialized_Vehicle_Statuses_Sum_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_sum_fields';
  accessory_state?: Maybe<Scalars['Int']>;
  air_speed_meters_per_second?: Maybe<Scalars['float8']>;
  alt_agl_meters?: Maybe<Scalars['float8']>;
  alt_meters?: Maybe<Scalars['float8']>;
  anomaly_status?: Maybe<Scalars['Int']>;
  battery_power_watts?: Maybe<Scalars['float8']>;
  battery_temperature_celsius?: Maybe<Scalars['float8']>;
  battery_voltage_volts?: Maybe<Scalars['float8']>;
  cell_modem_rssi?: Maybe<Scalars['Int']>;
  destination_soc_required?: Maybe<Scalars['float8']>;
  estimated_soc?: Maybe<Scalars['float8']>;
  estimated_soc_percentage?: Maybe<Scalars['Int']>;
  eta_secs?: Maybe<Scalars['float8']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['float8']>;
  flight_mode?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_state?: Maybe<Scalars['Int']>;
  gps_fix_type?: Maybe<Scalars['Int']>;
  ground_speed_meters_per_second?: Maybe<Scalars['float8']>;
  heading_degrees?: Maybe<Scalars['float8']>;
  lat_degs?: Maybe<Scalars['float8']>;
  lidar_dist_meters?: Maybe<Scalars['float8']>;
  lon_degs?: Maybe<Scalars['float8']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Int']>;
  pl_retries?: Maybe<Scalars['Int']>;
  primary_gps_indicator?: Maybe<Scalars['Int']>;
  reported_soc_percentage?: Maybe<Scalars['Int']>;
  satellites_visible?: Maybe<Scalars['Int']>;
  smbt_soc?: Maybe<Scalars['float8']>;
  throttle_percentage?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Sum_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "kafka_serialized_vehicle_statuses" */
export enum Kafka_Serialized_Vehicle_Statuses_Update_Column {
  /** column name */
  AccessoryState = 'accessory_state',
  /** column name */
  AirSpeedMetersPerSecond = 'air_speed_meters_per_second',
  /** column name */
  AltAglMeters = 'alt_agl_meters',
  /** column name */
  AltMeters = 'alt_meters',
  /** column name */
  AnomalyStatus = 'anomaly_status',
  /** column name */
  BatteryLocked = 'battery_locked',
  /** column name */
  BatteryPowerWatts = 'battery_power_watts',
  /** column name */
  BatteryTemperatureCelsius = 'battery_temperature_celsius',
  /** column name */
  BatteryVoltageVolts = 'battery_voltage_volts',
  /** column name */
  CellModemRssi = 'cell_modem_rssi',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DestinationSocRequired = 'destination_soc_required',
  /** column name */
  EstimatedSoc = 'estimated_soc',
  /** column name */
  EstimatedSocPercentage = 'estimated_soc_percentage',
  /** column name */
  EtaSecs = 'eta_secs',
  /** column name */
  EteTerminalAirspaceSecs = 'ete_terminal_airspace_secs',
  /** column name */
  FlightMode = 'flight_mode',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FtsState = 'fts_state',
  /** column name */
  GpsFixType = 'gps_fix_type',
  /** column name */
  GroundSpeedMetersPerSecond = 'ground_speed_meters_per_second',
  /** column name */
  HeadingDegrees = 'heading_degrees',
  /** column name */
  LandingType = 'landing_type',
  /** column name */
  LatDegs = 'lat_degs',
  /** column name */
  LidarDistMeters = 'lidar_dist_meters',
  /** column name */
  Location = 'location',
  /** column name */
  LonDegs = 'lon_degs',
  /** column name */
  NearestSafetyZoneFlightPathIdx = 'nearest_safety_zone_flight_path_idx',
  /** column name */
  PairedGroundAssetSerialNumber = 'paired_ground_asset_serial_number',
  /** column name */
  PayloadLocked = 'payload_locked',
  /** column name */
  PlRetries = 'pl_retries',
  /** column name */
  PlTargetNumber = 'pl_target_number',
  /** column name */
  PrimaryGpsIndicator = 'primary_gps_indicator',
  /** column name */
  ProtobufMessage = 'protobuf_message',
  /** column name */
  ReportedSocPercentage = 'reported_soc_percentage',
  /** column name */
  SatellitesVisible = 'satellites_visible',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  SmbtSoc = 'smbt_soc',
  /** column name */
  SmbtSpn = 'smbt_spn',
  /** column name */
  ThrottlePercentage = 'throttle_percentage',
  /** column name */
  TimestampDate = 'timestamp_date',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Kafka_Serialized_Vehicle_Statuses_Var_Pop_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_var_pop_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Var_Pop_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Kafka_Serialized_Vehicle_Statuses_Var_Samp_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_var_samp_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Var_Samp_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Kafka_Serialized_Vehicle_Statuses_Variance_Fields = {
  __typename?: 'kafka_serialized_vehicle_statuses_variance_fields';
  accessory_state?: Maybe<Scalars['Float']>;
  air_speed_meters_per_second?: Maybe<Scalars['Float']>;
  alt_agl_meters?: Maybe<Scalars['Float']>;
  alt_meters?: Maybe<Scalars['Float']>;
  anomaly_status?: Maybe<Scalars['Float']>;
  battery_power_watts?: Maybe<Scalars['Float']>;
  battery_temperature_celsius?: Maybe<Scalars['Float']>;
  battery_voltage_volts?: Maybe<Scalars['Float']>;
  cell_modem_rssi?: Maybe<Scalars['Float']>;
  destination_soc_required?: Maybe<Scalars['Float']>;
  estimated_soc?: Maybe<Scalars['Float']>;
  estimated_soc_percentage?: Maybe<Scalars['Float']>;
  eta_secs?: Maybe<Scalars['Float']>;
  ete_terminal_airspace_secs?: Maybe<Scalars['Float']>;
  flight_mode?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  fts_state?: Maybe<Scalars['Float']>;
  gps_fix_type?: Maybe<Scalars['Float']>;
  ground_speed_meters_per_second?: Maybe<Scalars['Float']>;
  heading_degrees?: Maybe<Scalars['Float']>;
  lat_degs?: Maybe<Scalars['Float']>;
  lidar_dist_meters?: Maybe<Scalars['Float']>;
  lon_degs?: Maybe<Scalars['Float']>;
  nearest_safety_zone_flight_path_idx?: Maybe<Scalars['Float']>;
  pl_retries?: Maybe<Scalars['Float']>;
  primary_gps_indicator?: Maybe<Scalars['Float']>;
  reported_soc_percentage?: Maybe<Scalars['Float']>;
  satellites_visible?: Maybe<Scalars['Float']>;
  smbt_soc?: Maybe<Scalars['Float']>;
  throttle_percentage?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "kafka_serialized_vehicle_statuses" */
export type Kafka_Serialized_Vehicle_Statuses_Variance_Order_By = {
  accessory_state?: Maybe<Order_By>;
  air_speed_meters_per_second?: Maybe<Order_By>;
  alt_agl_meters?: Maybe<Order_By>;
  alt_meters?: Maybe<Order_By>;
  anomaly_status?: Maybe<Order_By>;
  battery_power_watts?: Maybe<Order_By>;
  battery_temperature_celsius?: Maybe<Order_By>;
  battery_voltage_volts?: Maybe<Order_By>;
  cell_modem_rssi?: Maybe<Order_By>;
  destination_soc_required?: Maybe<Order_By>;
  estimated_soc?: Maybe<Order_By>;
  estimated_soc_percentage?: Maybe<Order_By>;
  eta_secs?: Maybe<Order_By>;
  ete_terminal_airspace_secs?: Maybe<Order_By>;
  flight_mode?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_state?: Maybe<Order_By>;
  gps_fix_type?: Maybe<Order_By>;
  ground_speed_meters_per_second?: Maybe<Order_By>;
  heading_degrees?: Maybe<Order_By>;
  lat_degs?: Maybe<Order_By>;
  lidar_dist_meters?: Maybe<Order_By>;
  lon_degs?: Maybe<Order_By>;
  nearest_safety_zone_flight_path_idx?: Maybe<Order_By>;
  pl_retries?: Maybe<Order_By>;
  primary_gps_indicator?: Maybe<Order_By>;
  reported_soc_percentage?: Maybe<Order_By>;
  satellites_visible?: Maybe<Order_By>;
  smbt_soc?: Maybe<Order_By>;
  throttle_percentage?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "landing_request_statuses" */
export type Landing_Request_Statuses = {
  __typename?: 'landing_request_statuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "landing_request_statuses" */
export type Landing_Request_Statuses_Aggregate = {
  __typename?: 'landing_request_statuses_aggregate';
  aggregate?: Maybe<Landing_Request_Statuses_Aggregate_Fields>;
  nodes: Array<Landing_Request_Statuses>;
};

/** aggregate fields of "landing_request_statuses" */
export type Landing_Request_Statuses_Aggregate_Fields = {
  __typename?: 'landing_request_statuses_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Landing_Request_Statuses_Max_Fields>;
  min?: Maybe<Landing_Request_Statuses_Min_Fields>;
};


/** aggregate fields of "landing_request_statuses" */
export type Landing_Request_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Landing_Request_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "landing_request_statuses" */
export type Landing_Request_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Landing_Request_Statuses_Max_Order_By>;
  min?: Maybe<Landing_Request_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "landing_request_statuses" */
export type Landing_Request_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Landing_Request_Statuses_Insert_Input>;
  on_conflict?: Maybe<Landing_Request_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "landing_request_statuses". All fields are combined with a logical 'AND'. */
export type Landing_Request_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Landing_Request_Statuses_Bool_Exp>>>;
  _not?: Maybe<Landing_Request_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Landing_Request_Statuses_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "landing_request_statuses" */
export enum Landing_Request_Statuses_Constraint {
  /** unique or primary key constraint */
  LandingRequestStatusesPkey = 'landing_request_statuses_pkey'
}

export enum Landing_Request_Statuses_Enum {
  /** APPROVED */
  Approved = 'APPROVED',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** WAIT */
  Wait = 'WAIT'
}

/** expression to compare columns of type landing_request_statuses_enum. All fields are combined with logical 'AND'. */
export type Landing_Request_Statuses_Enum_Comparison_Exp = {
  _eq?: Maybe<Landing_Request_Statuses_Enum>;
  _in?: Maybe<Array<Landing_Request_Statuses_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Landing_Request_Statuses_Enum>;
  _nin?: Maybe<Array<Landing_Request_Statuses_Enum>>;
};

/** input type for inserting data into table "landing_request_statuses" */
export type Landing_Request_Statuses_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Landing_Request_Statuses_Max_Fields = {
  __typename?: 'landing_request_statuses_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "landing_request_statuses" */
export type Landing_Request_Statuses_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Landing_Request_Statuses_Min_Fields = {
  __typename?: 'landing_request_statuses_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "landing_request_statuses" */
export type Landing_Request_Statuses_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "landing_request_statuses" */
export type Landing_Request_Statuses_Mutation_Response = {
  __typename?: 'landing_request_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Landing_Request_Statuses>;
};

/** input type for inserting object relation for remote table "landing_request_statuses" */
export type Landing_Request_Statuses_Obj_Rel_Insert_Input = {
  data: Landing_Request_Statuses_Insert_Input;
  on_conflict?: Maybe<Landing_Request_Statuses_On_Conflict>;
};

/** on conflict condition type for table "landing_request_statuses" */
export type Landing_Request_Statuses_On_Conflict = {
  constraint: Landing_Request_Statuses_Constraint;
  update_columns: Array<Landing_Request_Statuses_Update_Column>;
  where?: Maybe<Landing_Request_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "landing_request_statuses" */
export type Landing_Request_Statuses_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "landing_request_statuses" */
export type Landing_Request_Statuses_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "landing_request_statuses" */
export enum Landing_Request_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "landing_request_statuses" */
export type Landing_Request_Statuses_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "landing_request_statuses" */
export enum Landing_Request_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "landing_requests" */
export type Landing_Requests = {
  __typename?: 'landing_requests';
  active?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  pad_serial?: Maybe<Scalars['String']>;
  /** An object relationship */
  station?: Maybe<Stations>;
  station_id?: Maybe<Scalars['Int']>;
  status: Landing_Request_Statuses_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
};

/** aggregated selection of "landing_requests" */
export type Landing_Requests_Aggregate = {
  __typename?: 'landing_requests_aggregate';
  aggregate?: Maybe<Landing_Requests_Aggregate_Fields>;
  nodes: Array<Landing_Requests>;
};

/** aggregate fields of "landing_requests" */
export type Landing_Requests_Aggregate_Fields = {
  __typename?: 'landing_requests_aggregate_fields';
  avg?: Maybe<Landing_Requests_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Landing_Requests_Max_Fields>;
  min?: Maybe<Landing_Requests_Min_Fields>;
  stddev?: Maybe<Landing_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Landing_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Landing_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Landing_Requests_Sum_Fields>;
  var_pop?: Maybe<Landing_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Landing_Requests_Var_Samp_Fields>;
  variance?: Maybe<Landing_Requests_Variance_Fields>;
};


/** aggregate fields of "landing_requests" */
export type Landing_Requests_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Landing_Requests_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "landing_requests" */
export type Landing_Requests_Aggregate_Order_By = {
  avg?: Maybe<Landing_Requests_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Landing_Requests_Max_Order_By>;
  min?: Maybe<Landing_Requests_Min_Order_By>;
  stddev?: Maybe<Landing_Requests_Stddev_Order_By>;
  stddev_pop?: Maybe<Landing_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Landing_Requests_Stddev_Samp_Order_By>;
  sum?: Maybe<Landing_Requests_Sum_Order_By>;
  var_pop?: Maybe<Landing_Requests_Var_Pop_Order_By>;
  var_samp?: Maybe<Landing_Requests_Var_Samp_Order_By>;
  variance?: Maybe<Landing_Requests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "landing_requests" */
export type Landing_Requests_Arr_Rel_Insert_Input = {
  data: Array<Landing_Requests_Insert_Input>;
  on_conflict?: Maybe<Landing_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Landing_Requests_Avg_Fields = {
  __typename?: 'landing_requests_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "landing_requests" */
export type Landing_Requests_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "landing_requests". All fields are combined with a logical 'AND'. */
export type Landing_Requests_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Landing_Requests_Bool_Exp>>>;
  _not?: Maybe<Landing_Requests_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Landing_Requests_Bool_Exp>>>;
  active?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  pad_serial?: Maybe<String_Comparison_Exp>;
  station?: Maybe<Stations_Bool_Exp>;
  station_id?: Maybe<Int_Comparison_Exp>;
  status?: Maybe<Landing_Request_Statuses_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "landing_requests" */
export enum Landing_Requests_Constraint {
  /** unique or primary key constraint */
  LandingRequestsPkey = 'landing_requests_pkey'
}

/** input type for incrementing integer column in table "landing_requests" */
export type Landing_Requests_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  station_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "landing_requests" */
export type Landing_Requests_Insert_Input = {
  active?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pad_serial?: Maybe<Scalars['String']>;
  station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  station_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Landing_Request_Statuses_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Landing_Requests_Max_Fields = {
  __typename?: 'landing_requests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pad_serial?: Maybe<Scalars['String']>;
  station_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "landing_requests" */
export type Landing_Requests_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pad_serial?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Landing_Requests_Min_Fields = {
  __typename?: 'landing_requests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pad_serial?: Maybe<Scalars['String']>;
  station_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "landing_requests" */
export type Landing_Requests_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pad_serial?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "landing_requests" */
export type Landing_Requests_Mutation_Response = {
  __typename?: 'landing_requests_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Landing_Requests>;
};

/** input type for inserting object relation for remote table "landing_requests" */
export type Landing_Requests_Obj_Rel_Insert_Input = {
  data: Landing_Requests_Insert_Input;
  on_conflict?: Maybe<Landing_Requests_On_Conflict>;
};

/** on conflict condition type for table "landing_requests" */
export type Landing_Requests_On_Conflict = {
  constraint: Landing_Requests_Constraint;
  update_columns: Array<Landing_Requests_Update_Column>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};

/** ordering options when selecting data from "landing_requests" */
export type Landing_Requests_Order_By = {
  active?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pad_serial?: Maybe<Order_By>;
  station?: Maybe<Stations_Order_By>;
  station_id?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "landing_requests" */
export type Landing_Requests_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "landing_requests" */
export enum Landing_Requests_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  PadSerial = 'pad_serial',
  /** column name */
  StationId = 'station_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "landing_requests" */
export type Landing_Requests_Set_Input = {
  active?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pad_serial?: Maybe<Scalars['String']>;
  station_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Landing_Request_Statuses_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Landing_Requests_Stddev_Fields = {
  __typename?: 'landing_requests_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "landing_requests" */
export type Landing_Requests_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Landing_Requests_Stddev_Pop_Fields = {
  __typename?: 'landing_requests_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "landing_requests" */
export type Landing_Requests_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Landing_Requests_Stddev_Samp_Fields = {
  __typename?: 'landing_requests_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "landing_requests" */
export type Landing_Requests_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Landing_Requests_Sum_Fields = {
  __typename?: 'landing_requests_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  station_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "landing_requests" */
export type Landing_Requests_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "landing_requests" */
export enum Landing_Requests_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  PadSerial = 'pad_serial',
  /** column name */
  StationId = 'station_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Landing_Requests_Var_Pop_Fields = {
  __typename?: 'landing_requests_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "landing_requests" */
export type Landing_Requests_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Landing_Requests_Var_Samp_Fields = {
  __typename?: 'landing_requests_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "landing_requests" */
export type Landing_Requests_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Landing_Requests_Variance_Fields = {
  __typename?: 'landing_requests_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  station_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "landing_requests" */
export type Landing_Requests_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  station_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses = {
  __typename?: 'last_vehicle_anomaly_statuses';
  /** anomaly_status_names derived from anomaly status, json string[] */
  anomaly_status_names: Scalars['jsonb'];
  created_at: Scalars['timestamptz'];
  flight_plan_id?: Maybe<Scalars['Int']>;
  /** timestamp from vehicle status */
  timestamp_secs: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
  /** Associated Vehicle Serial Number */
  vehicle_serial_number: Scalars['String'];
};


/** columns and relationships of "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_StatusesAnomaly_Status_NamesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Aggregate = {
  __typename?: 'last_vehicle_anomaly_statuses_aggregate';
  aggregate?: Maybe<Last_Vehicle_Anomaly_Statuses_Aggregate_Fields>;
  nodes: Array<Last_Vehicle_Anomaly_Statuses>;
};

/** aggregate fields of "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Aggregate_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_aggregate_fields';
  avg?: Maybe<Last_Vehicle_Anomaly_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Last_Vehicle_Anomaly_Statuses_Max_Fields>;
  min?: Maybe<Last_Vehicle_Anomaly_Statuses_Min_Fields>;
  stddev?: Maybe<Last_Vehicle_Anomaly_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Last_Vehicle_Anomaly_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Last_Vehicle_Anomaly_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Last_Vehicle_Anomaly_Statuses_Sum_Fields>;
  var_pop?: Maybe<Last_Vehicle_Anomaly_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Last_Vehicle_Anomaly_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Last_Vehicle_Anomaly_Statuses_Variance_Fields>;
};


/** aggregate fields of "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Last_Vehicle_Anomaly_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Last_Vehicle_Anomaly_Statuses_Max_Order_By>;
  min?: Maybe<Last_Vehicle_Anomaly_Statuses_Min_Order_By>;
  stddev?: Maybe<Last_Vehicle_Anomaly_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Last_Vehicle_Anomaly_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Last_Vehicle_Anomaly_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Last_Vehicle_Anomaly_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Last_Vehicle_Anomaly_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Last_Vehicle_Anomaly_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Last_Vehicle_Anomaly_Statuses_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Last_Vehicle_Anomaly_Statuses_Append_Input = {
  anomaly_status_names?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Last_Vehicle_Anomaly_Statuses_Insert_Input>;
  on_conflict?: Maybe<Last_Vehicle_Anomaly_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Last_Vehicle_Anomaly_Statuses_Avg_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "last_vehicle_anomaly_statuses". All fields are combined with a logical 'AND'. */
export type Last_Vehicle_Anomaly_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>>>;
  _not?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>>>;
  anomaly_status_names?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "last_vehicle_anomaly_statuses" */
export enum Last_Vehicle_Anomaly_Statuses_Constraint {
  /** unique or primary key constraint */
  LastVehicleAnomalyStatusesPkey = 'last_vehicle_anomaly_statuses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Last_Vehicle_Anomaly_Statuses_Delete_At_Path_Input = {
  anomaly_status_names?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Last_Vehicle_Anomaly_Statuses_Delete_Elem_Input = {
  anomaly_status_names?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Last_Vehicle_Anomaly_Statuses_Delete_Key_Input = {
  anomaly_status_names?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Insert_Input = {
  anomaly_status_names?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Last_Vehicle_Anomaly_Statuses_Max_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Last_Vehicle_Anomaly_Statuses_Min_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** response of any mutation on the table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Mutation_Response = {
  __typename?: 'last_vehicle_anomaly_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Last_Vehicle_Anomaly_Statuses>;
};

/** input type for inserting object relation for remote table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Obj_Rel_Insert_Input = {
  data: Last_Vehicle_Anomaly_Statuses_Insert_Input;
  on_conflict?: Maybe<Last_Vehicle_Anomaly_Statuses_On_Conflict>;
};

/** on conflict condition type for table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_On_Conflict = {
  constraint: Last_Vehicle_Anomaly_Statuses_Constraint;
  update_columns: Array<Last_Vehicle_Anomaly_Statuses_Update_Column>;
  where?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Order_By = {
  anomaly_status_names?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** primary key columns input for table: "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Pk_Columns_Input = {
  /** Associated Vehicle Serial Number */
  vehicle_serial_number: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Last_Vehicle_Anomaly_Statuses_Prepend_Input = {
  anomaly_status_names?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "last_vehicle_anomaly_statuses" */
export enum Last_Vehicle_Anomaly_Statuses_Select_Column {
  /** column name */
  AnomalyStatusNames = 'anomaly_status_names',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number'
}

/** input type for updating data in table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Set_Input = {
  anomaly_status_names?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Last_Vehicle_Anomaly_Statuses_Stddev_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Last_Vehicle_Anomaly_Statuses_Stddev_Pop_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Last_Vehicle_Anomaly_Statuses_Stddev_Samp_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Last_Vehicle_Anomaly_Statuses_Sum_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "last_vehicle_anomaly_statuses" */
export enum Last_Vehicle_Anomaly_Statuses_Update_Column {
  /** column name */
  AnomalyStatusNames = 'anomaly_status_names',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number'
}

/** aggregate var_pop on columns */
export type Last_Vehicle_Anomaly_Statuses_Var_Pop_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Last_Vehicle_Anomaly_Statuses_Var_Samp_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Last_Vehicle_Anomaly_Statuses_Variance_Fields = {
  __typename?: 'last_vehicle_anomaly_statuses_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "last_vehicle_anomaly_statuses" */
export type Last_Vehicle_Anomaly_Statuses_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "manifest_events" */
export type Manifest_Events = {
  __typename?: 'manifest_events';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object relationship */
  manifest?: Maybe<Manifests>;
  manifest_id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "manifest_events" */
export type Manifest_Events_Aggregate = {
  __typename?: 'manifest_events_aggregate';
  aggregate?: Maybe<Manifest_Events_Aggregate_Fields>;
  nodes: Array<Manifest_Events>;
};

/** aggregate fields of "manifest_events" */
export type Manifest_Events_Aggregate_Fields = {
  __typename?: 'manifest_events_aggregate_fields';
  avg?: Maybe<Manifest_Events_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifest_Events_Max_Fields>;
  min?: Maybe<Manifest_Events_Min_Fields>;
  stddev?: Maybe<Manifest_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Manifest_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manifest_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Manifest_Events_Sum_Fields>;
  var_pop?: Maybe<Manifest_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Manifest_Events_Var_Samp_Fields>;
  variance?: Maybe<Manifest_Events_Variance_Fields>;
};


/** aggregate fields of "manifest_events" */
export type Manifest_Events_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifest_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifest_events" */
export type Manifest_Events_Aggregate_Order_By = {
  avg?: Maybe<Manifest_Events_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Manifest_Events_Max_Order_By>;
  min?: Maybe<Manifest_Events_Min_Order_By>;
  stddev?: Maybe<Manifest_Events_Stddev_Order_By>;
  stddev_pop?: Maybe<Manifest_Events_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Manifest_Events_Stddev_Samp_Order_By>;
  sum?: Maybe<Manifest_Events_Sum_Order_By>;
  var_pop?: Maybe<Manifest_Events_Var_Pop_Order_By>;
  var_samp?: Maybe<Manifest_Events_Var_Samp_Order_By>;
  variance?: Maybe<Manifest_Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "manifest_events" */
export type Manifest_Events_Arr_Rel_Insert_Input = {
  data: Array<Manifest_Events_Insert_Input>;
  on_conflict?: Maybe<Manifest_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Manifest_Events_Avg_Fields = {
  __typename?: 'manifest_events_avg_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manifest_events" */
export type Manifest_Events_Avg_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "manifest_events". All fields are combined with a logical 'AND'. */
export type Manifest_Events_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifest_Events_Bool_Exp>>>;
  _not?: Maybe<Manifest_Events_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifest_Events_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  event?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifest?: Maybe<Manifests_Bool_Exp>;
  manifest_id?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "manifest_events" */
export enum Manifest_Events_Constraint {
  /** unique or primary key constraint */
  ManifestEventsMongoIdKey = 'manifest_events_mongo_id_key',
  /** unique or primary key constraint */
  ManifestEventsPkey = 'manifest_events_pkey'
}

/** input type for incrementing integer column in table "manifest_events" */
export type Manifest_Events_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "manifest_events" */
export type Manifest_Events_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest?: Maybe<Manifests_Obj_Rel_Insert_Input>;
  manifest_id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Manifest_Events_Max_Fields = {
  __typename?: 'manifest_events_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "manifest_events" */
export type Manifest_Events_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifest_Events_Min_Fields = {
  __typename?: 'manifest_events_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "manifest_events" */
export type Manifest_Events_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifest_events" */
export type Manifest_Events_Mutation_Response = {
  __typename?: 'manifest_events_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifest_Events>;
};

/** input type for inserting object relation for remote table "manifest_events" */
export type Manifest_Events_Obj_Rel_Insert_Input = {
  data: Manifest_Events_Insert_Input;
  on_conflict?: Maybe<Manifest_Events_On_Conflict>;
};

/** on conflict condition type for table "manifest_events" */
export type Manifest_Events_On_Conflict = {
  constraint: Manifest_Events_Constraint;
  update_columns: Array<Manifest_Events_Update_Column>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};

/** ordering options when selecting data from "manifest_events" */
export type Manifest_Events_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest?: Maybe<Manifests_Order_By>;
  manifest_id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "manifest_events" */
export type Manifest_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "manifest_events" */
export enum Manifest_Events_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "manifest_events" */
export type Manifest_Events_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Manifest_Events_Stddev_Fields = {
  __typename?: 'manifest_events_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manifest_events" */
export type Manifest_Events_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Manifest_Events_Stddev_Pop_Fields = {
  __typename?: 'manifest_events_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "manifest_events" */
export type Manifest_Events_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Manifest_Events_Stddev_Samp_Fields = {
  __typename?: 'manifest_events_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "manifest_events" */
export type Manifest_Events_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Manifest_Events_Sum_Fields = {
  __typename?: 'manifest_events_sum_fields';
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "manifest_events" */
export type Manifest_Events_Sum_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "manifest_events" */
export enum Manifest_Events_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Manifest_Events_Var_Pop_Fields = {
  __typename?: 'manifest_events_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "manifest_events" */
export type Manifest_Events_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Manifest_Events_Var_Samp_Fields = {
  __typename?: 'manifest_events_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "manifest_events" */
export type Manifest_Events_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Manifest_Events_Variance_Fields = {
  __typename?: 'manifest_events_variance_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manifest_events" */
export type Manifest_Events_Variance_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/**
 * Table containing the items entered into the system for delivery.
 *
 *
 * columns and relationships of "manifest_items"
 */
export type Manifest_Items = {
  __typename?: 'manifest_items';
  /** Time and date of manifest creation formatted as YYYY-MM-DD HH:MM:SS.MMS. */
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** External reference ID, for example a customer control number. */
  external_id?: Maybe<Scalars['String']>;
  /** UID of the manifest item. */
  id: Scalars['Int'];
  /** An object relationship */
  manifest: Manifests;
  manifest_id: Scalars['Int'];
  /** An object relationship */
  manifest_product: Manifest_Products;
  manifest_product_id: Scalars['Int'];
  quantity: Scalars['Int'];
  /** Time and date of manifest update formatted as YYYY-MM-DD HH:MM:SS.MMS. */
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "manifest_items" */
export type Manifest_Items_Aggregate = {
  __typename?: 'manifest_items_aggregate';
  aggregate?: Maybe<Manifest_Items_Aggregate_Fields>;
  nodes: Array<Manifest_Items>;
};

/** aggregate fields of "manifest_items" */
export type Manifest_Items_Aggregate_Fields = {
  __typename?: 'manifest_items_aggregate_fields';
  avg?: Maybe<Manifest_Items_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifest_Items_Max_Fields>;
  min?: Maybe<Manifest_Items_Min_Fields>;
  stddev?: Maybe<Manifest_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Manifest_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manifest_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Manifest_Items_Sum_Fields>;
  var_pop?: Maybe<Manifest_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Manifest_Items_Var_Samp_Fields>;
  variance?: Maybe<Manifest_Items_Variance_Fields>;
};


/** aggregate fields of "manifest_items" */
export type Manifest_Items_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifest_Items_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifest_items" */
export type Manifest_Items_Aggregate_Order_By = {
  avg?: Maybe<Manifest_Items_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Manifest_Items_Max_Order_By>;
  min?: Maybe<Manifest_Items_Min_Order_By>;
  stddev?: Maybe<Manifest_Items_Stddev_Order_By>;
  stddev_pop?: Maybe<Manifest_Items_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Manifest_Items_Stddev_Samp_Order_By>;
  sum?: Maybe<Manifest_Items_Sum_Order_By>;
  var_pop?: Maybe<Manifest_Items_Var_Pop_Order_By>;
  var_samp?: Maybe<Manifest_Items_Var_Samp_Order_By>;
  variance?: Maybe<Manifest_Items_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "manifest_items" */
export type Manifest_Items_Arr_Rel_Insert_Input = {
  data: Array<Manifest_Items_Insert_Input>;
  on_conflict?: Maybe<Manifest_Items_On_Conflict>;
};

/** aggregate avg on columns */
export type Manifest_Items_Avg_Fields = {
  __typename?: 'manifest_items_avg_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manifest_items" */
export type Manifest_Items_Avg_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "manifest_items". All fields are combined with a logical 'AND'. */
export type Manifest_Items_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifest_Items_Bool_Exp>>>;
  _not?: Maybe<Manifest_Items_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifest_Items_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  external_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifest?: Maybe<Manifests_Bool_Exp>;
  manifest_id?: Maybe<Int_Comparison_Exp>;
  manifest_product?: Maybe<Manifest_Products_Bool_Exp>;
  manifest_product_id?: Maybe<Int_Comparison_Exp>;
  quantity?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "manifest_items" */
export enum Manifest_Items_Constraint {
  /** unique or primary key constraint */
  ManifestItemsPkey = 'manifest_items_pkey'
}

/** input type for incrementing integer column in table "manifest_items" */
export type Manifest_Items_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  manifest_product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "manifest_items" */
export type Manifest_Items_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest?: Maybe<Manifests_Obj_Rel_Insert_Input>;
  manifest_id?: Maybe<Scalars['Int']>;
  manifest_product?: Maybe<Manifest_Products_Obj_Rel_Insert_Input>;
  manifest_product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Manifest_Items_Max_Fields = {
  __typename?: 'manifest_items_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  manifest_product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "manifest_items" */
export type Manifest_Items_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifest_Items_Min_Fields = {
  __typename?: 'manifest_items_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  manifest_product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "manifest_items" */
export type Manifest_Items_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifest_items" */
export type Manifest_Items_Mutation_Response = {
  __typename?: 'manifest_items_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifest_Items>;
};

/** input type for inserting object relation for remote table "manifest_items" */
export type Manifest_Items_Obj_Rel_Insert_Input = {
  data: Manifest_Items_Insert_Input;
  on_conflict?: Maybe<Manifest_Items_On_Conflict>;
};

/** on conflict condition type for table "manifest_items" */
export type Manifest_Items_On_Conflict = {
  constraint: Manifest_Items_Constraint;
  update_columns: Array<Manifest_Items_Update_Column>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};

/** ordering options when selecting data from "manifest_items" */
export type Manifest_Items_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  external_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest?: Maybe<Manifests_Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product?: Maybe<Manifest_Products_Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "manifest_items" */
export type Manifest_Items_Pk_Columns_Input = {
  /** UID of the manifest item. */
  id: Scalars['Int'];
};

/** select columns of table "manifest_items" */
export enum Manifest_Items_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  ManifestProductId = 'manifest_product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "manifest_items" */
export type Manifest_Items_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  external_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  manifest_product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Manifest_Items_Stddev_Fields = {
  __typename?: 'manifest_items_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manifest_items" */
export type Manifest_Items_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Manifest_Items_Stddev_Pop_Fields = {
  __typename?: 'manifest_items_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "manifest_items" */
export type Manifest_Items_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Manifest_Items_Stddev_Samp_Fields = {
  __typename?: 'manifest_items_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "manifest_items" */
export type Manifest_Items_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Manifest_Items_Sum_Fields = {
  __typename?: 'manifest_items_sum_fields';
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  manifest_product_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "manifest_items" */
export type Manifest_Items_Sum_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "manifest_items" */
export enum Manifest_Items_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  ManifestProductId = 'manifest_product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Manifest_Items_Var_Pop_Fields = {
  __typename?: 'manifest_items_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "manifest_items" */
export type Manifest_Items_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Manifest_Items_Var_Samp_Fields = {
  __typename?: 'manifest_items_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "manifest_items" */
export type Manifest_Items_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Manifest_Items_Variance_Fields = {
  __typename?: 'manifest_items_variance_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
  manifest_product_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manifest_items" */
export type Manifest_Items_Variance_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  manifest_product_id?: Maybe<Order_By>;
  quantity?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "manifest_products" */
export type Manifest_Products = {
  __typename?: 'manifest_products';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  estimated_weight: Scalars['float8'];
  id: Scalars['Int'];
  /** An array relationship */
  manifest_items: Array<Manifest_Items>;
  /** An aggregated array relationship */
  manifest_items_aggregate: Manifest_Items_Aggregate;
  name: Scalars['String'];
  /** An object relationship */
  network: Networks;
  network_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};


/** columns and relationships of "manifest_products" */
export type Manifest_ProductsManifest_ItemsArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/** columns and relationships of "manifest_products" */
export type Manifest_ProductsManifest_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};

/** aggregated selection of "manifest_products" */
export type Manifest_Products_Aggregate = {
  __typename?: 'manifest_products_aggregate';
  aggregate?: Maybe<Manifest_Products_Aggregate_Fields>;
  nodes: Array<Manifest_Products>;
};

/** aggregate fields of "manifest_products" */
export type Manifest_Products_Aggregate_Fields = {
  __typename?: 'manifest_products_aggregate_fields';
  avg?: Maybe<Manifest_Products_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifest_Products_Max_Fields>;
  min?: Maybe<Manifest_Products_Min_Fields>;
  stddev?: Maybe<Manifest_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Manifest_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manifest_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Manifest_Products_Sum_Fields>;
  var_pop?: Maybe<Manifest_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Manifest_Products_Var_Samp_Fields>;
  variance?: Maybe<Manifest_Products_Variance_Fields>;
};


/** aggregate fields of "manifest_products" */
export type Manifest_Products_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifest_Products_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifest_products" */
export type Manifest_Products_Aggregate_Order_By = {
  avg?: Maybe<Manifest_Products_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Manifest_Products_Max_Order_By>;
  min?: Maybe<Manifest_Products_Min_Order_By>;
  stddev?: Maybe<Manifest_Products_Stddev_Order_By>;
  stddev_pop?: Maybe<Manifest_Products_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Manifest_Products_Stddev_Samp_Order_By>;
  sum?: Maybe<Manifest_Products_Sum_Order_By>;
  var_pop?: Maybe<Manifest_Products_Var_Pop_Order_By>;
  var_samp?: Maybe<Manifest_Products_Var_Samp_Order_By>;
  variance?: Maybe<Manifest_Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "manifest_products" */
export type Manifest_Products_Arr_Rel_Insert_Input = {
  data: Array<Manifest_Products_Insert_Input>;
  on_conflict?: Maybe<Manifest_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Manifest_Products_Avg_Fields = {
  __typename?: 'manifest_products_avg_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manifest_products" */
export type Manifest_Products_Avg_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "manifest_products". All fields are combined with a logical 'AND'. */
export type Manifest_Products_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifest_Products_Bool_Exp>>>;
  _not?: Maybe<Manifest_Products_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifest_Products_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  estimated_weight?: Maybe<Float8_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifest_items?: Maybe<Manifest_Items_Bool_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "manifest_products" */
export enum Manifest_Products_Constraint {
  /** unique or primary key constraint */
  ManifestProductsNameNetworkId = 'manifest_products_name_network_id',
  /** unique or primary key constraint */
  ManifestProductsPkey = 'manifest_products_pkey'
}

/** input type for incrementing integer column in table "manifest_products" */
export type Manifest_Products_Inc_Input = {
  estimated_weight?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "manifest_products" */
export type Manifest_Products_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  estimated_weight?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  manifest_items?: Maybe<Manifest_Items_Arr_Rel_Insert_Input>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Manifest_Products_Max_Fields = {
  __typename?: 'manifest_products_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  estimated_weight?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "manifest_products" */
export type Manifest_Products_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifest_Products_Min_Fields = {
  __typename?: 'manifest_products_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  estimated_weight?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "manifest_products" */
export type Manifest_Products_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifest_products" */
export type Manifest_Products_Mutation_Response = {
  __typename?: 'manifest_products_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifest_Products>;
};

/** input type for inserting object relation for remote table "manifest_products" */
export type Manifest_Products_Obj_Rel_Insert_Input = {
  data: Manifest_Products_Insert_Input;
  on_conflict?: Maybe<Manifest_Products_On_Conflict>;
};

/** on conflict condition type for table "manifest_products" */
export type Manifest_Products_On_Conflict = {
  constraint: Manifest_Products_Constraint;
  update_columns: Array<Manifest_Products_Update_Column>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};

/** ordering options when selecting data from "manifest_products" */
export type Manifest_Products_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_items_aggregate?: Maybe<Manifest_Items_Aggregate_Order_By>;
  name?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "manifest_products" */
export type Manifest_Products_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "manifest_products" */
export enum Manifest_Products_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EstimatedWeight = 'estimated_weight',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "manifest_products" */
export type Manifest_Products_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  estimated_weight?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Manifest_Products_Stddev_Fields = {
  __typename?: 'manifest_products_stddev_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manifest_products" */
export type Manifest_Products_Stddev_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Manifest_Products_Stddev_Pop_Fields = {
  __typename?: 'manifest_products_stddev_pop_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "manifest_products" */
export type Manifest_Products_Stddev_Pop_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Manifest_Products_Stddev_Samp_Fields = {
  __typename?: 'manifest_products_stddev_samp_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "manifest_products" */
export type Manifest_Products_Stddev_Samp_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Manifest_Products_Sum_Fields = {
  __typename?: 'manifest_products_sum_fields';
  estimated_weight?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "manifest_products" */
export type Manifest_Products_Sum_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "manifest_products" */
export enum Manifest_Products_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EstimatedWeight = 'estimated_weight',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Manifest_Products_Var_Pop_Fields = {
  __typename?: 'manifest_products_var_pop_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "manifest_products" */
export type Manifest_Products_Var_Pop_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Manifest_Products_Var_Samp_Fields = {
  __typename?: 'manifest_products_var_samp_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "manifest_products" */
export type Manifest_Products_Var_Samp_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Manifest_Products_Variance_Fields = {
  __typename?: 'manifest_products_variance_fields';
  estimated_weight?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manifest_products" */
export type Manifest_Products_Variance_Order_By = {
  estimated_weight?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/**
 * Table containing manifest status change events.
 *
 *
 * columns and relationships of "manifest_status_audits"
 */
export type Manifest_Status_Audits = {
  __typename?: 'manifest_status_audits';
  /** Time and date of manifest status record creation formatted as YYYY-MM-DD HH:MM:SS.MMS. */
  created_at: Scalars['timestamptz'];
  id: Scalars['Int'];
  /** An object relationship */
  manifest: Manifests;
  manifest_id: Scalars['Int'];
  /** New manifest status. CREATED = Manifest has been created by a user. EN_ROUTE = Vehicle is in flight with payload. ARRIVED = Vehicle landed at the desination station. DELIVERED = Payload has been delivered to customer. CANCELED = Manifest has been canceled. */
  new_status?: Maybe<Scalars['String']>;
  /** Old manifest status. CREATED = Manifest has been created by a user. EN_ROUTE = Vehicle is in flight with payload. ARRIVED = Vehicle landed at the desination station. DELIVERED = Payload has been delivered to customer. CANCELED = Manifest has been canceled. */
  old_status?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "manifest_status_audits" */
export type Manifest_Status_Audits_Aggregate = {
  __typename?: 'manifest_status_audits_aggregate';
  aggregate?: Maybe<Manifest_Status_Audits_Aggregate_Fields>;
  nodes: Array<Manifest_Status_Audits>;
};

/** aggregate fields of "manifest_status_audits" */
export type Manifest_Status_Audits_Aggregate_Fields = {
  __typename?: 'manifest_status_audits_aggregate_fields';
  avg?: Maybe<Manifest_Status_Audits_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifest_Status_Audits_Max_Fields>;
  min?: Maybe<Manifest_Status_Audits_Min_Fields>;
  stddev?: Maybe<Manifest_Status_Audits_Stddev_Fields>;
  stddev_pop?: Maybe<Manifest_Status_Audits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manifest_Status_Audits_Stddev_Samp_Fields>;
  sum?: Maybe<Manifest_Status_Audits_Sum_Fields>;
  var_pop?: Maybe<Manifest_Status_Audits_Var_Pop_Fields>;
  var_samp?: Maybe<Manifest_Status_Audits_Var_Samp_Fields>;
  variance?: Maybe<Manifest_Status_Audits_Variance_Fields>;
};


/** aggregate fields of "manifest_status_audits" */
export type Manifest_Status_Audits_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifest_status_audits" */
export type Manifest_Status_Audits_Aggregate_Order_By = {
  avg?: Maybe<Manifest_Status_Audits_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Manifest_Status_Audits_Max_Order_By>;
  min?: Maybe<Manifest_Status_Audits_Min_Order_By>;
  stddev?: Maybe<Manifest_Status_Audits_Stddev_Order_By>;
  stddev_pop?: Maybe<Manifest_Status_Audits_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Manifest_Status_Audits_Stddev_Samp_Order_By>;
  sum?: Maybe<Manifest_Status_Audits_Sum_Order_By>;
  var_pop?: Maybe<Manifest_Status_Audits_Var_Pop_Order_By>;
  var_samp?: Maybe<Manifest_Status_Audits_Var_Samp_Order_By>;
  variance?: Maybe<Manifest_Status_Audits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "manifest_status_audits" */
export type Manifest_Status_Audits_Arr_Rel_Insert_Input = {
  data: Array<Manifest_Status_Audits_Insert_Input>;
  on_conflict?: Maybe<Manifest_Status_Audits_On_Conflict>;
};

/** aggregate avg on columns */
export type Manifest_Status_Audits_Avg_Fields = {
  __typename?: 'manifest_status_audits_avg_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Avg_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "manifest_status_audits". All fields are combined with a logical 'AND'. */
export type Manifest_Status_Audits_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifest_Status_Audits_Bool_Exp>>>;
  _not?: Maybe<Manifest_Status_Audits_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifest_Status_Audits_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifest?: Maybe<Manifests_Bool_Exp>;
  manifest_id?: Maybe<Int_Comparison_Exp>;
  new_status?: Maybe<String_Comparison_Exp>;
  old_status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "manifest_status_audits" */
export enum Manifest_Status_Audits_Constraint {
  /** unique or primary key constraint */
  ManifestStatusAuditsPkey = 'manifest_status_audits_pkey'
}

/** input type for incrementing integer column in table "manifest_status_audits" */
export type Manifest_Status_Audits_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "manifest_status_audits" */
export type Manifest_Status_Audits_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manifest?: Maybe<Manifests_Obj_Rel_Insert_Input>;
  manifest_id?: Maybe<Scalars['Int']>;
  new_status?: Maybe<Scalars['String']>;
  old_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Manifest_Status_Audits_Max_Fields = {
  __typename?: 'manifest_status_audits_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  new_status?: Maybe<Scalars['String']>;
  old_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  new_status?: Maybe<Order_By>;
  old_status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifest_Status_Audits_Min_Fields = {
  __typename?: 'manifest_status_audits_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  new_status?: Maybe<Scalars['String']>;
  old_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
  new_status?: Maybe<Order_By>;
  old_status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifest_status_audits" */
export type Manifest_Status_Audits_Mutation_Response = {
  __typename?: 'manifest_status_audits_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifest_Status_Audits>;
};

/** input type for inserting object relation for remote table "manifest_status_audits" */
export type Manifest_Status_Audits_Obj_Rel_Insert_Input = {
  data: Manifest_Status_Audits_Insert_Input;
  on_conflict?: Maybe<Manifest_Status_Audits_On_Conflict>;
};

/** on conflict condition type for table "manifest_status_audits" */
export type Manifest_Status_Audits_On_Conflict = {
  constraint: Manifest_Status_Audits_Constraint;
  update_columns: Array<Manifest_Status_Audits_Update_Column>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};

/** ordering options when selecting data from "manifest_status_audits" */
export type Manifest_Status_Audits_Order_By = {
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest?: Maybe<Manifests_Order_By>;
  manifest_id?: Maybe<Order_By>;
  new_status?: Maybe<Order_By>;
  old_status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "manifest_status_audits" */
export type Manifest_Status_Audits_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "manifest_status_audits" */
export enum Manifest_Status_Audits_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "manifest_status_audits" */
export type Manifest_Status_Audits_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  new_status?: Maybe<Scalars['String']>;
  old_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Manifest_Status_Audits_Stddev_Fields = {
  __typename?: 'manifest_status_audits_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Manifest_Status_Audits_Stddev_Pop_Fields = {
  __typename?: 'manifest_status_audits_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Manifest_Status_Audits_Stddev_Samp_Fields = {
  __typename?: 'manifest_status_audits_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Manifest_Status_Audits_Sum_Fields = {
  __typename?: 'manifest_status_audits_sum_fields';
  id?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Sum_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** update columns of table "manifest_status_audits" */
export enum Manifest_Status_Audits_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestId = 'manifest_id',
  /** column name */
  NewStatus = 'new_status',
  /** column name */
  OldStatus = 'old_status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Manifest_Status_Audits_Var_Pop_Fields = {
  __typename?: 'manifest_status_audits_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Manifest_Status_Audits_Var_Samp_Fields = {
  __typename?: 'manifest_status_audits_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Manifest_Status_Audits_Variance_Fields = {
  __typename?: 'manifest_status_audits_variance_fields';
  id?: Maybe<Scalars['Float']>;
  manifest_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manifest_status_audits" */
export type Manifest_Status_Audits_Variance_Order_By = {
  id?: Maybe<Order_By>;
  manifest_id?: Maybe<Order_By>;
};

/** columns and relationships of "manifest_types" */
export type Manifest_Types = {
  __typename?: 'manifest_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "manifest_types" */
export type Manifest_Types_Aggregate = {
  __typename?: 'manifest_types_aggregate';
  aggregate?: Maybe<Manifest_Types_Aggregate_Fields>;
  nodes: Array<Manifest_Types>;
};

/** aggregate fields of "manifest_types" */
export type Manifest_Types_Aggregate_Fields = {
  __typename?: 'manifest_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifest_Types_Max_Fields>;
  min?: Maybe<Manifest_Types_Min_Fields>;
};


/** aggregate fields of "manifest_types" */
export type Manifest_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifest_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifest_types" */
export type Manifest_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Manifest_Types_Max_Order_By>;
  min?: Maybe<Manifest_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "manifest_types" */
export type Manifest_Types_Arr_Rel_Insert_Input = {
  data: Array<Manifest_Types_Insert_Input>;
  on_conflict?: Maybe<Manifest_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "manifest_types". All fields are combined with a logical 'AND'. */
export type Manifest_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifest_Types_Bool_Exp>>>;
  _not?: Maybe<Manifest_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifest_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "manifest_types" */
export enum Manifest_Types_Constraint {
  /** unique or primary key constraint */
  ManifestTypesPkey = 'manifest_types_pkey'
}

export enum Manifest_Types_Enum {
  /** Manifest for customer alternate delivery */
  Alternate = 'ALTERNATE',
  /** Manifest for load balancing operations */
  Empty = 'EMPTY',
  /** Manifest for customer delivery */
  Flight = 'FLIGHT',
  /** Manifest for testing */
  Test = 'TEST'
}

/** expression to compare columns of type manifest_types_enum. All fields are combined with logical 'AND'. */
export type Manifest_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Manifest_Types_Enum>;
  _in?: Maybe<Array<Manifest_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Manifest_Types_Enum>;
  _nin?: Maybe<Array<Manifest_Types_Enum>>;
};

/** input type for inserting data into table "manifest_types" */
export type Manifest_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Manifest_Types_Max_Fields = {
  __typename?: 'manifest_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "manifest_types" */
export type Manifest_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifest_Types_Min_Fields = {
  __typename?: 'manifest_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "manifest_types" */
export type Manifest_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifest_types" */
export type Manifest_Types_Mutation_Response = {
  __typename?: 'manifest_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifest_Types>;
};

/** input type for inserting object relation for remote table "manifest_types" */
export type Manifest_Types_Obj_Rel_Insert_Input = {
  data: Manifest_Types_Insert_Input;
  on_conflict?: Maybe<Manifest_Types_On_Conflict>;
};

/** on conflict condition type for table "manifest_types" */
export type Manifest_Types_On_Conflict = {
  constraint: Manifest_Types_Constraint;
  update_columns: Array<Manifest_Types_Update_Column>;
  where?: Maybe<Manifest_Types_Bool_Exp>;
};

/** ordering options when selecting data from "manifest_types" */
export type Manifest_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "manifest_types" */
export type Manifest_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "manifest_types" */
export enum Manifest_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "manifest_types" */
export type Manifest_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "manifest_types" */
export enum Manifest_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type Manifests = {
  __typename?: 'manifests';
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived?: Maybe<Scalars['Boolean']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  badgeTokenByBadgeTokenSenderId?: Maybe<Badge_Tokens>;
  /** An object relationship */
  badge_token?: Maybe<Badge_Tokens>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  /** Time and date of manifest creation formatted as YYYY-MM-DD HH:MM:SS.MMS. */
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered?: Maybe<Scalars['Boolean']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  dest_station?: Maybe<Stations>;
  destination_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  destination_station?: Maybe<Stations>;
  /** An array relationship */
  flight_plans: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  manifest_events: Array<Manifest_Events>;
  /** An aggregated array relationship */
  manifest_events_aggregate: Manifest_Events_Aggregate;
  /** An array relationship */
  manifest_items: Array<Manifest_Items>;
  /** An aggregated array relationship */
  manifest_items_aggregate: Manifest_Items_Aggregate;
  /** An array relationship */
  manifest_status_updates: Array<Manifest_Status_Audits>;
  /** An aggregated array relationship */
  manifest_status_updates_aggregate: Manifest_Status_Audits_Aggregate;
  /** Manifest type. FLIGHT = Payload is being transported by Matternet vehicle. ALTERNATE = Payload transportation is via pedestrian, car, etc. EMPTY = Payload box is empty and this is a dead leg flight. */
  manifest_type: Manifest_Types_Enum;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  network?: Maybe<Networks>;
  /** UID of the network for which the manifest was created. */
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  origin_station?: Maybe<Stations>;
  /** Identifier of the physical payload box. */
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  rfid_enabled?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['Int']>;
  /** UUID of the manifest. */
  serial_number?: Maybe<Scalars['String']>;
  /** Current manifest status. CREATED = Manifest has been created by a user. EN_ROUTE = Vehicle is in flight with payload. ARRIVED = Vehicle landed at the desination station. DELIVERED = Payload has been delivered to customer. CANCELED = Manifest has been canceled. */
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  userBySenderId?: Maybe<Users>;
  version: Scalars['Int'];
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsManifest_EventsArgs = {
  distinct_on?: Maybe<Array<Manifest_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Events_Order_By>>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsManifest_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Events_Order_By>>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsManifest_ItemsArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsManifest_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsManifest_Status_UpdatesArgs = {
  distinct_on?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Status_Audits_Order_By>>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};


/**
 * Table containing all of the shipment records and their associated invoices.
 *
 *
 * columns and relationships of "manifests"
 */
export type ManifestsManifest_Status_Updates_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Status_Audits_Order_By>>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};

/** aggregated selection of "manifests" */
export type Manifests_Aggregate = {
  __typename?: 'manifests_aggregate';
  aggregate?: Maybe<Manifests_Aggregate_Fields>;
  nodes: Array<Manifests>;
};

/** aggregate fields of "manifests" */
export type Manifests_Aggregate_Fields = {
  __typename?: 'manifests_aggregate_fields';
  avg?: Maybe<Manifests_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifests_Max_Fields>;
  min?: Maybe<Manifests_Min_Fields>;
  stddev?: Maybe<Manifests_Stddev_Fields>;
  stddev_pop?: Maybe<Manifests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manifests_Stddev_Samp_Fields>;
  sum?: Maybe<Manifests_Sum_Fields>;
  var_pop?: Maybe<Manifests_Var_Pop_Fields>;
  var_samp?: Maybe<Manifests_Var_Samp_Fields>;
  variance?: Maybe<Manifests_Variance_Fields>;
};


/** aggregate fields of "manifests" */
export type Manifests_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifests_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifests" */
export type Manifests_Aggregate_Order_By = {
  avg?: Maybe<Manifests_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Manifests_Max_Order_By>;
  min?: Maybe<Manifests_Min_Order_By>;
  stddev?: Maybe<Manifests_Stddev_Order_By>;
  stddev_pop?: Maybe<Manifests_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Manifests_Stddev_Samp_Order_By>;
  sum?: Maybe<Manifests_Sum_Order_By>;
  var_pop?: Maybe<Manifests_Var_Pop_Order_By>;
  var_samp?: Maybe<Manifests_Var_Samp_Order_By>;
  variance?: Maybe<Manifests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "manifests" */
export type Manifests_Arr_Rel_Insert_Input = {
  data: Array<Manifests_Insert_Input>;
  on_conflict?: Maybe<Manifests_On_Conflict>;
};

/** columns and relationships of "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute = {
  __typename?: 'manifests_arrived_within_minute';
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived?: Maybe<Scalars['Boolean']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered?: Maybe<Scalars['Boolean']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_type?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  rfid_enabled?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Aggregate = {
  __typename?: 'manifests_arrived_within_minute_aggregate';
  aggregate?: Maybe<Manifests_Arrived_Within_Minute_Aggregate_Fields>;
  nodes: Array<Manifests_Arrived_Within_Minute>;
};

/** aggregate fields of "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Aggregate_Fields = {
  __typename?: 'manifests_arrived_within_minute_aggregate_fields';
  avg?: Maybe<Manifests_Arrived_Within_Minute_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Manifests_Arrived_Within_Minute_Max_Fields>;
  min?: Maybe<Manifests_Arrived_Within_Minute_Min_Fields>;
  stddev?: Maybe<Manifests_Arrived_Within_Minute_Stddev_Fields>;
  stddev_pop?: Maybe<Manifests_Arrived_Within_Minute_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Manifests_Arrived_Within_Minute_Stddev_Samp_Fields>;
  sum?: Maybe<Manifests_Arrived_Within_Minute_Sum_Fields>;
  var_pop?: Maybe<Manifests_Arrived_Within_Minute_Var_Pop_Fields>;
  var_samp?: Maybe<Manifests_Arrived_Within_Minute_Var_Samp_Fields>;
  variance?: Maybe<Manifests_Arrived_Within_Minute_Variance_Fields>;
};


/** aggregate fields of "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Manifests_Arrived_Within_Minute_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Aggregate_Order_By = {
  avg?: Maybe<Manifests_Arrived_Within_Minute_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Manifests_Arrived_Within_Minute_Max_Order_By>;
  min?: Maybe<Manifests_Arrived_Within_Minute_Min_Order_By>;
  stddev?: Maybe<Manifests_Arrived_Within_Minute_Stddev_Order_By>;
  stddev_pop?: Maybe<Manifests_Arrived_Within_Minute_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Manifests_Arrived_Within_Minute_Stddev_Samp_Order_By>;
  sum?: Maybe<Manifests_Arrived_Within_Minute_Sum_Order_By>;
  var_pop?: Maybe<Manifests_Arrived_Within_Minute_Var_Pop_Order_By>;
  var_samp?: Maybe<Manifests_Arrived_Within_Minute_Var_Samp_Order_By>;
  variance?: Maybe<Manifests_Arrived_Within_Minute_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Arr_Rel_Insert_Input = {
  data: Array<Manifests_Arrived_Within_Minute_Insert_Input>;
};

/** aggregate avg on columns */
export type Manifests_Arrived_Within_Minute_Avg_Fields = {
  __typename?: 'manifests_arrived_within_minute_avg_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Avg_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "manifests_arrived_within_minute". All fields are combined with a logical 'AND'. */
export type Manifests_Arrived_Within_Minute_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>>>;
  _not?: Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>>>;
  alternate_reason_code?: Maybe<String_Comparison_Exp>;
  arrived?: Maybe<Boolean_Comparison_Exp>;
  arrived_at?: Maybe<Timestamptz_Comparison_Exp>;
  badge_token_recipient_id?: Maybe<Int_Comparison_Exp>;
  badge_token_sender_id?: Maybe<Int_Comparison_Exp>;
  canceled?: Maybe<Boolean_Comparison_Exp>;
  canceled_reason_code?: Maybe<String_Comparison_Exp>;
  claimed_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  delivered?: Maybe<Boolean_Comparison_Exp>;
  delivered_at?: Maybe<Timestamptz_Comparison_Exp>;
  deposited_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  destination_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifest_type?: Maybe<String_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  origin_id?: Maybe<Int_Comparison_Exp>;
  payload_serial?: Maybe<String_Comparison_Exp>;
  priority?: Maybe<Int_Comparison_Exp>;
  recipient_id?: Maybe<Int_Comparison_Exp>;
  recipient_name?: Maybe<String_Comparison_Exp>;
  rfid_enabled?: Maybe<Boolean_Comparison_Exp>;
  sender_id?: Maybe<Int_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
  volume?: Maybe<Float8_Comparison_Exp>;
  weight?: Maybe<Float8_Comparison_Exp>;
};

/** input type for incrementing integer column in table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Inc_Input = {
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  sender_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Insert_Input = {
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived?: Maybe<Scalars['Boolean']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered?: Maybe<Scalars['Boolean']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_type?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  rfid_enabled?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Manifests_Arrived_Within_Minute_Max_Fields = {
  __typename?: 'manifests_arrived_within_minute_max_fields';
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_type?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Max_Order_By = {
  alternate_reason_code?: Maybe<Order_By>;
  arrived_at?: Maybe<Order_By>;
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  canceled_reason_code?: Maybe<Order_By>;
  claimed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  deposited_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_type?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  payload_serial?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  recipient_name?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifests_Arrived_Within_Minute_Min_Fields = {
  __typename?: 'manifests_arrived_within_minute_min_fields';
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_type?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Min_Order_By = {
  alternate_reason_code?: Maybe<Order_By>;
  arrived_at?: Maybe<Order_By>;
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  canceled_reason_code?: Maybe<Order_By>;
  claimed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  deposited_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_type?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  payload_serial?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  recipient_name?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Mutation_Response = {
  __typename?: 'manifests_arrived_within_minute_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifests_Arrived_Within_Minute>;
};

/** input type for inserting object relation for remote table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Obj_Rel_Insert_Input = {
  data: Manifests_Arrived_Within_Minute_Insert_Input;
};

/** ordering options when selecting data from "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Order_By = {
  alternate_reason_code?: Maybe<Order_By>;
  arrived?: Maybe<Order_By>;
  arrived_at?: Maybe<Order_By>;
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  canceled?: Maybe<Order_By>;
  canceled_reason_code?: Maybe<Order_By>;
  claimed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  delivered?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  deposited_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifest_type?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  payload_serial?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  recipient_name?: Maybe<Order_By>;
  rfid_enabled?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** select columns of table "manifests_arrived_within_minute" */
export enum Manifests_Arrived_Within_Minute_Select_Column {
  /** column name */
  AlternateReasonCode = 'alternate_reason_code',
  /** column name */
  Arrived = 'arrived',
  /** column name */
  ArrivedAt = 'arrived_at',
  /** column name */
  BadgeTokenRecipientId = 'badge_token_recipient_id',
  /** column name */
  BadgeTokenSenderId = 'badge_token_sender_id',
  /** column name */
  Canceled = 'canceled',
  /** column name */
  CanceledReasonCode = 'canceled_reason_code',
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Delivered = 'delivered',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  DepositedAt = 'deposited_at',
  /** column name */
  Description = 'description',
  /** column name */
  DestinationId = 'destination_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestType = 'manifest_type',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  PayloadSerial = 'payload_serial',
  /** column name */
  Priority = 'priority',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  RecipientName = 'recipient_name',
  /** column name */
  RfidEnabled = 'rfid_enabled',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  Volume = 'volume',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Set_Input = {
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived?: Maybe<Scalars['Boolean']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered?: Maybe<Scalars['Boolean']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_type?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  rfid_enabled?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Manifests_Arrived_Within_Minute_Stddev_Fields = {
  __typename?: 'manifests_arrived_within_minute_stddev_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Stddev_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Manifests_Arrived_Within_Minute_Stddev_Pop_Fields = {
  __typename?: 'manifests_arrived_within_minute_stddev_pop_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Stddev_Pop_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Manifests_Arrived_Within_Minute_Stddev_Samp_Fields = {
  __typename?: 'manifests_arrived_within_minute_stddev_samp_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Stddev_Samp_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Manifests_Arrived_Within_Minute_Sum_Fields = {
  __typename?: 'manifests_arrived_within_minute_sum_fields';
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  sender_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Sum_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Manifests_Arrived_Within_Minute_Var_Pop_Fields = {
  __typename?: 'manifests_arrived_within_minute_var_pop_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Var_Pop_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Manifests_Arrived_Within_Minute_Var_Samp_Fields = {
  __typename?: 'manifests_arrived_within_minute_var_samp_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Var_Samp_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Manifests_Arrived_Within_Minute_Variance_Fields = {
  __typename?: 'manifests_arrived_within_minute_variance_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manifests_arrived_within_minute" */
export type Manifests_Arrived_Within_Minute_Variance_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate avg on columns */
export type Manifests_Avg_Fields = {
  __typename?: 'manifests_avg_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "manifests" */
export type Manifests_Avg_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "manifests". All fields are combined with a logical 'AND'. */
export type Manifests_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Manifests_Bool_Exp>>>;
  _not?: Maybe<Manifests_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Manifests_Bool_Exp>>>;
  alternate_reason_code?: Maybe<String_Comparison_Exp>;
  arrived?: Maybe<Boolean_Comparison_Exp>;
  arrived_at?: Maybe<Timestamptz_Comparison_Exp>;
  badgeTokenByBadgeTokenSenderId?: Maybe<Badge_Tokens_Bool_Exp>;
  badge_token?: Maybe<Badge_Tokens_Bool_Exp>;
  badge_token_recipient_id?: Maybe<Int_Comparison_Exp>;
  badge_token_sender_id?: Maybe<Int_Comparison_Exp>;
  canceled?: Maybe<Boolean_Comparison_Exp>;
  canceled_reason_code?: Maybe<String_Comparison_Exp>;
  claimed_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  delivered?: Maybe<Boolean_Comparison_Exp>;
  delivered_at?: Maybe<Timestamptz_Comparison_Exp>;
  deposited_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  dest_station?: Maybe<Stations_Bool_Exp>;
  destination_id?: Maybe<Int_Comparison_Exp>;
  destination_station?: Maybe<Stations_Bool_Exp>;
  flight_plans?: Maybe<Flight_Plans_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifest_events?: Maybe<Manifest_Events_Bool_Exp>;
  manifest_items?: Maybe<Manifest_Items_Bool_Exp>;
  manifest_status_updates?: Maybe<Manifest_Status_Audits_Bool_Exp>;
  manifest_type?: Maybe<Manifest_Types_Enum_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  origin_id?: Maybe<Int_Comparison_Exp>;
  origin_station?: Maybe<Stations_Bool_Exp>;
  payload_serial?: Maybe<String_Comparison_Exp>;
  priority?: Maybe<Int_Comparison_Exp>;
  recipient_id?: Maybe<Int_Comparison_Exp>;
  recipient_name?: Maybe<String_Comparison_Exp>;
  rfid_enabled?: Maybe<Boolean_Comparison_Exp>;
  sender_id?: Maybe<Int_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  userBySenderId?: Maybe<Users_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
  volume?: Maybe<Float8_Comparison_Exp>;
  weight?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "manifests" */
export enum Manifests_Constraint {
  /** unique or primary key constraint */
  ManifestsMongoIdKey = 'manifests_mongo_id_key',
  /** unique or primary key constraint */
  ManifestsPkey = 'manifests_pkey'
}

/** input type for incrementing integer column in table "manifests" */
export type Manifests_Inc_Input = {
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  sender_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "manifests" */
export type Manifests_Insert_Input = {
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived?: Maybe<Scalars['Boolean']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badgeTokenByBadgeTokenSenderId?: Maybe<Badge_Tokens_Obj_Rel_Insert_Input>;
  badge_token?: Maybe<Badge_Tokens_Obj_Rel_Insert_Input>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered?: Maybe<Scalars['Boolean']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  dest_station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  destination_id?: Maybe<Scalars['Int']>;
  destination_station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  flight_plans?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  manifest_events?: Maybe<Manifest_Events_Arr_Rel_Insert_Input>;
  manifest_items?: Maybe<Manifest_Items_Arr_Rel_Insert_Input>;
  manifest_status_updates?: Maybe<Manifest_Status_Audits_Arr_Rel_Insert_Input>;
  manifest_type?: Maybe<Manifest_Types_Enum>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  origin_station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  rfid_enabled?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  userBySenderId?: Maybe<Users_Obj_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Manifests_Max_Fields = {
  __typename?: 'manifests_max_fields';
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "manifests" */
export type Manifests_Max_Order_By = {
  alternate_reason_code?: Maybe<Order_By>;
  arrived_at?: Maybe<Order_By>;
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  canceled_reason_code?: Maybe<Order_By>;
  claimed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  deposited_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  payload_serial?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  recipient_name?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Manifests_Min_Fields = {
  __typename?: 'manifests_min_fields';
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "manifests" */
export type Manifests_Min_Order_By = {
  alternate_reason_code?: Maybe<Order_By>;
  arrived_at?: Maybe<Order_By>;
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  canceled_reason_code?: Maybe<Order_By>;
  claimed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  deposited_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  payload_serial?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  recipient_name?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** response of any mutation on the table "manifests" */
export type Manifests_Mutation_Response = {
  __typename?: 'manifests_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Manifests>;
};

/** input type for inserting object relation for remote table "manifests" */
export type Manifests_Obj_Rel_Insert_Input = {
  data: Manifests_Insert_Input;
  on_conflict?: Maybe<Manifests_On_Conflict>;
};

/** on conflict condition type for table "manifests" */
export type Manifests_On_Conflict = {
  constraint: Manifests_Constraint;
  update_columns: Array<Manifests_Update_Column>;
  where?: Maybe<Manifests_Bool_Exp>;
};

/** ordering options when selecting data from "manifests" */
export type Manifests_Order_By = {
  alternate_reason_code?: Maybe<Order_By>;
  arrived?: Maybe<Order_By>;
  arrived_at?: Maybe<Order_By>;
  badgeTokenByBadgeTokenSenderId?: Maybe<Badge_Tokens_Order_By>;
  badge_token?: Maybe<Badge_Tokens_Order_By>;
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  canceled?: Maybe<Order_By>;
  canceled_reason_code?: Maybe<Order_By>;
  claimed_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  delivered?: Maybe<Order_By>;
  delivered_at?: Maybe<Order_By>;
  deposited_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  dest_station?: Maybe<Stations_Order_By>;
  destination_id?: Maybe<Order_By>;
  destination_station?: Maybe<Stations_Order_By>;
  flight_plans_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  manifest_events_aggregate?: Maybe<Manifest_Events_Aggregate_Order_By>;
  manifest_items_aggregate?: Maybe<Manifest_Items_Aggregate_Order_By>;
  manifest_status_updates_aggregate?: Maybe<Manifest_Status_Audits_Aggregate_Order_By>;
  manifest_type?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  origin_station?: Maybe<Stations_Order_By>;
  payload_serial?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  recipient_name?: Maybe<Order_By>;
  rfid_enabled?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  userBySenderId?: Maybe<Users_Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** primary key columns input for table: "manifests" */
export type Manifests_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "manifests" */
export enum Manifests_Select_Column {
  /** column name */
  AlternateReasonCode = 'alternate_reason_code',
  /** column name */
  Arrived = 'arrived',
  /** column name */
  ArrivedAt = 'arrived_at',
  /** column name */
  BadgeTokenRecipientId = 'badge_token_recipient_id',
  /** column name */
  BadgeTokenSenderId = 'badge_token_sender_id',
  /** column name */
  Canceled = 'canceled',
  /** column name */
  CanceledReasonCode = 'canceled_reason_code',
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Delivered = 'delivered',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  DepositedAt = 'deposited_at',
  /** column name */
  Description = 'description',
  /** column name */
  DestinationId = 'destination_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestType = 'manifest_type',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  PayloadSerial = 'payload_serial',
  /** column name */
  Priority = 'priority',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  RecipientName = 'recipient_name',
  /** column name */
  RfidEnabled = 'rfid_enabled',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  Volume = 'volume',
  /** column name */
  Weight = 'weight'
}

/** input type for updating data in table "manifests" */
export type Manifests_Set_Input = {
  alternate_reason_code?: Maybe<Scalars['String']>;
  arrived?: Maybe<Scalars['Boolean']>;
  arrived_at?: Maybe<Scalars['timestamptz']>;
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  canceled?: Maybe<Scalars['Boolean']>;
  canceled_reason_code?: Maybe<Scalars['String']>;
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  delivered?: Maybe<Scalars['Boolean']>;
  delivered_at?: Maybe<Scalars['timestamptz']>;
  deposited_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  manifest_type?: Maybe<Manifest_Types_Enum>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  payload_serial?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  recipient_name?: Maybe<Scalars['String']>;
  rfid_enabled?: Maybe<Scalars['Boolean']>;
  sender_id?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Manifests_Stddev_Fields = {
  __typename?: 'manifests_stddev_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "manifests" */
export type Manifests_Stddev_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Manifests_Stddev_Pop_Fields = {
  __typename?: 'manifests_stddev_pop_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "manifests" */
export type Manifests_Stddev_Pop_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Manifests_Stddev_Samp_Fields = {
  __typename?: 'manifests_stddev_samp_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "manifests" */
export type Manifests_Stddev_Samp_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Manifests_Sum_Fields = {
  __typename?: 'manifests_sum_fields';
  badge_token_recipient_id?: Maybe<Scalars['Int']>;
  badge_token_sender_id?: Maybe<Scalars['Int']>;
  destination_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  origin_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  recipient_id?: Maybe<Scalars['Int']>;
  sender_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  volume?: Maybe<Scalars['float8']>;
  weight?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "manifests" */
export type Manifests_Sum_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** update columns of table "manifests" */
export enum Manifests_Update_Column {
  /** column name */
  AlternateReasonCode = 'alternate_reason_code',
  /** column name */
  Arrived = 'arrived',
  /** column name */
  ArrivedAt = 'arrived_at',
  /** column name */
  BadgeTokenRecipientId = 'badge_token_recipient_id',
  /** column name */
  BadgeTokenSenderId = 'badge_token_sender_id',
  /** column name */
  Canceled = 'canceled',
  /** column name */
  CanceledReasonCode = 'canceled_reason_code',
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Delivered = 'delivered',
  /** column name */
  DeliveredAt = 'delivered_at',
  /** column name */
  DepositedAt = 'deposited_at',
  /** column name */
  Description = 'description',
  /** column name */
  DestinationId = 'destination_id',
  /** column name */
  Id = 'id',
  /** column name */
  ManifestType = 'manifest_type',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  PayloadSerial = 'payload_serial',
  /** column name */
  Priority = 'priority',
  /** column name */
  RecipientId = 'recipient_id',
  /** column name */
  RecipientName = 'recipient_name',
  /** column name */
  RfidEnabled = 'rfid_enabled',
  /** column name */
  SenderId = 'sender_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  Volume = 'volume',
  /** column name */
  Weight = 'weight'
}

/** aggregate var_pop on columns */
export type Manifests_Var_Pop_Fields = {
  __typename?: 'manifests_var_pop_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "manifests" */
export type Manifests_Var_Pop_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Manifests_Var_Samp_Fields = {
  __typename?: 'manifests_var_samp_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "manifests" */
export type Manifests_Var_Samp_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Manifests_Variance_Fields = {
  __typename?: 'manifests_variance_fields';
  badge_token_recipient_id?: Maybe<Scalars['Float']>;
  badge_token_sender_id?: Maybe<Scalars['Float']>;
  destination_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  origin_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  recipient_id?: Maybe<Scalars['Float']>;
  sender_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "manifests" */
export type Manifests_Variance_Order_By = {
  badge_token_recipient_id?: Maybe<Order_By>;
  badge_token_sender_id?: Maybe<Order_By>;
  destination_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  origin_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  recipient_id?: Maybe<Order_By>;
  sender_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  volume?: Maybe<Order_By>;
  weight?: Maybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** perform the action: "acknowledgePriorityEvent" */
  acknowledgePriorityEvent?: Maybe<PriorityEventOutput>;
  /** perform the action: "addUsersToNetwork" */
  addUsersToNetwork?: Maybe<AddUsersToNetworkOutput>;
  /** perform the action: "assignGroundAssetsToNetwork" */
  assignGroundAssetsToNetwork?: Maybe<AssignGroundAssetsToNetworkOutput>;
  /** perform the action: "assignPilotsToVehicle" */
  assignPilotsToVehicle?: Maybe<VehiclePilotAssignmentsOutput>;
  /** perform the action: "assignPrimaryAndBackupPilotsToVehicle" */
  assignPrimaryAndBackupPilotsToVehicle?: Maybe<AssignPrimaryAndBackupPilotsToVehicleOutput>;
  /** perform the action: "assignVehiclesToNetwork" */
  assignVehiclesToNetwork?: Maybe<AssignVehiclesToNetworkOutput>;
  /** perform the action: "claimManifest" */
  claimManifest?: Maybe<ClaimManifestOutput>;
  /** perform the action: "createManifest" */
  createManifest?: Maybe<CreateManifestOutput>;
  /** perform the action: "createNetwork" */
  createNetwork?: Maybe<CreateNetworkOutput>;
  /** perform the action: "createUser" */
  createUser?: Maybe<CreateUserOutput>;
  /** perform the action: "deactivateUser" */
  deactivateUser?: Maybe<DeactivateUserOutput>;
  /** perform the action: "deleteManifest" */
  deleteManifest?: Maybe<DeleteManifestOutput>;
  /** delete data from the table: "air_traffic_deconfliction_algorithm_types" */
  delete_air_traffic_deconfliction_algorithm_types?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Mutation_Response>;
  /** delete single row from the table: "air_traffic_deconfliction_algorithm_types" */
  delete_air_traffic_deconfliction_algorithm_types_by_pk?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** delete data from the table: "air_traffic_monitor_tasks" */
  delete_air_traffic_monitor_tasks?: Maybe<Air_Traffic_Monitor_Tasks_Mutation_Response>;
  /** delete single row from the table: "air_traffic_monitor_tasks" */
  delete_air_traffic_monitor_tasks_by_pk?: Maybe<Air_Traffic_Monitor_Tasks>;
  /** delete data from the table: "air_traffic_tracks" */
  delete_air_traffic_tracks?: Maybe<Air_Traffic_Tracks_Mutation_Response>;
  /** delete single row from the table: "air_traffic_tracks" */
  delete_air_traffic_tracks_by_pk?: Maybe<Air_Traffic_Tracks>;
  /** delete data from the table: "aircraft_type_designators" */
  delete_aircraft_type_designators?: Maybe<Aircraft_Type_Designators_Mutation_Response>;
  /** delete single row from the table: "aircraft_type_designators" */
  delete_aircraft_type_designators_by_pk?: Maybe<Aircraft_Type_Designators>;
  /** delete data from the table: "airspaces" */
  delete_airspaces?: Maybe<Airspaces_Mutation_Response>;
  /** delete single row from the table: "airspaces" */
  delete_airspaces_by_pk?: Maybe<Airspaces>;
  /** delete data from the table: "available_aircraft_command_sets" */
  delete_available_aircraft_command_sets?: Maybe<Available_Aircraft_Command_Sets_Mutation_Response>;
  /** delete single row from the table: "available_aircraft_command_sets" */
  delete_available_aircraft_command_sets_by_pk?: Maybe<Available_Aircraft_Command_Sets>;
  /** delete data from the table: "available_aircraft_command_state_keys" */
  delete_available_aircraft_command_state_keys?: Maybe<Available_Aircraft_Command_State_Keys_Mutation_Response>;
  /** delete single row from the table: "available_aircraft_command_state_keys" */
  delete_available_aircraft_command_state_keys_by_pk?: Maybe<Available_Aircraft_Command_State_Keys>;
  /** delete data from the table: "badge_tokens" */
  delete_badge_tokens?: Maybe<Badge_Tokens_Mutation_Response>;
  /** delete single row from the table: "badge_tokens" */
  delete_badge_tokens_by_pk?: Maybe<Badge_Tokens>;
  /** delete data from the table: "batteries" */
  delete_batteries?: Maybe<Batteries_Mutation_Response>;
  /** delete single row from the table: "batteries" */
  delete_batteries_by_pk?: Maybe<Batteries>;
  /** delete data from the table: "contingency_landing_spots" */
  delete_contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Mutation_Response>;
  /** delete single row from the table: "contingency_landing_spots" */
  delete_contingency_landing_spots_by_pk?: Maybe<Contingency_Landing_Spots>;
  /** delete data from the table: "current_air_traffic_proximity_recordings" */
  delete_current_air_traffic_proximity_recordings?: Maybe<Current_Air_Traffic_Proximity_Recordings_Mutation_Response>;
  /** delete data from the table: "current_air_traffic_tracks" */
  delete_current_air_traffic_tracks?: Maybe<Current_Air_Traffic_Tracks_Mutation_Response>;
  /** delete data from the table: "daa_observations" */
  delete_daa_observations?: Maybe<Daa_Observations_Mutation_Response>;
  /** delete single row from the table: "daa_observations" */
  delete_daa_observations_by_pk?: Maybe<Daa_Observations>;
  /** delete data from the table: "daa_statuses" */
  delete_daa_statuses?: Maybe<Daa_Statuses_Mutation_Response>;
  /** delete single row from the table: "daa_statuses" */
  delete_daa_statuses_by_pk?: Maybe<Daa_Statuses>;
  /** delete data from the table: "env_feature_flags" */
  delete_env_feature_flags?: Maybe<Env_Feature_Flags_Mutation_Response>;
  /** delete single row from the table: "env_feature_flags" */
  delete_env_feature_flags_by_pk?: Maybe<Env_Feature_Flags>;
  /** delete data from the table: "file_asset_types" */
  delete_file_asset_types?: Maybe<File_Asset_Types_Mutation_Response>;
  /** delete single row from the table: "file_asset_types" */
  delete_file_asset_types_by_pk?: Maybe<File_Asset_Types>;
  /** delete data from the table: "file_assets" */
  delete_file_assets?: Maybe<File_Assets_Mutation_Response>;
  /** delete single row from the table: "file_assets" */
  delete_file_assets_by_pk?: Maybe<File_Assets>;
  /** delete data from the table: "flight_commands" */
  delete_flight_commands?: Maybe<Flight_Commands_Mutation_Response>;
  /** delete single row from the table: "flight_commands" */
  delete_flight_commands_by_pk?: Maybe<Flight_Commands>;
  /** delete data from the table: "flight_derivation_reports" */
  delete_flight_derivation_reports?: Maybe<Flight_Derivation_Reports_Mutation_Response>;
  /** delete single row from the table: "flight_derivation_reports" */
  delete_flight_derivation_reports_by_pk?: Maybe<Flight_Derivation_Reports>;
  /** delete data from the table: "flight_plan_pilot_assignments" */
  delete_flight_plan_pilot_assignments?: Maybe<Flight_Plan_Pilot_Assignments_Mutation_Response>;
  /** delete single row from the table: "flight_plan_pilot_assignments" */
  delete_flight_plan_pilot_assignments_by_pk?: Maybe<Flight_Plan_Pilot_Assignments>;
  /** delete data from the table: "flight_plan_statuses" */
  delete_flight_plan_statuses?: Maybe<Flight_Plan_Statuses_Mutation_Response>;
  /** delete single row from the table: "flight_plan_statuses" */
  delete_flight_plan_statuses_by_pk?: Maybe<Flight_Plan_Statuses>;
  /** delete data from the table: "flight_plan_utm_providers" */
  delete_flight_plan_utm_providers?: Maybe<Flight_Plan_Utm_Providers_Mutation_Response>;
  /** delete single row from the table: "flight_plan_utm_providers" */
  delete_flight_plan_utm_providers_by_pk?: Maybe<Flight_Plan_Utm_Providers>;
  /** delete data from the table: "flight_plans" */
  delete_flight_plans?: Maybe<Flight_Plans_Mutation_Response>;
  /** delete single row from the table: "flight_plans" */
  delete_flight_plans_by_pk?: Maybe<Flight_Plans>;
  /** delete data from the table: "flight_routes" */
  delete_flight_routes?: Maybe<Flight_Routes_Mutation_Response>;
  /** delete single row from the table: "flight_routes" */
  delete_flight_routes_by_pk?: Maybe<Flight_Routes>;
  /** delete data from the table: "flight_weather_data" */
  delete_flight_weather_data?: Maybe<Flight_Weather_Data_Mutation_Response>;
  /** delete single row from the table: "flight_weather_data" */
  delete_flight_weather_data_by_pk?: Maybe<Flight_Weather_Data>;
  /** delete data from the table: "ground_asset_commands" */
  delete_ground_asset_commands?: Maybe<Ground_Asset_Commands_Mutation_Response>;
  /** delete single row from the table: "ground_asset_commands" */
  delete_ground_asset_commands_by_pk?: Maybe<Ground_Asset_Commands>;
  /** delete data from the table: "ground_asset_model_parameter_types" */
  delete_ground_asset_model_parameter_types?: Maybe<Ground_Asset_Model_Parameter_Types_Mutation_Response>;
  /** delete single row from the table: "ground_asset_model_parameter_types" */
  delete_ground_asset_model_parameter_types_by_pk?: Maybe<Ground_Asset_Model_Parameter_Types>;
  /** delete data from the table: "ground_asset_model_parameters" */
  delete_ground_asset_model_parameters?: Maybe<Ground_Asset_Model_Parameters_Mutation_Response>;
  /** delete single row from the table: "ground_asset_model_parameters" */
  delete_ground_asset_model_parameters_by_pk?: Maybe<Ground_Asset_Model_Parameters>;
  /** delete data from the table: "ground_asset_model_types" */
  delete_ground_asset_model_types?: Maybe<Ground_Asset_Model_Types_Mutation_Response>;
  /** delete single row from the table: "ground_asset_model_types" */
  delete_ground_asset_model_types_by_pk?: Maybe<Ground_Asset_Model_Types>;
  /** delete data from the table: "ground_asset_models" */
  delete_ground_asset_models?: Maybe<Ground_Asset_Models_Mutation_Response>;
  /** delete single row from the table: "ground_asset_models" */
  delete_ground_asset_models_by_pk?: Maybe<Ground_Asset_Models>;
  /** delete data from the table: "ground_asset_networks" */
  delete_ground_asset_networks?: Maybe<Ground_Asset_Networks_Mutation_Response>;
  /** delete single row from the table: "ground_asset_networks" */
  delete_ground_asset_networks_by_pk?: Maybe<Ground_Asset_Networks>;
  /** delete data from the table: "ground_asset_status_values" */
  delete_ground_asset_status_values?: Maybe<Ground_Asset_Status_Values_Mutation_Response>;
  /** delete single row from the table: "ground_asset_status_values" */
  delete_ground_asset_status_values_by_pk?: Maybe<Ground_Asset_Status_Values>;
  /** delete data from the table: "ground_assets" */
  delete_ground_assets?: Maybe<Ground_Assets_Mutation_Response>;
  /** delete single row from the table: "ground_assets" */
  delete_ground_assets_by_pk?: Maybe<Ground_Assets>;
  /** delete data from the table: "ground_control_workflow_state_processing_statuses" */
  delete_ground_control_workflow_state_processing_statuses?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Mutation_Response>;
  /** delete single row from the table: "ground_control_workflow_state_processing_statuses" */
  delete_ground_control_workflow_state_processing_statuses_by_pk?: Maybe<Ground_Control_Workflow_State_Processing_Statuses>;
  /** delete data from the table: "historical_serialized_ground_asset_statuses" */
  delete_historical_serialized_ground_asset_statuses?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Mutation_Response>;
  /** delete single row from the table: "historical_serialized_ground_asset_statuses" */
  delete_historical_serialized_ground_asset_statuses_by_pk?: Maybe<Historical_Serialized_Ground_Asset_Statuses>;
  /** delete data from the table: "historical_serialized_vehicle_statuses" */
  delete_historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Mutation_Response>;
  /** delete single row from the table: "historical_serialized_vehicle_statuses" */
  delete_historical_serialized_vehicle_statuses_by_pk?: Maybe<Historical_Serialized_Vehicle_Statuses>;
  /** delete data from the table: "historical_vehicle_positions" */
  delete_historical_vehicle_positions?: Maybe<Historical_Vehicle_Positions_Mutation_Response>;
  /** delete single row from the table: "historical_vehicle_positions" */
  delete_historical_vehicle_positions_by_pk?: Maybe<Historical_Vehicle_Positions>;
  /** delete data from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  delete_kafka_air_traffic_vehicle_flight_proximity_recordings?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Mutation_Response>;
  /** delete single row from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  delete_kafka_air_traffic_vehicle_flight_proximity_recordings_by_pk?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** delete data from the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  delete_kafka_cached_air_traffic_flight_proximity_recordings?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Mutation_Response>;
  /** delete single row from the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  delete_kafka_cached_air_traffic_flight_proximity_recordings_by_pk?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** delete data from the table: "kafka_mqtt_vehicle_status_messages" */
  delete_kafka_mqtt_vehicle_status_messages?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Mutation_Response>;
  /** delete single row from the table: "kafka_mqtt_vehicle_status_messages" */
  delete_kafka_mqtt_vehicle_status_messages_by_pk?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** delete data from the table: "kafka_serialized_ground_asset_statuses" */
  delete_kafka_serialized_ground_asset_statuses?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Mutation_Response>;
  /** delete single row from the table: "kafka_serialized_ground_asset_statuses" */
  delete_kafka_serialized_ground_asset_statuses_by_pk?: Maybe<Kafka_Serialized_Ground_Asset_Statuses>;
  /** delete single row from the table: "kafka_serialized_vehicle_statuses" */
  delete_kafka_serialized_vehicle_statuses_by_pk?: Maybe<Kafka_Serialized_Vehicle_Statuses>;
  /** delete data from the table: "landing_request_statuses" */
  delete_landing_request_statuses?: Maybe<Landing_Request_Statuses_Mutation_Response>;
  /** delete single row from the table: "landing_request_statuses" */
  delete_landing_request_statuses_by_pk?: Maybe<Landing_Request_Statuses>;
  /** delete data from the table: "landing_requests" */
  delete_landing_requests?: Maybe<Landing_Requests_Mutation_Response>;
  /** delete single row from the table: "landing_requests" */
  delete_landing_requests_by_pk?: Maybe<Landing_Requests>;
  /** delete data from the table: "last_vehicle_anomaly_statuses" */
  delete_last_vehicle_anomaly_statuses?: Maybe<Last_Vehicle_Anomaly_Statuses_Mutation_Response>;
  /** delete single row from the table: "last_vehicle_anomaly_statuses" */
  delete_last_vehicle_anomaly_statuses_by_pk?: Maybe<Last_Vehicle_Anomaly_Statuses>;
  /** delete data from the table: "manifest_events" */
  delete_manifest_events?: Maybe<Manifest_Events_Mutation_Response>;
  /** delete single row from the table: "manifest_events" */
  delete_manifest_events_by_pk?: Maybe<Manifest_Events>;
  /** delete data from the table: "manifest_items" */
  delete_manifest_items?: Maybe<Manifest_Items_Mutation_Response>;
  /** delete single row from the table: "manifest_items" */
  delete_manifest_items_by_pk?: Maybe<Manifest_Items>;
  /** delete data from the table: "manifest_products" */
  delete_manifest_products?: Maybe<Manifest_Products_Mutation_Response>;
  /** delete single row from the table: "manifest_products" */
  delete_manifest_products_by_pk?: Maybe<Manifest_Products>;
  /** delete data from the table: "manifest_status_audits" */
  delete_manifest_status_audits?: Maybe<Manifest_Status_Audits_Mutation_Response>;
  /** delete single row from the table: "manifest_status_audits" */
  delete_manifest_status_audits_by_pk?: Maybe<Manifest_Status_Audits>;
  /** delete data from the table: "manifest_types" */
  delete_manifest_types?: Maybe<Manifest_Types_Mutation_Response>;
  /** delete single row from the table: "manifest_types" */
  delete_manifest_types_by_pk?: Maybe<Manifest_Types>;
  /** delete data from the table: "manifests" */
  delete_manifests?: Maybe<Manifests_Mutation_Response>;
  /** delete data from the table: "manifests_arrived_within_minute" */
  delete_manifests_arrived_within_minute?: Maybe<Manifests_Arrived_Within_Minute_Mutation_Response>;
  /** delete single row from the table: "manifests" */
  delete_manifests_by_pk?: Maybe<Manifests>;
  /** delete data from the table: "network_utm_providers" */
  delete_network_utm_providers?: Maybe<Network_Utm_Providers_Mutation_Response>;
  /** delete single row from the table: "network_utm_providers" */
  delete_network_utm_providers_by_pk?: Maybe<Network_Utm_Providers>;
  /** delete data from the table: "networks" */
  delete_networks?: Maybe<Networks_Mutation_Response>;
  /** delete single row from the table: "networks" */
  delete_networks_by_pk?: Maybe<Networks>;
  /** delete data from the table: "organizations" */
  delete_organizations?: Maybe<Organizations_Mutation_Response>;
  /** delete single row from the table: "organizations" */
  delete_organizations_by_pk?: Maybe<Organizations>;
  /** delete data from the table: "paths" */
  delete_paths?: Maybe<Paths_Mutation_Response>;
  /** delete single row from the table: "paths" */
  delete_paths_by_pk?: Maybe<Paths>;
  /** delete data from the table: "pickup_requests" */
  delete_pickup_requests?: Maybe<Pickup_Requests_Mutation_Response>;
  /** delete single row from the table: "pickup_requests" */
  delete_pickup_requests_by_pk?: Maybe<Pickup_Requests>;
  /** delete data from the table: "positive_exchange_of_flight_control_requests" */
  delete_positive_exchange_of_flight_control_requests?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Mutation_Response>;
  /** delete single row from the table: "positive_exchange_of_flight_control_requests" */
  delete_positive_exchange_of_flight_control_requests_by_pk?: Maybe<Positive_Exchange_Of_Flight_Control_Requests>;
  /** delete data from the table: "predicted_conflicts" */
  delete_predicted_conflicts?: Maybe<Predicted_Conflicts_Mutation_Response>;
  /** delete single row from the table: "predicted_conflicts" */
  delete_predicted_conflicts_by_pk?: Maybe<Predicted_Conflicts>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** delete single row from the table: "spatial_ref_sys" */
  delete_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** delete data from the table: "squawk_severities" */
  delete_squawk_severities?: Maybe<Squawk_Severities_Mutation_Response>;
  /** delete single row from the table: "squawk_severities" */
  delete_squawk_severities_by_pk?: Maybe<Squawk_Severities>;
  /** delete data from the table: "squawk_squawkable_types" */
  delete_squawk_squawkable_types?: Maybe<Squawk_Squawkable_Types_Mutation_Response>;
  /** delete single row from the table: "squawk_squawkable_types" */
  delete_squawk_squawkable_types_by_pk?: Maybe<Squawk_Squawkable_Types>;
  /** delete data from the table: "squawk_statuses" */
  delete_squawk_statuses?: Maybe<Squawk_Statuses_Mutation_Response>;
  /** delete single row from the table: "squawk_statuses" */
  delete_squawk_statuses_by_pk?: Maybe<Squawk_Statuses>;
  /** delete data from the table: "squawks" */
  delete_squawks?: Maybe<Squawks_Mutation_Response>;
  /** delete single row from the table: "squawks" */
  delete_squawks_by_pk?: Maybe<Squawks>;
  /** delete data from the table: "stations" */
  delete_stations?: Maybe<Stations_Mutation_Response>;
  /** delete single row from the table: "stations" */
  delete_stations_by_pk?: Maybe<Stations>;
  /** delete data from the table: "tenants" */
  delete_tenants?: Maybe<Tenants_Mutation_Response>;
  /** delete single row from the table: "tenants" */
  delete_tenants_by_pk?: Maybe<Tenants>;
  /** delete data from the table: "type_cert_flight_analysis_data" */
  delete_type_cert_flight_analysis_data?: Maybe<Type_Cert_Flight_Analysis_Data_Mutation_Response>;
  /** delete single row from the table: "type_cert_flight_analysis_data" */
  delete_type_cert_flight_analysis_data_by_pk?: Maybe<Type_Cert_Flight_Analysis_Data>;
  /** delete data from the table: "type_cert_manual_data" */
  delete_type_cert_manual_data?: Maybe<Type_Cert_Manual_Data_Mutation_Response>;
  /** delete single row from the table: "type_cert_manual_data" */
  delete_type_cert_manual_data_by_pk?: Maybe<Type_Cert_Manual_Data>;
  /** delete data from the table: "user_app_states" */
  delete_user_app_states?: Maybe<User_App_States_Mutation_Response>;
  /** delete data from the table: "user_networks" */
  delete_user_networks?: Maybe<User_Networks_Mutation_Response>;
  /** delete single row from the table: "user_networks" */
  delete_user_networks_by_pk?: Maybe<User_Networks>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<User_Roles>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "vehicle_airworthiness_categories" */
  delete_vehicle_airworthiness_categories?: Maybe<Vehicle_Airworthiness_Categories_Mutation_Response>;
  /** delete single row from the table: "vehicle_airworthiness_categories" */
  delete_vehicle_airworthiness_categories_by_pk?: Maybe<Vehicle_Airworthiness_Categories>;
  /** delete data from the table: "vehicle_alerts" */
  delete_vehicle_alerts?: Maybe<Vehicle_Alerts_Mutation_Response>;
  /** delete single row from the table: "vehicle_alerts" */
  delete_vehicle_alerts_by_pk?: Maybe<Vehicle_Alerts>;
  /** delete data from the table: "vehicle_flight_state_enum" */
  delete_vehicle_flight_state_enum?: Maybe<Vehicle_Flight_State_Enum_Mutation_Response>;
  /** delete single row from the table: "vehicle_flight_state_enum" */
  delete_vehicle_flight_state_enum_by_pk?: Maybe<Vehicle_Flight_State_Enum>;
  /** delete data from the table: "vehicle_flight_statuses" */
  delete_vehicle_flight_statuses?: Maybe<Vehicle_Flight_Statuses_Mutation_Response>;
  /** delete single row from the table: "vehicle_flight_statuses" */
  delete_vehicle_flight_statuses_by_pk?: Maybe<Vehicle_Flight_Statuses>;
  /** delete data from the table: "vehicle_model_parameter_types" */
  delete_vehicle_model_parameter_types?: Maybe<Vehicle_Model_Parameter_Types_Mutation_Response>;
  /** delete single row from the table: "vehicle_model_parameter_types" */
  delete_vehicle_model_parameter_types_by_pk?: Maybe<Vehicle_Model_Parameter_Types>;
  /** delete data from the table: "vehicle_model_parameters" */
  delete_vehicle_model_parameters?: Maybe<Vehicle_Model_Parameters_Mutation_Response>;
  /** delete single row from the table: "vehicle_model_parameters" */
  delete_vehicle_model_parameters_by_pk?: Maybe<Vehicle_Model_Parameters>;
  /** delete data from the table: "vehicle_models" */
  delete_vehicle_models?: Maybe<Vehicle_Models_Mutation_Response>;
  /** delete data from the table: "vehicle_models_ancestors" */
  delete_vehicle_models_ancestors?: Maybe<Vehicle_Models_Ancestors_Mutation_Response>;
  /** delete single row from the table: "vehicle_models_ancestors" */
  delete_vehicle_models_ancestors_by_pk?: Maybe<Vehicle_Models_Ancestors>;
  /** delete single row from the table: "vehicle_models" */
  delete_vehicle_models_by_pk?: Maybe<Vehicle_Models>;
  /** delete data from the table: "vehicle_networks" */
  delete_vehicle_networks?: Maybe<Vehicle_Networks_Mutation_Response>;
  /** delete single row from the table: "vehicle_networks" */
  delete_vehicle_networks_by_pk?: Maybe<Vehicle_Networks>;
  /** delete data from the table: "vehicle_pilot_assignments" */
  delete_vehicle_pilot_assignments?: Maybe<Vehicle_Pilot_Assignments_Mutation_Response>;
  /** delete single row from the table: "vehicle_pilot_assignments" */
  delete_vehicle_pilot_assignments_by_pk?: Maybe<Vehicle_Pilot_Assignments>;
  /** delete data from the table: "vehicle_priority_event_keys" */
  delete_vehicle_priority_event_keys?: Maybe<Vehicle_Priority_Event_Keys_Mutation_Response>;
  /** delete single row from the table: "vehicle_priority_event_keys" */
  delete_vehicle_priority_event_keys_by_pk?: Maybe<Vehicle_Priority_Event_Keys>;
  /** delete data from the table: "vehicle_priority_events" */
  delete_vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Mutation_Response>;
  /** delete single row from the table: "vehicle_priority_events" */
  delete_vehicle_priority_events_by_pk?: Maybe<Vehicle_Priority_Events>;
  /** delete data from the table: "vehicle_status_updates" */
  delete_vehicle_status_updates?: Maybe<Vehicle_Status_Updates_Mutation_Response>;
  /** delete single row from the table: "vehicle_status_updates" */
  delete_vehicle_status_updates_by_pk?: Maybe<Vehicle_Status_Updates>;
  /** delete data from the table: "kafka_serialized_vehicle_statuses" */
  delete_vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Mutation_Response>;
  /** delete data from the table: "vehicles" */
  delete_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** delete single row from the table: "vehicles" */
  delete_vehicles_by_pk?: Maybe<Vehicles>;
  /** insert data into the table: "air_traffic_deconfliction_algorithm_types" */
  insert_air_traffic_deconfliction_algorithm_types?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Mutation_Response>;
  /** insert a single row into the table: "air_traffic_deconfliction_algorithm_types" */
  insert_air_traffic_deconfliction_algorithm_types_one?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** insert data into the table: "air_traffic_monitor_tasks" */
  insert_air_traffic_monitor_tasks?: Maybe<Air_Traffic_Monitor_Tasks_Mutation_Response>;
  /** insert a single row into the table: "air_traffic_monitor_tasks" */
  insert_air_traffic_monitor_tasks_one?: Maybe<Air_Traffic_Monitor_Tasks>;
  /** insert data into the table: "air_traffic_tracks" */
  insert_air_traffic_tracks?: Maybe<Air_Traffic_Tracks_Mutation_Response>;
  /** insert a single row into the table: "air_traffic_tracks" */
  insert_air_traffic_tracks_one?: Maybe<Air_Traffic_Tracks>;
  /** insert data into the table: "aircraft_type_designators" */
  insert_aircraft_type_designators?: Maybe<Aircraft_Type_Designators_Mutation_Response>;
  /** insert a single row into the table: "aircraft_type_designators" */
  insert_aircraft_type_designators_one?: Maybe<Aircraft_Type_Designators>;
  /** insert data into the table: "airspaces" */
  insert_airspaces?: Maybe<Airspaces_Mutation_Response>;
  /** insert a single row into the table: "airspaces" */
  insert_airspaces_one?: Maybe<Airspaces>;
  /** insert data into the table: "available_aircraft_command_sets" */
  insert_available_aircraft_command_sets?: Maybe<Available_Aircraft_Command_Sets_Mutation_Response>;
  /** insert a single row into the table: "available_aircraft_command_sets" */
  insert_available_aircraft_command_sets_one?: Maybe<Available_Aircraft_Command_Sets>;
  /** insert data into the table: "available_aircraft_command_state_keys" */
  insert_available_aircraft_command_state_keys?: Maybe<Available_Aircraft_Command_State_Keys_Mutation_Response>;
  /** insert a single row into the table: "available_aircraft_command_state_keys" */
  insert_available_aircraft_command_state_keys_one?: Maybe<Available_Aircraft_Command_State_Keys>;
  /** insert data into the table: "badge_tokens" */
  insert_badge_tokens?: Maybe<Badge_Tokens_Mutation_Response>;
  /** insert a single row into the table: "badge_tokens" */
  insert_badge_tokens_one?: Maybe<Badge_Tokens>;
  /** insert data into the table: "batteries" */
  insert_batteries?: Maybe<Batteries_Mutation_Response>;
  /** insert a single row into the table: "batteries" */
  insert_batteries_one?: Maybe<Batteries>;
  /** insert data into the table: "contingency_landing_spots" */
  insert_contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Mutation_Response>;
  /** insert a single row into the table: "contingency_landing_spots" */
  insert_contingency_landing_spots_one?: Maybe<Contingency_Landing_Spots>;
  /** insert data into the table: "current_air_traffic_proximity_recordings" */
  insert_current_air_traffic_proximity_recordings?: Maybe<Current_Air_Traffic_Proximity_Recordings_Mutation_Response>;
  /** insert a single row into the table: "current_air_traffic_proximity_recordings" */
  insert_current_air_traffic_proximity_recordings_one?: Maybe<Current_Air_Traffic_Proximity_Recordings>;
  /** insert data into the table: "current_air_traffic_tracks" */
  insert_current_air_traffic_tracks?: Maybe<Current_Air_Traffic_Tracks_Mutation_Response>;
  /** insert a single row into the table: "current_air_traffic_tracks" */
  insert_current_air_traffic_tracks_one?: Maybe<Current_Air_Traffic_Tracks>;
  /** insert data into the table: "daa_observations" */
  insert_daa_observations?: Maybe<Daa_Observations_Mutation_Response>;
  /** insert a single row into the table: "daa_observations" */
  insert_daa_observations_one?: Maybe<Daa_Observations>;
  /** insert data into the table: "daa_statuses" */
  insert_daa_statuses?: Maybe<Daa_Statuses_Mutation_Response>;
  /** insert a single row into the table: "daa_statuses" */
  insert_daa_statuses_one?: Maybe<Daa_Statuses>;
  /** insert data into the table: "env_feature_flags" */
  insert_env_feature_flags?: Maybe<Env_Feature_Flags_Mutation_Response>;
  /** insert a single row into the table: "env_feature_flags" */
  insert_env_feature_flags_one?: Maybe<Env_Feature_Flags>;
  /** insert data into the table: "file_asset_types" */
  insert_file_asset_types?: Maybe<File_Asset_Types_Mutation_Response>;
  /** insert a single row into the table: "file_asset_types" */
  insert_file_asset_types_one?: Maybe<File_Asset_Types>;
  /** insert data into the table: "file_assets" */
  insert_file_assets?: Maybe<File_Assets_Mutation_Response>;
  /** insert a single row into the table: "file_assets" */
  insert_file_assets_one?: Maybe<File_Assets>;
  /** insert data into the table: "flight_commands" */
  insert_flight_commands?: Maybe<Flight_Commands_Mutation_Response>;
  /** insert a single row into the table: "flight_commands" */
  insert_flight_commands_one?: Maybe<Flight_Commands>;
  /** insert data into the table: "flight_derivation_reports" */
  insert_flight_derivation_reports?: Maybe<Flight_Derivation_Reports_Mutation_Response>;
  /** insert a single row into the table: "flight_derivation_reports" */
  insert_flight_derivation_reports_one?: Maybe<Flight_Derivation_Reports>;
  /** insert data into the table: "flight_plan_pilot_assignments" */
  insert_flight_plan_pilot_assignments?: Maybe<Flight_Plan_Pilot_Assignments_Mutation_Response>;
  /** insert a single row into the table: "flight_plan_pilot_assignments" */
  insert_flight_plan_pilot_assignments_one?: Maybe<Flight_Plan_Pilot_Assignments>;
  /** insert data into the table: "flight_plan_statuses" */
  insert_flight_plan_statuses?: Maybe<Flight_Plan_Statuses_Mutation_Response>;
  /** insert a single row into the table: "flight_plan_statuses" */
  insert_flight_plan_statuses_one?: Maybe<Flight_Plan_Statuses>;
  /** insert data into the table: "flight_plan_utm_providers" */
  insert_flight_plan_utm_providers?: Maybe<Flight_Plan_Utm_Providers_Mutation_Response>;
  /** insert a single row into the table: "flight_plan_utm_providers" */
  insert_flight_plan_utm_providers_one?: Maybe<Flight_Plan_Utm_Providers>;
  /** insert data into the table: "flight_plans" */
  insert_flight_plans?: Maybe<Flight_Plans_Mutation_Response>;
  /** insert a single row into the table: "flight_plans" */
  insert_flight_plans_one?: Maybe<Flight_Plans>;
  /** insert data into the table: "flight_routes" */
  insert_flight_routes?: Maybe<Flight_Routes_Mutation_Response>;
  /** insert a single row into the table: "flight_routes" */
  insert_flight_routes_one?: Maybe<Flight_Routes>;
  /** insert data into the table: "flight_weather_data" */
  insert_flight_weather_data?: Maybe<Flight_Weather_Data_Mutation_Response>;
  /** insert a single row into the table: "flight_weather_data" */
  insert_flight_weather_data_one?: Maybe<Flight_Weather_Data>;
  /** insert data into the table: "ground_asset_commands" */
  insert_ground_asset_commands?: Maybe<Ground_Asset_Commands_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_commands" */
  insert_ground_asset_commands_one?: Maybe<Ground_Asset_Commands>;
  /** insert data into the table: "ground_asset_model_parameter_types" */
  insert_ground_asset_model_parameter_types?: Maybe<Ground_Asset_Model_Parameter_Types_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_model_parameter_types" */
  insert_ground_asset_model_parameter_types_one?: Maybe<Ground_Asset_Model_Parameter_Types>;
  /** insert data into the table: "ground_asset_model_parameters" */
  insert_ground_asset_model_parameters?: Maybe<Ground_Asset_Model_Parameters_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_model_parameters" */
  insert_ground_asset_model_parameters_one?: Maybe<Ground_Asset_Model_Parameters>;
  /** insert data into the table: "ground_asset_model_types" */
  insert_ground_asset_model_types?: Maybe<Ground_Asset_Model_Types_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_model_types" */
  insert_ground_asset_model_types_one?: Maybe<Ground_Asset_Model_Types>;
  /** insert data into the table: "ground_asset_models" */
  insert_ground_asset_models?: Maybe<Ground_Asset_Models_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_models" */
  insert_ground_asset_models_one?: Maybe<Ground_Asset_Models>;
  /** insert data into the table: "ground_asset_networks" */
  insert_ground_asset_networks?: Maybe<Ground_Asset_Networks_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_networks" */
  insert_ground_asset_networks_one?: Maybe<Ground_Asset_Networks>;
  /** insert data into the table: "ground_asset_status_values" */
  insert_ground_asset_status_values?: Maybe<Ground_Asset_Status_Values_Mutation_Response>;
  /** insert a single row into the table: "ground_asset_status_values" */
  insert_ground_asset_status_values_one?: Maybe<Ground_Asset_Status_Values>;
  /** insert data into the table: "ground_assets" */
  insert_ground_assets?: Maybe<Ground_Assets_Mutation_Response>;
  /** insert a single row into the table: "ground_assets" */
  insert_ground_assets_one?: Maybe<Ground_Assets>;
  /** insert data into the table: "ground_control_workflow_state_processing_statuses" */
  insert_ground_control_workflow_state_processing_statuses?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Mutation_Response>;
  /** insert a single row into the table: "ground_control_workflow_state_processing_statuses" */
  insert_ground_control_workflow_state_processing_statuses_one?: Maybe<Ground_Control_Workflow_State_Processing_Statuses>;
  /** insert data into the table: "historical_serialized_ground_asset_statuses" */
  insert_historical_serialized_ground_asset_statuses?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Mutation_Response>;
  /** insert a single row into the table: "historical_serialized_ground_asset_statuses" */
  insert_historical_serialized_ground_asset_statuses_one?: Maybe<Historical_Serialized_Ground_Asset_Statuses>;
  /** insert data into the table: "historical_serialized_vehicle_statuses" */
  insert_historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Mutation_Response>;
  /** insert a single row into the table: "historical_serialized_vehicle_statuses" */
  insert_historical_serialized_vehicle_statuses_one?: Maybe<Historical_Serialized_Vehicle_Statuses>;
  /** insert data into the table: "historical_vehicle_positions" */
  insert_historical_vehicle_positions?: Maybe<Historical_Vehicle_Positions_Mutation_Response>;
  /** insert a single row into the table: "historical_vehicle_positions" */
  insert_historical_vehicle_positions_one?: Maybe<Historical_Vehicle_Positions>;
  /** insert data into the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  insert_kafka_air_traffic_vehicle_flight_proximity_recordings?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Mutation_Response>;
  /** insert a single row into the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  insert_kafka_air_traffic_vehicle_flight_proximity_recordings_one?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** insert data into the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  insert_kafka_cached_air_traffic_flight_proximity_recordings?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Mutation_Response>;
  /** insert a single row into the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  insert_kafka_cached_air_traffic_flight_proximity_recordings_one?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** insert data into the table: "kafka_mqtt_vehicle_status_messages" */
  insert_kafka_mqtt_vehicle_status_messages?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Mutation_Response>;
  /** insert a single row into the table: "kafka_mqtt_vehicle_status_messages" */
  insert_kafka_mqtt_vehicle_status_messages_one?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** insert data into the table: "kafka_serialized_ground_asset_statuses" */
  insert_kafka_serialized_ground_asset_statuses?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Mutation_Response>;
  /** insert a single row into the table: "kafka_serialized_ground_asset_statuses" */
  insert_kafka_serialized_ground_asset_statuses_one?: Maybe<Kafka_Serialized_Ground_Asset_Statuses>;
  /** insert a single row into the table: "kafka_serialized_vehicle_statuses" */
  insert_kafka_serialized_vehicle_statuses_one?: Maybe<Kafka_Serialized_Vehicle_Statuses>;
  /** insert data into the table: "landing_request_statuses" */
  insert_landing_request_statuses?: Maybe<Landing_Request_Statuses_Mutation_Response>;
  /** insert a single row into the table: "landing_request_statuses" */
  insert_landing_request_statuses_one?: Maybe<Landing_Request_Statuses>;
  /** insert data into the table: "landing_requests" */
  insert_landing_requests?: Maybe<Landing_Requests_Mutation_Response>;
  /** insert a single row into the table: "landing_requests" */
  insert_landing_requests_one?: Maybe<Landing_Requests>;
  /** insert data into the table: "last_vehicle_anomaly_statuses" */
  insert_last_vehicle_anomaly_statuses?: Maybe<Last_Vehicle_Anomaly_Statuses_Mutation_Response>;
  /** insert a single row into the table: "last_vehicle_anomaly_statuses" */
  insert_last_vehicle_anomaly_statuses_one?: Maybe<Last_Vehicle_Anomaly_Statuses>;
  /** insert data into the table: "manifest_events" */
  insert_manifest_events?: Maybe<Manifest_Events_Mutation_Response>;
  /** insert a single row into the table: "manifest_events" */
  insert_manifest_events_one?: Maybe<Manifest_Events>;
  /** insert data into the table: "manifest_items" */
  insert_manifest_items?: Maybe<Manifest_Items_Mutation_Response>;
  /** insert a single row into the table: "manifest_items" */
  insert_manifest_items_one?: Maybe<Manifest_Items>;
  /** insert data into the table: "manifest_products" */
  insert_manifest_products?: Maybe<Manifest_Products_Mutation_Response>;
  /** insert a single row into the table: "manifest_products" */
  insert_manifest_products_one?: Maybe<Manifest_Products>;
  /** insert data into the table: "manifest_status_audits" */
  insert_manifest_status_audits?: Maybe<Manifest_Status_Audits_Mutation_Response>;
  /** insert a single row into the table: "manifest_status_audits" */
  insert_manifest_status_audits_one?: Maybe<Manifest_Status_Audits>;
  /** insert data into the table: "manifest_types" */
  insert_manifest_types?: Maybe<Manifest_Types_Mutation_Response>;
  /** insert a single row into the table: "manifest_types" */
  insert_manifest_types_one?: Maybe<Manifest_Types>;
  /** insert data into the table: "manifests" */
  insert_manifests?: Maybe<Manifests_Mutation_Response>;
  /** insert data into the table: "manifests_arrived_within_minute" */
  insert_manifests_arrived_within_minute?: Maybe<Manifests_Arrived_Within_Minute_Mutation_Response>;
  /** insert a single row into the table: "manifests_arrived_within_minute" */
  insert_manifests_arrived_within_minute_one?: Maybe<Manifests_Arrived_Within_Minute>;
  /** insert a single row into the table: "manifests" */
  insert_manifests_one?: Maybe<Manifests>;
  /** insert data into the table: "network_utm_providers" */
  insert_network_utm_providers?: Maybe<Network_Utm_Providers_Mutation_Response>;
  /** insert a single row into the table: "network_utm_providers" */
  insert_network_utm_providers_one?: Maybe<Network_Utm_Providers>;
  /** insert data into the table: "networks" */
  insert_networks?: Maybe<Networks_Mutation_Response>;
  /** insert a single row into the table: "networks" */
  insert_networks_one?: Maybe<Networks>;
  /** insert data into the table: "organizations" */
  insert_organizations?: Maybe<Organizations_Mutation_Response>;
  /** insert a single row into the table: "organizations" */
  insert_organizations_one?: Maybe<Organizations>;
  /** insert data into the table: "paths" */
  insert_paths?: Maybe<Paths_Mutation_Response>;
  /** insert a single row into the table: "paths" */
  insert_paths_one?: Maybe<Paths>;
  /** insert data into the table: "pickup_requests" */
  insert_pickup_requests?: Maybe<Pickup_Requests_Mutation_Response>;
  /** insert a single row into the table: "pickup_requests" */
  insert_pickup_requests_one?: Maybe<Pickup_Requests>;
  /** insert data into the table: "positive_exchange_of_flight_control_requests" */
  insert_positive_exchange_of_flight_control_requests?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Mutation_Response>;
  /** insert a single row into the table: "positive_exchange_of_flight_control_requests" */
  insert_positive_exchange_of_flight_control_requests_one?: Maybe<Positive_Exchange_Of_Flight_Control_Requests>;
  /** insert data into the table: "predicted_conflicts" */
  insert_predicted_conflicts?: Maybe<Predicted_Conflicts_Mutation_Response>;
  /** insert a single row into the table: "predicted_conflicts" */
  insert_predicted_conflicts_one?: Maybe<Predicted_Conflicts>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** insert a single row into the table: "spatial_ref_sys" */
  insert_spatial_ref_sys_one?: Maybe<Spatial_Ref_Sys>;
  /** insert data into the table: "squawk_severities" */
  insert_squawk_severities?: Maybe<Squawk_Severities_Mutation_Response>;
  /** insert a single row into the table: "squawk_severities" */
  insert_squawk_severities_one?: Maybe<Squawk_Severities>;
  /** insert data into the table: "squawk_squawkable_types" */
  insert_squawk_squawkable_types?: Maybe<Squawk_Squawkable_Types_Mutation_Response>;
  /** insert a single row into the table: "squawk_squawkable_types" */
  insert_squawk_squawkable_types_one?: Maybe<Squawk_Squawkable_Types>;
  /** insert data into the table: "squawk_statuses" */
  insert_squawk_statuses?: Maybe<Squawk_Statuses_Mutation_Response>;
  /** insert a single row into the table: "squawk_statuses" */
  insert_squawk_statuses_one?: Maybe<Squawk_Statuses>;
  /** insert data into the table: "squawks" */
  insert_squawks?: Maybe<Squawks_Mutation_Response>;
  /** insert a single row into the table: "squawks" */
  insert_squawks_one?: Maybe<Squawks>;
  /** insert data into the table: "stations" */
  insert_stations?: Maybe<Stations_Mutation_Response>;
  /** insert a single row into the table: "stations" */
  insert_stations_one?: Maybe<Stations>;
  /** insert data into the table: "tenants" */
  insert_tenants?: Maybe<Tenants_Mutation_Response>;
  /** insert a single row into the table: "tenants" */
  insert_tenants_one?: Maybe<Tenants>;
  /** insert data into the table: "type_cert_flight_analysis_data" */
  insert_type_cert_flight_analysis_data?: Maybe<Type_Cert_Flight_Analysis_Data_Mutation_Response>;
  /** insert a single row into the table: "type_cert_flight_analysis_data" */
  insert_type_cert_flight_analysis_data_one?: Maybe<Type_Cert_Flight_Analysis_Data>;
  /** insert data into the table: "type_cert_manual_data" */
  insert_type_cert_manual_data?: Maybe<Type_Cert_Manual_Data_Mutation_Response>;
  /** insert a single row into the table: "type_cert_manual_data" */
  insert_type_cert_manual_data_one?: Maybe<Type_Cert_Manual_Data>;
  /** insert data into the table: "user_app_states" */
  insert_user_app_states?: Maybe<User_App_States_Mutation_Response>;
  /** insert a single row into the table: "user_app_states" */
  insert_user_app_states_one?: Maybe<User_App_States>;
  /** insert data into the table: "user_networks" */
  insert_user_networks?: Maybe<User_Networks_Mutation_Response>;
  /** insert a single row into the table: "user_networks" */
  insert_user_networks_one?: Maybe<User_Networks>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<User_Roles>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "vehicle_airworthiness_categories" */
  insert_vehicle_airworthiness_categories?: Maybe<Vehicle_Airworthiness_Categories_Mutation_Response>;
  /** insert a single row into the table: "vehicle_airworthiness_categories" */
  insert_vehicle_airworthiness_categories_one?: Maybe<Vehicle_Airworthiness_Categories>;
  /** insert data into the table: "vehicle_alerts" */
  insert_vehicle_alerts?: Maybe<Vehicle_Alerts_Mutation_Response>;
  /** insert a single row into the table: "vehicle_alerts" */
  insert_vehicle_alerts_one?: Maybe<Vehicle_Alerts>;
  /** insert data into the table: "vehicle_flight_state_enum" */
  insert_vehicle_flight_state_enum?: Maybe<Vehicle_Flight_State_Enum_Mutation_Response>;
  /** insert a single row into the table: "vehicle_flight_state_enum" */
  insert_vehicle_flight_state_enum_one?: Maybe<Vehicle_Flight_State_Enum>;
  /** insert data into the table: "vehicle_flight_statuses" */
  insert_vehicle_flight_statuses?: Maybe<Vehicle_Flight_Statuses_Mutation_Response>;
  /** insert a single row into the table: "vehicle_flight_statuses" */
  insert_vehicle_flight_statuses_one?: Maybe<Vehicle_Flight_Statuses>;
  /** insert data into the table: "vehicle_model_parameter_types" */
  insert_vehicle_model_parameter_types?: Maybe<Vehicle_Model_Parameter_Types_Mutation_Response>;
  /** insert a single row into the table: "vehicle_model_parameter_types" */
  insert_vehicle_model_parameter_types_one?: Maybe<Vehicle_Model_Parameter_Types>;
  /** insert data into the table: "vehicle_model_parameters" */
  insert_vehicle_model_parameters?: Maybe<Vehicle_Model_Parameters_Mutation_Response>;
  /** insert a single row into the table: "vehicle_model_parameters" */
  insert_vehicle_model_parameters_one?: Maybe<Vehicle_Model_Parameters>;
  /** insert data into the table: "vehicle_models" */
  insert_vehicle_models?: Maybe<Vehicle_Models_Mutation_Response>;
  /** insert data into the table: "vehicle_models_ancestors" */
  insert_vehicle_models_ancestors?: Maybe<Vehicle_Models_Ancestors_Mutation_Response>;
  /** insert a single row into the table: "vehicle_models_ancestors" */
  insert_vehicle_models_ancestors_one?: Maybe<Vehicle_Models_Ancestors>;
  /** insert a single row into the table: "vehicle_models" */
  insert_vehicle_models_one?: Maybe<Vehicle_Models>;
  /** insert data into the table: "vehicle_networks" */
  insert_vehicle_networks?: Maybe<Vehicle_Networks_Mutation_Response>;
  /** insert a single row into the table: "vehicle_networks" */
  insert_vehicle_networks_one?: Maybe<Vehicle_Networks>;
  /** insert data into the table: "vehicle_pilot_assignments" */
  insert_vehicle_pilot_assignments?: Maybe<Vehicle_Pilot_Assignments_Mutation_Response>;
  /** insert a single row into the table: "vehicle_pilot_assignments" */
  insert_vehicle_pilot_assignments_one?: Maybe<Vehicle_Pilot_Assignments>;
  /** insert data into the table: "vehicle_priority_event_keys" */
  insert_vehicle_priority_event_keys?: Maybe<Vehicle_Priority_Event_Keys_Mutation_Response>;
  /** insert a single row into the table: "vehicle_priority_event_keys" */
  insert_vehicle_priority_event_keys_one?: Maybe<Vehicle_Priority_Event_Keys>;
  /** insert data into the table: "vehicle_priority_events" */
  insert_vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Mutation_Response>;
  /** insert a single row into the table: "vehicle_priority_events" */
  insert_vehicle_priority_events_one?: Maybe<Vehicle_Priority_Events>;
  /** insert data into the table: "vehicle_status_updates" */
  insert_vehicle_status_updates?: Maybe<Vehicle_Status_Updates_Mutation_Response>;
  /** insert a single row into the table: "vehicle_status_updates" */
  insert_vehicle_status_updates_one?: Maybe<Vehicle_Status_Updates>;
  /** insert data into the table: "kafka_serialized_vehicle_statuses" */
  insert_vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Mutation_Response>;
  /** insert data into the table: "vehicles" */
  insert_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** insert a single row into the table: "vehicles" */
  insert_vehicles_one?: Maybe<Vehicles>;
  /** perform the action: "issueAirTrafficSimulationCommand" */
  issueAirTrafficSimulationCommand?: Maybe<AirTrafficSimulationCommandOutput>;
  /** perform the action: "issueAlternateLandingTypeCommand" */
  issueAlternateLandingTypeCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issuePrecisionLandingTypeCommand" */
  issuePrecisionLandingTypeCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueProceedToSafetyZoneCommand" */
  issueProceedToSafetyZoneCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueResumePlannedFlightCommand" */
  issueResumePlannedFlightCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleAbortCommand" */
  issueVehicleAbortCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleArmCommand" */
  issueVehicleArmCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleCancelMissionCommand" */
  issueVehicleCancelMissionCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleDisarmCommand" */
  issueVehicleDisarmCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleHoldCommand" */
  issueVehicleHoldCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleProceedCommand" */
  issueVehicleProceedCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleResumeCommand" */
  issueVehicleResumeCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "issueVehicleReturnHomeCommand" */
  issueVehicleReturnHomeCommand?: Maybe<VehicleCommandOutput>;
  /** perform the action: "markManifestAsDelivered" */
  markManifestAsDelivered?: Maybe<MarkManifestAsDeliveredOutput>;
  /** perform the action: "removeUserFromNetwork" */
  removeUserFromNetwork?: Maybe<RemoveUserFromNetworkOutput>;
  /** perform the action: "requestFlightControl" */
  requestFlightControl?: Maybe<RequestFlightControlOutput>;
  /** perform the action: "resetUserPassword" */
  resetUserPassword?: Maybe<ResetUserPasswordOutput>;
  /** perform the action: "resolveFlightControlRequest" */
  resolveFlightControlRequest?: Maybe<ResolveFlightControlRequestOutput>;
  /** perform the action: "simulateAirTrafficConflict" */
  simulateAirTrafficConflict?: Maybe<SimulateAirTrafficConflictOutput>;
  /** perform the action: "simulateMultipleJitterAirTrafficConflicts" */
  simulateMultipleJitterAirTrafficConflicts?: Maybe<SimulateMultipleJitterAirTrafficConflictsOutput>;
  /** perform the action: "unassignAllPilotsFromVehicle" */
  unassignAllPilotsFromVehicle?: Maybe<UnassignAllPilotsFromVehicleOutput>;
  /** perform the action: "updateManifest" */
  updateManifest?: Maybe<UpdateManifestOutput>;
  /** perform the action: "updateNetworkName" */
  updateNetworkName?: Maybe<UpdateNetworkNameOutput>;
  /** perform the action: "updateNetworkServiceDisabled" */
  updateNetworkServiceDisabled?: Maybe<UpdateNetworkServiceDisabledOutput>;
  /** perform the action: "updateNetworkUtmEnabled" */
  updateNetworkUtmEnabled?: Maybe<UpdateNetworkUtmEnabledOutput>;
  /** perform the action: "updateUser" */
  updateUser?: Maybe<UpdateUserOutput>;
  /** update data of the table: "air_traffic_deconfliction_algorithm_types" */
  update_air_traffic_deconfliction_algorithm_types?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Mutation_Response>;
  /** update single row of the table: "air_traffic_deconfliction_algorithm_types" */
  update_air_traffic_deconfliction_algorithm_types_by_pk?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** update data of the table: "air_traffic_monitor_tasks" */
  update_air_traffic_monitor_tasks?: Maybe<Air_Traffic_Monitor_Tasks_Mutation_Response>;
  /** update single row of the table: "air_traffic_monitor_tasks" */
  update_air_traffic_monitor_tasks_by_pk?: Maybe<Air_Traffic_Monitor_Tasks>;
  /** update data of the table: "air_traffic_tracks" */
  update_air_traffic_tracks?: Maybe<Air_Traffic_Tracks_Mutation_Response>;
  /** update single row of the table: "air_traffic_tracks" */
  update_air_traffic_tracks_by_pk?: Maybe<Air_Traffic_Tracks>;
  /** update data of the table: "aircraft_type_designators" */
  update_aircraft_type_designators?: Maybe<Aircraft_Type_Designators_Mutation_Response>;
  /** update single row of the table: "aircraft_type_designators" */
  update_aircraft_type_designators_by_pk?: Maybe<Aircraft_Type_Designators>;
  /** update data of the table: "airspaces" */
  update_airspaces?: Maybe<Airspaces_Mutation_Response>;
  /** update single row of the table: "airspaces" */
  update_airspaces_by_pk?: Maybe<Airspaces>;
  /** update data of the table: "available_aircraft_command_sets" */
  update_available_aircraft_command_sets?: Maybe<Available_Aircraft_Command_Sets_Mutation_Response>;
  /** update single row of the table: "available_aircraft_command_sets" */
  update_available_aircraft_command_sets_by_pk?: Maybe<Available_Aircraft_Command_Sets>;
  /** update data of the table: "available_aircraft_command_state_keys" */
  update_available_aircraft_command_state_keys?: Maybe<Available_Aircraft_Command_State_Keys_Mutation_Response>;
  /** update single row of the table: "available_aircraft_command_state_keys" */
  update_available_aircraft_command_state_keys_by_pk?: Maybe<Available_Aircraft_Command_State_Keys>;
  /** update data of the table: "badge_tokens" */
  update_badge_tokens?: Maybe<Badge_Tokens_Mutation_Response>;
  /** update single row of the table: "badge_tokens" */
  update_badge_tokens_by_pk?: Maybe<Badge_Tokens>;
  /** update data of the table: "batteries" */
  update_batteries?: Maybe<Batteries_Mutation_Response>;
  /** update single row of the table: "batteries" */
  update_batteries_by_pk?: Maybe<Batteries>;
  /** update data of the table: "contingency_landing_spots" */
  update_contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Mutation_Response>;
  /** update single row of the table: "contingency_landing_spots" */
  update_contingency_landing_spots_by_pk?: Maybe<Contingency_Landing_Spots>;
  /** update data of the table: "current_air_traffic_proximity_recordings" */
  update_current_air_traffic_proximity_recordings?: Maybe<Current_Air_Traffic_Proximity_Recordings_Mutation_Response>;
  /** update data of the table: "current_air_traffic_tracks" */
  update_current_air_traffic_tracks?: Maybe<Current_Air_Traffic_Tracks_Mutation_Response>;
  /** update data of the table: "daa_observations" */
  update_daa_observations?: Maybe<Daa_Observations_Mutation_Response>;
  /** update single row of the table: "daa_observations" */
  update_daa_observations_by_pk?: Maybe<Daa_Observations>;
  /** update data of the table: "daa_statuses" */
  update_daa_statuses?: Maybe<Daa_Statuses_Mutation_Response>;
  /** update single row of the table: "daa_statuses" */
  update_daa_statuses_by_pk?: Maybe<Daa_Statuses>;
  /** update data of the table: "env_feature_flags" */
  update_env_feature_flags?: Maybe<Env_Feature_Flags_Mutation_Response>;
  /** update single row of the table: "env_feature_flags" */
  update_env_feature_flags_by_pk?: Maybe<Env_Feature_Flags>;
  /** update data of the table: "file_asset_types" */
  update_file_asset_types?: Maybe<File_Asset_Types_Mutation_Response>;
  /** update single row of the table: "file_asset_types" */
  update_file_asset_types_by_pk?: Maybe<File_Asset_Types>;
  /** update data of the table: "file_assets" */
  update_file_assets?: Maybe<File_Assets_Mutation_Response>;
  /** update single row of the table: "file_assets" */
  update_file_assets_by_pk?: Maybe<File_Assets>;
  /** update data of the table: "flight_commands" */
  update_flight_commands?: Maybe<Flight_Commands_Mutation_Response>;
  /** update single row of the table: "flight_commands" */
  update_flight_commands_by_pk?: Maybe<Flight_Commands>;
  /** update data of the table: "flight_derivation_reports" */
  update_flight_derivation_reports?: Maybe<Flight_Derivation_Reports_Mutation_Response>;
  /** update single row of the table: "flight_derivation_reports" */
  update_flight_derivation_reports_by_pk?: Maybe<Flight_Derivation_Reports>;
  /** update data of the table: "flight_plan_pilot_assignments" */
  update_flight_plan_pilot_assignments?: Maybe<Flight_Plan_Pilot_Assignments_Mutation_Response>;
  /** update single row of the table: "flight_plan_pilot_assignments" */
  update_flight_plan_pilot_assignments_by_pk?: Maybe<Flight_Plan_Pilot_Assignments>;
  /** update data of the table: "flight_plan_statuses" */
  update_flight_plan_statuses?: Maybe<Flight_Plan_Statuses_Mutation_Response>;
  /** update single row of the table: "flight_plan_statuses" */
  update_flight_plan_statuses_by_pk?: Maybe<Flight_Plan_Statuses>;
  /** update data of the table: "flight_plan_utm_providers" */
  update_flight_plan_utm_providers?: Maybe<Flight_Plan_Utm_Providers_Mutation_Response>;
  /** update single row of the table: "flight_plan_utm_providers" */
  update_flight_plan_utm_providers_by_pk?: Maybe<Flight_Plan_Utm_Providers>;
  /** update data of the table: "flight_plans" */
  update_flight_plans?: Maybe<Flight_Plans_Mutation_Response>;
  /** update single row of the table: "flight_plans" */
  update_flight_plans_by_pk?: Maybe<Flight_Plans>;
  /** update data of the table: "flight_routes" */
  update_flight_routes?: Maybe<Flight_Routes_Mutation_Response>;
  /** update single row of the table: "flight_routes" */
  update_flight_routes_by_pk?: Maybe<Flight_Routes>;
  /** update data of the table: "flight_weather_data" */
  update_flight_weather_data?: Maybe<Flight_Weather_Data_Mutation_Response>;
  /** update single row of the table: "flight_weather_data" */
  update_flight_weather_data_by_pk?: Maybe<Flight_Weather_Data>;
  /** update data of the table: "ground_asset_commands" */
  update_ground_asset_commands?: Maybe<Ground_Asset_Commands_Mutation_Response>;
  /** update single row of the table: "ground_asset_commands" */
  update_ground_asset_commands_by_pk?: Maybe<Ground_Asset_Commands>;
  /** update data of the table: "ground_asset_model_parameter_types" */
  update_ground_asset_model_parameter_types?: Maybe<Ground_Asset_Model_Parameter_Types_Mutation_Response>;
  /** update single row of the table: "ground_asset_model_parameter_types" */
  update_ground_asset_model_parameter_types_by_pk?: Maybe<Ground_Asset_Model_Parameter_Types>;
  /** update data of the table: "ground_asset_model_parameters" */
  update_ground_asset_model_parameters?: Maybe<Ground_Asset_Model_Parameters_Mutation_Response>;
  /** update single row of the table: "ground_asset_model_parameters" */
  update_ground_asset_model_parameters_by_pk?: Maybe<Ground_Asset_Model_Parameters>;
  /** update data of the table: "ground_asset_model_types" */
  update_ground_asset_model_types?: Maybe<Ground_Asset_Model_Types_Mutation_Response>;
  /** update single row of the table: "ground_asset_model_types" */
  update_ground_asset_model_types_by_pk?: Maybe<Ground_Asset_Model_Types>;
  /** update data of the table: "ground_asset_models" */
  update_ground_asset_models?: Maybe<Ground_Asset_Models_Mutation_Response>;
  /** update single row of the table: "ground_asset_models" */
  update_ground_asset_models_by_pk?: Maybe<Ground_Asset_Models>;
  /** update data of the table: "ground_asset_networks" */
  update_ground_asset_networks?: Maybe<Ground_Asset_Networks_Mutation_Response>;
  /** update single row of the table: "ground_asset_networks" */
  update_ground_asset_networks_by_pk?: Maybe<Ground_Asset_Networks>;
  /** update data of the table: "ground_asset_status_values" */
  update_ground_asset_status_values?: Maybe<Ground_Asset_Status_Values_Mutation_Response>;
  /** update single row of the table: "ground_asset_status_values" */
  update_ground_asset_status_values_by_pk?: Maybe<Ground_Asset_Status_Values>;
  /** update data of the table: "ground_assets" */
  update_ground_assets?: Maybe<Ground_Assets_Mutation_Response>;
  /** update single row of the table: "ground_assets" */
  update_ground_assets_by_pk?: Maybe<Ground_Assets>;
  /** update data of the table: "ground_control_workflow_state_processing_statuses" */
  update_ground_control_workflow_state_processing_statuses?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Mutation_Response>;
  /** update single row of the table: "ground_control_workflow_state_processing_statuses" */
  update_ground_control_workflow_state_processing_statuses_by_pk?: Maybe<Ground_Control_Workflow_State_Processing_Statuses>;
  /** update data of the table: "historical_serialized_ground_asset_statuses" */
  update_historical_serialized_ground_asset_statuses?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Mutation_Response>;
  /** update single row of the table: "historical_serialized_ground_asset_statuses" */
  update_historical_serialized_ground_asset_statuses_by_pk?: Maybe<Historical_Serialized_Ground_Asset_Statuses>;
  /** update data of the table: "historical_serialized_vehicle_statuses" */
  update_historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Mutation_Response>;
  /** update single row of the table: "historical_serialized_vehicle_statuses" */
  update_historical_serialized_vehicle_statuses_by_pk?: Maybe<Historical_Serialized_Vehicle_Statuses>;
  /** update data of the table: "historical_vehicle_positions" */
  update_historical_vehicle_positions?: Maybe<Historical_Vehicle_Positions_Mutation_Response>;
  /** update single row of the table: "historical_vehicle_positions" */
  update_historical_vehicle_positions_by_pk?: Maybe<Historical_Vehicle_Positions>;
  /** update data of the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  update_kafka_air_traffic_vehicle_flight_proximity_recordings?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Mutation_Response>;
  /** update single row of the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  update_kafka_air_traffic_vehicle_flight_proximity_recordings_by_pk?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** update data of the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  update_kafka_cached_air_traffic_flight_proximity_recordings?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Mutation_Response>;
  /** update single row of the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  update_kafka_cached_air_traffic_flight_proximity_recordings_by_pk?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** update data of the table: "kafka_mqtt_vehicle_status_messages" */
  update_kafka_mqtt_vehicle_status_messages?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Mutation_Response>;
  /** update single row of the table: "kafka_mqtt_vehicle_status_messages" */
  update_kafka_mqtt_vehicle_status_messages_by_pk?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** update data of the table: "kafka_serialized_ground_asset_statuses" */
  update_kafka_serialized_ground_asset_statuses?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Mutation_Response>;
  /** update single row of the table: "kafka_serialized_ground_asset_statuses" */
  update_kafka_serialized_ground_asset_statuses_by_pk?: Maybe<Kafka_Serialized_Ground_Asset_Statuses>;
  /** update single row of the table: "kafka_serialized_vehicle_statuses" */
  update_kafka_serialized_vehicle_statuses_by_pk?: Maybe<Kafka_Serialized_Vehicle_Statuses>;
  /** update data of the table: "landing_request_statuses" */
  update_landing_request_statuses?: Maybe<Landing_Request_Statuses_Mutation_Response>;
  /** update single row of the table: "landing_request_statuses" */
  update_landing_request_statuses_by_pk?: Maybe<Landing_Request_Statuses>;
  /** update data of the table: "landing_requests" */
  update_landing_requests?: Maybe<Landing_Requests_Mutation_Response>;
  /** update single row of the table: "landing_requests" */
  update_landing_requests_by_pk?: Maybe<Landing_Requests>;
  /** update data of the table: "last_vehicle_anomaly_statuses" */
  update_last_vehicle_anomaly_statuses?: Maybe<Last_Vehicle_Anomaly_Statuses_Mutation_Response>;
  /** update single row of the table: "last_vehicle_anomaly_statuses" */
  update_last_vehicle_anomaly_statuses_by_pk?: Maybe<Last_Vehicle_Anomaly_Statuses>;
  /** update data of the table: "manifest_events" */
  update_manifest_events?: Maybe<Manifest_Events_Mutation_Response>;
  /** update single row of the table: "manifest_events" */
  update_manifest_events_by_pk?: Maybe<Manifest_Events>;
  /** update data of the table: "manifest_items" */
  update_manifest_items?: Maybe<Manifest_Items_Mutation_Response>;
  /** update single row of the table: "manifest_items" */
  update_manifest_items_by_pk?: Maybe<Manifest_Items>;
  /** update data of the table: "manifest_products" */
  update_manifest_products?: Maybe<Manifest_Products_Mutation_Response>;
  /** update single row of the table: "manifest_products" */
  update_manifest_products_by_pk?: Maybe<Manifest_Products>;
  /** update data of the table: "manifest_status_audits" */
  update_manifest_status_audits?: Maybe<Manifest_Status_Audits_Mutation_Response>;
  /** update single row of the table: "manifest_status_audits" */
  update_manifest_status_audits_by_pk?: Maybe<Manifest_Status_Audits>;
  /** update data of the table: "manifest_types" */
  update_manifest_types?: Maybe<Manifest_Types_Mutation_Response>;
  /** update single row of the table: "manifest_types" */
  update_manifest_types_by_pk?: Maybe<Manifest_Types>;
  /** update data of the table: "manifests" */
  update_manifests?: Maybe<Manifests_Mutation_Response>;
  /** update data of the table: "manifests_arrived_within_minute" */
  update_manifests_arrived_within_minute?: Maybe<Manifests_Arrived_Within_Minute_Mutation_Response>;
  /** update single row of the table: "manifests" */
  update_manifests_by_pk?: Maybe<Manifests>;
  /** update data of the table: "network_utm_providers" */
  update_network_utm_providers?: Maybe<Network_Utm_Providers_Mutation_Response>;
  /** update single row of the table: "network_utm_providers" */
  update_network_utm_providers_by_pk?: Maybe<Network_Utm_Providers>;
  /** update data of the table: "networks" */
  update_networks?: Maybe<Networks_Mutation_Response>;
  /** update single row of the table: "networks" */
  update_networks_by_pk?: Maybe<Networks>;
  /** update data of the table: "organizations" */
  update_organizations?: Maybe<Organizations_Mutation_Response>;
  /** update single row of the table: "organizations" */
  update_organizations_by_pk?: Maybe<Organizations>;
  /** update data of the table: "paths" */
  update_paths?: Maybe<Paths_Mutation_Response>;
  /** update single row of the table: "paths" */
  update_paths_by_pk?: Maybe<Paths>;
  /** update data of the table: "pickup_requests" */
  update_pickup_requests?: Maybe<Pickup_Requests_Mutation_Response>;
  /** update single row of the table: "pickup_requests" */
  update_pickup_requests_by_pk?: Maybe<Pickup_Requests>;
  /** update data of the table: "positive_exchange_of_flight_control_requests" */
  update_positive_exchange_of_flight_control_requests?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Mutation_Response>;
  /** update single row of the table: "positive_exchange_of_flight_control_requests" */
  update_positive_exchange_of_flight_control_requests_by_pk?: Maybe<Positive_Exchange_Of_Flight_Control_Requests>;
  /** update data of the table: "predicted_conflicts" */
  update_predicted_conflicts?: Maybe<Predicted_Conflicts_Mutation_Response>;
  /** update single row of the table: "predicted_conflicts" */
  update_predicted_conflicts_by_pk?: Maybe<Predicted_Conflicts>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update data of the table: "spatial_ref_sys" */
  update_spatial_ref_sys?: Maybe<Spatial_Ref_Sys_Mutation_Response>;
  /** update single row of the table: "spatial_ref_sys" */
  update_spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** update data of the table: "squawk_severities" */
  update_squawk_severities?: Maybe<Squawk_Severities_Mutation_Response>;
  /** update single row of the table: "squawk_severities" */
  update_squawk_severities_by_pk?: Maybe<Squawk_Severities>;
  /** update data of the table: "squawk_squawkable_types" */
  update_squawk_squawkable_types?: Maybe<Squawk_Squawkable_Types_Mutation_Response>;
  /** update single row of the table: "squawk_squawkable_types" */
  update_squawk_squawkable_types_by_pk?: Maybe<Squawk_Squawkable_Types>;
  /** update data of the table: "squawk_statuses" */
  update_squawk_statuses?: Maybe<Squawk_Statuses_Mutation_Response>;
  /** update single row of the table: "squawk_statuses" */
  update_squawk_statuses_by_pk?: Maybe<Squawk_Statuses>;
  /** update data of the table: "squawks" */
  update_squawks?: Maybe<Squawks_Mutation_Response>;
  /** update single row of the table: "squawks" */
  update_squawks_by_pk?: Maybe<Squawks>;
  /** update data of the table: "stations" */
  update_stations?: Maybe<Stations_Mutation_Response>;
  /** update single row of the table: "stations" */
  update_stations_by_pk?: Maybe<Stations>;
  /** update data of the table: "tenants" */
  update_tenants?: Maybe<Tenants_Mutation_Response>;
  /** update single row of the table: "tenants" */
  update_tenants_by_pk?: Maybe<Tenants>;
  /** update data of the table: "type_cert_flight_analysis_data" */
  update_type_cert_flight_analysis_data?: Maybe<Type_Cert_Flight_Analysis_Data_Mutation_Response>;
  /** update single row of the table: "type_cert_flight_analysis_data" */
  update_type_cert_flight_analysis_data_by_pk?: Maybe<Type_Cert_Flight_Analysis_Data>;
  /** update data of the table: "type_cert_manual_data" */
  update_type_cert_manual_data?: Maybe<Type_Cert_Manual_Data_Mutation_Response>;
  /** update single row of the table: "type_cert_manual_data" */
  update_type_cert_manual_data_by_pk?: Maybe<Type_Cert_Manual_Data>;
  /** update data of the table: "user_app_states" */
  update_user_app_states?: Maybe<User_App_States_Mutation_Response>;
  /** update data of the table: "user_networks" */
  update_user_networks?: Maybe<User_Networks_Mutation_Response>;
  /** update single row of the table: "user_networks" */
  update_user_networks_by_pk?: Maybe<User_Networks>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<User_Roles>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "vehicle_airworthiness_categories" */
  update_vehicle_airworthiness_categories?: Maybe<Vehicle_Airworthiness_Categories_Mutation_Response>;
  /** update single row of the table: "vehicle_airworthiness_categories" */
  update_vehicle_airworthiness_categories_by_pk?: Maybe<Vehicle_Airworthiness_Categories>;
  /** update data of the table: "vehicle_alerts" */
  update_vehicle_alerts?: Maybe<Vehicle_Alerts_Mutation_Response>;
  /** update single row of the table: "vehicle_alerts" */
  update_vehicle_alerts_by_pk?: Maybe<Vehicle_Alerts>;
  /** update data of the table: "vehicle_flight_state_enum" */
  update_vehicle_flight_state_enum?: Maybe<Vehicle_Flight_State_Enum_Mutation_Response>;
  /** update single row of the table: "vehicle_flight_state_enum" */
  update_vehicle_flight_state_enum_by_pk?: Maybe<Vehicle_Flight_State_Enum>;
  /** update data of the table: "vehicle_flight_statuses" */
  update_vehicle_flight_statuses?: Maybe<Vehicle_Flight_Statuses_Mutation_Response>;
  /** update single row of the table: "vehicle_flight_statuses" */
  update_vehicle_flight_statuses_by_pk?: Maybe<Vehicle_Flight_Statuses>;
  /** update data of the table: "vehicle_model_parameter_types" */
  update_vehicle_model_parameter_types?: Maybe<Vehicle_Model_Parameter_Types_Mutation_Response>;
  /** update single row of the table: "vehicle_model_parameter_types" */
  update_vehicle_model_parameter_types_by_pk?: Maybe<Vehicle_Model_Parameter_Types>;
  /** update data of the table: "vehicle_model_parameters" */
  update_vehicle_model_parameters?: Maybe<Vehicle_Model_Parameters_Mutation_Response>;
  /** update single row of the table: "vehicle_model_parameters" */
  update_vehicle_model_parameters_by_pk?: Maybe<Vehicle_Model_Parameters>;
  /** update data of the table: "vehicle_models" */
  update_vehicle_models?: Maybe<Vehicle_Models_Mutation_Response>;
  /** update data of the table: "vehicle_models_ancestors" */
  update_vehicle_models_ancestors?: Maybe<Vehicle_Models_Ancestors_Mutation_Response>;
  /** update single row of the table: "vehicle_models_ancestors" */
  update_vehicle_models_ancestors_by_pk?: Maybe<Vehicle_Models_Ancestors>;
  /** update single row of the table: "vehicle_models" */
  update_vehicle_models_by_pk?: Maybe<Vehicle_Models>;
  /** update data of the table: "vehicle_networks" */
  update_vehicle_networks?: Maybe<Vehicle_Networks_Mutation_Response>;
  /** update single row of the table: "vehicle_networks" */
  update_vehicle_networks_by_pk?: Maybe<Vehicle_Networks>;
  /** update data of the table: "vehicle_pilot_assignments" */
  update_vehicle_pilot_assignments?: Maybe<Vehicle_Pilot_Assignments_Mutation_Response>;
  /** update single row of the table: "vehicle_pilot_assignments" */
  update_vehicle_pilot_assignments_by_pk?: Maybe<Vehicle_Pilot_Assignments>;
  /** update data of the table: "vehicle_priority_event_keys" */
  update_vehicle_priority_event_keys?: Maybe<Vehicle_Priority_Event_Keys_Mutation_Response>;
  /** update single row of the table: "vehicle_priority_event_keys" */
  update_vehicle_priority_event_keys_by_pk?: Maybe<Vehicle_Priority_Event_Keys>;
  /** update data of the table: "vehicle_priority_events" */
  update_vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Mutation_Response>;
  /** update single row of the table: "vehicle_priority_events" */
  update_vehicle_priority_events_by_pk?: Maybe<Vehicle_Priority_Events>;
  /** update data of the table: "vehicle_status_updates" */
  update_vehicle_status_updates?: Maybe<Vehicle_Status_Updates_Mutation_Response>;
  /** update single row of the table: "vehicle_status_updates" */
  update_vehicle_status_updates_by_pk?: Maybe<Vehicle_Status_Updates>;
  /** update data of the table: "kafka_serialized_vehicle_statuses" */
  update_vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Mutation_Response>;
  /** update data of the table: "vehicles" */
  update_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** update single row of the table: "vehicles" */
  update_vehicles_by_pk?: Maybe<Vehicles>;
  /** perform the action: "upsertTypeCertManualData" */
  upsertTypeCertManualData?: Maybe<TypeCertManualDataOutput>;
  /** perform the action: "upsertTypeCertManualDataAndWeatherObservation" */
  upsertTypeCertManualDataAndWeatherObservation?: Maybe<TypeCertManualDataAndWeatherObservationOutput>;
  /** perform the action: "upsertWeatherObservation" */
  upsertWeatherObservation?: Maybe<WeatherObservationOutput>;
};


/** mutation root */
export type Mutation_RootAcknowledgePriorityEventArgs = {
  input: PriorityEventInput;
};


/** mutation root */
export type Mutation_RootAddUsersToNetworkArgs = {
  input: AddUsersToNetworkInput;
};


/** mutation root */
export type Mutation_RootAssignGroundAssetsToNetworkArgs = {
  input: AssignGroundAssetsToNetworkInput;
};


/** mutation root */
export type Mutation_RootAssignPilotsToVehicleArgs = {
  input: VehiclePilotAssignmentsInput;
};


/** mutation root */
export type Mutation_RootAssignPrimaryAndBackupPilotsToVehicleArgs = {
  input: AssignPrimaryAndBackupPilotsToVehicleInput;
};


/** mutation root */
export type Mutation_RootAssignVehiclesToNetworkArgs = {
  input: AssignVehiclesToNetworkInput;
};


/** mutation root */
export type Mutation_RootClaimManifestArgs = {
  input: ClaimManifestInput;
};


/** mutation root */
export type Mutation_RootCreateManifestArgs = {
  input: CreateManifestInput;
};


/** mutation root */
export type Mutation_RootCreateNetworkArgs = {
  input: CreateNetworkInput;
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  input: CreateUserInput;
};


/** mutation root */
export type Mutation_RootDeactivateUserArgs = {
  input: DeactivateUserInput;
};


/** mutation root */
export type Mutation_RootDeleteManifestArgs = {
  input: DeleteManifestInput;
};


/** mutation root */
export type Mutation_RootDelete_Air_Traffic_Deconfliction_Algorithm_TypesArgs = {
  where: Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Air_Traffic_Deconfliction_Algorithm_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Air_Traffic_Monitor_TasksArgs = {
  where: Air_Traffic_Monitor_Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Air_Traffic_Monitor_Tasks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Air_Traffic_TracksArgs = {
  where: Air_Traffic_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Air_Traffic_Tracks_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Aircraft_Type_DesignatorsArgs = {
  where: Aircraft_Type_Designators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Aircraft_Type_Designators_By_PkArgs = {
  designator: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_AirspacesArgs = {
  where: Airspaces_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Airspaces_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Available_Aircraft_Command_SetsArgs = {
  where: Available_Aircraft_Command_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Available_Aircraft_Command_Sets_By_PkArgs = {
  aircraft_serial_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Available_Aircraft_Command_State_KeysArgs = {
  where: Available_Aircraft_Command_State_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Available_Aircraft_Command_State_Keys_By_PkArgs = {
  state_key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Badge_TokensArgs = {
  where: Badge_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Badge_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BatteriesArgs = {
  where: Batteries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Batteries_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Contingency_Landing_SpotsArgs = {
  where: Contingency_Landing_Spots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contingency_Landing_Spots_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Current_Air_Traffic_Proximity_RecordingsArgs = {
  where: Current_Air_Traffic_Proximity_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Current_Air_Traffic_TracksArgs = {
  where: Current_Air_Traffic_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Daa_ObservationsArgs = {
  where: Daa_Observations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Daa_Observations_By_PkArgs = {
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Daa_StatusesArgs = {
  where: Daa_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Daa_Statuses_By_PkArgs = {
  vehicle_serial_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Env_Feature_FlagsArgs = {
  where: Env_Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Env_Feature_Flags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_File_Asset_TypesArgs = {
  where: File_Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Asset_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_File_AssetsArgs = {
  where: File_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_CommandsArgs = {
  where: Flight_Commands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Commands_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_Derivation_ReportsArgs = {
  where: Flight_Derivation_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Derivation_Reports_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plan_Pilot_AssignmentsArgs = {
  where: Flight_Plan_Pilot_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plan_Pilot_Assignments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plan_StatusesArgs = {
  where: Flight_Plan_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plan_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plan_Utm_ProvidersArgs = {
  where: Flight_Plan_Utm_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plan_Utm_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_PlansArgs = {
  where: Flight_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_RoutesArgs = {
  where: Flight_Routes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Routes_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Flight_Weather_DataArgs = {
  where: Flight_Weather_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Flight_Weather_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_CommandsArgs = {
  where: Ground_Asset_Commands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Commands_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Model_Parameter_TypesArgs = {
  where: Ground_Asset_Model_Parameter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Model_Parameter_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Model_ParametersArgs = {
  where: Ground_Asset_Model_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Model_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Model_TypesArgs = {
  where: Ground_Asset_Model_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Model_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_ModelsArgs = {
  where: Ground_Asset_Models_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Models_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_NetworksArgs = {
  where: Ground_Asset_Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Networks_By_PkArgs = {
  ground_asset_id: Scalars['Int'];
  network_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Status_ValuesArgs = {
  where: Ground_Asset_Status_Values_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Asset_Status_Values_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_AssetsArgs = {
  where: Ground_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ground_Control_Workflow_State_Processing_StatusesArgs = {
  where: Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ground_Control_Workflow_State_Processing_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Historical_Serialized_Ground_Asset_StatusesArgs = {
  where: Historical_Serialized_Ground_Asset_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Historical_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Historical_Serialized_Vehicle_StatusesArgs = {
  where: Historical_Serialized_Vehicle_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Historical_Serialized_Vehicle_Statuses_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Historical_Vehicle_PositionsArgs = {
  where: Historical_Vehicle_Positions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Historical_Vehicle_Positions_By_PkArgs = {
  serial_number: Scalars['String'];
  timestamp_secs: Scalars['float8'];
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Air_Traffic_Vehicle_Flight_Proximity_RecordingsArgs = {
  where: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Cached_Air_Traffic_Flight_Proximity_RecordingsArgs = {
  where: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Mqtt_Vehicle_Status_MessagesArgs = {
  where: Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Mqtt_Vehicle_Status_Messages_By_PkArgs = {
  serial_number: Scalars['String'];
  timestamp: Scalars['float8'];
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Serialized_Ground_Asset_StatusesArgs = {
  where: Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  topic: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Kafka_Serialized_Vehicle_Statuses_By_PkArgs = {
  topic: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Landing_Request_StatusesArgs = {
  where: Landing_Request_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Landing_Request_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Landing_RequestsArgs = {
  where: Landing_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Landing_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Last_Vehicle_Anomaly_StatusesArgs = {
  where: Last_Vehicle_Anomaly_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Last_Vehicle_Anomaly_Statuses_By_PkArgs = {
  vehicle_serial_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Manifest_EventsArgs = {
  where: Manifest_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifest_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Manifest_ItemsArgs = {
  where: Manifest_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifest_Items_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Manifest_ProductsArgs = {
  where: Manifest_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifest_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Manifest_Status_AuditsArgs = {
  where: Manifest_Status_Audits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifest_Status_Audits_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Manifest_TypesArgs = {
  where: Manifest_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifest_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ManifestsArgs = {
  where: Manifests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifests_Arrived_Within_MinuteArgs = {
  where: Manifests_Arrived_Within_Minute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manifests_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Network_Utm_ProvidersArgs = {
  where: Network_Utm_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Network_Utm_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_NetworksArgs = {
  where: Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Networks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationsArgs = {
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_By_PkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PathsArgs = {
  where: Paths_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Paths_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Pickup_RequestsArgs = {
  where: Pickup_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pickup_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Positive_Exchange_Of_Flight_Control_RequestsArgs = {
  where: Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Positive_Exchange_Of_Flight_Control_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Predicted_ConflictsArgs = {
  where: Predicted_Conflicts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Predicted_Conflicts_By_PkArgs = {
  alert_level: Scalars['String'];
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_SysArgs = {
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Spatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Squawk_SeveritiesArgs = {
  where: Squawk_Severities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Squawk_Severities_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Squawk_Squawkable_TypesArgs = {
  where: Squawk_Squawkable_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Squawk_Squawkable_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Squawk_StatusesArgs = {
  where: Squawk_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Squawk_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_SquawksArgs = {
  where: Squawks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Squawks_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_StationsArgs = {
  where: Stations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TenantsArgs = {
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tenants_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Type_Cert_Flight_Analysis_DataArgs = {
  where: Type_Cert_Flight_Analysis_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Type_Cert_Flight_Analysis_Data_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Type_Cert_Manual_DataArgs = {
  where: Type_Cert_Manual_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Type_Cert_Manual_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_App_StatesArgs = {
  where: User_App_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_NetworksArgs = {
  where: User_Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Networks_By_PkArgs = {
  network_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_RolesArgs = {
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Roles_By_PkArgs = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Airworthiness_CategoriesArgs = {
  where: Vehicle_Airworthiness_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Airworthiness_Categories_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_AlertsArgs = {
  where: Vehicle_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Alerts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Flight_State_EnumArgs = {
  where: Vehicle_Flight_State_Enum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Flight_State_Enum_By_PkArgs = {
  state: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Flight_StatusesArgs = {
  where: Vehicle_Flight_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Flight_Statuses_By_PkArgs = {
  serial_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Model_Parameter_TypesArgs = {
  where: Vehicle_Model_Parameter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Model_Parameter_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Model_ParametersArgs = {
  where: Vehicle_Model_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Model_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_ModelsArgs = {
  where: Vehicle_Models_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Models_AncestorsArgs = {
  where: Vehicle_Models_Ancestors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Models_Ancestors_By_PkArgs = {
  ancestor_id: Scalars['Int'];
  vehicle_model_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Models_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_NetworksArgs = {
  where: Vehicle_Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Networks_By_PkArgs = {
  network_id: Scalars['Int'];
  vehicle_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Pilot_AssignmentsArgs = {
  where: Vehicle_Pilot_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Pilot_Assignments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Priority_Event_KeysArgs = {
  where: Vehicle_Priority_Event_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Priority_Event_Keys_By_PkArgs = {
  event_key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Priority_EventsArgs = {
  where: Vehicle_Priority_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Priority_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Status_UpdatesArgs = {
  where: Vehicle_Status_Updates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_Status_Updates_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vehicle_StatusesArgs = {
  where: Kafka_Serialized_Vehicle_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_VehiclesArgs = {
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicles_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_Air_Traffic_Deconfliction_Algorithm_TypesArgs = {
  objects: Array<Air_Traffic_Deconfliction_Algorithm_Types_Insert_Input>;
  on_conflict?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Air_Traffic_Deconfliction_Algorithm_Types_OneArgs = {
  object: Air_Traffic_Deconfliction_Algorithm_Types_Insert_Input;
  on_conflict?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Air_Traffic_Monitor_TasksArgs = {
  objects: Array<Air_Traffic_Monitor_Tasks_Insert_Input>;
  on_conflict?: Maybe<Air_Traffic_Monitor_Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Air_Traffic_Monitor_Tasks_OneArgs = {
  object: Air_Traffic_Monitor_Tasks_Insert_Input;
  on_conflict?: Maybe<Air_Traffic_Monitor_Tasks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Air_Traffic_TracksArgs = {
  objects: Array<Air_Traffic_Tracks_Insert_Input>;
  on_conflict?: Maybe<Air_Traffic_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Air_Traffic_Tracks_OneArgs = {
  object: Air_Traffic_Tracks_Insert_Input;
  on_conflict?: Maybe<Air_Traffic_Tracks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Aircraft_Type_DesignatorsArgs = {
  objects: Array<Aircraft_Type_Designators_Insert_Input>;
  on_conflict?: Maybe<Aircraft_Type_Designators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Aircraft_Type_Designators_OneArgs = {
  object: Aircraft_Type_Designators_Insert_Input;
  on_conflict?: Maybe<Aircraft_Type_Designators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AirspacesArgs = {
  objects: Array<Airspaces_Insert_Input>;
  on_conflict?: Maybe<Airspaces_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Airspaces_OneArgs = {
  object: Airspaces_Insert_Input;
  on_conflict?: Maybe<Airspaces_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Available_Aircraft_Command_SetsArgs = {
  objects: Array<Available_Aircraft_Command_Sets_Insert_Input>;
  on_conflict?: Maybe<Available_Aircraft_Command_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Available_Aircraft_Command_Sets_OneArgs = {
  object: Available_Aircraft_Command_Sets_Insert_Input;
  on_conflict?: Maybe<Available_Aircraft_Command_Sets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Available_Aircraft_Command_State_KeysArgs = {
  objects: Array<Available_Aircraft_Command_State_Keys_Insert_Input>;
  on_conflict?: Maybe<Available_Aircraft_Command_State_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Available_Aircraft_Command_State_Keys_OneArgs = {
  object: Available_Aircraft_Command_State_Keys_Insert_Input;
  on_conflict?: Maybe<Available_Aircraft_Command_State_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Badge_TokensArgs = {
  objects: Array<Badge_Tokens_Insert_Input>;
  on_conflict?: Maybe<Badge_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Badge_Tokens_OneArgs = {
  object: Badge_Tokens_Insert_Input;
  on_conflict?: Maybe<Badge_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BatteriesArgs = {
  objects: Array<Batteries_Insert_Input>;
  on_conflict?: Maybe<Batteries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Batteries_OneArgs = {
  object: Batteries_Insert_Input;
  on_conflict?: Maybe<Batteries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contingency_Landing_SpotsArgs = {
  objects: Array<Contingency_Landing_Spots_Insert_Input>;
  on_conflict?: Maybe<Contingency_Landing_Spots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contingency_Landing_Spots_OneArgs = {
  object: Contingency_Landing_Spots_Insert_Input;
  on_conflict?: Maybe<Contingency_Landing_Spots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Current_Air_Traffic_Proximity_RecordingsArgs = {
  objects: Array<Current_Air_Traffic_Proximity_Recordings_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Current_Air_Traffic_Proximity_Recordings_OneArgs = {
  object: Current_Air_Traffic_Proximity_Recordings_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Current_Air_Traffic_TracksArgs = {
  objects: Array<Current_Air_Traffic_Tracks_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Current_Air_Traffic_Tracks_OneArgs = {
  object: Current_Air_Traffic_Tracks_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Daa_ObservationsArgs = {
  objects: Array<Daa_Observations_Insert_Input>;
  on_conflict?: Maybe<Daa_Observations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daa_Observations_OneArgs = {
  object: Daa_Observations_Insert_Input;
  on_conflict?: Maybe<Daa_Observations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daa_StatusesArgs = {
  objects: Array<Daa_Statuses_Insert_Input>;
  on_conflict?: Maybe<Daa_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Daa_Statuses_OneArgs = {
  object: Daa_Statuses_Insert_Input;
  on_conflict?: Maybe<Daa_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Env_Feature_FlagsArgs = {
  objects: Array<Env_Feature_Flags_Insert_Input>;
  on_conflict?: Maybe<Env_Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Env_Feature_Flags_OneArgs = {
  object: Env_Feature_Flags_Insert_Input;
  on_conflict?: Maybe<Env_Feature_Flags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Asset_TypesArgs = {
  objects: Array<File_Asset_Types_Insert_Input>;
  on_conflict?: Maybe<File_Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Asset_Types_OneArgs = {
  object: File_Asset_Types_Insert_Input;
  on_conflict?: Maybe<File_Asset_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_AssetsArgs = {
  objects: Array<File_Assets_Insert_Input>;
  on_conflict?: Maybe<File_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_Assets_OneArgs = {
  object: File_Assets_Insert_Input;
  on_conflict?: Maybe<File_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_CommandsArgs = {
  objects: Array<Flight_Commands_Insert_Input>;
  on_conflict?: Maybe<Flight_Commands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Commands_OneArgs = {
  object: Flight_Commands_Insert_Input;
  on_conflict?: Maybe<Flight_Commands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Derivation_ReportsArgs = {
  objects: Array<Flight_Derivation_Reports_Insert_Input>;
  on_conflict?: Maybe<Flight_Derivation_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Derivation_Reports_OneArgs = {
  object: Flight_Derivation_Reports_Insert_Input;
  on_conflict?: Maybe<Flight_Derivation_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plan_Pilot_AssignmentsArgs = {
  objects: Array<Flight_Plan_Pilot_Assignments_Insert_Input>;
  on_conflict?: Maybe<Flight_Plan_Pilot_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plan_Pilot_Assignments_OneArgs = {
  object: Flight_Plan_Pilot_Assignments_Insert_Input;
  on_conflict?: Maybe<Flight_Plan_Pilot_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plan_StatusesArgs = {
  objects: Array<Flight_Plan_Statuses_Insert_Input>;
  on_conflict?: Maybe<Flight_Plan_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plan_Statuses_OneArgs = {
  object: Flight_Plan_Statuses_Insert_Input;
  on_conflict?: Maybe<Flight_Plan_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plan_Utm_ProvidersArgs = {
  objects: Array<Flight_Plan_Utm_Providers_Insert_Input>;
  on_conflict?: Maybe<Flight_Plan_Utm_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plan_Utm_Providers_OneArgs = {
  object: Flight_Plan_Utm_Providers_Insert_Input;
  on_conflict?: Maybe<Flight_Plan_Utm_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_PlansArgs = {
  objects: Array<Flight_Plans_Insert_Input>;
  on_conflict?: Maybe<Flight_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Plans_OneArgs = {
  object: Flight_Plans_Insert_Input;
  on_conflict?: Maybe<Flight_Plans_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_RoutesArgs = {
  objects: Array<Flight_Routes_Insert_Input>;
  on_conflict?: Maybe<Flight_Routes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Routes_OneArgs = {
  object: Flight_Routes_Insert_Input;
  on_conflict?: Maybe<Flight_Routes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Weather_DataArgs = {
  objects: Array<Flight_Weather_Data_Insert_Input>;
  on_conflict?: Maybe<Flight_Weather_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Flight_Weather_Data_OneArgs = {
  object: Flight_Weather_Data_Insert_Input;
  on_conflict?: Maybe<Flight_Weather_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_CommandsArgs = {
  objects: Array<Ground_Asset_Commands_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Commands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Commands_OneArgs = {
  object: Ground_Asset_Commands_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Commands_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Model_Parameter_TypesArgs = {
  objects: Array<Ground_Asset_Model_Parameter_Types_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Model_Parameter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Model_Parameter_Types_OneArgs = {
  object: Ground_Asset_Model_Parameter_Types_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Model_Parameter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Model_ParametersArgs = {
  objects: Array<Ground_Asset_Model_Parameters_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Model_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Model_Parameters_OneArgs = {
  object: Ground_Asset_Model_Parameters_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Model_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Model_TypesArgs = {
  objects: Array<Ground_Asset_Model_Types_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Model_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Model_Types_OneArgs = {
  object: Ground_Asset_Model_Types_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Model_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_ModelsArgs = {
  objects: Array<Ground_Asset_Models_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Models_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Models_OneArgs = {
  object: Ground_Asset_Models_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Models_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_NetworksArgs = {
  objects: Array<Ground_Asset_Networks_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Networks_OneArgs = {
  object: Ground_Asset_Networks_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Status_ValuesArgs = {
  objects: Array<Ground_Asset_Status_Values_Insert_Input>;
  on_conflict?: Maybe<Ground_Asset_Status_Values_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Asset_Status_Values_OneArgs = {
  object: Ground_Asset_Status_Values_Insert_Input;
  on_conflict?: Maybe<Ground_Asset_Status_Values_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_AssetsArgs = {
  objects: Array<Ground_Assets_Insert_Input>;
  on_conflict?: Maybe<Ground_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Assets_OneArgs = {
  object: Ground_Assets_Insert_Input;
  on_conflict?: Maybe<Ground_Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Control_Workflow_State_Processing_StatusesArgs = {
  objects: Array<Ground_Control_Workflow_State_Processing_Statuses_Insert_Input>;
  on_conflict?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ground_Control_Workflow_State_Processing_Statuses_OneArgs = {
  object: Ground_Control_Workflow_State_Processing_Statuses_Insert_Input;
  on_conflict?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historical_Serialized_Ground_Asset_StatusesArgs = {
  objects: Array<Historical_Serialized_Ground_Asset_Statuses_Insert_Input>;
  on_conflict?: Maybe<Historical_Serialized_Ground_Asset_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historical_Serialized_Ground_Asset_Statuses_OneArgs = {
  object: Historical_Serialized_Ground_Asset_Statuses_Insert_Input;
  on_conflict?: Maybe<Historical_Serialized_Ground_Asset_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historical_Serialized_Vehicle_StatusesArgs = {
  objects: Array<Historical_Serialized_Vehicle_Statuses_Insert_Input>;
  on_conflict?: Maybe<Historical_Serialized_Vehicle_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historical_Serialized_Vehicle_Statuses_OneArgs = {
  object: Historical_Serialized_Vehicle_Statuses_Insert_Input;
  on_conflict?: Maybe<Historical_Serialized_Vehicle_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historical_Vehicle_PositionsArgs = {
  objects: Array<Historical_Vehicle_Positions_Insert_Input>;
  on_conflict?: Maybe<Historical_Vehicle_Positions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Historical_Vehicle_Positions_OneArgs = {
  object: Historical_Vehicle_Positions_Insert_Input;
  on_conflict?: Maybe<Historical_Vehicle_Positions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Air_Traffic_Vehicle_Flight_Proximity_RecordingsArgs = {
  objects: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Insert_Input>;
  on_conflict?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_OneArgs = {
  object: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Insert_Input;
  on_conflict?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Cached_Air_Traffic_Flight_Proximity_RecordingsArgs = {
  objects: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Insert_Input>;
  on_conflict?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_OneArgs = {
  object: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Insert_Input;
  on_conflict?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Mqtt_Vehicle_Status_MessagesArgs = {
  objects: Array<Kafka_Mqtt_Vehicle_Status_Messages_Insert_Input>;
  on_conflict?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Mqtt_Vehicle_Status_Messages_OneArgs = {
  object: Kafka_Mqtt_Vehicle_Status_Messages_Insert_Input;
  on_conflict?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Serialized_Ground_Asset_StatusesArgs = {
  objects: Array<Kafka_Serialized_Ground_Asset_Statuses_Insert_Input>;
  on_conflict?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Serialized_Ground_Asset_Statuses_OneArgs = {
  object: Kafka_Serialized_Ground_Asset_Statuses_Insert_Input;
  on_conflict?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Kafka_Serialized_Vehicle_Statuses_OneArgs = {
  object: Kafka_Serialized_Vehicle_Statuses_Insert_Input;
  on_conflict?: Maybe<Kafka_Serialized_Vehicle_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Landing_Request_StatusesArgs = {
  objects: Array<Landing_Request_Statuses_Insert_Input>;
  on_conflict?: Maybe<Landing_Request_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Landing_Request_Statuses_OneArgs = {
  object: Landing_Request_Statuses_Insert_Input;
  on_conflict?: Maybe<Landing_Request_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Landing_RequestsArgs = {
  objects: Array<Landing_Requests_Insert_Input>;
  on_conflict?: Maybe<Landing_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Landing_Requests_OneArgs = {
  object: Landing_Requests_Insert_Input;
  on_conflict?: Maybe<Landing_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Last_Vehicle_Anomaly_StatusesArgs = {
  objects: Array<Last_Vehicle_Anomaly_Statuses_Insert_Input>;
  on_conflict?: Maybe<Last_Vehicle_Anomaly_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Last_Vehicle_Anomaly_Statuses_OneArgs = {
  object: Last_Vehicle_Anomaly_Statuses_Insert_Input;
  on_conflict?: Maybe<Last_Vehicle_Anomaly_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_EventsArgs = {
  objects: Array<Manifest_Events_Insert_Input>;
  on_conflict?: Maybe<Manifest_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_Events_OneArgs = {
  object: Manifest_Events_Insert_Input;
  on_conflict?: Maybe<Manifest_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_ItemsArgs = {
  objects: Array<Manifest_Items_Insert_Input>;
  on_conflict?: Maybe<Manifest_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_Items_OneArgs = {
  object: Manifest_Items_Insert_Input;
  on_conflict?: Maybe<Manifest_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_ProductsArgs = {
  objects: Array<Manifest_Products_Insert_Input>;
  on_conflict?: Maybe<Manifest_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_Products_OneArgs = {
  object: Manifest_Products_Insert_Input;
  on_conflict?: Maybe<Manifest_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_Status_AuditsArgs = {
  objects: Array<Manifest_Status_Audits_Insert_Input>;
  on_conflict?: Maybe<Manifest_Status_Audits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_Status_Audits_OneArgs = {
  object: Manifest_Status_Audits_Insert_Input;
  on_conflict?: Maybe<Manifest_Status_Audits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_TypesArgs = {
  objects: Array<Manifest_Types_Insert_Input>;
  on_conflict?: Maybe<Manifest_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifest_Types_OneArgs = {
  object: Manifest_Types_Insert_Input;
  on_conflict?: Maybe<Manifest_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ManifestsArgs = {
  objects: Array<Manifests_Insert_Input>;
  on_conflict?: Maybe<Manifests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manifests_Arrived_Within_MinuteArgs = {
  objects: Array<Manifests_Arrived_Within_Minute_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Manifests_Arrived_Within_Minute_OneArgs = {
  object: Manifests_Arrived_Within_Minute_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Manifests_OneArgs = {
  object: Manifests_Insert_Input;
  on_conflict?: Maybe<Manifests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Network_Utm_ProvidersArgs = {
  objects: Array<Network_Utm_Providers_Insert_Input>;
  on_conflict?: Maybe<Network_Utm_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Network_Utm_Providers_OneArgs = {
  object: Network_Utm_Providers_Insert_Input;
  on_conflict?: Maybe<Network_Utm_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NetworksArgs = {
  objects: Array<Networks_Insert_Input>;
  on_conflict?: Maybe<Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Networks_OneArgs = {
  object: Networks_Insert_Input;
  on_conflict?: Maybe<Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationsArgs = {
  objects: Array<Organizations_Insert_Input>;
  on_conflict?: Maybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_OneArgs = {
  object: Organizations_Insert_Input;
  on_conflict?: Maybe<Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PathsArgs = {
  objects: Array<Paths_Insert_Input>;
  on_conflict?: Maybe<Paths_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Paths_OneArgs = {
  object: Paths_Insert_Input;
  on_conflict?: Maybe<Paths_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pickup_RequestsArgs = {
  objects: Array<Pickup_Requests_Insert_Input>;
  on_conflict?: Maybe<Pickup_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pickup_Requests_OneArgs = {
  object: Pickup_Requests_Insert_Input;
  on_conflict?: Maybe<Pickup_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Positive_Exchange_Of_Flight_Control_RequestsArgs = {
  objects: Array<Positive_Exchange_Of_Flight_Control_Requests_Insert_Input>;
  on_conflict?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Positive_Exchange_Of_Flight_Control_Requests_OneArgs = {
  object: Positive_Exchange_Of_Flight_Control_Requests_Insert_Input;
  on_conflict?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Predicted_ConflictsArgs = {
  objects: Array<Predicted_Conflicts_Insert_Input>;
  on_conflict?: Maybe<Predicted_Conflicts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Predicted_Conflicts_OneArgs = {
  object: Predicted_Conflicts_Insert_Input;
  on_conflict?: Maybe<Predicted_Conflicts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: Maybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: Maybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_SysArgs = {
  objects: Array<Spatial_Ref_Sys_Insert_Input>;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Spatial_Ref_Sys_OneArgs = {
  object: Spatial_Ref_Sys_Insert_Input;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawk_SeveritiesArgs = {
  objects: Array<Squawk_Severities_Insert_Input>;
  on_conflict?: Maybe<Squawk_Severities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawk_Severities_OneArgs = {
  object: Squawk_Severities_Insert_Input;
  on_conflict?: Maybe<Squawk_Severities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawk_Squawkable_TypesArgs = {
  objects: Array<Squawk_Squawkable_Types_Insert_Input>;
  on_conflict?: Maybe<Squawk_Squawkable_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawk_Squawkable_Types_OneArgs = {
  object: Squawk_Squawkable_Types_Insert_Input;
  on_conflict?: Maybe<Squawk_Squawkable_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawk_StatusesArgs = {
  objects: Array<Squawk_Statuses_Insert_Input>;
  on_conflict?: Maybe<Squawk_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawk_Statuses_OneArgs = {
  object: Squawk_Statuses_Insert_Input;
  on_conflict?: Maybe<Squawk_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SquawksArgs = {
  objects: Array<Squawks_Insert_Input>;
  on_conflict?: Maybe<Squawks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Squawks_OneArgs = {
  object: Squawks_Insert_Input;
  on_conflict?: Maybe<Squawks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StationsArgs = {
  objects: Array<Stations_Insert_Input>;
  on_conflict?: Maybe<Stations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stations_OneArgs = {
  object: Stations_Insert_Input;
  on_conflict?: Maybe<Stations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantsArgs = {
  objects: Array<Tenants_Insert_Input>;
  on_conflict?: Maybe<Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenants_OneArgs = {
  object: Tenants_Insert_Input;
  on_conflict?: Maybe<Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Type_Cert_Flight_Analysis_DataArgs = {
  objects: Array<Type_Cert_Flight_Analysis_Data_Insert_Input>;
  on_conflict?: Maybe<Type_Cert_Flight_Analysis_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Type_Cert_Flight_Analysis_Data_OneArgs = {
  object: Type_Cert_Flight_Analysis_Data_Insert_Input;
  on_conflict?: Maybe<Type_Cert_Flight_Analysis_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Type_Cert_Manual_DataArgs = {
  objects: Array<Type_Cert_Manual_Data_Insert_Input>;
  on_conflict?: Maybe<Type_Cert_Manual_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Type_Cert_Manual_Data_OneArgs = {
  object: Type_Cert_Manual_Data_Insert_Input;
  on_conflict?: Maybe<Type_Cert_Manual_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_App_StatesArgs = {
  objects: Array<User_App_States_Insert_Input>;
  on_conflict?: Maybe<User_App_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_App_States_OneArgs = {
  object: User_App_States_Insert_Input;
  on_conflict?: Maybe<User_App_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_NetworksArgs = {
  objects: Array<User_Networks_Insert_Input>;
  on_conflict?: Maybe<User_Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Networks_OneArgs = {
  object: User_Networks_Insert_Input;
  on_conflict?: Maybe<User_Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RolesArgs = {
  objects: Array<User_Roles_Insert_Input>;
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Roles_OneArgs = {
  object: User_Roles_Insert_Input;
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Airworthiness_CategoriesArgs = {
  objects: Array<Vehicle_Airworthiness_Categories_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Airworthiness_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Airworthiness_Categories_OneArgs = {
  object: Vehicle_Airworthiness_Categories_Insert_Input;
  on_conflict?: Maybe<Vehicle_Airworthiness_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_AlertsArgs = {
  objects: Array<Vehicle_Alerts_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Alerts_OneArgs = {
  object: Vehicle_Alerts_Insert_Input;
  on_conflict?: Maybe<Vehicle_Alerts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Flight_State_EnumArgs = {
  objects: Array<Vehicle_Flight_State_Enum_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Flight_State_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Flight_State_Enum_OneArgs = {
  object: Vehicle_Flight_State_Enum_Insert_Input;
  on_conflict?: Maybe<Vehicle_Flight_State_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Flight_StatusesArgs = {
  objects: Array<Vehicle_Flight_Statuses_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Flight_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Flight_Statuses_OneArgs = {
  object: Vehicle_Flight_Statuses_Insert_Input;
  on_conflict?: Maybe<Vehicle_Flight_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Model_Parameter_TypesArgs = {
  objects: Array<Vehicle_Model_Parameter_Types_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Model_Parameter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Model_Parameter_Types_OneArgs = {
  object: Vehicle_Model_Parameter_Types_Insert_Input;
  on_conflict?: Maybe<Vehicle_Model_Parameter_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Model_ParametersArgs = {
  objects: Array<Vehicle_Model_Parameters_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Model_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Model_Parameters_OneArgs = {
  object: Vehicle_Model_Parameters_Insert_Input;
  on_conflict?: Maybe<Vehicle_Model_Parameters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_ModelsArgs = {
  objects: Array<Vehicle_Models_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Models_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Models_AncestorsArgs = {
  objects: Array<Vehicle_Models_Ancestors_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Models_Ancestors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Models_Ancestors_OneArgs = {
  object: Vehicle_Models_Ancestors_Insert_Input;
  on_conflict?: Maybe<Vehicle_Models_Ancestors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Models_OneArgs = {
  object: Vehicle_Models_Insert_Input;
  on_conflict?: Maybe<Vehicle_Models_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_NetworksArgs = {
  objects: Array<Vehicle_Networks_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Networks_OneArgs = {
  object: Vehicle_Networks_Insert_Input;
  on_conflict?: Maybe<Vehicle_Networks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Pilot_AssignmentsArgs = {
  objects: Array<Vehicle_Pilot_Assignments_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Pilot_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Pilot_Assignments_OneArgs = {
  object: Vehicle_Pilot_Assignments_Insert_Input;
  on_conflict?: Maybe<Vehicle_Pilot_Assignments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Priority_Event_KeysArgs = {
  objects: Array<Vehicle_Priority_Event_Keys_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Priority_Event_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Priority_Event_Keys_OneArgs = {
  object: Vehicle_Priority_Event_Keys_Insert_Input;
  on_conflict?: Maybe<Vehicle_Priority_Event_Keys_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Priority_EventsArgs = {
  objects: Array<Vehicle_Priority_Events_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Priority_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Priority_Events_OneArgs = {
  object: Vehicle_Priority_Events_Insert_Input;
  on_conflict?: Maybe<Vehicle_Priority_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Status_UpdatesArgs = {
  objects: Array<Vehicle_Status_Updates_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Status_Updates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_Status_Updates_OneArgs = {
  object: Vehicle_Status_Updates_Insert_Input;
  on_conflict?: Maybe<Vehicle_Status_Updates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicle_StatusesArgs = {
  objects: Array<Kafka_Serialized_Vehicle_Statuses_Insert_Input>;
  on_conflict?: Maybe<Kafka_Serialized_Vehicle_Statuses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VehiclesArgs = {
  objects: Array<Vehicles_Insert_Input>;
  on_conflict?: Maybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicles_OneArgs = {
  object: Vehicles_Insert_Input;
  on_conflict?: Maybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootIssueAirTrafficSimulationCommandArgs = {
  input: AirTrafficSimulationCommandInput;
};


/** mutation root */
export type Mutation_RootIssueAlternateLandingTypeCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssuePrecisionLandingTypeCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueProceedToSafetyZoneCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueResumePlannedFlightCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleAbortCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleArmCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleCancelMissionCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleDisarmCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleHoldCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleProceedCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleResumeCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootIssueVehicleReturnHomeCommandArgs = {
  commandInput: VehicleCommandInput;
};


/** mutation root */
export type Mutation_RootMarkManifestAsDeliveredArgs = {
  input: MarkManifestAsDeliveredInput;
};


/** mutation root */
export type Mutation_RootRemoveUserFromNetworkArgs = {
  input: RemoveUserFromNetworkInput;
};


/** mutation root */
export type Mutation_RootRequestFlightControlArgs = {
  input: RequestFlightControlInput;
};


/** mutation root */
export type Mutation_RootResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


/** mutation root */
export type Mutation_RootResolveFlightControlRequestArgs = {
  input: ResolveFlightControlRequestInput;
};


/** mutation root */
export type Mutation_RootSimulateAirTrafficConflictArgs = {
  input: SimulateAirTrafficConflictInput;
};


/** mutation root */
export type Mutation_RootSimulateMultipleJitterAirTrafficConflictsArgs = {
  input: SimulateMultipleJitterAirTrafficConflictsInput;
};


/** mutation root */
export type Mutation_RootUnassignAllPilotsFromVehicleArgs = {
  input: UnassignAllPilotsFromVehicleInput;
};


/** mutation root */
export type Mutation_RootUpdateManifestArgs = {
  input: UpdateManifestInput;
};


/** mutation root */
export type Mutation_RootUpdateNetworkNameArgs = {
  input: UpdateNetworkNameInput;
};


/** mutation root */
export type Mutation_RootUpdateNetworkServiceDisabledArgs = {
  input: UpdateNetworkServiceDisabledInput;
};


/** mutation root */
export type Mutation_RootUpdateNetworkUtmEnabledArgs = {
  input: UpdateNetworkUtmEnabledInput;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs = {
  input: UpdateUserInput;
};


/** mutation root */
export type Mutation_RootUpdate_Air_Traffic_Deconfliction_Algorithm_TypesArgs = {
  _set?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Set_Input>;
  where: Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Air_Traffic_Deconfliction_Algorithm_Types_By_PkArgs = {
  _set?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Set_Input>;
  pk_columns: Air_Traffic_Deconfliction_Algorithm_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Air_Traffic_Monitor_TasksArgs = {
  _inc?: Maybe<Air_Traffic_Monitor_Tasks_Inc_Input>;
  _set?: Maybe<Air_Traffic_Monitor_Tasks_Set_Input>;
  where: Air_Traffic_Monitor_Tasks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Air_Traffic_Monitor_Tasks_By_PkArgs = {
  _inc?: Maybe<Air_Traffic_Monitor_Tasks_Inc_Input>;
  _set?: Maybe<Air_Traffic_Monitor_Tasks_Set_Input>;
  pk_columns: Air_Traffic_Monitor_Tasks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Air_Traffic_TracksArgs = {
  _inc?: Maybe<Air_Traffic_Tracks_Inc_Input>;
  _set?: Maybe<Air_Traffic_Tracks_Set_Input>;
  where: Air_Traffic_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Air_Traffic_Tracks_By_PkArgs = {
  _inc?: Maybe<Air_Traffic_Tracks_Inc_Input>;
  _set?: Maybe<Air_Traffic_Tracks_Set_Input>;
  pk_columns: Air_Traffic_Tracks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Aircraft_Type_DesignatorsArgs = {
  _set?: Maybe<Aircraft_Type_Designators_Set_Input>;
  where: Aircraft_Type_Designators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Aircraft_Type_Designators_By_PkArgs = {
  _set?: Maybe<Aircraft_Type_Designators_Set_Input>;
  pk_columns: Aircraft_Type_Designators_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AirspacesArgs = {
  _inc?: Maybe<Airspaces_Inc_Input>;
  _set?: Maybe<Airspaces_Set_Input>;
  where: Airspaces_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Airspaces_By_PkArgs = {
  _inc?: Maybe<Airspaces_Inc_Input>;
  _set?: Maybe<Airspaces_Set_Input>;
  pk_columns: Airspaces_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Available_Aircraft_Command_SetsArgs = {
  _inc?: Maybe<Available_Aircraft_Command_Sets_Inc_Input>;
  _set?: Maybe<Available_Aircraft_Command_Sets_Set_Input>;
  where: Available_Aircraft_Command_Sets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Available_Aircraft_Command_Sets_By_PkArgs = {
  _inc?: Maybe<Available_Aircraft_Command_Sets_Inc_Input>;
  _set?: Maybe<Available_Aircraft_Command_Sets_Set_Input>;
  pk_columns: Available_Aircraft_Command_Sets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Available_Aircraft_Command_State_KeysArgs = {
  _set?: Maybe<Available_Aircraft_Command_State_Keys_Set_Input>;
  where: Available_Aircraft_Command_State_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Available_Aircraft_Command_State_Keys_By_PkArgs = {
  _set?: Maybe<Available_Aircraft_Command_State_Keys_Set_Input>;
  pk_columns: Available_Aircraft_Command_State_Keys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Badge_TokensArgs = {
  _inc?: Maybe<Badge_Tokens_Inc_Input>;
  _set?: Maybe<Badge_Tokens_Set_Input>;
  where: Badge_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Badge_Tokens_By_PkArgs = {
  _inc?: Maybe<Badge_Tokens_Inc_Input>;
  _set?: Maybe<Badge_Tokens_Set_Input>;
  pk_columns: Badge_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BatteriesArgs = {
  _inc?: Maybe<Batteries_Inc_Input>;
  _set?: Maybe<Batteries_Set_Input>;
  where: Batteries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Batteries_By_PkArgs = {
  _inc?: Maybe<Batteries_Inc_Input>;
  _set?: Maybe<Batteries_Set_Input>;
  pk_columns: Batteries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contingency_Landing_SpotsArgs = {
  _inc?: Maybe<Contingency_Landing_Spots_Inc_Input>;
  _set?: Maybe<Contingency_Landing_Spots_Set_Input>;
  where: Contingency_Landing_Spots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contingency_Landing_Spots_By_PkArgs = {
  _inc?: Maybe<Contingency_Landing_Spots_Inc_Input>;
  _set?: Maybe<Contingency_Landing_Spots_Set_Input>;
  pk_columns: Contingency_Landing_Spots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Current_Air_Traffic_Proximity_RecordingsArgs = {
  _inc?: Maybe<Current_Air_Traffic_Proximity_Recordings_Inc_Input>;
  _set?: Maybe<Current_Air_Traffic_Proximity_Recordings_Set_Input>;
  where: Current_Air_Traffic_Proximity_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Current_Air_Traffic_TracksArgs = {
  _inc?: Maybe<Current_Air_Traffic_Tracks_Inc_Input>;
  _set?: Maybe<Current_Air_Traffic_Tracks_Set_Input>;
  where: Current_Air_Traffic_Tracks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Daa_ObservationsArgs = {
  _append?: Maybe<Daa_Observations_Append_Input>;
  _delete_at_path?: Maybe<Daa_Observations_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Daa_Observations_Delete_Elem_Input>;
  _delete_key?: Maybe<Daa_Observations_Delete_Key_Input>;
  _inc?: Maybe<Daa_Observations_Inc_Input>;
  _prepend?: Maybe<Daa_Observations_Prepend_Input>;
  _set?: Maybe<Daa_Observations_Set_Input>;
  where: Daa_Observations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Daa_Observations_By_PkArgs = {
  _append?: Maybe<Daa_Observations_Append_Input>;
  _delete_at_path?: Maybe<Daa_Observations_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Daa_Observations_Delete_Elem_Input>;
  _delete_key?: Maybe<Daa_Observations_Delete_Key_Input>;
  _inc?: Maybe<Daa_Observations_Inc_Input>;
  _prepend?: Maybe<Daa_Observations_Prepend_Input>;
  _set?: Maybe<Daa_Observations_Set_Input>;
  pk_columns: Daa_Observations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Daa_StatusesArgs = {
  _append?: Maybe<Daa_Statuses_Append_Input>;
  _delete_at_path?: Maybe<Daa_Statuses_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Daa_Statuses_Delete_Elem_Input>;
  _delete_key?: Maybe<Daa_Statuses_Delete_Key_Input>;
  _inc?: Maybe<Daa_Statuses_Inc_Input>;
  _prepend?: Maybe<Daa_Statuses_Prepend_Input>;
  _set?: Maybe<Daa_Statuses_Set_Input>;
  where: Daa_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Daa_Statuses_By_PkArgs = {
  _append?: Maybe<Daa_Statuses_Append_Input>;
  _delete_at_path?: Maybe<Daa_Statuses_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Daa_Statuses_Delete_Elem_Input>;
  _delete_key?: Maybe<Daa_Statuses_Delete_Key_Input>;
  _inc?: Maybe<Daa_Statuses_Inc_Input>;
  _prepend?: Maybe<Daa_Statuses_Prepend_Input>;
  _set?: Maybe<Daa_Statuses_Set_Input>;
  pk_columns: Daa_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Env_Feature_FlagsArgs = {
  _inc?: Maybe<Env_Feature_Flags_Inc_Input>;
  _set?: Maybe<Env_Feature_Flags_Set_Input>;
  where: Env_Feature_Flags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Env_Feature_Flags_By_PkArgs = {
  _inc?: Maybe<Env_Feature_Flags_Inc_Input>;
  _set?: Maybe<Env_Feature_Flags_Set_Input>;
  pk_columns: Env_Feature_Flags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_Asset_TypesArgs = {
  _set?: Maybe<File_Asset_Types_Set_Input>;
  where: File_Asset_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Asset_Types_By_PkArgs = {
  _set?: Maybe<File_Asset_Types_Set_Input>;
  pk_columns: File_Asset_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_AssetsArgs = {
  _inc?: Maybe<File_Assets_Inc_Input>;
  _set?: Maybe<File_Assets_Set_Input>;
  where: File_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_Assets_By_PkArgs = {
  _inc?: Maybe<File_Assets_Inc_Input>;
  _set?: Maybe<File_Assets_Set_Input>;
  pk_columns: File_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_CommandsArgs = {
  _inc?: Maybe<Flight_Commands_Inc_Input>;
  _set?: Maybe<Flight_Commands_Set_Input>;
  where: Flight_Commands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Commands_By_PkArgs = {
  _inc?: Maybe<Flight_Commands_Inc_Input>;
  _set?: Maybe<Flight_Commands_Set_Input>;
  pk_columns: Flight_Commands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Derivation_ReportsArgs = {
  _inc?: Maybe<Flight_Derivation_Reports_Inc_Input>;
  _set?: Maybe<Flight_Derivation_Reports_Set_Input>;
  where: Flight_Derivation_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Derivation_Reports_By_PkArgs = {
  _inc?: Maybe<Flight_Derivation_Reports_Inc_Input>;
  _set?: Maybe<Flight_Derivation_Reports_Set_Input>;
  pk_columns: Flight_Derivation_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plan_Pilot_AssignmentsArgs = {
  _inc?: Maybe<Flight_Plan_Pilot_Assignments_Inc_Input>;
  _set?: Maybe<Flight_Plan_Pilot_Assignments_Set_Input>;
  where: Flight_Plan_Pilot_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plan_Pilot_Assignments_By_PkArgs = {
  _inc?: Maybe<Flight_Plan_Pilot_Assignments_Inc_Input>;
  _set?: Maybe<Flight_Plan_Pilot_Assignments_Set_Input>;
  pk_columns: Flight_Plan_Pilot_Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plan_StatusesArgs = {
  _set?: Maybe<Flight_Plan_Statuses_Set_Input>;
  where: Flight_Plan_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plan_Statuses_By_PkArgs = {
  _set?: Maybe<Flight_Plan_Statuses_Set_Input>;
  pk_columns: Flight_Plan_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plan_Utm_ProvidersArgs = {
  _set?: Maybe<Flight_Plan_Utm_Providers_Set_Input>;
  where: Flight_Plan_Utm_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plan_Utm_Providers_By_PkArgs = {
  _set?: Maybe<Flight_Plan_Utm_Providers_Set_Input>;
  pk_columns: Flight_Plan_Utm_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_PlansArgs = {
  _append?: Maybe<Flight_Plans_Append_Input>;
  _delete_at_path?: Maybe<Flight_Plans_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Flight_Plans_Delete_Elem_Input>;
  _delete_key?: Maybe<Flight_Plans_Delete_Key_Input>;
  _inc?: Maybe<Flight_Plans_Inc_Input>;
  _prepend?: Maybe<Flight_Plans_Prepend_Input>;
  _set?: Maybe<Flight_Plans_Set_Input>;
  where: Flight_Plans_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Plans_By_PkArgs = {
  _append?: Maybe<Flight_Plans_Append_Input>;
  _delete_at_path?: Maybe<Flight_Plans_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Flight_Plans_Delete_Elem_Input>;
  _delete_key?: Maybe<Flight_Plans_Delete_Key_Input>;
  _inc?: Maybe<Flight_Plans_Inc_Input>;
  _prepend?: Maybe<Flight_Plans_Prepend_Input>;
  _set?: Maybe<Flight_Plans_Set_Input>;
  pk_columns: Flight_Plans_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_RoutesArgs = {
  _append?: Maybe<Flight_Routes_Append_Input>;
  _delete_at_path?: Maybe<Flight_Routes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Flight_Routes_Delete_Elem_Input>;
  _delete_key?: Maybe<Flight_Routes_Delete_Key_Input>;
  _inc?: Maybe<Flight_Routes_Inc_Input>;
  _prepend?: Maybe<Flight_Routes_Prepend_Input>;
  _set?: Maybe<Flight_Routes_Set_Input>;
  where: Flight_Routes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Routes_By_PkArgs = {
  _append?: Maybe<Flight_Routes_Append_Input>;
  _delete_at_path?: Maybe<Flight_Routes_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Flight_Routes_Delete_Elem_Input>;
  _delete_key?: Maybe<Flight_Routes_Delete_Key_Input>;
  _inc?: Maybe<Flight_Routes_Inc_Input>;
  _prepend?: Maybe<Flight_Routes_Prepend_Input>;
  _set?: Maybe<Flight_Routes_Set_Input>;
  pk_columns: Flight_Routes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Weather_DataArgs = {
  _inc?: Maybe<Flight_Weather_Data_Inc_Input>;
  _set?: Maybe<Flight_Weather_Data_Set_Input>;
  where: Flight_Weather_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Flight_Weather_Data_By_PkArgs = {
  _inc?: Maybe<Flight_Weather_Data_Inc_Input>;
  _set?: Maybe<Flight_Weather_Data_Set_Input>;
  pk_columns: Flight_Weather_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_CommandsArgs = {
  _inc?: Maybe<Ground_Asset_Commands_Inc_Input>;
  _set?: Maybe<Ground_Asset_Commands_Set_Input>;
  where: Ground_Asset_Commands_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Commands_By_PkArgs = {
  _inc?: Maybe<Ground_Asset_Commands_Inc_Input>;
  _set?: Maybe<Ground_Asset_Commands_Set_Input>;
  pk_columns: Ground_Asset_Commands_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Model_Parameter_TypesArgs = {
  _set?: Maybe<Ground_Asset_Model_Parameter_Types_Set_Input>;
  where: Ground_Asset_Model_Parameter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Model_Parameter_Types_By_PkArgs = {
  _set?: Maybe<Ground_Asset_Model_Parameter_Types_Set_Input>;
  pk_columns: Ground_Asset_Model_Parameter_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Model_ParametersArgs = {
  _inc?: Maybe<Ground_Asset_Model_Parameters_Inc_Input>;
  _set?: Maybe<Ground_Asset_Model_Parameters_Set_Input>;
  where: Ground_Asset_Model_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Model_Parameters_By_PkArgs = {
  _inc?: Maybe<Ground_Asset_Model_Parameters_Inc_Input>;
  _set?: Maybe<Ground_Asset_Model_Parameters_Set_Input>;
  pk_columns: Ground_Asset_Model_Parameters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Model_TypesArgs = {
  _set?: Maybe<Ground_Asset_Model_Types_Set_Input>;
  where: Ground_Asset_Model_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Model_Types_By_PkArgs = {
  _set?: Maybe<Ground_Asset_Model_Types_Set_Input>;
  pk_columns: Ground_Asset_Model_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_ModelsArgs = {
  _inc?: Maybe<Ground_Asset_Models_Inc_Input>;
  _set?: Maybe<Ground_Asset_Models_Set_Input>;
  where: Ground_Asset_Models_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Models_By_PkArgs = {
  _inc?: Maybe<Ground_Asset_Models_Inc_Input>;
  _set?: Maybe<Ground_Asset_Models_Set_Input>;
  pk_columns: Ground_Asset_Models_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_NetworksArgs = {
  _inc?: Maybe<Ground_Asset_Networks_Inc_Input>;
  _set?: Maybe<Ground_Asset_Networks_Set_Input>;
  where: Ground_Asset_Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Networks_By_PkArgs = {
  _inc?: Maybe<Ground_Asset_Networks_Inc_Input>;
  _set?: Maybe<Ground_Asset_Networks_Set_Input>;
  pk_columns: Ground_Asset_Networks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Status_ValuesArgs = {
  _set?: Maybe<Ground_Asset_Status_Values_Set_Input>;
  where: Ground_Asset_Status_Values_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Asset_Status_Values_By_PkArgs = {
  _set?: Maybe<Ground_Asset_Status_Values_Set_Input>;
  pk_columns: Ground_Asset_Status_Values_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_AssetsArgs = {
  _inc?: Maybe<Ground_Assets_Inc_Input>;
  _set?: Maybe<Ground_Assets_Set_Input>;
  where: Ground_Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Assets_By_PkArgs = {
  _inc?: Maybe<Ground_Assets_Inc_Input>;
  _set?: Maybe<Ground_Assets_Set_Input>;
  pk_columns: Ground_Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Control_Workflow_State_Processing_StatusesArgs = {
  _set?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Set_Input>;
  where: Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ground_Control_Workflow_State_Processing_Statuses_By_PkArgs = {
  _set?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Set_Input>;
  pk_columns: Ground_Control_Workflow_State_Processing_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Historical_Serialized_Ground_Asset_StatusesArgs = {
  _inc?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Inc_Input>;
  _set?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Set_Input>;
  where: Historical_Serialized_Ground_Asset_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Historical_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  _inc?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Inc_Input>;
  _set?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Set_Input>;
  pk_columns: Historical_Serialized_Ground_Asset_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Historical_Serialized_Vehicle_StatusesArgs = {
  _inc?: Maybe<Historical_Serialized_Vehicle_Statuses_Inc_Input>;
  _set?: Maybe<Historical_Serialized_Vehicle_Statuses_Set_Input>;
  where: Historical_Serialized_Vehicle_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Historical_Serialized_Vehicle_Statuses_By_PkArgs = {
  _inc?: Maybe<Historical_Serialized_Vehicle_Statuses_Inc_Input>;
  _set?: Maybe<Historical_Serialized_Vehicle_Statuses_Set_Input>;
  pk_columns: Historical_Serialized_Vehicle_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Historical_Vehicle_PositionsArgs = {
  _inc?: Maybe<Historical_Vehicle_Positions_Inc_Input>;
  _set?: Maybe<Historical_Vehicle_Positions_Set_Input>;
  where: Historical_Vehicle_Positions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Historical_Vehicle_Positions_By_PkArgs = {
  _inc?: Maybe<Historical_Vehicle_Positions_Inc_Input>;
  _set?: Maybe<Historical_Vehicle_Positions_Set_Input>;
  pk_columns: Historical_Vehicle_Positions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Air_Traffic_Vehicle_Flight_Proximity_RecordingsArgs = {
  _inc?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Inc_Input>;
  _set?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Set_Input>;
  where: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_By_PkArgs = {
  _inc?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Inc_Input>;
  _set?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Set_Input>;
  pk_columns: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Cached_Air_Traffic_Flight_Proximity_RecordingsArgs = {
  _inc?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Inc_Input>;
  _set?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Set_Input>;
  where: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_By_PkArgs = {
  _inc?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Inc_Input>;
  _set?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Set_Input>;
  pk_columns: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Mqtt_Vehicle_Status_MessagesArgs = {
  _inc?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Inc_Input>;
  _set?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Set_Input>;
  where: Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Mqtt_Vehicle_Status_Messages_By_PkArgs = {
  _inc?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Inc_Input>;
  _set?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Set_Input>;
  pk_columns: Kafka_Mqtt_Vehicle_Status_Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Serialized_Ground_Asset_StatusesArgs = {
  _inc?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Inc_Input>;
  _set?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Set_Input>;
  where: Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  _inc?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Inc_Input>;
  _set?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Set_Input>;
  pk_columns: Kafka_Serialized_Ground_Asset_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Kafka_Serialized_Vehicle_Statuses_By_PkArgs = {
  _inc?: Maybe<Kafka_Serialized_Vehicle_Statuses_Inc_Input>;
  _set?: Maybe<Kafka_Serialized_Vehicle_Statuses_Set_Input>;
  pk_columns: Kafka_Serialized_Vehicle_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Landing_Request_StatusesArgs = {
  _set?: Maybe<Landing_Request_Statuses_Set_Input>;
  where: Landing_Request_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Landing_Request_Statuses_By_PkArgs = {
  _set?: Maybe<Landing_Request_Statuses_Set_Input>;
  pk_columns: Landing_Request_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Landing_RequestsArgs = {
  _inc?: Maybe<Landing_Requests_Inc_Input>;
  _set?: Maybe<Landing_Requests_Set_Input>;
  where: Landing_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Landing_Requests_By_PkArgs = {
  _inc?: Maybe<Landing_Requests_Inc_Input>;
  _set?: Maybe<Landing_Requests_Set_Input>;
  pk_columns: Landing_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Last_Vehicle_Anomaly_StatusesArgs = {
  _append?: Maybe<Last_Vehicle_Anomaly_Statuses_Append_Input>;
  _delete_at_path?: Maybe<Last_Vehicle_Anomaly_Statuses_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Last_Vehicle_Anomaly_Statuses_Delete_Elem_Input>;
  _delete_key?: Maybe<Last_Vehicle_Anomaly_Statuses_Delete_Key_Input>;
  _inc?: Maybe<Last_Vehicle_Anomaly_Statuses_Inc_Input>;
  _prepend?: Maybe<Last_Vehicle_Anomaly_Statuses_Prepend_Input>;
  _set?: Maybe<Last_Vehicle_Anomaly_Statuses_Set_Input>;
  where: Last_Vehicle_Anomaly_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Last_Vehicle_Anomaly_Statuses_By_PkArgs = {
  _append?: Maybe<Last_Vehicle_Anomaly_Statuses_Append_Input>;
  _delete_at_path?: Maybe<Last_Vehicle_Anomaly_Statuses_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Last_Vehicle_Anomaly_Statuses_Delete_Elem_Input>;
  _delete_key?: Maybe<Last_Vehicle_Anomaly_Statuses_Delete_Key_Input>;
  _inc?: Maybe<Last_Vehicle_Anomaly_Statuses_Inc_Input>;
  _prepend?: Maybe<Last_Vehicle_Anomaly_Statuses_Prepend_Input>;
  _set?: Maybe<Last_Vehicle_Anomaly_Statuses_Set_Input>;
  pk_columns: Last_Vehicle_Anomaly_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_EventsArgs = {
  _inc?: Maybe<Manifest_Events_Inc_Input>;
  _set?: Maybe<Manifest_Events_Set_Input>;
  where: Manifest_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_Events_By_PkArgs = {
  _inc?: Maybe<Manifest_Events_Inc_Input>;
  _set?: Maybe<Manifest_Events_Set_Input>;
  pk_columns: Manifest_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_ItemsArgs = {
  _inc?: Maybe<Manifest_Items_Inc_Input>;
  _set?: Maybe<Manifest_Items_Set_Input>;
  where: Manifest_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_Items_By_PkArgs = {
  _inc?: Maybe<Manifest_Items_Inc_Input>;
  _set?: Maybe<Manifest_Items_Set_Input>;
  pk_columns: Manifest_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_ProductsArgs = {
  _inc?: Maybe<Manifest_Products_Inc_Input>;
  _set?: Maybe<Manifest_Products_Set_Input>;
  where: Manifest_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_Products_By_PkArgs = {
  _inc?: Maybe<Manifest_Products_Inc_Input>;
  _set?: Maybe<Manifest_Products_Set_Input>;
  pk_columns: Manifest_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_Status_AuditsArgs = {
  _inc?: Maybe<Manifest_Status_Audits_Inc_Input>;
  _set?: Maybe<Manifest_Status_Audits_Set_Input>;
  where: Manifest_Status_Audits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_Status_Audits_By_PkArgs = {
  _inc?: Maybe<Manifest_Status_Audits_Inc_Input>;
  _set?: Maybe<Manifest_Status_Audits_Set_Input>;
  pk_columns: Manifest_Status_Audits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_TypesArgs = {
  _set?: Maybe<Manifest_Types_Set_Input>;
  where: Manifest_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifest_Types_By_PkArgs = {
  _set?: Maybe<Manifest_Types_Set_Input>;
  pk_columns: Manifest_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ManifestsArgs = {
  _inc?: Maybe<Manifests_Inc_Input>;
  _set?: Maybe<Manifests_Set_Input>;
  where: Manifests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifests_Arrived_Within_MinuteArgs = {
  _inc?: Maybe<Manifests_Arrived_Within_Minute_Inc_Input>;
  _set?: Maybe<Manifests_Arrived_Within_Minute_Set_Input>;
  where: Manifests_Arrived_Within_Minute_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manifests_By_PkArgs = {
  _inc?: Maybe<Manifests_Inc_Input>;
  _set?: Maybe<Manifests_Set_Input>;
  pk_columns: Manifests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Network_Utm_ProvidersArgs = {
  _set?: Maybe<Network_Utm_Providers_Set_Input>;
  where: Network_Utm_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Network_Utm_Providers_By_PkArgs = {
  _set?: Maybe<Network_Utm_Providers_Set_Input>;
  pk_columns: Network_Utm_Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_NetworksArgs = {
  _append?: Maybe<Networks_Append_Input>;
  _delete_at_path?: Maybe<Networks_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Networks_Delete_Elem_Input>;
  _delete_key?: Maybe<Networks_Delete_Key_Input>;
  _inc?: Maybe<Networks_Inc_Input>;
  _prepend?: Maybe<Networks_Prepend_Input>;
  _set?: Maybe<Networks_Set_Input>;
  where: Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Networks_By_PkArgs = {
  _append?: Maybe<Networks_Append_Input>;
  _delete_at_path?: Maybe<Networks_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Networks_Delete_Elem_Input>;
  _delete_key?: Maybe<Networks_Delete_Key_Input>;
  _inc?: Maybe<Networks_Inc_Input>;
  _prepend?: Maybe<Networks_Prepend_Input>;
  _set?: Maybe<Networks_Set_Input>;
  pk_columns: Networks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationsArgs = {
  _set?: Maybe<Organizations_Set_Input>;
  where: Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_By_PkArgs = {
  _set?: Maybe<Organizations_Set_Input>;
  pk_columns: Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PathsArgs = {
  _append?: Maybe<Paths_Append_Input>;
  _delete_at_path?: Maybe<Paths_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Paths_Delete_Elem_Input>;
  _delete_key?: Maybe<Paths_Delete_Key_Input>;
  _inc?: Maybe<Paths_Inc_Input>;
  _prepend?: Maybe<Paths_Prepend_Input>;
  _set?: Maybe<Paths_Set_Input>;
  where: Paths_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Paths_By_PkArgs = {
  _append?: Maybe<Paths_Append_Input>;
  _delete_at_path?: Maybe<Paths_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Paths_Delete_Elem_Input>;
  _delete_key?: Maybe<Paths_Delete_Key_Input>;
  _inc?: Maybe<Paths_Inc_Input>;
  _prepend?: Maybe<Paths_Prepend_Input>;
  _set?: Maybe<Paths_Set_Input>;
  pk_columns: Paths_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pickup_RequestsArgs = {
  _inc?: Maybe<Pickup_Requests_Inc_Input>;
  _set?: Maybe<Pickup_Requests_Set_Input>;
  where: Pickup_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pickup_Requests_By_PkArgs = {
  _inc?: Maybe<Pickup_Requests_Inc_Input>;
  _set?: Maybe<Pickup_Requests_Set_Input>;
  pk_columns: Pickup_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Positive_Exchange_Of_Flight_Control_RequestsArgs = {
  _inc?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Inc_Input>;
  _set?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Set_Input>;
  where: Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Positive_Exchange_Of_Flight_Control_Requests_By_PkArgs = {
  _inc?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Inc_Input>;
  _set?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Set_Input>;
  pk_columns: Positive_Exchange_Of_Flight_Control_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Predicted_ConflictsArgs = {
  _append?: Maybe<Predicted_Conflicts_Append_Input>;
  _delete_at_path?: Maybe<Predicted_Conflicts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Predicted_Conflicts_Delete_Elem_Input>;
  _delete_key?: Maybe<Predicted_Conflicts_Delete_Key_Input>;
  _inc?: Maybe<Predicted_Conflicts_Inc_Input>;
  _prepend?: Maybe<Predicted_Conflicts_Prepend_Input>;
  _set?: Maybe<Predicted_Conflicts_Set_Input>;
  where: Predicted_Conflicts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Predicted_Conflicts_By_PkArgs = {
  _append?: Maybe<Predicted_Conflicts_Append_Input>;
  _delete_at_path?: Maybe<Predicted_Conflicts_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Predicted_Conflicts_Delete_Elem_Input>;
  _delete_key?: Maybe<Predicted_Conflicts_Delete_Key_Input>;
  _inc?: Maybe<Predicted_Conflicts_Inc_Input>;
  _prepend?: Maybe<Predicted_Conflicts_Prepend_Input>;
  _set?: Maybe<Predicted_Conflicts_Set_Input>;
  pk_columns: Predicted_Conflicts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _inc?: Maybe<Roles_Inc_Input>;
  _set?: Maybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _inc?: Maybe<Roles_Inc_Input>;
  _set?: Maybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_SysArgs = {
  _inc?: Maybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: Maybe<Spatial_Ref_Sys_Set_Input>;
  where: Spatial_Ref_Sys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Spatial_Ref_Sys_By_PkArgs = {
  _inc?: Maybe<Spatial_Ref_Sys_Inc_Input>;
  _set?: Maybe<Spatial_Ref_Sys_Set_Input>;
  pk_columns: Spatial_Ref_Sys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Squawk_SeveritiesArgs = {
  _set?: Maybe<Squawk_Severities_Set_Input>;
  where: Squawk_Severities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Squawk_Severities_By_PkArgs = {
  _set?: Maybe<Squawk_Severities_Set_Input>;
  pk_columns: Squawk_Severities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Squawk_Squawkable_TypesArgs = {
  _set?: Maybe<Squawk_Squawkable_Types_Set_Input>;
  where: Squawk_Squawkable_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Squawk_Squawkable_Types_By_PkArgs = {
  _set?: Maybe<Squawk_Squawkable_Types_Set_Input>;
  pk_columns: Squawk_Squawkable_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Squawk_StatusesArgs = {
  _set?: Maybe<Squawk_Statuses_Set_Input>;
  where: Squawk_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Squawk_Statuses_By_PkArgs = {
  _set?: Maybe<Squawk_Statuses_Set_Input>;
  pk_columns: Squawk_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SquawksArgs = {
  _inc?: Maybe<Squawks_Inc_Input>;
  _set?: Maybe<Squawks_Set_Input>;
  where: Squawks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Squawks_By_PkArgs = {
  _inc?: Maybe<Squawks_Inc_Input>;
  _set?: Maybe<Squawks_Set_Input>;
  pk_columns: Squawks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_StationsArgs = {
  _inc?: Maybe<Stations_Inc_Input>;
  _set?: Maybe<Stations_Set_Input>;
  where: Stations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stations_By_PkArgs = {
  _inc?: Maybe<Stations_Inc_Input>;
  _set?: Maybe<Stations_Set_Input>;
  pk_columns: Stations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TenantsArgs = {
  _inc?: Maybe<Tenants_Inc_Input>;
  _set?: Maybe<Tenants_Set_Input>;
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_By_PkArgs = {
  _inc?: Maybe<Tenants_Inc_Input>;
  _set?: Maybe<Tenants_Set_Input>;
  pk_columns: Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Cert_Flight_Analysis_DataArgs = {
  _inc?: Maybe<Type_Cert_Flight_Analysis_Data_Inc_Input>;
  _set?: Maybe<Type_Cert_Flight_Analysis_Data_Set_Input>;
  where: Type_Cert_Flight_Analysis_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Cert_Flight_Analysis_Data_By_PkArgs = {
  _inc?: Maybe<Type_Cert_Flight_Analysis_Data_Inc_Input>;
  _set?: Maybe<Type_Cert_Flight_Analysis_Data_Set_Input>;
  pk_columns: Type_Cert_Flight_Analysis_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Cert_Manual_DataArgs = {
  _append?: Maybe<Type_Cert_Manual_Data_Append_Input>;
  _delete_at_path?: Maybe<Type_Cert_Manual_Data_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Type_Cert_Manual_Data_Delete_Elem_Input>;
  _delete_key?: Maybe<Type_Cert_Manual_Data_Delete_Key_Input>;
  _inc?: Maybe<Type_Cert_Manual_Data_Inc_Input>;
  _prepend?: Maybe<Type_Cert_Manual_Data_Prepend_Input>;
  _set?: Maybe<Type_Cert_Manual_Data_Set_Input>;
  where: Type_Cert_Manual_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Type_Cert_Manual_Data_By_PkArgs = {
  _append?: Maybe<Type_Cert_Manual_Data_Append_Input>;
  _delete_at_path?: Maybe<Type_Cert_Manual_Data_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Type_Cert_Manual_Data_Delete_Elem_Input>;
  _delete_key?: Maybe<Type_Cert_Manual_Data_Delete_Key_Input>;
  _inc?: Maybe<Type_Cert_Manual_Data_Inc_Input>;
  _prepend?: Maybe<Type_Cert_Manual_Data_Prepend_Input>;
  _set?: Maybe<Type_Cert_Manual_Data_Set_Input>;
  pk_columns: Type_Cert_Manual_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_App_StatesArgs = {
  _inc?: Maybe<User_App_States_Inc_Input>;
  _set?: Maybe<User_App_States_Set_Input>;
  where: User_App_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_NetworksArgs = {
  _inc?: Maybe<User_Networks_Inc_Input>;
  _set?: Maybe<User_Networks_Set_Input>;
  where: User_Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Networks_By_PkArgs = {
  _inc?: Maybe<User_Networks_Inc_Input>;
  _set?: Maybe<User_Networks_Set_Input>;
  pk_columns: User_Networks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_RolesArgs = {
  _inc?: Maybe<User_Roles_Inc_Input>;
  _set?: Maybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_By_PkArgs = {
  _inc?: Maybe<User_Roles_Inc_Input>;
  _set?: Maybe<User_Roles_Set_Input>;
  pk_columns: User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: Maybe<Users_Inc_Input>;
  _set?: Maybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Airworthiness_CategoriesArgs = {
  _set?: Maybe<Vehicle_Airworthiness_Categories_Set_Input>;
  where: Vehicle_Airworthiness_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Airworthiness_Categories_By_PkArgs = {
  _set?: Maybe<Vehicle_Airworthiness_Categories_Set_Input>;
  pk_columns: Vehicle_Airworthiness_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_AlertsArgs = {
  _inc?: Maybe<Vehicle_Alerts_Inc_Input>;
  _set?: Maybe<Vehicle_Alerts_Set_Input>;
  where: Vehicle_Alerts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Alerts_By_PkArgs = {
  _inc?: Maybe<Vehicle_Alerts_Inc_Input>;
  _set?: Maybe<Vehicle_Alerts_Set_Input>;
  pk_columns: Vehicle_Alerts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Flight_State_EnumArgs = {
  _set?: Maybe<Vehicle_Flight_State_Enum_Set_Input>;
  where: Vehicle_Flight_State_Enum_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Flight_State_Enum_By_PkArgs = {
  _set?: Maybe<Vehicle_Flight_State_Enum_Set_Input>;
  pk_columns: Vehicle_Flight_State_Enum_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Flight_StatusesArgs = {
  _inc?: Maybe<Vehicle_Flight_Statuses_Inc_Input>;
  _set?: Maybe<Vehicle_Flight_Statuses_Set_Input>;
  where: Vehicle_Flight_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Flight_Statuses_By_PkArgs = {
  _inc?: Maybe<Vehicle_Flight_Statuses_Inc_Input>;
  _set?: Maybe<Vehicle_Flight_Statuses_Set_Input>;
  pk_columns: Vehicle_Flight_Statuses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Model_Parameter_TypesArgs = {
  _set?: Maybe<Vehicle_Model_Parameter_Types_Set_Input>;
  where: Vehicle_Model_Parameter_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Model_Parameter_Types_By_PkArgs = {
  _set?: Maybe<Vehicle_Model_Parameter_Types_Set_Input>;
  pk_columns: Vehicle_Model_Parameter_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Model_ParametersArgs = {
  _inc?: Maybe<Vehicle_Model_Parameters_Inc_Input>;
  _set?: Maybe<Vehicle_Model_Parameters_Set_Input>;
  where: Vehicle_Model_Parameters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Model_Parameters_By_PkArgs = {
  _inc?: Maybe<Vehicle_Model_Parameters_Inc_Input>;
  _set?: Maybe<Vehicle_Model_Parameters_Set_Input>;
  pk_columns: Vehicle_Model_Parameters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_ModelsArgs = {
  _inc?: Maybe<Vehicle_Models_Inc_Input>;
  _set?: Maybe<Vehicle_Models_Set_Input>;
  where: Vehicle_Models_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Models_AncestorsArgs = {
  _inc?: Maybe<Vehicle_Models_Ancestors_Inc_Input>;
  _set?: Maybe<Vehicle_Models_Ancestors_Set_Input>;
  where: Vehicle_Models_Ancestors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Models_Ancestors_By_PkArgs = {
  _inc?: Maybe<Vehicle_Models_Ancestors_Inc_Input>;
  _set?: Maybe<Vehicle_Models_Ancestors_Set_Input>;
  pk_columns: Vehicle_Models_Ancestors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Models_By_PkArgs = {
  _inc?: Maybe<Vehicle_Models_Inc_Input>;
  _set?: Maybe<Vehicle_Models_Set_Input>;
  pk_columns: Vehicle_Models_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_NetworksArgs = {
  _inc?: Maybe<Vehicle_Networks_Inc_Input>;
  _set?: Maybe<Vehicle_Networks_Set_Input>;
  where: Vehicle_Networks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Networks_By_PkArgs = {
  _inc?: Maybe<Vehicle_Networks_Inc_Input>;
  _set?: Maybe<Vehicle_Networks_Set_Input>;
  pk_columns: Vehicle_Networks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Pilot_AssignmentsArgs = {
  _inc?: Maybe<Vehicle_Pilot_Assignments_Inc_Input>;
  _set?: Maybe<Vehicle_Pilot_Assignments_Set_Input>;
  where: Vehicle_Pilot_Assignments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Pilot_Assignments_By_PkArgs = {
  _inc?: Maybe<Vehicle_Pilot_Assignments_Inc_Input>;
  _set?: Maybe<Vehicle_Pilot_Assignments_Set_Input>;
  pk_columns: Vehicle_Pilot_Assignments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Priority_Event_KeysArgs = {
  _append?: Maybe<Vehicle_Priority_Event_Keys_Append_Input>;
  _delete_at_path?: Maybe<Vehicle_Priority_Event_Keys_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Vehicle_Priority_Event_Keys_Delete_Elem_Input>;
  _delete_key?: Maybe<Vehicle_Priority_Event_Keys_Delete_Key_Input>;
  _inc?: Maybe<Vehicle_Priority_Event_Keys_Inc_Input>;
  _prepend?: Maybe<Vehicle_Priority_Event_Keys_Prepend_Input>;
  _set?: Maybe<Vehicle_Priority_Event_Keys_Set_Input>;
  where: Vehicle_Priority_Event_Keys_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Priority_Event_Keys_By_PkArgs = {
  _append?: Maybe<Vehicle_Priority_Event_Keys_Append_Input>;
  _delete_at_path?: Maybe<Vehicle_Priority_Event_Keys_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Vehicle_Priority_Event_Keys_Delete_Elem_Input>;
  _delete_key?: Maybe<Vehicle_Priority_Event_Keys_Delete_Key_Input>;
  _inc?: Maybe<Vehicle_Priority_Event_Keys_Inc_Input>;
  _prepend?: Maybe<Vehicle_Priority_Event_Keys_Prepend_Input>;
  _set?: Maybe<Vehicle_Priority_Event_Keys_Set_Input>;
  pk_columns: Vehicle_Priority_Event_Keys_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Priority_EventsArgs = {
  _append?: Maybe<Vehicle_Priority_Events_Append_Input>;
  _delete_at_path?: Maybe<Vehicle_Priority_Events_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Vehicle_Priority_Events_Delete_Elem_Input>;
  _delete_key?: Maybe<Vehicle_Priority_Events_Delete_Key_Input>;
  _inc?: Maybe<Vehicle_Priority_Events_Inc_Input>;
  _prepend?: Maybe<Vehicle_Priority_Events_Prepend_Input>;
  _set?: Maybe<Vehicle_Priority_Events_Set_Input>;
  where: Vehicle_Priority_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Priority_Events_By_PkArgs = {
  _append?: Maybe<Vehicle_Priority_Events_Append_Input>;
  _delete_at_path?: Maybe<Vehicle_Priority_Events_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Vehicle_Priority_Events_Delete_Elem_Input>;
  _delete_key?: Maybe<Vehicle_Priority_Events_Delete_Key_Input>;
  _inc?: Maybe<Vehicle_Priority_Events_Inc_Input>;
  _prepend?: Maybe<Vehicle_Priority_Events_Prepend_Input>;
  _set?: Maybe<Vehicle_Priority_Events_Set_Input>;
  pk_columns: Vehicle_Priority_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_UpdatesArgs = {
  _inc?: Maybe<Vehicle_Status_Updates_Inc_Input>;
  _set?: Maybe<Vehicle_Status_Updates_Set_Input>;
  where: Vehicle_Status_Updates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_Status_Updates_By_PkArgs = {
  _inc?: Maybe<Vehicle_Status_Updates_Inc_Input>;
  _set?: Maybe<Vehicle_Status_Updates_Set_Input>;
  pk_columns: Vehicle_Status_Updates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicle_StatusesArgs = {
  _inc?: Maybe<Kafka_Serialized_Vehicle_Statuses_Inc_Input>;
  _set?: Maybe<Kafka_Serialized_Vehicle_Statuses_Set_Input>;
  where: Kafka_Serialized_Vehicle_Statuses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_VehiclesArgs = {
  _append?: Maybe<Vehicles_Append_Input>;
  _delete_at_path?: Maybe<Vehicles_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Vehicles_Delete_Elem_Input>;
  _delete_key?: Maybe<Vehicles_Delete_Key_Input>;
  _inc?: Maybe<Vehicles_Inc_Input>;
  _prepend?: Maybe<Vehicles_Prepend_Input>;
  _set?: Maybe<Vehicles_Set_Input>;
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_By_PkArgs = {
  _append?: Maybe<Vehicles_Append_Input>;
  _delete_at_path?: Maybe<Vehicles_Delete_At_Path_Input>;
  _delete_elem?: Maybe<Vehicles_Delete_Elem_Input>;
  _delete_key?: Maybe<Vehicles_Delete_Key_Input>;
  _inc?: Maybe<Vehicles_Inc_Input>;
  _prepend?: Maybe<Vehicles_Prepend_Input>;
  _set?: Maybe<Vehicles_Set_Input>;
  pk_columns: Vehicles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpsertTypeCertManualDataArgs = {
  input: TypeCertManualDataInput;
};


/** mutation root */
export type Mutation_RootUpsertTypeCertManualDataAndWeatherObservationArgs = {
  input: TypeCertManualDataAndWeatherObservationInput;
};


/** mutation root */
export type Mutation_RootUpsertWeatherObservationArgs = {
  input: WeatherObservationInput;
};

/** columns and relationships of "network_utm_providers" */
export type Network_Utm_Providers = {
  __typename?: 'network_utm_providers';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "network_utm_providers" */
export type Network_Utm_Providers_Aggregate = {
  __typename?: 'network_utm_providers_aggregate';
  aggregate?: Maybe<Network_Utm_Providers_Aggregate_Fields>;
  nodes: Array<Network_Utm_Providers>;
};

/** aggregate fields of "network_utm_providers" */
export type Network_Utm_Providers_Aggregate_Fields = {
  __typename?: 'network_utm_providers_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Network_Utm_Providers_Max_Fields>;
  min?: Maybe<Network_Utm_Providers_Min_Fields>;
};


/** aggregate fields of "network_utm_providers" */
export type Network_Utm_Providers_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Network_Utm_Providers_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "network_utm_providers" */
export type Network_Utm_Providers_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Network_Utm_Providers_Max_Order_By>;
  min?: Maybe<Network_Utm_Providers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "network_utm_providers" */
export type Network_Utm_Providers_Arr_Rel_Insert_Input = {
  data: Array<Network_Utm_Providers_Insert_Input>;
  on_conflict?: Maybe<Network_Utm_Providers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "network_utm_providers". All fields are combined with a logical 'AND'. */
export type Network_Utm_Providers_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Network_Utm_Providers_Bool_Exp>>>;
  _not?: Maybe<Network_Utm_Providers_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Network_Utm_Providers_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "network_utm_providers" */
export enum Network_Utm_Providers_Constraint {
  /** unique or primary key constraint */
  NetworkUtmProvidersPkey = 'network_utm_providers_pkey'
}

export enum Network_Utm_Providers_Enum {
  /** Airmap */
  Airmap = 'Airmap'
}

/** expression to compare columns of type network_utm_providers_enum. All fields are combined with logical 'AND'. */
export type Network_Utm_Providers_Enum_Comparison_Exp = {
  _eq?: Maybe<Network_Utm_Providers_Enum>;
  _in?: Maybe<Array<Network_Utm_Providers_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Network_Utm_Providers_Enum>;
  _nin?: Maybe<Array<Network_Utm_Providers_Enum>>;
};

/** input type for inserting data into table "network_utm_providers" */
export type Network_Utm_Providers_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Network_Utm_Providers_Max_Fields = {
  __typename?: 'network_utm_providers_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "network_utm_providers" */
export type Network_Utm_Providers_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Network_Utm_Providers_Min_Fields = {
  __typename?: 'network_utm_providers_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "network_utm_providers" */
export type Network_Utm_Providers_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "network_utm_providers" */
export type Network_Utm_Providers_Mutation_Response = {
  __typename?: 'network_utm_providers_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Network_Utm_Providers>;
};

/** input type for inserting object relation for remote table "network_utm_providers" */
export type Network_Utm_Providers_Obj_Rel_Insert_Input = {
  data: Network_Utm_Providers_Insert_Input;
  on_conflict?: Maybe<Network_Utm_Providers_On_Conflict>;
};

/** on conflict condition type for table "network_utm_providers" */
export type Network_Utm_Providers_On_Conflict = {
  constraint: Network_Utm_Providers_Constraint;
  update_columns: Array<Network_Utm_Providers_Update_Column>;
  where?: Maybe<Network_Utm_Providers_Bool_Exp>;
};

/** ordering options when selecting data from "network_utm_providers" */
export type Network_Utm_Providers_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "network_utm_providers" */
export type Network_Utm_Providers_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "network_utm_providers" */
export enum Network_Utm_Providers_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "network_utm_providers" */
export type Network_Utm_Providers_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "network_utm_providers" */
export enum Network_Utm_Providers_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type Networks = {
  __typename?: 'networks';
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  badge_tokens: Array<Badge_Tokens>;
  /** An aggregated array relationship */
  badge_tokens_aggregate: Badge_Tokens_Aggregate;
  /** An array relationship */
  contingency_landing_spots: Array<Contingency_Landing_Spots>;
  /** An aggregated array relationship */
  contingency_landing_spots_aggregate: Contingency_Landing_Spots_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  editable: Scalars['Boolean'];
  event?: Maybe<Scalars['String']>;
  /** An array relationship */
  flight_commands: Array<Flight_Commands>;
  /** An aggregated array relationship */
  flight_commands_aggregate: Flight_Commands_Aggregate;
  /** An array relationship */
  flight_plans: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  /** An array relationship */
  flight_routes: Array<Flight_Routes>;
  /** An aggregated array relationship */
  flight_routes_aggregate: Flight_Routes_Aggregate;
  /** An array relationship */
  ground_asset_commands: Array<Ground_Asset_Commands>;
  /** An aggregated array relationship */
  ground_asset_commands_aggregate: Ground_Asset_Commands_Aggregate;
  /** An array relationship */
  ground_asset_networks: Array<Ground_Asset_Networks>;
  /** An aggregated array relationship */
  ground_asset_networks_aggregate: Ground_Asset_Networks_Aggregate;
  /** UID of the operations network. */
  id: Scalars['Int'];
  is_public?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  manifest_products: Array<Manifest_Products>;
  /** An aggregated array relationship */
  manifest_products_aggregate: Manifest_Products_Aggregate;
  /** An array relationship */
  manifests: Array<Manifests>;
  /** An aggregated array relationship */
  manifests_aggregate: Manifests_Aggregate;
  mongo_id?: Maybe<Scalars['String']>;
  /** Boolean flag denoting availability of network in Terminal app. */
  network_service_disabled: Scalars['Boolean'];
  network_type: Scalars['String'];
  /** An array relationship */
  pickup_requests: Array<Pickup_Requests>;
  /** An aggregated array relationship */
  pickup_requests_aggregate: Pickup_Requests_Aggregate;
  /** An array relationship */
  stations: Array<Stations>;
  /** An aggregated array relationship */
  stations_aggregate: Stations_Aggregate;
  subtitle?: Maybe<Scalars['String']>;
  tenant_id: Scalars['uuid'];
  /** Title of the operations network. */
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_networks: Array<User_Networks>;
  /** An aggregated array relationship */
  user_networks_aggregate: User_Networks_Aggregate;
  utm_provider?: Maybe<Network_Utm_Providers_Enum>;
  /** An array relationship */
  vehicle_networks: Array<Vehicle_Networks>;
  /** An aggregated array relationship */
  vehicle_networks_aggregate: Vehicle_Networks_Aggregate;
  version: Scalars['Int'];
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksAirmap_RulesetsArgs = {
  path?: Maybe<Scalars['String']>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksBadge_TokensArgs = {
  distinct_on?: Maybe<Array<Badge_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Badge_Tokens_Order_By>>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksBadge_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Badge_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Badge_Tokens_Order_By>>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksContingency_Landing_SpotsArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksContingency_Landing_Spots_AggregateArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksFlight_CommandsArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksFlight_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksFlight_RoutesArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksFlight_Routes_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksGround_Asset_CommandsArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksGround_Asset_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksGround_Asset_NetworksArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksGround_Asset_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksManifest_ProductsArgs = {
  distinct_on?: Maybe<Array<Manifest_Products_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Products_Order_By>>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksManifest_Products_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Products_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Products_Order_By>>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksManifestsArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksManifests_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksPickup_RequestsArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksPickup_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksStationsArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksStations_AggregateArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksUser_NetworksArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksUser_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksVehicle_NetworksArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/**
 * Table containing operations networks in the Matternet system. A network is a collection of vehicles, terminal airspaces, and flight routes.
 *
 *
 * columns and relationships of "networks"
 */
export type NetworksVehicle_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};

/** aggregated selection of "networks" */
export type Networks_Aggregate = {
  __typename?: 'networks_aggregate';
  aggregate?: Maybe<Networks_Aggregate_Fields>;
  nodes: Array<Networks>;
};

/** aggregate fields of "networks" */
export type Networks_Aggregate_Fields = {
  __typename?: 'networks_aggregate_fields';
  avg?: Maybe<Networks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Networks_Max_Fields>;
  min?: Maybe<Networks_Min_Fields>;
  stddev?: Maybe<Networks_Stddev_Fields>;
  stddev_pop?: Maybe<Networks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Networks_Stddev_Samp_Fields>;
  sum?: Maybe<Networks_Sum_Fields>;
  var_pop?: Maybe<Networks_Var_Pop_Fields>;
  var_samp?: Maybe<Networks_Var_Samp_Fields>;
  variance?: Maybe<Networks_Variance_Fields>;
};


/** aggregate fields of "networks" */
export type Networks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Networks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "networks" */
export type Networks_Aggregate_Order_By = {
  avg?: Maybe<Networks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Networks_Max_Order_By>;
  min?: Maybe<Networks_Min_Order_By>;
  stddev?: Maybe<Networks_Stddev_Order_By>;
  stddev_pop?: Maybe<Networks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Networks_Stddev_Samp_Order_By>;
  sum?: Maybe<Networks_Sum_Order_By>;
  var_pop?: Maybe<Networks_Var_Pop_Order_By>;
  var_samp?: Maybe<Networks_Var_Samp_Order_By>;
  variance?: Maybe<Networks_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Networks_Append_Input = {
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "networks" */
export type Networks_Arr_Rel_Insert_Input = {
  data: Array<Networks_Insert_Input>;
  on_conflict?: Maybe<Networks_On_Conflict>;
};

/** aggregate avg on columns */
export type Networks_Avg_Fields = {
  __typename?: 'networks_avg_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "networks" */
export type Networks_Avg_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "networks". All fields are combined with a logical 'AND'. */
export type Networks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Networks_Bool_Exp>>>;
  _not?: Maybe<Networks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Networks_Bool_Exp>>>;
  airmap_rulesets?: Maybe<Jsonb_Comparison_Exp>;
  badge_tokens?: Maybe<Badge_Tokens_Bool_Exp>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  editable?: Maybe<Boolean_Comparison_Exp>;
  event?: Maybe<String_Comparison_Exp>;
  flight_commands?: Maybe<Flight_Commands_Bool_Exp>;
  flight_plans?: Maybe<Flight_Plans_Bool_Exp>;
  flight_routes?: Maybe<Flight_Routes_Bool_Exp>;
  ground_asset_commands?: Maybe<Ground_Asset_Commands_Bool_Exp>;
  ground_asset_networks?: Maybe<Ground_Asset_Networks_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_public?: Maybe<Boolean_Comparison_Exp>;
  manifest_products?: Maybe<Manifest_Products_Bool_Exp>;
  manifests?: Maybe<Manifests_Bool_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  network_service_disabled?: Maybe<Boolean_Comparison_Exp>;
  network_type?: Maybe<String_Comparison_Exp>;
  pickup_requests?: Maybe<Pickup_Requests_Bool_Exp>;
  stations?: Maybe<Stations_Bool_Exp>;
  subtitle?: Maybe<String_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_networks?: Maybe<User_Networks_Bool_Exp>;
  utm_provider?: Maybe<Network_Utm_Providers_Enum_Comparison_Exp>;
  vehicle_networks?: Maybe<Vehicle_Networks_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "networks" */
export enum Networks_Constraint {
  /** unique or primary key constraint */
  NetworksMongoIdKey = 'networks_mongo_id_key',
  /** unique or primary key constraint */
  NetworksPkey = 'networks_pkey',
  /** unique or primary key constraint */
  NetworksTitleTenantIdUk = 'networks_title_tenant_id_uk'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Networks_Delete_At_Path_Input = {
  airmap_rulesets?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Networks_Delete_Elem_Input = {
  airmap_rulesets?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Networks_Delete_Key_Input = {
  airmap_rulesets?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "networks" */
export type Networks_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "networks" */
export type Networks_Insert_Input = {
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
  badge_tokens?: Maybe<Badge_Tokens_Arr_Rel_Insert_Input>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  editable?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Scalars['String']>;
  flight_commands?: Maybe<Flight_Commands_Arr_Rel_Insert_Input>;
  flight_plans?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_routes?: Maybe<Flight_Routes_Arr_Rel_Insert_Input>;
  ground_asset_commands?: Maybe<Ground_Asset_Commands_Arr_Rel_Insert_Input>;
  ground_asset_networks?: Maybe<Ground_Asset_Networks_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  is_public?: Maybe<Scalars['Boolean']>;
  manifest_products?: Maybe<Manifest_Products_Arr_Rel_Insert_Input>;
  manifests?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  mongo_id?: Maybe<Scalars['String']>;
  network_service_disabled?: Maybe<Scalars['Boolean']>;
  network_type?: Maybe<Scalars['String']>;
  pickup_requests?: Maybe<Pickup_Requests_Arr_Rel_Insert_Input>;
  stations?: Maybe<Stations_Arr_Rel_Insert_Input>;
  subtitle?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_networks?: Maybe<User_Networks_Arr_Rel_Insert_Input>;
  utm_provider?: Maybe<Network_Utm_Providers_Enum>;
  vehicle_networks?: Maybe<Vehicle_Networks_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Networks_Max_Fields = {
  __typename?: 'networks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_type?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "networks" */
export type Networks_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_type?: Maybe<Order_By>;
  subtitle?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Networks_Min_Fields = {
  __typename?: 'networks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_type?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "networks" */
export type Networks_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_type?: Maybe<Order_By>;
  subtitle?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "networks" */
export type Networks_Mutation_Response = {
  __typename?: 'networks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Networks>;
};

/** input type for inserting object relation for remote table "networks" */
export type Networks_Obj_Rel_Insert_Input = {
  data: Networks_Insert_Input;
  on_conflict?: Maybe<Networks_On_Conflict>;
};

/** on conflict condition type for table "networks" */
export type Networks_On_Conflict = {
  constraint: Networks_Constraint;
  update_columns: Array<Networks_Update_Column>;
  where?: Maybe<Networks_Bool_Exp>;
};

/** ordering options when selecting data from "networks" */
export type Networks_Order_By = {
  airmap_rulesets?: Maybe<Order_By>;
  badge_tokens_aggregate?: Maybe<Badge_Tokens_Aggregate_Order_By>;
  contingency_landing_spots_aggregate?: Maybe<Contingency_Landing_Spots_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  editable?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  flight_commands_aggregate?: Maybe<Flight_Commands_Aggregate_Order_By>;
  flight_plans_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_routes_aggregate?: Maybe<Flight_Routes_Aggregate_Order_By>;
  ground_asset_commands_aggregate?: Maybe<Ground_Asset_Commands_Aggregate_Order_By>;
  ground_asset_networks_aggregate?: Maybe<Ground_Asset_Networks_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  is_public?: Maybe<Order_By>;
  manifest_products_aggregate?: Maybe<Manifest_Products_Aggregate_Order_By>;
  manifests_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_service_disabled?: Maybe<Order_By>;
  network_type?: Maybe<Order_By>;
  pickup_requests_aggregate?: Maybe<Pickup_Requests_Aggregate_Order_By>;
  stations_aggregate?: Maybe<Stations_Aggregate_Order_By>;
  subtitle?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_networks_aggregate?: Maybe<User_Networks_Aggregate_Order_By>;
  utm_provider?: Maybe<Order_By>;
  vehicle_networks_aggregate?: Maybe<Vehicle_Networks_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "networks" */
export type Networks_Pk_Columns_Input = {
  /** UID of the operations network. */
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Networks_Prepend_Input = {
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "networks" */
export enum Networks_Select_Column {
  /** column name */
  AirmapRulesets = 'airmap_rulesets',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Editable = 'editable',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkServiceDisabled = 'network_service_disabled',
  /** column name */
  NetworkType = 'network_type',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmProvider = 'utm_provider',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "networks" */
export type Networks_Set_Input = {
  airmap_rulesets?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  editable?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_public?: Maybe<Scalars['Boolean']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_service_disabled?: Maybe<Scalars['Boolean']>;
  network_type?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  utm_provider?: Maybe<Network_Utm_Providers_Enum>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Networks_Stddev_Fields = {
  __typename?: 'networks_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "networks" */
export type Networks_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Networks_Stddev_Pop_Fields = {
  __typename?: 'networks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "networks" */
export type Networks_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Networks_Stddev_Samp_Fields = {
  __typename?: 'networks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "networks" */
export type Networks_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Networks_Sum_Fields = {
  __typename?: 'networks_sum_fields';
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "networks" */
export type Networks_Sum_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "networks" */
export enum Networks_Update_Column {
  /** column name */
  AirmapRulesets = 'airmap_rulesets',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Editable = 'editable',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublic = 'is_public',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NetworkServiceDisabled = 'network_service_disabled',
  /** column name */
  NetworkType = 'network_type',
  /** column name */
  Subtitle = 'subtitle',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmProvider = 'utm_provider',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Networks_Var_Pop_Fields = {
  __typename?: 'networks_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "networks" */
export type Networks_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Networks_Var_Samp_Fields = {
  __typename?: 'networks_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "networks" */
export type Networks_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Networks_Variance_Fields = {
  __typename?: 'networks_variance_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "networks" */
export type Networks_Variance_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'organizations';
  /** Organization unique string display name */
  display_name: Scalars['String'];
  /** Organization unique string id (snake_case) */
  key: Scalars['String'];
};

/** aggregated selection of "organizations" */
export type Organizations_Aggregate = {
  __typename?: 'organizations_aggregate';
  aggregate?: Maybe<Organizations_Aggregate_Fields>;
  nodes: Array<Organizations>;
};

/** aggregate fields of "organizations" */
export type Organizations_Aggregate_Fields = {
  __typename?: 'organizations_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Organizations_Max_Fields>;
  min?: Maybe<Organizations_Min_Fields>;
};


/** aggregate fields of "organizations" */
export type Organizations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Organizations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organizations" */
export type Organizations_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Organizations_Max_Order_By>;
  min?: Maybe<Organizations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organizations" */
export type Organizations_Arr_Rel_Insert_Input = {
  data: Array<Organizations_Insert_Input>;
  on_conflict?: Maybe<Organizations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type Organizations_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Organizations_Bool_Exp>>>;
  _not?: Maybe<Organizations_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Organizations_Bool_Exp>>>;
  display_name?: Maybe<String_Comparison_Exp>;
  key?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations" */
export enum Organizations_Constraint {
  /** unique or primary key constraint */
  OrganizationsDisplayNameKey = 'organizations_display_name_key',
  /** unique or primary key constraint */
  OrganizationsPkey = 'organizations_pkey'
}

export enum Organizations_Enum {
  /** Matternet */
  Matternet = 'matternet',
  /** Swiss Post */
  SwissPost = 'swiss_post',
  /** UPS */
  Ups = 'ups'
}

/** expression to compare columns of type organizations_enum. All fields are combined with logical 'AND'. */
export type Organizations_Enum_Comparison_Exp = {
  _eq?: Maybe<Organizations_Enum>;
  _in?: Maybe<Array<Organizations_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Organizations_Enum>;
  _nin?: Maybe<Array<Organizations_Enum>>;
};

/** input type for inserting data into table "organizations" */
export type Organizations_Insert_Input = {
  display_name?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organizations_Max_Fields = {
  __typename?: 'organizations_max_fields';
  display_name?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "organizations" */
export type Organizations_Max_Order_By = {
  display_name?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Organizations_Min_Fields = {
  __typename?: 'organizations_min_fields';
  display_name?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "organizations" */
export type Organizations_Min_Order_By = {
  display_name?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
};

/** response of any mutation on the table "organizations" */
export type Organizations_Mutation_Response = {
  __typename?: 'organizations_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type Organizations_Obj_Rel_Insert_Input = {
  data: Organizations_Insert_Input;
  on_conflict?: Maybe<Organizations_On_Conflict>;
};

/** on conflict condition type for table "organizations" */
export type Organizations_On_Conflict = {
  constraint: Organizations_Constraint;
  update_columns: Array<Organizations_Update_Column>;
  where?: Maybe<Organizations_Bool_Exp>;
};

/** ordering options when selecting data from "organizations" */
export type Organizations_Order_By = {
  display_name?: Maybe<Order_By>;
  key?: Maybe<Order_By>;
};

/** primary key columns input for table: "organizations" */
export type Organizations_Pk_Columns_Input = {
  /** Organization unique string id (snake_case) */
  key: Scalars['String'];
};

/** select columns of table "organizations" */
export enum Organizations_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Key = 'key'
}

/** input type for updating data in table "organizations" */
export type Organizations_Set_Input = {
  display_name?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

/** update columns of table "organizations" */
export enum Organizations_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Key = 'key'
}

/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type Paths = {
  __typename?: 'paths';
  airdrop?: Maybe<Scalars['Boolean']>;
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** Waypoints provided as [latitude, longitude, altitude]. Latitude and longitude are in degrees (-180, 180) and altitude is in meters. The first waypoint is at the origin terminal airspace. The last waypoint is at the destination terminal airspace. */
  flight_path: Scalars['geometry'];
  flight_path_destination: Scalars['geometry'];
  flight_path_origin: Scalars['geometry'];
  /** An array relationship */
  flight_plans_by_dest_contingency_path: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_by_dest_contingency_path_aggregate: Flight_Plans_Aggregate;
  /** An array relationship */
  flight_plans_by_origin_contingency_path: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_by_origin_contingency_path_aggregate: Flight_Plans_Aggregate;
  /** An array relationship */
  flight_plans_by_path: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_by_path_aggregate: Flight_Plans_Aggregate;
  flight_route_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  flight_routes: Array<Flight_Routes>;
  /** An aggregated array relationship */
  flight_routes_aggregate: Flight_Routes_Aggregate;
  /** An array relationship */
  flight_routes_by_reverse_path: Array<Flight_Routes>;
  /** An aggregated array relationship */
  flight_routes_by_reverse_path_aggregate: Flight_Routes_Aggregate;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  flown?: Maybe<Scalars['Boolean']>;
  ground_path: Scalars['geometry'];
  id: Scalars['Int'];
  mgrs_id?: Maybe<Scalars['String']>;
  planner_algorithm?: Maybe<Scalars['String']>;
  safety_zones?: Maybe<Scalars['jsonb']>;
  srid?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Plans_By_Dest_Contingency_PathArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Plans_By_Dest_Contingency_Path_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Plans_By_Origin_Contingency_PathArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Plans_By_Origin_Contingency_Path_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Plans_By_PathArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Plans_By_Path_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_RoutesArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Routes_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Routes_By_Reverse_PathArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsFlight_Routes_By_Reverse_Path_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/**
 * Table contianing the three-dimensional geometries that define the flight boundaries.
 *
 *
 * columns and relationships of "paths"
 */
export type PathsSafety_ZonesArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "paths" */
export type Paths_Aggregate = {
  __typename?: 'paths_aggregate';
  aggregate?: Maybe<Paths_Aggregate_Fields>;
  nodes: Array<Paths>;
};

/** aggregate fields of "paths" */
export type Paths_Aggregate_Fields = {
  __typename?: 'paths_aggregate_fields';
  avg?: Maybe<Paths_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Paths_Max_Fields>;
  min?: Maybe<Paths_Min_Fields>;
  stddev?: Maybe<Paths_Stddev_Fields>;
  stddev_pop?: Maybe<Paths_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Paths_Stddev_Samp_Fields>;
  sum?: Maybe<Paths_Sum_Fields>;
  var_pop?: Maybe<Paths_Var_Pop_Fields>;
  var_samp?: Maybe<Paths_Var_Samp_Fields>;
  variance?: Maybe<Paths_Variance_Fields>;
};


/** aggregate fields of "paths" */
export type Paths_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Paths_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "paths" */
export type Paths_Aggregate_Order_By = {
  avg?: Maybe<Paths_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Paths_Max_Order_By>;
  min?: Maybe<Paths_Min_Order_By>;
  stddev?: Maybe<Paths_Stddev_Order_By>;
  stddev_pop?: Maybe<Paths_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Paths_Stddev_Samp_Order_By>;
  sum?: Maybe<Paths_Sum_Order_By>;
  var_pop?: Maybe<Paths_Var_Pop_Order_By>;
  var_samp?: Maybe<Paths_Var_Samp_Order_By>;
  variance?: Maybe<Paths_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Paths_Append_Input = {
  safety_zones?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "paths" */
export type Paths_Arr_Rel_Insert_Input = {
  data: Array<Paths_Insert_Input>;
  on_conflict?: Maybe<Paths_On_Conflict>;
};

/** aggregate avg on columns */
export type Paths_Avg_Fields = {
  __typename?: 'paths_avg_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "paths" */
export type Paths_Avg_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "paths". All fields are combined with a logical 'AND'. */
export type Paths_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Paths_Bool_Exp>>>;
  _not?: Maybe<Paths_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Paths_Bool_Exp>>>;
  airdrop?: Maybe<Boolean_Comparison_Exp>;
  airdrop_altitude_agl?: Maybe<Int_Comparison_Exp>;
  airdrop_flight_path_idx?: Maybe<Int_Comparison_Exp>;
  airdrop_hold_time?: Maybe<Int_Comparison_Exp>;
  ceiling_altitude_agl?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_path?: Maybe<Geometry_Comparison_Exp>;
  flight_path_destination?: Maybe<Geometry_Comparison_Exp>;
  flight_path_origin?: Maybe<Geometry_Comparison_Exp>;
  flight_plans_by_dest_contingency_path?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plans_by_origin_contingency_path?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plans_by_path?: Maybe<Flight_Plans_Bool_Exp>;
  flight_route_id?: Maybe<Int_Comparison_Exp>;
  flight_routes?: Maybe<Flight_Routes_Bool_Exp>;
  flight_routes_by_reverse_path?: Maybe<Flight_Routes_Bool_Exp>;
  floor_altitude_agl?: Maybe<Int_Comparison_Exp>;
  flown?: Maybe<Boolean_Comparison_Exp>;
  ground_path?: Maybe<Geometry_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mgrs_id?: Maybe<String_Comparison_Exp>;
  planner_algorithm?: Maybe<String_Comparison_Exp>;
  safety_zones?: Maybe<Jsonb_Comparison_Exp>;
  srid?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "paths" */
export enum Paths_Constraint {
  /** unique or primary key constraint */
  PathsPkey = 'paths_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Paths_Delete_At_Path_Input = {
  safety_zones?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Paths_Delete_Elem_Input = {
  safety_zones?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Paths_Delete_Key_Input = {
  safety_zones?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "paths" */
export type Paths_Inc_Input = {
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  flight_route_id?: Maybe<Scalars['Int']>;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "paths" */
export type Paths_Insert_Input = {
  airdrop?: Maybe<Scalars['Boolean']>;
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_path?: Maybe<Scalars['geometry']>;
  flight_path_destination?: Maybe<Scalars['geometry']>;
  flight_path_origin?: Maybe<Scalars['geometry']>;
  flight_plans_by_dest_contingency_path?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_plans_by_origin_contingency_path?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_plans_by_path?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_route_id?: Maybe<Scalars['Int']>;
  flight_routes?: Maybe<Flight_Routes_Arr_Rel_Insert_Input>;
  flight_routes_by_reverse_path?: Maybe<Flight_Routes_Arr_Rel_Insert_Input>;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  flown?: Maybe<Scalars['Boolean']>;
  ground_path?: Maybe<Scalars['geometry']>;
  id?: Maybe<Scalars['Int']>;
  mgrs_id?: Maybe<Scalars['String']>;
  planner_algorithm?: Maybe<Scalars['String']>;
  safety_zones?: Maybe<Scalars['jsonb']>;
  srid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Paths_Max_Fields = {
  __typename?: 'paths_max_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_route_id?: Maybe<Scalars['Int']>;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mgrs_id?: Maybe<Scalars['String']>;
  planner_algorithm?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "paths" */
export type Paths_Max_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mgrs_id?: Maybe<Order_By>;
  planner_algorithm?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Paths_Min_Fields = {
  __typename?: 'paths_min_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_route_id?: Maybe<Scalars['Int']>;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  mgrs_id?: Maybe<Scalars['String']>;
  planner_algorithm?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "paths" */
export type Paths_Min_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mgrs_id?: Maybe<Order_By>;
  planner_algorithm?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "paths" */
export type Paths_Mutation_Response = {
  __typename?: 'paths_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Paths>;
};

/** input type for inserting object relation for remote table "paths" */
export type Paths_Obj_Rel_Insert_Input = {
  data: Paths_Insert_Input;
  on_conflict?: Maybe<Paths_On_Conflict>;
};

/** on conflict condition type for table "paths" */
export type Paths_On_Conflict = {
  constraint: Paths_Constraint;
  update_columns: Array<Paths_Update_Column>;
  where?: Maybe<Paths_Bool_Exp>;
};

/** ordering options when selecting data from "paths" */
export type Paths_Order_By = {
  airdrop?: Maybe<Order_By>;
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_path?: Maybe<Order_By>;
  flight_path_destination?: Maybe<Order_By>;
  flight_path_origin?: Maybe<Order_By>;
  flight_plans_by_dest_contingency_path_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_plans_by_origin_contingency_path_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_plans_by_path_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_route_id?: Maybe<Order_By>;
  flight_routes_aggregate?: Maybe<Flight_Routes_Aggregate_Order_By>;
  flight_routes_by_reverse_path_aggregate?: Maybe<Flight_Routes_Aggregate_Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  flown?: Maybe<Order_By>;
  ground_path?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mgrs_id?: Maybe<Order_By>;
  planner_algorithm?: Maybe<Order_By>;
  safety_zones?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "paths" */
export type Paths_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Paths_Prepend_Input = {
  safety_zones?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "paths" */
export enum Paths_Select_Column {
  /** column name */
  Airdrop = 'airdrop',
  /** column name */
  AirdropAltitudeAgl = 'airdrop_altitude_agl',
  /** column name */
  AirdropFlightPathIdx = 'airdrop_flight_path_idx',
  /** column name */
  AirdropHoldTime = 'airdrop_hold_time',
  /** column name */
  CeilingAltitudeAgl = 'ceiling_altitude_agl',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPath = 'flight_path',
  /** column name */
  FlightPathDestination = 'flight_path_destination',
  /** column name */
  FlightPathOrigin = 'flight_path_origin',
  /** column name */
  FlightRouteId = 'flight_route_id',
  /** column name */
  FloorAltitudeAgl = 'floor_altitude_agl',
  /** column name */
  Flown = 'flown',
  /** column name */
  GroundPath = 'ground_path',
  /** column name */
  Id = 'id',
  /** column name */
  MgrsId = 'mgrs_id',
  /** column name */
  PlannerAlgorithm = 'planner_algorithm',
  /** column name */
  SafetyZones = 'safety_zones',
  /** column name */
  Srid = 'srid',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "paths" */
export type Paths_Set_Input = {
  airdrop?: Maybe<Scalars['Boolean']>;
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_path?: Maybe<Scalars['geometry']>;
  flight_path_destination?: Maybe<Scalars['geometry']>;
  flight_path_origin?: Maybe<Scalars['geometry']>;
  flight_route_id?: Maybe<Scalars['Int']>;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  flown?: Maybe<Scalars['Boolean']>;
  ground_path?: Maybe<Scalars['geometry']>;
  id?: Maybe<Scalars['Int']>;
  mgrs_id?: Maybe<Scalars['String']>;
  planner_algorithm?: Maybe<Scalars['String']>;
  safety_zones?: Maybe<Scalars['jsonb']>;
  srid?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Paths_Stddev_Fields = {
  __typename?: 'paths_stddev_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "paths" */
export type Paths_Stddev_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Paths_Stddev_Pop_Fields = {
  __typename?: 'paths_stddev_pop_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "paths" */
export type Paths_Stddev_Pop_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Paths_Stddev_Samp_Fields = {
  __typename?: 'paths_stddev_samp_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "paths" */
export type Paths_Stddev_Samp_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Paths_Sum_Fields = {
  __typename?: 'paths_sum_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Int']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Int']>;
  airdrop_hold_time?: Maybe<Scalars['Int']>;
  ceiling_altitude_agl?: Maybe<Scalars['Int']>;
  flight_route_id?: Maybe<Scalars['Int']>;
  floor_altitude_agl?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "paths" */
export type Paths_Sum_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "paths" */
export enum Paths_Update_Column {
  /** column name */
  Airdrop = 'airdrop',
  /** column name */
  AirdropAltitudeAgl = 'airdrop_altitude_agl',
  /** column name */
  AirdropFlightPathIdx = 'airdrop_flight_path_idx',
  /** column name */
  AirdropHoldTime = 'airdrop_hold_time',
  /** column name */
  CeilingAltitudeAgl = 'ceiling_altitude_agl',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPath = 'flight_path',
  /** column name */
  FlightPathDestination = 'flight_path_destination',
  /** column name */
  FlightPathOrigin = 'flight_path_origin',
  /** column name */
  FlightRouteId = 'flight_route_id',
  /** column name */
  FloorAltitudeAgl = 'floor_altitude_agl',
  /** column name */
  Flown = 'flown',
  /** column name */
  GroundPath = 'ground_path',
  /** column name */
  Id = 'id',
  /** column name */
  MgrsId = 'mgrs_id',
  /** column name */
  PlannerAlgorithm = 'planner_algorithm',
  /** column name */
  SafetyZones = 'safety_zones',
  /** column name */
  Srid = 'srid',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Paths_Var_Pop_Fields = {
  __typename?: 'paths_var_pop_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "paths" */
export type Paths_Var_Pop_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Paths_Var_Samp_Fields = {
  __typename?: 'paths_var_samp_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "paths" */
export type Paths_Var_Samp_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Paths_Variance_Fields = {
  __typename?: 'paths_variance_fields';
  airdrop_altitude_agl?: Maybe<Scalars['Float']>;
  airdrop_flight_path_idx?: Maybe<Scalars['Float']>;
  airdrop_hold_time?: Maybe<Scalars['Float']>;
  ceiling_altitude_agl?: Maybe<Scalars['Float']>;
  flight_route_id?: Maybe<Scalars['Float']>;
  floor_altitude_agl?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "paths" */
export type Paths_Variance_Order_By = {
  airdrop_altitude_agl?: Maybe<Order_By>;
  airdrop_flight_path_idx?: Maybe<Order_By>;
  airdrop_hold_time?: Maybe<Order_By>;
  ceiling_altitude_agl?: Maybe<Order_By>;
  flight_route_id?: Maybe<Order_By>;
  floor_altitude_agl?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "pickup_requests" */
export type Pickup_Requests = {
  __typename?: 'pickup_requests';
  canceled?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fulfilled?: Maybe<Scalars['Boolean']>;
  fulfilled_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  mongo_id?: Maybe<Scalars['String']>;
  need_payload?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  station?: Maybe<Stations>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
};

/** aggregated selection of "pickup_requests" */
export type Pickup_Requests_Aggregate = {
  __typename?: 'pickup_requests_aggregate';
  aggregate?: Maybe<Pickup_Requests_Aggregate_Fields>;
  nodes: Array<Pickup_Requests>;
};

/** aggregate fields of "pickup_requests" */
export type Pickup_Requests_Aggregate_Fields = {
  __typename?: 'pickup_requests_aggregate_fields';
  avg?: Maybe<Pickup_Requests_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Pickup_Requests_Max_Fields>;
  min?: Maybe<Pickup_Requests_Min_Fields>;
  stddev?: Maybe<Pickup_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Pickup_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pickup_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Pickup_Requests_Sum_Fields>;
  var_pop?: Maybe<Pickup_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Pickup_Requests_Var_Samp_Fields>;
  variance?: Maybe<Pickup_Requests_Variance_Fields>;
};


/** aggregate fields of "pickup_requests" */
export type Pickup_Requests_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Pickup_Requests_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "pickup_requests" */
export type Pickup_Requests_Aggregate_Order_By = {
  avg?: Maybe<Pickup_Requests_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Pickup_Requests_Max_Order_By>;
  min?: Maybe<Pickup_Requests_Min_Order_By>;
  stddev?: Maybe<Pickup_Requests_Stddev_Order_By>;
  stddev_pop?: Maybe<Pickup_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Pickup_Requests_Stddev_Samp_Order_By>;
  sum?: Maybe<Pickup_Requests_Sum_Order_By>;
  var_pop?: Maybe<Pickup_Requests_Var_Pop_Order_By>;
  var_samp?: Maybe<Pickup_Requests_Var_Samp_Order_By>;
  variance?: Maybe<Pickup_Requests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "pickup_requests" */
export type Pickup_Requests_Arr_Rel_Insert_Input = {
  data: Array<Pickup_Requests_Insert_Input>;
  on_conflict?: Maybe<Pickup_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Pickup_Requests_Avg_Fields = {
  __typename?: 'pickup_requests_avg_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "pickup_requests" */
export type Pickup_Requests_Avg_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pickup_requests". All fields are combined with a logical 'AND'. */
export type Pickup_Requests_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Pickup_Requests_Bool_Exp>>>;
  _not?: Maybe<Pickup_Requests_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Pickup_Requests_Bool_Exp>>>;
  canceled?: Maybe<Boolean_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  fulfilled?: Maybe<Boolean_Comparison_Exp>;
  fulfilled_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  need_payload?: Maybe<Boolean_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  pickup_station_id?: Maybe<Int_Comparison_Exp>;
  priority?: Maybe<Int_Comparison_Exp>;
  requested_by_id?: Maybe<Int_Comparison_Exp>;
  station?: Maybe<Stations_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "pickup_requests" */
export enum Pickup_Requests_Constraint {
  /** unique or primary key constraint */
  PickupRequestsMongoIdKey = 'pickup_requests_mongo_id_key',
  /** unique or primary key constraint */
  PickupRequestsPkey = 'pickup_requests_pkey'
}

/** input type for incrementing integer column in table "pickup_requests" */
export type Pickup_Requests_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "pickup_requests" */
export type Pickup_Requests_Insert_Input = {
  canceled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fulfilled?: Maybe<Scalars['Boolean']>;
  fulfilled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  need_payload?: Maybe<Scalars['Boolean']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Pickup_Requests_Max_Fields = {
  __typename?: 'pickup_requests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fulfilled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "pickup_requests" */
export type Pickup_Requests_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  fulfilled_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Pickup_Requests_Min_Fields = {
  __typename?: 'pickup_requests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fulfilled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "pickup_requests" */
export type Pickup_Requests_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  fulfilled_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "pickup_requests" */
export type Pickup_Requests_Mutation_Response = {
  __typename?: 'pickup_requests_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Pickup_Requests>;
};

/** input type for inserting object relation for remote table "pickup_requests" */
export type Pickup_Requests_Obj_Rel_Insert_Input = {
  data: Pickup_Requests_Insert_Input;
  on_conflict?: Maybe<Pickup_Requests_On_Conflict>;
};

/** on conflict condition type for table "pickup_requests" */
export type Pickup_Requests_On_Conflict = {
  constraint: Pickup_Requests_Constraint;
  update_columns: Array<Pickup_Requests_Update_Column>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};

/** ordering options when selecting data from "pickup_requests" */
export type Pickup_Requests_Order_By = {
  canceled?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  fulfilled?: Maybe<Order_By>;
  fulfilled_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  need_payload?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  station?: Maybe<Stations_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "pickup_requests" */
export type Pickup_Requests_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "pickup_requests" */
export enum Pickup_Requests_Select_Column {
  /** column name */
  Canceled = 'canceled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Fulfilled = 'fulfilled',
  /** column name */
  FulfilledAt = 'fulfilled_at',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NeedPayload = 'need_payload',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PickupStationId = 'pickup_station_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  RequestedById = 'requested_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "pickup_requests" */
export type Pickup_Requests_Set_Input = {
  canceled?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fulfilled?: Maybe<Scalars['Boolean']>;
  fulfilled_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  need_payload?: Maybe<Scalars['Boolean']>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Pickup_Requests_Stddev_Fields = {
  __typename?: 'pickup_requests_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "pickup_requests" */
export type Pickup_Requests_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pickup_Requests_Stddev_Pop_Fields = {
  __typename?: 'pickup_requests_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "pickup_requests" */
export type Pickup_Requests_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pickup_Requests_Stddev_Samp_Fields = {
  __typename?: 'pickup_requests_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "pickup_requests" */
export type Pickup_Requests_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Pickup_Requests_Sum_Fields = {
  __typename?: 'pickup_requests_sum_fields';
  id?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_station_id?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  requested_by_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "pickup_requests" */
export type Pickup_Requests_Sum_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "pickup_requests" */
export enum Pickup_Requests_Update_Column {
  /** column name */
  Canceled = 'canceled',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Fulfilled = 'fulfilled',
  /** column name */
  FulfilledAt = 'fulfilled_at',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  NeedPayload = 'need_payload',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  PickupStationId = 'pickup_station_id',
  /** column name */
  Priority = 'priority',
  /** column name */
  RequestedById = 'requested_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Pickup_Requests_Var_Pop_Fields = {
  __typename?: 'pickup_requests_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "pickup_requests" */
export type Pickup_Requests_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pickup_Requests_Var_Samp_Fields = {
  __typename?: 'pickup_requests_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "pickup_requests" */
export type Pickup_Requests_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Pickup_Requests_Variance_Fields = {
  __typename?: 'pickup_requests_variance_fields';
  id?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  pickup_station_id?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  requested_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "pickup_requests" */
export type Pickup_Requests_Variance_Order_By = {
  id?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_station_id?: Maybe<Order_By>;
  priority?: Maybe<Order_By>;
  requested_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests = {
  __typename?: 'positive_exchange_of_flight_control_requests';
  created_at: Scalars['timestamptz'];
  /** Reference to the RPIC the request is for */
  current_rpic_assignment_id: Scalars['Int'];
  id: Scalars['Int'];
  /** References a flight plan pilot assignment */
  requesting_pilot_assignment_id: Scalars['Int'];
  /** Resolution of the exchange request */
  resolution?: Maybe<Scalars['String']>;
  resolution_recorded_at?: Maybe<Scalars['timestamptz']>;
  /** Status of the postive exchange of flight control request */
  status: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Aggregate = {
  __typename?: 'positive_exchange_of_flight_control_requests_aggregate';
  aggregate?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Aggregate_Fields>;
  nodes: Array<Positive_Exchange_Of_Flight_Control_Requests>;
};

/** aggregate fields of "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Aggregate_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_aggregate_fields';
  avg?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Max_Fields>;
  min?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Min_Fields>;
  stddev?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Stddev_Fields>;
  stddev_pop?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Stddev_Samp_Fields>;
  sum?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Sum_Fields>;
  var_pop?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Var_Pop_Fields>;
  var_samp?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Var_Samp_Fields>;
  variance?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Variance_Fields>;
};


/** aggregate fields of "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Aggregate_Order_By = {
  avg?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Max_Order_By>;
  min?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Min_Order_By>;
  stddev?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Stddev_Order_By>;
  stddev_pop?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Stddev_Samp_Order_By>;
  sum?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Sum_Order_By>;
  var_pop?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Var_Pop_Order_By>;
  var_samp?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Var_Samp_Order_By>;
  variance?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Arr_Rel_Insert_Input = {
  data: Array<Positive_Exchange_Of_Flight_Control_Requests_Insert_Input>;
  on_conflict?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_On_Conflict>;
};

/** aggregate avg on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Avg_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_avg_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Avg_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "positive_exchange_of_flight_control_requests". All fields are combined with a logical 'AND'. */
export type Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>>>;
  _not?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  current_rpic_assignment_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  requesting_pilot_assignment_id?: Maybe<Int_Comparison_Exp>;
  resolution?: Maybe<String_Comparison_Exp>;
  resolution_recorded_at?: Maybe<Timestamptz_Comparison_Exp>;
  status?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "positive_exchange_of_flight_control_requests" */
export enum Positive_Exchange_Of_Flight_Control_Requests_Constraint {
  /** unique or primary key constraint */
  PositiveExchangeOfFlightControlRequestsPkey = 'positive_exchange_of_flight_control_requests_pkey'
}

/** input type for incrementing integer column in table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Inc_Input = {
  current_rpic_assignment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  current_rpic_assignment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Int']>;
  resolution?: Maybe<Scalars['String']>;
  resolution_recorded_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Max_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  current_rpic_assignment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Int']>;
  resolution?: Maybe<Scalars['String']>;
  resolution_recorded_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
  resolution?: Maybe<Order_By>;
  resolution_recorded_at?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Min_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  current_rpic_assignment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Int']>;
  resolution?: Maybe<Scalars['String']>;
  resolution_recorded_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
  resolution?: Maybe<Order_By>;
  resolution_recorded_at?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Mutation_Response = {
  __typename?: 'positive_exchange_of_flight_control_requests_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Positive_Exchange_Of_Flight_Control_Requests>;
};

/** input type for inserting object relation for remote table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Obj_Rel_Insert_Input = {
  data: Positive_Exchange_Of_Flight_Control_Requests_Insert_Input;
  on_conflict?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_On_Conflict>;
};

/** on conflict condition type for table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_On_Conflict = {
  constraint: Positive_Exchange_Of_Flight_Control_Requests_Constraint;
  update_columns: Array<Positive_Exchange_Of_Flight_Control_Requests_Update_Column>;
  where?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
};

/** ordering options when selecting data from "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Order_By = {
  created_at?: Maybe<Order_By>;
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
  resolution?: Maybe<Order_By>;
  resolution_recorded_at?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "positive_exchange_of_flight_control_requests" */
export enum Positive_Exchange_Of_Flight_Control_Requests_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentRpicAssignmentId = 'current_rpic_assignment_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestingPilotAssignmentId = 'requesting_pilot_assignment_id',
  /** column name */
  Resolution = 'resolution',
  /** column name */
  ResolutionRecordedAt = 'resolution_recorded_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  current_rpic_assignment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Int']>;
  resolution?: Maybe<Scalars['String']>;
  resolution_recorded_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Stddev_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_stddev_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Stddev_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Stddev_Pop_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_stddev_pop_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Stddev_Pop_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Stddev_Samp_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_stddev_samp_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Stddev_Samp_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Sum_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_sum_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Sum_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** update columns of table "positive_exchange_of_flight_control_requests" */
export enum Positive_Exchange_Of_Flight_Control_Requests_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentRpicAssignmentId = 'current_rpic_assignment_id',
  /** column name */
  Id = 'id',
  /** column name */
  RequestingPilotAssignmentId = 'requesting_pilot_assignment_id',
  /** column name */
  Resolution = 'resolution',
  /** column name */
  ResolutionRecordedAt = 'resolution_recorded_at',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Var_Pop_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_var_pop_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Var_Pop_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Var_Samp_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_var_samp_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Var_Samp_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Positive_Exchange_Of_Flight_Control_Requests_Variance_Fields = {
  __typename?: 'positive_exchange_of_flight_control_requests_variance_fields';
  current_rpic_assignment_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  requesting_pilot_assignment_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "positive_exchange_of_flight_control_requests" */
export type Positive_Exchange_Of_Flight_Control_Requests_Variance_Order_By = {
  current_rpic_assignment_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  requesting_pilot_assignment_id?: Maybe<Order_By>;
};

/** columns and relationships of "predicted_conflicts" */
export type Predicted_Conflicts = {
  __typename?: 'predicted_conflicts';
  /** Alert level that the observation has breached */
  alert_level: Scalars['String'];
  conflict_contours?: Maybe<Scalars['geometry']>;
  conflict_intervals?: Maybe<Scalars['jsonb']>;
  created_at: Scalars['timestamptz'];
  /** Flight plan ID associated with the aicraft that reported the observation */
  flight_plan_id?: Maybe<Scalars['Int']>;
  /** Identifier for the observation */
  observation_id: Scalars['String'];
  /** signifies whether the conflict has been pruned */
  pruned: Scalars['Boolean'];
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
  updated_at: Scalars['timestamptz'];
  /** Serial number of the aircraft which reported the observation */
  vehicle_serial_number: Scalars['String'];
};


/** columns and relationships of "predicted_conflicts" */
export type Predicted_ConflictsConflict_IntervalsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "predicted_conflicts" */
export type Predicted_Conflicts_Aggregate = {
  __typename?: 'predicted_conflicts_aggregate';
  aggregate?: Maybe<Predicted_Conflicts_Aggregate_Fields>;
  nodes: Array<Predicted_Conflicts>;
};

/** aggregate fields of "predicted_conflicts" */
export type Predicted_Conflicts_Aggregate_Fields = {
  __typename?: 'predicted_conflicts_aggregate_fields';
  avg?: Maybe<Predicted_Conflicts_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Predicted_Conflicts_Max_Fields>;
  min?: Maybe<Predicted_Conflicts_Min_Fields>;
  stddev?: Maybe<Predicted_Conflicts_Stddev_Fields>;
  stddev_pop?: Maybe<Predicted_Conflicts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Predicted_Conflicts_Stddev_Samp_Fields>;
  sum?: Maybe<Predicted_Conflicts_Sum_Fields>;
  var_pop?: Maybe<Predicted_Conflicts_Var_Pop_Fields>;
  var_samp?: Maybe<Predicted_Conflicts_Var_Samp_Fields>;
  variance?: Maybe<Predicted_Conflicts_Variance_Fields>;
};


/** aggregate fields of "predicted_conflicts" */
export type Predicted_Conflicts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "predicted_conflicts" */
export type Predicted_Conflicts_Aggregate_Order_By = {
  avg?: Maybe<Predicted_Conflicts_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Predicted_Conflicts_Max_Order_By>;
  min?: Maybe<Predicted_Conflicts_Min_Order_By>;
  stddev?: Maybe<Predicted_Conflicts_Stddev_Order_By>;
  stddev_pop?: Maybe<Predicted_Conflicts_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Predicted_Conflicts_Stddev_Samp_Order_By>;
  sum?: Maybe<Predicted_Conflicts_Sum_Order_By>;
  var_pop?: Maybe<Predicted_Conflicts_Var_Pop_Order_By>;
  var_samp?: Maybe<Predicted_Conflicts_Var_Samp_Order_By>;
  variance?: Maybe<Predicted_Conflicts_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Predicted_Conflicts_Append_Input = {
  conflict_intervals?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "predicted_conflicts" */
export type Predicted_Conflicts_Arr_Rel_Insert_Input = {
  data: Array<Predicted_Conflicts_Insert_Input>;
  on_conflict?: Maybe<Predicted_Conflicts_On_Conflict>;
};

/** aggregate avg on columns */
export type Predicted_Conflicts_Avg_Fields = {
  __typename?: 'predicted_conflicts_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "predicted_conflicts". All fields are combined with a logical 'AND'. */
export type Predicted_Conflicts_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Predicted_Conflicts_Bool_Exp>>>;
  _not?: Maybe<Predicted_Conflicts_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Predicted_Conflicts_Bool_Exp>>>;
  alert_level?: Maybe<String_Comparison_Exp>;
  conflict_contours?: Maybe<Geometry_Comparison_Exp>;
  conflict_intervals?: Maybe<Jsonb_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  observation_id?: Maybe<String_Comparison_Exp>;
  pruned?: Maybe<Boolean_Comparison_Exp>;
  time_to_violation_in_secs?: Maybe<Float8_Comparison_Exp>;
  time_to_violation_out_secs?: Maybe<Float8_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "predicted_conflicts" */
export enum Predicted_Conflicts_Constraint {
  /** unique or primary key constraint */
  PredictedConflictsPkey = 'predicted_conflicts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Predicted_Conflicts_Delete_At_Path_Input = {
  conflict_intervals?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Predicted_Conflicts_Delete_Elem_Input = {
  conflict_intervals?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Predicted_Conflicts_Delete_Key_Input = {
  conflict_intervals?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "predicted_conflicts" */
export type Predicted_Conflicts_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "predicted_conflicts" */
export type Predicted_Conflicts_Insert_Input = {
  alert_level?: Maybe<Scalars['String']>;
  conflict_contours?: Maybe<Scalars['geometry']>;
  conflict_intervals?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  observation_id?: Maybe<Scalars['String']>;
  pruned?: Maybe<Scalars['Boolean']>;
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Predicted_Conflicts_Max_Fields = {
  __typename?: 'predicted_conflicts_max_fields';
  alert_level?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  observation_id?: Maybe<Scalars['String']>;
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Max_Order_By = {
  alert_level?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  observation_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Predicted_Conflicts_Min_Fields = {
  __typename?: 'predicted_conflicts_min_fields';
  alert_level?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  observation_id?: Maybe<Scalars['String']>;
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Min_Order_By = {
  alert_level?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  observation_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** response of any mutation on the table "predicted_conflicts" */
export type Predicted_Conflicts_Mutation_Response = {
  __typename?: 'predicted_conflicts_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Predicted_Conflicts>;
};

/** input type for inserting object relation for remote table "predicted_conflicts" */
export type Predicted_Conflicts_Obj_Rel_Insert_Input = {
  data: Predicted_Conflicts_Insert_Input;
  on_conflict?: Maybe<Predicted_Conflicts_On_Conflict>;
};

/** on conflict condition type for table "predicted_conflicts" */
export type Predicted_Conflicts_On_Conflict = {
  constraint: Predicted_Conflicts_Constraint;
  update_columns: Array<Predicted_Conflicts_Update_Column>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};

/** ordering options when selecting data from "predicted_conflicts" */
export type Predicted_Conflicts_Order_By = {
  alert_level?: Maybe<Order_By>;
  conflict_contours?: Maybe<Order_By>;
  conflict_intervals?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  observation_id?: Maybe<Order_By>;
  pruned?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** primary key columns input for table: "predicted_conflicts" */
export type Predicted_Conflicts_Pk_Columns_Input = {
  /** Alert level that the observation has breached */
  alert_level: Scalars['String'];
  /** Identifier for the observation */
  observation_id: Scalars['String'];
  /** Serial number of the aircraft which reported the observation */
  vehicle_serial_number: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Predicted_Conflicts_Prepend_Input = {
  conflict_intervals?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "predicted_conflicts" */
export enum Predicted_Conflicts_Select_Column {
  /** column name */
  AlertLevel = 'alert_level',
  /** column name */
  ConflictContours = 'conflict_contours',
  /** column name */
  ConflictIntervals = 'conflict_intervals',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  Pruned = 'pruned',
  /** column name */
  TimeToViolationInSecs = 'time_to_violation_in_secs',
  /** column name */
  TimeToViolationOutSecs = 'time_to_violation_out_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number'
}

/** input type for updating data in table "predicted_conflicts" */
export type Predicted_Conflicts_Set_Input = {
  alert_level?: Maybe<Scalars['String']>;
  conflict_contours?: Maybe<Scalars['geometry']>;
  conflict_intervals?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  observation_id?: Maybe<Scalars['String']>;
  pruned?: Maybe<Scalars['Boolean']>;
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Predicted_Conflicts_Stddev_Fields = {
  __typename?: 'predicted_conflicts_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Predicted_Conflicts_Stddev_Pop_Fields = {
  __typename?: 'predicted_conflicts_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Predicted_Conflicts_Stddev_Samp_Fields = {
  __typename?: 'predicted_conflicts_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Predicted_Conflicts_Sum_Fields = {
  __typename?: 'predicted_conflicts_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  time_to_violation_in_secs?: Maybe<Scalars['float8']>;
  time_to_violation_out_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** update columns of table "predicted_conflicts" */
export enum Predicted_Conflicts_Update_Column {
  /** column name */
  AlertLevel = 'alert_level',
  /** column name */
  ConflictContours = 'conflict_contours',
  /** column name */
  ConflictIntervals = 'conflict_intervals',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  ObservationId = 'observation_id',
  /** column name */
  Pruned = 'pruned',
  /** column name */
  TimeToViolationInSecs = 'time_to_violation_in_secs',
  /** column name */
  TimeToViolationOutSecs = 'time_to_violation_out_secs',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number'
}

/** aggregate var_pop on columns */
export type Predicted_Conflicts_Var_Pop_Fields = {
  __typename?: 'predicted_conflicts_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Predicted_Conflicts_Var_Samp_Fields = {
  __typename?: 'predicted_conflicts_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Predicted_Conflicts_Variance_Fields = {
  __typename?: 'predicted_conflicts_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  time_to_violation_in_secs?: Maybe<Scalars['Float']>;
  time_to_violation_out_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "predicted_conflicts" */
export type Predicted_Conflicts_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  time_to_violation_in_secs?: Maybe<Order_By>;
  time_to_violation_out_secs?: Maybe<Order_By>;
};

/** query root */
export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "air_traffic_deconfliction_algorithm_types" */
  air_traffic_deconfliction_algorithm_types: Array<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** fetch aggregated fields from the table: "air_traffic_deconfliction_algorithm_types" */
  air_traffic_deconfliction_algorithm_types_aggregate: Air_Traffic_Deconfliction_Algorithm_Types_Aggregate;
  /** fetch data from the table: "air_traffic_deconfliction_algorithm_types" using primary key columns */
  air_traffic_deconfliction_algorithm_types_by_pk?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** fetch data from the table: "air_traffic_monitor_tasks" */
  air_traffic_monitor_tasks: Array<Air_Traffic_Monitor_Tasks>;
  /** fetch aggregated fields from the table: "air_traffic_monitor_tasks" */
  air_traffic_monitor_tasks_aggregate: Air_Traffic_Monitor_Tasks_Aggregate;
  /** fetch data from the table: "air_traffic_monitor_tasks" using primary key columns */
  air_traffic_monitor_tasks_by_pk?: Maybe<Air_Traffic_Monitor_Tasks>;
  /** fetch data from the table: "air_traffic_tracks" */
  air_traffic_tracks: Array<Air_Traffic_Tracks>;
  /** fetch aggregated fields from the table: "air_traffic_tracks" */
  air_traffic_tracks_aggregate: Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "air_traffic_tracks" using primary key columns */
  air_traffic_tracks_by_pk?: Maybe<Air_Traffic_Tracks>;
  /** fetch data from the table: "aircraft_type_designators" */
  aircraft_type_designators: Array<Aircraft_Type_Designators>;
  /** fetch aggregated fields from the table: "aircraft_type_designators" */
  aircraft_type_designators_aggregate: Aircraft_Type_Designators_Aggregate;
  /** fetch data from the table: "aircraft_type_designators" using primary key columns */
  aircraft_type_designators_by_pk?: Maybe<Aircraft_Type_Designators>;
  /** fetch data from the table: "airspaces" */
  airspaces: Array<Airspaces>;
  /** fetch aggregated fields from the table: "airspaces" */
  airspaces_aggregate: Airspaces_Aggregate;
  /** fetch data from the table: "airspaces" using primary key columns */
  airspaces_by_pk?: Maybe<Airspaces>;
  /** fetch data from the table: "available_aircraft_command_sets" */
  available_aircraft_command_sets: Array<Available_Aircraft_Command_Sets>;
  /** fetch aggregated fields from the table: "available_aircraft_command_sets" */
  available_aircraft_command_sets_aggregate: Available_Aircraft_Command_Sets_Aggregate;
  /** fetch data from the table: "available_aircraft_command_sets" using primary key columns */
  available_aircraft_command_sets_by_pk?: Maybe<Available_Aircraft_Command_Sets>;
  /** fetch data from the table: "available_aircraft_command_state_keys" */
  available_aircraft_command_state_keys: Array<Available_Aircraft_Command_State_Keys>;
  /** fetch aggregated fields from the table: "available_aircraft_command_state_keys" */
  available_aircraft_command_state_keys_aggregate: Available_Aircraft_Command_State_Keys_Aggregate;
  /** fetch data from the table: "available_aircraft_command_state_keys" using primary key columns */
  available_aircraft_command_state_keys_by_pk?: Maybe<Available_Aircraft_Command_State_Keys>;
  /** fetch data from the table: "badge_tokens" */
  badge_tokens: Array<Badge_Tokens>;
  /** fetch aggregated fields from the table: "badge_tokens" */
  badge_tokens_aggregate: Badge_Tokens_Aggregate;
  /** fetch data from the table: "badge_tokens" using primary key columns */
  badge_tokens_by_pk?: Maybe<Badge_Tokens>;
  /** fetch data from the table: "batteries" */
  batteries: Array<Batteries>;
  /** fetch aggregated fields from the table: "batteries" */
  batteries_aggregate: Batteries_Aggregate;
  /** fetch data from the table: "batteries" using primary key columns */
  batteries_by_pk?: Maybe<Batteries>;
  /** fetch data from the table: "contingency_landing_spots" */
  contingency_landing_spots: Array<Contingency_Landing_Spots>;
  /** fetch aggregated fields from the table: "contingency_landing_spots" */
  contingency_landing_spots_aggregate: Contingency_Landing_Spots_Aggregate;
  /** fetch data from the table: "contingency_landing_spots" using primary key columns */
  contingency_landing_spots_by_pk?: Maybe<Contingency_Landing_Spots>;
  /** fetch data from the table: "current_air_traffic_proximity_recordings" */
  current_air_traffic_proximity_recordings: Array<Current_Air_Traffic_Proximity_Recordings>;
  /** fetch aggregated fields from the table: "current_air_traffic_proximity_recordings" */
  current_air_traffic_proximity_recordings_aggregate: Current_Air_Traffic_Proximity_Recordings_Aggregate;
  /** fetch data from the table: "current_air_traffic_tracks" */
  current_air_traffic_tracks: Array<Current_Air_Traffic_Tracks>;
  /** fetch aggregated fields from the table: "current_air_traffic_tracks" */
  current_air_traffic_tracks_aggregate: Current_Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "current_utm_air_traffic_tracks" */
  current_utm_air_traffic_tracks: Array<Current_Utm_Air_Traffic_Tracks>;
  /** fetch aggregated fields from the table: "current_utm_air_traffic_tracks" */
  current_utm_air_traffic_tracks_aggregate: Current_Utm_Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "daa_observations" */
  daa_observations: Array<Daa_Observations>;
  /** fetch aggregated fields from the table: "daa_observations" */
  daa_observations_aggregate: Daa_Observations_Aggregate;
  /** fetch data from the table: "daa_observations" using primary key columns */
  daa_observations_by_pk?: Maybe<Daa_Observations>;
  /** fetch data from the table: "daa_statuses" */
  daa_statuses: Array<Daa_Statuses>;
  /** fetch aggregated fields from the table: "daa_statuses" */
  daa_statuses_aggregate: Daa_Statuses_Aggregate;
  /** fetch data from the table: "daa_statuses" using primary key columns */
  daa_statuses_by_pk?: Maybe<Daa_Statuses>;
  /** fetch data from the table: "env_feature_flags" */
  env_feature_flags: Array<Env_Feature_Flags>;
  /** fetch aggregated fields from the table: "env_feature_flags" */
  env_feature_flags_aggregate: Env_Feature_Flags_Aggregate;
  /** fetch data from the table: "env_feature_flags" using primary key columns */
  env_feature_flags_by_pk?: Maybe<Env_Feature_Flags>;
  /** execute function "fetch_current_deduped_air_traffic_tracks" which returns "current_utm_air_traffic_tracks" */
  fetch_current_deduped_air_traffic_tracks: Array<Current_Utm_Air_Traffic_Tracks>;
  /** execute function "fetch_current_deduped_air_traffic_tracks" and query aggregates on result of table type "current_utm_air_traffic_tracks" */
  fetch_current_deduped_air_traffic_tracks_aggregate: Current_Utm_Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "file_asset_types" */
  file_asset_types: Array<File_Asset_Types>;
  /** fetch aggregated fields from the table: "file_asset_types" */
  file_asset_types_aggregate: File_Asset_Types_Aggregate;
  /** fetch data from the table: "file_asset_types" using primary key columns */
  file_asset_types_by_pk?: Maybe<File_Asset_Types>;
  /** fetch data from the table: "file_assets" */
  file_assets: Array<File_Assets>;
  /** fetch aggregated fields from the table: "file_assets" */
  file_assets_aggregate: File_Assets_Aggregate;
  /** fetch data from the table: "file_assets" using primary key columns */
  file_assets_by_pk?: Maybe<File_Assets>;
  /** fetch data from the table: "flight_commands" */
  flight_commands: Array<Flight_Commands>;
  /** fetch aggregated fields from the table: "flight_commands" */
  flight_commands_aggregate: Flight_Commands_Aggregate;
  /** fetch data from the table: "flight_commands" using primary key columns */
  flight_commands_by_pk?: Maybe<Flight_Commands>;
  /** fetch data from the table: "flight_derivation_reports" */
  flight_derivation_reports: Array<Flight_Derivation_Reports>;
  /** fetch aggregated fields from the table: "flight_derivation_reports" */
  flight_derivation_reports_aggregate: Flight_Derivation_Reports_Aggregate;
  /** fetch data from the table: "flight_derivation_reports" using primary key columns */
  flight_derivation_reports_by_pk?: Maybe<Flight_Derivation_Reports>;
  /** fetch data from the table: "flight_plan_current_rpic_view" */
  flight_plan_current_rpic_view: Array<Flight_Plan_Current_Rpic_View>;
  /** fetch aggregated fields from the table: "flight_plan_current_rpic_view" */
  flight_plan_current_rpic_view_aggregate: Flight_Plan_Current_Rpic_View_Aggregate;
  /** fetch data from the table: "flight_plan_pilot_assignments" */
  flight_plan_pilot_assignments: Array<Flight_Plan_Pilot_Assignments>;
  /** fetch aggregated fields from the table: "flight_plan_pilot_assignments" */
  flight_plan_pilot_assignments_aggregate: Flight_Plan_Pilot_Assignments_Aggregate;
  /** fetch data from the table: "flight_plan_pilot_assignments" using primary key columns */
  flight_plan_pilot_assignments_by_pk?: Maybe<Flight_Plan_Pilot_Assignments>;
  /** fetch data from the table: "flight_plan_statuses" */
  flight_plan_statuses: Array<Flight_Plan_Statuses>;
  /** fetch aggregated fields from the table: "flight_plan_statuses" */
  flight_plan_statuses_aggregate: Flight_Plan_Statuses_Aggregate;
  /** fetch data from the table: "flight_plan_statuses" using primary key columns */
  flight_plan_statuses_by_pk?: Maybe<Flight_Plan_Statuses>;
  /** fetch data from the table: "flight_plan_utm_providers" */
  flight_plan_utm_providers: Array<Flight_Plan_Utm_Providers>;
  /** fetch aggregated fields from the table: "flight_plan_utm_providers" */
  flight_plan_utm_providers_aggregate: Flight_Plan_Utm_Providers_Aggregate;
  /** fetch data from the table: "flight_plan_utm_providers" using primary key columns */
  flight_plan_utm_providers_by_pk?: Maybe<Flight_Plan_Utm_Providers>;
  /** fetch data from the table: "flight_plans" */
  flight_plans: Array<Flight_Plans>;
  /** fetch aggregated fields from the table: "flight_plans" */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  /** fetch data from the table: "flight_plans" using primary key columns */
  flight_plans_by_pk?: Maybe<Flight_Plans>;
  /** fetch data from the table: "flight_routes" */
  flight_routes: Array<Flight_Routes>;
  /** fetch aggregated fields from the table: "flight_routes" */
  flight_routes_aggregate: Flight_Routes_Aggregate;
  /** fetch data from the table: "flight_routes" using primary key columns */
  flight_routes_by_pk?: Maybe<Flight_Routes>;
  /** fetch data from the table: "flight_weather_data" */
  flight_weather_data: Array<Flight_Weather_Data>;
  /** fetch aggregated fields from the table: "flight_weather_data" */
  flight_weather_data_aggregate: Flight_Weather_Data_Aggregate;
  /** fetch data from the table: "flight_weather_data" using primary key columns */
  flight_weather_data_by_pk?: Maybe<Flight_Weather_Data>;
  /** fetch data from the table: "ground_asset_commands" */
  ground_asset_commands: Array<Ground_Asset_Commands>;
  /** fetch aggregated fields from the table: "ground_asset_commands" */
  ground_asset_commands_aggregate: Ground_Asset_Commands_Aggregate;
  /** fetch data from the table: "ground_asset_commands" using primary key columns */
  ground_asset_commands_by_pk?: Maybe<Ground_Asset_Commands>;
  /** fetch data from the table: "ground_asset_model_parameter_types" */
  ground_asset_model_parameter_types: Array<Ground_Asset_Model_Parameter_Types>;
  /** fetch aggregated fields from the table: "ground_asset_model_parameter_types" */
  ground_asset_model_parameter_types_aggregate: Ground_Asset_Model_Parameter_Types_Aggregate;
  /** fetch data from the table: "ground_asset_model_parameter_types" using primary key columns */
  ground_asset_model_parameter_types_by_pk?: Maybe<Ground_Asset_Model_Parameter_Types>;
  /** fetch data from the table: "ground_asset_model_parameters" */
  ground_asset_model_parameters: Array<Ground_Asset_Model_Parameters>;
  /** fetch aggregated fields from the table: "ground_asset_model_parameters" */
  ground_asset_model_parameters_aggregate: Ground_Asset_Model_Parameters_Aggregate;
  /** fetch data from the table: "ground_asset_model_parameters" using primary key columns */
  ground_asset_model_parameters_by_pk?: Maybe<Ground_Asset_Model_Parameters>;
  /** fetch data from the table: "ground_asset_model_types" */
  ground_asset_model_types: Array<Ground_Asset_Model_Types>;
  /** fetch aggregated fields from the table: "ground_asset_model_types" */
  ground_asset_model_types_aggregate: Ground_Asset_Model_Types_Aggregate;
  /** fetch data from the table: "ground_asset_model_types" using primary key columns */
  ground_asset_model_types_by_pk?: Maybe<Ground_Asset_Model_Types>;
  /** fetch data from the table: "ground_asset_models" */
  ground_asset_models: Array<Ground_Asset_Models>;
  /** fetch aggregated fields from the table: "ground_asset_models" */
  ground_asset_models_aggregate: Ground_Asset_Models_Aggregate;
  /** fetch data from the table: "ground_asset_models" using primary key columns */
  ground_asset_models_by_pk?: Maybe<Ground_Asset_Models>;
  /** fetch data from the table: "ground_asset_networks" */
  ground_asset_networks: Array<Ground_Asset_Networks>;
  /** fetch aggregated fields from the table: "ground_asset_networks" */
  ground_asset_networks_aggregate: Ground_Asset_Networks_Aggregate;
  /** fetch data from the table: "ground_asset_networks" using primary key columns */
  ground_asset_networks_by_pk?: Maybe<Ground_Asset_Networks>;
  /** fetch data from the table: "ground_asset_status_values" */
  ground_asset_status_values: Array<Ground_Asset_Status_Values>;
  /** fetch aggregated fields from the table: "ground_asset_status_values" */
  ground_asset_status_values_aggregate: Ground_Asset_Status_Values_Aggregate;
  /** fetch data from the table: "ground_asset_status_values" using primary key columns */
  ground_asset_status_values_by_pk?: Maybe<Ground_Asset_Status_Values>;
  /** fetch data from the table: "kafka_serialized_ground_asset_statuses" */
  ground_asset_statuses: Array<Kafka_Serialized_Ground_Asset_Statuses>;
  /** fetch data from the table: "ground_assets" */
  ground_assets: Array<Ground_Assets>;
  /** fetch aggregated fields from the table: "ground_assets" */
  ground_assets_aggregate: Ground_Assets_Aggregate;
  /** fetch data from the table: "ground_assets" using primary key columns */
  ground_assets_by_pk?: Maybe<Ground_Assets>;
  /** fetch data from the table: "ground_control_workflow_state_processing_statuses" */
  ground_control_workflow_state_processing_statuses: Array<Ground_Control_Workflow_State_Processing_Statuses>;
  /** fetch aggregated fields from the table: "ground_control_workflow_state_processing_statuses" */
  ground_control_workflow_state_processing_statuses_aggregate: Ground_Control_Workflow_State_Processing_Statuses_Aggregate;
  /** fetch data from the table: "ground_control_workflow_state_processing_statuses" using primary key columns */
  ground_control_workflow_state_processing_statuses_by_pk?: Maybe<Ground_Control_Workflow_State_Processing_Statuses>;
  /** fetch data from the table: "historical_serialized_ground_asset_statuses" */
  historical_serialized_ground_asset_statuses: Array<Historical_Serialized_Ground_Asset_Statuses>;
  /** fetch aggregated fields from the table: "historical_serialized_ground_asset_statuses" */
  historical_serialized_ground_asset_statuses_aggregate: Historical_Serialized_Ground_Asset_Statuses_Aggregate;
  /** fetch data from the table: "historical_serialized_ground_asset_statuses" using primary key columns */
  historical_serialized_ground_asset_statuses_by_pk?: Maybe<Historical_Serialized_Ground_Asset_Statuses>;
  /** fetch data from the table: "historical_serialized_vehicle_statuses" */
  historical_serialized_vehicle_statuses: Array<Historical_Serialized_Vehicle_Statuses>;
  /** fetch aggregated fields from the table: "historical_serialized_vehicle_statuses" */
  historical_serialized_vehicle_statuses_aggregate: Historical_Serialized_Vehicle_Statuses_Aggregate;
  /** fetch data from the table: "historical_serialized_vehicle_statuses" using primary key columns */
  historical_serialized_vehicle_statuses_by_pk?: Maybe<Historical_Serialized_Vehicle_Statuses>;
  /** fetch data from the table: "historical_vehicle_positions" */
  historical_vehicle_positions: Array<Historical_Vehicle_Positions>;
  /** fetch aggregated fields from the table: "historical_vehicle_positions" */
  historical_vehicle_positions_aggregate: Historical_Vehicle_Positions_Aggregate;
  /** fetch data from the table: "historical_vehicle_positions" using primary key columns */
  historical_vehicle_positions_by_pk?: Maybe<Historical_Vehicle_Positions>;
  /** fetch data from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  kafka_air_traffic_vehicle_flight_proximity_recordings: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** fetch aggregated fields from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  kafka_air_traffic_vehicle_flight_proximity_recordings_aggregate: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate;
  /** fetch data from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" using primary key columns */
  kafka_air_traffic_vehicle_flight_proximity_recordings_by_pk?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** fetch data from the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  kafka_cached_air_traffic_flight_proximity_recordings: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** fetch aggregated fields from the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  kafka_cached_air_traffic_flight_proximity_recordings_aggregate: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate;
  /** fetch data from the table: "kafka_cached_air_traffic_flight_proximity_recordings" using primary key columns */
  kafka_cached_air_traffic_flight_proximity_recordings_by_pk?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** fetch data from the table: "kafka_mqtt_vehicle_status_messages" */
  kafka_mqtt_vehicle_status_messages: Array<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** fetch aggregated fields from the table: "kafka_mqtt_vehicle_status_messages" */
  kafka_mqtt_vehicle_status_messages_aggregate: Kafka_Mqtt_Vehicle_Status_Messages_Aggregate;
  /** fetch data from the table: "kafka_mqtt_vehicle_status_messages" using primary key columns */
  kafka_mqtt_vehicle_status_messages_by_pk?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** fetch aggregated fields from the table: "kafka_serialized_ground_asset_statuses" */
  kafka_serialized_ground_asset_statuses_aggregate: Kafka_Serialized_Ground_Asset_Statuses_Aggregate;
  /** fetch data from the table: "kafka_serialized_ground_asset_statuses" using primary key columns */
  kafka_serialized_ground_asset_statuses_by_pk?: Maybe<Kafka_Serialized_Ground_Asset_Statuses>;
  /** fetch data from the table: "landing_request_statuses" */
  landing_request_statuses: Array<Landing_Request_Statuses>;
  /** fetch aggregated fields from the table: "landing_request_statuses" */
  landing_request_statuses_aggregate: Landing_Request_Statuses_Aggregate;
  /** fetch data from the table: "landing_request_statuses" using primary key columns */
  landing_request_statuses_by_pk?: Maybe<Landing_Request_Statuses>;
  /** fetch data from the table: "landing_requests" */
  landing_requests: Array<Landing_Requests>;
  /** fetch aggregated fields from the table: "landing_requests" */
  landing_requests_aggregate: Landing_Requests_Aggregate;
  /** fetch data from the table: "landing_requests" using primary key columns */
  landing_requests_by_pk?: Maybe<Landing_Requests>;
  /** fetch data from the table: "last_vehicle_anomaly_statuses" */
  last_vehicle_anomaly_statuses: Array<Last_Vehicle_Anomaly_Statuses>;
  /** fetch aggregated fields from the table: "last_vehicle_anomaly_statuses" */
  last_vehicle_anomaly_statuses_aggregate: Last_Vehicle_Anomaly_Statuses_Aggregate;
  /** fetch data from the table: "last_vehicle_anomaly_statuses" using primary key columns */
  last_vehicle_anomaly_statuses_by_pk?: Maybe<Last_Vehicle_Anomaly_Statuses>;
  /** fetch data from the table: "manifest_events" */
  manifest_events: Array<Manifest_Events>;
  /** fetch aggregated fields from the table: "manifest_events" */
  manifest_events_aggregate: Manifest_Events_Aggregate;
  /** fetch data from the table: "manifest_events" using primary key columns */
  manifest_events_by_pk?: Maybe<Manifest_Events>;
  /** fetch data from the table: "manifest_items" */
  manifest_items: Array<Manifest_Items>;
  /** fetch aggregated fields from the table: "manifest_items" */
  manifest_items_aggregate: Manifest_Items_Aggregate;
  /** fetch data from the table: "manifest_items" using primary key columns */
  manifest_items_by_pk?: Maybe<Manifest_Items>;
  /** fetch data from the table: "manifest_products" */
  manifest_products: Array<Manifest_Products>;
  /** fetch aggregated fields from the table: "manifest_products" */
  manifest_products_aggregate: Manifest_Products_Aggregate;
  /** fetch data from the table: "manifest_products" using primary key columns */
  manifest_products_by_pk?: Maybe<Manifest_Products>;
  /** fetch data from the table: "manifest_status_audits" */
  manifest_status_audits: Array<Manifest_Status_Audits>;
  /** fetch aggregated fields from the table: "manifest_status_audits" */
  manifest_status_audits_aggregate: Manifest_Status_Audits_Aggregate;
  /** fetch data from the table: "manifest_status_audits" using primary key columns */
  manifest_status_audits_by_pk?: Maybe<Manifest_Status_Audits>;
  /** fetch data from the table: "manifest_types" */
  manifest_types: Array<Manifest_Types>;
  /** fetch aggregated fields from the table: "manifest_types" */
  manifest_types_aggregate: Manifest_Types_Aggregate;
  /** fetch data from the table: "manifest_types" using primary key columns */
  manifest_types_by_pk?: Maybe<Manifest_Types>;
  /** fetch data from the table: "manifests" */
  manifests: Array<Manifests>;
  /** fetch aggregated fields from the table: "manifests" */
  manifests_aggregate: Manifests_Aggregate;
  /** fetch data from the table: "manifests_arrived_within_minute" */
  manifests_arrived_within_minute: Array<Manifests_Arrived_Within_Minute>;
  /** fetch aggregated fields from the table: "manifests_arrived_within_minute" */
  manifests_arrived_within_minute_aggregate: Manifests_Arrived_Within_Minute_Aggregate;
  /** fetch data from the table: "manifests" using primary key columns */
  manifests_by_pk?: Maybe<Manifests>;
  /** fetch data from the table: "network_utm_providers" */
  network_utm_providers: Array<Network_Utm_Providers>;
  /** fetch aggregated fields from the table: "network_utm_providers" */
  network_utm_providers_aggregate: Network_Utm_Providers_Aggregate;
  /** fetch data from the table: "network_utm_providers" using primary key columns */
  network_utm_providers_by_pk?: Maybe<Network_Utm_Providers>;
  /** fetch data from the table: "networks" */
  networks: Array<Networks>;
  /** fetch aggregated fields from the table: "networks" */
  networks_aggregate: Networks_Aggregate;
  /** fetch data from the table: "networks" using primary key columns */
  networks_by_pk?: Maybe<Networks>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "paths" */
  paths: Array<Paths>;
  /** fetch aggregated fields from the table: "paths" */
  paths_aggregate: Paths_Aggregate;
  /** fetch data from the table: "paths" using primary key columns */
  paths_by_pk?: Maybe<Paths>;
  /** fetch data from the table: "pickup_requests" */
  pickup_requests: Array<Pickup_Requests>;
  /** fetch aggregated fields from the table: "pickup_requests" */
  pickup_requests_aggregate: Pickup_Requests_Aggregate;
  /** fetch data from the table: "pickup_requests" using primary key columns */
  pickup_requests_by_pk?: Maybe<Pickup_Requests>;
  /** fetch data from the table: "positive_exchange_of_flight_control_requests" */
  positive_exchange_of_flight_control_requests: Array<Positive_Exchange_Of_Flight_Control_Requests>;
  /** fetch aggregated fields from the table: "positive_exchange_of_flight_control_requests" */
  positive_exchange_of_flight_control_requests_aggregate: Positive_Exchange_Of_Flight_Control_Requests_Aggregate;
  /** fetch data from the table: "positive_exchange_of_flight_control_requests" using primary key columns */
  positive_exchange_of_flight_control_requests_by_pk?: Maybe<Positive_Exchange_Of_Flight_Control_Requests>;
  /** fetch data from the table: "predicted_conflicts" */
  predicted_conflicts: Array<Predicted_Conflicts>;
  /** fetch aggregated fields from the table: "predicted_conflicts" */
  predicted_conflicts_aggregate: Predicted_Conflicts_Aggregate;
  /** fetch data from the table: "predicted_conflicts" using primary key columns */
  predicted_conflicts_by_pk?: Maybe<Predicted_Conflicts>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table: "squawk_severities" */
  squawk_severities: Array<Squawk_Severities>;
  /** fetch aggregated fields from the table: "squawk_severities" */
  squawk_severities_aggregate: Squawk_Severities_Aggregate;
  /** fetch data from the table: "squawk_severities" using primary key columns */
  squawk_severities_by_pk?: Maybe<Squawk_Severities>;
  /** fetch data from the table: "squawk_squawkable_types" */
  squawk_squawkable_types: Array<Squawk_Squawkable_Types>;
  /** fetch aggregated fields from the table: "squawk_squawkable_types" */
  squawk_squawkable_types_aggregate: Squawk_Squawkable_Types_Aggregate;
  /** fetch data from the table: "squawk_squawkable_types" using primary key columns */
  squawk_squawkable_types_by_pk?: Maybe<Squawk_Squawkable_Types>;
  /** fetch data from the table: "squawk_statuses" */
  squawk_statuses: Array<Squawk_Statuses>;
  /** fetch aggregated fields from the table: "squawk_statuses" */
  squawk_statuses_aggregate: Squawk_Statuses_Aggregate;
  /** fetch data from the table: "squawk_statuses" using primary key columns */
  squawk_statuses_by_pk?: Maybe<Squawk_Statuses>;
  /** fetch data from the table: "squawks" */
  squawks: Array<Squawks>;
  /** fetch aggregated fields from the table: "squawks" */
  squawks_aggregate: Squawks_Aggregate;
  /** fetch data from the table: "squawks" using primary key columns */
  squawks_by_pk?: Maybe<Squawks>;
  /** fetch data from the table: "stations" */
  stations: Array<Stations>;
  /** fetch aggregated fields from the table: "stations" */
  stations_aggregate: Stations_Aggregate;
  /** fetch data from the table: "stations" using primary key columns */
  stations_by_pk?: Maybe<Stations>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** fetch data from the table: "type_cert_flight_analysis_data" */
  type_cert_flight_analysis_data: Array<Type_Cert_Flight_Analysis_Data>;
  /** fetch aggregated fields from the table: "type_cert_flight_analysis_data" */
  type_cert_flight_analysis_data_aggregate: Type_Cert_Flight_Analysis_Data_Aggregate;
  /** fetch data from the table: "type_cert_flight_analysis_data" using primary key columns */
  type_cert_flight_analysis_data_by_pk?: Maybe<Type_Cert_Flight_Analysis_Data>;
  /** fetch data from the table: "type_cert_manual_data" */
  type_cert_manual_data: Array<Type_Cert_Manual_Data>;
  /** fetch aggregated fields from the table: "type_cert_manual_data" */
  type_cert_manual_data_aggregate: Type_Cert_Manual_Data_Aggregate;
  /** fetch data from the table: "type_cert_manual_data" using primary key columns */
  type_cert_manual_data_by_pk?: Maybe<Type_Cert_Manual_Data>;
  /** fetch data from the table: "user_app_states" */
  user_app_states: Array<User_App_States>;
  /** fetch aggregated fields from the table: "user_app_states" */
  user_app_states_aggregate: User_App_States_Aggregate;
  /** fetch data from the table: "user_networks" */
  user_networks: Array<User_Networks>;
  /** fetch aggregated fields from the table: "user_networks" */
  user_networks_aggregate: User_Networks_Aggregate;
  /** fetch data from the table: "user_networks" using primary key columns */
  user_networks_by_pk?: Maybe<User_Networks>;
  /** fetch data from the table: "user_permissions_view" */
  user_permissions_view: Array<User_Permissions_View>;
  /** fetch aggregated fields from the table: "user_permissions_view" */
  user_permissions_view_aggregate: User_Permissions_View_Aggregate;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "vehicle_airworthiness_categories" */
  vehicle_airworthiness_categories: Array<Vehicle_Airworthiness_Categories>;
  /** fetch aggregated fields from the table: "vehicle_airworthiness_categories" */
  vehicle_airworthiness_categories_aggregate: Vehicle_Airworthiness_Categories_Aggregate;
  /** fetch data from the table: "vehicle_airworthiness_categories" using primary key columns */
  vehicle_airworthiness_categories_by_pk?: Maybe<Vehicle_Airworthiness_Categories>;
  /** fetch data from the table: "vehicle_alerts" */
  vehicle_alerts: Array<Vehicle_Alerts>;
  /** fetch aggregated fields from the table: "vehicle_alerts" */
  vehicle_alerts_aggregate: Vehicle_Alerts_Aggregate;
  /** fetch data from the table: "vehicle_alerts" using primary key columns */
  vehicle_alerts_by_pk?: Maybe<Vehicle_Alerts>;
  /** fetch data from the table: "vehicle_flight_state_enum" */
  vehicle_flight_state_enum: Array<Vehicle_Flight_State_Enum>;
  /** fetch aggregated fields from the table: "vehicle_flight_state_enum" */
  vehicle_flight_state_enum_aggregate: Vehicle_Flight_State_Enum_Aggregate;
  /** fetch data from the table: "vehicle_flight_state_enum" using primary key columns */
  vehicle_flight_state_enum_by_pk?: Maybe<Vehicle_Flight_State_Enum>;
  /** fetch data from the table: "vehicle_flight_statuses" */
  vehicle_flight_statuses: Array<Vehicle_Flight_Statuses>;
  /** fetch aggregated fields from the table: "vehicle_flight_statuses" */
  vehicle_flight_statuses_aggregate: Vehicle_Flight_Statuses_Aggregate;
  /** fetch data from the table: "vehicle_flight_statuses" using primary key columns */
  vehicle_flight_statuses_by_pk?: Maybe<Vehicle_Flight_Statuses>;
  /** fetch data from the table: "vehicle_model_parameter_types" */
  vehicle_model_parameter_types: Array<Vehicle_Model_Parameter_Types>;
  /** fetch aggregated fields from the table: "vehicle_model_parameter_types" */
  vehicle_model_parameter_types_aggregate: Vehicle_Model_Parameter_Types_Aggregate;
  /** fetch data from the table: "vehicle_model_parameter_types" using primary key columns */
  vehicle_model_parameter_types_by_pk?: Maybe<Vehicle_Model_Parameter_Types>;
  /** fetch data from the table: "vehicle_model_parameters" */
  vehicle_model_parameters: Array<Vehicle_Model_Parameters>;
  /** fetch aggregated fields from the table: "vehicle_model_parameters" */
  vehicle_model_parameters_aggregate: Vehicle_Model_Parameters_Aggregate;
  /** fetch data from the table: "vehicle_model_parameters" using primary key columns */
  vehicle_model_parameters_by_pk?: Maybe<Vehicle_Model_Parameters>;
  /** fetch data from the table: "vehicle_models" */
  vehicle_models: Array<Vehicle_Models>;
  /** fetch aggregated fields from the table: "vehicle_models" */
  vehicle_models_aggregate: Vehicle_Models_Aggregate;
  /** fetch data from the table: "vehicle_models_ancestors" */
  vehicle_models_ancestors: Array<Vehicle_Models_Ancestors>;
  /** fetch aggregated fields from the table: "vehicle_models_ancestors" */
  vehicle_models_ancestors_aggregate: Vehicle_Models_Ancestors_Aggregate;
  /** fetch data from the table: "vehicle_models_ancestors" using primary key columns */
  vehicle_models_ancestors_by_pk?: Maybe<Vehicle_Models_Ancestors>;
  /** fetch data from the table: "vehicle_models" using primary key columns */
  vehicle_models_by_pk?: Maybe<Vehicle_Models>;
  /** fetch data from the table: "vehicle_networks" */
  vehicle_networks: Array<Vehicle_Networks>;
  /** fetch aggregated fields from the table: "vehicle_networks" */
  vehicle_networks_aggregate: Vehicle_Networks_Aggregate;
  /** fetch data from the table: "vehicle_networks" using primary key columns */
  vehicle_networks_by_pk?: Maybe<Vehicle_Networks>;
  /** fetch data from the table: "vehicle_pilot_assignments" */
  vehicle_pilot_assignments: Array<Vehicle_Pilot_Assignments>;
  /** fetch aggregated fields from the table: "vehicle_pilot_assignments" */
  vehicle_pilot_assignments_aggregate: Vehicle_Pilot_Assignments_Aggregate;
  /** fetch data from the table: "vehicle_pilot_assignments" using primary key columns */
  vehicle_pilot_assignments_by_pk?: Maybe<Vehicle_Pilot_Assignments>;
  /** fetch data from the table: "vehicle_priority_event_keys" */
  vehicle_priority_event_keys: Array<Vehicle_Priority_Event_Keys>;
  /** fetch aggregated fields from the table: "vehicle_priority_event_keys" */
  vehicle_priority_event_keys_aggregate: Vehicle_Priority_Event_Keys_Aggregate;
  /** fetch data from the table: "vehicle_priority_event_keys" using primary key columns */
  vehicle_priority_event_keys_by_pk?: Maybe<Vehicle_Priority_Event_Keys>;
  /** fetch data from the table: "vehicle_priority_events" */
  vehicle_priority_events: Array<Vehicle_Priority_Events>;
  /** fetch aggregated fields from the table: "vehicle_priority_events" */
  vehicle_priority_events_aggregate: Vehicle_Priority_Events_Aggregate;
  /** fetch data from the table: "vehicle_priority_events" using primary key columns */
  vehicle_priority_events_by_pk?: Maybe<Vehicle_Priority_Events>;
  /** fetch data from the table: "vehicle_status_updates" */
  vehicle_status_updates: Array<Vehicle_Status_Updates>;
  /** fetch aggregated fields from the table: "vehicle_status_updates" */
  vehicle_status_updates_aggregate: Vehicle_Status_Updates_Aggregate;
  /** fetch data from the table: "vehicle_status_updates" using primary key columns */
  vehicle_status_updates_by_pk?: Maybe<Vehicle_Status_Updates>;
  /** fetch data from the table: "kafka_serialized_vehicle_statuses" */
  vehicle_statuses: Array<Kafka_Serialized_Vehicle_Statuses>;
  /** fetch aggregated fields from the table: "kafka_serialized_vehicle_statuses" */
  vehicle_statuses_aggregate: Kafka_Serialized_Vehicle_Statuses_Aggregate;
  /** fetch data from the table: "kafka_serialized_vehicle_statuses" using primary key columns */
  vehicle_statuses_by_pk?: Maybe<Kafka_Serialized_Vehicle_Statuses>;
  /** fetch data from the table: "vehicles" */
  vehicles: Array<Vehicles>;
  /** fetch aggregated fields from the table: "vehicles" */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
};


/** query root */
export type Query_RootAir_Traffic_Deconfliction_Algorithm_TypesArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Order_By>>;
  where?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
};


/** query root */
export type Query_RootAir_Traffic_Deconfliction_Algorithm_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Order_By>>;
  where?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
};


/** query root */
export type Query_RootAir_Traffic_Deconfliction_Algorithm_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootAir_Traffic_Monitor_TasksArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Monitor_Tasks_Order_By>>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};


/** query root */
export type Query_RootAir_Traffic_Monitor_Tasks_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Monitor_Tasks_Order_By>>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};


/** query root */
export type Query_RootAir_Traffic_Monitor_Tasks_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootAir_Traffic_TracksArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootAir_Traffic_Tracks_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootAir_Traffic_Tracks_By_PkArgs = {
  id: Scalars['String'];
};


/** query root */
export type Query_RootAircraft_Type_DesignatorsArgs = {
  distinct_on?: Maybe<Array<Aircraft_Type_Designators_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Aircraft_Type_Designators_Order_By>>;
  where?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
};


/** query root */
export type Query_RootAircraft_Type_Designators_AggregateArgs = {
  distinct_on?: Maybe<Array<Aircraft_Type_Designators_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Aircraft_Type_Designators_Order_By>>;
  where?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
};


/** query root */
export type Query_RootAircraft_Type_Designators_By_PkArgs = {
  designator: Scalars['String'];
};


/** query root */
export type Query_RootAirspacesArgs = {
  distinct_on?: Maybe<Array<Airspaces_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Airspaces_Order_By>>;
  where?: Maybe<Airspaces_Bool_Exp>;
};


/** query root */
export type Query_RootAirspaces_AggregateArgs = {
  distinct_on?: Maybe<Array<Airspaces_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Airspaces_Order_By>>;
  where?: Maybe<Airspaces_Bool_Exp>;
};


/** query root */
export type Query_RootAirspaces_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootAvailable_Aircraft_Command_SetsArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_Sets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_Sets_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
};


/** query root */
export type Query_RootAvailable_Aircraft_Command_Sets_AggregateArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_Sets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_Sets_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
};


/** query root */
export type Query_RootAvailable_Aircraft_Command_Sets_By_PkArgs = {
  aircraft_serial_number: Scalars['String'];
};


/** query root */
export type Query_RootAvailable_Aircraft_Command_State_KeysArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_State_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_State_Keys_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>;
};


/** query root */
export type Query_RootAvailable_Aircraft_Command_State_Keys_AggregateArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_State_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_State_Keys_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>;
};


/** query root */
export type Query_RootAvailable_Aircraft_Command_State_Keys_By_PkArgs = {
  state_key: Scalars['String'];
};


/** query root */
export type Query_RootBadge_TokensArgs = {
  distinct_on?: Maybe<Array<Badge_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Badge_Tokens_Order_By>>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};


/** query root */
export type Query_RootBadge_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Badge_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Badge_Tokens_Order_By>>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};


/** query root */
export type Query_RootBadge_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootBatteriesArgs = {
  distinct_on?: Maybe<Array<Batteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batteries_Order_By>>;
  where?: Maybe<Batteries_Bool_Exp>;
};


/** query root */
export type Query_RootBatteries_AggregateArgs = {
  distinct_on?: Maybe<Array<Batteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batteries_Order_By>>;
  where?: Maybe<Batteries_Bool_Exp>;
};


/** query root */
export type Query_RootBatteries_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootContingency_Landing_SpotsArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/** query root */
export type Query_RootContingency_Landing_Spots_AggregateArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/** query root */
export type Query_RootContingency_Landing_Spots_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootCurrent_Air_Traffic_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
};


/** query root */
export type Query_RootCurrent_Air_Traffic_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
};


/** query root */
export type Query_RootCurrent_Air_Traffic_TracksArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootCurrent_Air_Traffic_Tracks_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootCurrent_Utm_Air_Traffic_TracksArgs = {
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootCurrent_Utm_Air_Traffic_Tracks_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootDaa_ObservationsArgs = {
  distinct_on?: Maybe<Array<Daa_Observations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Observations_Order_By>>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};


/** query root */
export type Query_RootDaa_Observations_AggregateArgs = {
  distinct_on?: Maybe<Array<Daa_Observations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Observations_Order_By>>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};


/** query root */
export type Query_RootDaa_Observations_By_PkArgs = {
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};


/** query root */
export type Query_RootDaa_StatusesArgs = {
  distinct_on?: Maybe<Array<Daa_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Statuses_Order_By>>;
  where?: Maybe<Daa_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootDaa_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Daa_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Statuses_Order_By>>;
  where?: Maybe<Daa_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootDaa_Statuses_By_PkArgs = {
  vehicle_serial_number: Scalars['String'];
};


/** query root */
export type Query_RootEnv_Feature_FlagsArgs = {
  distinct_on?: Maybe<Array<Env_Feature_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Env_Feature_Flags_Order_By>>;
  where?: Maybe<Env_Feature_Flags_Bool_Exp>;
};


/** query root */
export type Query_RootEnv_Feature_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Env_Feature_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Env_Feature_Flags_Order_By>>;
  where?: Maybe<Env_Feature_Flags_Bool_Exp>;
};


/** query root */
export type Query_RootEnv_Feature_Flags_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFetch_Current_Deduped_Air_Traffic_TracksArgs = {
  args: Fetch_Current_Deduped_Air_Traffic_Tracks_Args;
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootFetch_Current_Deduped_Air_Traffic_Tracks_AggregateArgs = {
  args: Fetch_Current_Deduped_Air_Traffic_Tracks_Args;
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Asset_TypesArgs = {
  distinct_on?: Maybe<Array<File_Asset_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Asset_Types_Order_By>>;
  where?: Maybe<File_Asset_Types_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Asset_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Asset_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Asset_Types_Order_By>>;
  where?: Maybe<File_Asset_Types_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Asset_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootFile_AssetsArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/** query root */
export type Query_RootFile_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFlight_CommandsArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Commands_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFlight_Derivation_ReportsArgs = {
  distinct_on?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Derivation_Reports_Order_By>>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Derivation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Derivation_Reports_Order_By>>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Derivation_Reports_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
};


/** query root */
export type Query_RootFlight_Plan_Current_Rpic_ViewArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Current_Rpic_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Current_Rpic_View_Order_By>>;
  where?: Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Current_Rpic_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Current_Rpic_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Current_Rpic_View_Order_By>>;
  where?: Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Pilot_AssignmentsArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Pilot_Assignments_Order_By>>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Pilot_Assignments_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Pilot_Assignments_Order_By>>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Pilot_Assignments_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFlight_Plan_StatusesArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Statuses_Order_By>>;
  where?: Maybe<Flight_Plan_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Statuses_Order_By>>;
  where?: Maybe<Flight_Plan_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootFlight_Plan_Utm_ProvidersArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Utm_Providers_Order_By>>;
  where?: Maybe<Flight_Plan_Utm_Providers_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Utm_Providers_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Utm_Providers_Order_By>>;
  where?: Maybe<Flight_Plan_Utm_Providers_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plan_Utm_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFlight_RoutesArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Routes_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Routes_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootFlight_Weather_DataArgs = {
  distinct_on?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Weather_Data_Order_By>>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Weather_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Weather_Data_Order_By>>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};


/** query root */
export type Query_RootFlight_Weather_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGround_Asset_CommandsArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Commands_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGround_Asset_Model_Parameter_TypesArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Model_Parameter_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Model_Parameter_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootGround_Asset_Model_ParametersArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameters_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Model_Parameters_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameters_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Model_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGround_Asset_Model_TypesArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Types_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Model_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Types_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Model_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootGround_Asset_ModelsArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Models_Order_By>>;
  where?: Maybe<Ground_Asset_Models_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Models_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Models_Order_By>>;
  where?: Maybe<Ground_Asset_Models_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Models_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGround_Asset_NetworksArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Networks_By_PkArgs = {
  ground_asset_id: Scalars['Int'];
  network_id: Scalars['Int'];
};


/** query root */
export type Query_RootGround_Asset_Status_ValuesArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Status_Values_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Status_Values_Order_By>>;
  where?: Maybe<Ground_Asset_Status_Values_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Status_Values_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Status_Values_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Status_Values_Order_By>>;
  where?: Maybe<Ground_Asset_Status_Values_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Asset_Status_Values_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootGround_Asset_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootGround_AssetsArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootGround_Control_Workflow_State_Processing_StatusesArgs = {
  distinct_on?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Order_By>>;
  where?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Control_Workflow_State_Processing_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Order_By>>;
  where?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootGround_Control_Workflow_State_Processing_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootHistorical_Serialized_Ground_Asset_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootHistorical_Serialized_Ground_Asset_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootHistorical_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** query root */
export type Query_RootHistorical_Serialized_Vehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootHistorical_Serialized_Vehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootHistorical_Serialized_Vehicle_Statuses_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** query root */
export type Query_RootHistorical_Vehicle_PositionsArgs = {
  distinct_on?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Vehicle_Positions_Order_By>>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};


/** query root */
export type Query_RootHistorical_Vehicle_Positions_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Vehicle_Positions_Order_By>>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};


/** query root */
export type Query_RootHistorical_Vehicle_Positions_By_PkArgs = {
  serial_number: Scalars['String'];
  timestamp_secs: Scalars['float8'];
};


/** query root */
export type Query_RootKafka_Air_Traffic_Vehicle_Flight_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** query root */
export type Query_RootKafka_Cached_Air_Traffic_Flight_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Cached_Air_Traffic_Flight_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Cached_Air_Traffic_Flight_Proximity_Recordings_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
  id: Scalars['String'];
};


/** query root */
export type Query_RootKafka_Mqtt_Vehicle_Status_MessagesArgs = {
  distinct_on?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Order_By>>;
  where?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Mqtt_Vehicle_Status_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Order_By>>;
  where?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Mqtt_Vehicle_Status_Messages_By_PkArgs = {
  serial_number: Scalars['String'];
  timestamp: Scalars['float8'];
};


/** query root */
export type Query_RootKafka_Serialized_Ground_Asset_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootKafka_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  topic: Scalars['String'];
};


/** query root */
export type Query_RootLanding_Request_StatusesArgs = {
  distinct_on?: Maybe<Array<Landing_Request_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Request_Statuses_Order_By>>;
  where?: Maybe<Landing_Request_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootLanding_Request_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Request_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Request_Statuses_Order_By>>;
  where?: Maybe<Landing_Request_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootLanding_Request_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootLanding_RequestsArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/** query root */
export type Query_RootLanding_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/** query root */
export type Query_RootLanding_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootLast_Vehicle_Anomaly_StatusesArgs = {
  distinct_on?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Order_By>>;
  where?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootLast_Vehicle_Anomaly_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Order_By>>;
  where?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootLast_Vehicle_Anomaly_Statuses_By_PkArgs = {
  vehicle_serial_number: Scalars['String'];
};


/** query root */
export type Query_RootManifest_EventsArgs = {
  distinct_on?: Maybe<Array<Manifest_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Events_Order_By>>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Events_Order_By>>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootManifest_ItemsArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Items_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootManifest_ProductsArgs = {
  distinct_on?: Maybe<Array<Manifest_Products_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Products_Order_By>>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Products_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Products_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Products_Order_By>>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootManifest_Status_AuditsArgs = {
  distinct_on?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Status_Audits_Order_By>>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Status_Audits_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Status_Audits_Order_By>>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Status_Audits_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootManifest_TypesArgs = {
  distinct_on?: Maybe<Array<Manifest_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Types_Order_By>>;
  where?: Maybe<Manifest_Types_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Types_Order_By>>;
  where?: Maybe<Manifest_Types_Bool_Exp>;
};


/** query root */
export type Query_RootManifest_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootManifestsArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** query root */
export type Query_RootManifests_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** query root */
export type Query_RootManifests_Arrived_Within_MinuteArgs = {
  distinct_on?: Maybe<Array<Manifests_Arrived_Within_Minute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Arrived_Within_Minute_Order_By>>;
  where?: Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>;
};


/** query root */
export type Query_RootManifests_Arrived_Within_Minute_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Arrived_Within_Minute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Arrived_Within_Minute_Order_By>>;
  where?: Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>;
};


/** query root */
export type Query_RootManifests_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootNetwork_Utm_ProvidersArgs = {
  distinct_on?: Maybe<Array<Network_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Network_Utm_Providers_Order_By>>;
  where?: Maybe<Network_Utm_Providers_Bool_Exp>;
};


/** query root */
export type Query_RootNetwork_Utm_Providers_AggregateArgs = {
  distinct_on?: Maybe<Array<Network_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Network_Utm_Providers_Order_By>>;
  where?: Maybe<Network_Utm_Providers_Bool_Exp>;
};


/** query root */
export type Query_RootNetwork_Utm_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootNetworksArgs = {
  distinct_on?: Maybe<Array<Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Networks_Order_By>>;
  where?: Maybe<Networks_Bool_Exp>;
};


/** query root */
export type Query_RootNetworks_AggregateArgs = {
  distinct_on?: Maybe<Array<Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Networks_Order_By>>;
  where?: Maybe<Networks_Bool_Exp>;
};


/** query root */
export type Query_RootNetworks_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootOrganizationsArgs = {
  distinct_on?: Maybe<Array<Organizations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Organizations_Order_By>>;
  where?: Maybe<Organizations_Bool_Exp>;
};


/** query root */
export type Query_RootOrganizations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organizations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Organizations_Order_By>>;
  where?: Maybe<Organizations_Bool_Exp>;
};


/** query root */
export type Query_RootOrganizations_By_PkArgs = {
  key: Scalars['String'];
};


/** query root */
export type Query_RootPathsArgs = {
  distinct_on?: Maybe<Array<Paths_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Paths_Order_By>>;
  where?: Maybe<Paths_Bool_Exp>;
};


/** query root */
export type Query_RootPaths_AggregateArgs = {
  distinct_on?: Maybe<Array<Paths_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Paths_Order_By>>;
  where?: Maybe<Paths_Bool_Exp>;
};


/** query root */
export type Query_RootPaths_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootPickup_RequestsArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/** query root */
export type Query_RootPickup_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/** query root */
export type Query_RootPickup_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootPositive_Exchange_Of_Flight_Control_RequestsArgs = {
  distinct_on?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Order_By>>;
  where?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
};


/** query root */
export type Query_RootPositive_Exchange_Of_Flight_Control_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Order_By>>;
  where?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
};


/** query root */
export type Query_RootPositive_Exchange_Of_Flight_Control_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootPredicted_ConflictsArgs = {
  distinct_on?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Predicted_Conflicts_Order_By>>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};


/** query root */
export type Query_RootPredicted_Conflicts_AggregateArgs = {
  distinct_on?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Predicted_Conflicts_Order_By>>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};


/** query root */
export type Query_RootPredicted_Conflicts_By_PkArgs = {
  alert_level: Scalars['String'];
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};


/** query root */
export type Query_RootRolesArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** query root */
export type Query_RootRoles_AggregateArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** query root */
export type Query_RootRoles_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootSpatial_Ref_SysArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** query root */
export type Query_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** query root */
export type Query_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int'];
};


/** query root */
export type Query_RootSquawk_SeveritiesArgs = {
  distinct_on?: Maybe<Array<Squawk_Severities_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Severities_Order_By>>;
  where?: Maybe<Squawk_Severities_Bool_Exp>;
};


/** query root */
export type Query_RootSquawk_Severities_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawk_Severities_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Severities_Order_By>>;
  where?: Maybe<Squawk_Severities_Bool_Exp>;
};


/** query root */
export type Query_RootSquawk_Severities_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootSquawk_Squawkable_TypesArgs = {
  distinct_on?: Maybe<Array<Squawk_Squawkable_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Squawkable_Types_Order_By>>;
  where?: Maybe<Squawk_Squawkable_Types_Bool_Exp>;
};


/** query root */
export type Query_RootSquawk_Squawkable_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawk_Squawkable_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Squawkable_Types_Order_By>>;
  where?: Maybe<Squawk_Squawkable_Types_Bool_Exp>;
};


/** query root */
export type Query_RootSquawk_Squawkable_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootSquawk_StatusesArgs = {
  distinct_on?: Maybe<Array<Squawk_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Statuses_Order_By>>;
  where?: Maybe<Squawk_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootSquawk_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawk_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Statuses_Order_By>>;
  where?: Maybe<Squawk_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootSquawk_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootSquawksArgs = {
  distinct_on?: Maybe<Array<Squawks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawks_Order_By>>;
  where?: Maybe<Squawks_Bool_Exp>;
};


/** query root */
export type Query_RootSquawks_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawks_Order_By>>;
  where?: Maybe<Squawks_Bool_Exp>;
};


/** query root */
export type Query_RootSquawks_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootStationsArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/** query root */
export type Query_RootStations_AggregateArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/** query root */
export type Query_RootStations_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootTenantsArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** query root */
export type Query_RootTenants_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** query root */
export type Query_RootTenants_By_PkArgs = {
  id: Scalars['uuid'];
};


/** query root */
export type Query_RootType_Cert_Flight_Analysis_DataArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Order_By>>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};


/** query root */
export type Query_RootType_Cert_Flight_Analysis_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Order_By>>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};


/** query root */
export type Query_RootType_Cert_Flight_Analysis_Data_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
};


/** query root */
export type Query_RootType_Cert_Manual_DataArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Manual_Data_Order_By>>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};


/** query root */
export type Query_RootType_Cert_Manual_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Manual_Data_Order_By>>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};


/** query root */
export type Query_RootType_Cert_Manual_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootUser_App_StatesArgs = {
  distinct_on?: Maybe<Array<User_App_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_App_States_Order_By>>;
  where?: Maybe<User_App_States_Bool_Exp>;
};


/** query root */
export type Query_RootUser_App_States_AggregateArgs = {
  distinct_on?: Maybe<Array<User_App_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_App_States_Order_By>>;
  where?: Maybe<User_App_States_Bool_Exp>;
};


/** query root */
export type Query_RootUser_NetworksArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Networks_By_PkArgs = {
  network_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** query root */
export type Query_RootUser_Permissions_ViewArgs = {
  distinct_on?: Maybe<Array<User_Permissions_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Permissions_View_Order_By>>;
  where?: Maybe<User_Permissions_View_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Permissions_View_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Permissions_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Permissions_View_Order_By>>;
  where?: Maybe<User_Permissions_View_Bool_Exp>;
};


/** query root */
export type Query_RootUser_RolesArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


/** query root */
export type Query_RootUser_Roles_By_PkArgs = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** query root */
export type Query_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** query root */
export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_Airworthiness_CategoriesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Airworthiness_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Airworthiness_Categories_Order_By>>;
  where?: Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Airworthiness_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Airworthiness_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Airworthiness_Categories_Order_By>>;
  where?: Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Airworthiness_Categories_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootVehicle_AlertsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Alerts_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Alerts_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_Flight_State_EnumArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_State_Enum_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_State_Enum_Order_By>>;
  where?: Maybe<Vehicle_Flight_State_Enum_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Flight_State_Enum_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_State_Enum_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_State_Enum_Order_By>>;
  where?: Maybe<Vehicle_Flight_State_Enum_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Flight_State_Enum_By_PkArgs = {
  state: Scalars['String'];
};


/** query root */
export type Query_RootVehicle_Flight_StatusesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_Statuses_Order_By>>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Flight_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_Statuses_Order_By>>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Flight_Statuses_By_PkArgs = {
  serial_number: Scalars['String'];
};


/** query root */
export type Query_RootVehicle_Model_Parameter_TypesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Model_Parameter_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Model_Parameter_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** query root */
export type Query_RootVehicle_Model_ParametersArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameters_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Model_Parameters_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameters_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Model_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_ModelsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Order_By>>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Models_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Order_By>>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Models_AncestorsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Models_Ancestors_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Models_Ancestors_By_PkArgs = {
  ancestor_id: Scalars['Int'];
  vehicle_model_id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_Models_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_NetworksArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Networks_By_PkArgs = {
  network_id: Scalars['Int'];
  vehicle_id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_Pilot_AssignmentsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Pilot_Assignments_Order_By>>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Pilot_Assignments_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Pilot_Assignments_Order_By>>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Pilot_Assignments_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_Priority_Event_KeysArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Event_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Event_Keys_Order_By>>;
  where?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Priority_Event_Keys_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Event_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Event_Keys_Order_By>>;
  where?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Priority_Event_Keys_By_PkArgs = {
  event_key: Scalars['String'];
};


/** query root */
export type Query_RootVehicle_Priority_EventsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Priority_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Priority_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type Query_RootVehicle_Status_UpdatesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Status_Updates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Status_Updates_Order_By>>;
  where?: Maybe<Vehicle_Status_Updates_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Status_Updates_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Status_Updates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Status_Updates_Order_By>>;
  where?: Maybe<Vehicle_Status_Updates_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Status_Updates_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** query root */
export type Query_RootVehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** query root */
export type Query_RootVehicle_Statuses_By_PkArgs = {
  topic: Scalars['String'];
};


/** query root */
export type Query_RootVehiclesArgs = {
  distinct_on?: Maybe<Array<Vehicles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicles_Order_By>>;
  where?: Maybe<Vehicles_Bool_Exp>;
};


/** query root */
export type Query_RootVehicles_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicles_Order_By>>;
  where?: Maybe<Vehicles_Bool_Exp>;
};


/** query root */
export type Query_RootVehicles_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'roles';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deprecated_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  tenant_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  avg?: Maybe<Roles_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
  stddev?: Maybe<Roles_Stddev_Fields>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Fields>;
  sum?: Maybe<Roles_Sum_Fields>;
  var_pop?: Maybe<Roles_Var_Pop_Fields>;
  var_samp?: Maybe<Roles_Var_Samp_Fields>;
  variance?: Maybe<Roles_Variance_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Roles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "roles" */
export type Roles_Aggregate_Order_By = {
  avg?: Maybe<Roles_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Roles_Max_Order_By>;
  min?: Maybe<Roles_Min_Order_By>;
  stddev?: Maybe<Roles_Stddev_Order_By>;
  stddev_pop?: Maybe<Roles_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Roles_Stddev_Samp_Order_By>;
  sum?: Maybe<Roles_Sum_Order_By>;
  var_pop?: Maybe<Roles_Var_Pop_Order_By>;
  var_samp?: Maybe<Roles_Var_Samp_Order_By>;
  variance?: Maybe<Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roles" */
export type Roles_Arr_Rel_Insert_Input = {
  data: Array<Roles_Insert_Input>;
  on_conflict?: Maybe<Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type Roles_Avg_Fields = {
  __typename?: 'roles_avg_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "roles" */
export type Roles_Avg_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Roles_Bool_Exp>>>;
  _not?: Maybe<Roles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Roles_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  deprecated_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  display_name?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint */
  RolesNameTenantIdUk = 'roles_name_tenant_id_uk',
  /** unique or primary key constraint */
  RolesPkey = 'roles_pkey'
}

/** input type for incrementing integer column in table "roles" */
export type Roles_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deprecated_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deprecated_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "roles" */
export type Roles_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  deprecated_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  display_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deprecated_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "roles" */
export type Roles_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  deprecated_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  display_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type Roles_Obj_Rel_Insert_Input = {
  data: Roles_Insert_Input;
  on_conflict?: Maybe<Roles_On_Conflict>;
};

/** on conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns: Array<Roles_Update_Column>;
  where?: Maybe<Roles_Bool_Exp>;
};

/** ordering options when selecting data from "roles" */
export type Roles_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  deprecated_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  display_name?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "roles" */
export type Roles_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  deprecated_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Roles_Stddev_Fields = {
  __typename?: 'roles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "roles" */
export type Roles_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Roles_Stddev_Pop_Fields = {
  __typename?: 'roles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "roles" */
export type Roles_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Roles_Stddev_Samp_Fields = {
  __typename?: 'roles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "roles" */
export type Roles_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Roles_Sum_Fields = {
  __typename?: 'roles_sum_fields';
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "roles" */
export type Roles_Sum_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeprecatedAt = 'deprecated_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Roles_Var_Pop_Fields = {
  __typename?: 'roles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "roles" */
export type Roles_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Roles_Var_Samp_Fields = {
  __typename?: 'roles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "roles" */
export type Roles_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Roles_Variance_Fields = {
  __typename?: 'roles_variance_fields';
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "roles" */
export type Roles_Variance_Order_By = {
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};


/** expression to compare columns of type smallint. All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: Maybe<Scalars['smallint']>;
  _gt?: Maybe<Scalars['smallint']>;
  _gte?: Maybe<Scalars['smallint']>;
  _in?: Maybe<Array<Scalars['smallint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['smallint']>;
  _lte?: Maybe<Scalars['smallint']>;
  _neq?: Maybe<Scalars['smallint']>;
  _nin?: Maybe<Array<Scalars['smallint']>>;
};

/** columns and relationships of "spatial_ref_sys" */
export type Spatial_Ref_Sys = {
  __typename?: 'spatial_ref_sys';
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid: Scalars['Int'];
  srtext?: Maybe<Scalars['String']>;
};

/** aggregated selection of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate = {
  __typename?: 'spatial_ref_sys_aggregate';
  aggregate?: Maybe<Spatial_Ref_Sys_Aggregate_Fields>;
  nodes: Array<Spatial_Ref_Sys>;
};

/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_Fields = {
  __typename?: 'spatial_ref_sys_aggregate_fields';
  avg?: Maybe<Spatial_Ref_Sys_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Spatial_Ref_Sys_Max_Fields>;
  min?: Maybe<Spatial_Ref_Sys_Min_Fields>;
  stddev?: Maybe<Spatial_Ref_Sys_Stddev_Fields>;
  stddev_pop?: Maybe<Spatial_Ref_Sys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Spatial_Ref_Sys_Stddev_Samp_Fields>;
  sum?: Maybe<Spatial_Ref_Sys_Sum_Fields>;
  var_pop?: Maybe<Spatial_Ref_Sys_Var_Pop_Fields>;
  var_samp?: Maybe<Spatial_Ref_Sys_Var_Samp_Fields>;
  variance?: Maybe<Spatial_Ref_Sys_Variance_Fields>;
};


/** aggregate fields of "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Aggregate_Order_By = {
  avg?: Maybe<Spatial_Ref_Sys_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Spatial_Ref_Sys_Max_Order_By>;
  min?: Maybe<Spatial_Ref_Sys_Min_Order_By>;
  stddev?: Maybe<Spatial_Ref_Sys_Stddev_Order_By>;
  stddev_pop?: Maybe<Spatial_Ref_Sys_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Spatial_Ref_Sys_Stddev_Samp_Order_By>;
  sum?: Maybe<Spatial_Ref_Sys_Sum_Order_By>;
  var_pop?: Maybe<Spatial_Ref_Sys_Var_Pop_Order_By>;
  var_samp?: Maybe<Spatial_Ref_Sys_Var_Samp_Order_By>;
  variance?: Maybe<Spatial_Ref_Sys_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Arr_Rel_Insert_Input = {
  data: Array<Spatial_Ref_Sys_Insert_Input>;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};

/** aggregate avg on columns */
export type Spatial_Ref_Sys_Avg_Fields = {
  __typename?: 'spatial_ref_sys_avg_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Avg_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "spatial_ref_sys". All fields are combined with a logical 'AND'. */
export type Spatial_Ref_Sys_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Spatial_Ref_Sys_Bool_Exp>>>;
  _not?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Spatial_Ref_Sys_Bool_Exp>>>;
  auth_name?: Maybe<String_Comparison_Exp>;
  auth_srid?: Maybe<Int_Comparison_Exp>;
  proj4text?: Maybe<String_Comparison_Exp>;
  srid?: Maybe<Int_Comparison_Exp>;
  srtext?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Constraint {
  /** unique or primary key constraint */
  SpatialRefSysPkey = 'spatial_ref_sys_pkey'
}

/** input type for incrementing integer column in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Inc_Input = {
  auth_srid?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Insert_Input = {
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Spatial_Ref_Sys_Max_Fields = {
  __typename?: 'spatial_ref_sys_max_fields';
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Max_Order_By = {
  auth_name?: Maybe<Order_By>;
  auth_srid?: Maybe<Order_By>;
  proj4text?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  srtext?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Spatial_Ref_Sys_Min_Fields = {
  __typename?: 'spatial_ref_sys_min_fields';
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Min_Order_By = {
  auth_name?: Maybe<Order_By>;
  auth_srid?: Maybe<Order_By>;
  proj4text?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  srtext?: Maybe<Order_By>;
};

/** response of any mutation on the table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Mutation_Response = {
  __typename?: 'spatial_ref_sys_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Spatial_Ref_Sys>;
};

/** input type for inserting object relation for remote table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Obj_Rel_Insert_Input = {
  data: Spatial_Ref_Sys_Insert_Input;
  on_conflict?: Maybe<Spatial_Ref_Sys_On_Conflict>;
};

/** on conflict condition type for table "spatial_ref_sys" */
export type Spatial_Ref_Sys_On_Conflict = {
  constraint: Spatial_Ref_Sys_Constraint;
  update_columns: Array<Spatial_Ref_Sys_Update_Column>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};

/** ordering options when selecting data from "spatial_ref_sys" */
export type Spatial_Ref_Sys_Order_By = {
  auth_name?: Maybe<Order_By>;
  auth_srid?: Maybe<Order_By>;
  proj4text?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
  srtext?: Maybe<Order_By>;
};

/** primary key columns input for table: "spatial_ref_sys" */
export type Spatial_Ref_Sys_Pk_Columns_Input = {
  srid: Scalars['Int'];
};

/** select columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Select_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** input type for updating data in table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Set_Input = {
  auth_name?: Maybe<Scalars['String']>;
  auth_srid?: Maybe<Scalars['Int']>;
  proj4text?: Maybe<Scalars['String']>;
  srid?: Maybe<Scalars['Int']>;
  srtext?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Spatial_Ref_Sys_Stddev_Fields = {
  __typename?: 'spatial_ref_sys_stddev_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stddev_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Spatial_Ref_Sys_Stddev_Pop_Fields = {
  __typename?: 'spatial_ref_sys_stddev_pop_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stddev_Pop_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Spatial_Ref_Sys_Stddev_Samp_Fields = {
  __typename?: 'spatial_ref_sys_stddev_samp_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Stddev_Samp_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Spatial_Ref_Sys_Sum_Fields = {
  __typename?: 'spatial_ref_sys_sum_fields';
  auth_srid?: Maybe<Scalars['Int']>;
  srid?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Sum_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** update columns of table "spatial_ref_sys" */
export enum Spatial_Ref_Sys_Update_Column {
  /** column name */
  AuthName = 'auth_name',
  /** column name */
  AuthSrid = 'auth_srid',
  /** column name */
  Proj4text = 'proj4text',
  /** column name */
  Srid = 'srid',
  /** column name */
  Srtext = 'srtext'
}

/** aggregate var_pop on columns */
export type Spatial_Ref_Sys_Var_Pop_Fields = {
  __typename?: 'spatial_ref_sys_var_pop_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Var_Pop_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Spatial_Ref_Sys_Var_Samp_Fields = {
  __typename?: 'spatial_ref_sys_var_samp_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Var_Samp_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Spatial_Ref_Sys_Variance_Fields = {
  __typename?: 'spatial_ref_sys_variance_fields';
  auth_srid?: Maybe<Scalars['Float']>;
  srid?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "spatial_ref_sys" */
export type Spatial_Ref_Sys_Variance_Order_By = {
  auth_srid?: Maybe<Order_By>;
  srid?: Maybe<Order_By>;
};

/** columns and relationships of "squawk_severities" */
export type Squawk_Severities = {
  __typename?: 'squawk_severities';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "squawk_severities" */
export type Squawk_Severities_Aggregate = {
  __typename?: 'squawk_severities_aggregate';
  aggregate?: Maybe<Squawk_Severities_Aggregate_Fields>;
  nodes: Array<Squawk_Severities>;
};

/** aggregate fields of "squawk_severities" */
export type Squawk_Severities_Aggregate_Fields = {
  __typename?: 'squawk_severities_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Squawk_Severities_Max_Fields>;
  min?: Maybe<Squawk_Severities_Min_Fields>;
};


/** aggregate fields of "squawk_severities" */
export type Squawk_Severities_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Squawk_Severities_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "squawk_severities" */
export type Squawk_Severities_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Squawk_Severities_Max_Order_By>;
  min?: Maybe<Squawk_Severities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "squawk_severities" */
export type Squawk_Severities_Arr_Rel_Insert_Input = {
  data: Array<Squawk_Severities_Insert_Input>;
  on_conflict?: Maybe<Squawk_Severities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "squawk_severities". All fields are combined with a logical 'AND'. */
export type Squawk_Severities_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Squawk_Severities_Bool_Exp>>>;
  _not?: Maybe<Squawk_Severities_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Squawk_Severities_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "squawk_severities" */
export enum Squawk_Severities_Constraint {
  /** unique or primary key constraint */
  SquawkSeveritiesPkey = 'squawk_severities_pkey'
}

export enum Squawk_Severities_Enum {
  /** CRITICAL */
  Critical = 'CRITICAL',
  /** INFO */
  Info = 'INFO',
  /** WARNING */
  Warning = 'WARNING'
}

/** expression to compare columns of type squawk_severities_enum. All fields are combined with logical 'AND'. */
export type Squawk_Severities_Enum_Comparison_Exp = {
  _eq?: Maybe<Squawk_Severities_Enum>;
  _in?: Maybe<Array<Squawk_Severities_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Squawk_Severities_Enum>;
  _nin?: Maybe<Array<Squawk_Severities_Enum>>;
};

/** input type for inserting data into table "squawk_severities" */
export type Squawk_Severities_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Squawk_Severities_Max_Fields = {
  __typename?: 'squawk_severities_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "squawk_severities" */
export type Squawk_Severities_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Squawk_Severities_Min_Fields = {
  __typename?: 'squawk_severities_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "squawk_severities" */
export type Squawk_Severities_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "squawk_severities" */
export type Squawk_Severities_Mutation_Response = {
  __typename?: 'squawk_severities_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Squawk_Severities>;
};

/** input type for inserting object relation for remote table "squawk_severities" */
export type Squawk_Severities_Obj_Rel_Insert_Input = {
  data: Squawk_Severities_Insert_Input;
  on_conflict?: Maybe<Squawk_Severities_On_Conflict>;
};

/** on conflict condition type for table "squawk_severities" */
export type Squawk_Severities_On_Conflict = {
  constraint: Squawk_Severities_Constraint;
  update_columns: Array<Squawk_Severities_Update_Column>;
  where?: Maybe<Squawk_Severities_Bool_Exp>;
};

/** ordering options when selecting data from "squawk_severities" */
export type Squawk_Severities_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "squawk_severities" */
export type Squawk_Severities_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "squawk_severities" */
export enum Squawk_Severities_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "squawk_severities" */
export type Squawk_Severities_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "squawk_severities" */
export enum Squawk_Severities_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "squawk_squawkable_types" */
export type Squawk_Squawkable_Types = {
  __typename?: 'squawk_squawkable_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Aggregate = {
  __typename?: 'squawk_squawkable_types_aggregate';
  aggregate?: Maybe<Squawk_Squawkable_Types_Aggregate_Fields>;
  nodes: Array<Squawk_Squawkable_Types>;
};

/** aggregate fields of "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Aggregate_Fields = {
  __typename?: 'squawk_squawkable_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Squawk_Squawkable_Types_Max_Fields>;
  min?: Maybe<Squawk_Squawkable_Types_Min_Fields>;
};


/** aggregate fields of "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Squawk_Squawkable_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Squawk_Squawkable_Types_Max_Order_By>;
  min?: Maybe<Squawk_Squawkable_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Arr_Rel_Insert_Input = {
  data: Array<Squawk_Squawkable_Types_Insert_Input>;
  on_conflict?: Maybe<Squawk_Squawkable_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "squawk_squawkable_types". All fields are combined with a logical 'AND'. */
export type Squawk_Squawkable_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Squawk_Squawkable_Types_Bool_Exp>>>;
  _not?: Maybe<Squawk_Squawkable_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Squawk_Squawkable_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "squawk_squawkable_types" */
export enum Squawk_Squawkable_Types_Constraint {
  /** unique or primary key constraint */
  SquawkSquawkableTypesPkey = 'squawk_squawkable_types_pkey'
}

export enum Squawk_Squawkable_Types_Enum {
  /** FlightPlan */
  FlightPlan = 'FlightPlan'
}

/** expression to compare columns of type squawk_squawkable_types_enum. All fields are combined with logical 'AND'. */
export type Squawk_Squawkable_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Squawk_Squawkable_Types_Enum>;
  _in?: Maybe<Array<Squawk_Squawkable_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Squawk_Squawkable_Types_Enum>;
  _nin?: Maybe<Array<Squawk_Squawkable_Types_Enum>>;
};

/** input type for inserting data into table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Squawk_Squawkable_Types_Max_Fields = {
  __typename?: 'squawk_squawkable_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Squawk_Squawkable_Types_Min_Fields = {
  __typename?: 'squawk_squawkable_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Mutation_Response = {
  __typename?: 'squawk_squawkable_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Squawk_Squawkable_Types>;
};

/** input type for inserting object relation for remote table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Obj_Rel_Insert_Input = {
  data: Squawk_Squawkable_Types_Insert_Input;
  on_conflict?: Maybe<Squawk_Squawkable_Types_On_Conflict>;
};

/** on conflict condition type for table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_On_Conflict = {
  constraint: Squawk_Squawkable_Types_Constraint;
  update_columns: Array<Squawk_Squawkable_Types_Update_Column>;
  where?: Maybe<Squawk_Squawkable_Types_Bool_Exp>;
};

/** ordering options when selecting data from "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "squawk_squawkable_types" */
export enum Squawk_Squawkable_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "squawk_squawkable_types" */
export type Squawk_Squawkable_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "squawk_squawkable_types" */
export enum Squawk_Squawkable_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "squawk_statuses" */
export type Squawk_Statuses = {
  __typename?: 'squawk_statuses';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "squawk_statuses" */
export type Squawk_Statuses_Aggregate = {
  __typename?: 'squawk_statuses_aggregate';
  aggregate?: Maybe<Squawk_Statuses_Aggregate_Fields>;
  nodes: Array<Squawk_Statuses>;
};

/** aggregate fields of "squawk_statuses" */
export type Squawk_Statuses_Aggregate_Fields = {
  __typename?: 'squawk_statuses_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Squawk_Statuses_Max_Fields>;
  min?: Maybe<Squawk_Statuses_Min_Fields>;
};


/** aggregate fields of "squawk_statuses" */
export type Squawk_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Squawk_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "squawk_statuses" */
export type Squawk_Statuses_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Squawk_Statuses_Max_Order_By>;
  min?: Maybe<Squawk_Statuses_Min_Order_By>;
};

/** input type for inserting array relation for remote table "squawk_statuses" */
export type Squawk_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Squawk_Statuses_Insert_Input>;
  on_conflict?: Maybe<Squawk_Statuses_On_Conflict>;
};

/** Boolean expression to filter rows from the table "squawk_statuses". All fields are combined with a logical 'AND'. */
export type Squawk_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Squawk_Statuses_Bool_Exp>>>;
  _not?: Maybe<Squawk_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Squawk_Statuses_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "squawk_statuses" */
export enum Squawk_Statuses_Constraint {
  /** unique or primary key constraint */
  SquawkStatusesPkey = 'squawk_statuses_pkey'
}

export enum Squawk_Statuses_Enum {
  /** OPEN */
  Open = 'OPEN',
  /** RESOLVED */
  Resolved = 'RESOLVED'
}

/** expression to compare columns of type squawk_statuses_enum. All fields are combined with logical 'AND'. */
export type Squawk_Statuses_Enum_Comparison_Exp = {
  _eq?: Maybe<Squawk_Statuses_Enum>;
  _in?: Maybe<Array<Squawk_Statuses_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Squawk_Statuses_Enum>;
  _nin?: Maybe<Array<Squawk_Statuses_Enum>>;
};

/** input type for inserting data into table "squawk_statuses" */
export type Squawk_Statuses_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Squawk_Statuses_Max_Fields = {
  __typename?: 'squawk_statuses_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "squawk_statuses" */
export type Squawk_Statuses_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Squawk_Statuses_Min_Fields = {
  __typename?: 'squawk_statuses_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "squawk_statuses" */
export type Squawk_Statuses_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "squawk_statuses" */
export type Squawk_Statuses_Mutation_Response = {
  __typename?: 'squawk_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Squawk_Statuses>;
};

/** input type for inserting object relation for remote table "squawk_statuses" */
export type Squawk_Statuses_Obj_Rel_Insert_Input = {
  data: Squawk_Statuses_Insert_Input;
  on_conflict?: Maybe<Squawk_Statuses_On_Conflict>;
};

/** on conflict condition type for table "squawk_statuses" */
export type Squawk_Statuses_On_Conflict = {
  constraint: Squawk_Statuses_Constraint;
  update_columns: Array<Squawk_Statuses_Update_Column>;
  where?: Maybe<Squawk_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "squawk_statuses" */
export type Squawk_Statuses_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "squawk_statuses" */
export type Squawk_Statuses_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "squawk_statuses" */
export enum Squawk_Statuses_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "squawk_statuses" */
export type Squawk_Statuses_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "squawk_statuses" */
export enum Squawk_Statuses_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "squawks" */
export type Squawks = {
  __typename?: 'squawks';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  mongo_id?: Maybe<Scalars['String']>;
  severity: Squawk_Severities_Enum;
  squawkable_id: Scalars['Int'];
  squawkable_type: Squawk_Squawkable_Types_Enum;
  status: Squawk_Statuses_Enum;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};

/** aggregated selection of "squawks" */
export type Squawks_Aggregate = {
  __typename?: 'squawks_aggregate';
  aggregate?: Maybe<Squawks_Aggregate_Fields>;
  nodes: Array<Squawks>;
};

/** aggregate fields of "squawks" */
export type Squawks_Aggregate_Fields = {
  __typename?: 'squawks_aggregate_fields';
  avg?: Maybe<Squawks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Squawks_Max_Fields>;
  min?: Maybe<Squawks_Min_Fields>;
  stddev?: Maybe<Squawks_Stddev_Fields>;
  stddev_pop?: Maybe<Squawks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Squawks_Stddev_Samp_Fields>;
  sum?: Maybe<Squawks_Sum_Fields>;
  var_pop?: Maybe<Squawks_Var_Pop_Fields>;
  var_samp?: Maybe<Squawks_Var_Samp_Fields>;
  variance?: Maybe<Squawks_Variance_Fields>;
};


/** aggregate fields of "squawks" */
export type Squawks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Squawks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "squawks" */
export type Squawks_Aggregate_Order_By = {
  avg?: Maybe<Squawks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Squawks_Max_Order_By>;
  min?: Maybe<Squawks_Min_Order_By>;
  stddev?: Maybe<Squawks_Stddev_Order_By>;
  stddev_pop?: Maybe<Squawks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Squawks_Stddev_Samp_Order_By>;
  sum?: Maybe<Squawks_Sum_Order_By>;
  var_pop?: Maybe<Squawks_Var_Pop_Order_By>;
  var_samp?: Maybe<Squawks_Var_Samp_Order_By>;
  variance?: Maybe<Squawks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "squawks" */
export type Squawks_Arr_Rel_Insert_Input = {
  data: Array<Squawks_Insert_Input>;
  on_conflict?: Maybe<Squawks_On_Conflict>;
};

/** aggregate avg on columns */
export type Squawks_Avg_Fields = {
  __typename?: 'squawks_avg_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "squawks" */
export type Squawks_Avg_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "squawks". All fields are combined with a logical 'AND'. */
export type Squawks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Squawks_Bool_Exp>>>;
  _not?: Maybe<Squawks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Squawks_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  severity?: Maybe<Squawk_Severities_Enum_Comparison_Exp>;
  squawkable_id?: Maybe<Int_Comparison_Exp>;
  squawkable_type?: Maybe<Squawk_Squawkable_Types_Enum_Comparison_Exp>;
  status?: Maybe<Squawk_Statuses_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "squawks" */
export enum Squawks_Constraint {
  /** unique or primary key constraint */
  SquawksMongoIdKey = 'squawks_mongo_id_key',
  /** unique or primary key constraint */
  SquawksPkey = 'squawks_pkey'
}

/** input type for incrementing integer column in table "squawks" */
export type Squawks_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  squawkable_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "squawks" */
export type Squawks_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  severity?: Maybe<Squawk_Severities_Enum>;
  squawkable_id?: Maybe<Scalars['Int']>;
  squawkable_type?: Maybe<Squawk_Squawkable_Types_Enum>;
  status?: Maybe<Squawk_Statuses_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Squawks_Max_Fields = {
  __typename?: 'squawks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  squawkable_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "squawks" */
export type Squawks_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Squawks_Min_Fields = {
  __typename?: 'squawks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  squawkable_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "squawks" */
export type Squawks_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "squawks" */
export type Squawks_Mutation_Response = {
  __typename?: 'squawks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Squawks>;
};

/** input type for inserting object relation for remote table "squawks" */
export type Squawks_Obj_Rel_Insert_Input = {
  data: Squawks_Insert_Input;
  on_conflict?: Maybe<Squawks_On_Conflict>;
};

/** on conflict condition type for table "squawks" */
export type Squawks_On_Conflict = {
  constraint: Squawks_Constraint;
  update_columns: Array<Squawks_Update_Column>;
  where?: Maybe<Squawks_Bool_Exp>;
};

/** ordering options when selecting data from "squawks" */
export type Squawks_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  squawkable_type?: Maybe<Order_By>;
  status?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "squawks" */
export type Squawks_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "squawks" */
export enum Squawks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Severity = 'severity',
  /** column name */
  SquawkableId = 'squawkable_id',
  /** column name */
  SquawkableType = 'squawkable_type',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "squawks" */
export type Squawks_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  severity?: Maybe<Squawk_Severities_Enum>;
  squawkable_id?: Maybe<Scalars['Int']>;
  squawkable_type?: Maybe<Squawk_Squawkable_Types_Enum>;
  status?: Maybe<Squawk_Statuses_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Squawks_Stddev_Fields = {
  __typename?: 'squawks_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "squawks" */
export type Squawks_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Squawks_Stddev_Pop_Fields = {
  __typename?: 'squawks_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "squawks" */
export type Squawks_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Squawks_Stddev_Samp_Fields = {
  __typename?: 'squawks_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "squawks" */
export type Squawks_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Squawks_Sum_Fields = {
  __typename?: 'squawks_sum_fields';
  id?: Maybe<Scalars['Int']>;
  squawkable_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "squawks" */
export type Squawks_Sum_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "squawks" */
export enum Squawks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Severity = 'severity',
  /** column name */
  SquawkableId = 'squawkable_id',
  /** column name */
  SquawkableType = 'squawkable_type',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Squawks_Var_Pop_Fields = {
  __typename?: 'squawks_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "squawks" */
export type Squawks_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Squawks_Var_Samp_Fields = {
  __typename?: 'squawks_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "squawks" */
export type Squawks_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Squawks_Variance_Fields = {
  __typename?: 'squawks_variance_fields';
  id?: Maybe<Scalars['Float']>;
  squawkable_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "squawks" */
export type Squawks_Variance_Order_By = {
  id?: Maybe<Order_By>;
  squawkable_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: Maybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type Stations = {
  __typename?: 'stations';
  /** An object relationship */
  airspace?: Maybe<Airspaces>;
  /** UID of the terminal airspace. */
  airspace_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  flight_plans_by_dest: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_by_dest_aggregate: Flight_Plans_Aggregate;
  /** An array relationship */
  flight_plans_by_origin: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_by_origin_aggregate: Flight_Plans_Aggregate;
  id: Scalars['Int'];
  /** An array relationship */
  landing_requests: Array<Landing_Requests>;
  /** An aggregated array relationship */
  landing_requests_aggregate: Landing_Requests_Aggregate;
  /** An array relationship */
  manifests_by_dest: Array<Manifests>;
  /** An aggregated array relationship */
  manifests_by_dest_aggregate: Manifests_Aggregate;
  /** An array relationship */
  manifests_by_origin: Array<Manifests>;
  /** An aggregated array relationship */
  manifests_by_origin_aggregate: Manifests_Aggregate;
  min_agl?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  /** Name of the terminal airspace. */
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  network?: Maybe<Networks>;
  network_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  pickup_requests: Array<Pickup_Requests>;
  /** An aggregated array relationship */
  pickup_requests_aggregate: Pickup_Requests_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregated array relationship */
  users_aggregate: Users_Aggregate;
  version: Scalars['Int'];
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsFlight_Plans_By_DestArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsFlight_Plans_By_Dest_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsFlight_Plans_By_OriginArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsFlight_Plans_By_Origin_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsLanding_RequestsArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsLanding_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsManifests_By_DestArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsManifests_By_Dest_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsManifests_By_OriginArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsManifests_By_Origin_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsPickup_RequestsArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsPickup_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/**
 * Table containing the list of terminal airspaces and their associating names.
 *
 *
 * columns and relationships of "stations"
 */
export type StationsUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "stations" */
export type Stations_Aggregate = {
  __typename?: 'stations_aggregate';
  aggregate?: Maybe<Stations_Aggregate_Fields>;
  nodes: Array<Stations>;
};

/** aggregate fields of "stations" */
export type Stations_Aggregate_Fields = {
  __typename?: 'stations_aggregate_fields';
  avg?: Maybe<Stations_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Stations_Max_Fields>;
  min?: Maybe<Stations_Min_Fields>;
  stddev?: Maybe<Stations_Stddev_Fields>;
  stddev_pop?: Maybe<Stations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Stations_Stddev_Samp_Fields>;
  sum?: Maybe<Stations_Sum_Fields>;
  var_pop?: Maybe<Stations_Var_Pop_Fields>;
  var_samp?: Maybe<Stations_Var_Samp_Fields>;
  variance?: Maybe<Stations_Variance_Fields>;
};


/** aggregate fields of "stations" */
export type Stations_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Stations_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stations" */
export type Stations_Aggregate_Order_By = {
  avg?: Maybe<Stations_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Stations_Max_Order_By>;
  min?: Maybe<Stations_Min_Order_By>;
  stddev?: Maybe<Stations_Stddev_Order_By>;
  stddev_pop?: Maybe<Stations_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Stations_Stddev_Samp_Order_By>;
  sum?: Maybe<Stations_Sum_Order_By>;
  var_pop?: Maybe<Stations_Var_Pop_Order_By>;
  var_samp?: Maybe<Stations_Var_Samp_Order_By>;
  variance?: Maybe<Stations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "stations" */
export type Stations_Arr_Rel_Insert_Input = {
  data: Array<Stations_Insert_Input>;
  on_conflict?: Maybe<Stations_On_Conflict>;
};

/** aggregate avg on columns */
export type Stations_Avg_Fields = {
  __typename?: 'stations_avg_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "stations" */
export type Stations_Avg_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "stations". All fields are combined with a logical 'AND'. */
export type Stations_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Stations_Bool_Exp>>>;
  _not?: Maybe<Stations_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Stations_Bool_Exp>>>;
  airspace?: Maybe<Airspaces_Bool_Exp>;
  airspace_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  created_by_id?: Maybe<Int_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plans_by_dest?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plans_by_origin?: Maybe<Flight_Plans_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  landing_requests?: Maybe<Landing_Requests_Bool_Exp>;
  manifests_by_dest?: Maybe<Manifests_Bool_Exp>;
  manifests_by_origin?: Maybe<Manifests_Bool_Exp>;
  min_agl?: Maybe<Int_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  pickup_requests?: Maybe<Pickup_Requests_Bool_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "stations" */
export enum Stations_Constraint {
  /** unique or primary key constraint */
  StationsMongoIdKey = 'stations_mongo_id_key',
  /** unique or primary key constraint */
  StationsPkey = 'stations_pkey'
}

/** input type for incrementing integer column in table "stations" */
export type Stations_Inc_Input = {
  airspace_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  min_agl?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "stations" */
export type Stations_Insert_Input = {
  airspace?: Maybe<Airspaces_Obj_Rel_Insert_Input>;
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plans_by_dest?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_plans_by_origin?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  landing_requests?: Maybe<Landing_Requests_Arr_Rel_Insert_Input>;
  manifests_by_dest?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  manifests_by_origin?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  min_agl?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  pickup_requests?: Maybe<Pickup_Requests_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Stations_Max_Fields = {
  __typename?: 'stations_max_fields';
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  min_agl?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "stations" */
export type Stations_Max_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Stations_Min_Fields = {
  __typename?: 'stations_min_fields';
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  min_agl?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "stations" */
export type Stations_Min_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "stations" */
export type Stations_Mutation_Response = {
  __typename?: 'stations_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Stations>;
};

/** input type for inserting object relation for remote table "stations" */
export type Stations_Obj_Rel_Insert_Input = {
  data: Stations_Insert_Input;
  on_conflict?: Maybe<Stations_On_Conflict>;
};

/** on conflict condition type for table "stations" */
export type Stations_On_Conflict = {
  constraint: Stations_Constraint;
  update_columns: Array<Stations_Update_Column>;
  where?: Maybe<Stations_Bool_Exp>;
};

/** ordering options when selecting data from "stations" */
export type Stations_Order_By = {
  airspace?: Maybe<Airspaces_Order_By>;
  airspace_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plans_by_dest_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_plans_by_origin_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  id?: Maybe<Order_By>;
  landing_requests_aggregate?: Maybe<Landing_Requests_Aggregate_Order_By>;
  manifests_by_dest_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  manifests_by_origin_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  min_agl?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  pickup_requests_aggregate?: Maybe<Pickup_Requests_Aggregate_Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "stations" */
export type Stations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "stations" */
export enum Stations_Select_Column {
  /** column name */
  AirspaceId = 'airspace_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MinAgl = 'min_agl',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "stations" */
export type Stations_Set_Input = {
  airspace_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_id?: Maybe<Scalars['Int']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  min_agl?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Stations_Stddev_Fields = {
  __typename?: 'stations_stddev_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "stations" */
export type Stations_Stddev_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Stations_Stddev_Pop_Fields = {
  __typename?: 'stations_stddev_pop_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "stations" */
export type Stations_Stddev_Pop_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Stations_Stddev_Samp_Fields = {
  __typename?: 'stations_stddev_samp_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "stations" */
export type Stations_Stddev_Samp_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Stations_Sum_Fields = {
  __typename?: 'stations_sum_fields';
  airspace_id?: Maybe<Scalars['Int']>;
  created_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  min_agl?: Maybe<Scalars['Int']>;
  network_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "stations" */
export type Stations_Sum_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "stations" */
export enum Stations_Update_Column {
  /** column name */
  AirspaceId = 'airspace_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  MinAgl = 'min_agl',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Stations_Var_Pop_Fields = {
  __typename?: 'stations_var_pop_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "stations" */
export type Stations_Var_Pop_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Stations_Var_Samp_Fields = {
  __typename?: 'stations_var_samp_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "stations" */
export type Stations_Var_Samp_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Stations_Variance_Fields = {
  __typename?: 'stations_variance_fields';
  airspace_id?: Maybe<Scalars['Float']>;
  created_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  min_agl?: Maybe<Scalars['Float']>;
  network_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "stations" */
export type Stations_Variance_Order_By = {
  airspace_id?: Maybe<Order_By>;
  created_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  min_agl?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** subscription root */
export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "air_traffic_deconfliction_algorithm_types" */
  air_traffic_deconfliction_algorithm_types: Array<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** fetch aggregated fields from the table: "air_traffic_deconfliction_algorithm_types" */
  air_traffic_deconfliction_algorithm_types_aggregate: Air_Traffic_Deconfliction_Algorithm_Types_Aggregate;
  /** fetch data from the table: "air_traffic_deconfliction_algorithm_types" using primary key columns */
  air_traffic_deconfliction_algorithm_types_by_pk?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types>;
  /** fetch data from the table: "air_traffic_monitor_tasks" */
  air_traffic_monitor_tasks: Array<Air_Traffic_Monitor_Tasks>;
  /** fetch aggregated fields from the table: "air_traffic_monitor_tasks" */
  air_traffic_monitor_tasks_aggregate: Air_Traffic_Monitor_Tasks_Aggregate;
  /** fetch data from the table: "air_traffic_monitor_tasks" using primary key columns */
  air_traffic_monitor_tasks_by_pk?: Maybe<Air_Traffic_Monitor_Tasks>;
  /** fetch data from the table: "air_traffic_tracks" */
  air_traffic_tracks: Array<Air_Traffic_Tracks>;
  /** fetch aggregated fields from the table: "air_traffic_tracks" */
  air_traffic_tracks_aggregate: Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "air_traffic_tracks" using primary key columns */
  air_traffic_tracks_by_pk?: Maybe<Air_Traffic_Tracks>;
  /** fetch data from the table: "aircraft_type_designators" */
  aircraft_type_designators: Array<Aircraft_Type_Designators>;
  /** fetch aggregated fields from the table: "aircraft_type_designators" */
  aircraft_type_designators_aggregate: Aircraft_Type_Designators_Aggregate;
  /** fetch data from the table: "aircraft_type_designators" using primary key columns */
  aircraft_type_designators_by_pk?: Maybe<Aircraft_Type_Designators>;
  /** fetch data from the table: "airspaces" */
  airspaces: Array<Airspaces>;
  /** fetch aggregated fields from the table: "airspaces" */
  airspaces_aggregate: Airspaces_Aggregate;
  /** fetch data from the table: "airspaces" using primary key columns */
  airspaces_by_pk?: Maybe<Airspaces>;
  /** fetch data from the table: "available_aircraft_command_sets" */
  available_aircraft_command_sets: Array<Available_Aircraft_Command_Sets>;
  /** fetch aggregated fields from the table: "available_aircraft_command_sets" */
  available_aircraft_command_sets_aggregate: Available_Aircraft_Command_Sets_Aggregate;
  /** fetch data from the table: "available_aircraft_command_sets" using primary key columns */
  available_aircraft_command_sets_by_pk?: Maybe<Available_Aircraft_Command_Sets>;
  /** fetch data from the table: "available_aircraft_command_state_keys" */
  available_aircraft_command_state_keys: Array<Available_Aircraft_Command_State_Keys>;
  /** fetch aggregated fields from the table: "available_aircraft_command_state_keys" */
  available_aircraft_command_state_keys_aggregate: Available_Aircraft_Command_State_Keys_Aggregate;
  /** fetch data from the table: "available_aircraft_command_state_keys" using primary key columns */
  available_aircraft_command_state_keys_by_pk?: Maybe<Available_Aircraft_Command_State_Keys>;
  /** fetch data from the table: "badge_tokens" */
  badge_tokens: Array<Badge_Tokens>;
  /** fetch aggregated fields from the table: "badge_tokens" */
  badge_tokens_aggregate: Badge_Tokens_Aggregate;
  /** fetch data from the table: "badge_tokens" using primary key columns */
  badge_tokens_by_pk?: Maybe<Badge_Tokens>;
  /** fetch data from the table: "batteries" */
  batteries: Array<Batteries>;
  /** fetch aggregated fields from the table: "batteries" */
  batteries_aggregate: Batteries_Aggregate;
  /** fetch data from the table: "batteries" using primary key columns */
  batteries_by_pk?: Maybe<Batteries>;
  /** fetch data from the table: "contingency_landing_spots" */
  contingency_landing_spots: Array<Contingency_Landing_Spots>;
  /** fetch aggregated fields from the table: "contingency_landing_spots" */
  contingency_landing_spots_aggregate: Contingency_Landing_Spots_Aggregate;
  /** fetch data from the table: "contingency_landing_spots" using primary key columns */
  contingency_landing_spots_by_pk?: Maybe<Contingency_Landing_Spots>;
  /** fetch data from the table: "current_air_traffic_proximity_recordings" */
  current_air_traffic_proximity_recordings: Array<Current_Air_Traffic_Proximity_Recordings>;
  /** fetch aggregated fields from the table: "current_air_traffic_proximity_recordings" */
  current_air_traffic_proximity_recordings_aggregate: Current_Air_Traffic_Proximity_Recordings_Aggregate;
  /** fetch data from the table: "current_air_traffic_tracks" */
  current_air_traffic_tracks: Array<Current_Air_Traffic_Tracks>;
  /** fetch aggregated fields from the table: "current_air_traffic_tracks" */
  current_air_traffic_tracks_aggregate: Current_Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "current_utm_air_traffic_tracks" */
  current_utm_air_traffic_tracks: Array<Current_Utm_Air_Traffic_Tracks>;
  /** fetch aggregated fields from the table: "current_utm_air_traffic_tracks" */
  current_utm_air_traffic_tracks_aggregate: Current_Utm_Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "daa_observations" */
  daa_observations: Array<Daa_Observations>;
  /** fetch aggregated fields from the table: "daa_observations" */
  daa_observations_aggregate: Daa_Observations_Aggregate;
  /** fetch data from the table: "daa_observations" using primary key columns */
  daa_observations_by_pk?: Maybe<Daa_Observations>;
  /** fetch data from the table: "daa_statuses" */
  daa_statuses: Array<Daa_Statuses>;
  /** fetch aggregated fields from the table: "daa_statuses" */
  daa_statuses_aggregate: Daa_Statuses_Aggregate;
  /** fetch data from the table: "daa_statuses" using primary key columns */
  daa_statuses_by_pk?: Maybe<Daa_Statuses>;
  /** fetch data from the table: "env_feature_flags" */
  env_feature_flags: Array<Env_Feature_Flags>;
  /** fetch aggregated fields from the table: "env_feature_flags" */
  env_feature_flags_aggregate: Env_Feature_Flags_Aggregate;
  /** fetch data from the table: "env_feature_flags" using primary key columns */
  env_feature_flags_by_pk?: Maybe<Env_Feature_Flags>;
  /** execute function "fetch_current_deduped_air_traffic_tracks" which returns "current_utm_air_traffic_tracks" */
  fetch_current_deduped_air_traffic_tracks: Array<Current_Utm_Air_Traffic_Tracks>;
  /** execute function "fetch_current_deduped_air_traffic_tracks" and query aggregates on result of table type "current_utm_air_traffic_tracks" */
  fetch_current_deduped_air_traffic_tracks_aggregate: Current_Utm_Air_Traffic_Tracks_Aggregate;
  /** fetch data from the table: "file_asset_types" */
  file_asset_types: Array<File_Asset_Types>;
  /** fetch aggregated fields from the table: "file_asset_types" */
  file_asset_types_aggregate: File_Asset_Types_Aggregate;
  /** fetch data from the table: "file_asset_types" using primary key columns */
  file_asset_types_by_pk?: Maybe<File_Asset_Types>;
  /** fetch data from the table: "file_assets" */
  file_assets: Array<File_Assets>;
  /** fetch aggregated fields from the table: "file_assets" */
  file_assets_aggregate: File_Assets_Aggregate;
  /** fetch data from the table: "file_assets" using primary key columns */
  file_assets_by_pk?: Maybe<File_Assets>;
  /** fetch data from the table: "flight_commands" */
  flight_commands: Array<Flight_Commands>;
  /** fetch aggregated fields from the table: "flight_commands" */
  flight_commands_aggregate: Flight_Commands_Aggregate;
  /** fetch data from the table: "flight_commands" using primary key columns */
  flight_commands_by_pk?: Maybe<Flight_Commands>;
  /** fetch data from the table: "flight_derivation_reports" */
  flight_derivation_reports: Array<Flight_Derivation_Reports>;
  /** fetch aggregated fields from the table: "flight_derivation_reports" */
  flight_derivation_reports_aggregate: Flight_Derivation_Reports_Aggregate;
  /** fetch data from the table: "flight_derivation_reports" using primary key columns */
  flight_derivation_reports_by_pk?: Maybe<Flight_Derivation_Reports>;
  /** fetch data from the table: "flight_plan_current_rpic_view" */
  flight_plan_current_rpic_view: Array<Flight_Plan_Current_Rpic_View>;
  /** fetch aggregated fields from the table: "flight_plan_current_rpic_view" */
  flight_plan_current_rpic_view_aggregate: Flight_Plan_Current_Rpic_View_Aggregate;
  /** fetch data from the table: "flight_plan_pilot_assignments" */
  flight_plan_pilot_assignments: Array<Flight_Plan_Pilot_Assignments>;
  /** fetch aggregated fields from the table: "flight_plan_pilot_assignments" */
  flight_plan_pilot_assignments_aggregate: Flight_Plan_Pilot_Assignments_Aggregate;
  /** fetch data from the table: "flight_plan_pilot_assignments" using primary key columns */
  flight_plan_pilot_assignments_by_pk?: Maybe<Flight_Plan_Pilot_Assignments>;
  /** fetch data from the table: "flight_plan_statuses" */
  flight_plan_statuses: Array<Flight_Plan_Statuses>;
  /** fetch aggregated fields from the table: "flight_plan_statuses" */
  flight_plan_statuses_aggregate: Flight_Plan_Statuses_Aggregate;
  /** fetch data from the table: "flight_plan_statuses" using primary key columns */
  flight_plan_statuses_by_pk?: Maybe<Flight_Plan_Statuses>;
  /** fetch data from the table: "flight_plan_utm_providers" */
  flight_plan_utm_providers: Array<Flight_Plan_Utm_Providers>;
  /** fetch aggregated fields from the table: "flight_plan_utm_providers" */
  flight_plan_utm_providers_aggregate: Flight_Plan_Utm_Providers_Aggregate;
  /** fetch data from the table: "flight_plan_utm_providers" using primary key columns */
  flight_plan_utm_providers_by_pk?: Maybe<Flight_Plan_Utm_Providers>;
  /** fetch data from the table: "flight_plans" */
  flight_plans: Array<Flight_Plans>;
  /** fetch aggregated fields from the table: "flight_plans" */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  /** fetch data from the table: "flight_plans" using primary key columns */
  flight_plans_by_pk?: Maybe<Flight_Plans>;
  /** fetch data from the table: "flight_routes" */
  flight_routes: Array<Flight_Routes>;
  /** fetch aggregated fields from the table: "flight_routes" */
  flight_routes_aggregate: Flight_Routes_Aggregate;
  /** fetch data from the table: "flight_routes" using primary key columns */
  flight_routes_by_pk?: Maybe<Flight_Routes>;
  /** fetch data from the table: "flight_weather_data" */
  flight_weather_data: Array<Flight_Weather_Data>;
  /** fetch aggregated fields from the table: "flight_weather_data" */
  flight_weather_data_aggregate: Flight_Weather_Data_Aggregate;
  /** fetch data from the table: "flight_weather_data" using primary key columns */
  flight_weather_data_by_pk?: Maybe<Flight_Weather_Data>;
  /** fetch data from the table: "ground_asset_commands" */
  ground_asset_commands: Array<Ground_Asset_Commands>;
  /** fetch aggregated fields from the table: "ground_asset_commands" */
  ground_asset_commands_aggregate: Ground_Asset_Commands_Aggregate;
  /** fetch data from the table: "ground_asset_commands" using primary key columns */
  ground_asset_commands_by_pk?: Maybe<Ground_Asset_Commands>;
  /** fetch data from the table: "ground_asset_model_parameter_types" */
  ground_asset_model_parameter_types: Array<Ground_Asset_Model_Parameter_Types>;
  /** fetch aggregated fields from the table: "ground_asset_model_parameter_types" */
  ground_asset_model_parameter_types_aggregate: Ground_Asset_Model_Parameter_Types_Aggregate;
  /** fetch data from the table: "ground_asset_model_parameter_types" using primary key columns */
  ground_asset_model_parameter_types_by_pk?: Maybe<Ground_Asset_Model_Parameter_Types>;
  /** fetch data from the table: "ground_asset_model_parameters" */
  ground_asset_model_parameters: Array<Ground_Asset_Model_Parameters>;
  /** fetch aggregated fields from the table: "ground_asset_model_parameters" */
  ground_asset_model_parameters_aggregate: Ground_Asset_Model_Parameters_Aggregate;
  /** fetch data from the table: "ground_asset_model_parameters" using primary key columns */
  ground_asset_model_parameters_by_pk?: Maybe<Ground_Asset_Model_Parameters>;
  /** fetch data from the table: "ground_asset_model_types" */
  ground_asset_model_types: Array<Ground_Asset_Model_Types>;
  /** fetch aggregated fields from the table: "ground_asset_model_types" */
  ground_asset_model_types_aggregate: Ground_Asset_Model_Types_Aggregate;
  /** fetch data from the table: "ground_asset_model_types" using primary key columns */
  ground_asset_model_types_by_pk?: Maybe<Ground_Asset_Model_Types>;
  /** fetch data from the table: "ground_asset_models" */
  ground_asset_models: Array<Ground_Asset_Models>;
  /** fetch aggregated fields from the table: "ground_asset_models" */
  ground_asset_models_aggregate: Ground_Asset_Models_Aggregate;
  /** fetch data from the table: "ground_asset_models" using primary key columns */
  ground_asset_models_by_pk?: Maybe<Ground_Asset_Models>;
  /** fetch data from the table: "ground_asset_networks" */
  ground_asset_networks: Array<Ground_Asset_Networks>;
  /** fetch aggregated fields from the table: "ground_asset_networks" */
  ground_asset_networks_aggregate: Ground_Asset_Networks_Aggregate;
  /** fetch data from the table: "ground_asset_networks" using primary key columns */
  ground_asset_networks_by_pk?: Maybe<Ground_Asset_Networks>;
  /** fetch data from the table: "ground_asset_status_values" */
  ground_asset_status_values: Array<Ground_Asset_Status_Values>;
  /** fetch aggregated fields from the table: "ground_asset_status_values" */
  ground_asset_status_values_aggregate: Ground_Asset_Status_Values_Aggregate;
  /** fetch data from the table: "ground_asset_status_values" using primary key columns */
  ground_asset_status_values_by_pk?: Maybe<Ground_Asset_Status_Values>;
  /** fetch data from the table: "kafka_serialized_ground_asset_statuses" */
  ground_asset_statuses: Array<Kafka_Serialized_Ground_Asset_Statuses>;
  /** fetch data from the table: "ground_assets" */
  ground_assets: Array<Ground_Assets>;
  /** fetch aggregated fields from the table: "ground_assets" */
  ground_assets_aggregate: Ground_Assets_Aggregate;
  /** fetch data from the table: "ground_assets" using primary key columns */
  ground_assets_by_pk?: Maybe<Ground_Assets>;
  /** fetch data from the table: "ground_control_workflow_state_processing_statuses" */
  ground_control_workflow_state_processing_statuses: Array<Ground_Control_Workflow_State_Processing_Statuses>;
  /** fetch aggregated fields from the table: "ground_control_workflow_state_processing_statuses" */
  ground_control_workflow_state_processing_statuses_aggregate: Ground_Control_Workflow_State_Processing_Statuses_Aggregate;
  /** fetch data from the table: "ground_control_workflow_state_processing_statuses" using primary key columns */
  ground_control_workflow_state_processing_statuses_by_pk?: Maybe<Ground_Control_Workflow_State_Processing_Statuses>;
  /** fetch data from the table: "historical_serialized_ground_asset_statuses" */
  historical_serialized_ground_asset_statuses: Array<Historical_Serialized_Ground_Asset_Statuses>;
  /** fetch aggregated fields from the table: "historical_serialized_ground_asset_statuses" */
  historical_serialized_ground_asset_statuses_aggregate: Historical_Serialized_Ground_Asset_Statuses_Aggregate;
  /** fetch data from the table: "historical_serialized_ground_asset_statuses" using primary key columns */
  historical_serialized_ground_asset_statuses_by_pk?: Maybe<Historical_Serialized_Ground_Asset_Statuses>;
  /** fetch data from the table: "historical_serialized_vehicle_statuses" */
  historical_serialized_vehicle_statuses: Array<Historical_Serialized_Vehicle_Statuses>;
  /** fetch aggregated fields from the table: "historical_serialized_vehicle_statuses" */
  historical_serialized_vehicle_statuses_aggregate: Historical_Serialized_Vehicle_Statuses_Aggregate;
  /** fetch data from the table: "historical_serialized_vehicle_statuses" using primary key columns */
  historical_serialized_vehicle_statuses_by_pk?: Maybe<Historical_Serialized_Vehicle_Statuses>;
  /** fetch data from the table: "historical_vehicle_positions" */
  historical_vehicle_positions: Array<Historical_Vehicle_Positions>;
  /** fetch aggregated fields from the table: "historical_vehicle_positions" */
  historical_vehicle_positions_aggregate: Historical_Vehicle_Positions_Aggregate;
  /** fetch data from the table: "historical_vehicle_positions" using primary key columns */
  historical_vehicle_positions_by_pk?: Maybe<Historical_Vehicle_Positions>;
  /** fetch data from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  kafka_air_traffic_vehicle_flight_proximity_recordings: Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** fetch aggregated fields from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" */
  kafka_air_traffic_vehicle_flight_proximity_recordings_aggregate: Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Aggregate;
  /** fetch data from the table: "kafka_air_traffic_vehicle_flight_proximity_recordings" using primary key columns */
  kafka_air_traffic_vehicle_flight_proximity_recordings_by_pk?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings>;
  /** fetch data from the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  kafka_cached_air_traffic_flight_proximity_recordings: Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** fetch aggregated fields from the table: "kafka_cached_air_traffic_flight_proximity_recordings" */
  kafka_cached_air_traffic_flight_proximity_recordings_aggregate: Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Aggregate;
  /** fetch data from the table: "kafka_cached_air_traffic_flight_proximity_recordings" using primary key columns */
  kafka_cached_air_traffic_flight_proximity_recordings_by_pk?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings>;
  /** fetch data from the table: "kafka_mqtt_vehicle_status_messages" */
  kafka_mqtt_vehicle_status_messages: Array<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** fetch aggregated fields from the table: "kafka_mqtt_vehicle_status_messages" */
  kafka_mqtt_vehicle_status_messages_aggregate: Kafka_Mqtt_Vehicle_Status_Messages_Aggregate;
  /** fetch data from the table: "kafka_mqtt_vehicle_status_messages" using primary key columns */
  kafka_mqtt_vehicle_status_messages_by_pk?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages>;
  /** fetch aggregated fields from the table: "kafka_serialized_ground_asset_statuses" */
  kafka_serialized_ground_asset_statuses_aggregate: Kafka_Serialized_Ground_Asset_Statuses_Aggregate;
  /** fetch data from the table: "kafka_serialized_ground_asset_statuses" using primary key columns */
  kafka_serialized_ground_asset_statuses_by_pk?: Maybe<Kafka_Serialized_Ground_Asset_Statuses>;
  /** fetch data from the table: "landing_request_statuses" */
  landing_request_statuses: Array<Landing_Request_Statuses>;
  /** fetch aggregated fields from the table: "landing_request_statuses" */
  landing_request_statuses_aggregate: Landing_Request_Statuses_Aggregate;
  /** fetch data from the table: "landing_request_statuses" using primary key columns */
  landing_request_statuses_by_pk?: Maybe<Landing_Request_Statuses>;
  /** fetch data from the table: "landing_requests" */
  landing_requests: Array<Landing_Requests>;
  /** fetch aggregated fields from the table: "landing_requests" */
  landing_requests_aggregate: Landing_Requests_Aggregate;
  /** fetch data from the table: "landing_requests" using primary key columns */
  landing_requests_by_pk?: Maybe<Landing_Requests>;
  /** fetch data from the table: "last_vehicle_anomaly_statuses" */
  last_vehicle_anomaly_statuses: Array<Last_Vehicle_Anomaly_Statuses>;
  /** fetch aggregated fields from the table: "last_vehicle_anomaly_statuses" */
  last_vehicle_anomaly_statuses_aggregate: Last_Vehicle_Anomaly_Statuses_Aggregate;
  /** fetch data from the table: "last_vehicle_anomaly_statuses" using primary key columns */
  last_vehicle_anomaly_statuses_by_pk?: Maybe<Last_Vehicle_Anomaly_Statuses>;
  /** fetch data from the table: "manifest_events" */
  manifest_events: Array<Manifest_Events>;
  /** fetch aggregated fields from the table: "manifest_events" */
  manifest_events_aggregate: Manifest_Events_Aggregate;
  /** fetch data from the table: "manifest_events" using primary key columns */
  manifest_events_by_pk?: Maybe<Manifest_Events>;
  /** fetch data from the table: "manifest_items" */
  manifest_items: Array<Manifest_Items>;
  /** fetch aggregated fields from the table: "manifest_items" */
  manifest_items_aggregate: Manifest_Items_Aggregate;
  /** fetch data from the table: "manifest_items" using primary key columns */
  manifest_items_by_pk?: Maybe<Manifest_Items>;
  /** fetch data from the table: "manifest_products" */
  manifest_products: Array<Manifest_Products>;
  /** fetch aggregated fields from the table: "manifest_products" */
  manifest_products_aggregate: Manifest_Products_Aggregate;
  /** fetch data from the table: "manifest_products" using primary key columns */
  manifest_products_by_pk?: Maybe<Manifest_Products>;
  /** fetch data from the table: "manifest_status_audits" */
  manifest_status_audits: Array<Manifest_Status_Audits>;
  /** fetch aggregated fields from the table: "manifest_status_audits" */
  manifest_status_audits_aggregate: Manifest_Status_Audits_Aggregate;
  /** fetch data from the table: "manifest_status_audits" using primary key columns */
  manifest_status_audits_by_pk?: Maybe<Manifest_Status_Audits>;
  /** fetch data from the table: "manifest_types" */
  manifest_types: Array<Manifest_Types>;
  /** fetch aggregated fields from the table: "manifest_types" */
  manifest_types_aggregate: Manifest_Types_Aggregate;
  /** fetch data from the table: "manifest_types" using primary key columns */
  manifest_types_by_pk?: Maybe<Manifest_Types>;
  /** fetch data from the table: "manifests" */
  manifests: Array<Manifests>;
  /** fetch aggregated fields from the table: "manifests" */
  manifests_aggregate: Manifests_Aggregate;
  /** fetch data from the table: "manifests_arrived_within_minute" */
  manifests_arrived_within_minute: Array<Manifests_Arrived_Within_Minute>;
  /** fetch aggregated fields from the table: "manifests_arrived_within_minute" */
  manifests_arrived_within_minute_aggregate: Manifests_Arrived_Within_Minute_Aggregate;
  /** fetch data from the table: "manifests" using primary key columns */
  manifests_by_pk?: Maybe<Manifests>;
  /** fetch data from the table: "network_utm_providers" */
  network_utm_providers: Array<Network_Utm_Providers>;
  /** fetch aggregated fields from the table: "network_utm_providers" */
  network_utm_providers_aggregate: Network_Utm_Providers_Aggregate;
  /** fetch data from the table: "network_utm_providers" using primary key columns */
  network_utm_providers_by_pk?: Maybe<Network_Utm_Providers>;
  /** fetch data from the table: "networks" */
  networks: Array<Networks>;
  /** fetch aggregated fields from the table: "networks" */
  networks_aggregate: Networks_Aggregate;
  /** fetch data from the table: "networks" using primary key columns */
  networks_by_pk?: Maybe<Networks>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizations_aggregate: Organizations_Aggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizations_by_pk?: Maybe<Organizations>;
  /** fetch data from the table: "paths" */
  paths: Array<Paths>;
  /** fetch aggregated fields from the table: "paths" */
  paths_aggregate: Paths_Aggregate;
  /** fetch data from the table: "paths" using primary key columns */
  paths_by_pk?: Maybe<Paths>;
  /** fetch data from the table: "pickup_requests" */
  pickup_requests: Array<Pickup_Requests>;
  /** fetch aggregated fields from the table: "pickup_requests" */
  pickup_requests_aggregate: Pickup_Requests_Aggregate;
  /** fetch data from the table: "pickup_requests" using primary key columns */
  pickup_requests_by_pk?: Maybe<Pickup_Requests>;
  /** fetch data from the table: "positive_exchange_of_flight_control_requests" */
  positive_exchange_of_flight_control_requests: Array<Positive_Exchange_Of_Flight_Control_Requests>;
  /** fetch aggregated fields from the table: "positive_exchange_of_flight_control_requests" */
  positive_exchange_of_flight_control_requests_aggregate: Positive_Exchange_Of_Flight_Control_Requests_Aggregate;
  /** fetch data from the table: "positive_exchange_of_flight_control_requests" using primary key columns */
  positive_exchange_of_flight_control_requests_by_pk?: Maybe<Positive_Exchange_Of_Flight_Control_Requests>;
  /** fetch data from the table: "predicted_conflicts" */
  predicted_conflicts: Array<Predicted_Conflicts>;
  /** fetch aggregated fields from the table: "predicted_conflicts" */
  predicted_conflicts_aggregate: Predicted_Conflicts_Aggregate;
  /** fetch data from the table: "predicted_conflicts" using primary key columns */
  predicted_conflicts_by_pk?: Maybe<Predicted_Conflicts>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "spatial_ref_sys" */
  spatial_ref_sys: Array<Spatial_Ref_Sys>;
  /** fetch aggregated fields from the table: "spatial_ref_sys" */
  spatial_ref_sys_aggregate: Spatial_Ref_Sys_Aggregate;
  /** fetch data from the table: "spatial_ref_sys" using primary key columns */
  spatial_ref_sys_by_pk?: Maybe<Spatial_Ref_Sys>;
  /** fetch data from the table: "squawk_severities" */
  squawk_severities: Array<Squawk_Severities>;
  /** fetch aggregated fields from the table: "squawk_severities" */
  squawk_severities_aggregate: Squawk_Severities_Aggregate;
  /** fetch data from the table: "squawk_severities" using primary key columns */
  squawk_severities_by_pk?: Maybe<Squawk_Severities>;
  /** fetch data from the table: "squawk_squawkable_types" */
  squawk_squawkable_types: Array<Squawk_Squawkable_Types>;
  /** fetch aggregated fields from the table: "squawk_squawkable_types" */
  squawk_squawkable_types_aggregate: Squawk_Squawkable_Types_Aggregate;
  /** fetch data from the table: "squawk_squawkable_types" using primary key columns */
  squawk_squawkable_types_by_pk?: Maybe<Squawk_Squawkable_Types>;
  /** fetch data from the table: "squawk_statuses" */
  squawk_statuses: Array<Squawk_Statuses>;
  /** fetch aggregated fields from the table: "squawk_statuses" */
  squawk_statuses_aggregate: Squawk_Statuses_Aggregate;
  /** fetch data from the table: "squawk_statuses" using primary key columns */
  squawk_statuses_by_pk?: Maybe<Squawk_Statuses>;
  /** fetch data from the table: "squawks" */
  squawks: Array<Squawks>;
  /** fetch aggregated fields from the table: "squawks" */
  squawks_aggregate: Squawks_Aggregate;
  /** fetch data from the table: "squawks" using primary key columns */
  squawks_by_pk?: Maybe<Squawks>;
  /** fetch data from the table: "stations" */
  stations: Array<Stations>;
  /** fetch aggregated fields from the table: "stations" */
  stations_aggregate: Stations_Aggregate;
  /** fetch data from the table: "stations" using primary key columns */
  stations_by_pk?: Maybe<Stations>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** fetch data from the table: "type_cert_flight_analysis_data" */
  type_cert_flight_analysis_data: Array<Type_Cert_Flight_Analysis_Data>;
  /** fetch aggregated fields from the table: "type_cert_flight_analysis_data" */
  type_cert_flight_analysis_data_aggregate: Type_Cert_Flight_Analysis_Data_Aggregate;
  /** fetch data from the table: "type_cert_flight_analysis_data" using primary key columns */
  type_cert_flight_analysis_data_by_pk?: Maybe<Type_Cert_Flight_Analysis_Data>;
  /** fetch data from the table: "type_cert_manual_data" */
  type_cert_manual_data: Array<Type_Cert_Manual_Data>;
  /** fetch aggregated fields from the table: "type_cert_manual_data" */
  type_cert_manual_data_aggregate: Type_Cert_Manual_Data_Aggregate;
  /** fetch data from the table: "type_cert_manual_data" using primary key columns */
  type_cert_manual_data_by_pk?: Maybe<Type_Cert_Manual_Data>;
  /** fetch data from the table: "user_app_states" */
  user_app_states: Array<User_App_States>;
  /** fetch aggregated fields from the table: "user_app_states" */
  user_app_states_aggregate: User_App_States_Aggregate;
  /** fetch data from the table: "user_networks" */
  user_networks: Array<User_Networks>;
  /** fetch aggregated fields from the table: "user_networks" */
  user_networks_aggregate: User_Networks_Aggregate;
  /** fetch data from the table: "user_networks" using primary key columns */
  user_networks_by_pk?: Maybe<User_Networks>;
  /** fetch data from the table: "user_permissions_view" */
  user_permissions_view: Array<User_Permissions_View>;
  /** fetch aggregated fields from the table: "user_permissions_view" */
  user_permissions_view_aggregate: User_Permissions_View_Aggregate;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "vehicle_airworthiness_categories" */
  vehicle_airworthiness_categories: Array<Vehicle_Airworthiness_Categories>;
  /** fetch aggregated fields from the table: "vehicle_airworthiness_categories" */
  vehicle_airworthiness_categories_aggregate: Vehicle_Airworthiness_Categories_Aggregate;
  /** fetch data from the table: "vehicle_airworthiness_categories" using primary key columns */
  vehicle_airworthiness_categories_by_pk?: Maybe<Vehicle_Airworthiness_Categories>;
  /** fetch data from the table: "vehicle_alerts" */
  vehicle_alerts: Array<Vehicle_Alerts>;
  /** fetch aggregated fields from the table: "vehicle_alerts" */
  vehicle_alerts_aggregate: Vehicle_Alerts_Aggregate;
  /** fetch data from the table: "vehicle_alerts" using primary key columns */
  vehicle_alerts_by_pk?: Maybe<Vehicle_Alerts>;
  /** fetch data from the table: "vehicle_flight_state_enum" */
  vehicle_flight_state_enum: Array<Vehicle_Flight_State_Enum>;
  /** fetch aggregated fields from the table: "vehicle_flight_state_enum" */
  vehicle_flight_state_enum_aggregate: Vehicle_Flight_State_Enum_Aggregate;
  /** fetch data from the table: "vehicle_flight_state_enum" using primary key columns */
  vehicle_flight_state_enum_by_pk?: Maybe<Vehicle_Flight_State_Enum>;
  /** fetch data from the table: "vehicle_flight_statuses" */
  vehicle_flight_statuses: Array<Vehicle_Flight_Statuses>;
  /** fetch aggregated fields from the table: "vehicle_flight_statuses" */
  vehicle_flight_statuses_aggregate: Vehicle_Flight_Statuses_Aggregate;
  /** fetch data from the table: "vehicle_flight_statuses" using primary key columns */
  vehicle_flight_statuses_by_pk?: Maybe<Vehicle_Flight_Statuses>;
  /** fetch data from the table: "vehicle_model_parameter_types" */
  vehicle_model_parameter_types: Array<Vehicle_Model_Parameter_Types>;
  /** fetch aggregated fields from the table: "vehicle_model_parameter_types" */
  vehicle_model_parameter_types_aggregate: Vehicle_Model_Parameter_Types_Aggregate;
  /** fetch data from the table: "vehicle_model_parameter_types" using primary key columns */
  vehicle_model_parameter_types_by_pk?: Maybe<Vehicle_Model_Parameter_Types>;
  /** fetch data from the table: "vehicle_model_parameters" */
  vehicle_model_parameters: Array<Vehicle_Model_Parameters>;
  /** fetch aggregated fields from the table: "vehicle_model_parameters" */
  vehicle_model_parameters_aggregate: Vehicle_Model_Parameters_Aggregate;
  /** fetch data from the table: "vehicle_model_parameters" using primary key columns */
  vehicle_model_parameters_by_pk?: Maybe<Vehicle_Model_Parameters>;
  /** fetch data from the table: "vehicle_models" */
  vehicle_models: Array<Vehicle_Models>;
  /** fetch aggregated fields from the table: "vehicle_models" */
  vehicle_models_aggregate: Vehicle_Models_Aggregate;
  /** fetch data from the table: "vehicle_models_ancestors" */
  vehicle_models_ancestors: Array<Vehicle_Models_Ancestors>;
  /** fetch aggregated fields from the table: "vehicle_models_ancestors" */
  vehicle_models_ancestors_aggregate: Vehicle_Models_Ancestors_Aggregate;
  /** fetch data from the table: "vehicle_models_ancestors" using primary key columns */
  vehicle_models_ancestors_by_pk?: Maybe<Vehicle_Models_Ancestors>;
  /** fetch data from the table: "vehicle_models" using primary key columns */
  vehicle_models_by_pk?: Maybe<Vehicle_Models>;
  /** fetch data from the table: "vehicle_networks" */
  vehicle_networks: Array<Vehicle_Networks>;
  /** fetch aggregated fields from the table: "vehicle_networks" */
  vehicle_networks_aggregate: Vehicle_Networks_Aggregate;
  /** fetch data from the table: "vehicle_networks" using primary key columns */
  vehicle_networks_by_pk?: Maybe<Vehicle_Networks>;
  /** fetch data from the table: "vehicle_pilot_assignments" */
  vehicle_pilot_assignments: Array<Vehicle_Pilot_Assignments>;
  /** fetch aggregated fields from the table: "vehicle_pilot_assignments" */
  vehicle_pilot_assignments_aggregate: Vehicle_Pilot_Assignments_Aggregate;
  /** fetch data from the table: "vehicle_pilot_assignments" using primary key columns */
  vehicle_pilot_assignments_by_pk?: Maybe<Vehicle_Pilot_Assignments>;
  /** fetch data from the table: "vehicle_priority_event_keys" */
  vehicle_priority_event_keys: Array<Vehicle_Priority_Event_Keys>;
  /** fetch aggregated fields from the table: "vehicle_priority_event_keys" */
  vehicle_priority_event_keys_aggregate: Vehicle_Priority_Event_Keys_Aggregate;
  /** fetch data from the table: "vehicle_priority_event_keys" using primary key columns */
  vehicle_priority_event_keys_by_pk?: Maybe<Vehicle_Priority_Event_Keys>;
  /** fetch data from the table: "vehicle_priority_events" */
  vehicle_priority_events: Array<Vehicle_Priority_Events>;
  /** fetch aggregated fields from the table: "vehicle_priority_events" */
  vehicle_priority_events_aggregate: Vehicle_Priority_Events_Aggregate;
  /** fetch data from the table: "vehicle_priority_events" using primary key columns */
  vehicle_priority_events_by_pk?: Maybe<Vehicle_Priority_Events>;
  /** fetch data from the table: "vehicle_status_updates" */
  vehicle_status_updates: Array<Vehicle_Status_Updates>;
  /** fetch aggregated fields from the table: "vehicle_status_updates" */
  vehicle_status_updates_aggregate: Vehicle_Status_Updates_Aggregate;
  /** fetch data from the table: "vehicle_status_updates" using primary key columns */
  vehicle_status_updates_by_pk?: Maybe<Vehicle_Status_Updates>;
  /** fetch data from the table: "kafka_serialized_vehicle_statuses" */
  vehicle_statuses: Array<Kafka_Serialized_Vehicle_Statuses>;
  /** fetch aggregated fields from the table: "kafka_serialized_vehicle_statuses" */
  vehicle_statuses_aggregate: Kafka_Serialized_Vehicle_Statuses_Aggregate;
  /** fetch data from the table: "kafka_serialized_vehicle_statuses" using primary key columns */
  vehicle_statuses_by_pk?: Maybe<Kafka_Serialized_Vehicle_Statuses>;
  /** fetch data from the table: "vehicles" */
  vehicles: Array<Vehicles>;
  /** fetch aggregated fields from the table: "vehicles" */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Deconfliction_Algorithm_TypesArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Order_By>>;
  where?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Deconfliction_Algorithm_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Deconfliction_Algorithm_Types_Order_By>>;
  where?: Maybe<Air_Traffic_Deconfliction_Algorithm_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Deconfliction_Algorithm_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootAir_Traffic_Monitor_TasksArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Monitor_Tasks_Order_By>>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Monitor_Tasks_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Monitor_Tasks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Monitor_Tasks_Order_By>>;
  where?: Maybe<Air_Traffic_Monitor_Tasks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Monitor_Tasks_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootAir_Traffic_TracksArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Tracks_AggregateArgs = {
  distinct_on?: Maybe<Array<Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAir_Traffic_Tracks_By_PkArgs = {
  id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootAircraft_Type_DesignatorsArgs = {
  distinct_on?: Maybe<Array<Aircraft_Type_Designators_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Aircraft_Type_Designators_Order_By>>;
  where?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAircraft_Type_Designators_AggregateArgs = {
  distinct_on?: Maybe<Array<Aircraft_Type_Designators_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Aircraft_Type_Designators_Order_By>>;
  where?: Maybe<Aircraft_Type_Designators_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAircraft_Type_Designators_By_PkArgs = {
  designator: Scalars['String'];
};


/** subscription root */
export type Subscription_RootAirspacesArgs = {
  distinct_on?: Maybe<Array<Airspaces_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Airspaces_Order_By>>;
  where?: Maybe<Airspaces_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAirspaces_AggregateArgs = {
  distinct_on?: Maybe<Array<Airspaces_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Airspaces_Order_By>>;
  where?: Maybe<Airspaces_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAirspaces_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootAvailable_Aircraft_Command_SetsArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_Sets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_Sets_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAvailable_Aircraft_Command_Sets_AggregateArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_Sets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_Sets_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAvailable_Aircraft_Command_Sets_By_PkArgs = {
  aircraft_serial_number: Scalars['String'];
};


/** subscription root */
export type Subscription_RootAvailable_Aircraft_Command_State_KeysArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_State_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_State_Keys_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAvailable_Aircraft_Command_State_Keys_AggregateArgs = {
  distinct_on?: Maybe<Array<Available_Aircraft_Command_State_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Available_Aircraft_Command_State_Keys_Order_By>>;
  where?: Maybe<Available_Aircraft_Command_State_Keys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootAvailable_Aircraft_Command_State_Keys_By_PkArgs = {
  state_key: Scalars['String'];
};


/** subscription root */
export type Subscription_RootBadge_TokensArgs = {
  distinct_on?: Maybe<Array<Badge_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Badge_Tokens_Order_By>>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBadge_Tokens_AggregateArgs = {
  distinct_on?: Maybe<Array<Badge_Tokens_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Badge_Tokens_Order_By>>;
  where?: Maybe<Badge_Tokens_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBadge_Tokens_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootBatteriesArgs = {
  distinct_on?: Maybe<Array<Batteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batteries_Order_By>>;
  where?: Maybe<Batteries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBatteries_AggregateArgs = {
  distinct_on?: Maybe<Array<Batteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batteries_Order_By>>;
  where?: Maybe<Batteries_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootBatteries_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootContingency_Landing_SpotsArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootContingency_Landing_Spots_AggregateArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootContingency_Landing_Spots_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootCurrent_Air_Traffic_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurrent_Air_Traffic_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Proximity_Recordings_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Proximity_Recordings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurrent_Air_Traffic_TracksArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurrent_Air_Traffic_Tracks_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurrent_Utm_Air_Traffic_TracksArgs = {
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootCurrent_Utm_Air_Traffic_Tracks_AggregateArgs = {
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDaa_ObservationsArgs = {
  distinct_on?: Maybe<Array<Daa_Observations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Observations_Order_By>>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDaa_Observations_AggregateArgs = {
  distinct_on?: Maybe<Array<Daa_Observations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Observations_Order_By>>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDaa_Observations_By_PkArgs = {
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};


/** subscription root */
export type Subscription_RootDaa_StatusesArgs = {
  distinct_on?: Maybe<Array<Daa_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Statuses_Order_By>>;
  where?: Maybe<Daa_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDaa_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Daa_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Statuses_Order_By>>;
  where?: Maybe<Daa_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootDaa_Statuses_By_PkArgs = {
  vehicle_serial_number: Scalars['String'];
};


/** subscription root */
export type Subscription_RootEnv_Feature_FlagsArgs = {
  distinct_on?: Maybe<Array<Env_Feature_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Env_Feature_Flags_Order_By>>;
  where?: Maybe<Env_Feature_Flags_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnv_Feature_Flags_AggregateArgs = {
  distinct_on?: Maybe<Array<Env_Feature_Flags_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Env_Feature_Flags_Order_By>>;
  where?: Maybe<Env_Feature_Flags_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootEnv_Feature_Flags_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFetch_Current_Deduped_Air_Traffic_TracksArgs = {
  args: Fetch_Current_Deduped_Air_Traffic_Tracks_Args;
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFetch_Current_Deduped_Air_Traffic_Tracks_AggregateArgs = {
  args: Fetch_Current_Deduped_Air_Traffic_Tracks_Args;
  distinct_on?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Current_Utm_Air_Traffic_Tracks_Order_By>>;
  where?: Maybe<Current_Utm_Air_Traffic_Tracks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Asset_TypesArgs = {
  distinct_on?: Maybe<Array<File_Asset_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Asset_Types_Order_By>>;
  where?: Maybe<File_Asset_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Asset_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Asset_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Asset_Types_Order_By>>;
  where?: Maybe<File_Asset_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Asset_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootFile_AssetsArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFile_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFlight_CommandsArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Commands_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFlight_Derivation_ReportsArgs = {
  distinct_on?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Derivation_Reports_Order_By>>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Derivation_Reports_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Derivation_Reports_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Derivation_Reports_Order_By>>;
  where?: Maybe<Flight_Derivation_Reports_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Derivation_Reports_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFlight_Plan_Current_Rpic_ViewArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Current_Rpic_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Current_Rpic_View_Order_By>>;
  where?: Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Current_Rpic_View_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Current_Rpic_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Current_Rpic_View_Order_By>>;
  where?: Maybe<Flight_Plan_Current_Rpic_View_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Pilot_AssignmentsArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Pilot_Assignments_Order_By>>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Pilot_Assignments_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Pilot_Assignments_Order_By>>;
  where?: Maybe<Flight_Plan_Pilot_Assignments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Pilot_Assignments_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFlight_Plan_StatusesArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Statuses_Order_By>>;
  where?: Maybe<Flight_Plan_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Statuses_Order_By>>;
  where?: Maybe<Flight_Plan_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootFlight_Plan_Utm_ProvidersArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Utm_Providers_Order_By>>;
  where?: Maybe<Flight_Plan_Utm_Providers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Utm_Providers_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plan_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plan_Utm_Providers_Order_By>>;
  where?: Maybe<Flight_Plan_Utm_Providers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plan_Utm_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Plans_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFlight_RoutesArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Routes_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Routes_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootFlight_Weather_DataArgs = {
  distinct_on?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Weather_Data_Order_By>>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Weather_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Weather_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Weather_Data_Order_By>>;
  where?: Maybe<Flight_Weather_Data_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootFlight_Weather_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGround_Asset_CommandsArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Commands_Order_By>>;
  where?: Maybe<Ground_Asset_Commands_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Commands_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Parameter_TypesArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Parameter_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameter_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Parameter_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_ParametersArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameters_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Parameters_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Parameters_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Parameters_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_TypesArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Model_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Model_Types_Order_By>>;
  where?: Maybe<Ground_Asset_Model_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Model_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootGround_Asset_ModelsArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Models_Order_By>>;
  where?: Maybe<Ground_Asset_Models_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Models_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Models_Order_By>>;
  where?: Maybe<Ground_Asset_Models_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Models_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGround_Asset_NetworksArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Networks_Order_By>>;
  where?: Maybe<Ground_Asset_Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Networks_By_PkArgs = {
  ground_asset_id: Scalars['Int'];
  network_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGround_Asset_Status_ValuesArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Status_Values_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Status_Values_Order_By>>;
  where?: Maybe<Ground_Asset_Status_Values_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Status_Values_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Asset_Status_Values_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Asset_Status_Values_Order_By>>;
  where?: Maybe<Ground_Asset_Status_Values_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Asset_Status_Values_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootGround_Asset_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_AssetsArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Assets_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootGround_Control_Workflow_State_Processing_StatusesArgs = {
  distinct_on?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Order_By>>;
  where?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Control_Workflow_State_Processing_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Control_Workflow_State_Processing_Statuses_Order_By>>;
  where?: Maybe<Ground_Control_Workflow_State_Processing_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootGround_Control_Workflow_State_Processing_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootHistorical_Serialized_Ground_Asset_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootHistorical_Serialized_Ground_Asset_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootHistorical_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** subscription root */
export type Subscription_RootHistorical_Serialized_Vehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootHistorical_Serialized_Vehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootHistorical_Serialized_Vehicle_Statuses_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** subscription root */
export type Subscription_RootHistorical_Vehicle_PositionsArgs = {
  distinct_on?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Vehicle_Positions_Order_By>>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootHistorical_Vehicle_Positions_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Vehicle_Positions_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Vehicle_Positions_Order_By>>;
  where?: Maybe<Historical_Vehicle_Positions_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootHistorical_Vehicle_Positions_By_PkArgs = {
  serial_number: Scalars['String'];
  timestamp_secs: Scalars['float8'];
};


/** subscription root */
export type Subscription_RootKafka_Air_Traffic_Vehicle_Flight_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Air_Traffic_Vehicle_Flight_Proximity_Recordings_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** subscription root */
export type Subscription_RootKafka_Cached_Air_Traffic_Flight_Proximity_RecordingsArgs = {
  distinct_on?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Cached_Air_Traffic_Flight_Proximity_Recordings_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Order_By>>;
  where?: Maybe<Kafka_Cached_Air_Traffic_Flight_Proximity_Recordings_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Cached_Air_Traffic_Flight_Proximity_Recordings_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
  id: Scalars['String'];
};


/** subscription root */
export type Subscription_RootKafka_Mqtt_Vehicle_Status_MessagesArgs = {
  distinct_on?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Order_By>>;
  where?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Mqtt_Vehicle_Status_Messages_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Mqtt_Vehicle_Status_Messages_Order_By>>;
  where?: Maybe<Kafka_Mqtt_Vehicle_Status_Messages_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Mqtt_Vehicle_Status_Messages_By_PkArgs = {
  serial_number: Scalars['String'];
  timestamp: Scalars['float8'];
};


/** subscription root */
export type Subscription_RootKafka_Serialized_Ground_Asset_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Ground_Asset_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Ground_Asset_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootKafka_Serialized_Ground_Asset_Statuses_By_PkArgs = {
  topic: Scalars['String'];
};


/** subscription root */
export type Subscription_RootLanding_Request_StatusesArgs = {
  distinct_on?: Maybe<Array<Landing_Request_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Request_Statuses_Order_By>>;
  where?: Maybe<Landing_Request_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLanding_Request_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Request_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Request_Statuses_Order_By>>;
  where?: Maybe<Landing_Request_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLanding_Request_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootLanding_RequestsArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLanding_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLanding_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootLast_Vehicle_Anomaly_StatusesArgs = {
  distinct_on?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Order_By>>;
  where?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLast_Vehicle_Anomaly_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Last_Vehicle_Anomaly_Statuses_Order_By>>;
  where?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootLast_Vehicle_Anomaly_Statuses_By_PkArgs = {
  vehicle_serial_number: Scalars['String'];
};


/** subscription root */
export type Subscription_RootManifest_EventsArgs = {
  distinct_on?: Maybe<Array<Manifest_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Events_Order_By>>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Events_Order_By>>;
  where?: Maybe<Manifest_Events_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootManifest_ItemsArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Items_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Items_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Items_Order_By>>;
  where?: Maybe<Manifest_Items_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Items_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootManifest_ProductsArgs = {
  distinct_on?: Maybe<Array<Manifest_Products_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Products_Order_By>>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Products_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Products_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Products_Order_By>>;
  where?: Maybe<Manifest_Products_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Products_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootManifest_Status_AuditsArgs = {
  distinct_on?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Status_Audits_Order_By>>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Status_Audits_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Status_Audits_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Status_Audits_Order_By>>;
  where?: Maybe<Manifest_Status_Audits_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Status_Audits_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootManifest_TypesArgs = {
  distinct_on?: Maybe<Array<Manifest_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Types_Order_By>>;
  where?: Maybe<Manifest_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifest_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifest_Types_Order_By>>;
  where?: Maybe<Manifest_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifest_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootManifestsArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifests_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifests_Arrived_Within_MinuteArgs = {
  distinct_on?: Maybe<Array<Manifests_Arrived_Within_Minute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Arrived_Within_Minute_Order_By>>;
  where?: Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifests_Arrived_Within_Minute_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Arrived_Within_Minute_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Arrived_Within_Minute_Order_By>>;
  where?: Maybe<Manifests_Arrived_Within_Minute_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootManifests_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootNetwork_Utm_ProvidersArgs = {
  distinct_on?: Maybe<Array<Network_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Network_Utm_Providers_Order_By>>;
  where?: Maybe<Network_Utm_Providers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNetwork_Utm_Providers_AggregateArgs = {
  distinct_on?: Maybe<Array<Network_Utm_Providers_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Network_Utm_Providers_Order_By>>;
  where?: Maybe<Network_Utm_Providers_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNetwork_Utm_Providers_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootNetworksArgs = {
  distinct_on?: Maybe<Array<Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Networks_Order_By>>;
  where?: Maybe<Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNetworks_AggregateArgs = {
  distinct_on?: Maybe<Array<Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Networks_Order_By>>;
  where?: Maybe<Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootNetworks_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootOrganizationsArgs = {
  distinct_on?: Maybe<Array<Organizations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Organizations_Order_By>>;
  where?: Maybe<Organizations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootOrganizations_AggregateArgs = {
  distinct_on?: Maybe<Array<Organizations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Organizations_Order_By>>;
  where?: Maybe<Organizations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootOrganizations_By_PkArgs = {
  key: Scalars['String'];
};


/** subscription root */
export type Subscription_RootPathsArgs = {
  distinct_on?: Maybe<Array<Paths_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Paths_Order_By>>;
  where?: Maybe<Paths_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPaths_AggregateArgs = {
  distinct_on?: Maybe<Array<Paths_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Paths_Order_By>>;
  where?: Maybe<Paths_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPaths_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootPickup_RequestsArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPickup_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPickup_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootPositive_Exchange_Of_Flight_Control_RequestsArgs = {
  distinct_on?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Order_By>>;
  where?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPositive_Exchange_Of_Flight_Control_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Positive_Exchange_Of_Flight_Control_Requests_Order_By>>;
  where?: Maybe<Positive_Exchange_Of_Flight_Control_Requests_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPositive_Exchange_Of_Flight_Control_Requests_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootPredicted_ConflictsArgs = {
  distinct_on?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Predicted_Conflicts_Order_By>>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPredicted_Conflicts_AggregateArgs = {
  distinct_on?: Maybe<Array<Predicted_Conflicts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Predicted_Conflicts_Order_By>>;
  where?: Maybe<Predicted_Conflicts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootPredicted_Conflicts_By_PkArgs = {
  alert_level: Scalars['String'];
  observation_id: Scalars['String'];
  vehicle_serial_number: Scalars['String'];
};


/** subscription root */
export type Subscription_RootRolesArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: Maybe<Array<Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Roles_Order_By>>;
  where?: Maybe<Roles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootRoles_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootSpatial_Ref_SysArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpatial_Ref_Sys_AggregateArgs = {
  distinct_on?: Maybe<Array<Spatial_Ref_Sys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Spatial_Ref_Sys_Order_By>>;
  where?: Maybe<Spatial_Ref_Sys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSpatial_Ref_Sys_By_PkArgs = {
  srid: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootSquawk_SeveritiesArgs = {
  distinct_on?: Maybe<Array<Squawk_Severities_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Severities_Order_By>>;
  where?: Maybe<Squawk_Severities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawk_Severities_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawk_Severities_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Severities_Order_By>>;
  where?: Maybe<Squawk_Severities_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawk_Severities_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootSquawk_Squawkable_TypesArgs = {
  distinct_on?: Maybe<Array<Squawk_Squawkable_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Squawkable_Types_Order_By>>;
  where?: Maybe<Squawk_Squawkable_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawk_Squawkable_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawk_Squawkable_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Squawkable_Types_Order_By>>;
  where?: Maybe<Squawk_Squawkable_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawk_Squawkable_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootSquawk_StatusesArgs = {
  distinct_on?: Maybe<Array<Squawk_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Statuses_Order_By>>;
  where?: Maybe<Squawk_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawk_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawk_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawk_Statuses_Order_By>>;
  where?: Maybe<Squawk_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawk_Statuses_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootSquawksArgs = {
  distinct_on?: Maybe<Array<Squawks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawks_Order_By>>;
  where?: Maybe<Squawks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawks_AggregateArgs = {
  distinct_on?: Maybe<Array<Squawks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Squawks_Order_By>>;
  where?: Maybe<Squawks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootSquawks_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootStationsArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStations_AggregateArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootStations_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootTenantsArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTenants_AggregateArgs = {
  distinct_on?: Maybe<Array<Tenants_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Tenants_Order_By>>;
  where?: Maybe<Tenants_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootTenants_By_PkArgs = {
  id: Scalars['uuid'];
};


/** subscription root */
export type Subscription_RootType_Cert_Flight_Analysis_DataArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Order_By>>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootType_Cert_Flight_Analysis_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Order_By>>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootType_Cert_Flight_Analysis_Data_By_PkArgs = {
  flight_plan_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootType_Cert_Manual_DataArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Manual_Data_Order_By>>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootType_Cert_Manual_Data_AggregateArgs = {
  distinct_on?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Type_Cert_Manual_Data_Order_By>>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootType_Cert_Manual_Data_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootUser_App_StatesArgs = {
  distinct_on?: Maybe<Array<User_App_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_App_States_Order_By>>;
  where?: Maybe<User_App_States_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_App_States_AggregateArgs = {
  distinct_on?: Maybe<Array<User_App_States_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_App_States_Order_By>>;
  where?: Maybe<User_App_States_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_NetworksArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Networks_By_PkArgs = {
  network_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootUser_Permissions_ViewArgs = {
  distinct_on?: Maybe<Array<User_Permissions_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Permissions_View_Order_By>>;
  where?: Maybe<User_Permissions_View_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Permissions_View_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Permissions_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Permissions_View_Order_By>>;
  where?: Maybe<User_Permissions_View_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_RolesArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUser_Roles_By_PkArgs = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_Airworthiness_CategoriesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Airworthiness_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Airworthiness_Categories_Order_By>>;
  where?: Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Airworthiness_Categories_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Airworthiness_Categories_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Airworthiness_Categories_Order_By>>;
  where?: Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Airworthiness_Categories_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehicle_AlertsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Alerts_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Alerts_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_Flight_State_EnumArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_State_Enum_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_State_Enum_Order_By>>;
  where?: Maybe<Vehicle_Flight_State_Enum_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Flight_State_Enum_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_State_Enum_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_State_Enum_Order_By>>;
  where?: Maybe<Vehicle_Flight_State_Enum_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Flight_State_Enum_By_PkArgs = {
  state: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehicle_Flight_StatusesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_Statuses_Order_By>>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Flight_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Flight_Statuses_Order_By>>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Flight_Statuses_By_PkArgs = {
  serial_number: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehicle_Model_Parameter_TypesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Model_Parameter_Types_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameter_Types_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameter_Types_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Model_Parameter_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehicle_Model_ParametersArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameters_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Model_Parameters_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameters_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Model_Parameters_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_ModelsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Order_By>>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Models_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Order_By>>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Models_AncestorsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Models_Ancestors_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Models_Ancestors_By_PkArgs = {
  ancestor_id: Scalars['Int'];
  vehicle_model_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_Models_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_NetworksArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Networks_By_PkArgs = {
  network_id: Scalars['Int'];
  vehicle_id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_Pilot_AssignmentsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Pilot_Assignments_Order_By>>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Pilot_Assignments_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Pilot_Assignments_Order_By>>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Pilot_Assignments_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_Priority_Event_KeysArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Event_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Event_Keys_Order_By>>;
  where?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Priority_Event_Keys_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Event_Keys_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Event_Keys_Order_By>>;
  where?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Priority_Event_Keys_By_PkArgs = {
  event_key: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehicle_Priority_EventsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Priority_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Priority_Events_By_PkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type Subscription_RootVehicle_Status_UpdatesArgs = {
  distinct_on?: Maybe<Array<Vehicle_Status_Updates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Status_Updates_Order_By>>;
  where?: Maybe<Vehicle_Status_Updates_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Status_Updates_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Status_Updates_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Status_Updates_Order_By>>;
  where?: Maybe<Vehicle_Status_Updates_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Status_Updates_By_PkArgs = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicle_Statuses_By_PkArgs = {
  topic: Scalars['String'];
};


/** subscription root */
export type Subscription_RootVehiclesArgs = {
  distinct_on?: Maybe<Array<Vehicles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicles_Order_By>>;
  where?: Maybe<Vehicles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicles_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicles_Order_By>>;
  where?: Maybe<Vehicles_Bool_Exp>;
};


/** subscription root */
export type Subscription_RootVehicles_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "tenants" */
export type Tenants = {
  __typename?: 'tenants';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  tenant_type: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregated array relationship */
  users_aggregate: Users_Aggregate;
  version: Scalars['Int'];
};


/** columns and relationships of "tenants" */
export type TenantsUsersArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsUsers_AggregateArgs = {
  distinct_on?: Maybe<Array<Users_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Users_Order_By>>;
  where?: Maybe<Users_Bool_Exp>;
};

/** aggregated selection of "tenants" */
export type Tenants_Aggregate = {
  __typename?: 'tenants_aggregate';
  aggregate?: Maybe<Tenants_Aggregate_Fields>;
  nodes: Array<Tenants>;
};

/** aggregate fields of "tenants" */
export type Tenants_Aggregate_Fields = {
  __typename?: 'tenants_aggregate_fields';
  avg?: Maybe<Tenants_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Tenants_Max_Fields>;
  min?: Maybe<Tenants_Min_Fields>;
  stddev?: Maybe<Tenants_Stddev_Fields>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Fields>;
  sum?: Maybe<Tenants_Sum_Fields>;
  var_pop?: Maybe<Tenants_Var_Pop_Fields>;
  var_samp?: Maybe<Tenants_Var_Samp_Fields>;
  variance?: Maybe<Tenants_Variance_Fields>;
};


/** aggregate fields of "tenants" */
export type Tenants_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Tenants_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tenants" */
export type Tenants_Aggregate_Order_By = {
  avg?: Maybe<Tenants_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Tenants_Max_Order_By>;
  min?: Maybe<Tenants_Min_Order_By>;
  stddev?: Maybe<Tenants_Stddev_Order_By>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Order_By>;
  sum?: Maybe<Tenants_Sum_Order_By>;
  var_pop?: Maybe<Tenants_Var_Pop_Order_By>;
  var_samp?: Maybe<Tenants_Var_Samp_Order_By>;
  variance?: Maybe<Tenants_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tenants" */
export type Tenants_Arr_Rel_Insert_Input = {
  data: Array<Tenants_Insert_Input>;
  on_conflict?: Maybe<Tenants_On_Conflict>;
};

/** aggregate avg on columns */
export type Tenants_Avg_Fields = {
  __typename?: 'tenants_avg_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tenants" */
export type Tenants_Avg_Order_By = {
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Tenants_Bool_Exp>>>;
  _not?: Maybe<Tenants_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Tenants_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Uuid_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  tenant_type?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  users?: Maybe<Users_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenants" */
export enum Tenants_Constraint {
  /** unique or primary key constraint */
  TenantsNameKey = 'tenants_name_key',
  /** unique or primary key constraint */
  TenantsPkey = 'tenants_pkey'
}

/** input type for incrementing integer column in table "tenants" */
export type Tenants_Inc_Input = {
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "tenants" */
export type Tenants_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tenant_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  users?: Maybe<Users_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Tenants_Max_Fields = {
  __typename?: 'tenants_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tenant_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "tenants" */
export type Tenants_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  tenant_type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Tenants_Min_Fields = {
  __typename?: 'tenants_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tenant_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "tenants" */
export type Tenants_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  tenant_type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "tenants" */
export type Tenants_Mutation_Response = {
  __typename?: 'tenants_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Tenants>;
};

/** input type for inserting object relation for remote table "tenants" */
export type Tenants_Obj_Rel_Insert_Input = {
  data: Tenants_Insert_Input;
  on_conflict?: Maybe<Tenants_On_Conflict>;
};

/** on conflict condition type for table "tenants" */
export type Tenants_On_Conflict = {
  constraint: Tenants_Constraint;
  update_columns: Array<Tenants_Update_Column>;
  where?: Maybe<Tenants_Bool_Exp>;
};

/** ordering options when selecting data from "tenants" */
export type Tenants_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  tenant_type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  users_aggregate?: Maybe<Users_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "tenants" */
export type Tenants_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "tenants" */
export type Tenants_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tenant_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Tenants_Stddev_Fields = {
  __typename?: 'tenants_stddev_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tenants" */
export type Tenants_Stddev_Order_By = {
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tenants_Stddev_Pop_Fields = {
  __typename?: 'tenants_stddev_pop_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tenants" */
export type Tenants_Stddev_Pop_Order_By = {
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tenants_Stddev_Samp_Fields = {
  __typename?: 'tenants_stddev_samp_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tenants" */
export type Tenants_Stddev_Samp_Order_By = {
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Tenants_Sum_Fields = {
  __typename?: 'tenants_sum_fields';
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tenants" */
export type Tenants_Sum_Order_By = {
  version?: Maybe<Order_By>;
};

/** update columns of table "tenants" */
export enum Tenants_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Tenants_Var_Pop_Fields = {
  __typename?: 'tenants_var_pop_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tenants" */
export type Tenants_Var_Pop_Order_By = {
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tenants_Var_Samp_Fields = {
  __typename?: 'tenants_var_samp_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tenants" */
export type Tenants_Var_Samp_Order_By = {
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Tenants_Variance_Fields = {
  __typename?: 'tenants_variance_fields';
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tenants" */
export type Tenants_Variance_Order_By = {
  version?: Maybe<Order_By>;
};


/** expression to compare columns of type time. All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: Maybe<Scalars['time']>;
  _gt?: Maybe<Scalars['time']>;
  _gte?: Maybe<Scalars['time']>;
  _in?: Maybe<Array<Scalars['time']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['time']>;
  _lte?: Maybe<Scalars['time']>;
  _neq?: Maybe<Scalars['time']>;
  _nin?: Maybe<Array<Scalars['time']>>;
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data = {
  __typename?: 'type_cert_flight_analysis_data';
  /** Average elevation of the landing in meters as measured by the barometric sensors. */
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  /** Maximum altitude in meters measured by the primary barometric sensor during the cruise phase of flight. */
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  /** Mean altitude in meters measured by the primary barometric sensor during the cruise phase of flight. */
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  /** Maximum altitude in meters measured by the secondary barometric sensor during the cruise phase of flight. */
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  /** Mean altitude in meters measured by the secondary barometric sensor during the cruise phase of flight. */
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  /** Average elevation of the takeoff in meters as measured by the barometric sensors. */
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  created_at: Scalars['timestamptz'];
  /** Time spent in the cruise phase of the flight in seconds. */
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  /** An object relationship */
  flight_plan: Flight_Plans;
  /** Flight plan ID corresponding to the data record */
  flight_plan_id: Scalars['Int'];
  /** Whether the analysis found that the FTS onbaord the vehicle was triggered. */
  fts_triggered?: Maybe<Scalars['Boolean']>;
  /** Average elevation of the landing in meters as measured by the GPS sensors. */
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  /** Maximum altitude in meters measured by the primary GPS sensor during flight. */
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  /** Mean altitude in meters measured by the primary GPS sensor during flight. */
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  /** Maximum speed in meters per seconds measured by the primary GPS sensor during flight. */
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  /** Mean speed in meters per seconds measured by the primary GPS sensor during flight. */
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  /** Range of the flight in meters as measured by the primary GPS sensor. */
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  /** Range of the flight in meters as measured by the secondary GPS sensor. */
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  /** Maximum altitude in meters measured by the secondary GPS sensor during flight. */
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  /** Mean altitude in meters measured by the secondary GPS sensor during flight. */
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  /** Maximum speed in meters per second measured by the secondary GPS sensor during flight. */
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  /** Mean speed in meters per second measured by the secondary GPS sensor during flight. */
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  /** Average elevation of the takeoff in meters as measured by the GPS sensors. */
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  /** Time spent in the landing phase of the flight in seconds. */
  landing_time_seconds?: Maybe<Scalars['Int']>;
  /** Time spent in the takeoff phase of the flight in seconds. */
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
  /** Maximum vertical track error reported in meters. */
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  /** Mean vertical track error reported in meters. */
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** aggregated selection of "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Aggregate = {
  __typename?: 'type_cert_flight_analysis_data_aggregate';
  aggregate?: Maybe<Type_Cert_Flight_Analysis_Data_Aggregate_Fields>;
  nodes: Array<Type_Cert_Flight_Analysis_Data>;
};

/** aggregate fields of "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Aggregate_Fields = {
  __typename?: 'type_cert_flight_analysis_data_aggregate_fields';
  avg?: Maybe<Type_Cert_Flight_Analysis_Data_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Type_Cert_Flight_Analysis_Data_Max_Fields>;
  min?: Maybe<Type_Cert_Flight_Analysis_Data_Min_Fields>;
  stddev?: Maybe<Type_Cert_Flight_Analysis_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Type_Cert_Flight_Analysis_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Type_Cert_Flight_Analysis_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Type_Cert_Flight_Analysis_Data_Sum_Fields>;
  var_pop?: Maybe<Type_Cert_Flight_Analysis_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Type_Cert_Flight_Analysis_Data_Var_Samp_Fields>;
  variance?: Maybe<Type_Cert_Flight_Analysis_Data_Variance_Fields>;
};


/** aggregate fields of "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Type_Cert_Flight_Analysis_Data_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Aggregate_Order_By = {
  avg?: Maybe<Type_Cert_Flight_Analysis_Data_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Type_Cert_Flight_Analysis_Data_Max_Order_By>;
  min?: Maybe<Type_Cert_Flight_Analysis_Data_Min_Order_By>;
  stddev?: Maybe<Type_Cert_Flight_Analysis_Data_Stddev_Order_By>;
  stddev_pop?: Maybe<Type_Cert_Flight_Analysis_Data_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Type_Cert_Flight_Analysis_Data_Stddev_Samp_Order_By>;
  sum?: Maybe<Type_Cert_Flight_Analysis_Data_Sum_Order_By>;
  var_pop?: Maybe<Type_Cert_Flight_Analysis_Data_Var_Pop_Order_By>;
  var_samp?: Maybe<Type_Cert_Flight_Analysis_Data_Var_Samp_Order_By>;
  variance?: Maybe<Type_Cert_Flight_Analysis_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Arr_Rel_Insert_Input = {
  data: Array<Type_Cert_Flight_Analysis_Data_Insert_Input>;
  on_conflict?: Maybe<Type_Cert_Flight_Analysis_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Type_Cert_Flight_Analysis_Data_Avg_Fields = {
  __typename?: 'type_cert_flight_analysis_data_avg_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Avg_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "type_cert_flight_analysis_data". All fields are combined with a logical 'AND'. */
export type Type_Cert_Flight_Analysis_Data_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>>>;
  _not?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>>>;
  baro_landing_elevation_mean_meters?: Maybe<Float8_Comparison_Exp>;
  baro_primary_alt_cruise_max_meters?: Maybe<Float8_Comparison_Exp>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Float8_Comparison_Exp>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Float8_Comparison_Exp>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Float8_Comparison_Exp>;
  baro_takeoff_elevation_mean_meters?: Maybe<Float8_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  cruise_time_seconds?: Maybe<Int_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  fts_triggered?: Maybe<Boolean_Comparison_Exp>;
  gps_landing_elevation_mean_meters?: Maybe<Float8_Comparison_Exp>;
  gps_primary_alt_cruise_max_meters?: Maybe<Float8_Comparison_Exp>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Float8_Comparison_Exp>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  gps_range_primary_meters?: Maybe<Float8_Comparison_Exp>;
  gps_range_secondary_meters?: Maybe<Float8_Comparison_Exp>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Float8_Comparison_Exp>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Float8_Comparison_Exp>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Float8_Comparison_Exp>;
  gps_takeoff_elevation_mean_meters?: Maybe<Float8_Comparison_Exp>;
  landing_time_seconds?: Maybe<Int_Comparison_Exp>;
  takeoff_time_seconds?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
  vertical_track_error_max_meters?: Maybe<Float8_Comparison_Exp>;
  vertical_track_error_mean_meters?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "type_cert_flight_analysis_data" */
export enum Type_Cert_Flight_Analysis_Data_Constraint {
  /** unique or primary key constraint */
  TypeCertFlightAnalysisDataPkey = 'type_cert_flight_analysis_data_pkey'
}

/** input type for incrementing integer column in table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Inc_Input = {
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  landing_time_seconds?: Maybe<Scalars['Int']>;
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Insert_Input = {
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_triggered?: Maybe<Scalars['Boolean']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  landing_time_seconds?: Maybe<Scalars['Int']>;
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Type_Cert_Flight_Analysis_Data_Max_Fields = {
  __typename?: 'type_cert_flight_analysis_data_max_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  landing_time_seconds?: Maybe<Scalars['Int']>;
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Max_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Type_Cert_Flight_Analysis_Data_Min_Fields = {
  __typename?: 'type_cert_flight_analysis_data_min_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  landing_time_seconds?: Maybe<Scalars['Int']>;
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Min_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** response of any mutation on the table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Mutation_Response = {
  __typename?: 'type_cert_flight_analysis_data_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Type_Cert_Flight_Analysis_Data>;
};

/** input type for inserting object relation for remote table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Obj_Rel_Insert_Input = {
  data: Type_Cert_Flight_Analysis_Data_Insert_Input;
  on_conflict?: Maybe<Type_Cert_Flight_Analysis_Data_On_Conflict>;
};

/** on conflict condition type for table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_On_Conflict = {
  constraint: Type_Cert_Flight_Analysis_Data_Constraint;
  update_columns: Array<Type_Cert_Flight_Analysis_Data_Update_Column>;
  where?: Maybe<Type_Cert_Flight_Analysis_Data_Bool_Exp>;
};

/** ordering options when selecting data from "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  fts_triggered?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** primary key columns input for table: "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Pk_Columns_Input = {
  /** Flight plan ID corresponding to the data record */
  flight_plan_id: Scalars['Int'];
};

/** select columns of table "type_cert_flight_analysis_data" */
export enum Type_Cert_Flight_Analysis_Data_Select_Column {
  /** column name */
  BaroLandingElevationMeanMeters = 'baro_landing_elevation_mean_meters',
  /** column name */
  BaroPrimaryAltCruiseMaxMeters = 'baro_primary_alt_cruise_max_meters',
  /** column name */
  BaroPrimaryAltCruiseMeanMeters = 'baro_primary_alt_cruise_mean_meters',
  /** column name */
  BaroSecondaryAltCruiseMaxMeters = 'baro_secondary_alt_cruise_max_meters',
  /** column name */
  BaroSecondaryAltCruiseMeanMeters = 'baro_secondary_alt_cruise_mean_meters',
  /** column name */
  BaroTakeoffElevationMeanMeters = 'baro_takeoff_elevation_mean_meters',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CruiseTimeSeconds = 'cruise_time_seconds',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FtsTriggered = 'fts_triggered',
  /** column name */
  GpsLandingElevationMeanMeters = 'gps_landing_elevation_mean_meters',
  /** column name */
  GpsPrimaryAltCruiseMaxMeters = 'gps_primary_alt_cruise_max_meters',
  /** column name */
  GpsPrimaryAltCruiseMeanMeters = 'gps_primary_alt_cruise_mean_meters',
  /** column name */
  GpsPrimarySpdCruiseMaxMetersPerSecond = 'gps_primary_spd_cruise_max_meters_per_second',
  /** column name */
  GpsPrimarySpdCruiseMeanMetersPerSecond = 'gps_primary_spd_cruise_mean_meters_per_second',
  /** column name */
  GpsRangePrimaryMeters = 'gps_range_primary_meters',
  /** column name */
  GpsRangeSecondaryMeters = 'gps_range_secondary_meters',
  /** column name */
  GpsSecondaryAltCruiseMaxMeters = 'gps_secondary_alt_cruise_max_meters',
  /** column name */
  GpsSecondaryAltCruiseMeanMeters = 'gps_secondary_alt_cruise_mean_meters',
  /** column name */
  GpsSecondarySpdCruiseMaxMetersPerSecond = 'gps_secondary_spd_cruise_max_meters_per_second',
  /** column name */
  GpsSecondarySpdCruiseMeanMetersPerSecond = 'gps_secondary_spd_cruise_mean_meters_per_second',
  /** column name */
  GpsTakeoffElevationMeanMeters = 'gps_takeoff_elevation_mean_meters',
  /** column name */
  LandingTimeSeconds = 'landing_time_seconds',
  /** column name */
  TakeoffTimeSeconds = 'takeoff_time_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  VerticalTrackErrorMaxMeters = 'vertical_track_error_max_meters',
  /** column name */
  VerticalTrackErrorMeanMeters = 'vertical_track_error_mean_meters'
}

/** input type for updating data in table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Set_Input = {
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  fts_triggered?: Maybe<Scalars['Boolean']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  landing_time_seconds?: Maybe<Scalars['Int']>;
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Type_Cert_Flight_Analysis_Data_Stddev_Fields = {
  __typename?: 'type_cert_flight_analysis_data_stddev_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Stddev_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Type_Cert_Flight_Analysis_Data_Stddev_Pop_Fields = {
  __typename?: 'type_cert_flight_analysis_data_stddev_pop_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Stddev_Pop_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Type_Cert_Flight_Analysis_Data_Stddev_Samp_Fields = {
  __typename?: 'type_cert_flight_analysis_data_stddev_samp_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Stddev_Samp_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Type_Cert_Flight_Analysis_Data_Sum_Fields = {
  __typename?: 'type_cert_flight_analysis_data_sum_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  cruise_time_seconds?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_range_primary_meters?: Maybe<Scalars['float8']>;
  gps_range_secondary_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['float8']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['float8']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['float8']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['float8']>;
  landing_time_seconds?: Maybe<Scalars['Int']>;
  takeoff_time_seconds?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
  vertical_track_error_max_meters?: Maybe<Scalars['float8']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Sum_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** update columns of table "type_cert_flight_analysis_data" */
export enum Type_Cert_Flight_Analysis_Data_Update_Column {
  /** column name */
  BaroLandingElevationMeanMeters = 'baro_landing_elevation_mean_meters',
  /** column name */
  BaroPrimaryAltCruiseMaxMeters = 'baro_primary_alt_cruise_max_meters',
  /** column name */
  BaroPrimaryAltCruiseMeanMeters = 'baro_primary_alt_cruise_mean_meters',
  /** column name */
  BaroSecondaryAltCruiseMaxMeters = 'baro_secondary_alt_cruise_max_meters',
  /** column name */
  BaroSecondaryAltCruiseMeanMeters = 'baro_secondary_alt_cruise_mean_meters',
  /** column name */
  BaroTakeoffElevationMeanMeters = 'baro_takeoff_elevation_mean_meters',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CruiseTimeSeconds = 'cruise_time_seconds',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FtsTriggered = 'fts_triggered',
  /** column name */
  GpsLandingElevationMeanMeters = 'gps_landing_elevation_mean_meters',
  /** column name */
  GpsPrimaryAltCruiseMaxMeters = 'gps_primary_alt_cruise_max_meters',
  /** column name */
  GpsPrimaryAltCruiseMeanMeters = 'gps_primary_alt_cruise_mean_meters',
  /** column name */
  GpsPrimarySpdCruiseMaxMetersPerSecond = 'gps_primary_spd_cruise_max_meters_per_second',
  /** column name */
  GpsPrimarySpdCruiseMeanMetersPerSecond = 'gps_primary_spd_cruise_mean_meters_per_second',
  /** column name */
  GpsRangePrimaryMeters = 'gps_range_primary_meters',
  /** column name */
  GpsRangeSecondaryMeters = 'gps_range_secondary_meters',
  /** column name */
  GpsSecondaryAltCruiseMaxMeters = 'gps_secondary_alt_cruise_max_meters',
  /** column name */
  GpsSecondaryAltCruiseMeanMeters = 'gps_secondary_alt_cruise_mean_meters',
  /** column name */
  GpsSecondarySpdCruiseMaxMetersPerSecond = 'gps_secondary_spd_cruise_max_meters_per_second',
  /** column name */
  GpsSecondarySpdCruiseMeanMetersPerSecond = 'gps_secondary_spd_cruise_mean_meters_per_second',
  /** column name */
  GpsTakeoffElevationMeanMeters = 'gps_takeoff_elevation_mean_meters',
  /** column name */
  LandingTimeSeconds = 'landing_time_seconds',
  /** column name */
  TakeoffTimeSeconds = 'takeoff_time_seconds',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version',
  /** column name */
  VerticalTrackErrorMaxMeters = 'vertical_track_error_max_meters',
  /** column name */
  VerticalTrackErrorMeanMeters = 'vertical_track_error_mean_meters'
}

/** aggregate var_pop on columns */
export type Type_Cert_Flight_Analysis_Data_Var_Pop_Fields = {
  __typename?: 'type_cert_flight_analysis_data_var_pop_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Var_Pop_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Type_Cert_Flight_Analysis_Data_Var_Samp_Fields = {
  __typename?: 'type_cert_flight_analysis_data_var_samp_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Var_Samp_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Type_Cert_Flight_Analysis_Data_Variance_Fields = {
  __typename?: 'type_cert_flight_analysis_data_variance_fields';
  baro_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  baro_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  cruise_time_seconds?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  gps_landing_elevation_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_range_primary_meters?: Maybe<Scalars['Float']>;
  gps_range_secondary_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Scalars['Float']>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Scalars['Float']>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Scalars['Float']>;
  gps_takeoff_elevation_mean_meters?: Maybe<Scalars['Float']>;
  landing_time_seconds?: Maybe<Scalars['Float']>;
  takeoff_time_seconds?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
  vertical_track_error_max_meters?: Maybe<Scalars['Float']>;
  vertical_track_error_mean_meters?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "type_cert_flight_analysis_data" */
export type Type_Cert_Flight_Analysis_Data_Variance_Order_By = {
  baro_landing_elevation_mean_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  baro_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  baro_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  cruise_time_seconds?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  gps_landing_elevation_mean_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_primary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_primary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_primary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_range_primary_meters?: Maybe<Order_By>;
  gps_range_secondary_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_max_meters?: Maybe<Order_By>;
  gps_secondary_alt_cruise_mean_meters?: Maybe<Order_By>;
  gps_secondary_spd_cruise_max_meters_per_second?: Maybe<Order_By>;
  gps_secondary_spd_cruise_mean_meters_per_second?: Maybe<Order_By>;
  gps_takeoff_elevation_mean_meters?: Maybe<Order_By>;
  landing_time_seconds?: Maybe<Order_By>;
  takeoff_time_seconds?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
  vertical_track_error_max_meters?: Maybe<Order_By>;
  vertical_track_error_mean_meters?: Maybe<Order_By>;
};

/** columns and relationships of "type_cert_manual_data" */
export type Type_Cert_Manual_Data = {
  __typename?: 'type_cert_manual_data';
  /** Aircraft to pilot ratio. */
  aircraft_pilot_ratio: Scalars['String'];
  /** COA waiver used for the flight. */
  coa_waiver?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** Complexity of the flight. Low, medium, high. */
  flight_complexity: Scalars['String'];
  /** An object relationship */
  flight_plan: Flight_Plans;
  /** Flight plan ID corresponding to the record */
  flight_plan_id: Scalars['Int'];
  /** Risk assessment for the flight. Low, medium, high. */
  flight_risk_assessment: Scalars['String'];
  /** Witness for the flight test. Either FAA or Company. */
  flight_test_witness: Scalars['String'];
  /** Part numbers for the GCS used to monitor and control the flight. */
  ground_control_station_part_number?: Maybe<Scalars['String']>;
  /** ID for the manual entry record */
  id: Scalars['Int'];
  /** Name of the maintainer */
  maintainer_name: Scalars['String'];
  /** The level of turbulence perceived by the operator. */
  observed_turbulence?: Maybe<Scalars['String']>;
  /** Payload box id used for the given flight. */
  payload_box_id?: Maybe<Scalars['Int']>;
  /** Weight of the payload in lbs. [0.0, 4.4] */
  payload_weight_lbs: Scalars['float8'];
  /** Name of the pilot in command. */
  pilot_in_command_name: Scalars['String'];
  /** Name of the secondary pilot in command */
  secondary_in_command_name?: Maybe<Scalars['String']>;
  /** Special test conditions for the flight */
  special_test_conditions?: Maybe<Scalars['jsonb']>;
  /** Center of gravity measured prior to takeoff. [Max Vert, Full fwd R, Full fwd L, Mid, Full aft L, Full aft R] */
  takeoff_center_of_gravity: Scalars['String'];
  /** Test card number applicable for the flight. */
  test_card_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  version: Scalars['Int'];
};


/** columns and relationships of "type_cert_manual_data" */
export type Type_Cert_Manual_DataSpecial_Test_ConditionsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Aggregate = {
  __typename?: 'type_cert_manual_data_aggregate';
  aggregate?: Maybe<Type_Cert_Manual_Data_Aggregate_Fields>;
  nodes: Array<Type_Cert_Manual_Data>;
};

/** aggregate fields of "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Aggregate_Fields = {
  __typename?: 'type_cert_manual_data_aggregate_fields';
  avg?: Maybe<Type_Cert_Manual_Data_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Type_Cert_Manual_Data_Max_Fields>;
  min?: Maybe<Type_Cert_Manual_Data_Min_Fields>;
  stddev?: Maybe<Type_Cert_Manual_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Type_Cert_Manual_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Type_Cert_Manual_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Type_Cert_Manual_Data_Sum_Fields>;
  var_pop?: Maybe<Type_Cert_Manual_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Type_Cert_Manual_Data_Var_Samp_Fields>;
  variance?: Maybe<Type_Cert_Manual_Data_Variance_Fields>;
};


/** aggregate fields of "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Type_Cert_Manual_Data_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Aggregate_Order_By = {
  avg?: Maybe<Type_Cert_Manual_Data_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Type_Cert_Manual_Data_Max_Order_By>;
  min?: Maybe<Type_Cert_Manual_Data_Min_Order_By>;
  stddev?: Maybe<Type_Cert_Manual_Data_Stddev_Order_By>;
  stddev_pop?: Maybe<Type_Cert_Manual_Data_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Type_Cert_Manual_Data_Stddev_Samp_Order_By>;
  sum?: Maybe<Type_Cert_Manual_Data_Sum_Order_By>;
  var_pop?: Maybe<Type_Cert_Manual_Data_Var_Pop_Order_By>;
  var_samp?: Maybe<Type_Cert_Manual_Data_Var_Samp_Order_By>;
  variance?: Maybe<Type_Cert_Manual_Data_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Type_Cert_Manual_Data_Append_Input = {
  special_test_conditions?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Arr_Rel_Insert_Input = {
  data: Array<Type_Cert_Manual_Data_Insert_Input>;
  on_conflict?: Maybe<Type_Cert_Manual_Data_On_Conflict>;
};

/** aggregate avg on columns */
export type Type_Cert_Manual_Data_Avg_Fields = {
  __typename?: 'type_cert_manual_data_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "type_cert_manual_data". All fields are combined with a logical 'AND'. */
export type Type_Cert_Manual_Data_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Type_Cert_Manual_Data_Bool_Exp>>>;
  _not?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Type_Cert_Manual_Data_Bool_Exp>>>;
  aircraft_pilot_ratio?: Maybe<String_Comparison_Exp>;
  coa_waiver?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_complexity?: Maybe<String_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  flight_risk_assessment?: Maybe<String_Comparison_Exp>;
  flight_test_witness?: Maybe<String_Comparison_Exp>;
  ground_control_station_part_number?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  maintainer_name?: Maybe<String_Comparison_Exp>;
  observed_turbulence?: Maybe<String_Comparison_Exp>;
  payload_box_id?: Maybe<Int_Comparison_Exp>;
  payload_weight_lbs?: Maybe<Float8_Comparison_Exp>;
  pilot_in_command_name?: Maybe<String_Comparison_Exp>;
  secondary_in_command_name?: Maybe<String_Comparison_Exp>;
  special_test_conditions?: Maybe<Jsonb_Comparison_Exp>;
  takeoff_center_of_gravity?: Maybe<String_Comparison_Exp>;
  test_card_number?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "type_cert_manual_data" */
export enum Type_Cert_Manual_Data_Constraint {
  /** unique or primary key constraint */
  TypeCertManualDataPkey = 'type_cert_manual_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Type_Cert_Manual_Data_Delete_At_Path_Input = {
  special_test_conditions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Type_Cert_Manual_Data_Delete_Elem_Input = {
  special_test_conditions?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Type_Cert_Manual_Data_Delete_Key_Input = {
  special_test_conditions?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payload_box_id?: Maybe<Scalars['Int']>;
  payload_weight_lbs?: Maybe<Scalars['float8']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Insert_Input = {
  aircraft_pilot_ratio?: Maybe<Scalars['String']>;
  coa_waiver?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_complexity?: Maybe<Scalars['String']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_risk_assessment?: Maybe<Scalars['String']>;
  flight_test_witness?: Maybe<Scalars['String']>;
  ground_control_station_part_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maintainer_name?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  payload_box_id?: Maybe<Scalars['Int']>;
  payload_weight_lbs?: Maybe<Scalars['float8']>;
  pilot_in_command_name?: Maybe<Scalars['String']>;
  secondary_in_command_name?: Maybe<Scalars['String']>;
  special_test_conditions?: Maybe<Scalars['jsonb']>;
  takeoff_center_of_gravity?: Maybe<Scalars['String']>;
  test_card_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Type_Cert_Manual_Data_Max_Fields = {
  __typename?: 'type_cert_manual_data_max_fields';
  aircraft_pilot_ratio?: Maybe<Scalars['String']>;
  coa_waiver?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_complexity?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_risk_assessment?: Maybe<Scalars['String']>;
  flight_test_witness?: Maybe<Scalars['String']>;
  ground_control_station_part_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maintainer_name?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  payload_box_id?: Maybe<Scalars['Int']>;
  payload_weight_lbs?: Maybe<Scalars['float8']>;
  pilot_in_command_name?: Maybe<Scalars['String']>;
  secondary_in_command_name?: Maybe<Scalars['String']>;
  takeoff_center_of_gravity?: Maybe<Scalars['String']>;
  test_card_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Max_Order_By = {
  aircraft_pilot_ratio?: Maybe<Order_By>;
  coa_waiver?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_complexity?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_risk_assessment?: Maybe<Order_By>;
  flight_test_witness?: Maybe<Order_By>;
  ground_control_station_part_number?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  maintainer_name?: Maybe<Order_By>;
  observed_turbulence?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  pilot_in_command_name?: Maybe<Order_By>;
  secondary_in_command_name?: Maybe<Order_By>;
  takeoff_center_of_gravity?: Maybe<Order_By>;
  test_card_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Type_Cert_Manual_Data_Min_Fields = {
  __typename?: 'type_cert_manual_data_min_fields';
  aircraft_pilot_ratio?: Maybe<Scalars['String']>;
  coa_waiver?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_complexity?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_risk_assessment?: Maybe<Scalars['String']>;
  flight_test_witness?: Maybe<Scalars['String']>;
  ground_control_station_part_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maintainer_name?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  payload_box_id?: Maybe<Scalars['Int']>;
  payload_weight_lbs?: Maybe<Scalars['float8']>;
  pilot_in_command_name?: Maybe<Scalars['String']>;
  secondary_in_command_name?: Maybe<Scalars['String']>;
  takeoff_center_of_gravity?: Maybe<Scalars['String']>;
  test_card_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Min_Order_By = {
  aircraft_pilot_ratio?: Maybe<Order_By>;
  coa_waiver?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_complexity?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_risk_assessment?: Maybe<Order_By>;
  flight_test_witness?: Maybe<Order_By>;
  ground_control_station_part_number?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  maintainer_name?: Maybe<Order_By>;
  observed_turbulence?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  pilot_in_command_name?: Maybe<Order_By>;
  secondary_in_command_name?: Maybe<Order_By>;
  takeoff_center_of_gravity?: Maybe<Order_By>;
  test_card_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Mutation_Response = {
  __typename?: 'type_cert_manual_data_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Type_Cert_Manual_Data>;
};

/** input type for inserting object relation for remote table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Obj_Rel_Insert_Input = {
  data: Type_Cert_Manual_Data_Insert_Input;
  on_conflict?: Maybe<Type_Cert_Manual_Data_On_Conflict>;
};

/** on conflict condition type for table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_On_Conflict = {
  constraint: Type_Cert_Manual_Data_Constraint;
  update_columns: Array<Type_Cert_Manual_Data_Update_Column>;
  where?: Maybe<Type_Cert_Manual_Data_Bool_Exp>;
};

/** ordering options when selecting data from "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Order_By = {
  aircraft_pilot_ratio?: Maybe<Order_By>;
  coa_waiver?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  flight_complexity?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_risk_assessment?: Maybe<Order_By>;
  flight_test_witness?: Maybe<Order_By>;
  ground_control_station_part_number?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  maintainer_name?: Maybe<Order_By>;
  observed_turbulence?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  pilot_in_command_name?: Maybe<Order_By>;
  secondary_in_command_name?: Maybe<Order_By>;
  special_test_conditions?: Maybe<Order_By>;
  takeoff_center_of_gravity?: Maybe<Order_By>;
  test_card_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Pk_Columns_Input = {
  /** ID for the manual entry record */
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Type_Cert_Manual_Data_Prepend_Input = {
  special_test_conditions?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "type_cert_manual_data" */
export enum Type_Cert_Manual_Data_Select_Column {
  /** column name */
  AircraftPilotRatio = 'aircraft_pilot_ratio',
  /** column name */
  CoaWaiver = 'coa_waiver',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightComplexity = 'flight_complexity',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FlightRiskAssessment = 'flight_risk_assessment',
  /** column name */
  FlightTestWitness = 'flight_test_witness',
  /** column name */
  GroundControlStationPartNumber = 'ground_control_station_part_number',
  /** column name */
  Id = 'id',
  /** column name */
  MaintainerName = 'maintainer_name',
  /** column name */
  ObservedTurbulence = 'observed_turbulence',
  /** column name */
  PayloadBoxId = 'payload_box_id',
  /** column name */
  PayloadWeightLbs = 'payload_weight_lbs',
  /** column name */
  PilotInCommandName = 'pilot_in_command_name',
  /** column name */
  SecondaryInCommandName = 'secondary_in_command_name',
  /** column name */
  SpecialTestConditions = 'special_test_conditions',
  /** column name */
  TakeoffCenterOfGravity = 'takeoff_center_of_gravity',
  /** column name */
  TestCardNumber = 'test_card_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Set_Input = {
  aircraft_pilot_ratio?: Maybe<Scalars['String']>;
  coa_waiver?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  flight_complexity?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_risk_assessment?: Maybe<Scalars['String']>;
  flight_test_witness?: Maybe<Scalars['String']>;
  ground_control_station_part_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maintainer_name?: Maybe<Scalars['String']>;
  observed_turbulence?: Maybe<Scalars['String']>;
  payload_box_id?: Maybe<Scalars['Int']>;
  payload_weight_lbs?: Maybe<Scalars['float8']>;
  pilot_in_command_name?: Maybe<Scalars['String']>;
  secondary_in_command_name?: Maybe<Scalars['String']>;
  special_test_conditions?: Maybe<Scalars['jsonb']>;
  takeoff_center_of_gravity?: Maybe<Scalars['String']>;
  test_card_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Type_Cert_Manual_Data_Stddev_Fields = {
  __typename?: 'type_cert_manual_data_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Type_Cert_Manual_Data_Stddev_Pop_Fields = {
  __typename?: 'type_cert_manual_data_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Type_Cert_Manual_Data_Stddev_Samp_Fields = {
  __typename?: 'type_cert_manual_data_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Type_Cert_Manual_Data_Sum_Fields = {
  __typename?: 'type_cert_manual_data_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  payload_box_id?: Maybe<Scalars['Int']>;
  payload_weight_lbs?: Maybe<Scalars['float8']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "type_cert_manual_data" */
export enum Type_Cert_Manual_Data_Update_Column {
  /** column name */
  AircraftPilotRatio = 'aircraft_pilot_ratio',
  /** column name */
  CoaWaiver = 'coa_waiver',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlightComplexity = 'flight_complexity',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FlightRiskAssessment = 'flight_risk_assessment',
  /** column name */
  FlightTestWitness = 'flight_test_witness',
  /** column name */
  GroundControlStationPartNumber = 'ground_control_station_part_number',
  /** column name */
  Id = 'id',
  /** column name */
  MaintainerName = 'maintainer_name',
  /** column name */
  ObservedTurbulence = 'observed_turbulence',
  /** column name */
  PayloadBoxId = 'payload_box_id',
  /** column name */
  PayloadWeightLbs = 'payload_weight_lbs',
  /** column name */
  PilotInCommandName = 'pilot_in_command_name',
  /** column name */
  SecondaryInCommandName = 'secondary_in_command_name',
  /** column name */
  SpecialTestConditions = 'special_test_conditions',
  /** column name */
  TakeoffCenterOfGravity = 'takeoff_center_of_gravity',
  /** column name */
  TestCardNumber = 'test_card_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Type_Cert_Manual_Data_Var_Pop_Fields = {
  __typename?: 'type_cert_manual_data_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Type_Cert_Manual_Data_Var_Samp_Fields = {
  __typename?: 'type_cert_manual_data_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Type_Cert_Manual_Data_Variance_Fields = {
  __typename?: 'type_cert_manual_data_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  payload_box_id?: Maybe<Scalars['Float']>;
  payload_weight_lbs?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "type_cert_manual_data" */
export type Type_Cert_Manual_Data_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  payload_box_id?: Maybe<Order_By>;
  payload_weight_lbs?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "user_app_states" */
export type User_App_States = {
  __typename?: 'user_app_states';
  /** Auth0 user id */
  auth0_user_id: Scalars['String'];
  /** An object relationship */
  available_aircraft_command_set?: Maybe<Available_Aircraft_Command_Sets>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  /** Selected flight plan id */
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "user_app_states" */
export type User_App_States_Aggregate = {
  __typename?: 'user_app_states_aggregate';
  aggregate?: Maybe<User_App_States_Aggregate_Fields>;
  nodes: Array<User_App_States>;
};

/** aggregate fields of "user_app_states" */
export type User_App_States_Aggregate_Fields = {
  __typename?: 'user_app_states_aggregate_fields';
  avg?: Maybe<User_App_States_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_App_States_Max_Fields>;
  min?: Maybe<User_App_States_Min_Fields>;
  stddev?: Maybe<User_App_States_Stddev_Fields>;
  stddev_pop?: Maybe<User_App_States_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_App_States_Stddev_Samp_Fields>;
  sum?: Maybe<User_App_States_Sum_Fields>;
  var_pop?: Maybe<User_App_States_Var_Pop_Fields>;
  var_samp?: Maybe<User_App_States_Var_Samp_Fields>;
  variance?: Maybe<User_App_States_Variance_Fields>;
};


/** aggregate fields of "user_app_states" */
export type User_App_States_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_App_States_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_app_states" */
export type User_App_States_Aggregate_Order_By = {
  avg?: Maybe<User_App_States_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_App_States_Max_Order_By>;
  min?: Maybe<User_App_States_Min_Order_By>;
  stddev?: Maybe<User_App_States_Stddev_Order_By>;
  stddev_pop?: Maybe<User_App_States_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_App_States_Stddev_Samp_Order_By>;
  sum?: Maybe<User_App_States_Sum_Order_By>;
  var_pop?: Maybe<User_App_States_Var_Pop_Order_By>;
  var_samp?: Maybe<User_App_States_Var_Samp_Order_By>;
  variance?: Maybe<User_App_States_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_app_states" */
export type User_App_States_Arr_Rel_Insert_Input = {
  data: Array<User_App_States_Insert_Input>;
  on_conflict?: Maybe<User_App_States_On_Conflict>;
};

/** aggregate avg on columns */
export type User_App_States_Avg_Fields = {
  __typename?: 'user_app_states_avg_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_app_states" */
export type User_App_States_Avg_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_app_states". All fields are combined with a logical 'AND'. */
export type User_App_States_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_App_States_Bool_Exp>>>;
  _not?: Maybe<User_App_States_Bool_Exp>;
  _or?: Maybe<Array<Maybe<User_App_States_Bool_Exp>>>;
  auth0_user_id?: Maybe<String_Comparison_Exp>;
  available_aircraft_command_set?: Maybe<Available_Aircraft_Command_Sets_Bool_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  selected_flight_plan_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "user_app_states" */
export enum User_App_States_Constraint {
  /** unique or primary key constraint */
  UserAppStatesAuth0UserIdKey = 'user_app_states_auth0_user_id_key'
}

/** input type for incrementing integer column in table "user_app_states" */
export type User_App_States_Inc_Input = {
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_app_states" */
export type User_App_States_Insert_Input = {
  auth0_user_id?: Maybe<Scalars['String']>;
  available_aircraft_command_set?: Maybe<Available_Aircraft_Command_Sets_Obj_Rel_Insert_Input>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_App_States_Max_Fields = {
  __typename?: 'user_app_states_max_fields';
  auth0_user_id?: Maybe<Scalars['String']>;
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "user_app_states" */
export type User_App_States_Max_Order_By = {
  auth0_user_id?: Maybe<Order_By>;
  selected_flight_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_App_States_Min_Fields = {
  __typename?: 'user_app_states_min_fields';
  auth0_user_id?: Maybe<Scalars['String']>;
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "user_app_states" */
export type User_App_States_Min_Order_By = {
  auth0_user_id?: Maybe<Order_By>;
  selected_flight_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_app_states" */
export type User_App_States_Mutation_Response = {
  __typename?: 'user_app_states_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<User_App_States>;
};

/** input type for inserting object relation for remote table "user_app_states" */
export type User_App_States_Obj_Rel_Insert_Input = {
  data: User_App_States_Insert_Input;
  on_conflict?: Maybe<User_App_States_On_Conflict>;
};

/** on conflict condition type for table "user_app_states" */
export type User_App_States_On_Conflict = {
  constraint: User_App_States_Constraint;
  update_columns: Array<User_App_States_Update_Column>;
  where?: Maybe<User_App_States_Bool_Exp>;
};

/** ordering options when selecting data from "user_app_states" */
export type User_App_States_Order_By = {
  auth0_user_id?: Maybe<Order_By>;
  available_aircraft_command_set?: Maybe<Available_Aircraft_Command_Sets_Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  selected_flight_plan_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
};

/** select columns of table "user_app_states" */
export enum User_App_States_Select_Column {
  /** column name */
  Auth0UserId = 'auth0_user_id',
  /** column name */
  SelectedFlightPlanId = 'selected_flight_plan_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user_app_states" */
export type User_App_States_Set_Input = {
  auth0_user_id?: Maybe<Scalars['String']>;
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type User_App_States_Stddev_Fields = {
  __typename?: 'user_app_states_stddev_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_app_states" */
export type User_App_States_Stddev_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_App_States_Stddev_Pop_Fields = {
  __typename?: 'user_app_states_stddev_pop_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_app_states" */
export type User_App_States_Stddev_Pop_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_App_States_Stddev_Samp_Fields = {
  __typename?: 'user_app_states_stddev_samp_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_app_states" */
export type User_App_States_Stddev_Samp_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type User_App_States_Sum_Fields = {
  __typename?: 'user_app_states_sum_fields';
  selected_flight_plan_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_app_states" */
export type User_App_States_Sum_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** update columns of table "user_app_states" */
export enum User_App_States_Update_Column {
  /** column name */
  Auth0UserId = 'auth0_user_id',
  /** column name */
  SelectedFlightPlanId = 'selected_flight_plan_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type User_App_States_Var_Pop_Fields = {
  __typename?: 'user_app_states_var_pop_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_app_states" */
export type User_App_States_Var_Pop_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_App_States_Var_Samp_Fields = {
  __typename?: 'user_app_states_var_samp_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_app_states" */
export type User_App_States_Var_Samp_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_App_States_Variance_Fields = {
  __typename?: 'user_app_states_variance_fields';
  selected_flight_plan_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_app_states" */
export type User_App_States_Variance_Order_By = {
  selected_flight_plan_id?: Maybe<Order_By>;
};

/** columns and relationships of "user_networks" */
export type User_Networks = {
  __typename?: 'user_networks';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  network: Networks;
  network_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "user_networks" */
export type User_Networks_Aggregate = {
  __typename?: 'user_networks_aggregate';
  aggregate?: Maybe<User_Networks_Aggregate_Fields>;
  nodes: Array<User_Networks>;
};

/** aggregate fields of "user_networks" */
export type User_Networks_Aggregate_Fields = {
  __typename?: 'user_networks_aggregate_fields';
  avg?: Maybe<User_Networks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_Networks_Max_Fields>;
  min?: Maybe<User_Networks_Min_Fields>;
  stddev?: Maybe<User_Networks_Stddev_Fields>;
  stddev_pop?: Maybe<User_Networks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Networks_Stddev_Samp_Fields>;
  sum?: Maybe<User_Networks_Sum_Fields>;
  var_pop?: Maybe<User_Networks_Var_Pop_Fields>;
  var_samp?: Maybe<User_Networks_Var_Samp_Fields>;
  variance?: Maybe<User_Networks_Variance_Fields>;
};


/** aggregate fields of "user_networks" */
export type User_Networks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Networks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_networks" */
export type User_Networks_Aggregate_Order_By = {
  avg?: Maybe<User_Networks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Networks_Max_Order_By>;
  min?: Maybe<User_Networks_Min_Order_By>;
  stddev?: Maybe<User_Networks_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Networks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Networks_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Networks_Sum_Order_By>;
  var_pop?: Maybe<User_Networks_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Networks_Var_Samp_Order_By>;
  variance?: Maybe<User_Networks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_networks" */
export type User_Networks_Arr_Rel_Insert_Input = {
  data: Array<User_Networks_Insert_Input>;
  on_conflict?: Maybe<User_Networks_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Networks_Avg_Fields = {
  __typename?: 'user_networks_avg_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_networks" */
export type User_Networks_Avg_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_networks". All fields are combined with a logical 'AND'. */
export type User_Networks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Networks_Bool_Exp>>>;
  _not?: Maybe<User_Networks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<User_Networks_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_networks" */
export enum User_Networks_Constraint {
  /** unique or primary key constraint */
  UserNetworksNetworkIdUserIdPk = 'user_networks_network_id_user_id_pk'
}

/** input type for incrementing integer column in table "user_networks" */
export type User_Networks_Inc_Input = {
  network_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_networks" */
export type User_Networks_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Networks_Max_Fields = {
  __typename?: 'user_networks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_networks" */
export type User_Networks_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Networks_Min_Fields = {
  __typename?: 'user_networks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_networks" */
export type User_Networks_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_networks" */
export type User_Networks_Mutation_Response = {
  __typename?: 'user_networks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<User_Networks>;
};

/** input type for inserting object relation for remote table "user_networks" */
export type User_Networks_Obj_Rel_Insert_Input = {
  data: User_Networks_Insert_Input;
  on_conflict?: Maybe<User_Networks_On_Conflict>;
};

/** on conflict condition type for table "user_networks" */
export type User_Networks_On_Conflict = {
  constraint: User_Networks_Constraint;
  update_columns: Array<User_Networks_Update_Column>;
  where?: Maybe<User_Networks_Bool_Exp>;
};

/** ordering options when selecting data from "user_networks" */
export type User_Networks_Order_By = {
  created_at?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "user_networks" */
export type User_Networks_Pk_Columns_Input = {
  network_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_networks" */
export enum User_Networks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "user_networks" */
export type User_Networks_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Networks_Stddev_Fields = {
  __typename?: 'user_networks_stddev_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_networks" */
export type User_Networks_Stddev_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Networks_Stddev_Pop_Fields = {
  __typename?: 'user_networks_stddev_pop_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_networks" */
export type User_Networks_Stddev_Pop_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Networks_Stddev_Samp_Fields = {
  __typename?: 'user_networks_stddev_samp_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_networks" */
export type User_Networks_Stddev_Samp_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type User_Networks_Sum_Fields = {
  __typename?: 'user_networks_sum_fields';
  network_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_networks" */
export type User_Networks_Sum_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "user_networks" */
export enum User_Networks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type User_Networks_Var_Pop_Fields = {
  __typename?: 'user_networks_var_pop_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_networks" */
export type User_Networks_Var_Pop_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Networks_Var_Samp_Fields = {
  __typename?: 'user_networks_var_samp_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_networks" */
export type User_Networks_Var_Samp_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Networks_Variance_Fields = {
  __typename?: 'user_networks_variance_fields';
  network_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_networks" */
export type User_Networks_Variance_Order_By = {
  network_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "user_permissions_view" */
export type User_Permissions_View = {
  __typename?: 'user_permissions_view';
  auth0_user_id?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "user_permissions_view" */
export type User_Permissions_View_Aggregate = {
  __typename?: 'user_permissions_view_aggregate';
  aggregate?: Maybe<User_Permissions_View_Aggregate_Fields>;
  nodes: Array<User_Permissions_View>;
};

/** aggregate fields of "user_permissions_view" */
export type User_Permissions_View_Aggregate_Fields = {
  __typename?: 'user_permissions_view_aggregate_fields';
  avg?: Maybe<User_Permissions_View_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_Permissions_View_Max_Fields>;
  min?: Maybe<User_Permissions_View_Min_Fields>;
  stddev?: Maybe<User_Permissions_View_Stddev_Fields>;
  stddev_pop?: Maybe<User_Permissions_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Permissions_View_Stddev_Samp_Fields>;
  sum?: Maybe<User_Permissions_View_Sum_Fields>;
  var_pop?: Maybe<User_Permissions_View_Var_Pop_Fields>;
  var_samp?: Maybe<User_Permissions_View_Var_Samp_Fields>;
  variance?: Maybe<User_Permissions_View_Variance_Fields>;
};


/** aggregate fields of "user_permissions_view" */
export type User_Permissions_View_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Permissions_View_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_permissions_view" */
export type User_Permissions_View_Aggregate_Order_By = {
  avg?: Maybe<User_Permissions_View_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Permissions_View_Max_Order_By>;
  min?: Maybe<User_Permissions_View_Min_Order_By>;
  stddev?: Maybe<User_Permissions_View_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Permissions_View_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Permissions_View_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Permissions_View_Sum_Order_By>;
  var_pop?: Maybe<User_Permissions_View_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Permissions_View_Var_Samp_Order_By>;
  variance?: Maybe<User_Permissions_View_Variance_Order_By>;
};

/** aggregate avg on columns */
export type User_Permissions_View_Avg_Fields = {
  __typename?: 'user_permissions_view_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_permissions_view" */
export type User_Permissions_View_Avg_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_permissions_view". All fields are combined with a logical 'AND'. */
export type User_Permissions_View_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Permissions_View_Bool_Exp>>>;
  _not?: Maybe<User_Permissions_View_Bool_Exp>;
  _or?: Maybe<Array<Maybe<User_Permissions_View_Bool_Exp>>>;
  auth0_user_id?: Maybe<String_Comparison_Exp>;
  permission?: Maybe<String_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Permissions_View_Max_Fields = {
  __typename?: 'user_permissions_view_max_fields';
  auth0_user_id?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_permissions_view" */
export type User_Permissions_View_Max_Order_By = {
  auth0_user_id?: Maybe<Order_By>;
  permission?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Permissions_View_Min_Fields = {
  __typename?: 'user_permissions_view_min_fields';
  auth0_user_id?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_permissions_view" */
export type User_Permissions_View_Min_Order_By = {
  auth0_user_id?: Maybe<Order_By>;
  permission?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
};

/** ordering options when selecting data from "user_permissions_view" */
export type User_Permissions_View_Order_By = {
  auth0_user_id?: Maybe<Order_By>;
  permission?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
};

/** select columns of table "user_permissions_view" */
export enum User_Permissions_View_Select_Column {
  /** column name */
  Auth0UserId = 'auth0_user_id',
  /** column name */
  Permission = 'permission',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type User_Permissions_View_Stddev_Fields = {
  __typename?: 'user_permissions_view_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_permissions_view" */
export type User_Permissions_View_Stddev_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Permissions_View_Stddev_Pop_Fields = {
  __typename?: 'user_permissions_view_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_permissions_view" */
export type User_Permissions_View_Stddev_Pop_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Permissions_View_Stddev_Samp_Fields = {
  __typename?: 'user_permissions_view_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_permissions_view" */
export type User_Permissions_View_Stddev_Samp_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type User_Permissions_View_Sum_Fields = {
  __typename?: 'user_permissions_view_sum_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_permissions_view" */
export type User_Permissions_View_Sum_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate var_pop on columns */
export type User_Permissions_View_Var_Pop_Fields = {
  __typename?: 'user_permissions_view_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_permissions_view" */
export type User_Permissions_View_Var_Pop_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Permissions_View_Var_Samp_Fields = {
  __typename?: 'user_permissions_view_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_permissions_view" */
export type User_Permissions_View_Var_Samp_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Permissions_View_Variance_Fields = {
  __typename?: 'user_permissions_view_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_permissions_view" */
export type User_Permissions_View_Variance_Order_By = {
  user_id?: Maybe<Order_By>;
};

/** columns and relationships of "user_roles" */
export type User_Roles = {
  __typename?: 'user_roles';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  role: Roles;
  role_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "user_roles" */
export type User_Roles_Aggregate = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<User_Roles_Aggregate_Fields>;
  nodes: Array<User_Roles>;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_Fields = {
  __typename?: 'user_roles_aggregate_fields';
  avg?: Maybe<User_Roles_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<User_Roles_Max_Fields>;
  min?: Maybe<User_Roles_Min_Fields>;
  stddev?: Maybe<User_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<User_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<User_Roles_Sum_Fields>;
  var_pop?: Maybe<User_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<User_Roles_Var_Samp_Fields>;
  variance?: Maybe<User_Roles_Variance_Fields>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<User_Roles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles" */
export type User_Roles_Aggregate_Order_By = {
  avg?: Maybe<User_Roles_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<User_Roles_Max_Order_By>;
  min?: Maybe<User_Roles_Min_Order_By>;
  stddev?: Maybe<User_Roles_Stddev_Order_By>;
  stddev_pop?: Maybe<User_Roles_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<User_Roles_Stddev_Samp_Order_By>;
  sum?: Maybe<User_Roles_Sum_Order_By>;
  var_pop?: Maybe<User_Roles_Var_Pop_Order_By>;
  var_samp?: Maybe<User_Roles_Var_Samp_Order_By>;
  variance?: Maybe<User_Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_roles" */
export type User_Roles_Arr_Rel_Insert_Input = {
  data: Array<User_Roles_Insert_Input>;
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Roles_Avg_Fields = {
  __typename?: 'user_roles_avg_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_roles" */
export type User_Roles_Avg_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<User_Roles_Bool_Exp>>>;
  _not?: Maybe<User_Roles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<User_Roles_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  role?: Maybe<Roles_Bool_Exp>;
  role_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user?: Maybe<Users_Bool_Exp>;
  user_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_Constraint {
  /** unique or primary key constraint */
  UserRolesPkey1 = 'user_roles_pkey1'
}

/** input type for incrementing integer column in table "user_roles" */
export type User_Roles_Inc_Input = {
  role_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  role?: Maybe<Roles_Obj_Rel_Insert_Input>;
  role_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<Users_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Roles_Max_Fields = {
  __typename?: 'user_roles_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  role_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_roles" */
export type User_Roles_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  role_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type User_Roles_Min_Fields = {
  __typename?: 'user_roles_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  role_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_roles" */
export type User_Roles_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  role_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_Response = {
  __typename?: 'user_roles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<User_Roles>;
};

/** input type for inserting object relation for remote table "user_roles" */
export type User_Roles_Obj_Rel_Insert_Input = {
  data: User_Roles_Insert_Input;
  on_conflict?: Maybe<User_Roles_On_Conflict>;
};

/** on conflict condition type for table "user_roles" */
export type User_Roles_On_Conflict = {
  constraint: User_Roles_Constraint;
  update_columns: Array<User_Roles_Update_Column>;
  where?: Maybe<User_Roles_Bool_Exp>;
};

/** ordering options when selecting data from "user_roles" */
export type User_Roles_Order_By = {
  created_at?: Maybe<Order_By>;
  role?: Maybe<Roles_Order_By>;
  role_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user?: Maybe<Users_Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "user_roles" */
export type User_Roles_Pk_Columns_Input = {
  role_id: Scalars['Int'];
  user_id: Scalars['Int'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  role_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Roles_Stddev_Fields = {
  __typename?: 'user_roles_stddev_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_roles" */
export type User_Roles_Stddev_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Roles_Stddev_Pop_Fields = {
  __typename?: 'user_roles_stddev_pop_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_roles" */
export type User_Roles_Stddev_Pop_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Roles_Stddev_Samp_Fields = {
  __typename?: 'user_roles_stddev_samp_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_roles" */
export type User_Roles_Stddev_Samp_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type User_Roles_Sum_Fields = {
  __typename?: 'user_roles_sum_fields';
  role_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_roles" */
export type User_Roles_Sum_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type User_Roles_Var_Pop_Fields = {
  __typename?: 'user_roles_var_pop_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_roles" */
export type User_Roles_Var_Pop_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Roles_Var_Samp_Fields = {
  __typename?: 'user_roles_var_samp_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_roles" */
export type User_Roles_Var_Samp_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Roles_Variance_Fields = {
  __typename?: 'user_roles_variance_fields';
  role_id?: Maybe<Scalars['Float']>;
  user_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_roles" */
export type User_Roles_Variance_Order_By = {
  role_id?: Maybe<Order_By>;
  user_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  account_status: Scalars['String'];
  activated?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  assigned_station?: Maybe<Stations>;
  /** Assigned station to the Terminal user */
  assigned_station_id?: Maybe<Scalars['Int']>;
  auth0_user_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  batteries: Array<Batteries>;
  /** An aggregated array relationship */
  batteries_aggregate: Batteries_Aggregate;
  /** An array relationship */
  contingency_landing_spots: Array<Contingency_Landing_Spots>;
  /** An aggregated array relationship */
  contingency_landing_spots_aggregate: Contingency_Landing_Spots_Aggregate;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** An array relationship */
  file_assets: Array<File_Assets>;
  /** An aggregated array relationship */
  file_assets_aggregate: File_Assets_Aggregate;
  /** An array relationship */
  flight_commands: Array<Flight_Commands>;
  /** An aggregated array relationship */
  flight_commands_aggregate: Flight_Commands_Aggregate;
  /** An array relationship */
  flight_plans: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  /** An array relationship */
  flight_routes: Array<Flight_Routes>;
  /** An aggregated array relationship */
  flight_routes_aggregate: Flight_Routes_Aggregate;
  hashed_password?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An array relationship */
  manifests: Array<Manifests>;
  /** An array relationship */
  manifestsBySenderId: Array<Manifests>;
  /** An aggregated array relationship */
  manifestsBySenderId_aggregate: Manifests_Aggregate;
  /** An aggregated array relationship */
  manifests_aggregate: Manifests_Aggregate;
  mongo_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organizations>;
  /** Organization user belongs to */
  organization_key?: Maybe<Organizations_Enum>;
  /** An array relationship */
  pickup_requests: Array<Pickup_Requests>;
  /** An aggregated array relationship */
  pickup_requests_aggregate: Pickup_Requests_Aggregate;
  provider?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  salt?: Maybe<Scalars['String']>;
  /** An array relationship */
  stations: Array<Stations>;
  /** An aggregated array relationship */
  stations_aggregate: Stations_Aggregate;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_networks: Array<User_Networks>;
  /** An aggregated array relationship */
  user_networks_aggregate: User_Networks_Aggregate;
  /** An array relationship */
  user_permissions: Array<User_Permissions_View>;
  /** An aggregated array relationship */
  user_permissions_aggregate: User_Permissions_View_Aggregate;
  /** An array relationship */
  user_roles: Array<User_Roles>;
  /** An aggregated array relationship */
  user_roles_aggregate: User_Roles_Aggregate;
  /** An array relationship */
  vehicle_priority_events: Array<Vehicle_Priority_Events>;
  /** An aggregated array relationship */
  vehicle_priority_events_aggregate: Vehicle_Priority_Events_Aggregate;
  version: Scalars['Int'];
};


/** columns and relationships of "users" */
export type UsersBatteriesArgs = {
  distinct_on?: Maybe<Array<Batteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batteries_Order_By>>;
  where?: Maybe<Batteries_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersBatteries_AggregateArgs = {
  distinct_on?: Maybe<Array<Batteries_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Batteries_Order_By>>;
  where?: Maybe<Batteries_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersContingency_Landing_SpotsArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersContingency_Landing_Spots_AggregateArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_AssetsArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFile_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlight_CommandsArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlight_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlight_RoutesArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFlight_Routes_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Routes_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Routes_Order_By>>;
  where?: Maybe<Flight_Routes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersManifestsArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersManifestsBySenderIdArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersManifestsBySenderId_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersManifests_AggregateArgs = {
  distinct_on?: Maybe<Array<Manifests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Manifests_Order_By>>;
  where?: Maybe<Manifests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPickup_RequestsArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPickup_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStationsArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersStations_AggregateArgs = {
  distinct_on?: Maybe<Array<Stations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Stations_Order_By>>;
  where?: Maybe<Stations_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_NetworksArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Networks_Order_By>>;
  where?: Maybe<User_Networks_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_PermissionsArgs = {
  distinct_on?: Maybe<Array<User_Permissions_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Permissions_View_Order_By>>;
  where?: Maybe<User_Permissions_View_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Permissions_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Permissions_View_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Permissions_View_Order_By>>;
  where?: Maybe<User_Permissions_View_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_RolesArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Roles_AggregateArgs = {
  distinct_on?: Maybe<Array<User_Roles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<User_Roles_Order_By>>;
  where?: Maybe<User_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVehicle_Priority_EventsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersVehicle_Priority_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Users_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: Maybe<Users_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Users_Max_Order_By>;
  min?: Maybe<Users_Min_Order_By>;
  stddev?: Maybe<Users_Stddev_Order_By>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Order_By>;
  sum?: Maybe<Users_Sum_Order_By>;
  var_pop?: Maybe<Users_Var_Pop_Order_By>;
  var_samp?: Maybe<Users_Var_Samp_Order_By>;
  variance?: Maybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  _not?: Maybe<Users_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Users_Bool_Exp>>>;
  account_status?: Maybe<String_Comparison_Exp>;
  activated?: Maybe<Boolean_Comparison_Exp>;
  assigned_station?: Maybe<Stations_Bool_Exp>;
  assigned_station_id?: Maybe<Int_Comparison_Exp>;
  auth0_user_id?: Maybe<String_Comparison_Exp>;
  batteries?: Maybe<Batteries_Bool_Exp>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  email?: Maybe<String_Comparison_Exp>;
  file_assets?: Maybe<File_Assets_Bool_Exp>;
  flight_commands?: Maybe<Flight_Commands_Bool_Exp>;
  flight_plans?: Maybe<Flight_Plans_Bool_Exp>;
  flight_routes?: Maybe<Flight_Routes_Bool_Exp>;
  hashed_password?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  manifests?: Maybe<Manifests_Bool_Exp>;
  manifestsBySenderId?: Maybe<Manifests_Bool_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  organization?: Maybe<Organizations_Bool_Exp>;
  organization_key?: Maybe<Organizations_Enum_Comparison_Exp>;
  pickup_requests?: Maybe<Pickup_Requests_Bool_Exp>;
  provider?: Maybe<String_Comparison_Exp>;
  role?: Maybe<String_Comparison_Exp>;
  salt?: Maybe<String_Comparison_Exp>;
  stations?: Maybe<Stations_Bool_Exp>;
  tenant?: Maybe<Tenants_Bool_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  user_networks?: Maybe<User_Networks_Bool_Exp>;
  user_permissions?: Maybe<User_Permissions_View_Bool_Exp>;
  user_roles?: Maybe<User_Roles_Bool_Exp>;
  vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UsersAuth0UserIdKey = 'users_auth0_user_id_key',
  /** unique or primary key constraint */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint */
  UsersMongoIdKey = 'users_mongo_id_key',
  /** unique or primary key constraint */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing integer column in table "users" */
export type Users_Inc_Input = {
  assigned_station_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  account_status?: Maybe<Scalars['String']>;
  activated?: Maybe<Scalars['Boolean']>;
  assigned_station?: Maybe<Stations_Obj_Rel_Insert_Input>;
  assigned_station_id?: Maybe<Scalars['Int']>;
  auth0_user_id?: Maybe<Scalars['String']>;
  batteries?: Maybe<Batteries_Arr_Rel_Insert_Input>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  file_assets?: Maybe<File_Assets_Arr_Rel_Insert_Input>;
  flight_commands?: Maybe<Flight_Commands_Arr_Rel_Insert_Input>;
  flight_plans?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  flight_routes?: Maybe<Flight_Routes_Arr_Rel_Insert_Input>;
  hashed_password?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  manifests?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  manifestsBySenderId?: Maybe<Manifests_Arr_Rel_Insert_Input>;
  mongo_id?: Maybe<Scalars['String']>;
  organization?: Maybe<Organizations_Obj_Rel_Insert_Input>;
  organization_key?: Maybe<Organizations_Enum>;
  pickup_requests?: Maybe<Pickup_Requests_Arr_Rel_Insert_Input>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  stations?: Maybe<Stations_Arr_Rel_Insert_Input>;
  tenant?: Maybe<Tenants_Obj_Rel_Insert_Input>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_networks?: Maybe<User_Networks_Arr_Rel_Insert_Input>;
  user_roles?: Maybe<User_Roles_Arr_Rel_Insert_Input>;
  vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  account_status?: Maybe<Scalars['String']>;
  assigned_station_id?: Maybe<Scalars['Int']>;
  auth0_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hashed_password?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  account_status?: Maybe<Order_By>;
  assigned_station_id?: Maybe<Order_By>;
  auth0_user_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  hashed_password?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  provider?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  salt?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  account_status?: Maybe<Scalars['String']>;
  assigned_station_id?: Maybe<Scalars['Int']>;
  auth0_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hashed_password?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  account_status?: Maybe<Order_By>;
  assigned_station_id?: Maybe<Order_By>;
  auth0_user_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  hashed_password?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  provider?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  salt?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  on_conflict?: Maybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns: Array<Users_Update_Column>;
  where?: Maybe<Users_Bool_Exp>;
};

/** ordering options when selecting data from "users" */
export type Users_Order_By = {
  account_status?: Maybe<Order_By>;
  activated?: Maybe<Order_By>;
  assigned_station?: Maybe<Stations_Order_By>;
  assigned_station_id?: Maybe<Order_By>;
  auth0_user_id?: Maybe<Order_By>;
  batteries_aggregate?: Maybe<Batteries_Aggregate_Order_By>;
  contingency_landing_spots_aggregate?: Maybe<Contingency_Landing_Spots_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  email?: Maybe<Order_By>;
  file_assets_aggregate?: Maybe<File_Assets_Aggregate_Order_By>;
  flight_commands_aggregate?: Maybe<Flight_Commands_Aggregate_Order_By>;
  flight_plans_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  flight_routes_aggregate?: Maybe<Flight_Routes_Aggregate_Order_By>;
  hashed_password?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  manifestsBySenderId_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  manifests_aggregate?: Maybe<Manifests_Aggregate_Order_By>;
  mongo_id?: Maybe<Order_By>;
  organization?: Maybe<Organizations_Order_By>;
  organization_key?: Maybe<Order_By>;
  pickup_requests_aggregate?: Maybe<Pickup_Requests_Aggregate_Order_By>;
  provider?: Maybe<Order_By>;
  role?: Maybe<Order_By>;
  salt?: Maybe<Order_By>;
  stations_aggregate?: Maybe<Stations_Aggregate_Order_By>;
  tenant?: Maybe<Tenants_Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  user_networks_aggregate?: Maybe<User_Networks_Aggregate_Order_By>;
  user_permissions_aggregate?: Maybe<User_Permissions_View_Aggregate_Order_By>;
  user_roles_aggregate?: Maybe<User_Roles_Aggregate_Order_By>;
  vehicle_priority_events_aggregate?: Maybe<Vehicle_Priority_Events_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "users" */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AccountStatus = 'account_status',
  /** column name */
  Activated = 'activated',
  /** column name */
  AssignedStationId = 'assigned_station_id',
  /** column name */
  Auth0UserId = 'auth0_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  HashedPassword = 'hashed_password',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  OrganizationKey = 'organization_key',
  /** column name */
  Provider = 'provider',
  /** column name */
  Role = 'role',
  /** column name */
  Salt = 'salt',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  account_status?: Maybe<Scalars['String']>;
  activated?: Maybe<Scalars['Boolean']>;
  assigned_station_id?: Maybe<Scalars['Int']>;
  auth0_user_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  hashed_password?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  mongo_id?: Maybe<Scalars['String']>;
  organization_key?: Maybe<Organizations_Enum>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  assigned_station_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AccountStatus = 'account_status',
  /** column name */
  Activated = 'activated',
  /** column name */
  AssignedStationId = 'assigned_station_id',
  /** column name */
  Auth0UserId = 'auth0_user_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  Email = 'email',
  /** column name */
  HashedPassword = 'hashed_password',
  /** column name */
  Id = 'id',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  OrganizationKey = 'organization_key',
  /** column name */
  Provider = 'provider',
  /** column name */
  Role = 'role',
  /** column name */
  Salt = 'salt',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  assigned_station_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  assigned_station_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};


/** expression to compare columns of type uuid. All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories = {
  __typename?: 'vehicle_airworthiness_categories';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Aggregate = {
  __typename?: 'vehicle_airworthiness_categories_aggregate';
  aggregate?: Maybe<Vehicle_Airworthiness_Categories_Aggregate_Fields>;
  nodes: Array<Vehicle_Airworthiness_Categories>;
};

/** aggregate fields of "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Aggregate_Fields = {
  __typename?: 'vehicle_airworthiness_categories_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Airworthiness_Categories_Max_Fields>;
  min?: Maybe<Vehicle_Airworthiness_Categories_Min_Fields>;
};


/** aggregate fields of "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Airworthiness_Categories_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Airworthiness_Categories_Max_Order_By>;
  min?: Maybe<Vehicle_Airworthiness_Categories_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Airworthiness_Categories_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Airworthiness_Categories_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_airworthiness_categories". All fields are combined with a logical 'AND'. */
export type Vehicle_Airworthiness_Categories_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_airworthiness_categories" */
export enum Vehicle_Airworthiness_Categories_Constraint {
  /** unique or primary key constraint */
  VehicleAirworthinessCategoriesPkey = 'vehicle_airworthiness_categories_pkey'
}

export enum Vehicle_Airworthiness_Categories_Enum {
  /** Experimental */
  Experimental = 'Experimental',
  /** Production */
  Production = 'Production',
  /** Unqualified */
  Unqualified = 'Unqualified'
}

/** expression to compare columns of type vehicle_airworthiness_categories_enum. All fields are combined with logical 'AND'. */
export type Vehicle_Airworthiness_Categories_Enum_Comparison_Exp = {
  _eq?: Maybe<Vehicle_Airworthiness_Categories_Enum>;
  _in?: Maybe<Array<Vehicle_Airworthiness_Categories_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Vehicle_Airworthiness_Categories_Enum>;
  _nin?: Maybe<Array<Vehicle_Airworthiness_Categories_Enum>>;
};

/** input type for inserting data into table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vehicle_Airworthiness_Categories_Max_Fields = {
  __typename?: 'vehicle_airworthiness_categories_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Airworthiness_Categories_Min_Fields = {
  __typename?: 'vehicle_airworthiness_categories_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Mutation_Response = {
  __typename?: 'vehicle_airworthiness_categories_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Airworthiness_Categories>;
};

/** input type for inserting object relation for remote table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Obj_Rel_Insert_Input = {
  data: Vehicle_Airworthiness_Categories_Insert_Input;
  on_conflict?: Maybe<Vehicle_Airworthiness_Categories_On_Conflict>;
};

/** on conflict condition type for table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_On_Conflict = {
  constraint: Vehicle_Airworthiness_Categories_Constraint;
  update_columns: Array<Vehicle_Airworthiness_Categories_Update_Column>;
  where?: Maybe<Vehicle_Airworthiness_Categories_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "vehicle_airworthiness_categories" */
export enum Vehicle_Airworthiness_Categories_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "vehicle_airworthiness_categories" */
export type Vehicle_Airworthiness_Categories_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "vehicle_airworthiness_categories" */
export enum Vehicle_Airworthiness_Categories_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "vehicle_alerts" */
export type Vehicle_Alerts = {
  __typename?: 'vehicle_alerts';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  severity: Scalars['Int'];
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle?: Maybe<Vehicles>;
  vehicle_serial_number: Scalars['String'];
};

/** aggregated selection of "vehicle_alerts" */
export type Vehicle_Alerts_Aggregate = {
  __typename?: 'vehicle_alerts_aggregate';
  aggregate?: Maybe<Vehicle_Alerts_Aggregate_Fields>;
  nodes: Array<Vehicle_Alerts>;
};

/** aggregate fields of "vehicle_alerts" */
export type Vehicle_Alerts_Aggregate_Fields = {
  __typename?: 'vehicle_alerts_aggregate_fields';
  avg?: Maybe<Vehicle_Alerts_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Alerts_Max_Fields>;
  min?: Maybe<Vehicle_Alerts_Min_Fields>;
  stddev?: Maybe<Vehicle_Alerts_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Alerts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Alerts_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Alerts_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Alerts_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Alerts_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Alerts_Variance_Fields>;
};


/** aggregate fields of "vehicle_alerts" */
export type Vehicle_Alerts_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_alerts" */
export type Vehicle_Alerts_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Alerts_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Alerts_Max_Order_By>;
  min?: Maybe<Vehicle_Alerts_Min_Order_By>;
  stddev?: Maybe<Vehicle_Alerts_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Alerts_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Alerts_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Alerts_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Alerts_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Alerts_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Alerts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_alerts" */
export type Vehicle_Alerts_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Alerts_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Alerts_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Alerts_Avg_Fields = {
  __typename?: 'vehicle_alerts_avg_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Avg_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_alerts". All fields are combined with a logical 'AND'. */
export type Vehicle_Alerts_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Alerts_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Alerts_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Alerts_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  message?: Maybe<String_Comparison_Exp>;
  severity?: Maybe<Int_Comparison_Exp>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_serial_number?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_alerts" */
export enum Vehicle_Alerts_Constraint {
  /** unique or primary key constraint */
  VehicleAlertsPkey = 'vehicle_alerts_pkey'
}

/** input type for incrementing integer column in table "vehicle_alerts" */
export type Vehicle_Alerts_Inc_Input = {
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "vehicle_alerts" */
export type Vehicle_Alerts_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vehicle_Alerts_Max_Fields = {
  __typename?: 'vehicle_alerts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Alerts_Min_Fields = {
  __typename?: 'vehicle_alerts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_alerts" */
export type Vehicle_Alerts_Mutation_Response = {
  __typename?: 'vehicle_alerts_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Alerts>;
};

/** input type for inserting object relation for remote table "vehicle_alerts" */
export type Vehicle_Alerts_Obj_Rel_Insert_Input = {
  data: Vehicle_Alerts_Insert_Input;
  on_conflict?: Maybe<Vehicle_Alerts_On_Conflict>;
};

/** on conflict condition type for table "vehicle_alerts" */
export type Vehicle_Alerts_On_Conflict = {
  constraint: Vehicle_Alerts_Constraint;
  update_columns: Array<Vehicle_Alerts_Update_Column>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_alerts" */
export type Vehicle_Alerts_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_serial_number?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_alerts" */
export type Vehicle_Alerts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "vehicle_alerts" */
export enum Vehicle_Alerts_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Severity = 'severity',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number'
}

/** input type for updating data in table "vehicle_alerts" */
export type Vehicle_Alerts_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_serial_number?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Vehicle_Alerts_Stddev_Fields = {
  __typename?: 'vehicle_alerts_stddev_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Stddev_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Alerts_Stddev_Pop_Fields = {
  __typename?: 'vehicle_alerts_stddev_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Stddev_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Alerts_Stddev_Samp_Fields = {
  __typename?: 'vehicle_alerts_stddev_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Stddev_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Alerts_Sum_Fields = {
  __typename?: 'vehicle_alerts_sum_fields';
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['Int']>;
  timestamp_secs?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Sum_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** update columns of table "vehicle_alerts" */
export enum Vehicle_Alerts_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Severity = 'severity',
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleSerialNumber = 'vehicle_serial_number'
}

/** aggregate var_pop on columns */
export type Vehicle_Alerts_Var_Pop_Fields = {
  __typename?: 'vehicle_alerts_var_pop_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Var_Pop_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Alerts_Var_Samp_Fields = {
  __typename?: 'vehicle_alerts_var_samp_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Var_Samp_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Alerts_Variance_Fields = {
  __typename?: 'vehicle_alerts_variance_fields';
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  severity?: Maybe<Scalars['Float']>;
  timestamp_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_alerts" */
export type Vehicle_Alerts_Variance_Order_By = {
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  timestamp_secs?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum = {
  __typename?: 'vehicle_flight_state_enum';
  description?: Maybe<Scalars['String']>;
  state: Scalars['String'];
};

/** aggregated selection of "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Aggregate = {
  __typename?: 'vehicle_flight_state_enum_aggregate';
  aggregate?: Maybe<Vehicle_Flight_State_Enum_Aggregate_Fields>;
  nodes: Array<Vehicle_Flight_State_Enum>;
};

/** aggregate fields of "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Aggregate_Fields = {
  __typename?: 'vehicle_flight_state_enum_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Flight_State_Enum_Max_Fields>;
  min?: Maybe<Vehicle_Flight_State_Enum_Min_Fields>;
};


/** aggregate fields of "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Flight_State_Enum_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Flight_State_Enum_Max_Order_By>;
  min?: Maybe<Vehicle_Flight_State_Enum_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Flight_State_Enum_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Flight_State_Enum_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_flight_state_enum". All fields are combined with a logical 'AND'. */
export type Vehicle_Flight_State_Enum_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Flight_State_Enum_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Flight_State_Enum_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Flight_State_Enum_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  state?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_flight_state_enum" */
export enum Vehicle_Flight_State_Enum_Constraint {
  /** unique or primary key constraint */
  VehicleFlightStateEnumPkey = 'vehicle_flight_state_enum_pkey'
}

/** input type for inserting data into table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vehicle_Flight_State_Enum_Max_Fields = {
  __typename?: 'vehicle_flight_state_enum_max_fields';
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Max_Order_By = {
  description?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Flight_State_Enum_Min_Fields = {
  __typename?: 'vehicle_flight_state_enum_min_fields';
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Min_Order_By = {
  description?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Mutation_Response = {
  __typename?: 'vehicle_flight_state_enum_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Flight_State_Enum>;
};

/** input type for inserting object relation for remote table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Obj_Rel_Insert_Input = {
  data: Vehicle_Flight_State_Enum_Insert_Input;
  on_conflict?: Maybe<Vehicle_Flight_State_Enum_On_Conflict>;
};

/** on conflict condition type for table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_On_Conflict = {
  constraint: Vehicle_Flight_State_Enum_Constraint;
  update_columns: Array<Vehicle_Flight_State_Enum_Update_Column>;
  where?: Maybe<Vehicle_Flight_State_Enum_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Order_By = {
  description?: Maybe<Order_By>;
  state?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Pk_Columns_Input = {
  state: Scalars['String'];
};

/** select columns of table "vehicle_flight_state_enum" */
export enum Vehicle_Flight_State_Enum_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "vehicle_flight_state_enum" */
export type Vehicle_Flight_State_Enum_Set_Input = {
  description?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "vehicle_flight_state_enum" */
export enum Vehicle_Flight_State_Enum_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

/** columns and relationships of "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses = {
  __typename?: 'vehicle_flight_statuses';
  /** Timestamp of when the vehicle was determined to be in an active flight. In unix epoch format with unit of seconds. */
  activated_at?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  flight_plan?: Maybe<Flight_Plans>;
  /** Flight plan ID associated with the vehicle. */
  flight_plan_id?: Maybe<Scalars['Int']>;
  /** Flight state reported by the vehicle */
  flight_status: Scalars['String'];
  /** Timestamp of the last reported in-flight disconnect. In unix epoch format with unit of seconds. */
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  /** Flag denoting whether a flight state was commanded or automated */
  is_user_commanded: Scalars['Boolean'];
  /** Timestamp of the last reported status. In unix epoch format with unit of seconds. */
  last_updated_at: Scalars['Int'];
  /** Serial number of the vehicle. */
  serial_number: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Aggregate = {
  __typename?: 'vehicle_flight_statuses_aggregate';
  aggregate?: Maybe<Vehicle_Flight_Statuses_Aggregate_Fields>;
  nodes: Array<Vehicle_Flight_Statuses>;
};

/** aggregate fields of "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Aggregate_Fields = {
  __typename?: 'vehicle_flight_statuses_aggregate_fields';
  avg?: Maybe<Vehicle_Flight_Statuses_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Flight_Statuses_Max_Fields>;
  min?: Maybe<Vehicle_Flight_Statuses_Min_Fields>;
  stddev?: Maybe<Vehicle_Flight_Statuses_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Flight_Statuses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Flight_Statuses_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Flight_Statuses_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Flight_Statuses_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Flight_Statuses_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Flight_Statuses_Variance_Fields>;
};


/** aggregate fields of "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Flight_Statuses_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Flight_Statuses_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Flight_Statuses_Max_Order_By>;
  min?: Maybe<Vehicle_Flight_Statuses_Min_Order_By>;
  stddev?: Maybe<Vehicle_Flight_Statuses_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Flight_Statuses_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Flight_Statuses_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Flight_Statuses_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Flight_Statuses_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Flight_Statuses_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Flight_Statuses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Flight_Statuses_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Flight_Statuses_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Flight_Statuses_Avg_Fields = {
  __typename?: 'vehicle_flight_statuses_avg_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Avg_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_flight_statuses". All fields are combined with a logical 'AND'. */
export type Vehicle_Flight_Statuses_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Flight_Statuses_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Flight_Statuses_Bool_Exp>>>;
  activated_at?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  flight_status?: Maybe<String_Comparison_Exp>;
  in_flight_disconnect_at?: Maybe<Int_Comparison_Exp>;
  is_user_commanded?: Maybe<Boolean_Comparison_Exp>;
  last_updated_at?: Maybe<Int_Comparison_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_flight_statuses" */
export enum Vehicle_Flight_Statuses_Constraint {
  /** unique or primary key constraint */
  VehicleFlightStatusesPkey = 'vehicle_flight_statuses_pkey'
}

/** input type for incrementing integer column in table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Inc_Input = {
  activated_at?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  last_updated_at?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Insert_Input = {
  activated_at?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_status?: Maybe<Scalars['String']>;
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  is_user_commanded?: Maybe<Scalars['Boolean']>;
  last_updated_at?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Vehicle_Flight_Statuses_Max_Fields = {
  __typename?: 'vehicle_flight_statuses_max_fields';
  activated_at?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_status?: Maybe<Scalars['String']>;
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  last_updated_at?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Max_Order_By = {
  activated_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_status?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Flight_Statuses_Min_Fields = {
  __typename?: 'vehicle_flight_statuses_min_fields';
  activated_at?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_status?: Maybe<Scalars['String']>;
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  last_updated_at?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Min_Order_By = {
  activated_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_status?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Mutation_Response = {
  __typename?: 'vehicle_flight_statuses_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Flight_Statuses>;
};

/** input type for inserting object relation for remote table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Obj_Rel_Insert_Input = {
  data: Vehicle_Flight_Statuses_Insert_Input;
  on_conflict?: Maybe<Vehicle_Flight_Statuses_On_Conflict>;
};

/** on conflict condition type for table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_On_Conflict = {
  constraint: Vehicle_Flight_Statuses_Constraint;
  update_columns: Array<Vehicle_Flight_Statuses_Update_Column>;
  where?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Order_By = {
  activated_at?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_status?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  is_user_commanded?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Pk_Columns_Input = {
  /** Serial number of the vehicle. */
  serial_number: Scalars['String'];
};

/** select columns of table "vehicle_flight_statuses" */
export enum Vehicle_Flight_Statuses_Select_Column {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FlightStatus = 'flight_status',
  /** column name */
  InFlightDisconnectAt = 'in_flight_disconnect_at',
  /** column name */
  IsUserCommanded = 'is_user_commanded',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Set_Input = {
  activated_at?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_status?: Maybe<Scalars['String']>;
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  is_user_commanded?: Maybe<Scalars['Boolean']>;
  last_updated_at?: Maybe<Scalars['Int']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Vehicle_Flight_Statuses_Stddev_Fields = {
  __typename?: 'vehicle_flight_statuses_stddev_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Stddev_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Flight_Statuses_Stddev_Pop_Fields = {
  __typename?: 'vehicle_flight_statuses_stddev_pop_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Stddev_Pop_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Flight_Statuses_Stddev_Samp_Fields = {
  __typename?: 'vehicle_flight_statuses_stddev_samp_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Stddev_Samp_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Flight_Statuses_Sum_Fields = {
  __typename?: 'vehicle_flight_statuses_sum_fields';
  activated_at?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  in_flight_disconnect_at?: Maybe<Scalars['Int']>;
  last_updated_at?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Sum_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** update columns of table "vehicle_flight_statuses" */
export enum Vehicle_Flight_Statuses_Update_Column {
  /** column name */
  ActivatedAt = 'activated_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  FlightStatus = 'flight_status',
  /** column name */
  InFlightDisconnectAt = 'in_flight_disconnect_at',
  /** column name */
  IsUserCommanded = 'is_user_commanded',
  /** column name */
  LastUpdatedAt = 'last_updated_at',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Vehicle_Flight_Statuses_Var_Pop_Fields = {
  __typename?: 'vehicle_flight_statuses_var_pop_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Var_Pop_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Flight_Statuses_Var_Samp_Fields = {
  __typename?: 'vehicle_flight_statuses_var_samp_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Var_Samp_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Flight_Statuses_Variance_Fields = {
  __typename?: 'vehicle_flight_statuses_variance_fields';
  activated_at?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  in_flight_disconnect_at?: Maybe<Scalars['Float']>;
  last_updated_at?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_flight_statuses" */
export type Vehicle_Flight_Statuses_Variance_Order_By = {
  activated_at?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  in_flight_disconnect_at?: Maybe<Order_By>;
  last_updated_at?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types = {
  __typename?: 'vehicle_model_parameter_types';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Aggregate = {
  __typename?: 'vehicle_model_parameter_types_aggregate';
  aggregate?: Maybe<Vehicle_Model_Parameter_Types_Aggregate_Fields>;
  nodes: Array<Vehicle_Model_Parameter_Types>;
};

/** aggregate fields of "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Aggregate_Fields = {
  __typename?: 'vehicle_model_parameter_types_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Model_Parameter_Types_Max_Fields>;
  min?: Maybe<Vehicle_Model_Parameter_Types_Min_Fields>;
};


/** aggregate fields of "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Model_Parameter_Types_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Aggregate_Order_By = {
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Model_Parameter_Types_Max_Order_By>;
  min?: Maybe<Vehicle_Model_Parameter_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Model_Parameter_Types_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Model_Parameter_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "vehicle_model_parameter_types". All fields are combined with a logical 'AND'. */
export type Vehicle_Model_Parameter_Types_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>>>;
  description?: Maybe<String_Comparison_Exp>;
  value?: Maybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_model_parameter_types" */
export enum Vehicle_Model_Parameter_Types_Constraint {
  /** unique or primary key constraint */
  VehicleModelParameterTypesPkey = 'vehicle_model_parameter_types_pkey'
}

export enum Vehicle_Model_Parameter_Types_Enum {
  /** Ardupilot */
  Ardupilot = 'Ardupilot',
  /** Mavnet */
  Mavnet = 'Mavnet'
}

/** expression to compare columns of type vehicle_model_parameter_types_enum. All fields are combined with logical 'AND'. */
export type Vehicle_Model_Parameter_Types_Enum_Comparison_Exp = {
  _eq?: Maybe<Vehicle_Model_Parameter_Types_Enum>;
  _in?: Maybe<Array<Vehicle_Model_Parameter_Types_Enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Vehicle_Model_Parameter_Types_Enum>;
  _nin?: Maybe<Array<Vehicle_Model_Parameter_Types_Enum>>;
};

/** input type for inserting data into table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Insert_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vehicle_Model_Parameter_Types_Max_Fields = {
  __typename?: 'vehicle_model_parameter_types_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Max_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Model_Parameter_Types_Min_Fields = {
  __typename?: 'vehicle_model_parameter_types_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Min_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Mutation_Response = {
  __typename?: 'vehicle_model_parameter_types_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Model_Parameter_Types>;
};

/** input type for inserting object relation for remote table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Obj_Rel_Insert_Input = {
  data: Vehicle_Model_Parameter_Types_Insert_Input;
  on_conflict?: Maybe<Vehicle_Model_Parameter_Types_On_Conflict>;
};

/** on conflict condition type for table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_On_Conflict = {
  constraint: Vehicle_Model_Parameter_Types_Constraint;
  update_columns: Array<Vehicle_Model_Parameter_Types_Update_Column>;
  where?: Maybe<Vehicle_Model_Parameter_Types_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Order_By = {
  description?: Maybe<Order_By>;
  value?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "vehicle_model_parameter_types" */
export enum Vehicle_Model_Parameter_Types_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "vehicle_model_parameter_types" */
export type Vehicle_Model_Parameter_Types_Set_Input = {
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "vehicle_model_parameter_types" */
export enum Vehicle_Model_Parameter_Types_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "vehicle_model_parameters" */
export type Vehicle_Model_Parameters = {
  __typename?: 'vehicle_model_parameters';
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  param_key: Scalars['String'];
  param_value?: Maybe<Scalars['String']>;
  type: Vehicle_Model_Parameter_Types_Enum;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle_model: Vehicle_Models;
  vehicle_model_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Aggregate = {
  __typename?: 'vehicle_model_parameters_aggregate';
  aggregate?: Maybe<Vehicle_Model_Parameters_Aggregate_Fields>;
  nodes: Array<Vehicle_Model_Parameters>;
};

/** aggregate fields of "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Aggregate_Fields = {
  __typename?: 'vehicle_model_parameters_aggregate_fields';
  avg?: Maybe<Vehicle_Model_Parameters_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Model_Parameters_Max_Fields>;
  min?: Maybe<Vehicle_Model_Parameters_Min_Fields>;
  stddev?: Maybe<Vehicle_Model_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Model_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Model_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Model_Parameters_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Model_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Model_Parameters_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Model_Parameters_Variance_Fields>;
};


/** aggregate fields of "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Model_Parameters_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Model_Parameters_Max_Order_By>;
  min?: Maybe<Vehicle_Model_Parameters_Min_Order_By>;
  stddev?: Maybe<Vehicle_Model_Parameters_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Model_Parameters_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Model_Parameters_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Model_Parameters_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Model_Parameters_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Model_Parameters_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Model_Parameters_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Model_Parameters_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Model_Parameters_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Model_Parameters_Avg_Fields = {
  __typename?: 'vehicle_model_parameters_avg_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Avg_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_model_parameters". All fields are combined with a logical 'AND'. */
export type Vehicle_Model_Parameters_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Model_Parameters_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Model_Parameters_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  param_key?: Maybe<String_Comparison_Exp>;
  param_value?: Maybe<String_Comparison_Exp>;
  type?: Maybe<Vehicle_Model_Parameter_Types_Enum_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle_model?: Maybe<Vehicle_Models_Bool_Exp>;
  vehicle_model_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_model_parameters" */
export enum Vehicle_Model_Parameters_Constraint {
  /** unique or primary key constraint */
  VehicleModelParametersPkey = 'vehicle_model_parameters_pkey',
  /** unique or primary key constraint */
  VehicleModelParametersVehicleModelIdTypeParamKeyDelete = 'vehicle_model_parameters_vehicle_model_id_type_param_key_delete'
}

/** input type for incrementing integer column in table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  type?: Maybe<Vehicle_Model_Parameter_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_model?: Maybe<Vehicle_Models_Obj_Rel_Insert_Input>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicle_Model_Parameters_Max_Fields = {
  __typename?: 'vehicle_model_parameters_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  param_key?: Maybe<Order_By>;
  param_value?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Model_Parameters_Min_Fields = {
  __typename?: 'vehicle_model_parameters_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  param_key?: Maybe<Order_By>;
  param_value?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Mutation_Response = {
  __typename?: 'vehicle_model_parameters_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Model_Parameters>;
};

/** input type for inserting object relation for remote table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Obj_Rel_Insert_Input = {
  data: Vehicle_Model_Parameters_Insert_Input;
  on_conflict?: Maybe<Vehicle_Model_Parameters_On_Conflict>;
};

/** on conflict condition type for table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_On_Conflict = {
  constraint: Vehicle_Model_Parameters_Constraint;
  update_columns: Array<Vehicle_Model_Parameters_Update_Column>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  param_key?: Maybe<Order_By>;
  param_value?: Maybe<Order_By>;
  type?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_model?: Maybe<Vehicle_Models_Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "vehicle_model_parameters" */
export enum Vehicle_Model_Parameters_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParamKey = 'param_key',
  /** column name */
  ParamValue = 'param_value',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleModelId = 'vehicle_model_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  param_key?: Maybe<Scalars['String']>;
  param_value?: Maybe<Scalars['String']>;
  type?: Maybe<Vehicle_Model_Parameter_Types_Enum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicle_Model_Parameters_Stddev_Fields = {
  __typename?: 'vehicle_model_parameters_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Model_Parameters_Stddev_Pop_Fields = {
  __typename?: 'vehicle_model_parameters_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Model_Parameters_Stddev_Samp_Fields = {
  __typename?: 'vehicle_model_parameters_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Model_Parameters_Sum_Fields = {
  __typename?: 'vehicle_model_parameters_sum_fields';
  id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Sum_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "vehicle_model_parameters" */
export enum Vehicle_Model_Parameters_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  ParamKey = 'param_key',
  /** column name */
  ParamValue = 'param_value',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleModelId = 'vehicle_model_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Vehicle_Model_Parameters_Var_Pop_Fields = {
  __typename?: 'vehicle_model_parameters_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Model_Parameters_Var_Samp_Fields = {
  __typename?: 'vehicle_model_parameters_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Model_Parameters_Variance_Fields = {
  __typename?: 'vehicle_model_parameters_variance_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_model_parameters" */
export type Vehicle_Model_Parameters_Variance_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_models" */
export type Vehicle_Models = {
  __typename?: 'vehicle_models';
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  hierarchy_level?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  uwb_version?: Maybe<Scalars['String']>;
  /** An array relationship */
  vehicleModelsAncestorsByVehicleModelId: Array<Vehicle_Models_Ancestors>;
  /** An aggregated array relationship */
  vehicleModelsAncestorsByVehicleModelId_aggregate: Vehicle_Models_Ancestors_Aggregate;
  /** An object relationship */
  vehicle_model?: Maybe<Vehicle_Models>;
  /** An array relationship */
  vehicle_model_parameters: Array<Vehicle_Model_Parameters>;
  /** An aggregated array relationship */
  vehicle_model_parameters_aggregate: Vehicle_Model_Parameters_Aggregate;
  /** An array relationship */
  vehicle_models: Array<Vehicle_Models>;
  /** An aggregated array relationship */
  vehicle_models_aggregate: Vehicle_Models_Aggregate;
  /** An array relationship */
  vehicle_models_ancestors: Array<Vehicle_Models_Ancestors>;
  /** An aggregated array relationship */
  vehicle_models_ancestors_aggregate: Vehicle_Models_Ancestors_Aggregate;
  /** An array relationship */
  vehicles: Array<Vehicles>;
  /** An aggregated array relationship */
  vehicles_aggregate: Vehicles_Aggregate;
  version: Scalars['Int'];
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicleModelsAncestorsByVehicleModelIdArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicleModelsAncestorsByVehicleModelId_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicle_Model_ParametersArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameters_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicle_Model_Parameters_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Model_Parameters_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Model_Parameters_Order_By>>;
  where?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicle_ModelsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Order_By>>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicle_Models_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Order_By>>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicle_Models_AncestorsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicle_Models_Ancestors_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Models_Ancestors_Order_By>>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehiclesArgs = {
  distinct_on?: Maybe<Array<Vehicles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicles_Order_By>>;
  where?: Maybe<Vehicles_Bool_Exp>;
};


/** columns and relationships of "vehicle_models" */
export type Vehicle_ModelsVehicles_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicles_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicles_Order_By>>;
  where?: Maybe<Vehicles_Bool_Exp>;
};

/** aggregated selection of "vehicle_models" */
export type Vehicle_Models_Aggregate = {
  __typename?: 'vehicle_models_aggregate';
  aggregate?: Maybe<Vehicle_Models_Aggregate_Fields>;
  nodes: Array<Vehicle_Models>;
};

/** aggregate fields of "vehicle_models" */
export type Vehicle_Models_Aggregate_Fields = {
  __typename?: 'vehicle_models_aggregate_fields';
  avg?: Maybe<Vehicle_Models_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Models_Max_Fields>;
  min?: Maybe<Vehicle_Models_Min_Fields>;
  stddev?: Maybe<Vehicle_Models_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Models_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Models_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Models_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Models_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Models_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Models_Variance_Fields>;
};


/** aggregate fields of "vehicle_models" */
export type Vehicle_Models_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Models_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_models" */
export type Vehicle_Models_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Models_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Models_Max_Order_By>;
  min?: Maybe<Vehicle_Models_Min_Order_By>;
  stddev?: Maybe<Vehicle_Models_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Models_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Models_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Models_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Models_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Models_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Models_Variance_Order_By>;
};

/** columns and relationships of "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors = {
  __typename?: 'vehicle_models_ancestors';
  ancestor_id: Scalars['Int'];
  /** An object relationship */
  vehicleModelByVehicleModelId: Vehicle_Models;
  /** An object relationship */
  vehicle_model: Vehicle_Models;
  vehicle_model_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Aggregate = {
  __typename?: 'vehicle_models_ancestors_aggregate';
  aggregate?: Maybe<Vehicle_Models_Ancestors_Aggregate_Fields>;
  nodes: Array<Vehicle_Models_Ancestors>;
};

/** aggregate fields of "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Aggregate_Fields = {
  __typename?: 'vehicle_models_ancestors_aggregate_fields';
  avg?: Maybe<Vehicle_Models_Ancestors_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Models_Ancestors_Max_Fields>;
  min?: Maybe<Vehicle_Models_Ancestors_Min_Fields>;
  stddev?: Maybe<Vehicle_Models_Ancestors_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Models_Ancestors_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Models_Ancestors_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Models_Ancestors_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Models_Ancestors_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Models_Ancestors_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Models_Ancestors_Variance_Fields>;
};


/** aggregate fields of "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Models_Ancestors_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Models_Ancestors_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Models_Ancestors_Max_Order_By>;
  min?: Maybe<Vehicle_Models_Ancestors_Min_Order_By>;
  stddev?: Maybe<Vehicle_Models_Ancestors_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Models_Ancestors_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Models_Ancestors_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Models_Ancestors_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Models_Ancestors_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Models_Ancestors_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Models_Ancestors_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Models_Ancestors_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Models_Ancestors_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Models_Ancestors_Avg_Fields = {
  __typename?: 'vehicle_models_ancestors_avg_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Avg_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_models_ancestors". All fields are combined with a logical 'AND'. */
export type Vehicle_Models_Ancestors_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Models_Ancestors_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Models_Ancestors_Bool_Exp>>>;
  ancestor_id?: Maybe<Int_Comparison_Exp>;
  vehicleModelByVehicleModelId?: Maybe<Vehicle_Models_Bool_Exp>;
  vehicle_model?: Maybe<Vehicle_Models_Bool_Exp>;
  vehicle_model_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_models_ancestors" */
export enum Vehicle_Models_Ancestors_Constraint {
  /** unique or primary key constraint */
  VehicleModelsAncestorsVehicleModelIdAncestorIdPk = 'vehicle_models_ancestors_vehicle_model_id_ancestor_id_pk'
}

/** input type for incrementing integer column in table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Inc_Input = {
  ancestor_id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Insert_Input = {
  ancestor_id?: Maybe<Scalars['Int']>;
  vehicleModelByVehicleModelId?: Maybe<Vehicle_Models_Obj_Rel_Insert_Input>;
  vehicle_model?: Maybe<Vehicle_Models_Obj_Rel_Insert_Input>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicle_Models_Ancestors_Max_Fields = {
  __typename?: 'vehicle_models_ancestors_max_fields';
  ancestor_id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Max_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Models_Ancestors_Min_Fields = {
  __typename?: 'vehicle_models_ancestors_min_fields';
  ancestor_id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Min_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Mutation_Response = {
  __typename?: 'vehicle_models_ancestors_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Models_Ancestors>;
};

/** input type for inserting object relation for remote table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Obj_Rel_Insert_Input = {
  data: Vehicle_Models_Ancestors_Insert_Input;
  on_conflict?: Maybe<Vehicle_Models_Ancestors_On_Conflict>;
};

/** on conflict condition type for table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_On_Conflict = {
  constraint: Vehicle_Models_Ancestors_Constraint;
  update_columns: Array<Vehicle_Models_Ancestors_Update_Column>;
  where?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicleModelByVehicleModelId?: Maybe<Vehicle_Models_Order_By>;
  vehicle_model?: Maybe<Vehicle_Models_Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Pk_Columns_Input = {
  ancestor_id: Scalars['Int'];
  vehicle_model_id: Scalars['Int'];
};

/** select columns of table "vehicle_models_ancestors" */
export enum Vehicle_Models_Ancestors_Select_Column {
  /** column name */
  AncestorId = 'ancestor_id',
  /** column name */
  VehicleModelId = 'vehicle_model_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Set_Input = {
  ancestor_id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicle_Models_Ancestors_Stddev_Fields = {
  __typename?: 'vehicle_models_ancestors_stddev_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Stddev_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Models_Ancestors_Stddev_Pop_Fields = {
  __typename?: 'vehicle_models_ancestors_stddev_pop_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Stddev_Pop_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Models_Ancestors_Stddev_Samp_Fields = {
  __typename?: 'vehicle_models_ancestors_stddev_samp_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Stddev_Samp_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Models_Ancestors_Sum_Fields = {
  __typename?: 'vehicle_models_ancestors_sum_fields';
  ancestor_id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Sum_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "vehicle_models_ancestors" */
export enum Vehicle_Models_Ancestors_Update_Column {
  /** column name */
  AncestorId = 'ancestor_id',
  /** column name */
  VehicleModelId = 'vehicle_model_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Vehicle_Models_Ancestors_Var_Pop_Fields = {
  __typename?: 'vehicle_models_ancestors_var_pop_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Var_Pop_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Models_Ancestors_Var_Samp_Fields = {
  __typename?: 'vehicle_models_ancestors_var_samp_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Var_Samp_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Models_Ancestors_Variance_Fields = {
  __typename?: 'vehicle_models_ancestors_variance_fields';
  ancestor_id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_models_ancestors" */
export type Vehicle_Models_Ancestors_Variance_Order_By = {
  ancestor_id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_models" */
export type Vehicle_Models_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Models_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Models_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Models_Avg_Fields = {
  __typename?: 'vehicle_models_avg_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_models" */
export type Vehicle_Models_Avg_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_models". All fields are combined with a logical 'AND'. */
export type Vehicle_Models_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Models_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Models_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Models_Bool_Exp>>>;
  ardupilot_version?: Maybe<String_Comparison_Exp>;
  bmu2_version?: Maybe<String_Comparison_Exp>;
  bmu_version?: Maybe<String_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  fpga_version?: Maybe<String_Comparison_Exp>;
  fts_version?: Maybe<String_Comparison_Exp>;
  gps1_version?: Maybe<String_Comparison_Exp>;
  gps2_version?: Maybe<String_Comparison_Exp>;
  hierarchy_level?: Maybe<Int_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  lidar_version?: Maybe<String_Comparison_Exp>;
  mavnet_version?: Maybe<String_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parent_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uwb_version?: Maybe<String_Comparison_Exp>;
  vehicleModelsAncestorsByVehicleModelId?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
  vehicle_model?: Maybe<Vehicle_Models_Bool_Exp>;
  vehicle_model_parameters?: Maybe<Vehicle_Model_Parameters_Bool_Exp>;
  vehicle_models?: Maybe<Vehicle_Models_Bool_Exp>;
  vehicle_models_ancestors?: Maybe<Vehicle_Models_Ancestors_Bool_Exp>;
  vehicles?: Maybe<Vehicles_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_models" */
export enum Vehicle_Models_Constraint {
  /** unique or primary key constraint */
  VehicleModelsMongoIdKey = 'vehicle_models_mongo_id_key',
  /** unique or primary key constraint */
  VehicleModelsPkey = 'vehicle_models_pkey'
}

/** input type for incrementing integer column in table "vehicle_models" */
export type Vehicle_Models_Inc_Input = {
  hierarchy_level?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_models" */
export type Vehicle_Models_Insert_Input = {
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  hierarchy_level?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  vehicleModelsAncestorsByVehicleModelId?: Maybe<Vehicle_Models_Ancestors_Arr_Rel_Insert_Input>;
  vehicle_model?: Maybe<Vehicle_Models_Obj_Rel_Insert_Input>;
  vehicle_model_parameters?: Maybe<Vehicle_Model_Parameters_Arr_Rel_Insert_Input>;
  vehicle_models?: Maybe<Vehicle_Models_Arr_Rel_Insert_Input>;
  vehicle_models_ancestors?: Maybe<Vehicle_Models_Ancestors_Arr_Rel_Insert_Input>;
  vehicles?: Maybe<Vehicles_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicle_Models_Max_Fields = {
  __typename?: 'vehicle_models_max_fields';
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  hierarchy_level?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicle_models" */
export type Vehicle_Models_Max_Order_By = {
  ardupilot_version?: Maybe<Order_By>;
  bmu2_version?: Maybe<Order_By>;
  bmu_version?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  fpga_version?: Maybe<Order_By>;
  fts_version?: Maybe<Order_By>;
  gps1_version?: Maybe<Order_By>;
  gps2_version?: Maybe<Order_By>;
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lidar_version?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Models_Min_Fields = {
  __typename?: 'vehicle_models_min_fields';
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  hierarchy_level?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicle_models" */
export type Vehicle_Models_Min_Order_By = {
  ardupilot_version?: Maybe<Order_By>;
  bmu2_version?: Maybe<Order_By>;
  bmu_version?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  fpga_version?: Maybe<Order_By>;
  fts_version?: Maybe<Order_By>;
  gps1_version?: Maybe<Order_By>;
  gps2_version?: Maybe<Order_By>;
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lidar_version?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_models" */
export type Vehicle_Models_Mutation_Response = {
  __typename?: 'vehicle_models_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Models>;
};

/** input type for inserting object relation for remote table "vehicle_models" */
export type Vehicle_Models_Obj_Rel_Insert_Input = {
  data: Vehicle_Models_Insert_Input;
  on_conflict?: Maybe<Vehicle_Models_On_Conflict>;
};

/** on conflict condition type for table "vehicle_models" */
export type Vehicle_Models_On_Conflict = {
  constraint: Vehicle_Models_Constraint;
  update_columns: Array<Vehicle_Models_Update_Column>;
  where?: Maybe<Vehicle_Models_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_models" */
export type Vehicle_Models_Order_By = {
  ardupilot_version?: Maybe<Order_By>;
  bmu2_version?: Maybe<Order_By>;
  bmu_version?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  fpga_version?: Maybe<Order_By>;
  fts_version?: Maybe<Order_By>;
  gps1_version?: Maybe<Order_By>;
  gps2_version?: Maybe<Order_By>;
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lidar_version?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  vehicleModelsAncestorsByVehicleModelId_aggregate?: Maybe<Vehicle_Models_Ancestors_Aggregate_Order_By>;
  vehicle_model?: Maybe<Vehicle_Models_Order_By>;
  vehicle_model_parameters_aggregate?: Maybe<Vehicle_Model_Parameters_Aggregate_Order_By>;
  vehicle_models_aggregate?: Maybe<Vehicle_Models_Aggregate_Order_By>;
  vehicle_models_ancestors_aggregate?: Maybe<Vehicle_Models_Ancestors_Aggregate_Order_By>;
  vehicles_aggregate?: Maybe<Vehicles_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_models" */
export type Vehicle_Models_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "vehicle_models" */
export enum Vehicle_Models_Select_Column {
  /** column name */
  ArdupilotVersion = 'ardupilot_version',
  /** column name */
  Bmu2Version = 'bmu2_version',
  /** column name */
  BmuVersion = 'bmu_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FpgaVersion = 'fpga_version',
  /** column name */
  FtsVersion = 'fts_version',
  /** column name */
  Gps1Version = 'gps1_version',
  /** column name */
  Gps2Version = 'gps2_version',
  /** column name */
  HierarchyLevel = 'hierarchy_level',
  /** column name */
  Id = 'id',
  /** column name */
  LidarVersion = 'lidar_version',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "vehicle_models" */
export type Vehicle_Models_Set_Input = {
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  hierarchy_level?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicle_Models_Stddev_Fields = {
  __typename?: 'vehicle_models_stddev_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_models" */
export type Vehicle_Models_Stddev_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Models_Stddev_Pop_Fields = {
  __typename?: 'vehicle_models_stddev_pop_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_models" */
export type Vehicle_Models_Stddev_Pop_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Models_Stddev_Samp_Fields = {
  __typename?: 'vehicle_models_stddev_samp_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_models" */
export type Vehicle_Models_Stddev_Samp_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Models_Sum_Fields = {
  __typename?: 'vehicle_models_sum_fields';
  hierarchy_level?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_models" */
export type Vehicle_Models_Sum_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "vehicle_models" */
export enum Vehicle_Models_Update_Column {
  /** column name */
  ArdupilotVersion = 'ardupilot_version',
  /** column name */
  Bmu2Version = 'bmu2_version',
  /** column name */
  BmuVersion = 'bmu_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FpgaVersion = 'fpga_version',
  /** column name */
  FtsVersion = 'fts_version',
  /** column name */
  Gps1Version = 'gps1_version',
  /** column name */
  Gps2Version = 'gps2_version',
  /** column name */
  HierarchyLevel = 'hierarchy_level',
  /** column name */
  Id = 'id',
  /** column name */
  LidarVersion = 'lidar_version',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Vehicle_Models_Var_Pop_Fields = {
  __typename?: 'vehicle_models_var_pop_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_models" */
export type Vehicle_Models_Var_Pop_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Models_Var_Samp_Fields = {
  __typename?: 'vehicle_models_var_samp_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_models" */
export type Vehicle_Models_Var_Samp_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Models_Variance_Fields = {
  __typename?: 'vehicle_models_variance_fields';
  hierarchy_level?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_models" */
export type Vehicle_Models_Variance_Order_By = {
  hierarchy_level?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  parent_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/**
 * Table containing the vehicle network memberships.
 *
 *
 * columns and relationships of "vehicle_networks"
 */
export type Vehicle_Networks = {
  __typename?: 'vehicle_networks';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  network: Networks;
  /** UID of the operations network to which the vehicle belongs. */
  network_id: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
  /** UID of the vehicle. */
  vehicle_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "vehicle_networks" */
export type Vehicle_Networks_Aggregate = {
  __typename?: 'vehicle_networks_aggregate';
  aggregate?: Maybe<Vehicle_Networks_Aggregate_Fields>;
  nodes: Array<Vehicle_Networks>;
};

/** aggregate fields of "vehicle_networks" */
export type Vehicle_Networks_Aggregate_Fields = {
  __typename?: 'vehicle_networks_aggregate_fields';
  avg?: Maybe<Vehicle_Networks_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Networks_Max_Fields>;
  min?: Maybe<Vehicle_Networks_Min_Fields>;
  stddev?: Maybe<Vehicle_Networks_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Networks_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Networks_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Networks_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Networks_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Networks_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Networks_Variance_Fields>;
};


/** aggregate fields of "vehicle_networks" */
export type Vehicle_Networks_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_networks" */
export type Vehicle_Networks_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Networks_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Networks_Max_Order_By>;
  min?: Maybe<Vehicle_Networks_Min_Order_By>;
  stddev?: Maybe<Vehicle_Networks_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Networks_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Networks_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Networks_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Networks_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Networks_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Networks_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_networks" */
export type Vehicle_Networks_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Networks_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Networks_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Networks_Avg_Fields = {
  __typename?: 'vehicle_networks_avg_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Avg_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_networks". All fields are combined with a logical 'AND'. */
export type Vehicle_Networks_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Networks_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Networks_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Networks_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  network?: Maybe<Networks_Bool_Exp>;
  network_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_networks" */
export enum Vehicle_Networks_Constraint {
  /** unique or primary key constraint */
  VehicleNetworksNetworkIdVehicleIdPk = 'vehicle_networks_network_id_vehicle_id_pk'
}

/** input type for incrementing integer column in table "vehicle_networks" */
export type Vehicle_Networks_Inc_Input = {
  network_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_networks" */
export type Vehicle_Networks_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  network?: Maybe<Networks_Obj_Rel_Insert_Input>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicle_Networks_Max_Fields = {
  __typename?: 'vehicle_networks_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Networks_Min_Fields = {
  __typename?: 'vehicle_networks_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_networks" */
export type Vehicle_Networks_Mutation_Response = {
  __typename?: 'vehicle_networks_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Networks>;
};

/** input type for inserting object relation for remote table "vehicle_networks" */
export type Vehicle_Networks_Obj_Rel_Insert_Input = {
  data: Vehicle_Networks_Insert_Input;
  on_conflict?: Maybe<Vehicle_Networks_On_Conflict>;
};

/** on conflict condition type for table "vehicle_networks" */
export type Vehicle_Networks_On_Conflict = {
  constraint: Vehicle_Networks_Constraint;
  update_columns: Array<Vehicle_Networks_Update_Column>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_networks" */
export type Vehicle_Networks_Order_By = {
  created_at?: Maybe<Order_By>;
  network?: Maybe<Networks_Order_By>;
  network_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_networks" */
export type Vehicle_Networks_Pk_Columns_Input = {
  /** UID of the operations network to which the vehicle belongs. */
  network_id: Scalars['Int'];
  /** UID of the vehicle. */
  vehicle_id: Scalars['Int'];
};

/** select columns of table "vehicle_networks" */
export enum Vehicle_Networks_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "vehicle_networks" */
export type Vehicle_Networks_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  network_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicle_Networks_Stddev_Fields = {
  __typename?: 'vehicle_networks_stddev_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Stddev_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Networks_Stddev_Pop_Fields = {
  __typename?: 'vehicle_networks_stddev_pop_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Stddev_Pop_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Networks_Stddev_Samp_Fields = {
  __typename?: 'vehicle_networks_stddev_samp_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Stddev_Samp_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Networks_Sum_Fields = {
  __typename?: 'vehicle_networks_sum_fields';
  network_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Sum_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "vehicle_networks" */
export enum Vehicle_Networks_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  NetworkId = 'network_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Vehicle_Networks_Var_Pop_Fields = {
  __typename?: 'vehicle_networks_var_pop_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Var_Pop_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Networks_Var_Samp_Fields = {
  __typename?: 'vehicle_networks_var_samp_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Var_Samp_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Networks_Variance_Fields = {
  __typename?: 'vehicle_networks_variance_fields';
  network_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_networks" */
export type Vehicle_Networks_Variance_Order_By = {
  network_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments = {
  __typename?: 'vehicle_pilot_assignments';
  /** Time at which the assignment was made */
  assigned_at: Scalars['timestamptz'];
  /** ID of the user who made the assignment */
  assigned_by_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** ID for the pilot vehicle assignment record */
  id: Scalars['Int'];
  /** An object relationship */
  pilot: Users;
  /** User ID of the pilot */
  pilot_id: Scalars['Int'];
  /** Denotes whether this pilot is primary for the associated aircraft */
  primary: Scalars['Boolean'];
  /** Time at which the assignment was cleared */
  unassigned_at?: Maybe<Scalars['timestamptz']>;
  /** ID of the user who cleared the assignment */
  unassigned_by_id?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
  /** ID of the vehicle */
  vehicle_id: Scalars['Int'];
  version: Scalars['Int'];
};

/** aggregated selection of "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Aggregate = {
  __typename?: 'vehicle_pilot_assignments_aggregate';
  aggregate?: Maybe<Vehicle_Pilot_Assignments_Aggregate_Fields>;
  nodes: Array<Vehicle_Pilot_Assignments>;
};

/** aggregate fields of "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Aggregate_Fields = {
  __typename?: 'vehicle_pilot_assignments_aggregate_fields';
  avg?: Maybe<Vehicle_Pilot_Assignments_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Pilot_Assignments_Max_Fields>;
  min?: Maybe<Vehicle_Pilot_Assignments_Min_Fields>;
  stddev?: Maybe<Vehicle_Pilot_Assignments_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Pilot_Assignments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Pilot_Assignments_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Pilot_Assignments_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Pilot_Assignments_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Pilot_Assignments_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Pilot_Assignments_Variance_Fields>;
};


/** aggregate fields of "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Pilot_Assignments_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Pilot_Assignments_Max_Order_By>;
  min?: Maybe<Vehicle_Pilot_Assignments_Min_Order_By>;
  stddev?: Maybe<Vehicle_Pilot_Assignments_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Pilot_Assignments_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Pilot_Assignments_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Pilot_Assignments_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Pilot_Assignments_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Pilot_Assignments_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Pilot_Assignments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Pilot_Assignments_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Pilot_Assignments_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Pilot_Assignments_Avg_Fields = {
  __typename?: 'vehicle_pilot_assignments_avg_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Avg_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_pilot_assignments". All fields are combined with a logical 'AND'. */
export type Vehicle_Pilot_Assignments_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Pilot_Assignments_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Pilot_Assignments_Bool_Exp>>>;
  assigned_at?: Maybe<Timestamptz_Comparison_Exp>;
  assigned_by_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  pilot?: Maybe<Users_Bool_Exp>;
  pilot_id?: Maybe<Int_Comparison_Exp>;
  primary?: Maybe<Boolean_Comparison_Exp>;
  unassigned_at?: Maybe<Timestamptz_Comparison_Exp>;
  unassigned_by_id?: Maybe<Int_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_pilot_assignments" */
export enum Vehicle_Pilot_Assignments_Constraint {
  /** unique or primary key constraint */
  VehiclePilotAssignmentsIdPk = 'vehicle_pilot_assignments_id_pk'
}

/** input type for incrementing integer column in table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Inc_Input = {
  assigned_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  unassigned_by_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Insert_Input = {
  assigned_at?: Maybe<Scalars['timestamptz']>;
  assigned_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  pilot?: Maybe<Users_Obj_Rel_Insert_Input>;
  pilot_id?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
  unassigned_at?: Maybe<Scalars['timestamptz']>;
  unassigned_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicle_Pilot_Assignments_Max_Fields = {
  __typename?: 'vehicle_pilot_assignments_max_fields';
  assigned_at?: Maybe<Scalars['timestamptz']>;
  assigned_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  unassigned_at?: Maybe<Scalars['timestamptz']>;
  unassigned_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Max_Order_By = {
  assigned_at?: Maybe<Order_By>;
  assigned_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_at?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Pilot_Assignments_Min_Fields = {
  __typename?: 'vehicle_pilot_assignments_min_fields';
  assigned_at?: Maybe<Scalars['timestamptz']>;
  assigned_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  unassigned_at?: Maybe<Scalars['timestamptz']>;
  unassigned_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Min_Order_By = {
  assigned_at?: Maybe<Order_By>;
  assigned_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_at?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Mutation_Response = {
  __typename?: 'vehicle_pilot_assignments_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Pilot_Assignments>;
};

/** input type for inserting object relation for remote table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Obj_Rel_Insert_Input = {
  data: Vehicle_Pilot_Assignments_Insert_Input;
  on_conflict?: Maybe<Vehicle_Pilot_Assignments_On_Conflict>;
};

/** on conflict condition type for table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_On_Conflict = {
  constraint: Vehicle_Pilot_Assignments_Constraint;
  update_columns: Array<Vehicle_Pilot_Assignments_Update_Column>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Order_By = {
  assigned_at?: Maybe<Order_By>;
  assigned_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot?: Maybe<Users_Order_By>;
  pilot_id?: Maybe<Order_By>;
  primary?: Maybe<Order_By>;
  unassigned_at?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Pk_Columns_Input = {
  /** ID for the pilot vehicle assignment record */
  id: Scalars['Int'];
};

/** select columns of table "vehicle_pilot_assignments" */
export enum Vehicle_Pilot_Assignments_Select_Column {
  /** column name */
  AssignedAt = 'assigned_at',
  /** column name */
  AssignedById = 'assigned_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PilotId = 'pilot_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  UnassignedAt = 'unassigned_at',
  /** column name */
  UnassignedById = 'unassigned_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Set_Input = {
  assigned_at?: Maybe<Scalars['timestamptz']>;
  assigned_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
  unassigned_at?: Maybe<Scalars['timestamptz']>;
  unassigned_by_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicle_Pilot_Assignments_Stddev_Fields = {
  __typename?: 'vehicle_pilot_assignments_stddev_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Stddev_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Pilot_Assignments_Stddev_Pop_Fields = {
  __typename?: 'vehicle_pilot_assignments_stddev_pop_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Stddev_Pop_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Pilot_Assignments_Stddev_Samp_Fields = {
  __typename?: 'vehicle_pilot_assignments_stddev_samp_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Stddev_Samp_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Pilot_Assignments_Sum_Fields = {
  __typename?: 'vehicle_pilot_assignments_sum_fields';
  assigned_by_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pilot_id?: Maybe<Scalars['Int']>;
  unassigned_by_id?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Sum_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "vehicle_pilot_assignments" */
export enum Vehicle_Pilot_Assignments_Update_Column {
  /** column name */
  AssignedAt = 'assigned_at',
  /** column name */
  AssignedById = 'assigned_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PilotId = 'pilot_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  UnassignedAt = 'unassigned_at',
  /** column name */
  UnassignedById = 'unassigned_by_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Vehicle_Pilot_Assignments_Var_Pop_Fields = {
  __typename?: 'vehicle_pilot_assignments_var_pop_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Var_Pop_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Pilot_Assignments_Var_Samp_Fields = {
  __typename?: 'vehicle_pilot_assignments_var_samp_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Var_Samp_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Pilot_Assignments_Variance_Fields = {
  __typename?: 'vehicle_pilot_assignments_variance_fields';
  assigned_by_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  pilot_id?: Maybe<Scalars['Float']>;
  unassigned_by_id?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_pilot_assignments" */
export type Vehicle_Pilot_Assignments_Variance_Order_By = {
  assigned_by_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  pilot_id?: Maybe<Order_By>;
  unassigned_by_id?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys = {
  __typename?: 'vehicle_priority_event_keys';
  created_at: Scalars['timestamptz'];
  /** Criterion data */
  criterion?: Maybe<Scalars['jsonb']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  /** Human readable description, may be used for client representation */
  description?: Maybe<Scalars['String']>;
  /** Unique event string representation */
  event_key: Scalars['String'];
  /** Type of event */
  event_type: Scalars['String'];
  /** An array relationship */
  events: Array<Vehicle_Priority_Events>;
  /** An aggregated array relationship */
  events_aggregate: Vehicle_Priority_Events_Aggregate;
  /** Indication of event importance, 0 being the most important */
  rank: Scalars['Int'];
  /** Priority Event Severity Level */
  severity?: Maybe<Scalars['String']>;
  /** Human readable title, may be used for client representation */
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_KeysCriterionArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_KeysEventsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/** columns and relationships of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_KeysEvents_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};

/** aggregated selection of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Aggregate = {
  __typename?: 'vehicle_priority_event_keys_aggregate';
  aggregate?: Maybe<Vehicle_Priority_Event_Keys_Aggregate_Fields>;
  nodes: Array<Vehicle_Priority_Event_Keys>;
};

/** aggregate fields of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Aggregate_Fields = {
  __typename?: 'vehicle_priority_event_keys_aggregate_fields';
  avg?: Maybe<Vehicle_Priority_Event_Keys_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Priority_Event_Keys_Max_Fields>;
  min?: Maybe<Vehicle_Priority_Event_Keys_Min_Fields>;
  stddev?: Maybe<Vehicle_Priority_Event_Keys_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Priority_Event_Keys_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Priority_Event_Keys_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Priority_Event_Keys_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Priority_Event_Keys_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Priority_Event_Keys_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Priority_Event_Keys_Variance_Fields>;
};


/** aggregate fields of "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Priority_Event_Keys_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Priority_Event_Keys_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Priority_Event_Keys_Max_Order_By>;
  min?: Maybe<Vehicle_Priority_Event_Keys_Min_Order_By>;
  stddev?: Maybe<Vehicle_Priority_Event_Keys_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Priority_Event_Keys_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Priority_Event_Keys_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Priority_Event_Keys_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Priority_Event_Keys_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Priority_Event_Keys_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Priority_Event_Keys_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Vehicle_Priority_Event_Keys_Append_Input = {
  criterion?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Priority_Event_Keys_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Priority_Event_Keys_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Priority_Event_Keys_Avg_Fields = {
  __typename?: 'vehicle_priority_event_keys_avg_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Avg_Order_By = {
  rank?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_priority_event_keys". All fields are combined with a logical 'AND'. */
export type Vehicle_Priority_Event_Keys_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>>>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  criterion?: Maybe<Jsonb_Comparison_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  description?: Maybe<String_Comparison_Exp>;
  event_key?: Maybe<String_Comparison_Exp>;
  event_type?: Maybe<String_Comparison_Exp>;
  events?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
  rank?: Maybe<Int_Comparison_Exp>;
  severity?: Maybe<String_Comparison_Exp>;
  title?: Maybe<String_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_priority_event_keys" */
export enum Vehicle_Priority_Event_Keys_Constraint {
  /** unique or primary key constraint */
  VehiclePriorityEventKeysPkey = 'vehicle_priority_event_keys_pkey',
  /** unique or primary key constraint */
  VehiclePriorityEventKeysRankKey = 'vehicle_priority_event_keys_rank_key',
  /** unique or primary key constraint */
  VehiclePriorityEventKeysTitleKey = 'vehicle_priority_event_keys_title_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Vehicle_Priority_Event_Keys_Delete_At_Path_Input = {
  criterion?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Vehicle_Priority_Event_Keys_Delete_Elem_Input = {
  criterion?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Vehicle_Priority_Event_Keys_Delete_Key_Input = {
  criterion?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Inc_Input = {
  rank?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion?: Maybe<Scalars['jsonb']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_key?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  events?: Maybe<Vehicle_Priority_Events_Arr_Rel_Insert_Input>;
  rank?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Vehicle_Priority_Event_Keys_Max_Fields = {
  __typename?: 'vehicle_priority_event_keys_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_key?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Max_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  event_key?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  rank?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Priority_Event_Keys_Min_Fields = {
  __typename?: 'vehicle_priority_event_keys_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_key?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Min_Order_By = {
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  event_key?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  rank?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Mutation_Response = {
  __typename?: 'vehicle_priority_event_keys_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Priority_Event_Keys>;
};

/** input type for inserting object relation for remote table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Obj_Rel_Insert_Input = {
  data: Vehicle_Priority_Event_Keys_Insert_Input;
  on_conflict?: Maybe<Vehicle_Priority_Event_Keys_On_Conflict>;
};

/** on conflict condition type for table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_On_Conflict = {
  constraint: Vehicle_Priority_Event_Keys_Constraint;
  update_columns: Array<Vehicle_Priority_Event_Keys_Update_Column>;
  where?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Order_By = {
  created_at?: Maybe<Order_By>;
  criterion?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  description?: Maybe<Order_By>;
  event_key?: Maybe<Order_By>;
  event_type?: Maybe<Order_By>;
  events_aggregate?: Maybe<Vehicle_Priority_Events_Aggregate_Order_By>;
  rank?: Maybe<Order_By>;
  severity?: Maybe<Order_By>;
  title?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Pk_Columns_Input = {
  /** Unique event string representation */
  event_key: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Vehicle_Priority_Event_Keys_Prepend_Input = {
  criterion?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "vehicle_priority_event_keys" */
export enum Vehicle_Priority_Event_Keys_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criterion = 'criterion',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventKey = 'event_key',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Rank = 'rank',
  /** column name */
  Severity = 'severity',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  criterion?: Maybe<Scalars['jsonb']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  event_key?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  severity?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Vehicle_Priority_Event_Keys_Stddev_Fields = {
  __typename?: 'vehicle_priority_event_keys_stddev_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Stddev_Order_By = {
  rank?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Priority_Event_Keys_Stddev_Pop_Fields = {
  __typename?: 'vehicle_priority_event_keys_stddev_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Stddev_Pop_Order_By = {
  rank?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Priority_Event_Keys_Stddev_Samp_Fields = {
  __typename?: 'vehicle_priority_event_keys_stddev_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Stddev_Samp_Order_By = {
  rank?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Priority_Event_Keys_Sum_Fields = {
  __typename?: 'vehicle_priority_event_keys_sum_fields';
  rank?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Sum_Order_By = {
  rank?: Maybe<Order_By>;
};

/** update columns of table "vehicle_priority_event_keys" */
export enum Vehicle_Priority_Event_Keys_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Criterion = 'criterion',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Description = 'description',
  /** column name */
  EventKey = 'event_key',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Rank = 'rank',
  /** column name */
  Severity = 'severity',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Vehicle_Priority_Event_Keys_Var_Pop_Fields = {
  __typename?: 'vehicle_priority_event_keys_var_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Var_Pop_Order_By = {
  rank?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Priority_Event_Keys_Var_Samp_Fields = {
  __typename?: 'vehicle_priority_event_keys_var_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Var_Samp_Order_By = {
  rank?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Priority_Event_Keys_Variance_Fields = {
  __typename?: 'vehicle_priority_event_keys_variance_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_priority_event_keys" */
export type Vehicle_Priority_Event_Keys_Variance_Order_By = {
  rank?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_priority_events" */
export type Vehicle_Priority_Events = {
  __typename?: 'vehicle_priority_events';
  /** Time of acknowlegment */
  acknowledged_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  acknowledged_by?: Maybe<Users>;
  /** User acknowledged the event */
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamptz'];
  /** Event identifier */
  event: Scalars['String'];
  /** An object relationship */
  event_details: Vehicle_Priority_Event_Keys;
  /** An object relationship */
  flight_plan: Flight_Plans;
  /** Flight plan for priority event */
  flight_plan_id: Scalars['Int'];
  /** An object relationship */
  flight_status?: Maybe<Vehicle_Flight_Statuses>;
  id: Scalars['Int'];
  /** Free text description of the event */
  message: Scalars['String'];
  /** Number of occurrences of the event before being acknowledged. */
  occurrence_count?: Maybe<Scalars['Int']>;
  /** Free JSON blub that can be used to store additional metadata */
  reference_data?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  vehicle: Vehicles;
  /** Vehicle which has triggered event */
  vehicle_id: Scalars['Int'];
};


/** columns and relationships of "vehicle_priority_events" */
export type Vehicle_Priority_EventsReference_DataArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "vehicle_priority_events" */
export type Vehicle_Priority_Events_Aggregate = {
  __typename?: 'vehicle_priority_events_aggregate';
  aggregate?: Maybe<Vehicle_Priority_Events_Aggregate_Fields>;
  nodes: Array<Vehicle_Priority_Events>;
};

/** aggregate fields of "vehicle_priority_events" */
export type Vehicle_Priority_Events_Aggregate_Fields = {
  __typename?: 'vehicle_priority_events_aggregate_fields';
  avg?: Maybe<Vehicle_Priority_Events_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Priority_Events_Max_Fields>;
  min?: Maybe<Vehicle_Priority_Events_Min_Fields>;
  stddev?: Maybe<Vehicle_Priority_Events_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Priority_Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Priority_Events_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Priority_Events_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Priority_Events_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Priority_Events_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Priority_Events_Variance_Fields>;
};


/** aggregate fields of "vehicle_priority_events" */
export type Vehicle_Priority_Events_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Priority_Events_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Priority_Events_Max_Order_By>;
  min?: Maybe<Vehicle_Priority_Events_Min_Order_By>;
  stddev?: Maybe<Vehicle_Priority_Events_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Priority_Events_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Priority_Events_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Priority_Events_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Priority_Events_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Priority_Events_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Priority_Events_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Vehicle_Priority_Events_Append_Input = {
  reference_data?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Priority_Events_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Priority_Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Priority_Events_Avg_Fields = {
  __typename?: 'vehicle_priority_events_avg_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Avg_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_priority_events". All fields are combined with a logical 'AND'. */
export type Vehicle_Priority_Events_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Priority_Events_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Priority_Events_Bool_Exp>>>;
  acknowledged_at?: Maybe<Timestamptz_Comparison_Exp>;
  acknowledged_by?: Maybe<Users_Bool_Exp>;
  acknowledged_by_id?: Maybe<Int_Comparison_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  event?: Maybe<String_Comparison_Exp>;
  event_details?: Maybe<Vehicle_Priority_Event_Keys_Bool_Exp>;
  flight_plan?: Maybe<Flight_Plans_Bool_Exp>;
  flight_plan_id?: Maybe<Int_Comparison_Exp>;
  flight_status?: Maybe<Vehicle_Flight_Statuses_Bool_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  message?: Maybe<String_Comparison_Exp>;
  occurrence_count?: Maybe<Int_Comparison_Exp>;
  reference_data?: Maybe<Jsonb_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  vehicle?: Maybe<Vehicles_Bool_Exp>;
  vehicle_id?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_priority_events" */
export enum Vehicle_Priority_Events_Constraint {
  /** unique or primary key constraint */
  VehiclePriorityEventsPkey = 'vehicle_priority_events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Vehicle_Priority_Events_Delete_At_Path_Input = {
  reference_data?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Vehicle_Priority_Events_Delete_Elem_Input = {
  reference_data?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Vehicle_Priority_Events_Delete_Key_Input = {
  reference_data?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Inc_Input = {
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  occurrence_count?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Insert_Input = {
  acknowledged_at?: Maybe<Scalars['timestamptz']>;
  acknowledged_by?: Maybe<Users_Obj_Rel_Insert_Input>;
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  event_details?: Maybe<Vehicle_Priority_Event_Keys_Obj_Rel_Insert_Input>;
  flight_plan?: Maybe<Flight_Plans_Obj_Rel_Insert_Input>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  flight_status?: Maybe<Vehicle_Flight_Statuses_Obj_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  occurrence_count?: Maybe<Scalars['Int']>;
  reference_data?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle?: Maybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicle_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicle_Priority_Events_Max_Fields = {
  __typename?: 'vehicle_priority_events_max_fields';
  acknowledged_at?: Maybe<Scalars['timestamptz']>;
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  occurrence_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Max_Order_By = {
  acknowledged_at?: Maybe<Order_By>;
  acknowledged_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Priority_Events_Min_Fields = {
  __typename?: 'vehicle_priority_events_min_fields';
  acknowledged_at?: Maybe<Scalars['timestamptz']>;
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  occurrence_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Min_Order_By = {
  acknowledged_at?: Maybe<Order_By>;
  acknowledged_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Mutation_Response = {
  __typename?: 'vehicle_priority_events_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Priority_Events>;
};

/** input type for inserting object relation for remote table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Obj_Rel_Insert_Input = {
  data: Vehicle_Priority_Events_Insert_Input;
  on_conflict?: Maybe<Vehicle_Priority_Events_On_Conflict>;
};

/** on conflict condition type for table "vehicle_priority_events" */
export type Vehicle_Priority_Events_On_Conflict = {
  constraint: Vehicle_Priority_Events_Constraint;
  update_columns: Array<Vehicle_Priority_Events_Update_Column>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_priority_events" */
export type Vehicle_Priority_Events_Order_By = {
  acknowledged_at?: Maybe<Order_By>;
  acknowledged_by?: Maybe<Users_Order_By>;
  acknowledged_by_id?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  event?: Maybe<Order_By>;
  event_details?: Maybe<Vehicle_Priority_Event_Keys_Order_By>;
  flight_plan?: Maybe<Flight_Plans_Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  flight_status?: Maybe<Vehicle_Flight_Statuses_Order_By>;
  id?: Maybe<Order_By>;
  message?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  reference_data?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  vehicle?: Maybe<Vehicles_Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_priority_events" */
export type Vehicle_Priority_Events_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Vehicle_Priority_Events_Prepend_Input = {
  reference_data?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "vehicle_priority_events" */
export enum Vehicle_Priority_Events_Select_Column {
  /** column name */
  AcknowledgedAt = 'acknowledged_at',
  /** column name */
  AcknowledgedById = 'acknowledged_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Event = 'event',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  OccurrenceCount = 'occurrence_count',
  /** column name */
  ReferenceData = 'reference_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** input type for updating data in table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Set_Input = {
  acknowledged_at?: Maybe<Scalars['timestamptz']>;
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event?: Maybe<Scalars['String']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  occurrence_count?: Maybe<Scalars['Int']>;
  reference_data?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vehicle_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicle_Priority_Events_Stddev_Fields = {
  __typename?: 'vehicle_priority_events_stddev_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Stddev_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Priority_Events_Stddev_Pop_Fields = {
  __typename?: 'vehicle_priority_events_stddev_pop_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Stddev_Pop_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Priority_Events_Stddev_Samp_Fields = {
  __typename?: 'vehicle_priority_events_stddev_samp_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Stddev_Samp_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Priority_Events_Sum_Fields = {
  __typename?: 'vehicle_priority_events_sum_fields';
  acknowledged_by_id?: Maybe<Scalars['Int']>;
  flight_plan_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  occurrence_count?: Maybe<Scalars['Int']>;
  vehicle_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Sum_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** update columns of table "vehicle_priority_events" */
export enum Vehicle_Priority_Events_Update_Column {
  /** column name */
  AcknowledgedAt = 'acknowledged_at',
  /** column name */
  AcknowledgedById = 'acknowledged_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Event = 'event',
  /** column name */
  FlightPlanId = 'flight_plan_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  OccurrenceCount = 'occurrence_count',
  /** column name */
  ReferenceData = 'reference_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehicleId = 'vehicle_id'
}

/** aggregate var_pop on columns */
export type Vehicle_Priority_Events_Var_Pop_Fields = {
  __typename?: 'vehicle_priority_events_var_pop_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Var_Pop_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Priority_Events_Var_Samp_Fields = {
  __typename?: 'vehicle_priority_events_var_samp_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Var_Samp_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Priority_Events_Variance_Fields = {
  __typename?: 'vehicle_priority_events_variance_fields';
  acknowledged_by_id?: Maybe<Scalars['Float']>;
  flight_plan_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  occurrence_count?: Maybe<Scalars['Float']>;
  vehicle_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_priority_events" */
export type Vehicle_Priority_Events_Variance_Order_By = {
  acknowledged_by_id?: Maybe<Order_By>;
  flight_plan_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  occurrence_count?: Maybe<Order_By>;
  vehicle_id?: Maybe<Order_By>;
};

/** columns and relationships of "vehicle_status_updates" */
export type Vehicle_Status_Updates = {
  __typename?: 'vehicle_status_updates';
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
  updated_estimated_soc: Scalars['float8'];
};

/** aggregated selection of "vehicle_status_updates" */
export type Vehicle_Status_Updates_Aggregate = {
  __typename?: 'vehicle_status_updates_aggregate';
  aggregate?: Maybe<Vehicle_Status_Updates_Aggregate_Fields>;
  nodes: Array<Vehicle_Status_Updates>;
};

/** aggregate fields of "vehicle_status_updates" */
export type Vehicle_Status_Updates_Aggregate_Fields = {
  __typename?: 'vehicle_status_updates_aggregate_fields';
  avg?: Maybe<Vehicle_Status_Updates_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicle_Status_Updates_Max_Fields>;
  min?: Maybe<Vehicle_Status_Updates_Min_Fields>;
  stddev?: Maybe<Vehicle_Status_Updates_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicle_Status_Updates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicle_Status_Updates_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicle_Status_Updates_Sum_Fields>;
  var_pop?: Maybe<Vehicle_Status_Updates_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicle_Status_Updates_Var_Samp_Fields>;
  variance?: Maybe<Vehicle_Status_Updates_Variance_Fields>;
};


/** aggregate fields of "vehicle_status_updates" */
export type Vehicle_Status_Updates_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicle_Status_Updates_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Aggregate_Order_By = {
  avg?: Maybe<Vehicle_Status_Updates_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicle_Status_Updates_Max_Order_By>;
  min?: Maybe<Vehicle_Status_Updates_Min_Order_By>;
  stddev?: Maybe<Vehicle_Status_Updates_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicle_Status_Updates_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicle_Status_Updates_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicle_Status_Updates_Sum_Order_By>;
  var_pop?: Maybe<Vehicle_Status_Updates_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicle_Status_Updates_Var_Samp_Order_By>;
  variance?: Maybe<Vehicle_Status_Updates_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Arr_Rel_Insert_Input = {
  data: Array<Vehicle_Status_Updates_Insert_Input>;
  on_conflict?: Maybe<Vehicle_Status_Updates_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicle_Status_Updates_Avg_Fields = {
  __typename?: 'vehicle_status_updates_avg_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Avg_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicle_status_updates". All fields are combined with a logical 'AND'. */
export type Vehicle_Status_Updates_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicle_Status_Updates_Bool_Exp>>>;
  _not?: Maybe<Vehicle_Status_Updates_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicle_Status_Updates_Bool_Exp>>>;
  timestamp_secs?: Maybe<Float8_Comparison_Exp>;
  topic?: Maybe<String_Comparison_Exp>;
  updated_estimated_soc?: Maybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicle_status_updates" */
export enum Vehicle_Status_Updates_Constraint {
  /** unique or primary key constraint */
  VehicleStatusUpdatesPkey = 'vehicle_status_updates_pkey'
}

/** input type for incrementing integer column in table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Inc_Input = {
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_estimated_soc?: Maybe<Scalars['float8']>;
};

/** input type for inserting data into table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Insert_Input = {
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_estimated_soc?: Maybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Vehicle_Status_Updates_Max_Fields = {
  __typename?: 'vehicle_status_updates_max_fields';
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_estimated_soc?: Maybe<Scalars['float8']>;
};

/** order by max() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Max_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicle_Status_Updates_Min_Fields = {
  __typename?: 'vehicle_status_updates_min_fields';
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_estimated_soc?: Maybe<Scalars['float8']>;
};

/** order by min() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Min_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Mutation_Response = {
  __typename?: 'vehicle_status_updates_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicle_Status_Updates>;
};

/** input type for inserting object relation for remote table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Obj_Rel_Insert_Input = {
  data: Vehicle_Status_Updates_Insert_Input;
  on_conflict?: Maybe<Vehicle_Status_Updates_On_Conflict>;
};

/** on conflict condition type for table "vehicle_status_updates" */
export type Vehicle_Status_Updates_On_Conflict = {
  constraint: Vehicle_Status_Updates_Constraint;
  update_columns: Array<Vehicle_Status_Updates_Update_Column>;
  where?: Maybe<Vehicle_Status_Updates_Bool_Exp>;
};

/** ordering options when selecting data from "vehicle_status_updates" */
export type Vehicle_Status_Updates_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  topic?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicle_status_updates" */
export type Vehicle_Status_Updates_Pk_Columns_Input = {
  timestamp_secs: Scalars['float8'];
  topic: Scalars['String'];
};

/** select columns of table "vehicle_status_updates" */
export enum Vehicle_Status_Updates_Select_Column {
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedEstimatedSoc = 'updated_estimated_soc'
}

/** input type for updating data in table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Set_Input = {
  timestamp_secs?: Maybe<Scalars['float8']>;
  topic?: Maybe<Scalars['String']>;
  updated_estimated_soc?: Maybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type Vehicle_Status_Updates_Stddev_Fields = {
  __typename?: 'vehicle_status_updates_stddev_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Stddev_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicle_Status_Updates_Stddev_Pop_Fields = {
  __typename?: 'vehicle_status_updates_stddev_pop_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Stddev_Pop_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicle_Status_Updates_Stddev_Samp_Fields = {
  __typename?: 'vehicle_status_updates_stddev_samp_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Stddev_Samp_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicle_Status_Updates_Sum_Fields = {
  __typename?: 'vehicle_status_updates_sum_fields';
  timestamp_secs?: Maybe<Scalars['float8']>;
  updated_estimated_soc?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Sum_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** update columns of table "vehicle_status_updates" */
export enum Vehicle_Status_Updates_Update_Column {
  /** column name */
  TimestampSecs = 'timestamp_secs',
  /** column name */
  Topic = 'topic',
  /** column name */
  UpdatedEstimatedSoc = 'updated_estimated_soc'
}

/** aggregate var_pop on columns */
export type Vehicle_Status_Updates_Var_Pop_Fields = {
  __typename?: 'vehicle_status_updates_var_pop_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Var_Pop_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicle_Status_Updates_Var_Samp_Fields = {
  __typename?: 'vehicle_status_updates_var_samp_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Var_Samp_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicle_Status_Updates_Variance_Fields = {
  __typename?: 'vehicle_status_updates_variance_fields';
  timestamp_secs?: Maybe<Scalars['Float']>;
  updated_estimated_soc?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicle_status_updates" */
export type Vehicle_Status_Updates_Variance_Order_By = {
  timestamp_secs?: Maybe<Order_By>;
  updated_estimated_soc?: Maybe<Order_By>;
};

/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type Vehicles = {
  __typename?: 'vehicles';
  activated?: Maybe<Scalars['Boolean']>;
  airworthiness_category: Vehicle_Airworthiness_Categories_Enum;
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  /** An array relationship */
  contingency_landing_spots: Array<Contingency_Landing_Spots>;
  /** An aggregated array relationship */
  contingency_landing_spots_aggregate: Contingency_Landing_Spots_Aggregate;
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  daa_observations: Array<Daa_Observations>;
  /** An aggregated array relationship */
  daa_observations_aggregate: Daa_Observations_Aggregate;
  /** An object relationship */
  daa_status?: Maybe<Daa_Statuses>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  faa_n_number?: Maybe<Scalars['String']>;
  faa_registration_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  file_assets: Array<File_Assets>;
  /** An aggregated array relationship */
  file_assets_aggregate: File_Assets_Aggregate;
  /** An array relationship */
  flight_commands: Array<Flight_Commands>;
  /** An aggregated array relationship */
  flight_commands_aggregate: Flight_Commands_Aggregate;
  /** An array relationship */
  flight_plans: Array<Flight_Plans>;
  /** An aggregated array relationship */
  flight_plans_aggregate: Flight_Plans_Aggregate;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  /** An array relationship */
  ground_assets: Array<Ground_Assets>;
  /** An aggregated array relationship */
  ground_assets_aggregate: Ground_Assets_Aggregate;
  /** An array relationship */
  historical_serialized_vehicle_statuses: Array<Historical_Serialized_Vehicle_Statuses>;
  /** An aggregated array relationship */
  historical_serialized_vehicle_statuses_aggregate: Historical_Serialized_Vehicle_Statuses_Aggregate;
  icao_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_connected?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  landing_requests: Array<Landing_Requests>;
  /** An aggregated array relationship */
  landing_requests_aggregate: Landing_Requests_Aggregate;
  /** An object relationship */
  last_vehicle_anomaly_status?: Maybe<Last_Vehicle_Anomaly_Statuses>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_parameters?: Maybe<Scalars['jsonb']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  pickup_requests: Array<Pickup_Requests>;
  /** An aggregated array relationship */
  pickup_requests_aggregate: Pickup_Requests_Aggregate;
  /** An array relationship */
  raw_alerts: Array<Vehicle_Alerts>;
  /** An aggregated array relationship */
  raw_alerts_aggregate: Vehicle_Alerts_Aggregate;
  /** Serial number of the vehicle. */
  serial_number?: Maybe<Scalars['String']>;
  store_telemetry?: Maybe<Scalars['Boolean']>;
  sui_id?: Maybe<Scalars['String']>;
  tenant_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  uwb_version?: Maybe<Scalars['String']>;
  /** An object relationship */
  vehicle_model?: Maybe<Vehicle_Models>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  vehicle_networks: Array<Vehicle_Networks>;
  /** An aggregated array relationship */
  vehicle_networks_aggregate: Vehicle_Networks_Aggregate;
  /** An array relationship */
  vehicle_pilot_assignments: Array<Vehicle_Pilot_Assignments>;
  /** An aggregated array relationship */
  vehicle_pilot_assignments_aggregate: Vehicle_Pilot_Assignments_Aggregate;
  /** An array relationship */
  vehicle_priority_events: Array<Vehicle_Priority_Events>;
  /** An aggregated array relationship */
  vehicle_priority_events_aggregate: Vehicle_Priority_Events_Aggregate;
  /** An array relationship */
  vehicle_statuses: Array<Kafka_Serialized_Vehicle_Statuses>;
  /** An aggregated array relationship */
  vehicle_statuses_aggregate: Kafka_Serialized_Vehicle_Statuses_Aggregate;
  version: Scalars['Int'];
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesContingency_Landing_SpotsArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesContingency_Landing_Spots_AggregateArgs = {
  distinct_on?: Maybe<Array<Contingency_Landing_Spots_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Contingency_Landing_Spots_Order_By>>;
  where?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesDaa_ObservationsArgs = {
  distinct_on?: Maybe<Array<Daa_Observations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Observations_Order_By>>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesDaa_Observations_AggregateArgs = {
  distinct_on?: Maybe<Array<Daa_Observations_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Daa_Observations_Order_By>>;
  where?: Maybe<Daa_Observations_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesFile_AssetsArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesFile_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<File_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<File_Assets_Order_By>>;
  where?: Maybe<File_Assets_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesFlight_CommandsArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesFlight_Commands_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Commands_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Commands_Order_By>>;
  where?: Maybe<Flight_Commands_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesFlight_PlansArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesFlight_Plans_AggregateArgs = {
  distinct_on?: Maybe<Array<Flight_Plans_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Flight_Plans_Order_By>>;
  where?: Maybe<Flight_Plans_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesGround_AssetsArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesGround_Assets_AggregateArgs = {
  distinct_on?: Maybe<Array<Ground_Assets_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Ground_Assets_Order_By>>;
  where?: Maybe<Ground_Assets_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesHistorical_Serialized_Vehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesHistorical_Serialized_Vehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Historical_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesLanding_RequestsArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesLanding_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Landing_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Landing_Requests_Order_By>>;
  where?: Maybe<Landing_Requests_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesMavnet_ParametersArgs = {
  path?: Maybe<Scalars['String']>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesParametersArgs = {
  path?: Maybe<Scalars['String']>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesPickup_RequestsArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesPickup_Requests_AggregateArgs = {
  distinct_on?: Maybe<Array<Pickup_Requests_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Pickup_Requests_Order_By>>;
  where?: Maybe<Pickup_Requests_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesRaw_AlertsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesRaw_Alerts_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Alerts_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Alerts_Order_By>>;
  where?: Maybe<Vehicle_Alerts_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_NetworksArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_Networks_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Networks_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Networks_Order_By>>;
  where?: Maybe<Vehicle_Networks_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_Pilot_AssignmentsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Pilot_Assignments_Order_By>>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_Pilot_Assignments_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Pilot_Assignments_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Pilot_Assignments_Order_By>>;
  where?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_Priority_EventsArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_Priority_Events_AggregateArgs = {
  distinct_on?: Maybe<Array<Vehicle_Priority_Events_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Vehicle_Priority_Events_Order_By>>;
  where?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_StatusesArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};


/**
 * Table containing the list of vehicles that are usable in the Matternet ecosystem.
 *
 *
 * columns and relationships of "vehicles"
 */
export type VehiclesVehicle_Statuses_AggregateArgs = {
  distinct_on?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Select_Column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<Kafka_Serialized_Vehicle_Statuses_Order_By>>;
  where?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
};

/** aggregated selection of "vehicles" */
export type Vehicles_Aggregate = {
  __typename?: 'vehicles_aggregate';
  aggregate?: Maybe<Vehicles_Aggregate_Fields>;
  nodes: Array<Vehicles>;
};

/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_Fields = {
  __typename?: 'vehicles_aggregate_fields';
  avg?: Maybe<Vehicles_Avg_Fields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Vehicles_Max_Fields>;
  min?: Maybe<Vehicles_Min_Fields>;
  stddev?: Maybe<Vehicles_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicles_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicles_Sum_Fields>;
  var_pop?: Maybe<Vehicles_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicles_Var_Samp_Fields>;
  variance?: Maybe<Vehicles_Variance_Fields>;
};


/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_FieldsCountArgs = {
  columns?: Maybe<Array<Vehicles_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vehicles" */
export type Vehicles_Aggregate_Order_By = {
  avg?: Maybe<Vehicles_Avg_Order_By>;
  count?: Maybe<Order_By>;
  max?: Maybe<Vehicles_Max_Order_By>;
  min?: Maybe<Vehicles_Min_Order_By>;
  stddev?: Maybe<Vehicles_Stddev_Order_By>;
  stddev_pop?: Maybe<Vehicles_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<Vehicles_Stddev_Samp_Order_By>;
  sum?: Maybe<Vehicles_Sum_Order_By>;
  var_pop?: Maybe<Vehicles_Var_Pop_Order_By>;
  var_samp?: Maybe<Vehicles_Var_Samp_Order_By>;
  variance?: Maybe<Vehicles_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Vehicles_Append_Input = {
  mavnet_parameters?: Maybe<Scalars['jsonb']>;
  parameters?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "vehicles" */
export type Vehicles_Arr_Rel_Insert_Input = {
  data: Array<Vehicles_Insert_Input>;
  on_conflict?: Maybe<Vehicles_On_Conflict>;
};

/** aggregate avg on columns */
export type Vehicles_Avg_Fields = {
  __typename?: 'vehicles_avg_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vehicles" */
export type Vehicles_Avg_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vehicles". All fields are combined with a logical 'AND'. */
export type Vehicles_Bool_Exp = {
  _and?: Maybe<Array<Maybe<Vehicles_Bool_Exp>>>;
  _not?: Maybe<Vehicles_Bool_Exp>;
  _or?: Maybe<Array<Maybe<Vehicles_Bool_Exp>>>;
  activated?: Maybe<Boolean_Comparison_Exp>;
  airworthiness_category?: Maybe<Vehicle_Airworthiness_Categories_Enum_Comparison_Exp>;
  ardupilot_version?: Maybe<String_Comparison_Exp>;
  bmu2_version?: Maybe<String_Comparison_Exp>;
  bmu_version?: Maybe<String_Comparison_Exp>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Bool_Exp>;
  created_at?: Maybe<Timestamptz_Comparison_Exp>;
  daa_observations?: Maybe<Daa_Observations_Bool_Exp>;
  daa_status?: Maybe<Daa_Statuses_Bool_Exp>;
  deleted_at?: Maybe<Timestamptz_Comparison_Exp>;
  faa_n_number?: Maybe<String_Comparison_Exp>;
  faa_registration_id?: Maybe<String_Comparison_Exp>;
  file_assets?: Maybe<File_Assets_Bool_Exp>;
  flight_commands?: Maybe<Flight_Commands_Bool_Exp>;
  flight_plans?: Maybe<Flight_Plans_Bool_Exp>;
  fpga_version?: Maybe<String_Comparison_Exp>;
  fts_version?: Maybe<String_Comparison_Exp>;
  gps1_version?: Maybe<String_Comparison_Exp>;
  gps2_version?: Maybe<String_Comparison_Exp>;
  ground_assets?: Maybe<Ground_Assets_Bool_Exp>;
  historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Bool_Exp>;
  icao_id?: Maybe<String_Comparison_Exp>;
  id?: Maybe<Int_Comparison_Exp>;
  is_connected?: Maybe<Boolean_Comparison_Exp>;
  landing_requests?: Maybe<Landing_Requests_Bool_Exp>;
  last_vehicle_anomaly_status?: Maybe<Last_Vehicle_Anomaly_Statuses_Bool_Exp>;
  lidar_version?: Maybe<String_Comparison_Exp>;
  mavnet_parameters?: Maybe<Jsonb_Comparison_Exp>;
  mavnet_version?: Maybe<String_Comparison_Exp>;
  mongo_id?: Maybe<String_Comparison_Exp>;
  mttr_serial_number?: Maybe<String_Comparison_Exp>;
  name?: Maybe<String_Comparison_Exp>;
  parameters?: Maybe<Jsonb_Comparison_Exp>;
  pickup_requests?: Maybe<Pickup_Requests_Bool_Exp>;
  raw_alerts?: Maybe<Vehicle_Alerts_Bool_Exp>;
  serial_number?: Maybe<String_Comparison_Exp>;
  store_telemetry?: Maybe<Boolean_Comparison_Exp>;
  sui_id?: Maybe<String_Comparison_Exp>;
  tenant_id?: Maybe<Uuid_Comparison_Exp>;
  updated_at?: Maybe<Timestamptz_Comparison_Exp>;
  uwb_version?: Maybe<String_Comparison_Exp>;
  vehicle_model?: Maybe<Vehicle_Models_Bool_Exp>;
  vehicle_model_id?: Maybe<Int_Comparison_Exp>;
  vehicle_networks?: Maybe<Vehicle_Networks_Bool_Exp>;
  vehicle_pilot_assignments?: Maybe<Vehicle_Pilot_Assignments_Bool_Exp>;
  vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Bool_Exp>;
  vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Bool_Exp>;
  version?: Maybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicles" */
export enum Vehicles_Constraint {
  /** unique or primary key constraint */
  VehiclesMongoIdKey = 'vehicles_mongo_id_key',
  /** unique or primary key constraint */
  VehiclesPkey = 'vehicles_pkey',
  /** unique or primary key constraint */
  VehiclesSerialNumberKey = 'vehicles_serial_number_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Vehicles_Delete_At_Path_Input = {
  mavnet_parameters?: Maybe<Array<Maybe<Scalars['String']>>>;
  parameters?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Vehicles_Delete_Elem_Input = {
  mavnet_parameters?: Maybe<Scalars['Int']>;
  parameters?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Vehicles_Delete_Key_Input = {
  mavnet_parameters?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "vehicles" */
export type Vehicles_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "vehicles" */
export type Vehicles_Insert_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  airworthiness_category?: Maybe<Vehicle_Airworthiness_Categories_Enum>;
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  contingency_landing_spots?: Maybe<Contingency_Landing_Spots_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  daa_observations?: Maybe<Daa_Observations_Arr_Rel_Insert_Input>;
  daa_status?: Maybe<Daa_Statuses_Obj_Rel_Insert_Input>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  faa_n_number?: Maybe<Scalars['String']>;
  faa_registration_id?: Maybe<Scalars['String']>;
  file_assets?: Maybe<File_Assets_Arr_Rel_Insert_Input>;
  flight_commands?: Maybe<Flight_Commands_Arr_Rel_Insert_Input>;
  flight_plans?: Maybe<Flight_Plans_Arr_Rel_Insert_Input>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  ground_assets?: Maybe<Ground_Assets_Arr_Rel_Insert_Input>;
  historical_serialized_vehicle_statuses?: Maybe<Historical_Serialized_Vehicle_Statuses_Arr_Rel_Insert_Input>;
  icao_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_connected?: Maybe<Scalars['Boolean']>;
  landing_requests?: Maybe<Landing_Requests_Arr_Rel_Insert_Input>;
  last_vehicle_anomaly_status?: Maybe<Last_Vehicle_Anomaly_Statuses_Obj_Rel_Insert_Input>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_parameters?: Maybe<Scalars['jsonb']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['jsonb']>;
  pickup_requests?: Maybe<Pickup_Requests_Arr_Rel_Insert_Input>;
  raw_alerts?: Maybe<Vehicle_Alerts_Arr_Rel_Insert_Input>;
  serial_number?: Maybe<Scalars['String']>;
  store_telemetry?: Maybe<Scalars['Boolean']>;
  sui_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  vehicle_model?: Maybe<Vehicle_Models_Obj_Rel_Insert_Input>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  vehicle_networks?: Maybe<Vehicle_Networks_Arr_Rel_Insert_Input>;
  vehicle_pilot_assignments?: Maybe<Vehicle_Pilot_Assignments_Arr_Rel_Insert_Input>;
  vehicle_priority_events?: Maybe<Vehicle_Priority_Events_Arr_Rel_Insert_Input>;
  vehicle_statuses?: Maybe<Kafka_Serialized_Vehicle_Statuses_Arr_Rel_Insert_Input>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vehicles_Max_Fields = {
  __typename?: 'vehicles_max_fields';
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  faa_n_number?: Maybe<Scalars['String']>;
  faa_registration_id?: Maybe<Scalars['String']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  icao_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  sui_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "vehicles" */
export type Vehicles_Max_Order_By = {
  ardupilot_version?: Maybe<Order_By>;
  bmu2_version?: Maybe<Order_By>;
  bmu_version?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  faa_n_number?: Maybe<Order_By>;
  faa_registration_id?: Maybe<Order_By>;
  fpga_version?: Maybe<Order_By>;
  fts_version?: Maybe<Order_By>;
  gps1_version?: Maybe<Order_By>;
  gps2_version?: Maybe<Order_By>;
  icao_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lidar_version?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  mttr_serial_number?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  sui_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate min on columns */
export type Vehicles_Min_Fields = {
  __typename?: 'vehicles_min_fields';
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  faa_n_number?: Maybe<Scalars['String']>;
  faa_registration_id?: Maybe<Scalars['String']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  icao_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serial_number?: Maybe<Scalars['String']>;
  sui_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "vehicles" */
export type Vehicles_Min_Order_By = {
  ardupilot_version?: Maybe<Order_By>;
  bmu2_version?: Maybe<Order_By>;
  bmu_version?: Maybe<Order_By>;
  created_at?: Maybe<Order_By>;
  deleted_at?: Maybe<Order_By>;
  faa_n_number?: Maybe<Order_By>;
  faa_registration_id?: Maybe<Order_By>;
  fpga_version?: Maybe<Order_By>;
  fts_version?: Maybe<Order_By>;
  gps1_version?: Maybe<Order_By>;
  gps2_version?: Maybe<Order_By>;
  icao_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  lidar_version?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  mttr_serial_number?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  serial_number?: Maybe<Order_By>;
  sui_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** response of any mutation on the table "vehicles" */
export type Vehicles_Mutation_Response = {
  __typename?: 'vehicles_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Vehicles>;
};

/** input type for inserting object relation for remote table "vehicles" */
export type Vehicles_Obj_Rel_Insert_Input = {
  data: Vehicles_Insert_Input;
  on_conflict?: Maybe<Vehicles_On_Conflict>;
};

/** on conflict condition type for table "vehicles" */
export type Vehicles_On_Conflict = {
  constraint: Vehicles_Constraint;
  update_columns: Array<Vehicles_Update_Column>;
  where?: Maybe<Vehicles_Bool_Exp>;
};

/** ordering options when selecting data from "vehicles" */
export type Vehicles_Order_By = {
  activated?: Maybe<Order_By>;
  airworthiness_category?: Maybe<Order_By>;
  ardupilot_version?: Maybe<Order_By>;
  bmu2_version?: Maybe<Order_By>;
  bmu_version?: Maybe<Order_By>;
  contingency_landing_spots_aggregate?: Maybe<Contingency_Landing_Spots_Aggregate_Order_By>;
  created_at?: Maybe<Order_By>;
  daa_observations_aggregate?: Maybe<Daa_Observations_Aggregate_Order_By>;
  daa_status?: Maybe<Daa_Statuses_Order_By>;
  deleted_at?: Maybe<Order_By>;
  faa_n_number?: Maybe<Order_By>;
  faa_registration_id?: Maybe<Order_By>;
  file_assets_aggregate?: Maybe<File_Assets_Aggregate_Order_By>;
  flight_commands_aggregate?: Maybe<Flight_Commands_Aggregate_Order_By>;
  flight_plans_aggregate?: Maybe<Flight_Plans_Aggregate_Order_By>;
  fpga_version?: Maybe<Order_By>;
  fts_version?: Maybe<Order_By>;
  gps1_version?: Maybe<Order_By>;
  gps2_version?: Maybe<Order_By>;
  ground_assets_aggregate?: Maybe<Ground_Assets_Aggregate_Order_By>;
  historical_serialized_vehicle_statuses_aggregate?: Maybe<Historical_Serialized_Vehicle_Statuses_Aggregate_Order_By>;
  icao_id?: Maybe<Order_By>;
  id?: Maybe<Order_By>;
  is_connected?: Maybe<Order_By>;
  landing_requests_aggregate?: Maybe<Landing_Requests_Aggregate_Order_By>;
  last_vehicle_anomaly_status?: Maybe<Last_Vehicle_Anomaly_Statuses_Order_By>;
  lidar_version?: Maybe<Order_By>;
  mavnet_parameters?: Maybe<Order_By>;
  mavnet_version?: Maybe<Order_By>;
  mongo_id?: Maybe<Order_By>;
  mttr_serial_number?: Maybe<Order_By>;
  name?: Maybe<Order_By>;
  parameters?: Maybe<Order_By>;
  pickup_requests_aggregate?: Maybe<Pickup_Requests_Aggregate_Order_By>;
  raw_alerts_aggregate?: Maybe<Vehicle_Alerts_Aggregate_Order_By>;
  serial_number?: Maybe<Order_By>;
  store_telemetry?: Maybe<Order_By>;
  sui_id?: Maybe<Order_By>;
  tenant_id?: Maybe<Order_By>;
  updated_at?: Maybe<Order_By>;
  uwb_version?: Maybe<Order_By>;
  vehicle_model?: Maybe<Vehicle_Models_Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  vehicle_networks_aggregate?: Maybe<Vehicle_Networks_Aggregate_Order_By>;
  vehicle_pilot_assignments_aggregate?: Maybe<Vehicle_Pilot_Assignments_Aggregate_Order_By>;
  vehicle_priority_events_aggregate?: Maybe<Vehicle_Priority_Events_Aggregate_Order_By>;
  vehicle_statuses_aggregate?: Maybe<Kafka_Serialized_Vehicle_Statuses_Aggregate_Order_By>;
  version?: Maybe<Order_By>;
};

/** primary key columns input for table: "vehicles" */
export type Vehicles_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Vehicles_Prepend_Input = {
  mavnet_parameters?: Maybe<Scalars['jsonb']>;
  parameters?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "vehicles" */
export enum Vehicles_Select_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  AirworthinessCategory = 'airworthiness_category',
  /** column name */
  ArdupilotVersion = 'ardupilot_version',
  /** column name */
  Bmu2Version = 'bmu2_version',
  /** column name */
  BmuVersion = 'bmu_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FaaNNumber = 'faa_n_number',
  /** column name */
  FaaRegistrationId = 'faa_registration_id',
  /** column name */
  FpgaVersion = 'fpga_version',
  /** column name */
  FtsVersion = 'fts_version',
  /** column name */
  Gps1Version = 'gps1_version',
  /** column name */
  Gps2Version = 'gps2_version',
  /** column name */
  IcaoId = 'icao_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsConnected = 'is_connected',
  /** column name */
  LidarVersion = 'lidar_version',
  /** column name */
  MavnetParameters = 'mavnet_parameters',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  MttrSerialNumber = 'mttr_serial_number',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  StoreTelemetry = 'store_telemetry',
  /** column name */
  SuiId = 'sui_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  VehicleModelId = 'vehicle_model_id',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "vehicles" */
export type Vehicles_Set_Input = {
  activated?: Maybe<Scalars['Boolean']>;
  airworthiness_category?: Maybe<Vehicle_Airworthiness_Categories_Enum>;
  ardupilot_version?: Maybe<Scalars['String']>;
  bmu2_version?: Maybe<Scalars['String']>;
  bmu_version?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  deleted_at?: Maybe<Scalars['timestamptz']>;
  faa_n_number?: Maybe<Scalars['String']>;
  faa_registration_id?: Maybe<Scalars['String']>;
  fpga_version?: Maybe<Scalars['String']>;
  fts_version?: Maybe<Scalars['String']>;
  gps1_version?: Maybe<Scalars['String']>;
  gps2_version?: Maybe<Scalars['String']>;
  icao_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_connected?: Maybe<Scalars['Boolean']>;
  lidar_version?: Maybe<Scalars['String']>;
  mavnet_parameters?: Maybe<Scalars['jsonb']>;
  mavnet_version?: Maybe<Scalars['String']>;
  mongo_id?: Maybe<Scalars['String']>;
  mttr_serial_number?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parameters?: Maybe<Scalars['jsonb']>;
  serial_number?: Maybe<Scalars['String']>;
  store_telemetry?: Maybe<Scalars['Boolean']>;
  sui_id?: Maybe<Scalars['String']>;
  tenant_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uwb_version?: Maybe<Scalars['String']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vehicles_Stddev_Fields = {
  __typename?: 'vehicles_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vehicles" */
export type Vehicles_Stddev_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vehicles_Stddev_Pop_Fields = {
  __typename?: 'vehicles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vehicles" */
export type Vehicles_Stddev_Pop_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vehicles_Stddev_Samp_Fields = {
  __typename?: 'vehicles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vehicles" */
export type Vehicles_Stddev_Samp_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate sum on columns */
export type Vehicles_Sum_Fields = {
  __typename?: 'vehicles_sum_fields';
  id?: Maybe<Scalars['Int']>;
  vehicle_model_id?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "vehicles" */
export type Vehicles_Sum_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** update columns of table "vehicles" */
export enum Vehicles_Update_Column {
  /** column name */
  Activated = 'activated',
  /** column name */
  AirworthinessCategory = 'airworthiness_category',
  /** column name */
  ArdupilotVersion = 'ardupilot_version',
  /** column name */
  Bmu2Version = 'bmu2_version',
  /** column name */
  BmuVersion = 'bmu_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FaaNNumber = 'faa_n_number',
  /** column name */
  FaaRegistrationId = 'faa_registration_id',
  /** column name */
  FpgaVersion = 'fpga_version',
  /** column name */
  FtsVersion = 'fts_version',
  /** column name */
  Gps1Version = 'gps1_version',
  /** column name */
  Gps2Version = 'gps2_version',
  /** column name */
  IcaoId = 'icao_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsConnected = 'is_connected',
  /** column name */
  LidarVersion = 'lidar_version',
  /** column name */
  MavnetParameters = 'mavnet_parameters',
  /** column name */
  MavnetVersion = 'mavnet_version',
  /** column name */
  MongoId = 'mongo_id',
  /** column name */
  MttrSerialNumber = 'mttr_serial_number',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  StoreTelemetry = 'store_telemetry',
  /** column name */
  SuiId = 'sui_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UwbVersion = 'uwb_version',
  /** column name */
  VehicleModelId = 'vehicle_model_id',
  /** column name */
  Version = 'version'
}

/** aggregate var_pop on columns */
export type Vehicles_Var_Pop_Fields = {
  __typename?: 'vehicles_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vehicles" */
export type Vehicles_Var_Pop_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vehicles_Var_Samp_Fields = {
  __typename?: 'vehicles_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vehicles" */
export type Vehicles_Var_Samp_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

/** aggregate variance on columns */
export type Vehicles_Variance_Fields = {
  __typename?: 'vehicles_variance_fields';
  id?: Maybe<Scalars['Float']>;
  vehicle_model_id?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vehicles" */
export type Vehicles_Variance_Order_By = {
  id?: Maybe<Order_By>;
  vehicle_model_id?: Maybe<Order_By>;
  version?: Maybe<Order_By>;
};

export type GetLandingTypeSubscriptionVariables = Exact<{
  flightPlanId?: Maybe<Scalars['Int']>;
}>;


export type GetLandingTypeSubscription = (
  { __typename?: 'subscription_root' }
  & { vehicleStatuses: Array<(
    { __typename?: 'kafka_serialized_vehicle_statuses' }
    & { landingType: Kafka_Serialized_Vehicle_Statuses['landing_type'] }
  )> }
);

export type GetAltitudesSubscriptionVariables = Exact<{
  flightPlanId?: Maybe<Scalars['Int']>;
}>;


export type GetAltitudesSubscription = (
  { __typename?: 'subscription_root' }
  & { vehicleStatuses: Array<(
    { __typename?: 'kafka_serialized_vehicle_statuses' }
    & { altAglMeters: Kafka_Serialized_Vehicle_Statuses['alt_agl_meters'], altMeters: Kafka_Serialized_Vehicle_Statuses['alt_meters'], timestampSecs: Kafka_Serialized_Vehicle_Statuses['timestamp_secs'] }
  )> }
);

export type GetHistoricalAltitudesQueryVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetHistoricalAltitudesQuery = (
  { __typename?: 'query_root' }
  & { flightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & { historicalVehiclePositions: Array<(
      { __typename?: 'historical_vehicle_positions' }
      & { altAglMeters: Historical_Vehicle_Positions['alt_agl_meters'], altMeters: Historical_Vehicle_Positions['alt_meters'], timestampSecs: Historical_Vehicle_Positions['timestamp_secs'] }
    )> }
  )> }
);

export type ClearSelectedFlightPlanMutationVariables = Exact<{
  auth0UserId: Scalars['String'];
}>;


export type ClearSelectedFlightPlanMutation = (
  { __typename?: 'mutation_root' }
  & { userAppStates?: Maybe<(
    { __typename?: 'user_app_states' }
    & Pick<User_App_States, 'updated_at'>
  )> }
);

export type GetEnvFeatureFlagsQueryVariables = Exact<{
  env: Scalars['String'];
}>;


export type GetEnvFeatureFlagsQuery = (
  { __typename?: 'query_root' }
  & { envFeatureFlags: Array<(
    { __typename?: 'env_feature_flags' }
    & { value: Env_Feature_Flags['enabled'], name: Env_Feature_Flags['feature_name'] }
  )> }
);

export type GetFlightStatusBySelectedFlightPlanSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetFlightStatusBySelectedFlightPlanSubscription = (
  { __typename?: 'subscription_root' }
  & { userAppStates: Array<(
    { __typename?: 'user_app_states' }
    & { flightPlan?: Maybe<(
      { __typename?: 'flight_plans' }
      & { flightStatuses: Array<(
        { __typename?: 'vehicle_flight_statuses' }
        & { status: Vehicle_Flight_Statuses['flight_status'] }
      )> }
    )> }
  )> }
);

export type GetSelectedFlightPlanSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetSelectedFlightPlanSubscription = (
  { __typename?: 'subscription_root' }
  & { userAppStates: Array<(
    { __typename?: 'user_app_states' }
    & { appStateUpdatedAt: User_App_States['updated_at'] }
    & { flightPlan?: Maybe<(
      { __typename?: 'flight_plans' }
      & Pick<Flight_Plans, 'id'>
      & { deconflictionAlgorithm: Flight_Plans['air_traffic_deconfliction_algorithm'] }
      & { vehicle?: Maybe<(
        { __typename?: 'vehicles' }
        & Pick<Vehicles, 'id' | 'name'>
        & { serialNumber: Vehicles['serial_number'] }
        & { daaStatus?: Maybe<(
          { __typename?: 'daa_statuses' }
          & { wellClearStatus: Daa_Statuses['well_clear_status'], maneuverType: Daa_Statuses['maneuver_type'] }
        )>, vehicleStatuses: Array<(
          { __typename?: 'kafka_serialized_vehicle_statuses' }
          & { lat: Kafka_Serialized_Vehicle_Statuses['lat_degs'], lon: Kafka_Serialized_Vehicle_Statuses['lon_degs'], altMeters: Kafka_Serialized_Vehicle_Statuses['alt_meters'], headingDegrees: Kafka_Serialized_Vehicle_Statuses['heading_degrees'], groundSpeedMetersPerSecond: Kafka_Serialized_Vehicle_Statuses['ground_speed_meters_per_second'], landingType: Kafka_Serialized_Vehicle_Statuses['landing_type'], flightPlanId: Kafka_Serialized_Vehicle_Statuses['flight_plan_id'] }
          & { flightStatus?: Maybe<(
            { __typename?: 'vehicle_flight_statuses' }
            & { flightStatusValue: Vehicle_Flight_Statuses['flight_status'] }
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type GetUserPermissionsQueryVariables = Exact<{
  auth0UserId: Scalars['String'];
}>;


export type GetUserPermissionsQuery = (
  { __typename?: 'query_root' }
  & { permissions: Array<(
    { __typename?: 'user_permissions_view' }
    & Pick<User_Permissions_View, 'permission'>
  )> }
);

export type SetSelectedFlightPlanMutationVariables = Exact<{
  auth0UserId: Scalars['String'];
  flightPlanId: Scalars['Int'];
}>;


export type SetSelectedFlightPlanMutation = (
  { __typename?: 'mutation_root' }
  & { userAppStates?: Maybe<(
    { __typename?: 'user_app_states' }
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'email'>
    ), flightPlan?: Maybe<(
      { __typename?: 'flight_plans' }
      & Pick<Flight_Plans, 'id'>
    )> }
  )> }
);

export type GetActiveFlightsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetActiveFlightsSubscription = (
  { __typename?: 'subscription_root' }
  & { activeFlights: Array<(
    { __typename?: 'vehicle_flight_statuses' }
    & { activatedAt: Vehicle_Flight_Statuses['activated_at'], flightStatus: Vehicle_Flight_Statuses['flight_status'], isUserCommanded: Vehicle_Flight_Statuses['is_user_commanded'] }
    & { flightPlan?: Maybe<(
      { __typename?: 'flight_plans' }
      & Pick<Flight_Plans, 'id' | 'title'>
      & { isSelectedByUser: Flight_Plans['flight_plan_selected_by_user'] }
      & { path?: Maybe<(
        { __typename?: 'paths' }
        & Pick<Paths, 'title'>
      )>, network?: Maybe<(
        { __typename?: 'networks' }
        & Pick<Networks, 'title'>
      )>, vehicle?: Maybe<(
        { __typename?: 'vehicles' }
        & Pick<Vehicles, 'name'>
        & { serialNumber: Vehicles['serial_number'] }
        & { vehicleStatuses: Array<(
          { __typename?: 'kafka_serialized_vehicle_statuses' }
          & { estimatedSocPercentage: Kafka_Serialized_Vehicle_Statuses['estimated_soc_percentage'] }
        )> }
      )> }
    )> }
  )> }
);

export type GetVehicleAlertsSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetVehicleAlertsSubscription = (
  { __typename?: 'subscription_root' }
  & { vehicleAlerts?: Maybe<(
    { __typename?: 'flight_plans' }
    & { alertsFromPriorityEvents: Array<(
      { __typename?: 'vehicle_priority_events' }
      & Pick<Vehicle_Priority_Events, 'id' | 'message'>
      & { createdAt: Vehicle_Priority_Events['created_at'] }
    )>, rawAlerts: Array<(
      { __typename?: 'vehicle_alerts' }
      & Pick<Vehicle_Alerts, 'id' | 'message' | 'severity'>
      & { createdAt: Vehicle_Alerts['created_at'] }
    )> }
  )> }
);

export type GetVehicleAnomalyByFlightPlanIdSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetVehicleAnomalyByFlightPlanIdSubscription = (
  { __typename?: 'subscription_root' }
  & { flightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & Pick<Flight_Plans, 'id'>
    & { vehicle?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id'>
      & { lastVehicleAnomalyStatus?: Maybe<(
        { __typename?: 'last_vehicle_anomaly_statuses' }
        & { anomalyStatusNames: Last_Vehicle_Anomaly_Statuses['anomaly_status_names'], updatedAt: Last_Vehicle_Anomaly_Statuses['updated_at'] }
      )> }
    )> }
  )> }
);

export type GetAvailableCommandsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCommandsSubscription = (
  { __typename?: 'subscription_root' }
  & { states: Array<(
    { __typename?: 'user_app_states' }
    & { commandSet?: Maybe<(
      { __typename?: 'available_aircraft_command_sets' }
      & CommandSetFragment
    )> }
  )> }
);

export type CommandSetFragment = (
  { __typename?: 'available_aircraft_command_sets' }
  & Pick<Available_Aircraft_Command_Sets, 'arm' | 'disarm' | 'hold' | 'land' | 'resume' | 'takeoff'>
  & { exitSafe: Available_Aircraft_Command_Sets['exit_safe'], safeZone: Available_Aircraft_Command_Sets['safe_zone'], reverseCourse: Available_Aircraft_Command_Sets['reverse_course'], alternateLanding: Available_Aircraft_Command_Sets['alternate_landing'], precisionLandingToggle: Available_Aircraft_Command_Sets['precision_landing_toggle'], alternateLandingToggle: Available_Aircraft_Command_Sets['alternate_landing_toggle'] }
);

export type GetCommandStatusSubscriptionVariables = Exact<{
  commandId: Scalars['Int'];
}>;


export type GetCommandStatusSubscription = (
  { __typename?: 'subscription_root' }
  & { flightCommandData?: Maybe<(
    { __typename?: 'flight_commands' }
    & Pick<Flight_Commands, 'acknowledged' | 'accepted'>
    & { statusMessage: Flight_Commands['status_message'] }
  )> }
);

export type GetCurrentRpicSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetCurrentRpicSubscription = (
  { __typename?: 'subscription_root' }
  & { currentRpic: Array<(
    { __typename?: 'flight_plan_current_rpic_view' }
    & { requestingPilot?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'email'>
    )>, rpicUser?: Maybe<(
      { __typename?: 'users' }
      & { rpicEmail: Users['email'] }
    )>, flightPlan?: Maybe<(
      { __typename?: 'flight_plans' }
      & { vehicle?: Maybe<(
        { __typename?: 'vehicles' }
        & { vehicleName: Vehicles['name'] }
      )>, assignments: Array<(
        { __typename?: 'flight_plan_pilot_assignments' }
        & { pilot: (
          { __typename?: 'users' }
          & Pick<Users, 'email'>
        ) }
      )> }
    )> }
  )> }
);

export type IssueArmCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueArmCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleArmCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueDisarmCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueDisarmCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleDisarmCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueTakeOffCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueTakeOffCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleProceedCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueHoldCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueHoldCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleHoldCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueResumeCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueResumeCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleResumeCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueLandCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueLandCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleAbortCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueReverseCourseCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueReverseCourseCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueVehicleReturnHomeCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueProceedToSafetyZoneCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueProceedToSafetyZoneCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueProceedToSafetyZoneCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueResumePlannedFlightCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueResumePlannedFlightCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueResumePlannedFlightCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssueAlternateLandingCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssueAlternateLandingCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issueAlternateLandingTypeCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type IssuePrecisionLandingCommandMutationVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type IssuePrecisionLandingCommandMutation = (
  { __typename?: 'mutation_root' }
  & { issuePrecisionLandingTypeCommand?: Maybe<(
    { __typename?: 'VehicleCommandOutput' }
    & Pick<VehicleCommandOutput, 'commandId'>
  )> }
);

export type RequestFlightControlMutationVariables = Exact<{
  input: RequestFlightControlInput;
}>;


export type RequestFlightControlMutation = (
  { __typename?: 'mutation_root' }
  & { requestFlightControl?: Maybe<(
    { __typename?: 'RequestFlightControlOutput' }
    & Pick<RequestFlightControlOutput, 'requestId'>
  )> }
);

export type GetAirTrafficFlightProximityRecordingsSubscriptionVariables = Exact<{
  flightPlanId?: Maybe<Scalars['Int']>;
}>;


export type GetAirTrafficFlightProximityRecordingsSubscription = (
  { __typename?: 'subscription_root' }
  & { airTrafficProximityRecordings: Array<(
    { __typename?: 'current_air_traffic_proximity_recordings' }
    & Pick<Current_Air_Traffic_Proximity_Recordings, 'id'>
    & { lonDeg: Current_Air_Traffic_Proximity_Recordings['lon_degrees'], latDeg: Current_Air_Traffic_Proximity_Recordings['lat_degrees'], altM: Current_Air_Traffic_Proximity_Recordings['alt_meters'], headingDeg: Current_Air_Traffic_Proximity_Recordings['heading_degrees'], groundspeedMps: Current_Air_Traffic_Proximity_Recordings['groundspeed_meters_per_second'], callsign: Current_Air_Traffic_Proximity_Recordings['callsign'], icaoAddress: Current_Air_Traffic_Proximity_Recordings['icao_address'], aircraftType: Current_Air_Traffic_Proximity_Recordings['aircraft_type'], relativeAltitudeM: Current_Air_Traffic_Proximity_Recordings['relative_altitude_meters'], proximityLevel: Current_Air_Traffic_Proximity_Recordings['proximity_level'], source: Current_Air_Traffic_Proximity_Recordings['source'] }
    & { aircraftTypeDesignator?: Maybe<(
      { __typename?: 'aircraft_type_designators' }
      & { iconName: Aircraft_Type_Designators['icon_name'] }
    )> }
  )> }
);

export type GetDedupedAirTrafficForUserViewportQueryVariables = Exact<{
  userBboxPolygon?: Maybe<Scalars['String']>;
  selectedVehicleSerialNumber?: Maybe<Scalars['String']>;
}>;


export type GetDedupedAirTrafficForUserViewportQuery = (
  { __typename?: 'query_root' }
  & { currentAirTrafficTracks: Array<(
    { __typename?: 'current_utm_air_traffic_tracks' }
    & TrafficDataFragment
  )> }
);

export type GetUtmAirTrafficForUserViewportQueryVariables = Exact<{
  userBboxPolygon?: Maybe<Scalars['geometry']>;
}>;


export type GetUtmAirTrafficForUserViewportQuery = (
  { __typename?: 'query_root' }
  & { currentAirTrafficTracks: Array<(
    { __typename?: 'current_utm_air_traffic_tracks' }
    & TrafficDataFragment
  )> }
);

export type TrafficDataFragment = (
  { __typename?: 'current_utm_air_traffic_tracks' }
  & Pick<Current_Utm_Air_Traffic_Tracks, 'id' | 'location' | 'callsign' | 'source'>
  & { lonDeg: Current_Utm_Air_Traffic_Tracks['lon_degs'], latDeg: Current_Utm_Air_Traffic_Tracks['lat_degs'], headingDeg: Current_Utm_Air_Traffic_Tracks['heading_degs'], icaoAddress: Current_Utm_Air_Traffic_Tracks['icao_address'], alt: Current_Utm_Air_Traffic_Tracks['alt_m'], aircraftType: Current_Utm_Air_Traffic_Tracks['aircraft_type'], groundSpeed: Current_Utm_Air_Traffic_Tracks['groundspeed_mps'], iconName: Current_Utm_Air_Traffic_Tracks['aircraft_type_icon_name'] }
);

export type GetConnectedAircraftSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedAircraftSubscription = (
  { __typename?: 'subscription_root' }
  & { vehicleStatuses: Array<(
    { __typename?: 'kafka_serialized_vehicle_statuses' }
    & { lat: Kafka_Serialized_Vehicle_Statuses['lat_degs'], lon: Kafka_Serialized_Vehicle_Statuses['lon_degs'], timestampSecs: Kafka_Serialized_Vehicle_Statuses['timestamp_secs'], headingDegrees: Kafka_Serialized_Vehicle_Statuses['heading_degrees'], groundSpeedMetersPerSecond: Kafka_Serialized_Vehicle_Statuses['ground_speed_meters_per_second'], flightPlanId: Kafka_Serialized_Vehicle_Statuses['flight_plan_id'], altMeters: Kafka_Serialized_Vehicle_Statuses['alt_meters'], altAglMeters: Kafka_Serialized_Vehicle_Statuses['alt_agl_meters'] }
    & { flightStatus?: Maybe<(
      { __typename?: 'vehicle_flight_statuses' }
      & { inFlightDisconnectAt: Vehicle_Flight_Statuses['in_flight_disconnect_at'], flightStatusValue: Vehicle_Flight_Statuses['flight_status'] }
    )>, vehicle?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id' | 'name'>
      & { isConnected: Vehicles['is_connected'] }
    )> }
  )> }
);

export type GetDaaObservationsSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetDaaObservationsSubscription = (
  { __typename?: 'subscription_root' }
  & { daaObservations: Array<(
    { __typename?: 'daa_observations' }
    & Pick<Daa_Observations, 'source' | 'callsign'>
    & { observationId: Daa_Observations['observation_id'], observationCoord: Daa_Observations['observation_coord'], observationType: Daa_Observations['observation_type'], highestAlertLevel: Daa_Observations['alert_level'], vehicleSerialNumber: Daa_Observations['vehicle_serial_number'], flightPlanId: Daa_Observations['flight_plan_id'], groundSpeedMps: Daa_Observations['groundspeed_mps'], headingDeg: Daa_Observations['heading_deg'], icaoAddress: Daa_Observations['icao_address'], altitudeM: Daa_Observations['altitude_m'], updatedAt: Daa_Observations['updated_at'] }
    & { observationTypeInfo?: Maybe<(
      { __typename?: 'aircraft_type_designators' }
      & { iconName: Aircraft_Type_Designators['icon_name'] }
    )>, predictedConflicts: Array<(
      { __typename?: 'predicted_conflicts' }
      & PredictedConflictFragment
    )> }
  )> }
);

export type PredictedConflictFragment = (
  { __typename?: 'predicted_conflicts' }
  & Pick<Predicted_Conflicts, 'pruned'>
  & { alertLevel: Predicted_Conflicts['alert_level'], conflictContours: Predicted_Conflicts['conflict_contours'], conflictIntervals: Predicted_Conflicts['conflict_intervals'], timeToViolationOutSecs: Predicted_Conflicts['time_to_violation_out_secs'], timeToViolationInSecs: Predicted_Conflicts['time_to_violation_in_secs'] }
);

export type GetDaaStatusSubscriptionVariables = Exact<{
  vehicleSerialNumber: Scalars['String'];
}>;


export type GetDaaStatusSubscription = (
  { __typename?: 'subscription_root' }
  & { daaStatus?: Maybe<(
    { __typename?: 'daa_statuses' }
    & { vehicleSerialNumber: Daa_Statuses['vehicle_serial_number'], flightPlanId: Daa_Statuses['flight_plan_id'], timeStamp: Daa_Statuses['timestamp_utc_secs'], wellClearStatus: Daa_Statuses['well_clear_status'], maneuverPath: Daa_Statuses['maneuver_path'], maneuverType: Daa_Statuses['maneuver_type'] }
  )> }
);

export type GetFlightPathSubscriptionVariables = Exact<{
  flightPlanId?: Maybe<Scalars['Int']>;
}>;


export type GetFlightPathSubscription = (
  { __typename?: 'subscription_root' }
  & { flightPlans: Array<(
    { __typename?: 'flight_plans' }
    & { vehicleStatuses: Array<(
      { __typename?: 'kafka_serialized_vehicle_statuses' }
      & Pick<Kafka_Serialized_Vehicle_Statuses, 'nearest_safety_zone_flight_path_idx'>
    )>, path?: Maybe<(
      { __typename?: 'paths' }
      & Pick<Paths, 'id' | 'title'>
      & { flightPath: Paths['flight_path'], safetyZones: Paths['safety_zones'] }
    )>, destContingencyPath?: Maybe<(
      { __typename?: 'paths' }
      & Pick<Paths, 'id' | 'title'>
      & { flightPath: Paths['flight_path'] }
    )>, originContingencyPath?: Maybe<(
      { __typename?: 'paths' }
      & Pick<Paths, 'id' | 'title'>
      & { flightPath: Paths['flight_path'] }
    )>, originStation?: Maybe<(
      { __typename?: 'stations' }
      & Pick<Stations, 'name'>
      & { airspace?: Maybe<(
        { __typename?: 'airspaces' }
        & Pick<Airspaces, 'perimeter'>
      )> }
    )>, destStation?: Maybe<(
      { __typename?: 'stations' }
      & Pick<Stations, 'name'>
      & { airspace?: Maybe<(
        { __typename?: 'airspaces' }
        & Pick<Airspaces, 'perimeter'>
      )> }
    )>, contingencyByOrigin?: Maybe<(
      { __typename?: 'contingency_landing_spots' }
      & { airspace?: Maybe<(
        { __typename?: 'airspaces' }
        & Pick<Airspaces, 'perimeter'>
      )> }
    )>, contingencyByDest?: Maybe<(
      { __typename?: 'contingency_landing_spots' }
      & { airspace?: Maybe<(
        { __typename?: 'airspaces' }
        & Pick<Airspaces, 'perimeter'>
      )> }
    )> }
  )> }
);

export type GetConnectedGroundAssetStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedGroundAssetStatusSubscription = (
  { __typename?: 'subscription_root' }
  & { groundAssetStatuses: Array<(
    { __typename?: 'kafka_serialized_ground_asset_statuses' }
    & { lat: Kafka_Serialized_Ground_Asset_Statuses['lat_degs'], lon: Kafka_Serialized_Ground_Asset_Statuses['lon_degs'], timestampSecs: Kafka_Serialized_Ground_Asset_Statuses['timestamp_secs'] }
    & { groundAsset?: Maybe<(
      { __typename?: 'ground_assets' }
      & Pick<Ground_Assets, 'id'>
      & { serialNumber: Ground_Assets['serial_number'], isConnected: Ground_Assets['is_connected'], headingDegrees: Ground_Assets['heading'] }
    )> }
  )> }
);

export type GetDisconnectedGroundAssetStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetDisconnectedGroundAssetStatusSubscription = (
  { __typename?: 'subscription_root' }
  & { groundAssetStatuses: Array<(
    { __typename?: 'kafka_serialized_ground_asset_statuses' }
    & { lat: Kafka_Serialized_Ground_Asset_Statuses['lat_degs'], lon: Kafka_Serialized_Ground_Asset_Statuses['lon_degs'], timestampSecs: Kafka_Serialized_Ground_Asset_Statuses['timestamp_secs'] }
    & { groundAsset?: Maybe<(
      { __typename?: 'ground_assets' }
      & Pick<Ground_Assets, 'id'>
      & { serialNumber: Ground_Assets['serial_number'], isConnected: Ground_Assets['is_connected'], headingDegrees: Ground_Assets['heading'] }
    )> }
  )> }
);

export type GetHistoricalActualFlightPathQueryVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetHistoricalActualFlightPathQuery = (
  { __typename?: 'query_root' }
  & { flightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & { historicalVehiclePositions: Array<(
      { __typename?: 'historical_vehicle_positions' }
      & { altAglMeters: Historical_Vehicle_Positions['alt_agl_meters'], lon: Historical_Vehicle_Positions['lon_degs'], lat: Historical_Vehicle_Positions['lat_degs'] }
    )> }
  )> }
);

export type GetNearestSafetyZoneFlightPathIndexSubscriptionSubscriptionVariables = Exact<{
  flightPlanId?: Maybe<Scalars['Int']>;
}>;


export type GetNearestSafetyZoneFlightPathIndexSubscriptionSubscription = (
  { __typename?: 'subscription_root' }
  & { vehicleStatuses: Array<(
    { __typename?: 'kafka_serialized_vehicle_statuses' }
    & { nearestSafetyZoneFlightPathIndex: Kafka_Serialized_Vehicle_Statuses['nearest_safety_zone_flight_path_idx'] }
  )> }
);

export type GetVehicleStatusSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetVehicleStatusSubscription = (
  { __typename?: 'subscription_root' }
  & { vehicleStatuses: Array<(
    { __typename?: 'kafka_serialized_vehicle_statuses' }
    & { lat: Kafka_Serialized_Vehicle_Statuses['lat_degs'], lon: Kafka_Serialized_Vehicle_Statuses['lon_degs'], timestampSecs: Kafka_Serialized_Vehicle_Statuses['timestamp_secs'], headingDegrees: Kafka_Serialized_Vehicle_Statuses['heading_degrees'], groundSpeedMetersPerSecond: Kafka_Serialized_Vehicle_Statuses['ground_speed_meters_per_second'] }
    & { vehicle?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id'>
      & { serialNumber: Vehicles['serial_number'], isConnected: Vehicles['is_connected'] }
    )> }
  )> }
);

export type GetActivePriorityEventsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetActivePriorityEventsSubscription = (
  { __typename?: 'subscription_root' }
  & { vehiclePriorityEvents: Array<(
    { __typename?: 'vehicle_priority_events' }
    & Pick<Vehicle_Priority_Events, 'id' | 'message'>
    & { flightPlanId: Vehicle_Priority_Events['flight_plan_id'] }
    & { vehicle: (
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'name'>
      & { vehicleId: Vehicles['id'], serialNumber: Vehicles['serial_number'] }
      & { vehicleStatuses: Array<(
        { __typename?: 'kafka_serialized_vehicle_statuses' }
        & { estimatedSocPercentage: Kafka_Serialized_Vehicle_Statuses['estimated_soc_percentage'] }
      )> }
    ), flightStatusDetails?: Maybe<(
      { __typename?: 'vehicle_flight_statuses' }
      & { flightStatus: Vehicle_Flight_Statuses['flight_status'], isUserCommanded: Vehicle_Flight_Statuses['is_user_commanded'] }
    )>, eventDetails: (
      { __typename?: 'vehicle_priority_event_keys' }
      & Pick<Vehicle_Priority_Event_Keys, 'rank' | 'title' | 'severity'>
      & { eventKey: Vehicle_Priority_Event_Keys['event_key'] }
    ) }
  )> }
);

export type AcknowledgePriorityEventMutationVariables = Exact<{
  eventId: Scalars['Int'];
}>;


export type AcknowledgePriorityEventMutation = (
  { __typename?: 'mutation_root' }
  & { acknowledgePriorityEvent?: Maybe<(
    { __typename?: 'PriorityEventOutput' }
    & { priorityEvent?: Maybe<(
      { __typename?: 'vehicle_priority_events' }
      & { acknowledgedAt: Vehicle_Priority_Events['acknowledged_at'] }
    )> }
  )> }
);

export type GetHighestPriorityEventSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetHighestPriorityEventSubscription = (
  { __typename?: 'subscription_root' }
  & { priorityEvent: Array<(
    { __typename?: 'vehicle_priority_events' }
    & Pick<Vehicle_Priority_Events, 'id' | 'event'>
    & { priorityEventMessage: Vehicle_Priority_Events['message'] }
    & { eventDetails: (
      { __typename?: 'vehicle_priority_event_keys' }
      & Pick<Vehicle_Priority_Event_Keys, 'title' | 'rank' | 'severity'>
    ), flightPlan: (
      { __typename?: 'flight_plans' }
      & { rpicView?: Maybe<(
        { __typename?: 'flight_plan_current_rpic_view' }
        & { rpicUser?: Maybe<(
          { __typename?: 'users' }
          & Pick<Users, 'email'>
        )> }
      )> }
    ) }
  )> }
);

export type GetVehicleTelemetryByFlightPlanSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetVehicleTelemetryByFlightPlanSubscription = (
  { __typename?: 'subscription_root' }
  & { selectedFlightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & Pick<Flight_Plans, 'id'>
    & { vehicle?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id'>
      & { vehicleTelemetry: Array<(
        { __typename?: 'kafka_serialized_vehicle_statuses' }
        & { groundSpeedMetersPerSecond: Kafka_Serialized_Vehicle_Statuses['ground_speed_meters_per_second'], altAglMeters: Kafka_Serialized_Vehicle_Statuses['alt_agl_meters'], altMeters: Kafka_Serialized_Vehicle_Statuses['alt_meters'], estimatedSocPercentage: Kafka_Serialized_Vehicle_Statuses['estimated_soc_percentage'], batteryVoltageVolts: Kafka_Serialized_Vehicle_Statuses['battery_voltage_volts'], batteryPowerWatts: Kafka_Serialized_Vehicle_Statuses['battery_power_watts'], satellitesVisible: Kafka_Serialized_Vehicle_Statuses['satellites_visible'], gpsFixType: Kafka_Serialized_Vehicle_Statuses['gps_fix_type'], flightMode: Kafka_Serialized_Vehicle_Statuses['flight_mode'], plTargetNumber: Kafka_Serialized_Vehicle_Statuses['pl_target_number'], landingType: Kafka_Serialized_Vehicle_Statuses['landing_type'], lidarDistMeters: Kafka_Serialized_Vehicle_Statuses['lidar_dist_meters'], pairedGroundAssetSerialNumber: Kafka_Serialized_Vehicle_Statuses['paired_ground_asset_serial_number'], headingDegrees: Kafka_Serialized_Vehicle_Statuses['heading_degrees'], primaryGpsIndicator: Kafka_Serialized_Vehicle_Statuses['primary_gps_indicator'] }
      )> }
    )> }
  )> }
);

export type GetAllPriorityEventsByFlightPlanQueryVariables = Exact<{
  selectedFlightPlanId: Scalars['Int'];
}>;


export type GetAllPriorityEventsByFlightPlanQuery = (
  { __typename?: 'query_root' }
  & { flightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & Pick<Flight_Plans, 'id'>
    & { priorityEvents: Array<(
      { __typename?: 'vehicle_priority_events' }
      & Pick<Vehicle_Priority_Events, 'id' | 'message'>
      & { createdAt: Vehicle_Priority_Events['created_at'] }
    )> }
  )> }
);

export type GetFlightStatusByFlightPlanSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetFlightStatusByFlightPlanSubscription = (
  { __typename?: 'subscription_root' }
  & { selectedFlightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & Pick<Flight_Plans, 'id'>
    & { vehicle?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id'>
      & { telemetry: Array<(
        { __typename?: 'kafka_serialized_vehicle_statuses' }
        & { currentFlightPlan?: Maybe<(
          { __typename?: 'flight_plans' }
          & Pick<Flight_Plans, 'id'>
        )> }
      )> }
    )> }
  )> }
);

export type GetPostFlightFlightPlanDetailsQueryVariables = Exact<{
  selectedFlightPlanId: Scalars['Int'];
}>;


export type GetPostFlightFlightPlanDetailsQuery = (
  { __typename?: 'query_root' }
  & { flightPlanDetails?: Maybe<(
    { __typename?: 'flight_plans' }
    & Pick<Flight_Plans, 'id'>
    & { flightPlanId: Flight_Plans['id'], departureTime: Flight_Plans['departed_on'], arrivalTime: Flight_Plans['arrived_on'] }
    & { aircraft?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id'>
      & { name: Vehicles['name'] }
    )>, flightRoute?: Maybe<(
      { __typename?: 'paths' }
      & Pick<Paths, 'title'>
    )>, manifest?: Maybe<(
      { __typename?: 'manifests' }
      & Pick<Manifests, 'id'>
      & { serialNumber: Manifests['serial_number'] }
    )>, assignedPilots: Array<(
      { __typename?: 'flight_plan_pilot_assignments' }
      & Pick<Flight_Plan_Pilot_Assignments, 'id'>
      & { user: (
        { __typename?: 'users' }
        & Pick<Users, 'email'>
      ) }
    )> }
  )>, lastRpic: Array<(
    { __typename?: 'flight_plan_current_rpic_view' }
    & { user?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'email'>
    )> }
  )> }
);

export type GetPostFlightLandingDetailsQueryVariables = Exact<{
  selectedFlightPlanId: Scalars['Int'];
}>;


export type GetPostFlightLandingDetailsQuery = (
  { __typename?: 'query_root' }
  & { landingDetails?: Maybe<(
    { __typename?: 'flight_plans' }
    & { _id: Flight_Plans['id'] }
    & { aircraft?: Maybe<(
      { __typename?: 'vehicles' }
      & { _id: Vehicles['id'] }
      & { lastReportedLocation: Array<(
        { __typename?: 'historical_serialized_vehicle_statuses' }
        & { _id: Historical_Serialized_Vehicle_Statuses['flight_plan_id'], latDeg: Historical_Serialized_Vehicle_Statuses['lat_degs'], lonDeg: Historical_Serialized_Vehicle_Statuses['lon_degs'] }
      )> }
    )> }
  )> }
);

export type GetPendingPeocApprovalsAsRpicSubscriptionVariables = Exact<{
  auth0UserId?: Maybe<Scalars['String']>;
}>;


export type GetPendingPeocApprovalsAsRpicSubscription = (
  { __typename?: 'subscription_root' }
  & { currentRpic: Array<(
    { __typename?: 'flight_plan_current_rpic_view' }
    & { rpicRequestId: Flight_Plan_Current_Rpic_View['flight_peoc_request_id'] }
    & { peocRequestingPilot?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'email' | 'id'>
    )>, rpicPilot?: Maybe<(
      { __typename?: 'users' }
      & Pick<Users, 'email' | 'id'>
    )>, flight_plan?: Maybe<(
      { __typename?: 'flight_plans' }
      & { vehicle?: Maybe<(
        { __typename?: 'vehicles' }
        & Pick<Vehicles, 'name'>
      )> }
    )> }
  )> }
);

export type ResolveFlightControlRequestMutationVariables = Exact<{
  input: ResolveFlightControlRequestInput;
}>;


export type ResolveFlightControlRequestMutation = (
  { __typename?: 'mutation_root' }
  & { resolveFlightControlRequest?: Maybe<(
    { __typename?: 'ResolveFlightControlRequestOutput' }
    & Pick<ResolveFlightControlRequestOutput, 'status'>
  )> }
);

export type GetVehicleDetailsByFlightPlanSubscriptionVariables = Exact<{
  flightPlanId: Scalars['Int'];
}>;


export type GetVehicleDetailsByFlightPlanSubscription = (
  { __typename?: 'subscription_root' }
  & { flightPlan?: Maybe<(
    { __typename?: 'flight_plans' }
    & Pick<Flight_Plans, 'id'>
    & { path?: Maybe<(
      { __typename?: 'paths' }
      & Pick<Paths, 'title'>
    )>, vehicle?: Maybe<(
      { __typename?: 'vehicles' }
      & Pick<Vehicles, 'id' | 'name'>
      & { telemetry: Array<(
        { __typename?: 'kafka_serialized_vehicle_statuses' }
        & { etaSecs: Kafka_Serialized_Vehicle_Statuses['eta_secs'], eteSecs: Kafka_Serialized_Vehicle_Statuses['ete_terminal_airspace_secs'], timestampSecs: Kafka_Serialized_Vehicle_Statuses['timestamp_secs'], isBatterylocked: Kafka_Serialized_Vehicle_Statuses['battery_locked'], isPayloadLocked: Kafka_Serialized_Vehicle_Statuses['payload_locked'] }
        & { currentFlightPlan?: Maybe<(
          { __typename?: 'flight_plans' }
          & Pick<Flight_Plans, 'id'>
        )>, flightStatus?: Maybe<(
          { __typename?: 'vehicle_flight_statuses' }
          & { flightStatusName: Vehicle_Flight_Statuses['flight_status'], isUserCommanded: Vehicle_Flight_Statuses['is_user_commanded'] }
        )> }
      )> }
    )> }
    & PilotAssignmentsFragment
  )> }
);

export type PilotAssignmentsFragment = (
  { __typename?: 'flight_plans' }
  & { pilotAssignments: Array<(
    { __typename?: 'flight_plan_pilot_assignments' }
    & { user: (
      { __typename?: 'users' }
      & Pick<Users, 'email'>
      & { auth0UserId: Users['auth0_user_id'] }
    ) }
  )> }
);

export const CommandSetFragmentDoc = gql`
    fragment commandSet on available_aircraft_command_sets {
  arm
  disarm
  hold
  land
  resume
  takeoff
  exitSafe: exit_safe
  safeZone: safe_zone
  reverseCourse: reverse_course
  alternateLanding: alternate_landing
  precisionLandingToggle: precision_landing_toggle
  alternateLandingToggle: alternate_landing_toggle
}
    `;
export const TrafficDataFragmentDoc = gql`
    fragment TrafficData on current_utm_air_traffic_tracks {
  id
  location
  lonDeg: lon_degs
  latDeg: lat_degs
  headingDeg: heading_degs
  icaoAddress: icao_address
  alt: alt_m
  aircraftType: aircraft_type
  callsign
  source
  groundSpeed: groundspeed_mps
  iconName: aircraft_type_icon_name
}
    `;
export const PredictedConflictFragmentDoc = gql`
    fragment predictedConflict on predicted_conflicts {
  alertLevel: alert_level
  conflictContours: conflict_contours
  conflictIntervals: conflict_intervals
  timeToViolationOutSecs: time_to_violation_out_secs
  timeToViolationInSecs: time_to_violation_in_secs
  pruned
}
    `;
export const PilotAssignmentsFragmentDoc = gql`
    fragment pilotAssignments on flight_plans {
  pilotAssignments: flight_plan_pilot_assignments {
    user {
      email
      auth0UserId: auth0_user_id
    }
  }
}
    `;
export const GetLandingTypeDocument = gql`
    subscription getLandingType($flightPlanId: Int) {
  vehicleStatuses: vehicle_statuses(where: {flight_plan_id: {_eq: $flightPlanId}}) {
    landingType: landing_type
  }
}
    `;

/**
 * __useGetLandingTypeSubscription__
 *
 * To run a query within a React component, call `useGetLandingTypeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingTypeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingTypeSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetLandingTypeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetLandingTypeSubscription, GetLandingTypeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetLandingTypeSubscription, GetLandingTypeSubscriptionVariables>(GetLandingTypeDocument, options);
      }
export type GetLandingTypeSubscriptionHookResult = ReturnType<typeof useGetLandingTypeSubscription>;
export type GetLandingTypeSubscriptionResult = Apollo.SubscriptionResult<GetLandingTypeSubscription>;
export const GetAltitudesDocument = gql`
    subscription getAltitudes($flightPlanId: Int) {
  vehicleStatuses: vehicle_statuses(where: {flight_plan_id: {_eq: $flightPlanId}}) {
    altAglMeters: alt_agl_meters
    altMeters: alt_meters
    timestampSecs: timestamp_secs
  }
}
    `;

/**
 * __useGetAltitudesSubscription__
 *
 * To run a query within a React component, call `useGetAltitudesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAltitudesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAltitudesSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetAltitudesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetAltitudesSubscription, GetAltitudesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetAltitudesSubscription, GetAltitudesSubscriptionVariables>(GetAltitudesDocument, options);
      }
export type GetAltitudesSubscriptionHookResult = ReturnType<typeof useGetAltitudesSubscription>;
export type GetAltitudesSubscriptionResult = Apollo.SubscriptionResult<GetAltitudesSubscription>;
export const GetHistoricalAltitudesDocument = gql`
    query getHistoricalAltitudes($flightPlanId: Int!) {
  flightPlan: flight_plans_by_pk(id: $flightPlanId) {
    historicalVehiclePositions: historical_vehicle_positions(
      order_by: {timestamp_secs: asc}
    ) {
      altAglMeters: alt_agl_meters
      altMeters: alt_meters
      timestampSecs: timestamp_secs
    }
  }
}
    `;

/**
 * __useGetHistoricalAltitudesQuery__
 *
 * To run a query within a React component, call `useGetHistoricalAltitudesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalAltitudesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalAltitudesQuery({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetHistoricalAltitudesQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalAltitudesQuery, GetHistoricalAltitudesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalAltitudesQuery, GetHistoricalAltitudesQueryVariables>(GetHistoricalAltitudesDocument, options);
      }
export function useGetHistoricalAltitudesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalAltitudesQuery, GetHistoricalAltitudesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalAltitudesQuery, GetHistoricalAltitudesQueryVariables>(GetHistoricalAltitudesDocument, options);
        }
export type GetHistoricalAltitudesQueryHookResult = ReturnType<typeof useGetHistoricalAltitudesQuery>;
export type GetHistoricalAltitudesLazyQueryHookResult = ReturnType<typeof useGetHistoricalAltitudesLazyQuery>;
export type GetHistoricalAltitudesQueryResult = Apollo.QueryResult<GetHistoricalAltitudesQuery, GetHistoricalAltitudesQueryVariables>;
export const ClearSelectedFlightPlanDocument = gql`
    mutation clearSelectedFlightPlan($auth0UserId: String!) {
  userAppStates: insert_user_app_states_one(
    object: {auth0_user_id: $auth0UserId, selected_flight_plan_id: null}
    on_conflict: {constraint: user_app_states_auth0_user_id_key, update_columns: [selected_flight_plan_id]}
  ) {
    updated_at
  }
}
    `;
export type ClearSelectedFlightPlanMutationFn = Apollo.MutationFunction<ClearSelectedFlightPlanMutation, ClearSelectedFlightPlanMutationVariables>;

/**
 * __useClearSelectedFlightPlanMutation__
 *
 * To run a mutation, you first call `useClearSelectedFlightPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearSelectedFlightPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearSelectedFlightPlanMutation, { data, loading, error }] = useClearSelectedFlightPlanMutation({
 *   variables: {
 *      auth0UserId: // value for 'auth0UserId'
 *   },
 * });
 */
export function useClearSelectedFlightPlanMutation(baseOptions?: Apollo.MutationHookOptions<ClearSelectedFlightPlanMutation, ClearSelectedFlightPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearSelectedFlightPlanMutation, ClearSelectedFlightPlanMutationVariables>(ClearSelectedFlightPlanDocument, options);
      }
export type ClearSelectedFlightPlanMutationHookResult = ReturnType<typeof useClearSelectedFlightPlanMutation>;
export type ClearSelectedFlightPlanMutationResult = Apollo.MutationResult<ClearSelectedFlightPlanMutation>;
export type ClearSelectedFlightPlanMutationOptions = Apollo.BaseMutationOptions<ClearSelectedFlightPlanMutation, ClearSelectedFlightPlanMutationVariables>;
export const GetEnvFeatureFlagsDocument = gql`
    query getEnvFeatureFlags($env: String!) {
  envFeatureFlags: env_feature_flags(where: {hasura_domain: {_eq: $env}}) {
    value: enabled
    name: feature_name
  }
}
    `;

/**
 * __useGetEnvFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetEnvFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvFeatureFlagsQuery({
 *   variables: {
 *      env: // value for 'env'
 *   },
 * });
 */
export function useGetEnvFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<GetEnvFeatureFlagsQuery, GetEnvFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnvFeatureFlagsQuery, GetEnvFeatureFlagsQueryVariables>(GetEnvFeatureFlagsDocument, options);
      }
export function useGetEnvFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnvFeatureFlagsQuery, GetEnvFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnvFeatureFlagsQuery, GetEnvFeatureFlagsQueryVariables>(GetEnvFeatureFlagsDocument, options);
        }
export type GetEnvFeatureFlagsQueryHookResult = ReturnType<typeof useGetEnvFeatureFlagsQuery>;
export type GetEnvFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetEnvFeatureFlagsLazyQuery>;
export type GetEnvFeatureFlagsQueryResult = Apollo.QueryResult<GetEnvFeatureFlagsQuery, GetEnvFeatureFlagsQueryVariables>;
export const GetFlightStatusBySelectedFlightPlanDocument = gql`
    subscription getFlightStatusBySelectedFlightPlan {
  userAppStates: user_app_states {
    flightPlan: flight_plan {
      flightStatuses: vehicle_flight_statuses {
        status: flight_status
      }
    }
  }
}
    `;

/**
 * __useGetFlightStatusBySelectedFlightPlanSubscription__
 *
 * To run a query within a React component, call `useGetFlightStatusBySelectedFlightPlanSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetFlightStatusBySelectedFlightPlanSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlightStatusBySelectedFlightPlanSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetFlightStatusBySelectedFlightPlanSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetFlightStatusBySelectedFlightPlanSubscription, GetFlightStatusBySelectedFlightPlanSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetFlightStatusBySelectedFlightPlanSubscription, GetFlightStatusBySelectedFlightPlanSubscriptionVariables>(GetFlightStatusBySelectedFlightPlanDocument, options);
      }
export type GetFlightStatusBySelectedFlightPlanSubscriptionHookResult = ReturnType<typeof useGetFlightStatusBySelectedFlightPlanSubscription>;
export type GetFlightStatusBySelectedFlightPlanSubscriptionResult = Apollo.SubscriptionResult<GetFlightStatusBySelectedFlightPlanSubscription>;
export const GetSelectedFlightPlanDocument = gql`
    subscription getSelectedFlightPlan {
  userAppStates: user_app_states {
    appStateUpdatedAt: updated_at
    flightPlan: flight_plan {
      id
      deconflictionAlgorithm: air_traffic_deconfliction_algorithm
      vehicle {
        id
        name
        serialNumber: serial_number
        daaStatus: daa_status {
          wellClearStatus: well_clear_status
          maneuverType: maneuver_type
        }
        vehicleStatuses: vehicle_statuses {
          lat: lat_degs
          lon: lon_degs
          altMeters: alt_meters
          headingDegrees: heading_degrees
          groundSpeedMetersPerSecond: ground_speed_meters_per_second
          landingType: landing_type
          flightPlanId: flight_plan_id
          flightStatus {
            flightStatusValue: flight_status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSelectedFlightPlanSubscription__
 *
 * To run a query within a React component, call `useGetSelectedFlightPlanSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedFlightPlanSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedFlightPlanSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectedFlightPlanSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetSelectedFlightPlanSubscription, GetSelectedFlightPlanSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetSelectedFlightPlanSubscription, GetSelectedFlightPlanSubscriptionVariables>(GetSelectedFlightPlanDocument, options);
      }
export type GetSelectedFlightPlanSubscriptionHookResult = ReturnType<typeof useGetSelectedFlightPlanSubscription>;
export type GetSelectedFlightPlanSubscriptionResult = Apollo.SubscriptionResult<GetSelectedFlightPlanSubscription>;
export const GetUserPermissionsDocument = gql`
    query getUserPermissions($auth0UserId: String!) {
  permissions: user_permissions_view(where: {auth0_user_id: {_eq: $auth0UserId}}) {
    permission
  }
}
    `;

/**
 * __useGetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsQuery({
 *   variables: {
 *      auth0UserId: // value for 'auth0UserId'
 *   },
 * });
 */
export function useGetUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
      }
export function useGetUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export type GetUserPermissionsQueryHookResult = ReturnType<typeof useGetUserPermissionsQuery>;
export type GetUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsLazyQuery>;
export type GetUserPermissionsQueryResult = Apollo.QueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export const SetSelectedFlightPlanDocument = gql`
    mutation setSelectedFlightPlan($auth0UserId: String!, $flightPlanId: Int!) {
  userAppStates: insert_user_app_states_one(
    object: {auth0_user_id: $auth0UserId, selected_flight_plan_id: $flightPlanId}
    on_conflict: {constraint: user_app_states_auth0_user_id_key, update_columns: [selected_flight_plan_id]}
  ) {
    user {
      email
    }
    flightPlan: flight_plan {
      id
    }
  }
}
    `;
export type SetSelectedFlightPlanMutationFn = Apollo.MutationFunction<SetSelectedFlightPlanMutation, SetSelectedFlightPlanMutationVariables>;

/**
 * __useSetSelectedFlightPlanMutation__
 *
 * To run a mutation, you first call `useSetSelectedFlightPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSelectedFlightPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSelectedFlightPlanMutation, { data, loading, error }] = useSetSelectedFlightPlanMutation({
 *   variables: {
 *      auth0UserId: // value for 'auth0UserId'
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useSetSelectedFlightPlanMutation(baseOptions?: Apollo.MutationHookOptions<SetSelectedFlightPlanMutation, SetSelectedFlightPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSelectedFlightPlanMutation, SetSelectedFlightPlanMutationVariables>(SetSelectedFlightPlanDocument, options);
      }
export type SetSelectedFlightPlanMutationHookResult = ReturnType<typeof useSetSelectedFlightPlanMutation>;
export type SetSelectedFlightPlanMutationResult = Apollo.MutationResult<SetSelectedFlightPlanMutation>;
export type SetSelectedFlightPlanMutationOptions = Apollo.BaseMutationOptions<SetSelectedFlightPlanMutation, SetSelectedFlightPlanMutationVariables>;
export const GetActiveFlightsDocument = gql`
    subscription getActiveFlights {
  activeFlights: vehicle_flight_statuses(where: {activated_at: {_is_null: false}}) {
    activatedAt: activated_at
    flightStatus: flight_status
    isUserCommanded: is_user_commanded
    flightPlan: flight_plan {
      id
      isSelectedByUser: flight_plan_selected_by_user
      title
      path {
        title
      }
      network {
        title
      }
      vehicle {
        serialNumber: serial_number
        name
        vehicleStatuses: vehicle_statuses {
          estimatedSocPercentage: estimated_soc_percentage
        }
      }
    }
  }
}
    `;

/**
 * __useGetActiveFlightsSubscription__
 *
 * To run a query within a React component, call `useGetActiveFlightsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveFlightsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveFlightsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveFlightsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetActiveFlightsSubscription, GetActiveFlightsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetActiveFlightsSubscription, GetActiveFlightsSubscriptionVariables>(GetActiveFlightsDocument, options);
      }
export type GetActiveFlightsSubscriptionHookResult = ReturnType<typeof useGetActiveFlightsSubscription>;
export type GetActiveFlightsSubscriptionResult = Apollo.SubscriptionResult<GetActiveFlightsSubscription>;
export const GetVehicleAlertsDocument = gql`
    subscription getVehicleAlerts($flightPlanId: Int!) {
  vehicleAlerts: flight_plans_by_pk(id: $flightPlanId) {
    alertsFromPriorityEvents: vehicle_priority_events(
      where: {event_details: {event_type: {_eq: "VehicleAlert"}}}
      order_by: {created_at: desc_nulls_last}
    ) {
      id
      createdAt: created_at
      message
    }
    rawAlerts: vehicle_alerts(order_by: {created_at: desc_nulls_last}) {
      id
      createdAt: created_at
      message
      severity
    }
  }
}
    `;

/**
 * __useGetVehicleAlertsSubscription__
 *
 * To run a query within a React component, call `useGetVehicleAlertsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleAlertsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleAlertsSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetVehicleAlertsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetVehicleAlertsSubscription, GetVehicleAlertsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetVehicleAlertsSubscription, GetVehicleAlertsSubscriptionVariables>(GetVehicleAlertsDocument, options);
      }
export type GetVehicleAlertsSubscriptionHookResult = ReturnType<typeof useGetVehicleAlertsSubscription>;
export type GetVehicleAlertsSubscriptionResult = Apollo.SubscriptionResult<GetVehicleAlertsSubscription>;
export const GetVehicleAnomalyByFlightPlanIdDocument = gql`
    subscription getVehicleAnomalyByFlightPlanId($flightPlanId: Int!) {
  flightPlan: flight_plans_by_pk(id: $flightPlanId) {
    id
    vehicle {
      id
      lastVehicleAnomalyStatus: last_vehicle_anomaly_status {
        anomalyStatusNames: anomaly_status_names
        updatedAt: updated_at
      }
    }
  }
}
    `;

/**
 * __useGetVehicleAnomalyByFlightPlanIdSubscription__
 *
 * To run a query within a React component, call `useGetVehicleAnomalyByFlightPlanIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleAnomalyByFlightPlanIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleAnomalyByFlightPlanIdSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetVehicleAnomalyByFlightPlanIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetVehicleAnomalyByFlightPlanIdSubscription, GetVehicleAnomalyByFlightPlanIdSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetVehicleAnomalyByFlightPlanIdSubscription, GetVehicleAnomalyByFlightPlanIdSubscriptionVariables>(GetVehicleAnomalyByFlightPlanIdDocument, options);
      }
export type GetVehicleAnomalyByFlightPlanIdSubscriptionHookResult = ReturnType<typeof useGetVehicleAnomalyByFlightPlanIdSubscription>;
export type GetVehicleAnomalyByFlightPlanIdSubscriptionResult = Apollo.SubscriptionResult<GetVehicleAnomalyByFlightPlanIdSubscription>;
export const GetAvailableCommandsDocument = gql`
    subscription getAvailableCommands {
  states: user_app_states {
    commandSet: available_aircraft_command_set {
      ...commandSet
    }
  }
}
    ${CommandSetFragmentDoc}`;

/**
 * __useGetAvailableCommandsSubscription__
 *
 * To run a query within a React component, call `useGetAvailableCommandsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCommandsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCommandsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableCommandsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetAvailableCommandsSubscription, GetAvailableCommandsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetAvailableCommandsSubscription, GetAvailableCommandsSubscriptionVariables>(GetAvailableCommandsDocument, options);
      }
export type GetAvailableCommandsSubscriptionHookResult = ReturnType<typeof useGetAvailableCommandsSubscription>;
export type GetAvailableCommandsSubscriptionResult = Apollo.SubscriptionResult<GetAvailableCommandsSubscription>;
export const GetCommandStatusDocument = gql`
    subscription getCommandStatus($commandId: Int!) {
  flightCommandData: flight_commands_by_pk(id: $commandId) {
    acknowledged
    accepted
    statusMessage: status_message
  }
}
    `;

/**
 * __useGetCommandStatusSubscription__
 *
 * To run a query within a React component, call `useGetCommandStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetCommandStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommandStatusSubscription({
 *   variables: {
 *      commandId: // value for 'commandId'
 *   },
 * });
 */
export function useGetCommandStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetCommandStatusSubscription, GetCommandStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetCommandStatusSubscription, GetCommandStatusSubscriptionVariables>(GetCommandStatusDocument, options);
      }
export type GetCommandStatusSubscriptionHookResult = ReturnType<typeof useGetCommandStatusSubscription>;
export type GetCommandStatusSubscriptionResult = Apollo.SubscriptionResult<GetCommandStatusSubscription>;
export const GetCurrentRpicDocument = gql`
    subscription getCurrentRpic($flightPlanId: Int!) {
  currentRpic: flight_plan_current_rpic_view(
    where: {flight_plan_id: {_eq: $flightPlanId}}
  ) {
    requestingPilot: flight_peoc_requesting_pilot {
      email
    }
    rpicUser: rpic_user {
      rpicEmail: email
    }
    flightPlan: flight_plan {
      vehicle {
        vehicleName: name
      }
      assignments: flight_plan_pilot_assignments {
        pilot: user {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentRpicSubscription__
 *
 * To run a query within a React component, call `useGetCurrentRpicSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentRpicSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentRpicSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetCurrentRpicSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetCurrentRpicSubscription, GetCurrentRpicSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetCurrentRpicSubscription, GetCurrentRpicSubscriptionVariables>(GetCurrentRpicDocument, options);
      }
export type GetCurrentRpicSubscriptionHookResult = ReturnType<typeof useGetCurrentRpicSubscription>;
export type GetCurrentRpicSubscriptionResult = Apollo.SubscriptionResult<GetCurrentRpicSubscription>;
export const IssueArmCommandDocument = gql`
    mutation issueArmCommand($flightPlanId: Int!) {
  issueVehicleArmCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueArmCommandMutationFn = Apollo.MutationFunction<IssueArmCommandMutation, IssueArmCommandMutationVariables>;

/**
 * __useIssueArmCommandMutation__
 *
 * To run a mutation, you first call `useIssueArmCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueArmCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueArmCommandMutation, { data, loading, error }] = useIssueArmCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueArmCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueArmCommandMutation, IssueArmCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueArmCommandMutation, IssueArmCommandMutationVariables>(IssueArmCommandDocument, options);
      }
export type IssueArmCommandMutationHookResult = ReturnType<typeof useIssueArmCommandMutation>;
export type IssueArmCommandMutationResult = Apollo.MutationResult<IssueArmCommandMutation>;
export type IssueArmCommandMutationOptions = Apollo.BaseMutationOptions<IssueArmCommandMutation, IssueArmCommandMutationVariables>;
export const IssueDisarmCommandDocument = gql`
    mutation issueDisarmCommand($flightPlanId: Int!) {
  issueVehicleDisarmCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueDisarmCommandMutationFn = Apollo.MutationFunction<IssueDisarmCommandMutation, IssueDisarmCommandMutationVariables>;

/**
 * __useIssueDisarmCommandMutation__
 *
 * To run a mutation, you first call `useIssueDisarmCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueDisarmCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueDisarmCommandMutation, { data, loading, error }] = useIssueDisarmCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueDisarmCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueDisarmCommandMutation, IssueDisarmCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueDisarmCommandMutation, IssueDisarmCommandMutationVariables>(IssueDisarmCommandDocument, options);
      }
export type IssueDisarmCommandMutationHookResult = ReturnType<typeof useIssueDisarmCommandMutation>;
export type IssueDisarmCommandMutationResult = Apollo.MutationResult<IssueDisarmCommandMutation>;
export type IssueDisarmCommandMutationOptions = Apollo.BaseMutationOptions<IssueDisarmCommandMutation, IssueDisarmCommandMutationVariables>;
export const IssueTakeOffCommandDocument = gql`
    mutation issueTakeOffCommand($flightPlanId: Int!) {
  issueVehicleProceedCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueTakeOffCommandMutationFn = Apollo.MutationFunction<IssueTakeOffCommandMutation, IssueTakeOffCommandMutationVariables>;

/**
 * __useIssueTakeOffCommandMutation__
 *
 * To run a mutation, you first call `useIssueTakeOffCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueTakeOffCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueTakeOffCommandMutation, { data, loading, error }] = useIssueTakeOffCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueTakeOffCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueTakeOffCommandMutation, IssueTakeOffCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueTakeOffCommandMutation, IssueTakeOffCommandMutationVariables>(IssueTakeOffCommandDocument, options);
      }
export type IssueTakeOffCommandMutationHookResult = ReturnType<typeof useIssueTakeOffCommandMutation>;
export type IssueTakeOffCommandMutationResult = Apollo.MutationResult<IssueTakeOffCommandMutation>;
export type IssueTakeOffCommandMutationOptions = Apollo.BaseMutationOptions<IssueTakeOffCommandMutation, IssueTakeOffCommandMutationVariables>;
export const IssueHoldCommandDocument = gql`
    mutation issueHoldCommand($flightPlanId: Int!) {
  issueVehicleHoldCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueHoldCommandMutationFn = Apollo.MutationFunction<IssueHoldCommandMutation, IssueHoldCommandMutationVariables>;

/**
 * __useIssueHoldCommandMutation__
 *
 * To run a mutation, you first call `useIssueHoldCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueHoldCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueHoldCommandMutation, { data, loading, error }] = useIssueHoldCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueHoldCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueHoldCommandMutation, IssueHoldCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueHoldCommandMutation, IssueHoldCommandMutationVariables>(IssueHoldCommandDocument, options);
      }
export type IssueHoldCommandMutationHookResult = ReturnType<typeof useIssueHoldCommandMutation>;
export type IssueHoldCommandMutationResult = Apollo.MutationResult<IssueHoldCommandMutation>;
export type IssueHoldCommandMutationOptions = Apollo.BaseMutationOptions<IssueHoldCommandMutation, IssueHoldCommandMutationVariables>;
export const IssueResumeCommandDocument = gql`
    mutation issueResumeCommand($flightPlanId: Int!) {
  issueVehicleResumeCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueResumeCommandMutationFn = Apollo.MutationFunction<IssueResumeCommandMutation, IssueResumeCommandMutationVariables>;

/**
 * __useIssueResumeCommandMutation__
 *
 * To run a mutation, you first call `useIssueResumeCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueResumeCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueResumeCommandMutation, { data, loading, error }] = useIssueResumeCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueResumeCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueResumeCommandMutation, IssueResumeCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueResumeCommandMutation, IssueResumeCommandMutationVariables>(IssueResumeCommandDocument, options);
      }
export type IssueResumeCommandMutationHookResult = ReturnType<typeof useIssueResumeCommandMutation>;
export type IssueResumeCommandMutationResult = Apollo.MutationResult<IssueResumeCommandMutation>;
export type IssueResumeCommandMutationOptions = Apollo.BaseMutationOptions<IssueResumeCommandMutation, IssueResumeCommandMutationVariables>;
export const IssueLandCommandDocument = gql`
    mutation issueLandCommand($flightPlanId: Int!) {
  issueVehicleAbortCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueLandCommandMutationFn = Apollo.MutationFunction<IssueLandCommandMutation, IssueLandCommandMutationVariables>;

/**
 * __useIssueLandCommandMutation__
 *
 * To run a mutation, you first call `useIssueLandCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueLandCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueLandCommandMutation, { data, loading, error }] = useIssueLandCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueLandCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueLandCommandMutation, IssueLandCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueLandCommandMutation, IssueLandCommandMutationVariables>(IssueLandCommandDocument, options);
      }
export type IssueLandCommandMutationHookResult = ReturnType<typeof useIssueLandCommandMutation>;
export type IssueLandCommandMutationResult = Apollo.MutationResult<IssueLandCommandMutation>;
export type IssueLandCommandMutationOptions = Apollo.BaseMutationOptions<IssueLandCommandMutation, IssueLandCommandMutationVariables>;
export const IssueReverseCourseCommandDocument = gql`
    mutation issueReverseCourseCommand($flightPlanId: Int!) {
  issueVehicleReturnHomeCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueReverseCourseCommandMutationFn = Apollo.MutationFunction<IssueReverseCourseCommandMutation, IssueReverseCourseCommandMutationVariables>;

/**
 * __useIssueReverseCourseCommandMutation__
 *
 * To run a mutation, you first call `useIssueReverseCourseCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueReverseCourseCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueReverseCourseCommandMutation, { data, loading, error }] = useIssueReverseCourseCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueReverseCourseCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueReverseCourseCommandMutation, IssueReverseCourseCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueReverseCourseCommandMutation, IssueReverseCourseCommandMutationVariables>(IssueReverseCourseCommandDocument, options);
      }
export type IssueReverseCourseCommandMutationHookResult = ReturnType<typeof useIssueReverseCourseCommandMutation>;
export type IssueReverseCourseCommandMutationResult = Apollo.MutationResult<IssueReverseCourseCommandMutation>;
export type IssueReverseCourseCommandMutationOptions = Apollo.BaseMutationOptions<IssueReverseCourseCommandMutation, IssueReverseCourseCommandMutationVariables>;
export const IssueProceedToSafetyZoneCommandDocument = gql`
    mutation issueProceedToSafetyZoneCommand($flightPlanId: Int!) {
  issueProceedToSafetyZoneCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueProceedToSafetyZoneCommandMutationFn = Apollo.MutationFunction<IssueProceedToSafetyZoneCommandMutation, IssueProceedToSafetyZoneCommandMutationVariables>;

/**
 * __useIssueProceedToSafetyZoneCommandMutation__
 *
 * To run a mutation, you first call `useIssueProceedToSafetyZoneCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueProceedToSafetyZoneCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueProceedToSafetyZoneCommandMutation, { data, loading, error }] = useIssueProceedToSafetyZoneCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueProceedToSafetyZoneCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueProceedToSafetyZoneCommandMutation, IssueProceedToSafetyZoneCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueProceedToSafetyZoneCommandMutation, IssueProceedToSafetyZoneCommandMutationVariables>(IssueProceedToSafetyZoneCommandDocument, options);
      }
export type IssueProceedToSafetyZoneCommandMutationHookResult = ReturnType<typeof useIssueProceedToSafetyZoneCommandMutation>;
export type IssueProceedToSafetyZoneCommandMutationResult = Apollo.MutationResult<IssueProceedToSafetyZoneCommandMutation>;
export type IssueProceedToSafetyZoneCommandMutationOptions = Apollo.BaseMutationOptions<IssueProceedToSafetyZoneCommandMutation, IssueProceedToSafetyZoneCommandMutationVariables>;
export const IssueResumePlannedFlightCommandDocument = gql`
    mutation issueResumePlannedFlightCommand($flightPlanId: Int!) {
  issueResumePlannedFlightCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueResumePlannedFlightCommandMutationFn = Apollo.MutationFunction<IssueResumePlannedFlightCommandMutation, IssueResumePlannedFlightCommandMutationVariables>;

/**
 * __useIssueResumePlannedFlightCommandMutation__
 *
 * To run a mutation, you first call `useIssueResumePlannedFlightCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueResumePlannedFlightCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueResumePlannedFlightCommandMutation, { data, loading, error }] = useIssueResumePlannedFlightCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueResumePlannedFlightCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueResumePlannedFlightCommandMutation, IssueResumePlannedFlightCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueResumePlannedFlightCommandMutation, IssueResumePlannedFlightCommandMutationVariables>(IssueResumePlannedFlightCommandDocument, options);
      }
export type IssueResumePlannedFlightCommandMutationHookResult = ReturnType<typeof useIssueResumePlannedFlightCommandMutation>;
export type IssueResumePlannedFlightCommandMutationResult = Apollo.MutationResult<IssueResumePlannedFlightCommandMutation>;
export type IssueResumePlannedFlightCommandMutationOptions = Apollo.BaseMutationOptions<IssueResumePlannedFlightCommandMutation, IssueResumePlannedFlightCommandMutationVariables>;
export const IssueAlternateLandingCommandDocument = gql`
    mutation issueAlternateLandingCommand($flightPlanId: Int!) {
  issueAlternateLandingTypeCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssueAlternateLandingCommandMutationFn = Apollo.MutationFunction<IssueAlternateLandingCommandMutation, IssueAlternateLandingCommandMutationVariables>;

/**
 * __useIssueAlternateLandingCommandMutation__
 *
 * To run a mutation, you first call `useIssueAlternateLandingCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueAlternateLandingCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueAlternateLandingCommandMutation, { data, loading, error }] = useIssueAlternateLandingCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssueAlternateLandingCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssueAlternateLandingCommandMutation, IssueAlternateLandingCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueAlternateLandingCommandMutation, IssueAlternateLandingCommandMutationVariables>(IssueAlternateLandingCommandDocument, options);
      }
export type IssueAlternateLandingCommandMutationHookResult = ReturnType<typeof useIssueAlternateLandingCommandMutation>;
export type IssueAlternateLandingCommandMutationResult = Apollo.MutationResult<IssueAlternateLandingCommandMutation>;
export type IssueAlternateLandingCommandMutationOptions = Apollo.BaseMutationOptions<IssueAlternateLandingCommandMutation, IssueAlternateLandingCommandMutationVariables>;
export const IssuePrecisionLandingCommandDocument = gql`
    mutation issuePrecisionLandingCommand($flightPlanId: Int!) {
  issuePrecisionLandingTypeCommand(commandInput: {flightPlanId: $flightPlanId}) {
    commandId
  }
}
    `;
export type IssuePrecisionLandingCommandMutationFn = Apollo.MutationFunction<IssuePrecisionLandingCommandMutation, IssuePrecisionLandingCommandMutationVariables>;

/**
 * __useIssuePrecisionLandingCommandMutation__
 *
 * To run a mutation, you first call `useIssuePrecisionLandingCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssuePrecisionLandingCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issuePrecisionLandingCommandMutation, { data, loading, error }] = useIssuePrecisionLandingCommandMutation({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useIssuePrecisionLandingCommandMutation(baseOptions?: Apollo.MutationHookOptions<IssuePrecisionLandingCommandMutation, IssuePrecisionLandingCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssuePrecisionLandingCommandMutation, IssuePrecisionLandingCommandMutationVariables>(IssuePrecisionLandingCommandDocument, options);
      }
export type IssuePrecisionLandingCommandMutationHookResult = ReturnType<typeof useIssuePrecisionLandingCommandMutation>;
export type IssuePrecisionLandingCommandMutationResult = Apollo.MutationResult<IssuePrecisionLandingCommandMutation>;
export type IssuePrecisionLandingCommandMutationOptions = Apollo.BaseMutationOptions<IssuePrecisionLandingCommandMutation, IssuePrecisionLandingCommandMutationVariables>;
export const RequestFlightControlDocument = gql`
    mutation requestFlightControl($input: RequestFlightControlInput!) {
  requestFlightControl(input: $input) {
    requestId
  }
}
    `;
export type RequestFlightControlMutationFn = Apollo.MutationFunction<RequestFlightControlMutation, RequestFlightControlMutationVariables>;

/**
 * __useRequestFlightControlMutation__
 *
 * To run a mutation, you first call `useRequestFlightControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFlightControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFlightControlMutation, { data, loading, error }] = useRequestFlightControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestFlightControlMutation(baseOptions?: Apollo.MutationHookOptions<RequestFlightControlMutation, RequestFlightControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestFlightControlMutation, RequestFlightControlMutationVariables>(RequestFlightControlDocument, options);
      }
export type RequestFlightControlMutationHookResult = ReturnType<typeof useRequestFlightControlMutation>;
export type RequestFlightControlMutationResult = Apollo.MutationResult<RequestFlightControlMutation>;
export type RequestFlightControlMutationOptions = Apollo.BaseMutationOptions<RequestFlightControlMutation, RequestFlightControlMutationVariables>;
export const GetAirTrafficFlightProximityRecordingsDocument = gql`
    subscription getAirTrafficFlightProximityRecordings($flightPlanId: Int) {
  airTrafficProximityRecordings: current_air_traffic_proximity_recordings(
    where: {flight_plan_id: {_eq: $flightPlanId}}
  ) {
    lonDeg: lon_degrees
    latDeg: lat_degrees
    altM: alt_meters
    headingDeg: heading_degrees
    groundspeedMps: groundspeed_meters_per_second
    callsign: callsign
    icaoAddress: icao_address
    aircraftType: aircraft_type
    relativeAltitudeM: relative_altitude_meters
    proximityLevel: proximity_level
    source: source
    id
    aircraftTypeDesignator: aircraft_type_designator {
      iconName: icon_name
    }
  }
}
    `;

/**
 * __useGetAirTrafficFlightProximityRecordingsSubscription__
 *
 * To run a query within a React component, call `useGetAirTrafficFlightProximityRecordingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetAirTrafficFlightProximityRecordingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAirTrafficFlightProximityRecordingsSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetAirTrafficFlightProximityRecordingsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetAirTrafficFlightProximityRecordingsSubscription, GetAirTrafficFlightProximityRecordingsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetAirTrafficFlightProximityRecordingsSubscription, GetAirTrafficFlightProximityRecordingsSubscriptionVariables>(GetAirTrafficFlightProximityRecordingsDocument, options);
      }
export type GetAirTrafficFlightProximityRecordingsSubscriptionHookResult = ReturnType<typeof useGetAirTrafficFlightProximityRecordingsSubscription>;
export type GetAirTrafficFlightProximityRecordingsSubscriptionResult = Apollo.SubscriptionResult<GetAirTrafficFlightProximityRecordingsSubscription>;
export const GetDedupedAirTrafficForUserViewportDocument = gql`
    query getDedupedAirTrafficForUserViewport($userBboxPolygon: String, $selectedVehicleSerialNumber: String) {
  currentAirTrafficTracks: fetch_current_deduped_air_traffic_tracks(
    order_by: {alt_m: asc, icao_address: asc}
    args: {searchpolygon: $userBboxPolygon, vehicleserialnumber: $selectedVehicleSerialNumber}
  ) {
    ...TrafficData
  }
}
    ${TrafficDataFragmentDoc}`;

/**
 * __useGetDedupedAirTrafficForUserViewportQuery__
 *
 * To run a query within a React component, call `useGetDedupedAirTrafficForUserViewportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDedupedAirTrafficForUserViewportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDedupedAirTrafficForUserViewportQuery({
 *   variables: {
 *      userBboxPolygon: // value for 'userBboxPolygon'
 *      selectedVehicleSerialNumber: // value for 'selectedVehicleSerialNumber'
 *   },
 * });
 */
export function useGetDedupedAirTrafficForUserViewportQuery(baseOptions?: Apollo.QueryHookOptions<GetDedupedAirTrafficForUserViewportQuery, GetDedupedAirTrafficForUserViewportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDedupedAirTrafficForUserViewportQuery, GetDedupedAirTrafficForUserViewportQueryVariables>(GetDedupedAirTrafficForUserViewportDocument, options);
      }
export function useGetDedupedAirTrafficForUserViewportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDedupedAirTrafficForUserViewportQuery, GetDedupedAirTrafficForUserViewportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDedupedAirTrafficForUserViewportQuery, GetDedupedAirTrafficForUserViewportQueryVariables>(GetDedupedAirTrafficForUserViewportDocument, options);
        }
export type GetDedupedAirTrafficForUserViewportQueryHookResult = ReturnType<typeof useGetDedupedAirTrafficForUserViewportQuery>;
export type GetDedupedAirTrafficForUserViewportLazyQueryHookResult = ReturnType<typeof useGetDedupedAirTrafficForUserViewportLazyQuery>;
export type GetDedupedAirTrafficForUserViewportQueryResult = Apollo.QueryResult<GetDedupedAirTrafficForUserViewportQuery, GetDedupedAirTrafficForUserViewportQueryVariables>;
export const GetUtmAirTrafficForUserViewportDocument = gql`
    query getUtmAirTrafficForUserViewport($userBboxPolygon: geometry) {
  currentAirTrafficTracks: current_utm_air_traffic_tracks(
    order_by: {alt_m: asc, icao_address: asc}
    where: {location: {_st_within: $userBboxPolygon}}
  ) {
    ...TrafficData
  }
}
    ${TrafficDataFragmentDoc}`;

/**
 * __useGetUtmAirTrafficForUserViewportQuery__
 *
 * To run a query within a React component, call `useGetUtmAirTrafficForUserViewportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUtmAirTrafficForUserViewportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUtmAirTrafficForUserViewportQuery({
 *   variables: {
 *      userBboxPolygon: // value for 'userBboxPolygon'
 *   },
 * });
 */
export function useGetUtmAirTrafficForUserViewportQuery(baseOptions?: Apollo.QueryHookOptions<GetUtmAirTrafficForUserViewportQuery, GetUtmAirTrafficForUserViewportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUtmAirTrafficForUserViewportQuery, GetUtmAirTrafficForUserViewportQueryVariables>(GetUtmAirTrafficForUserViewportDocument, options);
      }
export function useGetUtmAirTrafficForUserViewportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUtmAirTrafficForUserViewportQuery, GetUtmAirTrafficForUserViewportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUtmAirTrafficForUserViewportQuery, GetUtmAirTrafficForUserViewportQueryVariables>(GetUtmAirTrafficForUserViewportDocument, options);
        }
export type GetUtmAirTrafficForUserViewportQueryHookResult = ReturnType<typeof useGetUtmAirTrafficForUserViewportQuery>;
export type GetUtmAirTrafficForUserViewportLazyQueryHookResult = ReturnType<typeof useGetUtmAirTrafficForUserViewportLazyQuery>;
export type GetUtmAirTrafficForUserViewportQueryResult = Apollo.QueryResult<GetUtmAirTrafficForUserViewportQuery, GetUtmAirTrafficForUserViewportQueryVariables>;
export const GetConnectedAircraftDocument = gql`
    subscription getConnectedAircraft {
  vehicleStatuses: vehicle_statuses {
    lat: lat_degs
    lon: lon_degs
    timestampSecs: timestamp_secs
    headingDegrees: heading_degrees
    groundSpeedMetersPerSecond: ground_speed_meters_per_second
    flightPlanId: flight_plan_id
    altMeters: alt_meters
    altAglMeters: alt_agl_meters
    flightStatus {
      inFlightDisconnectAt: in_flight_disconnect_at
      flightStatusValue: flight_status
    }
    vehicle {
      id
      isConnected: is_connected
      name
    }
  }
}
    `;

/**
 * __useGetConnectedAircraftSubscription__
 *
 * To run a query within a React component, call `useGetConnectedAircraftSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedAircraftSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedAircraftSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectedAircraftSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetConnectedAircraftSubscription, GetConnectedAircraftSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetConnectedAircraftSubscription, GetConnectedAircraftSubscriptionVariables>(GetConnectedAircraftDocument, options);
      }
export type GetConnectedAircraftSubscriptionHookResult = ReturnType<typeof useGetConnectedAircraftSubscription>;
export type GetConnectedAircraftSubscriptionResult = Apollo.SubscriptionResult<GetConnectedAircraftSubscription>;
export const GetDaaObservationsDocument = gql`
    subscription getDaaObservations($flightPlanId: Int!) {
  daaObservations: daa_observations(
    where: {flight_plan_id: {_eq: $flightPlanId}, _and: {in_lookahead: {_eq: true}}}
  ) {
    observationId: observation_id
    observationCoord: observation_coord
    observationType: observation_type
    highestAlertLevel: alert_level
    vehicleSerialNumber: vehicle_serial_number
    flightPlanId: flight_plan_id
    groundSpeedMps: groundspeed_mps
    headingDeg: heading_deg
    icaoAddress: icao_address
    altitudeM: altitude_m
    observationTypeInfo: observation_type_info {
      iconName: icon_name
    }
    predictedConflicts: predicted_conflicts(where: {pruned: {_eq: false}}) {
      ...predictedConflict
    }
    source
    callsign
    updatedAt: updated_at
  }
}
    ${PredictedConflictFragmentDoc}`;

/**
 * __useGetDaaObservationsSubscription__
 *
 * To run a query within a React component, call `useGetDaaObservationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDaaObservationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaaObservationsSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetDaaObservationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetDaaObservationsSubscription, GetDaaObservationsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDaaObservationsSubscription, GetDaaObservationsSubscriptionVariables>(GetDaaObservationsDocument, options);
      }
export type GetDaaObservationsSubscriptionHookResult = ReturnType<typeof useGetDaaObservationsSubscription>;
export type GetDaaObservationsSubscriptionResult = Apollo.SubscriptionResult<GetDaaObservationsSubscription>;
export const GetDaaStatusDocument = gql`
    subscription getDaaStatus($vehicleSerialNumber: String!) {
  daaStatus: daa_statuses_by_pk(vehicle_serial_number: $vehicleSerialNumber) {
    vehicleSerialNumber: vehicle_serial_number
    flightPlanId: flight_plan_id
    timeStamp: timestamp_utc_secs
    wellClearStatus: well_clear_status
    maneuverPath: maneuver_path
    maneuverType: maneuver_type
  }
}
    `;

/**
 * __useGetDaaStatusSubscription__
 *
 * To run a query within a React component, call `useGetDaaStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDaaStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDaaStatusSubscription({
 *   variables: {
 *      vehicleSerialNumber: // value for 'vehicleSerialNumber'
 *   },
 * });
 */
export function useGetDaaStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetDaaStatusSubscription, GetDaaStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDaaStatusSubscription, GetDaaStatusSubscriptionVariables>(GetDaaStatusDocument, options);
      }
export type GetDaaStatusSubscriptionHookResult = ReturnType<typeof useGetDaaStatusSubscription>;
export type GetDaaStatusSubscriptionResult = Apollo.SubscriptionResult<GetDaaStatusSubscription>;
export const GetFlightPathDocument = gql`
    subscription getFlightPath($flightPlanId: Int) {
  flightPlans: flight_plans(where: {id: {_eq: $flightPlanId}}) {
    vehicleStatuses: kafka_serialized_vehicle_statuses {
      nearest_safety_zone_flight_path_idx
    }
    path {
      id
      title
      flightPath: flight_path
      safetyZones: safety_zones
    }
    destContingencyPath: path_by_dest_contingency_path {
      id
      title
      flightPath: flight_path
    }
    originContingencyPath: path_by_origin_contingency_path {
      id
      title
      flightPath: flight_path
    }
    originStation: origin_station {
      name
      airspace {
        perimeter
      }
    }
    destStation: destination_station {
      name
      airspace {
        perimeter
      }
    }
    contingencyByOrigin: contingency_landing_spot {
      airspace {
        perimeter
      }
    }
    contingencyByDest: contingencyLandingSpotByOriginContingencyLandingSpotId {
      airspace {
        perimeter
      }
    }
  }
}
    `;

/**
 * __useGetFlightPathSubscription__
 *
 * To run a query within a React component, call `useGetFlightPathSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetFlightPathSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlightPathSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetFlightPathSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetFlightPathSubscription, GetFlightPathSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetFlightPathSubscription, GetFlightPathSubscriptionVariables>(GetFlightPathDocument, options);
      }
export type GetFlightPathSubscriptionHookResult = ReturnType<typeof useGetFlightPathSubscription>;
export type GetFlightPathSubscriptionResult = Apollo.SubscriptionResult<GetFlightPathSubscription>;
export const GetConnectedGroundAssetStatusDocument = gql`
    subscription getConnectedGroundAssetStatus {
  groundAssetStatuses: ground_asset_statuses(
    where: {ground_asset: {is_connected: {_eq: true}}}
  ) {
    groundAsset: ground_asset {
      id
      serialNumber: serial_number
      isConnected: is_connected
      headingDegrees: heading
    }
    lat: lat_degs
    lon: lon_degs
    timestampSecs: timestamp_secs
  }
}
    `;

/**
 * __useGetConnectedGroundAssetStatusSubscription__
 *
 * To run a query within a React component, call `useGetConnectedGroundAssetStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedGroundAssetStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedGroundAssetStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectedGroundAssetStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetConnectedGroundAssetStatusSubscription, GetConnectedGroundAssetStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetConnectedGroundAssetStatusSubscription, GetConnectedGroundAssetStatusSubscriptionVariables>(GetConnectedGroundAssetStatusDocument, options);
      }
export type GetConnectedGroundAssetStatusSubscriptionHookResult = ReturnType<typeof useGetConnectedGroundAssetStatusSubscription>;
export type GetConnectedGroundAssetStatusSubscriptionResult = Apollo.SubscriptionResult<GetConnectedGroundAssetStatusSubscription>;
export const GetDisconnectedGroundAssetStatusDocument = gql`
    subscription getDisconnectedGroundAssetStatus {
  groundAssetStatuses: ground_asset_statuses(
    where: {ground_asset: {is_connected: {_eq: false}}}
  ) {
    groundAsset: ground_asset {
      id
      serialNumber: serial_number
      isConnected: is_connected
      headingDegrees: heading
    }
    lat: lat_degs
    lon: lon_degs
    timestampSecs: timestamp_secs
  }
}
    `;

/**
 * __useGetDisconnectedGroundAssetStatusSubscription__
 *
 * To run a query within a React component, call `useGetDisconnectedGroundAssetStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDisconnectedGroundAssetStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisconnectedGroundAssetStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetDisconnectedGroundAssetStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetDisconnectedGroundAssetStatusSubscription, GetDisconnectedGroundAssetStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDisconnectedGroundAssetStatusSubscription, GetDisconnectedGroundAssetStatusSubscriptionVariables>(GetDisconnectedGroundAssetStatusDocument, options);
      }
export type GetDisconnectedGroundAssetStatusSubscriptionHookResult = ReturnType<typeof useGetDisconnectedGroundAssetStatusSubscription>;
export type GetDisconnectedGroundAssetStatusSubscriptionResult = Apollo.SubscriptionResult<GetDisconnectedGroundAssetStatusSubscription>;
export const GetHistoricalActualFlightPathDocument = gql`
    query getHistoricalActualFlightPath($flightPlanId: Int!) {
  flightPlan: flight_plans_by_pk(id: $flightPlanId) {
    historicalVehiclePositions: historical_vehicle_positions(
      order_by: {timestamp_secs: asc}
    ) {
      altAglMeters: alt_agl_meters
      lon: lon_degs
      lat: lat_degs
    }
  }
}
    `;

/**
 * __useGetHistoricalActualFlightPathQuery__
 *
 * To run a query within a React component, call `useGetHistoricalActualFlightPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoricalActualFlightPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoricalActualFlightPathQuery({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetHistoricalActualFlightPathQuery(baseOptions: Apollo.QueryHookOptions<GetHistoricalActualFlightPathQuery, GetHistoricalActualFlightPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoricalActualFlightPathQuery, GetHistoricalActualFlightPathQueryVariables>(GetHistoricalActualFlightPathDocument, options);
      }
export function useGetHistoricalActualFlightPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoricalActualFlightPathQuery, GetHistoricalActualFlightPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoricalActualFlightPathQuery, GetHistoricalActualFlightPathQueryVariables>(GetHistoricalActualFlightPathDocument, options);
        }
export type GetHistoricalActualFlightPathQueryHookResult = ReturnType<typeof useGetHistoricalActualFlightPathQuery>;
export type GetHistoricalActualFlightPathLazyQueryHookResult = ReturnType<typeof useGetHistoricalActualFlightPathLazyQuery>;
export type GetHistoricalActualFlightPathQueryResult = Apollo.QueryResult<GetHistoricalActualFlightPathQuery, GetHistoricalActualFlightPathQueryVariables>;
export const GetNearestSafetyZoneFlightPathIndexSubscriptionDocument = gql`
    subscription getNearestSafetyZoneFlightPathIndexSubscription($flightPlanId: Int) {
  vehicleStatuses: vehicle_statuses(where: {flight_plan_id: {_eq: $flightPlanId}}) {
    nearestSafetyZoneFlightPathIndex: nearest_safety_zone_flight_path_idx
  }
}
    `;

/**
 * __useGetNearestSafetyZoneFlightPathIndexSubscriptionSubscription__
 *
 * To run a query within a React component, call `useGetNearestSafetyZoneFlightPathIndexSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetNearestSafetyZoneFlightPathIndexSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNearestSafetyZoneFlightPathIndexSubscriptionSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetNearestSafetyZoneFlightPathIndexSubscriptionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetNearestSafetyZoneFlightPathIndexSubscriptionSubscription, GetNearestSafetyZoneFlightPathIndexSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetNearestSafetyZoneFlightPathIndexSubscriptionSubscription, GetNearestSafetyZoneFlightPathIndexSubscriptionSubscriptionVariables>(GetNearestSafetyZoneFlightPathIndexSubscriptionDocument, options);
      }
export type GetNearestSafetyZoneFlightPathIndexSubscriptionSubscriptionHookResult = ReturnType<typeof useGetNearestSafetyZoneFlightPathIndexSubscriptionSubscription>;
export type GetNearestSafetyZoneFlightPathIndexSubscriptionSubscriptionResult = Apollo.SubscriptionResult<GetNearestSafetyZoneFlightPathIndexSubscriptionSubscription>;
export const GetVehicleStatusDocument = gql`
    subscription getVehicleStatus {
  vehicleStatuses: vehicle_statuses {
    vehicle {
      id
      serialNumber: serial_number
      isConnected: is_connected
    }
    lat: lat_degs
    lon: lon_degs
    timestampSecs: timestamp_secs
    headingDegrees: heading_degrees
    groundSpeedMetersPerSecond: ground_speed_meters_per_second
  }
}
    `;

/**
 * __useGetVehicleStatusSubscription__
 *
 * To run a query within a React component, call `useGetVehicleStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetVehicleStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetVehicleStatusSubscription, GetVehicleStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetVehicleStatusSubscription, GetVehicleStatusSubscriptionVariables>(GetVehicleStatusDocument, options);
      }
export type GetVehicleStatusSubscriptionHookResult = ReturnType<typeof useGetVehicleStatusSubscription>;
export type GetVehicleStatusSubscriptionResult = Apollo.SubscriptionResult<GetVehicleStatusSubscription>;
export const GetActivePriorityEventsDocument = gql`
    subscription getActivePriorityEvents {
  vehiclePriorityEvents: vehicle_priority_events(
    order_by: {vehicle_id: asc, event_details: {rank: asc_nulls_last}}
    where: {acknowledged_at: {_is_null: true}, flight_status: {_or: [{activated_at: {_is_null: false}}, {flight_status: {_eq: "READY_TO_ARM"}}]}}
    distinct_on: vehicle_id
  ) {
    id
    message
    vehicle {
      vehicleId: id
      serialNumber: serial_number
      name
      vehicleStatuses: vehicle_statuses {
        estimatedSocPercentage: estimated_soc_percentage
      }
    }
    flightStatusDetails: flight_status {
      flightStatus: flight_status
      isUserCommanded: is_user_commanded
    }
    flightPlanId: flight_plan_id
    eventDetails: event_details {
      eventKey: event_key
      rank
      title
      severity
    }
  }
}
    `;

/**
 * __useGetActivePriorityEventsSubscription__
 *
 * To run a query within a React component, call `useGetActivePriorityEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePriorityEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePriorityEventsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetActivePriorityEventsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetActivePriorityEventsSubscription, GetActivePriorityEventsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetActivePriorityEventsSubscription, GetActivePriorityEventsSubscriptionVariables>(GetActivePriorityEventsDocument, options);
      }
export type GetActivePriorityEventsSubscriptionHookResult = ReturnType<typeof useGetActivePriorityEventsSubscription>;
export type GetActivePriorityEventsSubscriptionResult = Apollo.SubscriptionResult<GetActivePriorityEventsSubscription>;
export const AcknowledgePriorityEventDocument = gql`
    mutation acknowledgePriorityEvent($eventId: Int!) {
  acknowledgePriorityEvent(input: {priorityEventId: $eventId}) {
    priorityEvent {
      acknowledgedAt: acknowledged_at
    }
  }
}
    `;
export type AcknowledgePriorityEventMutationFn = Apollo.MutationFunction<AcknowledgePriorityEventMutation, AcknowledgePriorityEventMutationVariables>;

/**
 * __useAcknowledgePriorityEventMutation__
 *
 * To run a mutation, you first call `useAcknowledgePriorityEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgePriorityEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgePriorityEventMutation, { data, loading, error }] = useAcknowledgePriorityEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useAcknowledgePriorityEventMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgePriorityEventMutation, AcknowledgePriorityEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgePriorityEventMutation, AcknowledgePriorityEventMutationVariables>(AcknowledgePriorityEventDocument, options);
      }
export type AcknowledgePriorityEventMutationHookResult = ReturnType<typeof useAcknowledgePriorityEventMutation>;
export type AcknowledgePriorityEventMutationResult = Apollo.MutationResult<AcknowledgePriorityEventMutation>;
export type AcknowledgePriorityEventMutationOptions = Apollo.BaseMutationOptions<AcknowledgePriorityEventMutation, AcknowledgePriorityEventMutationVariables>;
export const GetHighestPriorityEventDocument = gql`
    subscription getHighestPriorityEvent($flightPlanId: Int!) {
  priorityEvent: vehicle_priority_events(
    where: {flight_plan_id: {_eq: $flightPlanId}, acknowledged_at: {_is_null: true}}
    order_by: {vehicle_id: asc, event_details: {rank: asc_nulls_last}}
    distinct_on: vehicle_id
    limit: 1
    offset: 0
  ) {
    id
    event
    priorityEventMessage: message
    eventDetails: event_details {
      title
      rank
      severity
    }
    flightPlan: flight_plan {
      rpicView: flight_plan_current_rpic_view {
        rpicUser: rpic_user {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetHighestPriorityEventSubscription__
 *
 * To run a query within a React component, call `useGetHighestPriorityEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetHighestPriorityEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighestPriorityEventSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetHighestPriorityEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetHighestPriorityEventSubscription, GetHighestPriorityEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetHighestPriorityEventSubscription, GetHighestPriorityEventSubscriptionVariables>(GetHighestPriorityEventDocument, options);
      }
export type GetHighestPriorityEventSubscriptionHookResult = ReturnType<typeof useGetHighestPriorityEventSubscription>;
export type GetHighestPriorityEventSubscriptionResult = Apollo.SubscriptionResult<GetHighestPriorityEventSubscription>;
export const GetVehicleTelemetryByFlightPlanDocument = gql`
    subscription getVehicleTelemetryByFlightPlan($flightPlanId: Int!) {
  selectedFlightPlan: flight_plans_by_pk(id: $flightPlanId) {
    id
    vehicle {
      id
      vehicleTelemetry: vehicle_statuses {
        groundSpeedMetersPerSecond: ground_speed_meters_per_second
        altAglMeters: alt_agl_meters
        altMeters: alt_meters
        estimatedSocPercentage: estimated_soc_percentage
        batteryVoltageVolts: battery_voltage_volts
        batteryPowerWatts: battery_power_watts
        satellitesVisible: satellites_visible
        gpsFixType: gps_fix_type
        flightMode: flight_mode
        plTargetNumber: pl_target_number
        landingType: landing_type
        lidarDistMeters: lidar_dist_meters
        pairedGroundAssetSerialNumber: paired_ground_asset_serial_number
        headingDegrees: heading_degrees
        primaryGpsIndicator: primary_gps_indicator
      }
    }
  }
}
    `;

/**
 * __useGetVehicleTelemetryByFlightPlanSubscription__
 *
 * To run a query within a React component, call `useGetVehicleTelemetryByFlightPlanSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleTelemetryByFlightPlanSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleTelemetryByFlightPlanSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetVehicleTelemetryByFlightPlanSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetVehicleTelemetryByFlightPlanSubscription, GetVehicleTelemetryByFlightPlanSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetVehicleTelemetryByFlightPlanSubscription, GetVehicleTelemetryByFlightPlanSubscriptionVariables>(GetVehicleTelemetryByFlightPlanDocument, options);
      }
export type GetVehicleTelemetryByFlightPlanSubscriptionHookResult = ReturnType<typeof useGetVehicleTelemetryByFlightPlanSubscription>;
export type GetVehicleTelemetryByFlightPlanSubscriptionResult = Apollo.SubscriptionResult<GetVehicleTelemetryByFlightPlanSubscription>;
export const GetAllPriorityEventsByFlightPlanDocument = gql`
    query getAllPriorityEventsByFlightPlan($selectedFlightPlanId: Int!) {
  flightPlan: flight_plans_by_pk(id: $selectedFlightPlanId) {
    id
    priorityEvents: vehicle_priority_events(order_by: {created_at: asc_nulls_last}) {
      id
      createdAt: created_at
      message
    }
  }
}
    `;

/**
 * __useGetAllPriorityEventsByFlightPlanQuery__
 *
 * To run a query within a React component, call `useGetAllPriorityEventsByFlightPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPriorityEventsByFlightPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPriorityEventsByFlightPlanQuery({
 *   variables: {
 *      selectedFlightPlanId: // value for 'selectedFlightPlanId'
 *   },
 * });
 */
export function useGetAllPriorityEventsByFlightPlanQuery(baseOptions: Apollo.QueryHookOptions<GetAllPriorityEventsByFlightPlanQuery, GetAllPriorityEventsByFlightPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPriorityEventsByFlightPlanQuery, GetAllPriorityEventsByFlightPlanQueryVariables>(GetAllPriorityEventsByFlightPlanDocument, options);
      }
export function useGetAllPriorityEventsByFlightPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPriorityEventsByFlightPlanQuery, GetAllPriorityEventsByFlightPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPriorityEventsByFlightPlanQuery, GetAllPriorityEventsByFlightPlanQueryVariables>(GetAllPriorityEventsByFlightPlanDocument, options);
        }
export type GetAllPriorityEventsByFlightPlanQueryHookResult = ReturnType<typeof useGetAllPriorityEventsByFlightPlanQuery>;
export type GetAllPriorityEventsByFlightPlanLazyQueryHookResult = ReturnType<typeof useGetAllPriorityEventsByFlightPlanLazyQuery>;
export type GetAllPriorityEventsByFlightPlanQueryResult = Apollo.QueryResult<GetAllPriorityEventsByFlightPlanQuery, GetAllPriorityEventsByFlightPlanQueryVariables>;
export const GetFlightStatusByFlightPlanDocument = gql`
    subscription getFlightStatusByFlightPlan($flightPlanId: Int!) {
  selectedFlightPlan: flight_plans_by_pk(id: $flightPlanId) {
    id
    vehicle {
      id
      telemetry: vehicle_statuses {
        currentFlightPlan: flight_plan {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetFlightStatusByFlightPlanSubscription__
 *
 * To run a query within a React component, call `useGetFlightStatusByFlightPlanSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetFlightStatusByFlightPlanSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlightStatusByFlightPlanSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetFlightStatusByFlightPlanSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetFlightStatusByFlightPlanSubscription, GetFlightStatusByFlightPlanSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetFlightStatusByFlightPlanSubscription, GetFlightStatusByFlightPlanSubscriptionVariables>(GetFlightStatusByFlightPlanDocument, options);
      }
export type GetFlightStatusByFlightPlanSubscriptionHookResult = ReturnType<typeof useGetFlightStatusByFlightPlanSubscription>;
export type GetFlightStatusByFlightPlanSubscriptionResult = Apollo.SubscriptionResult<GetFlightStatusByFlightPlanSubscription>;
export const GetPostFlightFlightPlanDetailsDocument = gql`
    query getPostFlightFlightPlanDetails($selectedFlightPlanId: Int!) {
  flightPlanDetails: flight_plans_by_pk(id: $selectedFlightPlanId) {
    id
    aircraft: vehicle {
      id
      name: name
    }
    flightPlanId: id
    flightRoute: path {
      title
    }
    departureTime: departed_on
    arrivalTime: arrived_on
    manifest {
      id
      serialNumber: serial_number
    }
    assignedPilots: flight_plan_pilot_assignments {
      id
      user {
        email
      }
    }
  }
  lastRpic: flight_plan_current_rpic_view(
    where: {flight_plan_id: {_eq: $selectedFlightPlanId}}
  ) {
    user: rpic_user {
      email
    }
  }
}
    `;

/**
 * __useGetPostFlightFlightPlanDetailsQuery__
 *
 * To run a query within a React component, call `useGetPostFlightFlightPlanDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostFlightFlightPlanDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostFlightFlightPlanDetailsQuery({
 *   variables: {
 *      selectedFlightPlanId: // value for 'selectedFlightPlanId'
 *   },
 * });
 */
export function useGetPostFlightFlightPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPostFlightFlightPlanDetailsQuery, GetPostFlightFlightPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostFlightFlightPlanDetailsQuery, GetPostFlightFlightPlanDetailsQueryVariables>(GetPostFlightFlightPlanDetailsDocument, options);
      }
export function useGetPostFlightFlightPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostFlightFlightPlanDetailsQuery, GetPostFlightFlightPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostFlightFlightPlanDetailsQuery, GetPostFlightFlightPlanDetailsQueryVariables>(GetPostFlightFlightPlanDetailsDocument, options);
        }
export type GetPostFlightFlightPlanDetailsQueryHookResult = ReturnType<typeof useGetPostFlightFlightPlanDetailsQuery>;
export type GetPostFlightFlightPlanDetailsLazyQueryHookResult = ReturnType<typeof useGetPostFlightFlightPlanDetailsLazyQuery>;
export type GetPostFlightFlightPlanDetailsQueryResult = Apollo.QueryResult<GetPostFlightFlightPlanDetailsQuery, GetPostFlightFlightPlanDetailsQueryVariables>;
export const GetPostFlightLandingDetailsDocument = gql`
    query getPostFlightLandingDetails($selectedFlightPlanId: Int!) {
  landingDetails: flight_plans_by_pk(id: $selectedFlightPlanId) {
    _id: id
    aircraft: vehicle {
      _id: id
      lastReportedLocation: historical_serialized_vehicle_statuses(
        where: {flight_plan_id: {_eq: $selectedFlightPlanId}}
        order_by: {created_at: desc_nulls_last}
        limit: 1
      ) {
        _id: flight_plan_id
        latDeg: lat_degs
        lonDeg: lon_degs
      }
    }
  }
}
    `;

/**
 * __useGetPostFlightLandingDetailsQuery__
 *
 * To run a query within a React component, call `useGetPostFlightLandingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostFlightLandingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostFlightLandingDetailsQuery({
 *   variables: {
 *      selectedFlightPlanId: // value for 'selectedFlightPlanId'
 *   },
 * });
 */
export function useGetPostFlightLandingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPostFlightLandingDetailsQuery, GetPostFlightLandingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostFlightLandingDetailsQuery, GetPostFlightLandingDetailsQueryVariables>(GetPostFlightLandingDetailsDocument, options);
      }
export function useGetPostFlightLandingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostFlightLandingDetailsQuery, GetPostFlightLandingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostFlightLandingDetailsQuery, GetPostFlightLandingDetailsQueryVariables>(GetPostFlightLandingDetailsDocument, options);
        }
export type GetPostFlightLandingDetailsQueryHookResult = ReturnType<typeof useGetPostFlightLandingDetailsQuery>;
export type GetPostFlightLandingDetailsLazyQueryHookResult = ReturnType<typeof useGetPostFlightLandingDetailsLazyQuery>;
export type GetPostFlightLandingDetailsQueryResult = Apollo.QueryResult<GetPostFlightLandingDetailsQuery, GetPostFlightLandingDetailsQueryVariables>;
export const GetPendingPeocApprovalsAsRpicDocument = gql`
    subscription getPendingPeocApprovalsAsRpic($auth0UserId: String) {
  currentRpic: flight_plan_current_rpic_view(
    where: {flight_peoc_requesting_pilot_user_id: {_is_null: false}, _and: {rpic_user: {auth0_user_id: {_eq: $auth0UserId}}}}
  ) {
    rpicRequestId: flight_peoc_request_id
    peocRequestingPilot: flight_peoc_requesting_pilot {
      email
      id
    }
    rpicPilot: rpic_user {
      email
      id
    }
    flight_plan {
      vehicle {
        name
      }
    }
  }
}
    `;

/**
 * __useGetPendingPeocApprovalsAsRpicSubscription__
 *
 * To run a query within a React component, call `useGetPendingPeocApprovalsAsRpicSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPeocApprovalsAsRpicSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPeocApprovalsAsRpicSubscription({
 *   variables: {
 *      auth0UserId: // value for 'auth0UserId'
 *   },
 * });
 */
export function useGetPendingPeocApprovalsAsRpicSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetPendingPeocApprovalsAsRpicSubscription, GetPendingPeocApprovalsAsRpicSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPendingPeocApprovalsAsRpicSubscription, GetPendingPeocApprovalsAsRpicSubscriptionVariables>(GetPendingPeocApprovalsAsRpicDocument, options);
      }
export type GetPendingPeocApprovalsAsRpicSubscriptionHookResult = ReturnType<typeof useGetPendingPeocApprovalsAsRpicSubscription>;
export type GetPendingPeocApprovalsAsRpicSubscriptionResult = Apollo.SubscriptionResult<GetPendingPeocApprovalsAsRpicSubscription>;
export const ResolveFlightControlRequestDocument = gql`
    mutation resolveFlightControlRequest($input: ResolveFlightControlRequestInput!) {
  resolveFlightControlRequest(input: $input) {
    status
  }
}
    `;
export type ResolveFlightControlRequestMutationFn = Apollo.MutationFunction<ResolveFlightControlRequestMutation, ResolveFlightControlRequestMutationVariables>;

/**
 * __useResolveFlightControlRequestMutation__
 *
 * To run a mutation, you first call `useResolveFlightControlRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveFlightControlRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveFlightControlRequestMutation, { data, loading, error }] = useResolveFlightControlRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveFlightControlRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveFlightControlRequestMutation, ResolveFlightControlRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveFlightControlRequestMutation, ResolveFlightControlRequestMutationVariables>(ResolveFlightControlRequestDocument, options);
      }
export type ResolveFlightControlRequestMutationHookResult = ReturnType<typeof useResolveFlightControlRequestMutation>;
export type ResolveFlightControlRequestMutationResult = Apollo.MutationResult<ResolveFlightControlRequestMutation>;
export type ResolveFlightControlRequestMutationOptions = Apollo.BaseMutationOptions<ResolveFlightControlRequestMutation, ResolveFlightControlRequestMutationVariables>;
export const GetVehicleDetailsByFlightPlanDocument = gql`
    subscription getVehicleDetailsByFlightPlan($flightPlanId: Int!) {
  flightPlan: flight_plans_by_pk(id: $flightPlanId) {
    id
    path {
      title
    }
    vehicle {
      id
      name
      telemetry: vehicle_statuses {
        currentFlightPlan: flight_plan {
          id
        }
        etaSecs: eta_secs
        eteSecs: ete_terminal_airspace_secs
        timestampSecs: timestamp_secs
        isBatterylocked: battery_locked
        isPayloadLocked: payload_locked
        flightStatus {
          flightStatusName: flight_status
          isUserCommanded: is_user_commanded
        }
      }
    }
    ...pilotAssignments
  }
}
    ${PilotAssignmentsFragmentDoc}`;

/**
 * __useGetVehicleDetailsByFlightPlanSubscription__
 *
 * To run a query within a React component, call `useGetVehicleDetailsByFlightPlanSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleDetailsByFlightPlanSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleDetailsByFlightPlanSubscription({
 *   variables: {
 *      flightPlanId: // value for 'flightPlanId'
 *   },
 * });
 */
export function useGetVehicleDetailsByFlightPlanSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetVehicleDetailsByFlightPlanSubscription, GetVehicleDetailsByFlightPlanSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetVehicleDetailsByFlightPlanSubscription, GetVehicleDetailsByFlightPlanSubscriptionVariables>(GetVehicleDetailsByFlightPlanDocument, options);
      }
export type GetVehicleDetailsByFlightPlanSubscriptionHookResult = ReturnType<typeof useGetVehicleDetailsByFlightPlanSubscription>;
export type GetVehicleDetailsByFlightPlanSubscriptionResult = Apollo.SubscriptionResult<GetVehicleDetailsByFlightPlanSubscription>;